import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `BigInt` scalar type represents non-fractional whole numeric values.
   * `BigInt` is not constrained to 32-bit like the `Int` type and thus is a less
   * compatible type.
   */
  BigInt: { input: any; output: any; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /** The `Decimal` scalar type represents a python Decimal. */
  Decimal: { input: string; output: string; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: string; output: string; }
  /**
   * The `Time` scalar type represents a Time value as
   * specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Time: { input: string; output: string; }
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: { input: string; output: string; }
};

export type AcceptApplication = {
  readonly __typename?: 'AcceptApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type AcceptAsanaPendingTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly pendingId: Scalars['UUID']['input'];
};

export type AcceptAsanaPendingTaskPayload = {
  readonly __typename?: 'AcceptAsanaPendingTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly pending?: Maybe<AsanaPendingTaskNode>;
  readonly task?: Maybe<TaskNode>;
};

export type AcceptFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type AcceptFeatureAnnouncementPayload = {
  readonly __typename?: 'AcceptFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

export type AcceptMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type AcceptMessageSuggestionPayload = {
  readonly __typename?: 'AcceptMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type AcceptServiceChargeWaiverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly serviceChargeWaiverAcceptedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AcceptServiceChargeWaiverPayload = {
  readonly __typename?: 'AcceptServiceChargeWaiverPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
};

export type AcceptTermsAndConditionsInput = {
  readonly acceptedAt: Scalars['DateTime']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type AcceptTermsAndConditionsPayload = {
  readonly __typename?: 'AcceptTermsAndConditionsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type AcceptWaiverInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

export type AcceptWaiverPayload = {
  readonly __typename?: 'AcceptWaiverPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly waiver?: Maybe<WaiverNode>;
};

export type AccountTransactionNode = {
  readonly __typename?: 'AccountTransactionNode';
  readonly account?: Maybe<PaymentAccountNode>;
  readonly amount: Scalars['BigInt']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly status: PaymentsPaymentStatusChoices;
};

export type AccountTransactionNodeConnection = {
  readonly __typename?: 'AccountTransactionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AccountTransactionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AccountTransactionNode` and its cursor. */
export type AccountTransactionNodeEdge = {
  readonly __typename?: 'AccountTransactionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AccountTransactionNode>;
};

export type ActionObject = AmenityReservationNode | ApplicationNode | ApplicationSupportMessageNode | ApplicationThreadMessageNode | CommunityEventNode | CommunityProductPurchaseNode | CommunityUpdateCommentNode | CommunityUpdateLikeType | ConversationNode | GroupChatMessageNode | KeyholderNode | MarketplaceItemCommentNode | MarketplaceItemNode | MarketplaceItemThreadMessageNode | ResidentSurveyAnswerType | SafetyReviewAttemptNode;

export type ActionSourceRegionNode = {
  readonly __typename?: 'ActionSourceRegionNode';
  readonly region: SourceRegionNode;
  readonly role: Scalars['String']['output'];
};

export type ActivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ActivateGroupPayload = {
  readonly __typename?: 'ActivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ActivateSafetyComplianceV2 = {
  readonly __typename?: 'ActivateSafetyComplianceV2';
  readonly community?: Maybe<CommunityNode>;
  readonly readiness: SafetyComplianceReadinessType;
};

export type ActivateSafetyResponderToken = {
  readonly __typename?: 'ActivateSafetyResponderToken';
  readonly pack?: Maybe<SafetyResponderPackNode>;
};

export type Actor = ApplicantNode | ApplicationSupportThreadNode | CommunityNode | ConciergeNode | HomeNode | ManagerType | ResidentNode | TenancyApplicantNode | UserType;

export type AddApplicationCommunity = {
  readonly __typename?: 'AddApplicationCommunity';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationHome = {
  readonly __typename?: 'AddApplicationHome';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddApplicationOwnershipType = {
  readonly __typename?: 'AddApplicationOwnershipType';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddContractorToClientContractorCompanyInput = {
  readonly clientContractorCompanyId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type AddContractorToClientContractorCompanyPayload = {
  readonly __typename?: 'AddContractorToClientContractorCompanyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type AddDocumentSentStatus = {
  readonly __typename?: 'AddDocumentSentStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AddFeatureToClientInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureNames: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type AddFeatureToClientPayload = {
  readonly __typename?: 'AddFeatureToClientPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AddMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type AddMemberPayload = {
  readonly __typename?: 'AddMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly createdUserId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type AddMessageToThreadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly message: Scalars['String']['input'];
  readonly thread: Scalars['String']['input'];
};

export type AddMessageToThreadPayload = {
  readonly __typename?: 'AddMessageToThreadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly thread?: Maybe<Scalars['String']['output']>;
};

export type AddPackageToHomeInput = {
  readonly addressee?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly manualHomeSearchQuery?: InputMaybe<Scalars['String']['input']>;
  readonly scanOutput?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AddPackageToHomePayload = {
  readonly __typename?: 'AddPackageToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly package?: Maybe<PackageNode>;
};

export type AddTaskCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly objectId?: InputMaybe<Scalars['String']['input']>;
  readonly task: Scalars['String']['input'];
};

export type AddTaskCommentPayload = {
  readonly __typename?: 'AddTaskCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskUpdate?: Maybe<TaskUpdateNode>;
};

export type AddTeamMembersInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly users: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type AddTeamMembersPayload = {
  readonly __typename?: 'AddTeamMembersPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type AddUnknownCommunityStatus = {
  readonly __typename?: 'AddUnknownCommunityStatus';
  readonly application?: Maybe<ApplicationNode>;
};

export type AgreeEes = {
  readonly __typename?: 'AgreeEes';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type AgreementSignatureNode = {
  readonly __typename?: 'AgreementSignatureNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly signatureType: AstGeneratorAgreementSignatureSignatureTypeChoices;
  readonly signedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status: AstGeneratorAgreementSignatureStatusChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementSignatureNodeConnection = {
  readonly __typename?: 'AgreementSignatureNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementSignatureNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementSignatureNode` and its cursor. */
export type AgreementSignatureNodeEdge = {
  readonly __typename?: 'AgreementSignatureNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementSignatureNode>;
};

export type AgreementSignatureOutput = {
  readonly __typename?: 'AgreementSignatureOutput';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
};

export type AgreementSignaturesTenant = {
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type AgreementTenantNode = {
  readonly __typename?: 'AgreementTenantNode';
  readonly agreement: GeneratedAgreementNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type AgreementTenantNodeConnection = {
  readonly __typename?: 'AgreementTenantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AgreementTenantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AgreementTenantNode` and its cursor. */
export type AgreementTenantNodeEdge = {
  readonly __typename?: 'AgreementTenantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AgreementTenantNode>;
};

export type AicoDailyAverageReadingNode = {
  readonly __typename?: 'AicoDailyAverageReadingNode';
  readonly averageCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly averageHumidity?: Maybe<Scalars['Float']['output']>;
  readonly averageTemperature?: Maybe<Scalars['Float']['output']>;
  readonly date: Scalars['Date']['output'];
  readonly maxCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly maxHumidity?: Maybe<Scalars['Float']['output']>;
  readonly maxTemperature?: Maybe<Scalars['Float']['output']>;
  readonly minCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly minHumidity?: Maybe<Scalars['Float']['output']>;
  readonly minTemperature?: Maybe<Scalars['Float']['output']>;
};

export type AicoEnvironmentAdviceContentNode = {
  readonly __typename?: 'AicoEnvironmentAdviceContentNode';
  readonly advice?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly moreInfo?: Maybe<Scalars['String']['output']>;
  readonly reasons?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type AicoEnvironmentAdviceNode = {
  readonly __typename?: 'AicoEnvironmentAdviceNode';
  readonly highCarbonDioxide?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly highHumidity?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly highTemperature?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly lowHumidity?: Maybe<AicoEnvironmentAdviceContentNode>;
  readonly lowTemperature?: Maybe<AicoEnvironmentAdviceContentNode>;
};

export type AicoEnvironmentThresholdsNode = {
  readonly __typename?: 'AicoEnvironmentThresholdsNode';
  readonly maxCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly maxHumidity?: Maybe<Scalars['Float']['output']>;
  readonly maxTemperature?: Maybe<Scalars['Float']['output']>;
  readonly minHumidity?: Maybe<Scalars['Float']['output']>;
  readonly minTemperature?: Maybe<Scalars['Float']['output']>;
};

export type AicoLatestAverageReadingNode = {
  readonly __typename?: 'AicoLatestAverageReadingNode';
  readonly averageCarbonDioxide?: Maybe<Scalars['Float']['output']>;
  readonly averageHumidity?: Maybe<Scalars['Float']['output']>;
  readonly averageTemperature?: Maybe<Scalars['Float']['output']>;
  readonly carbonDioxideRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly humidityRecordedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly temperatureRecordedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AmenityNode = {
  readonly __typename?: 'AmenityNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<CommunityNode>>>;
  readonly community?: Maybe<CommunityNode>;
  readonly daysAvailable: ReadonlyArray<Scalars['String']['output']>;
  readonly description: Scalars['String']['output'];
  readonly endTime: Scalars['DateTime']['output'];
  readonly exclusive: Scalars['Boolean']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isCurrentlyReservable: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Meeting or external links for this amenity (e.g. Google Meet, Teams, Zoom). */
  readonly links?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly live: Scalars['Boolean']['output'];
  readonly maxAdvanceReservationDays: Scalars['Int']['output'];
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly maxReservations?: Maybe<Scalars['Int']['output']>;
  /** The maximum time in seconds */
  readonly maxTime?: Maybe<Scalars['Int']['output']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: Maybe<Scalars['Int']['output']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: Maybe<Scalars['Int']['output']>;
  /** The minimum time in seconds */
  readonly minTime?: Maybe<Scalars['Int']['output']>;
  readonly name: Scalars['String']['output'];
  readonly operatingTimes: AmenityOperatingTimesNodeConnection;
  readonly reservable: Scalars['Boolean']['output'];
  readonly reservations: AmenityReservationNodeConnection;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
  readonly startTime: Scalars['DateTime']['output'];
  readonly status: AmenityStatusEnum;
  readonly todaysBookingCount: Scalars['Int']['output'];
  readonly type?: Maybe<ResidentialManagementAmenityTypeChoices>;
  readonly unpaginatedReservations?: Maybe<AmenityReservationNodeConnection>;
};


export type AmenityNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type AmenityNodeOperatingTimesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type AmenityNodeReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type AmenityNodeUnpaginatedReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type AmenityNodeConnection = {
  readonly __typename?: 'AmenityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityNode` and its cursor. */
export type AmenityNodeEdge = {
  readonly __typename?: 'AmenityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityNode>;
};

export type AmenityOperatingTimesNode = {
  readonly __typename?: 'AmenityOperatingTimesNode';
  readonly amenity: AmenityNode;
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActivated: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly weekDay: Scalars['Int']['output'];
};

export type AmenityOperatingTimesNodeConnection = {
  readonly __typename?: 'AmenityOperatingTimesNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityOperatingTimesNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityOperatingTimesNode` and its cursor. */
export type AmenityOperatingTimesNodeEdge = {
  readonly __typename?: 'AmenityOperatingTimesNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityOperatingTimesNode>;
};

export type AmenityReservationNode = {
  readonly __typename?: 'AmenityReservationNode';
  readonly additionalAttendance: Scalars['Int']['output'];
  readonly amenity?: Maybe<AmenityNode>;
  readonly cancellationMessage?: Maybe<Scalars['String']['output']>;
  readonly end: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isManager: Scalars['Boolean']['output'];
  readonly isMine?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly start: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type AmenityReservationNodeConnection = {
  readonly __typename?: 'AmenityReservationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AmenityReservationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AmenityReservationNode` and its cursor. */
export type AmenityReservationNodeEdge = {
  readonly __typename?: 'AmenityReservationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AmenityReservationNode>;
};

/** An enumeration. */
export enum AmenityStatusEnum {
  Available = 'Available',
  Bookable = 'Bookable',
  NotAvailable = 'NotAvailable'
}

export type ApplicantNode = {
  readonly __typename?: 'ApplicantNode';
  readonly applications: ApplicationNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};


export type ApplicantNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type Applicants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationAttemptNode = {
  readonly __typename?: 'ApplicationAttemptNode';
  readonly application: ApplicationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly proofOfAddress?: Maybe<Scalars['String']['output']>;
  readonly rejectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly rejectionReason?: Maybe<Scalars['String']['output']>;
  readonly reviewer?: Maybe<ManagerType>;
  readonly reviewerUser?: Maybe<UserType>;
  readonly verificationResult?: Maybe<DocumentVerificationResultNode>;
};

export type ApplicationAttemptNodeConnection = {
  readonly __typename?: 'ApplicationAttemptNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationAttemptNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationAttemptNode` and its cursor. */
export type ApplicationAttemptNodeEdge = {
  readonly __typename?: 'ApplicationAttemptNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationAttemptNode>;
};

export type ApplicationAuditLogNode = {
  readonly __typename?: 'ApplicationAuditLogNode';
  readonly actor?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly eventType: ResidentialManagementApplicationAuditLogEventTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly metadata: Scalars['JSONString']['output'];
};

export type ApplicationAuditLogNodeConnection = {
  readonly __typename?: 'ApplicationAuditLogNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationAuditLogNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationAuditLogNode` and its cursor. */
export type ApplicationAuditLogNodeEdge = {
  readonly __typename?: 'ApplicationAuditLogNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationAuditLogNode>;
};

export type ApplicationDecisionStatsType = {
  readonly __typename?: 'ApplicationDecisionStatsType';
  readonly aiAccuracyRate?: Maybe<Scalars['Float']['output']>;
  readonly approvalCount?: Maybe<Scalars['Int']['output']>;
  readonly approvalRate?: Maybe<Scalars['Float']['output']>;
  readonly averageTimeToDecision?: Maybe<Scalars['Int']['output']>;
  readonly rejectionCount?: Maybe<Scalars['Int']['output']>;
  readonly rejectionRate?: Maybe<Scalars['Float']['output']>;
  readonly reminderCount?: Maybe<Scalars['Int']['output']>;
  readonly reminderRate?: Maybe<Scalars['Float']['output']>;
  readonly totalDecisions?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationHomeSearchNode = {
  readonly __typename?: 'ApplicationHomeSearchNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type ApplicationHomeSearchNodeConnection = {
  readonly __typename?: 'ApplicationHomeSearchNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationHomeSearchNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationHomeSearchNode` and its cursor. */
export type ApplicationHomeSearchNodeEdge = {
  readonly __typename?: 'ApplicationHomeSearchNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationHomeSearchNode>;
};

export type ApplicationNode = {
  readonly __typename?: 'ApplicationNode';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly applicant: ApplicantNode;
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly auditLogs: ApplicationAuditLogNodeConnection;
  readonly closestCommunities?: Maybe<ReadonlyArray<NewCommunityOption>>;
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly findCommunities?: Maybe<CommunityNodeConnection>;
  readonly findHomes?: Maybe<ApplicationHomeSearchNodeConnection>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isResident: Scalars['Boolean']['output'];
  readonly lastRejectionReason?: Maybe<Scalars['String']['output']>;
  readonly ownershipType?: Maybe<ResidentialManagementApplicationOwnershipTypeChoices>;
  readonly postcode: Scalars['String']['output'];
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly source: ResidentialManagementApplicationSourceChoices;
  readonly status: ResidentialManagementApplicationStatusChoices;
  readonly thread?: Maybe<ApplicationThreadNode>;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};


export type ApplicationNodeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ApplicationNodeFindHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicationNodeConnection = {
  readonly __typename?: 'ApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationNode` and its cursor. */
export type ApplicationNodeEdge = {
  readonly __typename?: 'ApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationNode>;
};

export enum ApplicationOwnershipType {
  Ow = 'OW',
  Re = 'RE',
  So = 'SO'
}

export type ApplicationReportingCountNode = {
  readonly __typename?: 'ApplicationReportingCountNode';
  readonly byDay: ReadonlyArray<ApplicationReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type ApplicationReportingDayCountNode = {
  readonly __typename?: 'ApplicationReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type ApplicationReportingDayDurationNode = {
  readonly __typename?: 'ApplicationReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ApplicationReportingDurationNode = {
  readonly __typename?: 'ApplicationReportingDurationNode';
  readonly byDay: ReadonlyArray<ApplicationReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type ApplicationReportingFlowLinkNode = {
  readonly __typename?: 'ApplicationReportingFlowLinkNode';
  readonly count: Scalars['Int']['output'];
  readonly source: ApplicationReportingFlowStage;
  readonly target: ApplicationReportingFlowStage;
};

/** An enumeration. */
export enum ApplicationReportingFlowStage {
  Approved = 'APPROVED',
  ProofRequested = 'PROOF_REQUESTED',
  Received = 'RECEIVED',
  Rejected = 'REJECTED',
  Undecided = 'UNDECIDED',
  WithoutProof = 'WITHOUT_PROOF',
  WithProof = 'WITH_PROOF'
}

/** An enumeration. */
export enum ApplicationReportingFunnelStage {
  Approved = 'APPROVED',
  DocumentSent = 'DOCUMENT_SENT',
  Received = 'RECEIVED'
}

export type ApplicationReportingFunnelStageNode = {
  readonly __typename?: 'ApplicationReportingFunnelStageNode';
  readonly count: Scalars['Int']['output'];
  readonly stage: ApplicationReportingFunnelStage;
};

export type ApplicationReportingNode = {
  readonly __typename?: 'ApplicationReportingNode';
  readonly approved: ApplicationReportingCountNode;
  readonly approvedByProof: ReadonlyArray<ApplicationReportingProofCountNode>;
  readonly bySubmissionSource: ReadonlyArray<ApplicationReportingSubmissionSourceCountNode>;
  readonly flow: ReadonlyArray<ApplicationReportingFlowLinkNode>;
  readonly funnel: ReadonlyArray<ApplicationReportingFunnelStageNode>;
  readonly outcomes: ApplicationReportingOutcomesNode;
  readonly pending: ApplicationReportingPendingNode;
  readonly pendingByWait: ReadonlyArray<ApplicationReportingWaitBucketNode>;
  readonly received: ApplicationReportingCountNode;
  readonly receivedWithMultipleAttempts: Scalars['Int']['output'];
  readonly rejectionReasons: ReadonlyArray<ApplicationReportingRejectionReasonCountNode>;
  readonly resubmissions: ApplicationReportingResubmissionsNode;
  readonly timeToApproval: ApplicationReportingDurationNode;
};

export type ApplicationReportingOutcomesNode = {
  readonly __typename?: 'ApplicationReportingOutcomesNode';
  readonly approvalRate?: Maybe<Scalars['Float']['output']>;
  readonly byStatus: ReadonlyArray<ApplicationReportingStatusCountNode>;
  readonly decidedCount: Scalars['Int']['output'];
};

export type ApplicationReportingPendingNode = {
  readonly __typename?: 'ApplicationReportingPendingNode';
  readonly atEnd?: Maybe<ApplicationReportingDayCountNode>;
  readonly byDay: ReadonlyArray<ApplicationReportingDayCountNode>;
};

export type ApplicationReportingProofCountNode = {
  readonly __typename?: 'ApplicationReportingProofCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hasProofOfAddress?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplicationReportingRejectionReasonCountNode = {
  readonly __typename?: 'ApplicationReportingRejectionReasonCountNode';
  readonly count: Scalars['Int']['output'];
  readonly reason?: Maybe<Scalars['String']['output']>;
};

export type ApplicationReportingResubmissionsNode = {
  readonly __typename?: 'ApplicationReportingResubmissionsNode';
  readonly approvedCount: Scalars['Int']['output'];
  readonly attemptsPerApproval?: Maybe<Scalars['Float']['output']>;
  readonly medianAttemptsPerApproval?: Maybe<Scalars['Float']['output']>;
  readonly resubmittedCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum ApplicationReportingStatus {
  Approved = 'APPROVED',
  CommunityKnown = 'COMMUNITY_KNOWN',
  DocumentSent = 'DOCUMENT_SENT',
  MultipleCommunities = 'MULTIPLE_COMMUNITIES',
  Pending = 'PENDING',
  Rejected = 'REJECTED',
  UnknownCommunity = 'UNKNOWN_COMMUNITY'
}

export type ApplicationReportingStatusCountNode = {
  readonly __typename?: 'ApplicationReportingStatusCountNode';
  readonly count: Scalars['Int']['output'];
  readonly status: ApplicationReportingStatus;
};

/** An enumeration. */
export enum ApplicationReportingSubmissionSource {
  Applicant = 'APPLICANT',
  Concierge = 'CONCIERGE'
}

export type ApplicationReportingSubmissionSourceCountNode = {
  readonly __typename?: 'ApplicationReportingSubmissionSourceCountNode';
  readonly count: Scalars['Int']['output'];
  readonly submissionSource?: Maybe<ApplicationReportingSubmissionSource>;
};

export type ApplicationReportingWaitBucketNode = {
  readonly __typename?: 'ApplicationReportingWaitBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type ApplicationSupportMessageNode = {
  readonly __typename?: 'ApplicationSupportMessageNode';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sender: ResidentialManagementApplicationSupportMessageSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
};

export type ApplicationSupportMessageNodeConnection = {
  readonly __typename?: 'ApplicationSupportMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationSupportMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationSupportMessageNode` and its cursor. */
export type ApplicationSupportMessageNodeEdge = {
  readonly __typename?: 'ApplicationSupportMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationSupportMessageNode>;
};

export type ApplicationSupportThreadNode = {
  readonly __typename?: 'ApplicationSupportThreadNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastMessage?: Maybe<ApplicationSupportMessageNode>;
  readonly messages: ApplicationSupportMessageNodeConnection;
};


export type ApplicationSupportThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicationThreadMediaNode = {
  readonly __typename?: 'ApplicationThreadMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sender: ResidentialManagementApplicationThreadMediaSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ApplicationThreadMediaNodeConnection = {
  readonly __typename?: 'ApplicationThreadMediaNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationThreadMediaNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationThreadMediaNode` and its cursor. */
export type ApplicationThreadMediaNodeEdge = {
  readonly __typename?: 'ApplicationThreadMediaNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationThreadMediaNode>;
};

export type ApplicationThreadMessageNode = {
  readonly __typename?: 'ApplicationThreadMessageNode';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices;
  readonly senderDisplay?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ApplicationThreadMessageNodeConnection = {
  readonly __typename?: 'ApplicationThreadMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ApplicationThreadMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ApplicationThreadMessageNode` and its cursor. */
export type ApplicationThreadMessageNodeEdge = {
  readonly __typename?: 'ApplicationThreadMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ApplicationThreadMessageNode>;
};

export type ApplicationThreadNode = {
  readonly __typename?: 'ApplicationThreadNode';
  readonly application: ApplicationNode;
  readonly applicationId?: Maybe<Scalars['UUID']['output']>;
  readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastMessage?: Maybe<ApplicationThreadMessageNode>;
  readonly media: ApplicationThreadMediaNodeConnection;
  readonly messages: ApplicationThreadMessageNodeConnection;
  readonly migratedConversation?: Maybe<ConversationNode>;
  readonly unreadCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type ApplicationThreadNodeMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ApplicationThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ArchiveAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type ArchiveAllNotificationsOnTargetPayload = {
  readonly __typename?: 'ArchiveAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type ArchiveAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveApplicationPayload = {
  readonly __typename?: 'ArchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveCommunityEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveCommunityEventPayload = {
  readonly __typename?: 'ArchiveCommunityEventPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityEvent?: Maybe<CommunityEventNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveContactNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveContactNotePayload = {
  readonly __typename?: 'ArchiveContactNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contactNote?: Maybe<ContactNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ArchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyPayload = {
  readonly __typename?: 'ArchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveKeyholderPayload = {
  readonly __typename?: 'ArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ArchiveMarketplaceItemInput = {
  readonly archivedReason?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveMarketplaceItemPayload = {
  readonly __typename?: 'ArchiveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type ArchiveNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveNotificationPayload = {
  readonly __typename?: 'ArchiveNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type ArchiveSafetyCenterDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveSafetyCenterDocumentPayload = {
  readonly __typename?: 'ArchiveSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type ArchiveSafetySubjectInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveSafetySubjectPayload = {
  readonly __typename?: 'ArchiveSafetySubjectPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ArchiveTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTagPayload = {
  readonly __typename?: 'ArchiveTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type ArchiveTaskGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTaskGroupPayload = {
  readonly __typename?: 'ArchiveTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type ArchiveTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ArchiveTaskPayload = {
  readonly __typename?: 'ArchiveTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type ArchiveTaskTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type ArchiveTaskTemplatePayload = {
  readonly __typename?: 'ArchiveTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type ArchivedContactNode = {
  readonly __typename?: 'ArchivedContactNode';
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly removalDate?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedContactNodeConnection = {
  readonly __typename?: 'ArchivedContactNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ArchivedContactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ArchivedContactNode` and its cursor. */
export type ArchivedContactNodeEdge = {
  readonly __typename?: 'ArchivedContactNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ArchivedContactNode>;
};

export type AsanaPendingTaskNode = {
  readonly __typename?: 'AsanaPendingTaskNode';
  readonly acceptedTask?: Maybe<TaskNode>;
  readonly asanaCreatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly asanaCreatedByGid?: Maybe<Scalars['String']['output']>;
  readonly asanaCreatedByUser?: Maybe<UserType>;
  readonly asanaId: Scalars['String']['output'];
  readonly asanaUrl: Scalars['String']['output'];
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes: Scalars['String']['output'];
  readonly resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly resolvedBy?: Maybe<UserType>;
  readonly status: TasksAsanaPendingTaskStatusChoices;
};

export type AsanaPendingTaskNodeConnection = {
  readonly __typename?: 'AsanaPendingTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<AsanaPendingTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `AsanaPendingTaskNode` and its cursor. */
export type AsanaPendingTaskNodeEdge = {
  readonly __typename?: 'AsanaPendingTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<AsanaPendingTaskNode>;
};

export type AsanaTaskSearchResultType = {
  readonly __typename?: 'AsanaTaskSearchResultType';
  readonly gid?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly permalinkUrl?: Maybe<Scalars['String']['output']>;
};

export type AssignChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignChecklistItemPayload = {
  readonly __typename?: 'AssignChecklistItemPayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignChecklistSectionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly sectionId: Scalars['UUID']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignChecklistSectionPayload = {
  readonly __typename?: 'AssignChecklistSectionPayload';
  readonly checklistSection?: Maybe<TaskChecklistSectionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagPayload = {
  readonly __typename?: 'AssignClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignClientTagToCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagToCommunityDocumentPayload = {
  readonly __typename?: 'AssignClientTagToCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignClientTagToTaskDefinitionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tagId: Scalars['UUID']['input'];
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type AssignClientTagToTaskDefinitionPayload = {
  readonly __typename?: 'AssignClientTagToTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type AssignClientTagToUserDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type AssignClientTagToUserDocumentPayload = {
  readonly __typename?: 'AssignClientTagToUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type AssignCommunityStaffRoleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly roleSlug: Scalars['String']['input'];
  readonly userId: Scalars['UUID']['input'];
};

export type AssignCommunityStaffRolePayload = {
  readonly __typename?: 'AssignCommunityStaffRolePayload';
  readonly assignment: CommunityStaffRoleType;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type AssignContractorToTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractorCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly contractorUserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly taskId: Scalars['UUID']['input'];
};

export type AssignContractorToTaskPayload = {
  readonly __typename?: 'AssignContractorToTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type AssignTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['UUID']['input'];
  readonly teamId?: InputMaybe<Scalars['UUID']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AssignTaskPayload = {
  readonly __typename?: 'AssignTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type AssignTeamInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly teamId: Scalars['UUID']['input'];
};

export type AssignTeamPayload = {
  readonly __typename?: 'AssignTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  readonly teamAssignment?: Maybe<TeamAssignmentNode>;
};

export type AssociateAgreementWithClient = {
  readonly __typename?: 'AssociateAgreementWithClient';
  readonly agreement?: Maybe<GeneratedAgreementType>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
};

export type AssociateAgreementWithClientInput = {
  readonly id: Scalars['String']['input'];
};

export type AssociateSection21WithClient = {
  readonly __typename?: 'AssociateSection21WithClient';
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type AssociateSection21WithClientInput = {
  readonly id: Scalars['String']['input'];
};

/** An enumeration. */
export enum AstGeneratorAgreementSignatureSignatureTypeChoices {
  /** Landlord */
  La = 'LA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum AstGeneratorAgreementSignatureStatusChoices {
  /** Signed */
  Si = 'SI',
  /** Void */
  Vo = 'VO',
  /** Waiting */
  Wa = 'WA'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementFurnishedChoices {
  /** Fully furnished */
  Ff = 'FF',
  /** Partially furnished */
  Pf = 'PF',
  /** Unfurnished */
  Uf = 'UF'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementPaymentFrequencyChoices {
  /** Monthly */
  Mo = 'MO',
  /** Weekly */
  We = 'WE'
}

/** An enumeration. */
export enum AstGeneratorGeneratedAgreementStatusChoices {
  /** Fully signed */
  Fs = 'FS',
  /** Generated */
  Ge = 'GE',
  /** Pending */
  Pe = 'PE',
  /** Sent for signing */
  Ss = 'SS',
  /** Tenants signed */
  Ts = 'TS'
}

export type AverageConversationRatingType = {
  readonly __typename?: 'AverageConversationRatingType';
  readonly averageRating?: Maybe<Scalars['Float']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type BacsPaymentType = {
  readonly __typename?: 'BACSPaymentType';
  readonly last4: Scalars['String']['output'];
  readonly sortCode: Scalars['String']['output'];
};

export type BatchCreateTaskDocumentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documents: ReadonlyArray<TaskDocumentItemInput>;
  readonly task: Scalars['UUID']['input'];
};

export type BatchCreateTaskDocumentsPayload = {
  readonly __typename?: 'BatchCreateTaskDocumentsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskDocuments?: Maybe<ReadonlyArray<Maybe<TaskDocumentNode>>>;
};

export type BlockComplianceRequirementItemAttachmentNode = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type BlockComplianceRequirementItemAttachmentNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemAttachmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemAttachmentNode` and its cursor. */
export type BlockComplianceRequirementItemAttachmentNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemAttachmentNode>;
};

export type BlockComplianceRequirementItemNode = {
  readonly __typename?: 'BlockComplianceRequirementItemNode';
  readonly attachments: BlockComplianceRequirementItemAttachmentNodeConnection;
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly expiryDate: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};


export type BlockComplianceRequirementItemNodeAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type BlockComplianceRequirementItemNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BlockComplianceRequirementItemNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementItemNode` and its cursor. */
export type BlockComplianceRequirementItemNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementItemNode>;
};

export type BlockComplianceRequirementNode = {
  readonly __typename?: 'BlockComplianceRequirementNode';
  readonly actionDate: Scalars['Date']['output'];
  readonly block: BlockNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly item?: Maybe<BlockComplianceRequirementItemNode>;
  readonly items: BlockComplianceRequirementItemNodeConnection;
  readonly requirement: BlocksComplianceRequirementNode;
  readonly status: BlockComplianceRequirementStatus;
};


export type BlockComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type BlockComplianceRequirementNodeConnection = {
  readonly __typename?: 'BlockComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockComplianceRequirementNode` and its cursor. */
export type BlockComplianceRequirementNodeEdge = {
  readonly __typename?: 'BlockComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockComplianceRequirementNode>;
};

export enum BlockComplianceRequirementStatus {
  Checked = 'CHECKED',
  Expired = 'EXPIRED',
  Expiring = 'EXPIRING',
  Missing = 'MISSING'
}

export type BlockGroupSyncResultNode = {
  readonly __typename?: 'BlockGroupSyncResultNode';
  readonly group: CommunityGroupNode;
  readonly membersAdded: Scalars['Int']['output'];
  readonly membersRemoved: Scalars['Int']['output'];
};

export type BlockNode = {
  readonly __typename?: 'BlockNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deleteRefusal?: Maybe<Scalars['String']['output']>;
  readonly dutyHolderLabel: Scalars['String']['output'];
  readonly everyoneCount?: Maybe<Scalars['Int']['output']>;
  readonly groups: ReadonlyArray<CommunityGroupNode>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly hrbReference?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isDefault: Scalars['Boolean']['output'];
  readonly isNewUnconfirmed: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly leaseholdersCount?: Maybe<Scalars['Int']['output']>;
  readonly name: Scalars['String']['output'];
  readonly residentsCount?: Maybe<Scalars['Int']['output']>;
  readonly responsiblePersonName: Scalars['String']['output'];
  readonly responsiblePersonRole: Scalars['String']['output'];
  readonly safetyResponderPack?: Maybe<SafetyResponderPackNode>;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly status: BlockStatus;
  readonly totalFloors?: Maybe<Scalars['Int']['output']>;
  readonly unassignedHomesCount: Scalars['Int']['output'];
  readonly unconfirmedHomesCount: Scalars['Int']['output'];
  readonly unconfirmedPlacements: ReadonlyArray<BlockPlacementType>;
};


export type BlockNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type BlockNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  includeDemoHomes?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missingFloor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};

export type BlockNodeConnection = {
  readonly __typename?: 'BlockNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BlockNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BlockNode` and its cursor. */
export type BlockNodeEdge = {
  readonly __typename?: 'BlockNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BlockNode>;
};

export enum BlockPlacementMethod {
  AddressMatch = 'ADDRESS_MATCH',
  Manual = 'MANUAL',
  Model = 'MODEL'
}

export type BlockPlacementType = {
  readonly __typename?: 'BlockPlacementType';
  readonly home: HomeNode;
  readonly id: Scalars['ID']['output'];
  readonly method: BlockPlacementMethod;
  readonly placedAt: Scalars['DateTime']['output'];
  readonly runKind?: Maybe<BlockSetupRunKind>;
};

export enum BlockSetupRunKind {
  Daily = 'DAILY',
  DryRun = 'DRY_RUN'
}

export type BlockSetupSummaryType = {
  readonly __typename?: 'BlockSetupSummaryType';
  readonly appliedAt: Scalars['DateTime']['output'];
  readonly blocksCreated: Scalars['Int']['output'];
  readonly homesPlaced: Scalars['Int']['output'];
  readonly runId: Scalars['ID']['output'];
  readonly unconfirmedCount: Scalars['Int']['output'];
};

export enum BlockStatus {
  Empty = 'EMPTY',
  NeedsResponsiblePerson = 'NEEDS_RESPONSIBLE_PERSON',
  PackStale = 'PACK_STALE',
  Ready = 'READY'
}

export type BlocksComplianceRequirementNode = {
  readonly __typename?: 'BlocksComplianceRequirementNode';
  readonly blockComplianceRequirements: BlockComplianceRequirementNodeConnection;
  readonly blocks: BlockNodeConnection;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly shared: Scalars['Boolean']['output'];
};


export type BlocksComplianceRequirementNodeBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type BlocksComplianceRequirementNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type BookCommunityEventMutationInput = {
  readonly additionalAttendance?: InputMaybe<Scalars['Int']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookCommunityEventMutationPayload = {
  readonly __typename?: 'BookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type BookPaidCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type BookPaidCommunityEventMutationPayload = {
  readonly __typename?: 'BookPaidCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type BookingReportingBookedByNode = {
  readonly __typename?: 'BookingReportingBookedByNode';
  readonly bookedByStaff: Scalars['Boolean']['output'];
  readonly count: Scalars['Int']['output'];
};

export type BookingReportingBookersNode = {
  readonly __typename?: 'BookingReportingBookersNode';
  readonly bookingsPerBooker?: Maybe<Scalars['Float']['output']>;
  readonly frequency: ReadonlyArray<BookingReportingFrequencyNode>;
  readonly uniqueBookers: Scalars['Int']['output'];
};

export type BookingReportingCancellationNode = {
  readonly __typename?: 'BookingReportingCancellationNode';
  readonly byDay: ReadonlyArray<BookingReportingDayCountNode>;
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type BookingReportingCapacityNode = {
  readonly __typename?: 'BookingReportingCapacityNode';
  readonly amenityId: Scalars['UUID']['output'];
  readonly capacityHours?: Maybe<Scalars['Float']['output']>;
  readonly label: Scalars['String']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
  readonly usedHours: Scalars['Float']['output'];
};

export type BookingReportingCountNode = {
  readonly __typename?: 'BookingReportingCountNode';
  readonly byDay: ReadonlyArray<BookingReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type BookingReportingDayCountNode = {
  readonly __typename?: 'BookingReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type BookingReportingFacilityNode = {
  readonly __typename?: 'BookingReportingFacilityNode';
  readonly amenityId?: Maybe<Scalars['UUID']['output']>;
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type BookingReportingFrequencyNode = {
  readonly __typename?: 'BookingReportingFrequencyNode';
  readonly bookers: Scalars['Int']['output'];
  readonly maxBookings?: Maybe<Scalars['Int']['output']>;
  readonly minBookings: Scalars['Int']['output'];
};

export type BookingReportingHourCountNode = {
  readonly __typename?: 'BookingReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type BookingReportingLeadTimeNode = {
  readonly __typename?: 'BookingReportingLeadTimeNode';
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type BookingReportingNode = {
  readonly __typename?: 'BookingReportingNode';
  readonly bookedBy: ReadonlyArray<BookingReportingBookedByNode>;
  readonly bookers: BookingReportingBookersNode;
  readonly bookings: BookingReportingCountNode;
  readonly byFacility: ReadonlyArray<BookingReportingFacilityNode>;
  readonly cancellations: BookingReportingCancellationNode;
  readonly capacityUse: ReadonlyArray<BookingReportingCapacityNode>;
  readonly leadTime: BookingReportingLeadTimeNode;
  readonly residentReach: BookingReportingResidentReachNode;
  readonly slotPattern: ReadonlyArray<BookingReportingHourCountNode>;
};

export type BookingReportingResidentReachNode = {
  readonly __typename?: 'BookingReportingResidentReachNode';
  readonly bookerCount: Scalars['Int']['output'];
  readonly residentCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
};

export type BudgetNode = {
  readonly __typename?: 'BudgetNode';
  readonly activatedOn: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type BudgetNodeConnection = {
  readonly __typename?: 'BudgetNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<BudgetNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `BudgetNode` and its cursor. */
export type BudgetNodeEdge = {
  readonly __typename?: 'BudgetNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<BudgetNode>;
};

export type BudgetSummaryType = {
  readonly __typename?: 'BudgetSummaryType';
  readonly buildingSafetyActCompliance: Scalars['Decimal']['output'];
  readonly buildingsInsurance: Scalars['Decimal']['output'];
  readonly generalExpenses: Scalars['Decimal']['output'];
  readonly generalHealthAndSafety: Scalars['Decimal']['output'];
  readonly management: Scalars['Decimal']['output'];
  readonly onsiteStaff: Scalars['Decimal']['output'];
  readonly otherProfessionalFees: Scalars['Decimal']['output'];
  readonly repairsAndMaintenance: Scalars['Decimal']['output'];
  readonly reserveFunds: Scalars['Decimal']['output'];
  readonly utilities: Scalars['Decimal']['output'];
  readonly yearEnd: Scalars['DateTime']['output'];
  readonly yearStart: Scalars['DateTime']['output'];
};

export type BulkConversationActionJobNode = {
  readonly __typename?: 'BulkConversationActionJobNode';
  readonly action: ResidentialManagementBulkConversationActionJobActionChoices;
  readonly closedReason: ResidentialManagementBulkConversationActionJobClosedReasonChoices;
  readonly conversationIds: Scalars['JSONString']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly failed: Scalars['Int']['output'];
  readonly finishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly processed: Scalars['Int']['output'];
  readonly skipped: Scalars['Int']['output'];
  readonly snapshotAt: Scalars['DateTime']['output'];
  readonly startedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status: ResidentialManagementBulkConversationActionJobStatusChoices;
  readonly succeeded: Scalars['Int']['output'];
  readonly total: Scalars['Int']['output'];
};

export type BulkConversationCloseFilterInput = {
  readonly assignedTo?: InputMaybe<Scalars['String']['input']>;
  readonly assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly dateFrom?: InputMaybe<Scalars['Date']['input']>;
  readonly dateTo?: InputMaybe<Scalars['Date']['input']>;
  readonly direction?: InputMaybe<Scalars['String']['input']>;
  readonly inactive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly search?: InputMaybe<Scalars['String']['input']>;
  readonly source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type BulkDeactivationJobNode = {
  readonly __typename?: 'BulkDeactivationJobNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly errorMessage?: Maybe<Scalars['String']['output']>;
  readonly failed: Scalars['Int']['output'];
  readonly finishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly processed: Scalars['Int']['output'];
  readonly startedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly succeeded: Scalars['Int']['output'];
  readonly total: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CalendarLinkType = {
  readonly __typename?: 'CalendarLinkType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastChecked?: Maybe<Scalars['DateTime']['output']>;
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type CancelAmenityReservationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelAmenityReservationPayload = {
  readonly __typename?: 'CancelAmenityReservationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CancelPaymentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['UUID']['input'];
};

export type CancelPaymentPayload = {
  readonly __typename?: 'CancelPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
};

export type CancelScheduledMessage = {
  readonly __typename?: 'CancelScheduledMessage';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type CancelScheduledMessageInput = {
  readonly id: Scalars['UUID']['input'];
};

export type CancelScheduledPublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CancelScheduledPublishCommunityUpdatePayload = {
  readonly __typename?: 'CancelScheduledPublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CardPaymentType = {
  readonly __typename?: 'CardPaymentType';
  readonly brand: Scalars['String']['output'];
  readonly last4: Scalars['String']['output'];
};

export type ChangeTaskStatusInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Status>;
};

export type ChangeTaskStatusPayload = {
  readonly __typename?: 'ChangeTaskStatusPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type ChargeType = {
  readonly __typename?: 'ChargeType';
  readonly paymentMethodDetails: PaymentMethod;
};

export type CheckInKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckInKeyV2Payload = {
  readonly __typename?: 'CheckInKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CheckOutKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly currentKeyholder?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CheckOutKeyV2Payload = {
  readonly __typename?: 'CheckOutKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type ChecklistActionNode = {
  readonly __typename?: 'ChecklistActionNode';
  readonly confidence?: Maybe<Scalars['Float']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dismissalNote: Scalars['String']['output'];
  readonly dismissalReason?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly finding: Scalars['String']['output'];
  readonly followUpTaskCount: Scalars['Int']['output'];
  readonly followUpTasks?: Maybe<ReadonlyArray<TaskNode>>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSuggested: Scalars['Boolean']['output'];
  readonly item: TaskChecklistItemNode;
  readonly legislationReference: Scalars['String']['output'];
  readonly location: Scalars['String']['output'];
  readonly locations: ReadonlyArray<Scalars['String']['output']>;
  readonly origin?: Maybe<Scalars['String']['output']>;
  readonly plannedDate?: Maybe<Scalars['Date']['output']>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly priorityRaw: Scalars['String']['output'];
  readonly recommendation: Scalars['String']['output'];
  readonly resolvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly resolvedBy?: Maybe<UserType>;
  readonly reviewStatus?: Maybe<Scalars['String']['output']>;
  readonly reviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly reviewedBy?: Maybe<UserType>;
  readonly sourceExtraction?: Maybe<DocumentExtractionNode>;
  readonly sourceQuote: Scalars['String']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly suggestedTaskDescription: Scalars['String']['output'];
  readonly suggestedTaskTitle: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ChecklistActionSourceNode = {
  readonly __typename?: 'ChecklistActionSourceNode';
  readonly actionId: Scalars['UUID']['output'];
  readonly isRegionLevel: Scalars['Boolean']['output'];
  readonly page?: Maybe<SourceDocumentPageNode>;
  readonly regions: ReadonlyArray<ActionSourceRegionNode>;
};

export type ChecklistComplianceRecordNode = {
  readonly __typename?: 'ChecklistComplianceRecordNode';
  readonly assessedBy?: Maybe<UserType>;
  readonly assessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly assessorName?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly nextAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly providerName?: Maybe<Scalars['String']['output']>;
  readonly riskConsequence?: Maybe<Scalars['String']['output']>;
  readonly riskLikelihood?: Maybe<Scalars['String']['output']>;
  readonly riskRating?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ChecklistItemResponseValueInput = {
  readonly responseBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  readonly responseChoice?: InputMaybe<Response_Choice>;
  readonly responseDate?: InputMaybe<Scalars['Date']['input']>;
  readonly responseId?: InputMaybe<Scalars['String']['input']>;
  readonly responseNumber?: InputMaybe<Scalars['Decimal']['input']>;
  readonly responseText?: InputMaybe<Scalars['String']['input']>;
  readonly responseTime?: InputMaybe<Scalars['Time']['input']>;
  readonly sourceInputId?: InputMaybe<Scalars['String']['input']>;
};

export type ChecklistSectionInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly steps?: InputMaybe<ReadonlyArray<ChecklistStepInput>>;
  readonly title: Scalars['String']['input'];
};

export type ChecklistStepFieldInput = {
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputType: Scalars['String']['input'];
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly label?: InputMaybe<Scalars['String']['input']>;
};

export type ChecklistStepInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly guidance?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputs?: InputMaybe<ReadonlyArray<ChecklistStepFieldInput>>;
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly referenceCode?: InputMaybe<Scalars['String']['input']>;
  readonly requiresPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stepType?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type ClientAdminNode = {
  readonly __typename?: 'ClientAdminNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};


export type ClientAdminNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientContractorCompanyNode = {
  readonly __typename?: 'ClientContractorCompanyNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly communities: CommunityNodeConnection;
  readonly companyType?: Maybe<ResidentialManagementClientContractorCompanyCompanyTypeChoices>;
  readonly contractorCompany: ContractorCompanyNode;
  readonly contractorCount?: Maybe<Scalars['Int']['output']>;
  readonly contractors: ContractorNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly website?: Maybe<Scalars['String']['output']>;
};


export type ClientContractorCompanyNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ClientContractorCompanyNodeContractorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientContractorCompanyNodeConnection = {
  readonly __typename?: 'ClientContractorCompanyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientContractorCompanyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientContractorCompanyNode` and its cursor. */
export type ClientContractorCompanyNodeEdge = {
  readonly __typename?: 'ClientContractorCompanyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientContractorCompanyNode>;
};

export type ClientStaffDirectoryMemberType = {
  readonly __typename?: 'ClientStaffDirectoryMemberType';
  readonly clientId: Scalars['UUID']['output'];
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
  readonly roles: ReadonlyArray<ClientStaffDirectoryRoleType>;
};

export type ClientStaffDirectoryRoleType = {
  readonly __typename?: 'ClientStaffDirectoryRoleType';
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly roleSlug: Scalars['String']['output'];
};

export type ClientStaffMemberNode = {
  readonly __typename?: 'ClientStaffMemberNode';
  readonly communityIds: ReadonlyArray<Maybe<Scalars['UUID']['output']>>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRoleActive?: Maybe<Scalars['Boolean']['output']>;
  readonly lastActive?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly mfaEnabled: Scalars['Boolean']['output'];
  readonly profile?: Maybe<UserProfileNode>;
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly roleCommunitiesPreview?: Maybe<ReadonlyArray<Maybe<ClientUserCommunityType>>>;
  readonly roleCommunityCount: Scalars['Int']['output'];
  readonly teamIds: ReadonlyArray<Maybe<Scalars['UUID']['output']>>;
  readonly teams?: Maybe<ReadonlyArray<Maybe<ClientStaffMemberTeamType>>>;
};

export type ClientStaffMemberNodeConnection = {
  readonly __typename?: 'ClientStaffMemberNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientStaffMemberNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientStaffMemberNode` and its cursor. */
export type ClientStaffMemberNodeEdge = {
  readonly __typename?: 'ClientStaffMemberNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientStaffMemberNode>;
};

export type ClientStaffMemberTeamType = {
  readonly __typename?: 'ClientStaffMemberTeamType';
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type ClientTagNode = {
  readonly __typename?: 'ClientTagNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignments: TagAssignmentNodeConnection;
  readonly client: ClientType;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSystemManaged: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};


export type ClientTagNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientTagNodeConnection = {
  readonly __typename?: 'ClientTagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientTagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientTagNode` and its cursor. */
export type ClientTagNodeEdge = {
  readonly __typename?: 'ClientTagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientTagNode>;
};

export type ClientType = {
  readonly __typename?: 'ClientType';
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly btlSubscriptionPerHomeCost?: Maybe<Scalars['Float']['output']>;
  readonly btlSubscriptionTotalCost?: Maybe<Scalars['Float']['output']>;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly clientType: PeopleClientClientTypeChoices;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly features: ReadonlyArray<FeatureType>;
  readonly hasAddedHome?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCheckedCompliance?: Maybe<Scalars['Boolean']['output']>;
  readonly hasCreatedTenancy?: Maybe<Scalars['Boolean']['output']>;
  readonly hasPayments?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSentReference?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSetupRentCollection?: Maybe<Scalars['Boolean']['output']>;
  readonly hasSignedAgreement?: Maybe<Scalars['Boolean']['output']>;
  readonly homes: ReadonlyArray<HomeType>;
  readonly homesCount?: Maybe<Scalars['Int']['output']>;
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly integrations?: Maybe<IntegrationType>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSubscribed?: Maybe<Scalars['Boolean']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly name: Scalars['String']['output'];
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly referenceStartedOn?: Maybe<Scalars['Date']['output']>;
  readonly stripeAccountId?: Maybe<Scalars['String']['output']>;
  readonly stripeAccountLink?: Maybe<Scalars['String']['output']>;
  readonly stripeDashboardLink?: Maybe<Scalars['String']['output']>;
  readonly subscriptions?: Maybe<ReadonlyArray<Maybe<SubscriptionNode>>>;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
  readonly tokens: Scalars['Int']['output'];
};


export type ClientTypeBtlSubscriptionTotalCostArgs = {
  includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ClientTypeStripeAccountLinkArgs = {
  returnUrl?: InputMaybe<Scalars['String']['input']>;
};


export type ClientTypeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientUserCommunityType = {
  readonly __typename?: 'ClientUserCommunityType';
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type ClientUserNode = {
  readonly __typename?: 'ClientUserNode';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRoleActive?: Maybe<Scalars['Boolean']['output']>;
  readonly lastActive?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly manager?: Maybe<ManagerType>;
  readonly mfaEnabled: Scalars['Boolean']['output'];
  readonly profile?: Maybe<UserProfileNode>;
  readonly role?: Maybe<Scalars['String']['output']>;
  readonly roleCommunities?: Maybe<ReadonlyArray<Maybe<ClientUserCommunityType>>>;
  readonly teams?: Maybe<TeamNodeConnection>;
};


export type ClientUserNodeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ClientUserNodeConnection = {
  readonly __typename?: 'ClientUserNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ClientUserNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ClientUserNode` and its cursor. */
export type ClientUserNodeEdge = {
  readonly __typename?: 'ClientUserNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ClientUserNode>;
};

export type CloseConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly notify?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CloseConversationPayload = {
  readonly __typename?: 'CloseConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type CloseSurvey = {
  readonly __typename?: 'CloseSurvey';
  readonly survey?: Maybe<ResidentSurveyNode>;
};

export type CollectPackagesForHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home: Scalars['UUID']['input'];
  readonly user?: InputMaybe<Scalars['UUID']['input']>;
};

export type CollectPackagesForHomePayload = {
  readonly __typename?: 'CollectPackagesForHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeNode>;
};

export type CollectPackagesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly packageIds: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly userId: Scalars['UUID']['input'];
};

export type CollectPackagesPayload = {
  readonly __typename?: 'CollectPackagesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly packages: ReadonlyArray<Maybe<PackageNode>>;
};

export type CommunityDashboardType = {
  readonly __typename?: 'CommunityDashboardType';
  readonly activeResidentsDifference?: Maybe<Scalars['Int']['output']>;
  readonly allTimeSatisfaction?: Maybe<Scalars['Decimal']['output']>;
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly downloadRate?: Maybe<Scalars['Int']['output']>;
  readonly downloadRateOverTime?: Maybe<ReadonlyArray<Maybe<DownloadRateType>>>;
  readonly listEngagementScores?: Maybe<ReadonlyArray<CommunityEngagementScoreType>>;
  readonly monthlyActiveResidents?: Maybe<Scalars['Int']['output']>;
  readonly openCount?: Maybe<Scalars['Int']['output']>;
  readonly ratingsOverTime?: Maybe<ReadonlyArray<Maybe<AverageConversationRatingType>>>;
  readonly responseTimeDifference?: Maybe<Scalars['Int']['output']>;
  readonly responseTimeOverTime?: Maybe<ReadonlyArray<Maybe<ResponseTimeType>>>;
  readonly snoozedCount?: Maybe<Scalars['Int']['output']>;
};

export type CommunityDocumentNode = {
  readonly __typename?: 'CommunityDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<ManagerType>;
  readonly createdByUser?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<DocumentNode>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly title: Scalars['String']['output'];
  readonly totalPotentialViewers: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly viewers: ResidentialManagementCommunityDocumentViewersChoices;
  readonly views: CommunityDocumentViewNodeConnection;
};


export type CommunityDocumentNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityDocumentNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityDocumentNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityDocumentNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityDocumentNodeConnection = {
  readonly __typename?: 'CommunityDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentNode` and its cursor. */
export type CommunityDocumentNodeEdge = {
  readonly __typename?: 'CommunityDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentNode>;
};

export type CommunityDocumentReminderNode = {
  readonly __typename?: 'CommunityDocumentReminderNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly document?: Maybe<CommunityDocumentNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type CommunityDocumentReminderNodeConnection = {
  readonly __typename?: 'CommunityDocumentReminderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentReminderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentReminderNode` and its cursor. */
export type CommunityDocumentReminderNodeEdge = {
  readonly __typename?: 'CommunityDocumentReminderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentReminderNode>;
};

export type CommunityDocumentViewNode = {
  readonly __typename?: 'CommunityDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type CommunityDocumentViewNodeConnection = {
  readonly __typename?: 'CommunityDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityDocumentViewNode` and its cursor. */
export type CommunityDocumentViewNodeEdge = {
  readonly __typename?: 'CommunityDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityDocumentViewNode>;
};

export type CommunityEngagementScoreType = {
  readonly __typename?: 'CommunityEngagementScoreType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly score: Scalars['Decimal']['output'];
};

export type CommunityEventNode = {
  readonly __typename?: 'CommunityEventNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly availableSpaces?: Maybe<Scalars['Int']['output']>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly end: Scalars['DateTime']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly guests?: Maybe<ContactNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAttending?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  /** Meeting or external links for this event (e.g. Google Meet, Teams, Zoom). */
  readonly links?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly maxAdditionalAttendees: Scalars['Int']['output'];
  readonly maxSpaces: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly parties: CommunityEventPartyNodeConnection;
  readonly partyAdditionalAttendance?: Maybe<Scalars['Int']['output']>;
  readonly start: Scalars['DateTime']['output'];
};


export type CommunityEventNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityEventNodeGuestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityEventNodePartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityEventNodeConnection = {
  readonly __typename?: 'CommunityEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityEventNode` and its cursor. */
export type CommunityEventNodeEdge = {
  readonly __typename?: 'CommunityEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityEventNode>;
};

export type CommunityEventPartyNode = {
  readonly __typename?: 'CommunityEventPartyNode';
  readonly additionalAttendance: Scalars['Int']['output'];
  readonly event?: Maybe<CommunityEventNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly users?: Maybe<ContactNodeConnection>;
};


export type CommunityEventPartyNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityEventPartyNodeConnection = {
  readonly __typename?: 'CommunityEventPartyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityEventPartyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityEventPartyNode` and its cursor. */
export type CommunityEventPartyNodeEdge = {
  readonly __typename?: 'CommunityEventPartyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityEventPartyNode>;
};

export type CommunityFeatureNode = {
  readonly __typename?: 'CommunityFeatureNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type CommunityFeatureNodeConnection = {
  readonly __typename?: 'CommunityFeatureNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityFeatureNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityFeatureNode` and its cursor. */
export type CommunityFeatureNodeEdge = {
  readonly __typename?: 'CommunityFeatureNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityFeatureNode>;
};

export type CommunityFormNode = {
  readonly __typename?: 'CommunityFormNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly externalId: Scalars['String']['output'];
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isCompleted?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link: Scalars['String']['output'];
  readonly numberOfResponses?: Maybe<Scalars['Int']['output']>;
  readonly provider: ResidentialManagementCommunityFormProviderChoices;
  readonly questions?: Maybe<TypeformQuestionConnection>;
  readonly responses?: Maybe<TypeformResponseConnection>;
  readonly title?: Maybe<Scalars['String']['output']>;
};


export type CommunityFormNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityFormNodeQuestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityFormNodeResponsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityFormNodeConnection = {
  readonly __typename?: 'CommunityFormNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityFormNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityFormNode` and its cursor. */
export type CommunityFormNodeEdge = {
  readonly __typename?: 'CommunityFormNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityFormNode>;
};

export type CommunityGroupNode = {
  readonly __typename?: 'CommunityGroupNode';
  readonly block?: Maybe<BlockNode>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityId?: Maybe<Scalars['ID']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly defaultDescription?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isAutomatic: Scalars['Boolean']['output'];
  readonly isBlockScoped?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityScoped?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSystemManaged: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numUsers?: Maybe<Scalars['Int']['output']>;
  readonly pinnedHomes: ReadonlyArray<HomeNode>;
  readonly type: ResidentialManagementCommunityGroupTypeChoices;
  readonly users?: Maybe<ContactNodeConnection>;
};


export type CommunityGroupNodeHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityGroupNodeUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityGroupNodeConnection = {
  readonly __typename?: 'CommunityGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityGroupNodeEdge>>;
  readonly locales?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityGroupNode` and its cursor. */
export type CommunityGroupNodeEdge = {
  readonly __typename?: 'CommunityGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityGroupNode>;
};

export type CommunityManagerNode = {
  readonly __typename?: 'CommunityManagerNode';
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};


export type CommunityManagerNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CommunityNode = {
  readonly __typename?: 'CommunityNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly appCoverImage?: Maybe<Scalars['String']['output']>;
  readonly asanaWebFormUrl?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageRentAmount?: Maybe<Scalars['Float']['output']>;
  readonly averageResidencyLength?: Maybe<Scalars['Float']['output']>;
  readonly blocks: BlockNodeConnection;
  readonly budgetSummaries: ReadonlyArray<Maybe<BudgetSummaryType>>;
  readonly buttonColor?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly commentsEnabled: Scalars['Boolean']['output'];
  readonly communityChatEnabled: Scalars['Boolean']['output'];
  readonly communityEvents: CommunityEventNodeConnection;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly dwellantTaskCategories?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly engagementScore?: Maybe<Scalars['Decimal']['output']>;
  readonly engagementScoreDifference?: Maybe<Scalars['Float']['output']>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly features: CommunityFeatureNodeConnection;
  readonly hasAsanaIntegration: Scalars['Boolean']['output'];
  readonly hasBlocks: Scalars['Boolean']['output'];
  readonly hasDwellantIntegration?: Maybe<Scalars['Boolean']['output']>;
  readonly homeCount: Scalars['Int']['output'];
  readonly iconColor?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isLeasehold: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastSibPackGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastSibPackPrintedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly logo?: Maybe<Scalars['String']['output']>;
  readonly managers: ReadonlyArray<ManagerType>;
  readonly marketplaceEnabled: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly officeHoursEnabled: Scalars['Boolean']['output'];
  readonly openConversationsCount?: Maybe<Scalars['Int']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<CommunityOpenPeriodNode>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly packageLocations?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly paymentsEnabled: Scalars['Boolean']['output'];
  readonly pendingBlockSetup?: Maybe<BlockSetupSummaryType>;
  readonly percentOccupied?: Maybe<Scalars['Float']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly recentUnresolvedConversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly referencingEnabled: Scalars['Boolean']['output'];
  readonly requisiteDate?: Maybe<Scalars['Date']['output']>;
  readonly residentCount: Scalars['Int']['output'];
  readonly responsiblePersonName: Scalars['String']['output'];
  readonly responsiblePersonRole: Scalars['String']['output'];
  readonly safetyComplianceReadiness: SafetyComplianceReadinessType;
  readonly safetyPackEligibility: SafetyPackEligibilityType;
  readonly satisfactionScore?: Maybe<Scalars['Float']['output']>;
  readonly settings: CommunitySettingsType;
  readonly sibPackStale: Scalars['Boolean']['output'];
  readonly sibPackUrl?: Maybe<Scalars['String']['output']>;
  readonly sibResidentNeedCount: Scalars['Int']['output'];
  readonly sibTaggedDocumentCount: Scalars['Int']['output'];
  readonly statisticDataPoint?: Maybe<CommunityStatisticDataPointNode>;
  readonly statisticDataPoints?: Maybe<ReadonlyArray<Maybe<CommunityStatisticDataPointNode>>>;
  readonly statisticDifference?: Maybe<Scalars['Float']['output']>;
  readonly status: Scalars['String']['output'];
  readonly team?: Maybe<CommunityTeamNodeConnection>;
  readonly textColor?: Maybe<Scalars['String']['output']>;
  readonly themeColor?: Maybe<Scalars['String']['output']>;
  readonly unreadConversations: Scalars['Int']['output'];
  readonly updates?: Maybe<ReadonlyArray<CommunityUpdateType>>;
};


export type CommunityNodeBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityNodeCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partyUsers?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type CommunityNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityNodeFeaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityNodeStatisticDataPointArgs = {
  date?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeStatisticDataPointsArgs = {
  frequency: HistoricalDataFrequency;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
  toDate?: InputMaybe<Scalars['Date']['input']>;
};


export type CommunityNodeStatisticDifferenceArgs = {
  since?: InputMaybe<Scalars['Date']['input']>;
  statisticType: HistoricalDataPointType;
};


export type CommunityNodeTeamArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  residentAppVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommunityNodeConnection = {
  readonly __typename?: 'CommunityNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityNode` and its cursor. */
export type CommunityNodeEdge = {
  readonly __typename?: 'CommunityNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityNode>;
};

export type CommunityOpenPeriodNode = {
  readonly __typename?: 'CommunityOpenPeriodNode';
  readonly end: Scalars['Time']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly start: Scalars['Time']['output'];
  readonly weekdayIndex: Scalars['Int']['output'];
};

export type CommunityOpenPeriodSerializerInput = {
  readonly end: Scalars['Time']['input'];
  readonly start: Scalars['Time']['input'];
  readonly weekdayIndex: Scalars['Int']['input'];
};

export type CommunityProductNode = {
  readonly __typename?: 'CommunityProductNode';
  readonly active: Scalars['Boolean']['output'];
  readonly client?: Maybe<ClientType>;
  readonly communities: CommunityNodeConnection;
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly purchases: CommunityProductPurchaseNodeConnection;
};


export type CommunityProductNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CommunityProductNodePurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CommunityProductNodeConnection = {
  readonly __typename?: 'CommunityProductNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductNode` and its cursor. */
export type CommunityProductNodeEdge = {
  readonly __typename?: 'CommunityProductNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductNode>;
};

export type CommunityProductPurchaseNode = {
  readonly __typename?: 'CommunityProductPurchaseNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly payment?: Maybe<PaymentNode>;
  readonly product?: Maybe<CommunityProductNode>;
  readonly user?: Maybe<UserType>;
};

export type CommunityProductPurchaseNodeConnection = {
  readonly __typename?: 'CommunityProductPurchaseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityProductPurchaseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityProductPurchaseNode` and its cursor. */
export type CommunityProductPurchaseNodeEdge = {
  readonly __typename?: 'CommunityProductPurchaseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityProductPurchaseNode>;
};

export type CommunitySettingsType = {
  readonly __typename?: 'CommunitySettingsType';
  readonly abMessageSuggestion: Scalars['Boolean']['output'];
  readonly accounts: Scalars['Boolean']['output'];
  readonly aiMessagePipeline: Scalars['Boolean']['output'];
  readonly appointments: Scalars['Boolean']['output'];
  readonly bankAccountName?: Maybe<Scalars['String']['output']>;
  readonly bankAccountNumber?: Maybe<Scalars['String']['output']>;
  readonly bankSortCode?: Maybe<Scalars['String']['output']>;
  readonly closureGateEnforced: Scalars['Boolean']['output'];
  readonly compliance: Scalars['Boolean']['output'];
  readonly contractorSuggestionsEnforced: Scalars['Boolean']['output'];
  readonly conversationForwardingEmails: ReadonlyArray<ConversationForwardingEmailType>;
  readonly documents: Scalars['Boolean']['output'];
  readonly dwellantOrgId?: Maybe<Scalars['String']['output']>;
  readonly emailHeaderImageUrl?: Maybe<Scalars['String']['output']>;
  readonly events: Scalars['Boolean']['output'];
  readonly externalPortalUrls: ReadonlyArray<ExternalPortalUrlType>;
  readonly facilities: Scalars['Boolean']['output'];
  readonly fixfloRepairPrompts: Scalars['Boolean']['output'];
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly forms: Scalars['Boolean']['output'];
  readonly fullMessageSuggestion: Scalars['Boolean']['output'];
  readonly keys: Scalars['Boolean']['output'];
  readonly marketplace: Scalars['Boolean']['output'];
  readonly marketplaceBatchNotifications: Scalars['Boolean']['output'];
  readonly messages: Scalars['Boolean']['output'];
  readonly mobileNumberRequired: Scalars['Boolean']['output'];
  readonly newsfeed: Scalars['Boolean']['output'];
  readonly occupancySurvey: Scalars['Boolean']['output'];
  readonly packageLabels: Scalars['Boolean']['output'];
  readonly packages: Scalars['Boolean']['output'];
  readonly payByBankEnabled: Scalars['Boolean']['output'];
  readonly payByBankUiVariant: Scalars['String']['output'];
  readonly portalUrl?: Maybe<Scalars['String']['output']>;
  readonly products: Scalars['Boolean']['output'];
  readonly residentVisibleTasks: Scalars['Boolean']['output'];
  readonly safetyCenter: Scalars['Boolean']['output'];
  readonly safetyComplianceV2ActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly sendExternalIdToFixflo: Scalars['Boolean']['output'];
  readonly serviceChargeWaiver: Scalars['Boolean']['output'];
  readonly sibPackReviewNudgeMonths: Scalars['Int']['output'];
  readonly sibPackReviewRemindersEnabled: Scalars['Boolean']['output'];
  readonly staffEmailPatterns: ReadonlyArray<Maybe<Scalars['String']['output']>>;
  readonly surveyReviewIntervalMonths: Scalars['Int']['output'];
  readonly surveys: Scalars['Boolean']['output'];
  readonly termsAndConditions: Scalars['Boolean']['output'];
};

export type CommunityStaffCandidateType = {
  readonly __typename?: 'CommunityStaffCandidateType';
  readonly email: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly name: Scalars['String']['output'];
};

export type CommunityStaffRoleType = {
  readonly __typename?: 'CommunityStaffRoleType';
  readonly clientId: Scalars['UUID']['output'];
  readonly communityId: Scalars['UUID']['output'];
  readonly grantedAt: Scalars['DateTime']['output'];
  readonly grantedById?: Maybe<Scalars['UUID']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly roleSlug: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
  readonly userName: Scalars['String']['output'];
};

export type CommunityStatisticDataPointNode = {
  readonly __typename?: 'CommunityStatisticDataPointNode';
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly date: Scalars['Date']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: ResidentialManagementCommunityStatisticDataPointTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly value: Scalars['Float']['output'];
};

export type CommunityTaskDefinitionNode = {
  readonly __typename?: 'CommunityTaskDefinitionNode';
  readonly block?: Maybe<BlockNode>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly taskDefinition: TaskDefinitionNode;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type CommunityTaskDefinitionNodeConnection = {
  readonly __typename?: 'CommunityTaskDefinitionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTaskDefinitionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTaskDefinitionNode` and its cursor. */
export type CommunityTaskDefinitionNodeEdge = {
  readonly __typename?: 'CommunityTaskDefinitionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTaskDefinitionNode>;
};

export type CommunityTaskNode = {
  readonly __typename?: 'CommunityTaskNode';
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly residentStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'id' instead. Retained for resident-app <= 4.20.x compatibility; remove once min-supported app version floor is raised above 4.20. */
  readonly taskId?: Maybe<Scalars['UUID']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<ReadonlyArray<ResidentTaskUpdateType>>;
};

export type CommunityTaskNodeConnection = {
  readonly __typename?: 'CommunityTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTaskNode` and its cursor. */
export type CommunityTaskNodeEdge = {
  readonly __typename?: 'CommunityTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTaskNode>;
};

export type CommunityTeamMembersGroupType = {
  readonly __typename?: 'CommunityTeamMembersGroupType';
  readonly communityId: Scalars['UUID']['output'];
  readonly members: ReadonlyArray<CommunityTeamNode>;
};

export type CommunityTeamNode = {
  readonly __typename?: 'CommunityTeamNode';
  readonly biography?: Maybe<Scalars['String']['output']>;
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly isAdmin?: Maybe<Scalars['Boolean']['output']>;
  readonly isCommunityManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isConcierge?: Maybe<Scalars['Boolean']['output']>;
  readonly isManager?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly publicUuid: Scalars['UUID']['output'];
};

export type CommunityTeamNodeConnection = {
  readonly __typename?: 'CommunityTeamNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityTeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityTeamNode` and its cursor. */
export type CommunityTeamNodeEdge = {
  readonly __typename?: 'CommunityTeamNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityTeamNode>;
};

export type CommunityUpdateAttachmentNode = {
  readonly __typename?: 'CommunityUpdateAttachmentNode';
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type CommunityUpdateCommentNode = {
  readonly __typename?: 'CommunityUpdateCommentNode';
  readonly author: UserType;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly userType: ResidentialManagementCommunityUpdateCommentUserTypeChoices;
};

export type CommunityUpdateCommentNodeConnection = {
  readonly __typename?: 'CommunityUpdateCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateCommentNode` and its cursor. */
export type CommunityUpdateCommentNodeEdge = {
  readonly __typename?: 'CommunityUpdateCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateCommentNode>;
};

export type CommunityUpdateLikeType = {
  readonly __typename?: 'CommunityUpdateLikeType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly update: CommunityUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type CommunityUpdateLocaleVariantNode = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNode';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly status: ResidentialManagementCommunityUpdateLocaleVariantStatusChoices;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type CommunityUpdateLocaleVariantNodeConnection = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateLocaleVariantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateLocaleVariantNode` and its cursor. */
export type CommunityUpdateLocaleVariantNodeEdge = {
  readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateLocaleVariantNode>;
};

export type CommunityUpdateNode = {
  readonly __typename?: 'CommunityUpdateNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly attachments?: Maybe<ReadonlyArray<Maybe<CommunityUpdateAttachmentNode>>>;
  readonly body: Scalars['String']['output'];
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly groups?: Maybe<CommunityGroupNodeConnection>;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly isLiked?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly linkedFeature?: Maybe<ResidentialManagementCommunityUpdateLinkedFeatureChoices>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly numberOfBookmarks?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityUpdateNodeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityUpdateNodeConnection = {
  readonly __typename?: 'CommunityUpdateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityUpdateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityUpdateNode` and its cursor. */
export type CommunityUpdateNodeEdge = {
  readonly __typename?: 'CommunityUpdateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityUpdateNode>;
};

export type CommunityUpdateStatsType = {
  readonly __typename?: 'CommunityUpdateStatsType';
  readonly totalComments: Scalars['Int']['output'];
  readonly totalLikes: Scalars['Int']['output'];
  readonly totalReads: Scalars['Int']['output'];
};

/** An enumeration. */
export enum CommunityUpdateStatusEnum {
  Archived = 'Archived',
  Dr = 'DR',
  Li = 'LI',
  Sc = 'SC'
}

export type CommunityUpdateType = {
  readonly __typename?: 'CommunityUpdateType';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly attachment?: Maybe<Scalars['String']['output']>;
  readonly attachments: ReadonlyArray<CommunityUpdateAttachmentNode>;
  readonly body: Scalars['String']['output'];
  readonly bookmarkedBy: ReadonlyArray<UserType>;
  readonly category: Scalars['String']['output'];
  readonly comments?: Maybe<CommunityUpdateCommentNodeConnection>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly creatorType: ResidentialManagementCommunityUpdateCreatorTypeChoices;
  readonly groups: CommunityGroupNodeConnection;
  readonly hasBookmarked?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly imageSearchTerm?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly isArk: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly likes: ReadonlyArray<CommunityUpdateLikeType>;
  readonly linkedFeature?: Maybe<ResidentialManagementCommunityUpdateLinkedFeatureChoices>;
  readonly numLikes?: Maybe<Scalars['Int']['output']>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residentLike?: Maybe<Scalars['UUID']['output']>;
  readonly scheduledFor?: Maybe<Scalars['DateTime']['output']>;
  readonly stats: CommunityUpdateStatsType;
  readonly status: CommunityUpdateStatusEnum;
  readonly summary: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueReads?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updatedBy?: Maybe<UserType>;
  readonly variants?: Maybe<CommunityUpdateLocaleVariantNodeConnection>;
};


export type CommunityUpdateTypeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CommunityUpdateTypeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type CommunityUpdateTypeVariantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type CommunityVisitorNode = {
  readonly __typename?: 'CommunityVisitorNode';
  readonly community: CommunityNode;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email: Scalars['String']['output'];
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reasonForVisit?: Maybe<Scalars['String']['output']>;
  readonly residentName?: Maybe<Scalars['String']['output']>;
  readonly signedOutAt?: Maybe<Scalars['DateTime']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly vehicleRegistration?: Maybe<Scalars['String']['output']>;
};

export type CommunityVisitorNodeConnection = {
  readonly __typename?: 'CommunityVisitorNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<CommunityVisitorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `CommunityVisitorNode` and its cursor. */
export type CommunityVisitorNodeEdge = {
  readonly __typename?: 'CommunityVisitorNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<CommunityVisitorNode>;
};

export type CompleteChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly isCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly responseBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  readonly responseChoice?: InputMaybe<Response_Choice>;
  readonly responseDate?: InputMaybe<Scalars['Date']['input']>;
  readonly responseNumber?: InputMaybe<Scalars['Decimal']['input']>;
  readonly responseText?: InputMaybe<Scalars['String']['input']>;
  readonly responseTime?: InputMaybe<Scalars['Time']['input']>;
  readonly responses?: InputMaybe<ReadonlyArray<InputMaybe<ChecklistItemResponseValueInput>>>;
};

export type CompleteChecklistItemPayload = {
  readonly __typename?: 'CompleteChecklistItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItem?: Maybe<TaskChecklistItemNode>;
};

/** An enumeration. */
export enum ComplianceAttachmentTypeChoices {
  /** Home */
  Ho = 'HO',
  /** Requirement item */
  Ri = 'RI'
}

/** An enumeration. */
export enum ComplianceComplianceRequirementTypeChoices {
  /** Custom */
  Cu = 'CU',
  /** Deposit Certificate */
  Dc = 'DC',
  /** Electrical Installation Condition Report */
  Ei = 'EI',
  /** Energy Performance Assessment */
  Ep = 'EP',
  /** Gas Safety Inspection */
  Gs = 'GS',
  /** Local Authority Licensing */
  La = 'LA',
  /** Portable Appliance Test */
  Pa = 'PA',
  /** Smoke Alarm & Carbon Monoxide */
  Sa = 'SA',
  /** Tenancy Agreement */
  Ta = 'TA'
}

/** An enumeration. */
export enum ComplianceComplianceUpdateActionRequirementChoices {
  /** Action */
  Ac = 'AC',
  /** Advice */
  Ad = 'AD'
}

export type ComplianceRequirementNode = {
  readonly __typename?: 'ComplianceRequirementNode';
  readonly actionDate?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly currentItem?: Maybe<RequirementItemNode>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly items: RequirementItemNodeConnection;
  readonly name: Scalars['String']['output'];
  readonly residency?: Maybe<ResidencyType>;
  readonly shared: Scalars['Boolean']['output'];
  readonly status: Scalars['String']['output'];
  readonly type: ComplianceComplianceRequirementTypeChoices;
};


export type ComplianceRequirementNodeItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ComplianceRequirementNodeConnection = {
  readonly __typename?: 'ComplianceRequirementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ComplianceRequirementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ComplianceRequirementNode` and its cursor. */
export type ComplianceRequirementNodeEdge = {
  readonly __typename?: 'ComplianceRequirementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ComplianceRequirementNode>;
};

export type ComplianceUpdateReadType = {
  readonly __typename?: 'ComplianceUpdateReadType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly manager: ManagerType;
  readonly update: ComplianceUpdateType;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ComplianceUpdateType = {
  readonly __typename?: 'ComplianceUpdateType';
  readonly actionRequirement: ComplianceComplianceUpdateActionRequirementChoices;
  readonly actionText?: Maybe<Scalars['String']['output']>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dateText?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly infoSource?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly wasRead?: Maybe<Scalars['Boolean']['output']>;
};

export type ConciergeNode = {
  readonly __typename?: 'ConciergeNode';
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};


export type ConciergeNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmBlockPlacements = {
  readonly __typename?: 'ConfirmBlockPlacements';
  readonly block?: Maybe<BlockNode>;
};

export type ConfirmBlockSetup = {
  readonly __typename?: 'ConfirmBlockSetup';
  readonly community?: Maybe<CommunityNode>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ConfirmResidencyWillRollInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ConfirmResidencyWillRollPayload = {
  readonly __typename?: 'ConfirmResidencyWillRollPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export enum ConsentAttestationAuthority {
  PrescribedRepresentative = 'PRESCRIBED_REPRESENTATIVE',
  Resident = 'RESIDENT'
}

export enum ConsentAttestationChannel {
  SignedPaper = 'SIGNED_PAPER',
  Verbal = 'VERBAL'
}

export type ConsentAttestationInput = {
  readonly authority: ConsentAttestationAuthority;
  readonly channel: ConsentAttestationChannel;
  readonly representativeName?: InputMaybe<Scalars['String']['input']>;
  readonly representativeRelationship?: InputMaybe<Scalars['String']['input']>;
};

export type ContactApplicationSupportInput = {
  readonly applicationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly rejectedCommunityIds?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type ContactApplicationSupportPayload = {
  readonly __typename?: 'ContactApplicationSupportPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok: Scalars['Boolean']['output'];
};

export type ContactNode = {
  readonly __typename?: 'ContactNode';
  readonly amenityReservations: AmenityReservationNodeConnection;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<CommunityNode>>>;
  readonly communityGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly contactNotes: ContactNoteNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly eventParties?: Maybe<CommunityEventPartyNodeConnection>;
  readonly firstName: Scalars['String']['output'];
  readonly forms?: Maybe<ReadonlyArray<Maybe<CommunityFormNode>>>;
  readonly id: Scalars['ID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName: Scalars['String']['output'];
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly resident?: Maybe<ResidentNode>;
  readonly waivers: WaiverNodeConnection;
};


export type ContactNodeAmenityReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ContactNodeContactNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ContactNodeEventPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ContactNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ContactNodeWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ContactNodeConnection = {
  readonly __typename?: 'ContactNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContactNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactNode` and its cursor. */
export type ContactNodeEdge = {
  readonly __typename?: 'ContactNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContactNode>;
};

export type ContactNoteNode = {
  readonly __typename?: 'ContactNoteNode';
  readonly author: UserType;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly text: Scalars['String']['output'];
  readonly user: UserType;
};

export type ContactNoteNodeConnection = {
  readonly __typename?: 'ContactNoteNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContactNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContactNoteNode` and its cursor. */
export type ContactNoteNodeEdge = {
  readonly __typename?: 'ContactNoteNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContactNoteNode>;
};

export type ContactPackagesReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contact: Scalars['UUID']['input'];
  readonly packageIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type ContactPackagesReminderPayload = {
  readonly __typename?: 'ContactPackagesReminderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type ContractorCompanyNode = {
  readonly __typename?: 'ContractorCompanyNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<ResidentialManagementContractorCompanyTypeChoices>;
  readonly website?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ContractorDecision {
  Accepted = 'ACCEPTED',
  DontKnow = 'DONT_KNOW',
  Rejected = 'REJECTED'
}

export type ContractorNode = {
  readonly __typename?: 'ContractorNode';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly user: UserType;
};

export type ContractorNodeConnection = {
  readonly __typename?: 'ContractorNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ContractorNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ContractorNode` and its cursor. */
export type ContractorNodeEdge = {
  readonly __typename?: 'ContractorNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ContractorNode>;
};

export type ContractorSuggestionType = {
  readonly __typename?: 'ContractorSuggestionType';
  readonly contractorConfidence?: Maybe<Scalars['Float']['output']>;
  readonly contractorHasCompany: Scalars['Boolean']['output'];
  readonly homeConfidence?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isContractor: Scalars['Boolean']['output'];
  readonly isContractorDecision?: Maybe<ContractorDecision>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly suggestedHome?: Maybe<HomeType>;
};

export type ConversationActionModelType = {
  readonly __typename?: 'ConversationActionModelType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationAssignmentNode = {
  readonly __typename?: 'ConversationAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly assignedTo: UserType;
  readonly conversation: ConversationNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type ConversationAssignmentNodeConnection = {
  readonly __typename?: 'ConversationAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationAssignmentNode` and its cursor. */
export type ConversationAssignmentNodeEdge = {
  readonly __typename?: 'ConversationAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationAssignmentNode>;
};

export type ConversationCountsNode = {
  readonly __typename?: 'ConversationCountsNode';
  readonly all: Scalars['Int']['output'];
  readonly assigned: Scalars['Int']['output'];
  readonly assignedToMyTeam: Scalars['Int']['output'];
  readonly fromArk: Scalars['Int']['output'];
  readonly fromEmail: Scalars['Int']['output'];
  readonly inactive: Scalars['Int']['output'];
  readonly inactiveOwed: Scalars['Int']['output'];
  readonly needsResponse: Scalars['Int']['output'];
  readonly snoozed: Scalars['Int']['output'];
  readonly unassigned: Scalars['Int']['output'];
};

export type ConversationEventType = ConversationActionModelType | ConversationMediaType | ConversationMessageType;

export type ConversationForwardingEmailType = {
  readonly __typename?: 'ConversationForwardingEmailType';
  readonly emails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum ConversationHomeDecision {
  Accepted = 'ACCEPTED',
  Edited = 'EDITED',
  Rejected = 'REJECTED'
}

export type ConversationMediaType = {
  readonly __typename?: 'ConversationMediaType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sender: ResidentialManagementConversationMediaSenderChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ConversationMessageType = {
  readonly __typename?: 'ConversationMessageType';
  readonly body: Scalars['String']['output'];
  readonly contractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly conversation: ConversationNode;
  readonly conversationsummarySet: ConversationSummaryNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  /** Raw From header of the inbound email, including any display name */
  readonly fromEmailRaw?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Quoted reply text from email */
  readonly quotedText?: Maybe<Scalars['String']['output']>;
  readonly scheduledSource: ReadonlyArray<ScheduledMessageType>;
  readonly seen?: Maybe<Scalars['Boolean']['output']>;
  readonly sender: ResidentialManagementConversationMessageSenderChoices;
  readonly suggestion?: Maybe<MessageSuggestionType>;
  readonly suggestions: ReadonlyArray<MessageSuggestionType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};


export type ConversationMessageTypeConversationsummarySetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ConversationNode = {
  readonly __typename?: 'ConversationNode';
  readonly actions: ReadonlyArray<ConversationActionModelType>;
  readonly asanaTaskId?: Maybe<Scalars['String']['output']>;
  readonly assignment?: Maybe<ConversationAssignmentNode>;
  readonly assignments: ConversationAssignmentNodeConnection;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly availableTags?: Maybe<ConversationTagNodeConnection>;
  readonly availableTeams?: Maybe<TeamNodeConnection>;
  readonly category: ResidentialManagementConversationCategoryChoices;
  readonly closedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly closedBy?: Maybe<ResidentialManagementConversationClosedByChoices>;
  readonly closedByUser?: Maybe<UserType>;
  readonly closedReason?: Maybe<ResidentialManagementConversationClosedReasonChoices>;
  readonly community?: Maybe<CommunityNode>;
  readonly contractorSuggestion?: Maybe<ContractorSuggestionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentStatus?: Maybe<Scalars['String']['output']>;
  readonly currentUrgency?: Maybe<Scalars['String']['output']>;
  /** Original email Message-ID for threading */
  readonly emailMessageId?: Maybe<Scalars['String']['output']>;
  readonly hasUnread: Scalars['Boolean']['output'];
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isResidentWaiting: Scalars['Boolean']['output'];
  readonly lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastReopenedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastResidentMessageAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastStaffEventAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestEvent?: Maybe<ConversationEventType>;
  readonly latestMedia?: Maybe<ConversationMediaType>;
  readonly latestMessage?: Maybe<ConversationMessageType>;
  readonly latestOpen?: Maybe<ConversationOpenedType>;
  readonly latestStatus?: Maybe<ConversationStatusType>;
  readonly latestUpdatedDate?: Maybe<Scalars['DateTime']['output']>;
  readonly linkedTasks?: Maybe<ReadonlyArray<Maybe<TaskNode>>>;
  readonly media: ReadonlyArray<ConversationMediaType>;
  readonly messages: ReadonlyArray<ConversationMessageType>;
  readonly notes?: Maybe<ConversationNoteNodeConnection>;
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly openedCount?: Maybe<Scalars['Int']['output']>;
  readonly opens: ReadonlyArray<ConversationOpenedType>;
  readonly participantType: ResidentialManagementConversationParticipantTypeChoices;
  readonly rating?: Maybe<ConversationRatingType>;
  readonly ratingPresentation: RatingPresentationType;
  readonly ratingPromptDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly ratingPromptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly ratingQuestions: ReadonlyArray<ConversationRatingQuestionType>;
  readonly reopenCount: Scalars['Int']['output'];
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly responseTime?: Maybe<Scalars['Int']['output']>;
  /** Set while a re-tag run holds this conversation. Cleared when it finishes; a value older than the lease is treated as abandoned. */
  readonly retagClaimedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly scheduledMessages?: Maybe<ReadonlyArray<Maybe<ScheduledMessageType>>>;
  readonly snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  readonly source?: Maybe<Scalars['String']['output']>;
  readonly sourceApplicationThread?: Maybe<ApplicationThreadNode>;
  readonly statuses: ReadonlyArray<ConversationStatusType>;
  readonly subject: Scalars['String']['output'];
  readonly summaries: ConversationSummaryNodeConnection;
  readonly summary?: Maybe<ConversationSummaryNode>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tagSuggestions: ConversationTagSuggestionNodeConnection;
  readonly tags?: Maybe<ConversationTagNodeConnection>;
  readonly tasks: TaskNodeConnection;
  readonly teamAssignment?: Maybe<TeamAssignmentNode>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgencies: ReadonlyArray<ConversationUrgencyType>;
  readonly user?: Maybe<UserType>;
};


export type ConversationNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ConversationNodeAvailableTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeAvailableTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ConversationNodeNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeSummariesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagSuggestionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ConversationNodeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConversationNodeConnection = {
  readonly __typename?: 'ConversationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationNode` and its cursor. */
export type ConversationNodeEdge = {
  readonly __typename?: 'ConversationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNode>;
};

export type ConversationNoteMediaNode = {
  readonly __typename?: 'ConversationNoteMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ConversationNoteNode = {
  readonly __typename?: 'ConversationNoteNode';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<Maybe<ConversationNoteMediaNode>>>;
  readonly text: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type ConversationNoteNodeConnection = {
  readonly __typename?: 'ConversationNoteNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationNoteNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationNoteNode` and its cursor. */
export type ConversationNoteNodeEdge = {
  readonly __typename?: 'ConversationNoteNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationNoteNode>;
};

export type ConversationOpenedType = {
  readonly __typename?: 'ConversationOpenedType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationRatingAnswerSerializerInput = {
  readonly question: Scalars['String']['input'];
  readonly valueText: Scalars['String']['input'];
};

export type ConversationRatingAnswerType = {
  readonly __typename?: 'ConversationRatingAnswerType';
  readonly id: Scalars['UUID']['output'];
  readonly question: ConversationRatingQuestionType;
  readonly valueText: Scalars['String']['output'];
};

export type ConversationRatingQuestionType = {
  readonly __typename?: 'ConversationRatingQuestionType';
  readonly answerType: ResidentialManagementConversationRatingQuestionAnswerTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly order: Scalars['Int']['output'];
  readonly questionText: Scalars['String']['output'];
};

export type ConversationRatingType = {
  readonly __typename?: 'ConversationRatingType';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly answers: ReadonlyArray<ConversationRatingAnswerType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly displayStyle?: Maybe<ResidentialManagementConversationRatingDisplayStyleChoices>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly promptText: Scalars['String']['output'];
  readonly rating: Scalars['Int']['output'];
  readonly surface?: Maybe<ResidentialManagementConversationRatingSurfaceChoices>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationReportingBlockTagNode = {
  readonly __typename?: 'ConversationReportingBlockTagNode';
  readonly blockId: Scalars['UUID']['output'];
  readonly blockLabel: Scalars['String']['output'];
  readonly count: Scalars['Int']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

/** An enumeration. */
export enum ConversationReportingChannel {
  Ark = 'ARK',
  Email = 'EMAIL'
}

export type ConversationReportingChannelCountNode = {
  readonly __typename?: 'ConversationReportingChannelCountNode';
  readonly channel: ConversationReportingChannel;
  readonly count: Scalars['Int']['output'];
};

export type ConversationReportingCountNode = {
  readonly __typename?: 'ConversationReportingCountNode';
  readonly byDay: ReadonlyArray<ConversationReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type ConversationReportingDayCountNode = {
  readonly __typename?: 'ConversationReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type ConversationReportingDayDurationNode = {
  readonly __typename?: 'ConversationReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type ConversationReportingDurationNode = {
  readonly __typename?: 'ConversationReportingDurationNode';
  readonly byDay: ReadonlyArray<ConversationReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type ConversationReportingHourCountNode = {
  readonly __typename?: 'ConversationReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type ConversationReportingMonthRatingNode = {
  readonly __typename?: 'ConversationReportingMonthRatingNode';
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly month: Scalars['Date']['output'];
  readonly ratedCount: Scalars['Int']['output'];
};

export type ConversationReportingNode = {
  readonly __typename?: 'ConversationReportingNode';
  readonly blockTags: ReadonlyArray<ConversationReportingBlockTagNode>;
  readonly byChannel: ReadonlyArray<ConversationReportingChannelCountNode>;
  readonly bySenderCategory: ReadonlyArray<ConversationReportingSenderCategoryCountNode>;
  readonly closed: ConversationReportingCountNode;
  readonly firstResponse: ConversationReportingDurationNode;
  readonly openConversations: ConversationReportingOpenNode;
  readonly opened: ConversationReportingCountNode;
  readonly openedPattern: ReadonlyArray<ConversationReportingHourCountNode>;
  readonly ratedShare?: Maybe<Scalars['Float']['output']>;
  readonly reopened: ConversationReportingCountNode;
  readonly resolutionTime: ConversationReportingDurationNode;
  readonly responseTime: ConversationReportingDurationNode;
  readonly satisfaction: ConversationReportingSatisfactionNode;
  readonly satisfactionByMonth: ReadonlyArray<ConversationReportingMonthRatingNode>;
  readonly satisfactionByTopic: ReadonlyArray<ConversationReportingTopicSatisfactionNode>;
  readonly tagUseTotal: Scalars['Int']['output'];
  readonly topicComparison: ReadonlyArray<ConversationReportingTopicComparisonNode>;
  readonly topics: ReadonlyArray<ConversationReportingTopicNode>;
};

export type ConversationReportingOpenNode = {
  readonly __typename?: 'ConversationReportingOpenNode';
  readonly atEnd?: Maybe<ConversationReportingDayCountNode>;
  readonly byDay: ReadonlyArray<ConversationReportingDayCountNode>;
};

export type ConversationReportingSatisfactionNode = {
  readonly __typename?: 'ConversationReportingSatisfactionNode';
  readonly byStar: ReadonlyArray<ConversationReportingStarCountNode>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly ratedCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum ConversationReportingSenderCategory {
  Contractor = 'CONTRACTOR',
  Internal = 'INTERNAL',
  Leaseholder = 'LEASEHOLDER',
  Resident = 'RESIDENT',
  Unknown = 'UNKNOWN'
}

export type ConversationReportingSenderCategoryCountNode = {
  readonly __typename?: 'ConversationReportingSenderCategoryCountNode';
  readonly count: Scalars['Int']['output'];
  readonly senderCategory: ConversationReportingSenderCategory;
};

export type ConversationReportingStarCountNode = {
  readonly __typename?: 'ConversationReportingStarCountNode';
  readonly count: Scalars['Int']['output'];
  readonly stars: Scalars['Int']['output'];
};

export type ConversationReportingTopicComparisonNode = {
  readonly __typename?: 'ConversationReportingTopicComparisonNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
  readonly yearAverage?: Maybe<Scalars['Float']['output']>;
};

export type ConversationReportingTopicNode = {
  readonly __typename?: 'ConversationReportingTopicNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type ConversationReportingTopicSatisfactionNode = {
  readonly __typename?: 'ConversationReportingTopicSatisfactionNode';
  readonly conversationCount: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly meanRating: Scalars['Float']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

/** An enumeration. */
export enum ConversationRole {
  Concierge = 'Concierge',
  Leaseholder = 'Leaseholder',
  Manager = 'Manager',
  Resident = 'Resident'
}

export type ConversationStatusType = {
  readonly __typename?: 'ConversationStatusType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ConversationSummaryNode = {
  readonly __typename?: 'ConversationSummaryNode';
  readonly conversation: ConversationNode;
  readonly editedBy?: Maybe<UserType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message: ConversationMessageType;
  readonly summary: Scalars['String']['output'];
};

export type ConversationSummaryNodeConnection = {
  readonly __typename?: 'ConversationSummaryNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationSummaryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationSummaryNode` and its cursor. */
export type ConversationSummaryNodeEdge = {
  readonly __typename?: 'ConversationSummaryNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationSummaryNode>;
};

export type ConversationTagNode = {
  readonly __typename?: 'ConversationTagNode';
  readonly client: ClientType;
  readonly color?: Maybe<Scalars['String']['output']>;
  readonly conversations: ConversationNodeConnection;
  readonly deletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSelected?: Maybe<Scalars['Boolean']['output']>;
  readonly name: Scalars['String']['output'];
  readonly suggested?: Maybe<Scalars['Boolean']['output']>;
};


export type ConversationTagNodeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ConversationTagNodeConnection = {
  readonly __typename?: 'ConversationTagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ConversationTagNode` and its cursor. */
export type ConversationTagNodeEdge = {
  readonly __typename?: 'ConversationTagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagNode>;
};

export type ConversationTagSuggestionNode = {
  readonly __typename?: 'ConversationTagSuggestionNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly tag: ConversationTagNode;
};

export type ConversationTagSuggestionNodeConnection = {
  readonly __typename?: 'ConversationTagSuggestionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ConversationTagSuggestionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `ConversationTagSuggestionNode` and its cursor. */
export type ConversationTagSuggestionNodeEdge = {
  readonly __typename?: 'ConversationTagSuggestionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ConversationTagSuggestionNode>;
};

export type ConversationUrgencyType = {
  readonly __typename?: 'ConversationUrgencyType';
  readonly conversation: ConversationNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly urgency?: Maybe<Scalars['String']['output']>;
};

export type CorrectInspectionSeriesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly complianceType: Compliance_Type;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CorrectInspectionSeriesPayload = {
  readonly __typename?: 'CorrectInspectionSeriesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CountersignAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CountersignAgreementPayload = {
  readonly __typename?: 'CountersignAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type CreateAgreementForTenancyInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly residency?: InputMaybe<Scalars['String']['input']>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAgreementForTenancyPayload = {
  readonly __typename?: 'CreateAgreementForTenancyPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly residency?: Maybe<Scalars['String']['output']>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type CreateAmenityReservationMutationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly timeSlots: ReadonlyArray<InputMaybe<Scalars['DateTime']['input']>>;
};

export type CreateAmenityReservationMutationPayload = {
  readonly __typename?: 'CreateAmenityReservationMutationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicantAndApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly home: Scalars['UUID']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly ownershipType: Scalars['String']['input'];
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicantAndApplicationPayload = {
  readonly __typename?: 'CreateApplicantAndApplicationPayload';
  readonly applicant?: Maybe<ApplicantNode>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly addressLine2?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isResident?: InputMaybe<Scalars['Boolean']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly moveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly ownershipType?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly region?: InputMaybe<Scalars['String']['input']>;
  readonly townOrCity?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationPayload = {
  readonly __typename?: 'CreateApplicationPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly addressLine2?: Maybe<Scalars['String']['output']>;
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly isResident?: Maybe<Scalars['Boolean']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly moveInDate?: Maybe<Scalars['Date']['output']>;
  readonly ownershipType?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
  readonly region?: Maybe<Scalars['String']['output']>;
  readonly townOrCity?: Maybe<Scalars['String']['output']>;
};

export type CreateApplicationThreadMutationInput = {
  readonly applicationId: Scalars['UUID']['input'];
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateApplicationThreadMutationPayload = {
  readonly __typename?: 'CreateApplicationThreadMutationPayload';
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnHomePayload = {
  readonly __typename?: 'CreateAttachmentOnHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateAttachmentOnRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requirementItemId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAttachmentOnRequirementItemPayload = {
  readonly __typename?: 'CreateAttachmentOnRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly requirementItemId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlockComplianceRequirementItemInput = {
  readonly blockComplianceRequirements: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate: Scalars['Date']['input'];
};

export type CreateBlockComplianceRequirementItemPayload = {
  readonly __typename?: 'CreateBlockComplianceRequirementItemPayload';
  readonly blockComplianceRequirementItem?: Maybe<BlockComplianceRequirementItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateBlocks = {
  readonly __typename?: 'CreateBlocks';
  readonly blocks?: Maybe<ReadonlyArray<Maybe<BlockNode>>>;
};

export type CreateBlocksComplianceRequirementInput = {
  readonly blocks: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly shared: Scalars['Boolean']['input'];
};

export type CreateBlocksComplianceRequirementPayload = {
  readonly __typename?: 'CreateBlocksComplianceRequirementPayload';
  readonly blocksComplianceRequirement?: Maybe<BlocksComplianceRequirementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateChecklistFromTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['String']['input'];
  readonly templateId: Scalars['String']['input'];
};

export type CreateChecklistFromTemplatePayload = {
  readonly __typename?: 'CreateChecklistFromTemplatePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateChecklistInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly task: Scalars['String']['input'];
};

export type CreateChecklistItemCommentInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly item: Scalars['String']['input'];
};

export type CreateChecklistItemCommentPayload = {
  readonly __typename?: 'CreateChecklistItemCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItemComment?: Maybe<TaskChecklistItemCommentNode>;
};

export type CreateChecklistItemMediaInput = {
  readonly checklistItem: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly response?: InputMaybe<Scalars['String']['input']>;
};

export type CreateChecklistItemMediaPayload = {
  readonly __typename?: 'CreateChecklistItemMediaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItemMedia?: Maybe<TaskChecklistItemMediaNode>;
};

export type CreateChecklistPayload = {
  readonly __typename?: 'CreateChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklist?: Maybe<TaskChecklistNode>;
};

export type CreateChecklistWithStructureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly kind?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sections: ReadonlyArray<ChecklistSectionInput>;
  readonly taskId: Scalars['UUID']['input'];
};

export type CreateChecklistWithStructurePayload = {
  readonly __typename?: 'CreateChecklistWithStructurePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type CreateCheckoutLinkInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly subscription: Scalars['UUID']['input'];
};

export type CreateCheckoutLinkPayload = {
  readonly __typename?: 'CreateCheckoutLinkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly url: Scalars['String']['output'];
};

export type CreateClientContractorCompanyInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateClientContractorCompanyPayload = {
  readonly __typename?: 'CreateClientContractorCompanyPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateClientTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type CreateClientTagPayload = {
  readonly __typename?: 'CreateClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentPayload = {
  readonly __typename?: 'CreateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentReminderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentReminderPayload = {
  readonly __typename?: 'CreateCommunityDocumentReminderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocumentReminder?: Maybe<CommunityDocumentReminderNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityDocumentTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly objectId: Scalars['String']['input'];
};

export type CreateCommunityDocumentTagPayload = {
  readonly __typename?: 'CreateCommunityDocumentTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type CreateCommunityDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityDocumentViewPayload = {
  readonly __typename?: 'CreateCommunityDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocumentView?: Maybe<CommunityDocumentViewNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateCommunityProductPayload = {
  readonly __typename?: 'CreateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityProductPaymentInput = {
  readonly amount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityProductId: Scalars['UUID']['input'];
};

export type CreateCommunityProductPaymentPayload = {
  readonly __typename?: 'CreateCommunityProductPaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateCommunityTaskDefinitionInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly taskDefinition: Scalars['String']['input'];
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityTaskDefinitionPayload = {
  readonly __typename?: 'CreateCommunityTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityUpdate: Scalars['String']['input'];
};

export type CreateCommunityUpdateReadPayload = {
  readonly __typename?: 'CreateCommunityUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly companyAddress?: InputMaybe<Scalars['String']['input']>;
  readonly companyType?: InputMaybe<Scalars['String']['input']>;
  readonly companyWebsite?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['UUID']['input']>;
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly reasonForVisit?: InputMaybe<Scalars['String']['input']>;
  readonly residentName?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
  readonly vehicleRegistration?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCommunityVisitorPayload = {
  readonly __typename?: 'CreateCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly frequencyText?: InputMaybe<Scalars['String']['input']>;
  readonly homes: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly name: Scalars['String']['input'];
  readonly renewalFrequency?: InputMaybe<Scalars['String']['input']>;
};

export type CreateComplianceRequirementPayload = {
  readonly __typename?: 'CreateComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceRequirements?: Maybe<ReadonlyArray<Maybe<ComplianceRequirementNode>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly frequencyText?: Maybe<Scalars['String']['output']>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly renewalFrequency?: Maybe<Scalars['String']['output']>;
};

export type CreateComplianceUpdateReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly update: Scalars['String']['input'];
};

export type CreateComplianceUpdateReadPayload = {
  readonly __typename?: 'CreateComplianceUpdateReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly update?: Maybe<Scalars['String']['output']>;
};

export type CreateContractorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly phone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContractorPayload = {
  readonly __typename?: 'CreateContractorPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateConversation = {
  readonly __typename?: 'CreateConversation';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationActionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly extra?: InputMaybe<Scalars['JSONString']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly type: Scalars['String']['input'];
};

export type CreateConversationActionPayload = {
  readonly __typename?: 'CreateConversationActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly extra?: Maybe<Scalars['JSONString']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type CreateConversationAndFirstMessage = {
  readonly __typename?: 'CreateConversationAndFirstMessage';
  readonly conversation?: Maybe<ConversationNode>;
};

export type CreateConversationAndFirstMessageInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentInput = {
  readonly assignedTo: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['UUID']['input'];
};

export type CreateConversationAssignmentPayload = {
  readonly __typename?: 'CreateConversationAssignmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationAssignment?: Maybe<ConversationAssignmentNode>;
};

export type CreateConversationInput = {
  readonly category: Scalars['String']['input'];
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly contactId?: InputMaybe<Scalars['UUID']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residentId?: InputMaybe<Scalars['UUID']['input']>;
  readonly subject?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationMessage = {
  readonly __typename?: 'CreateConversationMessage';
  readonly conversation?: Maybe<ConversationNode>;
  readonly message?: Maybe<ConversationMessageType>;
  readonly scheduled?: Maybe<Scalars['Boolean']['output']>;
  readonly scheduledMessageId?: Maybe<Scalars['UUID']['output']>;
};

export type CreateConversationMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly conversationId: Scalars['UUID']['input'];
  readonly reopen?: InputMaybe<Scalars['Boolean']['input']>;
  readonly suggestionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateConversationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text: Scalars['String']['input'];
};

export type CreateConversationNotePayload = {
  readonly __typename?: 'CreateConversationNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationNote?: Maybe<ConversationNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type CreateConversationSummaryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly summary: Scalars['String']['input'];
};

export type CreateConversationSummaryPayload = {
  readonly __typename?: 'CreateConversationSummaryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationSummary?: Maybe<ConversationSummaryNode>;
};

export type CreateConversationTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateConversationTagPayload = {
  readonly __typename?: 'CreateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type CreateFollowUpTaskFromChecklistItemInput = {
  readonly assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFollowUpTaskFromChecklistItemPayload = {
  readonly __typename?: 'CreateFollowUpTaskFromChecklistItemPayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly created: Scalars['Boolean']['output'];
  readonly task?: Maybe<TaskNode>;
};

export type CreateFollowUpTasksFromChecklistItemsInput = {
  readonly assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly itemIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type CreateFollowUpTasksFromChecklistItemsPayload = {
  readonly __typename?: 'CreateFollowUpTasksFromChecklistItemsPayload';
  readonly checklistItems?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly createdCount: Scalars['Int']['output'];
  readonly existingCount: Scalars['Int']['output'];
  readonly tasks?: Maybe<ReadonlyArray<TaskNode>>;
};

export type CreateGroupChatMessageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupChat: Scalars['String']['input'];
  readonly repliedTo?: InputMaybe<Scalars['String']['input']>;
  readonly text?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGroupChatMessagePayload = {
  readonly __typename?: 'CreateGroupChatMessagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
};

export type CreateGroupChatMessageReactionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupChatMessage?: InputMaybe<Scalars['String']['input']>;
  readonly reaction: Scalars['String']['input'];
};

export type CreateGroupChatMessageReactionPayload = {
  readonly __typename?: 'CreateGroupChatMessageReactionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
};

export type CreateGroupChatMessageReportInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly reason: Scalars['String']['input'];
};

export type CreateGroupChatMessageReportPayload = {
  readonly __typename?: 'CreateGroupChatMessageReportPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReport?: Maybe<GroupChatMessageReportNode>;
};

export type CreateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateGroupPayload = {
  readonly __typename?: 'CreateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type CreateKeyV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type CreateKeyV2Payload = {
  readonly __typename?: 'CreateKeyV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type CreateKeyholderV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly key: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateKeyholderV2Payload = {
  readonly __typename?: 'CreateKeyholderV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type CreateManagerConversationReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly unread?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateManagerConversationReadPayload = {
  readonly __typename?: 'CreateManagerConversationReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly unread?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateManagerSafetyDeclarationInput = {
  readonly braille: Scalars['Boolean']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communicationNeedDeclared: Scalars['Boolean']['input'];
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly consent?: InputMaybe<ConsentAttestationInput>;
  readonly contactEmail?: InputMaybe<Scalars['String']['input']>;
  readonly declaredAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly first?: InputMaybe<Scalars['String']['input']>;
  readonly isOccupant: Scalars['Boolean']['input'];
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint: Scalars['Boolean']['input'];
  readonly last?: InputMaybe<Scalars['String']['input']>;
  readonly mobilityNeedDeclared: Scalars['Boolean']['input'];
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly origin: ManagerDeclarationOrigin;
  readonly recordId?: InputMaybe<Scalars['UUID']['input']>;
  readonly residencyId: Scalars['UUID']['input'];
  readonly textToSpeech: Scalars['Boolean']['input'];
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateManagerSafetyDeclarationPayload = {
  readonly __typename?: 'CreateManagerSafetyDeclarationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly declaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type CreateMarketplaceItemCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly item: Scalars['String']['input'];
};

/**
 * Left ungated by Access V2 deliberately.
 *
 * ``MarketplaceItemComment`` has no entry in ``RESOURCE_REGISTRY`` and no row
 * in the role matrix, and none of the three registered marketplace resources
 * describes it. ``marketplace_item`` is the closest, but its ownership policy
 * scopes a resident to listings they own, so gating a public comment on it
 * would deny commenting on anyone else's listing once the rollout flag is on
 * — a regression, not a narrowing. Inventing a ``marketplace_item_comment``
 * resource is out of scope for this pathway, so the legacy
 * ``IsResidentOrLeaseholder`` check stands alone until one is added.
 */
export type CreateMarketplaceItemCommentPayload = {
  readonly __typename?: 'CreateMarketplaceItemCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly item?: Maybe<Scalars['String']['output']>;
};

export type CreateMarketplaceItemThreadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly item: Scalars['UUID']['input'];
  readonly message: Scalars['String']['input'];
};

export type CreateMarketplaceItemThreadPayload = {
  readonly __typename?: 'CreateMarketplaceItemThreadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
};

export type CreateNewDevice = {
  readonly __typename?: 'CreateNewDevice';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateNewDeviceInput = {
  readonly platform?: InputMaybe<Scalars['String']['input']>;
  readonly token: Scalars['String']['input'];
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOccupancySurvey = {
  readonly __typename?: 'CreateOccupancySurvey';
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
};

export type CreateOpenedConversation = {
  readonly __typename?: 'CreateOpenedConversation';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateOpenedConversationInput = {
  readonly conversationId: Scalars['UUID']['input'];
};

export type CreateOrUpdateUserSessionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly sessionTarget: Session_Target;
};

export type CreateOrUpdateUserSessionPayload = {
  readonly __typename?: 'CreateOrUpdateUserSessionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userSession?: Maybe<UserSessionNode>;
};

export type CreatePaymentInput = {
  readonly amount: Scalars['Decimal']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly paymentAccount?: InputMaybe<Scalars['UUID']['input']>;
  readonly paymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePaymentPayload = {
  readonly __typename?: 'CreatePaymentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly payment: PaymentNode;
  readonly stripeClientSecret: Scalars['String']['output'];
};

export type CreateReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly configuration: Scalars['JSONString']['input'];
  readonly favourite: Scalars['Boolean']['input'];
  readonly name: Scalars['String']['input'];
  readonly reportKey: Scalars['String']['input'];
  readonly schemaVersion: Scalars['Int']['input'];
  readonly sourceId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateReportingConfigurationPayload = {
  readonly __typename?: 'CreateReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type CreateResidencyAndResidents = {
  readonly __typename?: 'CreateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
  readonly residency?: Maybe<ResidencyNode>;
};

export type CreateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency: Scalars['String']['input'];
};

export type CreateResidencyDocumentPayload = {
  readonly __typename?: 'CreateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type CreateResidencyDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateResidencyDocumentViewPayload = {
  readonly __typename?: 'CreateResidencyDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocumentView?: Maybe<ResidencyDocumentViewNode>;
};

export type CreateResidencyDocuments = {
  readonly __typename?: 'CreateResidencyDocuments';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateResidencyDocumentsInput = {
  readonly complianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly customComplianceItems?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateResidencySubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly methods?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly residencyId: Scalars['String']['input'];
};

export type CreateResidencySubscriptionPayload = {
  readonly __typename?: 'CreateResidencySubscriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly methods?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly residencyId?: Maybe<Scalars['String']['output']>;
};

export type CreateResidentSafetyRecordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly records: ReadonlyArray<InputMaybe<ResidentSafetyRecordInput>>;
  readonly residencyId: Scalars['UUID']['input'];
};

/**
 * Submit (or re-submit) the household's safety records.
 *
 * Decoupled from consent: this mutation only persists declared needs and
 * audits NEEDS_SUBMITTED / NEEDS_UPDATED / OCCUPANT_REMOVED. Consent is
 * captured via the dedicated GiveSafetyConsent / DeclineSafetyConsent
 * mutations called separately from the resident app.
 */
export type CreateResidentSafetyRecordPayload = {
  readonly __typename?: 'CreateResidentSafetyRecordPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residentSafetyRecords?: Maybe<ReadonlyArray<Maybe<ResidentSafetyRecordNode>>>;
};

export type CreateRuleActionInput = {
  readonly action: Action;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly objectId: Scalars['String']['input'];
  readonly rule: Scalars['String']['input'];
};

export type CreateRuleActionPayload = {
  readonly __typename?: 'CreateRuleActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleAction?: Maybe<RuleActionNode>;
};

export type CreateRuleConditions = {
  readonly __typename?: 'CreateRuleConditions';
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleConditions?: Maybe<ReadonlyArray<Maybe<RuleConditionNode>>>;
};

export type CreateRuleConditionsInput = {
  readonly event: Scalars['String']['input'];
  readonly objectIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly operator: Scalars['String']['input'];
  readonly ruleId: Scalars['UUID']['input'];
};

export type CreateRuleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type CreateRulePayload = {
  readonly __typename?: 'CreateRulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type CreateSafetyCenterDocumentInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  readonly showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sibCategory?: InputMaybe<Sib_Category>;
  readonly sourceDocument?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type CreateSafetyCenterDocumentPayload = {
  readonly __typename?: 'CreateSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type CreateScheduledMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly sendAt: Scalars['DateTime']['input'];
  readonly sender: Sender;
};

export type CreateScheduledMessagePayload = {
  readonly __typename?: 'CreateScheduledMessagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly scheduledMessage?: Maybe<ScheduledMessageType>;
  readonly scheduledMessageId?: Maybe<Scalars['UUID']['output']>;
};

export type CreateStripeAccount = {
  readonly __typename?: 'CreateStripeAccount';
  readonly client?: Maybe<ClientType>;
};

export type CreateSurveyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly options?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly question: Scalars['String']['input'];
};

export type CreateSurveyPayload = {
  readonly __typename?: 'CreateSurveyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly question?: Maybe<Scalars['String']['output']>;
};

export type CreateTaskDefinitionInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskDefinitionPayload = {
  readonly __typename?: 'CreateTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type CreateTaskDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityDocument?: InputMaybe<Scalars['String']['input']>;
  readonly task?: InputMaybe<Scalars['String']['input']>;
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type CreateTaskDocumentPayload = {
  readonly __typename?: 'CreateTaskDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDocument?: Maybe<TaskDocumentNode>;
};

export type CreateTaskFromConversationInput = {
  readonly addAsWatcher?: InputMaybe<Scalars['Boolean']['input']>;
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskFromConversationPayload = {
  readonly __typename?: 'CreateTaskFromConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type CreateTaskGroupInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly generationHorizonDays?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly schedule: Scalars['JSONString']['input'];
  readonly startDate: Scalars['Date']['input'];
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CreateTaskGroupPayload = {
  readonly __typename?: 'CreateTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly tasksCreatedCount?: Maybe<Scalars['Int']['output']>;
};

export type CreateTaskInput = {
  readonly assignedTeamId?: InputMaybe<Scalars['UUID']['input']>;
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['Date']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type CreateTaskPayload = {
  readonly __typename?: 'CreateTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type CreateTaskTemplateInput = {
  readonly autoCompleteTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityIds?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly pdfExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
  readonly scope?: InputMaybe<Scalars['String']['input']>;
  readonly sections?: InputMaybe<ReadonlyArray<TaskTemplateSectionInput>>;
};

export type CreateTaskTemplatePayload = {
  readonly __typename?: 'CreateTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type CreateTeamInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTeamPayload = {
  readonly __typename?: 'CreateTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type CreateTemplateFromChecklistInput = {
  readonly checklistId: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTemplateFromChecklistPayload = {
  readonly __typename?: 'CreateTemplateFromChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type CreateTenancyApplicationInput = {
  readonly applicants?: InputMaybe<ReadonlyArray<InputMaybe<Applicants>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
};

export type CreateTenancyApplicationPayload = {
  readonly __typename?: 'CreateTenancyApplicationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type CreateUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment: Scalars['String']['input'];
  readonly updateId: Scalars['UUID']['input'];
  readonly userType: Scalars['String']['input'];
};

export type CreateUpdateCommentPayload = {
  readonly __typename?: 'CreateUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdateComment?: Maybe<CommunityUpdateCommentNode>;
};

export type CreateUserDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly users: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type CreateUserDocumentPayload = {
  readonly __typename?: 'CreateUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocument?: Maybe<UserDocumentNode>;
};

export type CreateUserDocumentTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly objectId: Scalars['String']['input'];
};

export type CreateUserDocumentTagPayload = {
  readonly __typename?: 'CreateUserDocumentTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tag?: Maybe<TagNode>;
};

export type CreateUserDocumentViewInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserDocumentViewPayload = {
  readonly __typename?: 'CreateUserDocumentViewPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocumentView?: Maybe<UserDocumentViewNode>;
};

export type CreditCheckNode = {
  readonly __typename?: 'CreditCheckNode';
  readonly activeBankruptcies: Scalars['Int']['output'];
  readonly activeCountyCourtJudgements: Scalars['Int']['output'];
  readonly aliases: ReadonlyArray<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly riskLevel?: Maybe<Scalars['String']['output']>;
  readonly score: Scalars['Int']['output'];
  readonly totalBankruptcies: Scalars['Int']['output'];
  readonly totalCountyCourtJudgements: Scalars['Int']['output'];
};

export type DeactivateClientUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type DeactivateClientUserPayload = {
  readonly __typename?: 'DeactivateClientUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type DeactivateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeactivateGroupPayload = {
  readonly __typename?: 'DeactivateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DebugSchema = {
  readonly __typename?: 'DebugSchema';
  readonly _debug?: Maybe<DjangoDebug>;
  readonly accountTransactions?: Maybe<AccountTransactionNodeConnection>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly agreements?: Maybe<GeneratedAgreementNodeConnection>;
  readonly amenities?: Maybe<AmenityNodeConnection>;
  readonly amenity?: Maybe<AmenityNode>;
  readonly amenityOperatingTime?: Maybe<AmenityOperatingTimesNode>;
  readonly amenityOperatingTimes?: Maybe<AmenityOperatingTimesNodeConnection>;
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly amenityReservations?: Maybe<AmenityReservationNodeConnection>;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly application?: Maybe<ApplicationNode>;
  readonly applicationDecisionStats?: Maybe<ApplicationDecisionStatsType>;
  readonly applicationSupportThreadByApplication?: Maybe<ApplicationSupportThreadNode>;
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly applicationThreadByApplication?: Maybe<ApplicationThreadNode>;
  readonly applicationThreadMedia?: Maybe<ApplicationThreadMediaNodeConnection>;
  readonly applicationThreadMessages?: Maybe<ApplicationThreadMessageNodeConnection>;
  readonly applications?: Maybe<ApplicationNodeConnection>;
  readonly asanaPendingTasks?: Maybe<AsanaPendingTaskNodeConnection>;
  readonly asanaPendingTasksCount: Scalars['Int']['output'];
  readonly block?: Maybe<BlockNode>;
  readonly blockComplianceRequirement?: Maybe<BlockComplianceRequirementNode>;
  readonly blockComplianceRequirements?: Maybe<BlockComplianceRequirementNodeConnection>;
  readonly blocks?: Maybe<BlockNodeConnection>;
  readonly budget?: Maybe<BudgetNode>;
  readonly budgets?: Maybe<BudgetNodeConnection>;
  readonly bulkConversationActionJob?: Maybe<BulkConversationActionJobNode>;
  readonly bulkDeactivationJob?: Maybe<BulkDeactivationJobNode>;
  readonly checklistActionSource?: Maybe<ChecklistActionSourceNode>;
  readonly clientContractorCompanies?: Maybe<ClientContractorCompanyNodeConnection>;
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientStaffDirectory: ReadonlyArray<ClientStaffDirectoryMemberType>;
  readonly clientStaffMembers?: Maybe<ClientStaffMemberNodeConnection>;
  readonly clientTag?: Maybe<ClientTagNode>;
  readonly clientTags?: Maybe<ClientTagNodeConnection>;
  readonly clientUser?: Maybe<ClientUserNode>;
  readonly clientUserById?: Maybe<ClientUserNode>;
  readonly clientUsers?: Maybe<ClientUserNodeConnection>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly communityDocumentReminders?: Maybe<CommunityDocumentReminderNodeConnection>;
  readonly communityDocuments?: Maybe<CommunityDocumentNodeConnection>;
  readonly communityEvent?: Maybe<CommunityEventNode>;
  readonly communityEventParties?: Maybe<CommunityEventPartyNodeConnection>;
  readonly communityEventParty?: Maybe<CommunityEventPartyNode>;
  readonly communityEvents?: Maybe<CommunityEventNodeConnection>;
  readonly communityForm?: Maybe<CommunityFormNode>;
  readonly communityForms?: Maybe<CommunityFormNodeConnection>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  readonly communityGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly communityGroupsAll?: Maybe<CommunityGroupNodeConnection>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  readonly communityProductPurchases?: Maybe<CommunityProductPurchaseNodeConnection>;
  readonly communityProducts?: Maybe<CommunityProductNodeConnection>;
  readonly communityStaffCandidates: ReadonlyArray<CommunityStaffCandidateType>;
  readonly communityStaffRoles: ReadonlyArray<CommunityStaffRoleType>;
  readonly communityTask?: Maybe<CommunityTaskNode>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  readonly communityTaskDefinitions?: Maybe<CommunityTaskDefinitionNodeConnection>;
  readonly communityTasks?: Maybe<CommunityTaskNodeConnection>;
  readonly communityTeamMembersBulk?: Maybe<ReadonlyArray<CommunityTeamMembersGroupType>>;
  readonly communityUpdate?: Maybe<CommunityUpdateNode>;
  readonly communityUpdates?: Maybe<CommunityUpdateNodeConnection>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  readonly communityVisitors?: Maybe<CommunityVisitorNodeConnection>;
  readonly complianceRequirement?: Maybe<ComplianceRequirementNode>;
  readonly complianceRequirements?: Maybe<ComplianceRequirementNodeConnection>;
  readonly contact?: Maybe<ContactNode>;
  readonly contactNote?: Maybe<ContactNoteNode>;
  readonly contactNotes?: Maybe<ContactNoteNodeConnection>;
  readonly contacts?: Maybe<ContactNodeConnection>;
  readonly conversation?: Maybe<ConversationNode>;
  readonly conversationCounts?: Maybe<ConversationCountsNode>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
  readonly conversationTags?: Maybe<ConversationTagNodeConnection>;
  readonly conversations?: Maybe<ConversationNodeConnection>;
  readonly dashboard?: Maybe<CommunityDashboardType>;
  readonly document?: Maybe<DocumentNode>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  readonly documentExtractions?: Maybe<DocumentExtractionNodeConnection>;
  readonly documents?: Maybe<DocumentNodeConnection>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly featureAnnouncement?: Maybe<FeatureAnnouncementNode>;
  readonly featureAnnouncementBySlug?: Maybe<FeatureAnnouncementNode>;
  readonly featureAnnouncements?: Maybe<FeatureAnnouncementNodeConnection>;
  readonly findComplianceUpdate?: Maybe<ComplianceUpdateType>;
  readonly findHome?: Maybe<HomeType>;
  readonly findSection21?: Maybe<GeneratedSection21Type>;
  readonly findTenancyAgreement?: Maybe<GeneratedAgreementType>;
  readonly getClient?: Maybe<ClientType>;
  readonly getClientAdmin?: Maybe<ClientAdminNode>;
  readonly getFixfloIssue?: Maybe<FixfloIssueType>;
  readonly getLandlord?: Maybe<LandlordNode>;
  readonly getLeaseholder?: Maybe<LeaseholderNode>;
  readonly getManager?: Maybe<ManagerType>;
  readonly getMe?: Maybe<ResidentType>;
  readonly getUser?: Maybe<UserType>;
  readonly globalFeatures?: Maybe<ReadonlyArray<Maybe<GlobalFeatureType>>>;
  readonly groupChat?: Maybe<GroupChatNode>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
  readonly groupChatMessageReactions?: Maybe<GroupChatMessageReactionNodeConnection>;
  readonly groupChatMessageReport?: Maybe<GroupChatMessageReportNode>;
  readonly groupChatMessageReports?: Maybe<GroupChatMessageReportNodeConnection>;
  readonly groupChatMessages?: Maybe<GroupChatMessageNodeConnection>;
  readonly groupChats?: Maybe<GroupChatNodeConnection>;
  readonly home?: Maybe<HomeNode>;
  readonly homes?: Maybe<HomeNodeConnection>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly invoices?: Maybe<InvoiceNodeConnection>;
  readonly key?: Maybe<KeyNode>;
  readonly keyholder?: Maybe<KeyholderNode>;
  readonly keyholders?: Maybe<KeyholderNodeConnection>;
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly landlordAttachment?: Maybe<LandlordAttachmentNode>;
  readonly landlordDocuments?: Maybe<ReadonlyArray<Maybe<LandlordDocumentNode>>>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly leanNotifications?: Maybe<LeanNotificationNodeConnection>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly leaseholdSchedule?: Maybe<LeaseholdScheduleNode>;
  readonly leaseholdSchedules?: Maybe<LeaseholdScheduleNodeConnection>;
  readonly leaseholds?: Maybe<LeaseholdNodeConnection>;
  readonly legacySafetyCenterDocument?: Maybe<PublicSafetyCenterDocumentType>;
  readonly legacySafetyPack?: Maybe<PublicSafetyPackType>;
  readonly listComplianceUpdates?: Maybe<ReadonlyArray<ComplianceUpdateType>>;
  readonly listHomes?: Maybe<ReadonlyArray<HomeType>>;
  readonly listResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
  readonly marketplaceItemThreadMessage?: Maybe<MarketplaceItemThreadMessageNode>;
  readonly marketplaceItemThreadMessages?: Maybe<MarketplaceItemThreadMessageNodeConnection>;
  readonly marketplaceItemThreads?: Maybe<MarketplaceItemThreadNodeConnection>;
  readonly marketplaceItems?: Maybe<MarketplaceItemNodeConnection>;
  readonly myOpenSafetyReviewRequests: ReadonlyArray<SafetyReviewRequestNode>;
  readonly notification?: Maybe<NotificationNode>;
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly occupancySurvey?: Maybe<OccupancySurveyNode>;
  readonly occupancySurveys?: Maybe<OccupancySurveyNodeConnection>;
  readonly package?: Maybe<PackageNode>;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly packagesExport?: Maybe<Scalars['String']['output']>;
  readonly payment?: Maybe<PaymentNode>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentAccounts?: Maybe<PaymentAccountNodeConnection>;
  readonly productCosts?: Maybe<ProductCosts>;
  readonly profile?: Maybe<ProfileType>;
  readonly publicSafetyCenterDocument?: Maybe<PublicSafetyCenterDocumentType>;
  readonly publicSafetyPack?: Maybe<PublicSafetyPackType>;
  readonly ratingPromptConversation?: Maybe<ConversationNode>;
  readonly reportingApplications: ApplicationReportingNode;
  readonly reportingBookings: BookingReportingNode;
  readonly reportingConfiguration?: Maybe<ReportingConfigurationNode>;
  readonly reportingConfigurations: ReadonlyArray<ReportingConfigurationNode>;
  readonly reportingConversations: ConversationReportingNode;
  readonly reportingDocuments: DocumentReportingNode;
  readonly reportingKeys: KeyReportingNode;
  readonly reportingPackages: PackageReportingNode;
  readonly reportingPortfolioEngagement: PortfolioEngagementReportingNode;
  readonly reportingPortfolioMaintenance: PortfolioMaintenanceReportingNode;
  readonly reportingPortfolioSatisfaction: PortfolioSatisfactionReportingNode;
  readonly reportingTeamActivity: TeamActivityReportingNode;
  readonly reportingTeamApplications: TeamApplicationReportingNode;
  readonly reportingTeamConversations: TeamConversationReportingNode;
  readonly reportingTeamDocuments: TeamDocumentReportingNode;
  readonly reportingTeamMembers: ReadonlyArray<TeamRosterMemberNode>;
  readonly reportingTeamUpdates: TeamUpdateReportingNode;
  readonly reportingUpdates: UpdateReportingNode;
  readonly reportingVisits: VisitReportingNode;
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentNode>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyDeclarations?: Maybe<ResidentSafetyDeclarationNodeConnection>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly residentSafetyRecords?: Maybe<ResidentSafetyRecordNodeConnection>;
  readonly residentTask?: Maybe<ResidentTaskNode>;
  readonly residentTasks?: Maybe<ResidentTaskNodeConnection>;
  readonly residents?: Maybe<ResidentNodeConnection>;
  readonly rule?: Maybe<RuleNode>;
  readonly rules?: Maybe<RuleNodeConnection>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
  readonly safetyCenterDocuments?: Maybe<SafetyCenterDocumentNodeConnection>;
  readonly safetyHousehold?: Maybe<SafetyHouseholdType>;
  readonly safetyPortfolio: ReadonlyArray<SafetyCommunityReadinessType>;
  readonly safetyReadiness: ReadonlyArray<SafetyBlockReadinessType>;
  readonly safetyRoster?: Maybe<SafetyRosterType>;
  readonly schedule?: Maybe<ScheduleNode>;
  readonly scheduleFinancialYear?: Maybe<ScheduleFinancialYearNode>;
  readonly scheduleFinancialYearCategoryTotal?: Maybe<ScheduleFinancialYearCategoryTotalNode>;
  readonly scheduleFinancialYearCategoryTotals?: Maybe<ScheduleFinancialYearCategoryTotalNodeConnection>;
  readonly scheduleFinancialYears?: Maybe<ScheduleFinancialYearNodeConnection>;
  readonly schedules?: Maybe<ScheduleNodeConnection>;
  readonly searchAsanaTasks?: Maybe<ReadonlyArray<Maybe<AsanaTaskSearchResultType>>>;
  readonly searchEpc?: Maybe<ReadonlyArray<EpcResponseType>>;
  readonly section21?: Maybe<GeneratedSection21Node>;
  readonly signature?: Maybe<AgreementSignatureNode>;
  readonly staffRoleCatalog: ReadonlyArray<StaffRoleCatalogType>;
  readonly survey?: Maybe<ResidentSurveyNode>;
  readonly surveys?: Maybe<ResidentSurveyNodeConnection>;
  readonly tag?: Maybe<TagNode>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly task?: Maybe<TaskNode>;
  readonly taskCategories?: Maybe<TaskCategoryNodeConnection>;
  readonly taskCategory?: Maybe<TaskCategoryNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
  readonly taskDefinitions?: Maybe<TaskDefinitionNodeConnection>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly taskGroups?: Maybe<TaskGroupNodeConnection>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
  readonly taskTemplates?: Maybe<TaskTemplateNodeConnection>;
  readonly tasks?: Maybe<TaskNodeConnection>;
  readonly team?: Maybe<TeamNode>;
  readonly teams?: Maybe<TeamNodeConnection>;
  readonly tenancyApplicant?: Maybe<TenancyApplicantNode>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
  readonly tenancyApplications?: Maybe<TenancyApplicationNodeConnection>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly tenantReferences?: Maybe<TenantReferenceNodeConnection>;
  readonly userFeatureAnnouncements?: Maybe<UserFeatureAnnouncementNodeConnection>;
  readonly userNotificationPreference?: Maybe<UserNotificationPreferenceNode>;
  readonly userNotificationPreferences?: Maybe<UserNotificationPreferenceNodeConnection>;
  readonly userSession?: Maybe<UserSessionNode>;
  readonly userSessions?: Maybe<UserSessionNodeConnection>;
  readonly waiver?: Maybe<WaiverNode>;
  readonly waivers?: Maybe<WaiverNodeConnection>;
};


export type DebugSchemaAccountTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaAmenitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isLive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAmenityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityOperatingTimeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityOperatingTimesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaAmenityReservationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaAmenityReservationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amenity?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicantArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationDecisionStatsArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
};


export type DebugSchemaApplicationSupportThreadByApplicationArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type DebugSchemaApplicationThreadArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaApplicationThreadByApplicationArgs = {
  applicationId: Scalars['UUID']['input'];
};


export type DebugSchemaApplicationThreadMediaArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaApplicationThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAsanaPendingTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaAsanaPendingTasksCountArgs = {
  communityIds: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};


export type DebugSchemaBlockArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBlockComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaBlocksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRequirements?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaBudgetArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBudgetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaBulkConversationActionJobArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaBulkDeactivationJobArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaChecklistActionSourceArgs = {
  actionId: Scalars['UUID']['input'];
};


export type DebugSchemaClientContractorCompaniesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientContractorCompanyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaClientStaffDirectoryArgs = {
  clientId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientStaffMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  excludeTeams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaClientTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaClientUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaClientUserByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaClientUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  excludeCommunities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityDocumentRemindersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaCommunityDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityEventArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityEventPartiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
  event_Start?: InputMaybe<Scalars['DateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityEventPartyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  endDateAfter?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  partyUsers?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityFormArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityFormsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityGroupArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityGroupsAllArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityProductArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityProductPurchasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaCommunityProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityStaffCandidatesArgs = {
  communityId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaCommunityStaffRolesArgs = {
  communityId: Scalars['UUID']['input'];
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaCommunityTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTaskDefinitionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
  taskGroup?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaCommunityTeamMembersBulkArgs = {
  communityIds: ReadonlyArray<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groups?: InputMaybe<Scalars['UUID']['input']>;
  hasLinkedFeature?: InputMaybe<Scalars['Boolean']['input']>;
  isPublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userBookmarked?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaCommunityVisitorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  onSite?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  signedOut?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaComplianceRequirementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaContactArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaContactNoteArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaContactNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  allowApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaConversationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationCountsArgs = {
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaConversationTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaConversationTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<ConversationRole>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaDashboardArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
};


export type DebugSchemaDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaDocumentExtractionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaDocumentExtractionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  complianceTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  tags2?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaEmployerReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFeatureAnnouncementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFeatureAnnouncementBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type DebugSchemaFeatureAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaFindComplianceUpdateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaFindTenancyAgreementArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGetFixfloIssueArgs = {
  communityId: Scalars['UUID']['input'];
  issueRef: Scalars['String']['input'];
};


export type DebugSchemaGroupChatArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReactionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatMessageReportArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaGroupChatMessageReportsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupChat?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaGroupChatsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaHomeArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaHomesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  includeDemoHomes?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  missingFloor?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  packagesStatus?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  trigramSearch?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaInvoiceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaInvoicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isCredit?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaKeyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholderArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaLandlordAttachmentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordDocumentsArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLandlordReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeanNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaLeaseholdArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaLegacySafetyCenterDocumentArgs = {
  communityId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
};


export type DebugSchemaLegacySafetyPackArgs = {
  communityId: Scalars['UUID']['input'];
};


export type DebugSchemaListComplianceUpdatesArgs = {
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaListHomesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaListResidenciesArgs = {
  communityId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadMessageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaMarketplaceItemThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaMarketplaceItemThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaMarketplaceItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isClosed?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaOccupancySurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackageArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPackagesExportArgs = {
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaPaymentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaPaymentAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communityActive?: InputMaybe<Scalars['Boolean']['input']>;
  communityPaymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaPublicSafetyCenterDocumentArgs = {
  id: Scalars['UUID']['input'];
  token: Scalars['UUID']['input'];
};


export type DebugSchemaPublicSafetyPackArgs = {
  token: Scalars['UUID']['input'];
};


export type DebugSchemaRatingPromptConversationArgs = {
  surface: RatingPromptSurface;
};


export type DebugSchemaReportingApplicationsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingBookingsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingConfigurationArgs = {
  id: Scalars['UUID']['input'];
};


export type DebugSchemaReportingConversationsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  tags?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingDocumentsArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  tags?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingKeysArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPackagesArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioEngagementArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioMaintenanceArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingPortfolioSatisfactionArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingTeamActivityArgs = {
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamApplicationsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamConversationsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamDocumentsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingTeamUpdatesArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
};


export type DebugSchemaReportingUpdatesArgs = {
  blocks?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']>>;
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
};


export type DebugSchemaReportingVisitsArgs = {
  communities: ReadonlyArray<Scalars['UUID']['input']>;
  period: ReportingPeriodInput;
  visitorTypes?: InputMaybe<ReadonlyArray<VisitReportingVisitorType>>;
};


export type DebugSchemaResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  referenceSent?: InputMaybe<Scalars['Boolean']['input']>;
  stage?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type DebugSchemaResidencyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyDeclarationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyDeclarationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyRecordArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaResidentTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaResidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  notDownloaded?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  scanData?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  withRating?: InputMaybe<Scalars['Boolean']['input']>;
};


export type DebugSchemaRuleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaSafetyCenterDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSafetyCenterDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  communityWide?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forBlock?: InputMaybe<Scalars['UUID']['input']>;
  includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  sibCategory?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaSafetyHouseholdArgs = {
  residencyId: Scalars['UUID']['input'];
};


export type DebugSchemaSafetyPortfolioArgs = {
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};


export type DebugSchemaSafetyReadinessArgs = {
  community: Scalars['UUID']['input'];
};


export type DebugSchemaSafetyRosterArgs = {
  block?: InputMaybe<Scalars['UUID']['input']>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  cohort?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  eesStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  issue?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  pcfraStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearCategoryTotalArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaScheduleFinancialYearCategoryTotalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaScheduleFinancialYearsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaSearchAsanaTasksArgs = {
  communityId: Scalars['UUID']['input'];
  query: Scalars['String']['input'];
};


export type DebugSchemaSearchEpcArgs = {
  homeId?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSection21Args = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSignatureArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaStaffRoleCatalogArgs = {
  communityId: Scalars['UUID']['input'];
};


export type DebugSchemaSurveyArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaSurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasLink?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTagArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaTaskArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskCategoryArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskDefinitionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskGroupArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTaskTemplateArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTaskTemplatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  isSystem?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTeamArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenancyApplicantArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type DebugSchemaTenantReferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaTenantReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaUserFeatureAnnouncementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
};


export type DebugSchemaUserNotificationPreferenceArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaUserNotificationPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaUserSessionArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaUserSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type DebugSchemaWaiverArgs = {
  id?: InputMaybe<Scalars['UUID']['input']>;
};


export type DebugSchemaWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type DeclinePcfra = {
  readonly __typename?: 'DeclinePcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** Resident declines (for now) a PCFRA against a specific safety record. */
export type DeclineSafetyConsent = {
  readonly __typename?: 'DeclineSafetyConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type DeleteAmenityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAmenityPayload = {
  readonly __typename?: 'DeleteAmenityPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteApplicant = {
  readonly __typename?: 'DeleteApplicant';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteAttachmentPayload = {
  readonly __typename?: 'DeleteAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteBlockInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteBlockPayload = {
  readonly __typename?: 'DeleteBlockPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteChecklistInput = {
  readonly checklistId: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteChecklistItemMediaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mediaId: Scalars['String']['input'];
};

export type DeleteChecklistItemMediaPayload = {
  readonly __typename?: 'DeleteChecklistItemMediaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedMediaId?: Maybe<Scalars['UUID']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteChecklistPayload = {
  readonly __typename?: 'DeleteChecklistPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedChecklistId?: Maybe<Scalars['UUID']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityDocumentPayload = {
  readonly __typename?: 'DeleteCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityProductInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityProductPayload = {
  readonly __typename?: 'DeleteCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityUpdateAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteCommunityUpdateAttachmentPayload = {
  readonly __typename?: 'DeleteCommunityUpdateAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdateAttachment?: Maybe<CommunityUpdateAttachmentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type DeleteCommunityUpdateCommentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteCommunityUpdateCommentPayload = {
  readonly __typename?: 'DeleteCommunityUpdateCommentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteCommunityUpdatePayload = {
  readonly __typename?: 'DeleteCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteComplianceRequirementV2Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteComplianceRequirementV2Payload = {
  readonly __typename?: 'DeleteComplianceRequirementV2Payload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type DeleteConversationTagPayload = {
  readonly __typename?: 'DeleteConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type DeleteGroupChatMessageReactionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteGroupChatMessageReactionPayload = {
  readonly __typename?: 'DeleteGroupChatMessageReactionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groupChatMessageReaction?: Maybe<GroupChatMessageReactionNode>;
};

export type DeleteHomeImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomeImagePayload = {
  readonly __typename?: 'DeleteHomeImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type DeleteHomePayload = {
  readonly __typename?: 'DeleteHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type DeleteMarketplaceItemImageInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Hard-delete one image from a listing.
 *
 * ``IsOwnerOfMarketplaceItemImage`` is the fix for a live hole: this
 * mutation shipped with ``permission_classes = []``, so any authenticated
 * user could delete any listing's image. That fix sits at the legacy layer
 * on purpose — the Access V2 requirement below is inert until
 * ``ACCESS_RBAC_BACKED`` is on and so closes nothing today.
 */
export type DeleteMarketplaceItemImagePayload = {
  readonly __typename?: 'DeleteMarketplaceItemImagePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItemImage?: Maybe<MarketplaceItemImageNode>;
};

export type DeleteReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type DeleteReportingConfigurationPayload = {
  readonly __typename?: 'DeleteReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deletedId: Scalars['UUID']['output'];
};

export type DeleteRuleActionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRuleActionPayload = {
  readonly __typename?: 'DeleteRuleActionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleAction?: Maybe<RuleActionNode>;
};

export type DeleteRuleConditionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type DeleteRuleConditionPayload = {
  readonly __typename?: 'DeleteRuleConditionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleCondition?: Maybe<RuleConditionNode>;
};

export type DismissAsanaPendingTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly pendingId: Scalars['UUID']['input'];
};

export type DismissAsanaPendingTaskPayload = {
  readonly __typename?: 'DismissAsanaPendingTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly pending?: Maybe<AsanaPendingTaskNode>;
};

export type DismissFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type DismissFeatureAnnouncementPayload = {
  readonly __typename?: 'DismissFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  readonly __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  readonly exceptions?: Maybe<ReadonlyArray<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  readonly sql?: Maybe<ReadonlyArray<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  readonly __typename?: 'DjangoDebugException';
  /** The class of the exception */
  readonly excType: Scalars['String']['output'];
  /** The message of the exception */
  readonly message: Scalars['String']['output'];
  /** The stack trace */
  readonly stack: Scalars['String']['output'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  readonly __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  readonly alias: Scalars['String']['output'];
  /** Duration of this database query in seconds. */
  readonly duration: Scalars['Float']['output'];
  /** Postgres connection encoding if available. */
  readonly encoding?: Maybe<Scalars['String']['output']>;
  /** Whether this database query was a SELECT. */
  readonly isSelect: Scalars['Boolean']['output'];
  /** Whether this database query took more than 10 seconds. */
  readonly isSlow: Scalars['Boolean']['output'];
  /** Postgres isolation level if available. */
  readonly isoLevel?: Maybe<Scalars['String']['output']>;
  /** JSON encoded database query parameters. */
  readonly params: Scalars['String']['output'];
  /** The raw SQL of this query, without params. */
  readonly rawSql: Scalars['String']['output'];
  /** The actual SQL sent to this database. */
  readonly sql?: Maybe<Scalars['String']['output']>;
  /** Start time of this database query. */
  readonly startTime: Scalars['Float']['output'];
  /** Stop time of this database query. */
  readonly stopTime: Scalars['Float']['output'];
  /** Postgres transaction ID if available. */
  readonly transId?: Maybe<Scalars['String']['output']>;
  /** Postgres transaction status if available. */
  readonly transStatus?: Maybe<Scalars['String']['output']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  readonly vendor: Scalars['String']['output'];
};

export type DocumentContent = CommunityDocumentNode | ResidencyDocumentNode | UserDocumentNode;

export type DocumentExtractionNode = {
  readonly __typename?: 'DocumentExtractionNode';
  readonly community: CommunityNode;
  readonly complianceType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly extractedTaskId?: Maybe<Scalars['UUID']['output']>;
  readonly extractedTemplate?: Maybe<TaskTemplateNode>;
  readonly extractionConfidence?: Maybe<Scalars['Float']['output']>;
  readonly failedStage?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mode: ResidentialManagementDocumentExtractionModeChoices;
  readonly overviewNarrative: Scalars['String']['output'];
  readonly overviewStats: InspectionOverviewStatsNode;
  readonly parseStrategy?: Maybe<ResidentialManagementDocumentExtractionParseStrategyChoices>;
  readonly progress?: Maybe<ReadonlyArray<ExtractionStageEventType>>;
  readonly sourceDocument?: Maybe<SourceDocumentNode>;
  readonly status: ResidentialManagementDocumentExtractionStatusChoices;
  readonly statusMessage?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly validationVerdict?: Maybe<Scalars['String']['output']>;
};

export type DocumentExtractionNodeConnection = {
  readonly __typename?: 'DocumentExtractionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DocumentExtractionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DocumentExtractionNode` and its cursor. */
export type DocumentExtractionNodeEdge = {
  readonly __typename?: 'DocumentExtractionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DocumentExtractionNode>;
};

export type DocumentNode = {
  readonly __typename?: 'DocumentNode';
  readonly contentObject?: Maybe<DocumentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type DocumentNodeConnection = {
  readonly __typename?: 'DocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<DocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `DocumentNode` and its cursor. */
export type DocumentNodeEdge = {
  readonly __typename?: 'DocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<DocumentNode>;
};

export type DocumentReportingAgeCountNode = {
  readonly __typename?: 'DocumentReportingAgeCountNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type DocumentReportingAllViewedNode = {
  readonly __typename?: 'DocumentReportingAllViewedNode';
  readonly audienceCount: Scalars['Int']['output'];
  readonly residentCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
  readonly viewedAllCount: Scalars['Int']['output'];
};

export type DocumentReportingCountNode = {
  readonly __typename?: 'DocumentReportingCountNode';
  readonly byDay: ReadonlyArray<DocumentReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type DocumentReportingDayCountNode = {
  readonly __typename?: 'DocumentReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type DocumentReportingHourCountNode = {
  readonly __typename?: 'DocumentReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type DocumentReportingLiveNode = {
  readonly __typename?: 'DocumentReportingLiveNode';
  readonly count: Scalars['Int']['output'];
  readonly viewedCount: Scalars['Int']['output'];
  readonly viewedShare?: Maybe<Scalars['Float']['output']>;
};

export type DocumentReportingNeverViewedNode = {
  readonly __typename?: 'DocumentReportingNeverViewedNode';
  readonly byAge: ReadonlyArray<DocumentReportingAgeCountNode>;
  readonly total: Scalars['Int']['output'];
};

export type DocumentReportingNode = {
  readonly __typename?: 'DocumentReportingNode';
  readonly added: DocumentReportingCountNode;
  readonly allViewed: DocumentReportingAllViewedNode;
  readonly firstViews: ReadonlyArray<DocumentReportingHourCountNode>;
  readonly live: DocumentReportingLiveNode;
  readonly liveByDay: ReadonlyArray<DocumentReportingDayCountNode>;
  readonly mostViewed: ReadonlyArray<DocumentReportingTopDocumentNode>;
  readonly neverViewed: DocumentReportingNeverViewedNode;
  readonly reach: ReadonlyArray<DocumentReportingReachNode>;
  readonly reminders: DocumentReportingCountNode;
  readonly tags: ReadonlyArray<DocumentReportingTagNode>;
  readonly uniqueViewers: Scalars['Int']['output'];
};

export type DocumentReportingReachNode = {
  readonly __typename?: 'DocumentReportingReachNode';
  readonly audienceCount: Scalars['Int']['output'];
  readonly documentId: Scalars['UUID']['output'];
  readonly share: Scalars['Float']['output'];
  readonly title: Scalars['String']['output'];
  readonly viewerCount: Scalars['Int']['output'];
};

export type DocumentReportingTagNode = {
  readonly __typename?: 'DocumentReportingTagNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type DocumentReportingTopDocumentNode = {
  readonly __typename?: 'DocumentReportingTopDocumentNode';
  readonly documentId: Scalars['UUID']['output'];
  readonly title: Scalars['String']['output'];
  readonly viewerCount: Scalars['Int']['output'];
};

export type DocumentVerificationResultNode = {
  readonly __typename?: 'DocumentVerificationResultNode';
  readonly addressMatchDetail?: Maybe<Scalars['String']['output']>;
  readonly addressMatchStatus?: Maybe<ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices>;
  readonly aiRecommendation?: Maybe<ResidentialManagementDocumentVerificationResultAiRecommendationChoices>;
  readonly appearsAuthentic?: Maybe<Scalars['Boolean']['output']>;
  readonly authenticityDetail?: Maybe<Scalars['String']['output']>;
  readonly confidence?: Maybe<Scalars['Float']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly documentType?: Maybe<Scalars['String']['output']>;
  readonly extractedAddress?: Maybe<Scalars['String']['output']>;
  readonly extractedName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isProofOfAddress: Scalars['Boolean']['output'];
  readonly nameMatchDetail?: Maybe<Scalars['String']['output']>;
  readonly nameMatchStatus?: Maybe<ResidentialManagementDocumentVerificationResultNameMatchStatusChoices>;
  readonly status: ResidentialManagementDocumentVerificationResultStatusChoices;
};

export type DownloadRateType = {
  readonly __typename?: 'DownloadRateType';
  readonly date?: Maybe<Scalars['Date']['output']>;
  readonly downloadRate?: Maybe<Scalars['Float']['output']>;
};

export type EpcResponseType = {
  readonly __typename?: 'EPCResponseType';
  readonly checkedDate: Scalars['String']['output'];
  readonly city: Scalars['String']['output'];
  readonly currentEnergyEfficiency: Scalars['String']['output'];
  readonly currentEnergyRating: Scalars['String']['output'];
  readonly expiryDate: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly potentialEnergyEfficiency: Scalars['String']['output'];
  readonly potentialEnergyRating: Scalars['String']['output'];
};

export type EditKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly image?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly reference?: InputMaybe<Scalars['String']['input']>;
};

export type EditKeyPayload = {
  readonly __typename?: 'EditKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type EditMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly email: Scalars['String']['input'];
  readonly role: Scalars['String']['input'];
};

export type EditMemberPayload = {
  readonly __typename?: 'EditMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communities?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type EmployerReferenceNode = {
  readonly __typename?: 'EmployerReferenceNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employeeInputtedCompanyName?: Maybe<Scalars['String']['output']>;
  readonly employeeName?: Maybe<Scalars['String']['output']>;
  readonly employerEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationEmployerReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EmployerUpdateEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employerReferenceId: Scalars['String']['input'];
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
};

export type EmployerUpdateEmploymentDetailsPayload = {
  readonly __typename?: 'EmployerUpdateEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type EmployerUpdatePersonalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type EmployerUpdatePersonalDetailsPayload = {
  readonly __typename?: 'EmployerUpdatePersonalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type EmploymentDetailsNode = {
  readonly __typename?: 'EmploymentDetailsNode';
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices;
  readonly fullOrPartTime?: Maybe<TenancyApplicationEmploymentDetailsFullOrPartTimeChoices>;
  readonly id: Scalars['UUID']['output'];
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<TenancyApplicationEmploymentDetailsPaymentFrequencyChoices>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type ErrorType = {
  readonly __typename?: 'ErrorType';
  readonly field: Scalars['String']['output'];
  readonly messages: ReadonlyArray<Scalars['String']['output']>;
};

export type ExternalPortalUrlType = {
  readonly __typename?: 'ExternalPortalUrlType';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type ExtractionStageEventType = {
  readonly __typename?: 'ExtractionStageEventType';
  readonly at?: Maybe<Scalars['String']['output']>;
  readonly detail?: Maybe<Scalars['String']['output']>;
  readonly stage: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type FakeCreditCheckMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditSafePayload: Scalars['String']['input'];
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeCreditCheckMutationPayload = {
  readonly __typename?: 'FakeCreditCheckMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeSendTenantReferenceRequestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReferenceId: Scalars['UUID']['input'];
};

export type FakeSendTenantReferenceRequestPayload = {
  readonly __typename?: 'FakeSendTenantReferenceRequestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tenantReference: TenantReferenceNode;
};

export type FakeStripeInvoicePaidEventInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly invoiceId: Scalars['String']['input'];
};

export type FakeStripeInvoicePaidEventPayload = {
  readonly __typename?: 'FakeStripeInvoicePaidEventPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
};

export type FeatureAnnouncementNode = {
  readonly __typename?: 'FeatureAnnouncementNode';
  readonly body: Scalars['JSONString']['output'];
  readonly communities: CommunityNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentUserView?: Maybe<FeatureAnnouncementViewNode>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly slug: Scalars['String']['output'];
  readonly stats: FeatureAnnouncementStatsType;
  readonly subtitle: Scalars['String']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly views?: Maybe<FeatureAnnouncementViewNodeConnection>;
};


export type FeatureAnnouncementNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type FeatureAnnouncementNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type FeatureAnnouncementNodeConnection = {
  readonly __typename?: 'FeatureAnnouncementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FeatureAnnouncementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FeatureAnnouncementNode` and its cursor. */
export type FeatureAnnouncementNodeEdge = {
  readonly __typename?: 'FeatureAnnouncementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<FeatureAnnouncementNode>;
};

export type FeatureAnnouncementStatsType = {
  readonly __typename?: 'FeatureAnnouncementStatsType';
  readonly acceptanceCount: Scalars['Int']['output'];
  readonly acceptanceRate: Scalars['Float']['output'];
  readonly dismissalCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
};

export type FeatureAnnouncementViewNode = {
  readonly __typename?: 'FeatureAnnouncementViewNode';
  readonly acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly featureAnnouncement: FeatureAnnouncementNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly viewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly viewedBy: UserType;
};

export type FeatureAnnouncementViewNodeConnection = {
  readonly __typename?: 'FeatureAnnouncementViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<FeatureAnnouncementViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `FeatureAnnouncementViewNode` and its cursor. */
export type FeatureAnnouncementViewNodeEdge = {
  readonly __typename?: 'FeatureAnnouncementViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<FeatureAnnouncementViewNode>;
};

export type FeatureType = {
  readonly __typename?: 'FeatureType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isBeta: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum FinanceScheduleFinancialYearCategoryTotalCategoryChoices {
  /** Buildings Insurance */
  BuildingsInsurance = 'BUILDINGS_INSURANCE',
  /** Building Safety Act Compliance */
  BuildingSafetyActCompliance = 'BUILDING_SAFETY_ACT_COMPLIANCE',
  /** General Expenses */
  GeneralExpenses = 'GENERAL_EXPENSES',
  /** General Health & Safety */
  GeneralHealthSafety = 'GENERAL_HEALTH_SAFETY',
  /** Management */
  Management = 'MANAGEMENT',
  /** Onsite staff */
  OnsiteStaff = 'ONSITE_STAFF',
  /** Other Professional Fees */
  OtherProfessionalFees = 'OTHER_PROFESSIONAL_FEES',
  /** Repairs & Maintenance */
  RepairsMaintenance = 'REPAIRS_MAINTENANCE',
  /** Reserve Funds */
  ReserveFunds = 'RESERVE_FUNDS',
  /** Utilities */
  Utilities = 'UTILITIES'
}

export type FixFloType = {
  readonly __typename?: 'FixFloType';
  readonly baseUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type FixfloIssueType = {
  readonly __typename?: 'FixfloIssueType';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly created?: Maybe<Scalars['String']['output']>;
  readonly faultCategory?: Maybe<Scalars['String']['output']>;
  readonly faultPriority?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type FlagChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly finding?: InputMaybe<Scalars['String']['input']>;
  readonly itemId: Scalars['UUID']['input'];
  readonly legislationReference?: InputMaybe<Scalars['String']['input']>;
  readonly location?: InputMaybe<Scalars['String']['input']>;
  readonly plannedDate?: InputMaybe<Scalars['Date']['input']>;
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly priorityRaw?: InputMaybe<Scalars['String']['input']>;
  readonly recommendation?: InputMaybe<Scalars['String']['input']>;
};

export type FlagChecklistItemPayload = {
  readonly __typename?: 'FlagChecklistItemPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type GenerateEes = {
  readonly __typename?: 'GenerateEes';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateHomeSafetyForm = {
  readonly __typename?: 'GenerateHomeSafetyForm';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
};

export type GeneratePeepsExport = {
  readonly __typename?: 'GeneratePeepsExport';
  readonly liveUrl?: Maybe<Scalars['String']['output']>;
  readonly occupantCount?: Maybe<Scalars['Int']['output']>;
  readonly qrDataUri?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateSafetyDocumentQrPdf = {
  readonly __typename?: 'GenerateSafetyDocumentQrPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GenerateSafetyRecordActivityPdf = {
  readonly __typename?: 'GenerateSafetyRecordActivityPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GenerateSibPack = {
  readonly __typename?: 'GenerateSibPack';
  readonly appendedPdfCount?: Maybe<Scalars['Int']['output']>;
  readonly blockCount?: Maybe<Scalars['Int']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly documentCount?: Maybe<Scalars['Int']['output']>;
  readonly liveUrl?: Maybe<Scalars['String']['output']>;
  readonly occupantCount?: Maybe<Scalars['Int']['output']>;
  readonly pack?: Maybe<SafetyResponderPackNode>;
  readonly qrDataUri?: Maybe<Scalars['String']['output']>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type GenerateSibPackQrPdf = {
  readonly __typename?: 'GenerateSibPackQrPdf';
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly pdfBase64?: Maybe<Scalars['String']['output']>;
};

export type GeneratedAgreementNode = {
  readonly __typename?: 'GeneratedAgreementNode';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paidForByInvoice?: Maybe<Scalars['Boolean']['output']>;
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementNodeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementNodeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedAgreementNodeConnection = {
  readonly __typename?: 'GeneratedAgreementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedAgreementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedAgreementNode` and its cursor. */
export type GeneratedAgreementNodeEdge = {
  readonly __typename?: 'GeneratedAgreementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedAgreementNode>;
};

export type GeneratedAgreementType = {
  readonly __typename?: 'GeneratedAgreementType';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly furnished: AstGeneratorGeneratedAgreementFurnishedChoices;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly paymentFrequency: AstGeneratorGeneratedAgreementPaymentFrequencyChoices;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly residency?: Maybe<ResidencyType>;
  readonly residentNames?: Maybe<Scalars['String']['output']>;
  readonly signatures: AgreementSignatureNodeConnection;
  readonly status: AstGeneratorGeneratedAgreementStatusChoices;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmail?: Maybe<Scalars['String']['output']>;
  readonly tenantMobile?: Maybe<Scalars['String']['output']>;
  readonly tenants: AgreementTenantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};


export type GeneratedAgreementTypeSignaturesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type GeneratedAgreementTypeTenantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GeneratedSection21Node = {
  readonly __typename?: 'GeneratedSection21Node';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly paidFor: Scalars['Boolean']['output'];
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly remindLandlord: Scalars['Boolean']['output'];
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantEmails?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GeneratedSection21NodeConnection = {
  readonly __typename?: 'GeneratedSection21NodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GeneratedSection21NodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GeneratedSection21Node` and its cursor. */
export type GeneratedSection21NodeEdge = {
  readonly __typename?: 'GeneratedSection21NodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GeneratedSection21Node>;
};

export type GeneratedSection21Type = {
  readonly __typename?: 'GeneratedSection21Type';
  readonly client?: Maybe<ClientType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided: Scalars['Boolean']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly serviceDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk: Scalars['Boolean']['output'];
};

export type GiveFireServiceConsent = {
  readonly __typename?: 'GiveFireServiceConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** Resident gives consent for a PCFRA against a specific safety record. */
export type GiveSafetyConsent = {
  readonly __typename?: 'GiveSafetyConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type GlobalFeatureType = {
  readonly __typename?: 'GlobalFeatureType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isEnabled: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type GroupChatMessageNode = {
  readonly __typename?: 'GroupChatMessageNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<Scalars['String']['output']>;
  readonly reactions?: Maybe<GroupChatMessageReactionNodeConnection>;
  readonly repliedTo?: Maybe<GroupChatMessageNode>;
  readonly text?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};


export type GroupChatMessageNodeReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type GroupChatMessageNodeConnection = {
  readonly __typename?: 'GroupChatMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageNode` and its cursor. */
export type GroupChatMessageNodeEdge = {
  readonly __typename?: 'GroupChatMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageNode>;
};

export type GroupChatMessageReactionNode = {
  readonly __typename?: 'GroupChatMessageReactionNode';
  readonly deletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly groupChatMessage?: Maybe<GroupChatMessageNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly reaction: Scalars['String']['output'];
  readonly user?: Maybe<UserType>;
};

export type GroupChatMessageReactionNodeConnection = {
  readonly __typename?: 'GroupChatMessageReactionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageReactionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageReactionNode` and its cursor. */
export type GroupChatMessageReactionNodeEdge = {
  readonly __typename?: 'GroupChatMessageReactionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageReactionNode>;
};

export type GroupChatMessageReportNode = {
  readonly __typename?: 'GroupChatMessageReportNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message?: Maybe<GroupChatMessageNode>;
  readonly reason: Scalars['String']['output'];
  readonly reporter?: Maybe<UserType>;
};

export type GroupChatMessageReportNodeConnection = {
  readonly __typename?: 'GroupChatMessageReportNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatMessageReportNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatMessageReportNode` and its cursor. */
export type GroupChatMessageReportNodeEdge = {
  readonly __typename?: 'GroupChatMessageReportNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatMessageReportNode>;
};

export type GroupChatNode = {
  readonly __typename?: 'GroupChatNode';
  readonly community: CommunityNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type GroupChatNodeConnection = {
  readonly __typename?: 'GroupChatNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<GroupChatNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `GroupChatNode` and its cursor. */
export type GroupChatNodeEdge = {
  readonly __typename?: 'GroupChatNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<GroupChatNode>;
};

export enum HistoricalDataFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export enum HistoricalDataPointType {
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  KeyInCount = 'KEY_IN_COUNT',
  KeyOutCount = 'KEY_OUT_COUNT',
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

export type HomeDetailsType = {
  readonly __typename?: 'HomeDetailsType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly furnishing?: Maybe<ResidentialManagementHomeDetailsFurnishingChoices>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home: HomeType;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<ResidentialManagementHomeDetailsParkingChoices>;
};

export type HomeImageType = {
  readonly __typename?: 'HomeImageType';
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
};

export type HomeImageTypeConnection = {
  readonly __typename?: 'HomeImageTypeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeImageTypeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeImageType` and its cursor. */
export type HomeImageTypeEdge = {
  readonly __typename?: 'HomeImageTypeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeImageType>;
};

export type HomeNode = {
  readonly __typename?: 'HomeNode';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidency?: Maybe<ResidencyNode>;
  readonly address: Scalars['String']['output'];
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly aicoSensorsLastSevenDaysAverage?: Maybe<ReadonlyArray<AicoDailyAverageReadingNode>>;
  readonly applications: ApplicationNodeConnection;
  readonly block?: Maybe<BlockNode>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly environmentAdvice?: Maybe<AicoEnvironmentAdviceNode>;
  readonly environmentThresholds?: Maybe<AicoEnvironmentThresholdsNode>;
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly hasFixfloExternalId?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keys?: Maybe<KeyNodeConnection>;
  readonly latestAverageAicoSensors?: Maybe<AicoLatestAverageReadingNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly name: Scalars['String']['output'];
  readonly occupantCount: Scalars['Int']['output'];
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly postcode: Scalars['String']['output'];
  readonly residencies?: Maybe<ResidencyNodeConnection>;
  readonly similarity?: Maybe<Scalars['Float']['output']>;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
};


export type HomeNodeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeNodeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeNodeResidenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeNodeConnection = {
  readonly __typename?: 'HomeNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<HomeNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `HomeNode` and its cursor. */
export type HomeNodeEdge = {
  readonly __typename?: 'HomeNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<HomeNode>;
};

export type HomeType = {
  readonly __typename?: 'HomeType';
  readonly HMO: Scalars['Boolean']['output'];
  readonly activeResidencies?: Maybe<ReadonlyArray<Maybe<ResidencyType>>>;
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly aicoPropertyId?: Maybe<Scalars['String']['output']>;
  readonly applications: ApplicationNodeConnection;
  readonly archivedLeaseholds: LeaseholdNodeConnection;
  readonly block?: Maybe<BlockNode>;
  readonly cachedAddressees?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly community?: Maybe<CommunityNode>;
  readonly communityGroups: CommunityGroupNodeConnection;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly contractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly conversations: ConversationNodeConnection;
  /** Home that the user manually corrected to. */
  readonly correctedContractorClassifications: ReadonlyArray<ContractorSuggestionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentPackageCount?: Maybe<Scalars['Int']['output']>;
  readonly currentResidency?: Maybe<ResidencyType>;
  readonly details?: Maybe<HomeDetailsType>;
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly images: HomeImageTypeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keys: KeyNodeConnection;
  readonly latitude?: Maybe<Scalars['Decimal']['output']>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly longitude?: Maybe<Scalars['Decimal']['output']>;
  readonly name: Scalars['String']['output'];
  readonly numRooms: Scalars['Int']['output'];
  readonly packages: PackageNodeConnection;
  /** Homes whose occupants stay in this block group whatever the membership rule says. Use for management offices, common areas, amenity spaces, or demo homes. Pinned homes may be outside the block. */
  readonly pinnedToCommunityGroups: CommunityGroupNodeConnection;
  readonly postcode: Scalars['String']['output'];
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly section21s: GeneratedSection21NodeConnection;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplications: TenancyApplicationNodeConnection;
  readonly uncollectedPackageCount: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type HomeTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeArchivedLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeConversationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type HomeTypePinnedToCommunityGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type HomeTypeSection21sArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type HomeTypeTenancyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type IdentityVerificationNode = {
  readonly __typename?: 'IdentityVerificationNode';
  readonly documentExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly documentNumber?: Maybe<Scalars['String']['output']>;
  readonly documentType?: Maybe<Scalars['String']['output']>;
  readonly hasRightToRent?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly nationality?: Maybe<Scalars['String']['output']>;
  readonly passport?: Maybe<Scalars['String']['output']>;
  readonly passportSelfie?: Maybe<Scalars['String']['output']>;
  readonly personaInquiryId: Scalars['String']['output'];
  readonly selfie?: Maybe<Scalars['String']['output']>;
  readonly status: TenancyApplicationIdentityVerificationStatusChoices;
};

export type IgnoreMessageSuggestionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type IgnoreMessageSuggestionPayload = {
  readonly __typename?: 'IgnoreMessageSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type InitializeSignup = {
  readonly __typename?: 'InitializeSignup';
  readonly landlord?: Maybe<LandlordNode>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type InspectionOverviewCountNode = {
  readonly __typename?: 'InspectionOverviewCountNode';
  readonly count: Scalars['Int']['output'];
  readonly key: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
};

export type InspectionOverviewStatsNode = {
  readonly __typename?: 'InspectionOverviewStatsNode';
  readonly actionsComplete: Scalars['Int']['output'];
  readonly actionsDismissed: Scalars['Int']['output'];
  readonly actionsInProgress: Scalars['Int']['output'];
  readonly actionsOutstanding: Scalars['Int']['output'];
  readonly actionsOverdue: Scalars['Int']['output'];
  readonly actionsTotal: Scalars['Int']['output'];
  readonly actionsWithTasks: Scalars['Int']['output'];
  readonly byArea: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byPriority: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byResolver: ReadonlyArray<InspectionOverviewCountNode>;
  readonly byReviewer: ReadonlyArray<InspectionOverviewCountNode>;
  readonly reportItemsNeedingAction: Scalars['Int']['output'];
  readonly reportItemsPassed: Scalars['Int']['output'];
  readonly reportItemsTotal: Scalars['Int']['output'];
};

export type IntegrationType = {
  readonly __typename?: 'IntegrationType';
  readonly fixflo?: Maybe<FixFloType>;
};

export type InviteDemoUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityId: Scalars['UUID']['input'];
  readonly email: Scalars['String']['input'];
};

export type InviteDemoUserPayload = {
  readonly __typename?: 'InviteDemoUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyNode;
};

export type InvoiceNode = {
  readonly __typename?: 'InvoiceNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isPaid: Scalars['Boolean']['output'];
};

export type InvoiceNodeConnection = {
  readonly __typename?: 'InvoiceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<InvoiceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `InvoiceNode` and its cursor. */
export type InvoiceNodeEdge = {
  readonly __typename?: 'InvoiceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<InvoiceNode>;
};

export type Invoices = {
  readonly __typename?: 'Invoices';
  readonly amount: Scalars['Int']['output'];
  readonly charge?: Maybe<ChargeType>;
  readonly created: Scalars['String']['output'];
  readonly id: Scalars['String']['output'];
  readonly nextPaymentAttempt?: Maybe<Scalars['Date']['output']>;
  readonly number?: Maybe<Scalars['String']['output']>;
  readonly paidAt?: Maybe<Scalars['String']['output']>;
  readonly paymentIntent?: Maybe<PaymentIntentType>;
  readonly status: Scalars['String']['output'];
};

export type KeyEventNode = {
  readonly __typename?: 'KeyEventNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly key: KeyNode;
  readonly keyholder: KeyholderNode;
  readonly performedBy: UserType;
  readonly type: ResidentialManagementKeyEventTypeChoices;
};

export type KeyEventNodeConnection = {
  readonly __typename?: 'KeyEventNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyEventNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyEventNode` and its cursor. */
export type KeyEventNodeEdge = {
  readonly __typename?: 'KeyEventNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyEventNode>;
};

export type KeyNode = {
  readonly __typename?: 'KeyNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly checkoutDate?: Maybe<Scalars['DateTime']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly communityName: Scalars['String']['output'];
  readonly currentKeyholder?: Maybe<KeyholderNode>;
  readonly events: KeyEventNodeConnection;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keyholders: KeyholderNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly reference?: Maybe<Scalars['String']['output']>;
  readonly status: Scalars['String']['output'];
};


export type KeyNodeEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type KeyNodeKeyholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type KeyNodeConnection = {
  readonly __typename?: 'KeyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyNode` and its cursor. */
export type KeyNodeEdge = {
  readonly __typename?: 'KeyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyNode>;
};

export type KeyReportingDayCountNode = {
  readonly __typename?: 'KeyReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type KeyReportingDayDurationNode = {
  readonly __typename?: 'KeyReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type KeyReportingDayMovementNode = {
  readonly __typename?: 'KeyReportingDayMovementNode';
  readonly checkedIn?: Maybe<Scalars['Int']['output']>;
  readonly checkedOut?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type KeyReportingDaysHeldBucketNode = {
  readonly __typename?: 'KeyReportingDaysHeldBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
  readonly overdue: Scalars['Boolean']['output'];
};

export type KeyReportingDaysHeldNode = {
  readonly __typename?: 'KeyReportingDaysHeldNode';
  readonly buckets: ReadonlyArray<KeyReportingDaysHeldBucketNode>;
  readonly overdueCount: Scalars['Int']['output'];
};

export type KeyReportingHeldKeyNode = {
  readonly __typename?: 'KeyReportingHeldKeyNode';
  readonly heldSeconds: Scalars['Int']['output'];
  readonly keyId: Scalars['UUID']['output'];
  readonly label: Scalars['String']['output'];
};

export type KeyReportingHolderCompanyNode = {
  readonly __typename?: 'KeyReportingHolderCompanyNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type KeyReportingKeysOutNode = {
  readonly __typename?: 'KeyReportingKeysOutNode';
  readonly atEnd?: Maybe<KeyReportingDayCountNode>;
  readonly byDay: ReadonlyArray<KeyReportingDayCountNode>;
};

export type KeyReportingMovementsNode = {
  readonly __typename?: 'KeyReportingMovementsNode';
  readonly byDay: ReadonlyArray<KeyReportingDayMovementNode>;
  readonly checkedIn?: Maybe<Scalars['Int']['output']>;
  readonly checkedOut?: Maybe<Scalars['Int']['output']>;
};

export type KeyReportingNode = {
  readonly __typename?: 'KeyReportingNode';
  readonly activeHolders: Scalars['Int']['output'];
  readonly daysHeld: KeyReportingDaysHeldNode;
  readonly holderCompanies: ReadonlyArray<KeyReportingHolderCompanyNode>;
  readonly keysOut: KeyReportingKeysOutNode;
  readonly longestHeld: ReadonlyArray<KeyReportingHeldKeyNode>;
  readonly movements: KeyReportingMovementsNode;
  readonly overdueAtEnd: Scalars['Int']['output'];
  readonly timeHeld: KeyReportingTimeHeldNode;
};

export type KeyReportingTimeHeldNode = {
  readonly __typename?: 'KeyReportingTimeHeldNode';
  readonly byDay: ReadonlyArray<KeyReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type KeyholderNode = {
  readonly __typename?: 'KeyholderNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly key: KeyNode;
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['DateTime']['output'];
  readonly type: Scalars['String']['output'];
};

export type KeyholderNodeConnection = {
  readonly __typename?: 'KeyholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<KeyholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `KeyholderNode` and its cursor. */
export type KeyholderNodeEdge = {
  readonly __typename?: 'KeyholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<KeyholderNode>;
};

export type LabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type LabelConversationPayload = {
  readonly __typename?: 'LabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type LandlordAttachmentNode = {
  readonly __typename?: 'LandlordAttachmentNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
};

export type LandlordAttachmentType = {
  readonly __typename?: 'LandlordAttachmentType';
  readonly client: ClientType;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly filename?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly requirementItem?: Maybe<RequirementItemNode>;
  readonly type: ComplianceAttachmentTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type LandlordDocumentNode = GeneratedAgreementNode | GeneratedSection21Node | LandlordAttachmentNode;

export type LandlordNode = {
  readonly __typename?: 'LandlordNode';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences: Scalars['Boolean']['output'];
};

export type LandlordReferenceNode = {
  readonly __typename?: 'LandlordReferenceNode';
  readonly comments?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly hasOutstandingRent: TenancyApplicationLandlordReferenceHasOutstandingRentChoices;
  readonly id: Scalars['UUID']['output'];
  readonly landlordOrAgent: Scalars['String']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile: Scalars['String']['output'];
  readonly monthlyRentAmount: Scalars['Decimal']['output'];
  readonly rentPaidOnTime: TenancyApplicationLandlordReferenceRentPaidOnTimeChoices;
  readonly step?: Maybe<TenancyApplicationLandlordReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenancyType: TenancyApplicationLandlordReferenceTenancyTypeChoices;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly tenantReference?: Maybe<TenantReferenceNode>;
  readonly treatedPropertyWell: TenancyApplicationLandlordReferenceTreatedPropertyWellChoices;
};

export type LandlordUpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
};

export type LandlordUpdateLandlordReferencePayload = {
  readonly __typename?: 'LandlordUpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type LandlordUpdateRentalDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly hasOutstandingRent?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly monthlyRentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly rentPaidOnTime?: InputMaybe<Scalars['String']['input']>;
  readonly tenancyType?: InputMaybe<Scalars['String']['input']>;
  readonly tenantMoveInDate?: InputMaybe<Scalars['Date']['input']>;
  readonly treatedPropertyWell?: InputMaybe<Scalars['String']['input']>;
};

export type LandlordUpdateRentalDetailsPayload = {
  readonly __typename?: 'LandlordUpdateRentalDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasOutstandingRent?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly monthlyRentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly rentPaidOnTime?: Maybe<Scalars['String']['output']>;
  readonly tenancyType?: Maybe<Scalars['String']['output']>;
  readonly tenantMoveInDate?: Maybe<Scalars['Date']['output']>;
  readonly treatedPropertyWell?: Maybe<Scalars['String']['output']>;
};

export type LeanNotificationNode = {
  readonly __typename?: 'LeanNotificationNode';
  readonly actionObjectObjectId?: Maybe<Scalars['String']['output']>;
  readonly actionObjectType?: Maybe<Scalars['String']['output']>;
  readonly actorName?: Maybe<Scalars['String']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFeatureAnnouncement: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly navigationMeta?: Maybe<NotificationNavigationMeta>;
  readonly platform?: Maybe<Scalars['String']['output']>;
  readonly read: Scalars['Boolean']['output'];
  readonly targetObjectId?: Maybe<Scalars['String']['output']>;
  readonly targetType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly verb?: Maybe<Scalars['String']['output']>;
};

export type LeanNotificationNodeConnection = {
  readonly __typename?: 'LeanNotificationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeanNotificationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeanNotificationNode` and its cursor. */
export type LeanNotificationNodeEdge = {
  readonly __typename?: 'LeanNotificationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeanNotificationNode>;
};

export type LeaseholdNode = {
  readonly __typename?: 'LeaseholdNode';
  readonly balance?: Maybe<Scalars['Decimal']['output']>;
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leaseholdSchedules?: Maybe<LeaseholdScheduleNodeConnection>;
  readonly leaseholder: LeaseholderNodeConnection;
  readonly pastLeaseholders?: Maybe<ArchivedContactNodeConnection>;
  readonly remainingSchedules?: Maybe<ScheduleNodeConnection>;
  readonly schedules: LeaseholdScheduleNodeConnection;
};


export type LeaseholdNodeLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeLeaseholderArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodePastLeaseholdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeRemainingSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type LeaseholdNodeSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholdNodeConnection = {
  readonly __typename?: 'LeaseholdNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholdNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholdNode` and its cursor. */
export type LeaseholdNodeEdge = {
  readonly __typename?: 'LeaseholdNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholdNode>;
};

export type LeaseholdScheduleNode = {
  readonly __typename?: 'LeaseholdScheduleNode';
  /** Apportionment percentage as decimal */
  readonly apportionment?: Maybe<Scalars['Decimal']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly leasehold: LeaseholdNode;
  readonly schedule: ScheduleNode;
  readonly totalContribution?: Maybe<Scalars['Decimal']['output']>;
};

export type LeaseholdScheduleNodeConnection = {
  readonly __typename?: 'LeaseholdScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholdScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholdScheduleNode` and its cursor. */
export type LeaseholdScheduleNodeEdge = {
  readonly __typename?: 'LeaseholdScheduleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholdScheduleNode>;
};

export type LeaseholderNode = {
  readonly __typename?: 'LeaseholderNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly leaseholds: LeaseholdNodeConnection;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly serviceChargeWaiverAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly user: UserType;
};


export type LeaseholderNodeLeaseholdsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type LeaseholderNodeConnection = {
  readonly __typename?: 'LeaseholderNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<LeaseholderNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `LeaseholderNode` and its cursor. */
export type LeaseholderNodeEdge = {
  readonly __typename?: 'LeaseholderNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<LeaseholderNode>;
};

export type LinkConversationToTaskInput = {
  readonly addAsWatcher?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly taskId: Scalars['UUID']['input'];
};

export type LinkConversationToTaskPayload = {
  readonly __typename?: 'LinkConversationToTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type LinkSafetySubjectInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly userId: Scalars['String']['input'];
};

export type LinkSafetySubjectPayload = {
  readonly __typename?: 'LinkSafetySubjectPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type LinkTaskToAsanaInput = {
  readonly asanaId?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTaskToAsanaPayload = {
  readonly __typename?: 'LinkTaskToAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type LinkTaskToFixfloInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly fixfloId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LinkTaskToFixfloPayload = {
  readonly __typename?: 'LinkTaskToFixfloPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type LogDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogDocumentReadPayload = {
  readonly __typename?: 'LogDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogManagerDashUse = {
  readonly __typename?: 'LogManagerDashUse';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type LogPublicDocumentReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type LogPublicDocumentReadPayload = {
  readonly __typename?: 'LogPublicDocumentReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type LogUserAppUseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deviceBrand: Scalars['String']['input'];
  readonly deviceNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deviceType: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly locale?: InputMaybe<Scalars['String']['input']>;
  readonly systemName: Scalars['String']['input'];
};

export type LogUserAppUsePayload = {
  readonly __typename?: 'LogUserAppUsePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deviceBrand?: Maybe<Scalars['String']['output']>;
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName?: Maybe<Scalars['String']['output']>;
};

export type ManagerAddApplicationHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerAddApplicationHomePayload = {
  readonly __typename?: 'ManagerAddApplicationHomePayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCancelAmenityReservationInput = {
  readonly cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ManagerCancelAmenityReservationPayload = {
  readonly __typename?: 'ManagerCancelAmenityReservationPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerCreateAmenityReservationInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly reason: Scalars['String']['input'];
  readonly timeSlots: ReadonlyArray<InputMaybe<TimeSlot>>;
};

export type ManagerCreateAmenityReservationPayload = {
  readonly __typename?: 'ManagerCreateAmenityReservationPayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export enum ManagerDeclarationOrigin {
  ManagerDirect = 'MANAGER_DIRECT',
  ManagerPaper = 'MANAGER_PAPER',
  ManagerPhone = 'MANAGER_PHONE'
}

export type ManagerNotificationType = {
  readonly __typename?: 'ManagerNotificationType';
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly client: ClientType;
  readonly contentObject?: Maybe<NotificationContentObjectType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description: Scalars['String']['output'];
  readonly dismissed: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ManagerProfileType = {
  readonly __typename?: 'ManagerProfileType';
  readonly ASTPageViewed: Scalars['Boolean']['output'];
  readonly acceptedMarketing: Scalars['Boolean']['output'];
  readonly complianceEmailExplanation: Scalars['Boolean']['output'];
  readonly compliancePageViewed: Scalars['Boolean']['output'];
  readonly complianceUpdateEmails: Scalars['Boolean']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly manager: ManagerType;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type ManagerReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly start: Scalars['DateTime']['input'];
};

export type ManagerReserveAmenityPayload = {
  readonly __typename?: 'ManagerReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ManagerType = {
  readonly __typename?: 'ManagerType';
  readonly applicationAttempts: ApplicationAttemptNodeConnection;
  readonly calendarLink?: Maybe<CalendarLinkType>;
  readonly client?: Maybe<ClientType>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly community?: Maybe<CommunityNodeConnection>;
  readonly complianceUpdateReads: ReadonlyArray<ComplianceUpdateReadType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdDocuments: CommunityDocumentNodeConnection;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isActive?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly profile?: Maybe<ManagerProfileType>;
  readonly residencydocumentSet: ResidencyDocumentNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ManagerTypeApplicationAttemptsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCommunityArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeCreatedDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type ManagerTypeResidencydocumentSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarkApplicationThreadAsReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type MarkApplicationThreadAsReadPayload = {
  readonly __typename?: 'MarkApplicationThreadAsReadPayload';
  readonly applicationThread?: Maybe<ApplicationThreadNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type MarkSafetyReviewRequestOpened = {
  readonly __typename?: 'MarkSafetyReviewRequestOpened';
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type MarkSibPackPrinted = {
  readonly __typename?: 'MarkSibPackPrinted';
  readonly community?: Maybe<CommunityNode>;
  readonly pack?: Maybe<SafetyResponderPackNode>;
};

export type MarkSuggestionShownInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly suggestionId: Scalars['UUID']['input'];
};

export type MarkSuggestionShownPayload = {
  readonly __typename?: 'MarkSuggestionShownPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly suggestion?: Maybe<MessageSuggestionType>;
};

export type MarkThreadMessagesAsReadInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Mark the other participant's messages in a thread as read.
 *
 * Gated on ``marketplace_item_thread`` edit rather than
 * ``marketplace_item_thread_message`` edit: the write targets every unread
 * message in the thread and no message id is supplied, so the thread is the
 * only object the requirement can bind to. Binding the thread still routes
 * through the thread ownership policy, which limits the caller to threads
 * they inquire on or own the listing for.
 */
export type MarkThreadMessagesAsReadPayload = {
  readonly __typename?: 'MarkThreadMessagesAsReadPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItemThread?: Maybe<MarketplaceItemThreadNode>;
};

export type MarketplaceItemCommentNode = {
  readonly __typename?: 'MarketplaceItemCommentNode';
  readonly author?: Maybe<UserType>;
  readonly comment: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type MarketplaceItemCommentNodeConnection = {
  readonly __typename?: 'MarketplaceItemCommentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemCommentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemCommentNode` and its cursor. */
export type MarketplaceItemCommentNodeEdge = {
  readonly __typename?: 'MarketplaceItemCommentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemCommentNode>;
};

export type MarketplaceItemImageNode = {
  readonly __typename?: 'MarketplaceItemImageNode';
  readonly id: Scalars['UUID']['output'];
  readonly image: Scalars['String']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type MarketplaceItemImageNodeConnection = {
  readonly __typename?: 'MarketplaceItemImageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemImageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemImageNode` and its cursor. */
export type MarketplaceItemImageNodeEdge = {
  readonly __typename?: 'MarketplaceItemImageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemImageNode>;
};

export type MarketplaceItemNode = {
  readonly __typename?: 'MarketplaceItemNode';
  readonly archivedBy?: Maybe<UserType>;
  readonly archivedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly archivedReason?: Maybe<Scalars['String']['output']>;
  readonly closedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly comments: MarketplaceItemCommentNodeConnection;
  readonly community: CommunityNode;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly images: MarketplaceItemImageNodeConnection;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly notifications?: Maybe<NotificationNodeConnection>;
  readonly price: Scalars['Decimal']['output'];
  readonly threads: MarketplaceItemThreadNodeConnection;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type MarketplaceItemNodeCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeImagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type MarketplaceItemNodeNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type MarketplaceItemNodeThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasMessages?: InputMaybe<Scalars['Boolean']['input']>;
  item?: InputMaybe<Scalars['UUID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceItemNodeConnection = {
  readonly __typename?: 'MarketplaceItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemNode` and its cursor. */
export type MarketplaceItemNodeEdge = {
  readonly __typename?: 'MarketplaceItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemNode>;
};

export type MarketplaceItemThreadMessageNode = {
  readonly __typename?: 'MarketplaceItemThreadMessageNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFromSeller?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly message: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly readAt?: Maybe<Scalars['DateTime']['output']>;
  readonly user: UserType;
};

export type MarketplaceItemThreadMessageNodeConnection = {
  readonly __typename?: 'MarketplaceItemThreadMessageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemThreadMessageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemThreadMessageNode` and its cursor. */
export type MarketplaceItemThreadMessageNodeEdge = {
  readonly __typename?: 'MarketplaceItemThreadMessageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemThreadMessageNode>;
};

export type MarketplaceItemThreadNode = {
  readonly __typename?: 'MarketplaceItemThreadNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inquirer: UserType;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly item: MarketplaceItemNode;
  readonly lastMessage?: Maybe<MarketplaceItemThreadMessageNode>;
  readonly messages: MarketplaceItemThreadMessageNodeConnection;
  readonly otherUserName?: Maybe<Scalars['String']['output']>;
  readonly unreadCount?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type MarketplaceItemThreadNodeMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type MarketplaceItemThreadNodeConnection = {
  readonly __typename?: 'MarketplaceItemThreadNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<MarketplaceItemThreadNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `MarketplaceItemThreadNode` and its cursor. */
export type MarketplaceItemThreadNodeEdge = {
  readonly __typename?: 'MarketplaceItemThreadNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<MarketplaceItemThreadNode>;
};

export type MessageSuggestionType = {
  readonly __typename?: 'MessageSuggestionType';
  readonly action?: Maybe<ResidentialManagementMessageSuggestionActionChoices>;
  readonly alteredMessage?: Maybe<Scalars['String']['output']>;
  readonly braintrustSpanId?: Maybe<Scalars['String']['output']>;
  readonly citations?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly model?: Maybe<Scalars['String']['output']>;
  readonly promptVersion?: Maybe<Scalars['String']['output']>;
  readonly suggestion?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly version: Scalars['Int']['output'];
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly acceptApplication?: Maybe<AcceptApplication>;
  readonly acceptAsanaPendingTask?: Maybe<AcceptAsanaPendingTaskPayload>;
  readonly acceptFeatureAnnouncement?: Maybe<AcceptFeatureAnnouncementPayload>;
  readonly acceptMessageSuggestion?: Maybe<AcceptMessageSuggestionPayload>;
  readonly acceptServiceChargeWaiver?: Maybe<AcceptServiceChargeWaiverPayload>;
  readonly acceptTermsAndConditions?: Maybe<AcceptTermsAndConditionsPayload>;
  readonly acceptWaiver?: Maybe<AcceptWaiverPayload>;
  readonly activateGroup?: Maybe<ActivateGroupPayload>;
  readonly activateSafetyComplianceV2?: Maybe<ActivateSafetyComplianceV2>;
  readonly activateSafetyResponderToken?: Maybe<ActivateSafetyResponderToken>;
  readonly addApplicationCommunity?: Maybe<AddApplicationCommunity>;
  readonly addApplicationHome?: Maybe<AddApplicationHome>;
  readonly addApplicationOwnershipType?: Maybe<AddApplicationOwnershipType>;
  readonly addContractorToClientContractorCompany?: Maybe<AddContractorToClientContractorCompanyPayload>;
  readonly addDocumentSentStatus?: Maybe<AddDocumentSentStatus>;
  readonly addFeatureToClient?: Maybe<AddFeatureToClientPayload>;
  readonly addMember?: Maybe<AddMemberPayload>;
  readonly addMessageToThread?: Maybe<AddMessageToThreadPayload>;
  readonly addPackageToHome?: Maybe<AddPackageToHomePayload>;
  readonly addTaskComment?: Maybe<AddTaskCommentPayload>;
  readonly addTeamMembers?: Maybe<AddTeamMembersPayload>;
  readonly addUnknownCommunityStatus?: Maybe<AddUnknownCommunityStatus>;
  readonly agreeEes?: Maybe<AgreeEes>;
  readonly archiveAllNotificationsOnTarget?: Maybe<ArchiveAllNotificationsOnTargetPayload>;
  readonly archiveApplication?: Maybe<ArchiveApplicationPayload>;
  readonly archiveCommunityEvent?: Maybe<ArchiveCommunityEventPayload>;
  readonly archiveContactNote?: Maybe<ArchiveContactNotePayload>;
  readonly archiveKey?: Maybe<ArchiveKeyPayload>;
  readonly archiveKeyholder?: Maybe<ArchiveKeyholderPayload>;
  readonly archiveMarketplaceItem?: Maybe<ArchiveMarketplaceItemPayload>;
  readonly archiveNotification?: Maybe<ArchiveNotificationPayload>;
  readonly archiveSafetyCenterDocument?: Maybe<ArchiveSafetyCenterDocumentPayload>;
  readonly archiveSafetySubject?: Maybe<ArchiveSafetySubjectPayload>;
  readonly archiveTag?: Maybe<ArchiveTagPayload>;
  readonly archiveTask?: Maybe<ArchiveTaskPayload>;
  readonly archiveTaskGroup?: Maybe<ArchiveTaskGroupPayload>;
  readonly archiveTaskTemplate?: Maybe<ArchiveTaskTemplatePayload>;
  readonly assignChecklistItem?: Maybe<AssignChecklistItemPayload>;
  readonly assignChecklistSection?: Maybe<AssignChecklistSectionPayload>;
  readonly assignClientTag?: Maybe<AssignClientTagPayload>;
  readonly assignClientTagToCommunityDocument?: Maybe<AssignClientTagToCommunityDocumentPayload>;
  readonly assignClientTagToTaskDefinition?: Maybe<AssignClientTagToTaskDefinitionPayload>;
  readonly assignClientTagToUserDocument?: Maybe<AssignClientTagToUserDocumentPayload>;
  readonly assignCommunityStaffRole?: Maybe<AssignCommunityStaffRolePayload>;
  readonly assignContractorToTask?: Maybe<AssignContractorToTaskPayload>;
  readonly assignTask?: Maybe<AssignTaskPayload>;
  readonly assignTeam?: Maybe<AssignTeamPayload>;
  readonly associateAgreementWithClient?: Maybe<AssociateAgreementWithClient>;
  readonly associateSection21WithClient?: Maybe<AssociateSection21WithClient>;
  readonly batchCreateTaskDocuments?: Maybe<BatchCreateTaskDocumentsPayload>;
  readonly bookCommunityEvent?: Maybe<BookCommunityEventMutationPayload>;
  readonly bookPaidCommunityEvent?: Maybe<BookPaidCommunityEventMutationPayload>;
  readonly cancelAmenityReservation?: Maybe<CancelAmenityReservationPayload>;
  readonly cancelPayment?: Maybe<CancelPaymentPayload>;
  readonly cancelScheduledMessage?: Maybe<CancelScheduledMessage>;
  readonly cancelScheduledPublishCommunityUpdate?: Maybe<CancelScheduledPublishCommunityUpdatePayload>;
  readonly changeTaskStatus?: Maybe<ChangeTaskStatusPayload>;
  readonly checkInKeyV2?: Maybe<CheckInKeyV2Payload>;
  readonly checkOutKeyV2?: Maybe<CheckOutKeyV2Payload>;
  readonly closeConversation?: Maybe<CloseConversationPayload>;
  readonly closeSurvey?: Maybe<CloseSurvey>;
  readonly collectPackages?: Maybe<CollectPackagesPayload>;
  readonly collectPackagesForHome?: Maybe<CollectPackagesForHomePayload>;
  readonly completeChecklistItem?: Maybe<CompleteChecklistItemPayload>;
  readonly confirmBlockPlacements?: Maybe<ConfirmBlockPlacements>;
  readonly confirmBlockSetup?: Maybe<ConfirmBlockSetup>;
  readonly confirmResidencyWillRoll?: Maybe<ConfirmResidencyWillRollPayload>;
  readonly contactApplicationSupport?: Maybe<ContactApplicationSupportPayload>;
  readonly contactPackagesReminder?: Maybe<ContactPackagesReminderPayload>;
  readonly correctInspectionSeries?: Maybe<CorrectInspectionSeriesPayload>;
  readonly countersignAgreement?: Maybe<CountersignAgreementPayload>;
  readonly createAgreementForTenancy?: Maybe<CreateAgreementForTenancyPayload>;
  readonly createAmenityReservation?: Maybe<CreateAmenityReservationMutationPayload>;
  readonly createApplicantAndApplication?: Maybe<CreateApplicantAndApplicationPayload>;
  readonly createApplication?: Maybe<CreateApplicationPayload>;
  readonly createApplicationThread?: Maybe<CreateApplicationThreadMutationPayload>;
  readonly createAttachmentOnHome?: Maybe<CreateAttachmentOnHomePayload>;
  readonly createAttachmentOnRequirementItem?: Maybe<CreateAttachmentOnRequirementItemPayload>;
  readonly createBlockComplianceRequirementItem?: Maybe<CreateBlockComplianceRequirementItemPayload>;
  readonly createBlocks?: Maybe<CreateBlocks>;
  readonly createBlocksComplianceRequirement?: Maybe<CreateBlocksComplianceRequirementPayload>;
  readonly createChecklist?: Maybe<CreateChecklistPayload>;
  readonly createChecklistFromTemplate?: Maybe<CreateChecklistFromTemplatePayload>;
  readonly createChecklistItemComment?: Maybe<CreateChecklistItemCommentPayload>;
  readonly createChecklistItemMedia?: Maybe<CreateChecklistItemMediaPayload>;
  readonly createChecklistWithStructure?: Maybe<CreateChecklistWithStructurePayload>;
  readonly createCheckoutLink?: Maybe<CreateCheckoutLinkPayload>;
  readonly createClientContractorCompany?: Maybe<CreateClientContractorCompanyPayload>;
  readonly createClientTag?: Maybe<CreateClientTagPayload>;
  readonly createCommunityDocument?: Maybe<CreateCommunityDocumentPayload>;
  readonly createCommunityDocumentReminder?: Maybe<CreateCommunityDocumentReminderPayload>;
  readonly createCommunityDocumentTag?: Maybe<CreateCommunityDocumentTagPayload>;
  readonly createCommunityDocumentView?: Maybe<CreateCommunityDocumentViewPayload>;
  readonly createCommunityProduct?: Maybe<CreateCommunityProductPayload>;
  readonly createCommunityProductPayment?: Maybe<CreateCommunityProductPaymentPayload>;
  readonly createCommunityTaskDefinition?: Maybe<CreateCommunityTaskDefinitionPayload>;
  readonly createCommunityUpdateRead?: Maybe<CreateCommunityUpdateReadPayload>;
  readonly createCommunityVisitor?: Maybe<CreateCommunityVisitorPayload>;
  readonly createComplianceRequirement?: Maybe<CreateComplianceRequirementPayload>;
  readonly createComplianceUpdateRead?: Maybe<CreateComplianceUpdateReadPayload>;
  readonly createContractor?: Maybe<CreateContractorPayload>;
  readonly createConversation?: Maybe<CreateConversation>;
  readonly createConversationAction?: Maybe<CreateConversationActionPayload>;
  readonly createConversationAndFirstMessage?: Maybe<CreateConversationAndFirstMessage>;
  readonly createConversationAssignment?: Maybe<CreateConversationAssignmentPayload>;
  readonly createConversationMessage?: Maybe<CreateConversationMessage>;
  readonly createConversationNote?: Maybe<CreateConversationNotePayload>;
  readonly createConversationSummary?: Maybe<CreateConversationSummaryPayload>;
  readonly createConversationTag?: Maybe<CreateConversationTagPayload>;
  readonly createFollowUpTaskFromChecklistItem?: Maybe<CreateFollowUpTaskFromChecklistItemPayload>;
  readonly createFollowUpTasksFromChecklistItems?: Maybe<CreateFollowUpTasksFromChecklistItemsPayload>;
  readonly createGroup?: Maybe<CreateGroupPayload>;
  readonly createGroupChatMessage?: Maybe<CreateGroupChatMessagePayload>;
  readonly createGroupChatMessageReaction?: Maybe<CreateGroupChatMessageReactionPayload>;
  readonly createGroupChatMessageReport?: Maybe<CreateGroupChatMessageReportPayload>;
  readonly createKeyV2?: Maybe<CreateKeyV2Payload>;
  readonly createKeyholderV2?: Maybe<CreateKeyholderV2Payload>;
  readonly createManagerConversationRead?: Maybe<CreateManagerConversationReadPayload>;
  readonly createManagerSafetyDeclaration?: Maybe<CreateManagerSafetyDeclarationPayload>;
  /**
   * Left ungated by Access V2 deliberately.
   *
   * ``MarketplaceItemComment`` has no entry in ``RESOURCE_REGISTRY`` and no row
   * in the role matrix, and none of the three registered marketplace resources
   * describes it. ``marketplace_item`` is the closest, but its ownership policy
   * scopes a resident to listings they own, so gating a public comment on it
   * would deny commenting on anyone else's listing once the rollout flag is on
   * — a regression, not a narrowing. Inventing a ``marketplace_item_comment``
   * resource is out of scope for this pathway, so the legacy
   * ``IsResidentOrLeaseholder`` check stands alone until one is added.
   */
  readonly createMarketplaceItemComment?: Maybe<CreateMarketplaceItemCommentPayload>;
  readonly createMarketplaceItemThread?: Maybe<CreateMarketplaceItemThreadPayload>;
  readonly createNewDevice?: Maybe<CreateNewDevice>;
  readonly createOccupancySurvey?: Maybe<CreateOccupancySurvey>;
  readonly createOpenedConversation?: Maybe<CreateOpenedConversation>;
  readonly createOrUpdateUserSession?: Maybe<CreateOrUpdateUserSessionPayload>;
  readonly createPayment?: Maybe<CreatePaymentPayload>;
  readonly createReportingConfiguration?: Maybe<CreateReportingConfigurationPayload>;
  readonly createResidencyAndResidents?: Maybe<CreateResidencyAndResidents>;
  readonly createResidencyDocument?: Maybe<CreateResidencyDocumentPayload>;
  readonly createResidencyDocumentView?: Maybe<CreateResidencyDocumentViewPayload>;
  readonly createResidencyDocuments?: Maybe<CreateResidencyDocuments>;
  readonly createResidencySubscription?: Maybe<CreateResidencySubscriptionPayload>;
  /**
   * Submit (or re-submit) the household's safety records.
   *
   * Decoupled from consent: this mutation only persists declared needs and
   * audits NEEDS_SUBMITTED / NEEDS_UPDATED / OCCUPANT_REMOVED. Consent is
   * captured via the dedicated GiveSafetyConsent / DeclineSafetyConsent
   * mutations called separately from the resident app.
   */
  readonly createResidentSafetyRecord?: Maybe<CreateResidentSafetyRecordPayload>;
  readonly createRule?: Maybe<CreateRulePayload>;
  readonly createRuleAction?: Maybe<CreateRuleActionPayload>;
  readonly createRuleConditions?: Maybe<CreateRuleConditions>;
  readonly createSafetyCenterDocument?: Maybe<CreateSafetyCenterDocumentPayload>;
  readonly createScheduledMessage?: Maybe<CreateScheduledMessagePayload>;
  readonly createStripeAccount?: Maybe<CreateStripeAccount>;
  readonly createSurvey?: Maybe<CreateSurveyPayload>;
  readonly createTask?: Maybe<CreateTaskPayload>;
  readonly createTaskDefinition?: Maybe<CreateTaskDefinitionPayload>;
  readonly createTaskDocument?: Maybe<CreateTaskDocumentPayload>;
  readonly createTaskFromConversation?: Maybe<CreateTaskFromConversationPayload>;
  readonly createTaskGroup?: Maybe<CreateTaskGroupPayload>;
  readonly createTaskTemplate?: Maybe<CreateTaskTemplatePayload>;
  readonly createTeam?: Maybe<CreateTeamPayload>;
  readonly createTemplateFromChecklist?: Maybe<CreateTemplateFromChecklistPayload>;
  readonly createTenancyApplication?: Maybe<CreateTenancyApplicationPayload>;
  readonly createUpdateComment?: Maybe<CreateUpdateCommentPayload>;
  readonly createUserDocument?: Maybe<CreateUserDocumentPayload>;
  readonly createUserDocumentTag?: Maybe<CreateUserDocumentTagPayload>;
  readonly createUserDocumentView?: Maybe<CreateUserDocumentViewPayload>;
  readonly deactivateClientUser?: Maybe<DeactivateClientUserPayload>;
  readonly deactivateGroup?: Maybe<DeactivateGroupPayload>;
  readonly declinePcfra?: Maybe<DeclinePcfra>;
  /** Resident declines (for now) a PCFRA against a specific safety record. */
  readonly declineSafetyConsent?: Maybe<DeclineSafetyConsent>;
  readonly deleteAmenity?: Maybe<DeleteAmenityPayload>;
  readonly deleteApplicant?: Maybe<DeleteApplicant>;
  readonly deleteAttachment?: Maybe<DeleteAttachmentPayload>;
  readonly deleteBlock?: Maybe<DeleteBlockPayload>;
  readonly deleteChecklist?: Maybe<DeleteChecklistPayload>;
  readonly deleteChecklistItemMedia?: Maybe<DeleteChecklistItemMediaPayload>;
  readonly deleteCommunityDocument?: Maybe<DeleteCommunityDocumentPayload>;
  readonly deleteCommunityProduct?: Maybe<DeleteCommunityProductPayload>;
  readonly deleteCommunityUpdate?: Maybe<DeleteCommunityUpdatePayload>;
  readonly deleteCommunityUpdateAttachment?: Maybe<DeleteCommunityUpdateAttachmentPayload>;
  readonly deleteComplianceRequirementV2?: Maybe<DeleteComplianceRequirementV2Payload>;
  readonly deleteConversationTag?: Maybe<DeleteConversationTagPayload>;
  readonly deleteGroupChatMessageReaction?: Maybe<DeleteGroupChatMessageReactionPayload>;
  readonly deleteHome?: Maybe<DeleteHomePayload>;
  readonly deleteHomeImage?: Maybe<DeleteHomeImagePayload>;
  /**
   * Hard-delete one image from a listing.
   *
   * ``IsOwnerOfMarketplaceItemImage`` is the fix for a live hole: this
   * mutation shipped with ``permission_classes = []``, so any authenticated
   * user could delete any listing's image. That fix sits at the legacy layer
   * on purpose — the Access V2 requirement below is inert until
   * ``ACCESS_RBAC_BACKED`` is on and so closes nothing today.
   */
  readonly deleteMarketplaceItemImage?: Maybe<DeleteMarketplaceItemImagePayload>;
  readonly deleteReportingConfiguration?: Maybe<DeleteReportingConfigurationPayload>;
  readonly deleteRuleAction?: Maybe<DeleteRuleActionPayload>;
  readonly deleteRuleCondition?: Maybe<DeleteRuleConditionPayload>;
  readonly deleteUpdateComment?: Maybe<DeleteCommunityUpdateCommentPayload>;
  readonly dismissAsanaPendingTask?: Maybe<DismissAsanaPendingTaskPayload>;
  readonly dismissFeatureAnnouncement?: Maybe<DismissFeatureAnnouncementPayload>;
  readonly editKey?: Maybe<EditKeyPayload>;
  readonly editMember?: Maybe<EditMemberPayload>;
  readonly employerUpdateEmploymentDetails?: Maybe<EmployerUpdateEmploymentDetailsPayload>;
  readonly employerUpdatePersonalDetails?: Maybe<EmployerUpdatePersonalDetailsPayload>;
  readonly fakeCreditCheck?: Maybe<FakeCreditCheckMutationPayload>;
  readonly fakeSendTenantReferenceRequest?: Maybe<FakeSendTenantReferenceRequestPayload>;
  readonly fakeStripeInvoicePaidEvent?: Maybe<FakeStripeInvoicePaidEventPayload>;
  readonly flagChecklistItem?: Maybe<FlagChecklistItemPayload>;
  readonly generateEes?: Maybe<GenerateEes>;
  readonly generateHomeSafetyForm?: Maybe<GenerateHomeSafetyForm>;
  readonly generatePeepsExport?: Maybe<GeneratePeepsExport>;
  readonly generateSafetyDocumentQrPdf?: Maybe<GenerateSafetyDocumentQrPdf>;
  readonly generateSafetyRecordActivityPdf?: Maybe<GenerateSafetyRecordActivityPdf>;
  readonly generateSibPack?: Maybe<GenerateSibPack>;
  readonly generateSibPackQrPdf?: Maybe<GenerateSibPackQrPdf>;
  readonly giveFireServiceConsent?: Maybe<GiveFireServiceConsent>;
  /** Resident gives consent for a PCFRA against a specific safety record. */
  readonly giveSafetyConsent?: Maybe<GiveSafetyConsent>;
  readonly ignoreMessageSuggestion?: Maybe<IgnoreMessageSuggestionPayload>;
  readonly initializeCalendarLink?: Maybe<CalendarLinkType>;
  readonly initializeSignup?: Maybe<InitializeSignup>;
  readonly inviteDemoUser?: Maybe<InviteDemoUserPayload>;
  readonly labelConversation?: Maybe<LabelConversationPayload>;
  readonly landlordUpdateLandlordReference?: Maybe<LandlordUpdateLandlordReferencePayload>;
  readonly landlordUpdateRentalDetails?: Maybe<LandlordUpdateRentalDetailsPayload>;
  readonly linkConversationToTask?: Maybe<LinkConversationToTaskPayload>;
  readonly linkSafetySubject?: Maybe<LinkSafetySubjectPayload>;
  readonly linkTaskToAsana?: Maybe<LinkTaskToAsanaPayload>;
  readonly linkTaskToFixflo?: Maybe<LinkTaskToFixfloPayload>;
  readonly logDocumentRead?: Maybe<LogDocumentReadPayload>;
  readonly logManagerDashUse?: Maybe<LogManagerDashUse>;
  readonly logPublicDocumentRead?: Maybe<LogPublicDocumentReadPayload>;
  readonly logUserAppUse?: Maybe<LogUserAppUsePayload>;
  readonly managerAddApplicationHome?: Maybe<ManagerAddApplicationHomePayload>;
  readonly managerCancelAmenityReservation?: Maybe<ManagerCancelAmenityReservationPayload>;
  readonly managerCreateAmenityReservation?: Maybe<ManagerCreateAmenityReservationPayload>;
  readonly managerReserveAmenity?: Maybe<ManagerReserveAmenityPayload>;
  readonly markApplicationThreadAsRead?: Maybe<MarkApplicationThreadAsReadPayload>;
  readonly markSafetyReviewRequestOpened?: Maybe<MarkSafetyReviewRequestOpened>;
  readonly markSibPackPrinted?: Maybe<MarkSibPackPrinted>;
  readonly markSuggestionShown?: Maybe<MarkSuggestionShownPayload>;
  /**
   * Mark the other participant's messages in a thread as read.
   *
   * Gated on ``marketplace_item_thread`` edit rather than
   * ``marketplace_item_thread_message`` edit: the write targets every unread
   * message in the thread and no message id is supplied, so the thread is the
   * only object the requirement can bind to. Binding the thread still routes
   * through the thread ownership policy, which limits the caller to threads
   * they inquire on or own the listing for.
   */
  readonly markThreadMessagesAsRead?: Maybe<MarkThreadMessagesAsReadPayload>;
  readonly newCreateApplication?: Maybe<NewCreateApplication>;
  readonly offerPcfra?: Maybe<OfferPcfra>;
  readonly officiallyVerifyRightToRent?: Maybe<OfficiallyVerifyRightToRentPayload>;
  readonly orderConversationTags?: Maybe<OrderConversationTagsPayload>;
  readonly packageReminderToAll?: Maybe<PackageReminderToAll>;
  readonly packageReminderToHome?: Maybe<PackageReminderToHomePayload>;
  readonly payForDocument?: Maybe<PayForDocumentPayload>;
  readonly payForUnpaidApplicationReferences?: Maybe<PayForUnpaidApplicationReferencesPayload>;
  readonly publishCommunityUpdate?: Maybe<PublishCommunityUpdatePayload>;
  readonly pushTaskToAsana?: Maybe<PushTaskToAsanaPayload>;
  readonly rateConversation?: Maybe<RateConversationPayload>;
  readonly reOpenConversation?: Maybe<ReOpenConversationPayload>;
  readonly readAllNotifications?: Maybe<ReadAllNotificationsPayload>;
  readonly readAllNotificationsOnTarget?: Maybe<ReadAllNotificationsOnTargetPayload>;
  readonly readNotification?: Maybe<ReadNotificationPayload>;
  readonly reconcileSafetyDeclaration?: Maybe<ReconcileSafetyDeclaration>;
  readonly reconfirmSafetyRecord?: Maybe<ReconfirmSafetyRecord>;
  readonly recordConversationRatingPrompt?: Maybe<RecordConversationRatingPromptPayload>;
  readonly recordReportingConfigurationOpened?: Maybe<RecordReportingConfigurationOpenedPayload>;
  readonly referenceSignupError?: Maybe<ReferenceSignupErrorPayload>;
  readonly rejectApplication?: Maybe<RejectApplication>;
  readonly remindAllApplicants?: Maybe<RemindAllApplicants>;
  readonly remindApplicant?: Maybe<RemindApplicant>;
  readonly remindResident?: Maybe<RemindResidentPayload>;
  readonly removeBlockPlacements?: Maybe<RemoveBlockPlacements>;
  readonly removeConversationTag?: Maybe<RemoveConversationTagPayload>;
  readonly removeResidentFromUnpaidEvents?: Maybe<RemoveResidentFromUnpaidEventsPayload>;
  readonly removeResidentsFromResidency?: Maybe<RemoveResidentsFromResidencyPayload>;
  readonly removeTaskDocument?: Maybe<RemoveTaskDocumentPayload>;
  readonly removeTeamMember?: Maybe<RemoveTeamMemberPayload>;
  readonly renameTask?: Maybe<RenameTaskPayload>;
  readonly resendMemberInviteEmail?: Maybe<ResendMemberInviteEmailPayload>;
  readonly reserveAmenity?: Maybe<ReserveAmenityPayload>;
  readonly reserveAmenitySlot?: Maybe<ReserveAmenitySlotPayload>;
  readonly residentArchiveKeyholder?: Maybe<ResidentArchiveKeyholderPayload>;
  readonly residentCreateKeyholder?: Maybe<ResidentCreateKeyholder>;
  readonly residentUnarchiveKeyholder?: Maybe<ResidentUnarchiveKeyholderPayload>;
  readonly residentUpdateKeyholder?: Maybe<ResidentUpdateKeyholderPayload>;
  readonly resolveChecklistAction?: Maybe<ResolveChecklistActionPayload>;
  readonly respondToContractorSuggestion?: Maybe<RespondToContractorSuggestionPayload>;
  readonly respondToPcfra?: Maybe<RespondToPcfra>;
  readonly restartIdentityVerification?: Maybe<RestartIdentityVerificationPayload>;
  readonly retryDocumentExtraction?: Maybe<RetryDocumentExtractionPayload>;
  readonly reviewInspectionAction?: Maybe<ReviewInspectionActionPayload>;
  readonly revokeCommunityStaffRole?: Maybe<RevokeCommunityStaffRolePayload>;
  readonly revokeGeneratedAgreement?: Maybe<RevokeGeneratedAgreementPayload>;
  readonly rotateSafetyResponderToken?: Maybe<RotateSafetyResponderToken>;
  readonly saveAmenity?: Maybe<SaveAmenityPayload>;
  readonly saveAmenityOperatingTimes?: Maybe<SaveAmenityOperatingTimesPayload>;
  readonly saveCommunityEvent?: Maybe<SaveCommunityEventPayload>;
  readonly saveCommunityUpdate?: Maybe<SaveCommunityUpdatePayload>;
  readonly saveContactNote?: Maybe<SaveContactNotePayload>;
  readonly saveGeneratedAgreement?: Maybe<SaveGeneratedAgreementPayload>;
  readonly saveGeneratedSection21?: Maybe<SaveGeneratedSection21Payload>;
  readonly saveHome?: Maybe<SaveHomePayload>;
  readonly saveManagerProfile?: Maybe<SaveManagerProfilePayload>;
  readonly saveMarketplaceItem?: Maybe<SaveMarketplaceItemPayload>;
  readonly saveRequirementItem?: Maybe<SaveRequirementItemPayload>;
  readonly saveResidentSurveyAnswer?: Maybe<SaveResidentSurveyAnswerPayload>;
  readonly saveTenantEmploymentDetails?: Maybe<SaveTenantEmploymentDetailsPayload>;
  readonly schedulePublishCommunityUpdate?: Maybe<SchedulePublishCommunityUpdatePayload>;
  readonly sendAgreementForSigning?: Maybe<SendAgreementForSigning>;
  readonly sendApplicationSupportMessage?: Maybe<SendApplicationSupportMessagePayload>;
  readonly sendApplicationThreadMessage?: Maybe<SendApplicationThreadMessagePayload>;
  readonly sendConversationToAsana?: Maybe<SendConversationToAsanaPayload>;
  readonly sendDocument?: Maybe<SendDocument>;
  readonly sendManagerAmplitudeTest?: Maybe<SendManagerAmplitudeTestPayload>;
  readonly sendPaymentReceiptEmail?: Maybe<SendPaymentReceiptEmailPayload>;
  readonly sendSafetyReminder?: Maybe<SendSafetyReminder>;
  readonly sendSafetyReviewRequest?: Maybe<SendSafetyReviewRequest>;
  readonly sendTenantReferenceRequests?: Maybe<SendTenantReferenceRequestsPayload>;
  readonly setChecklistItemDueDate?: Maybe<SetChecklistItemDueDatePayload>;
  readonly setChecklistSectionDueDate?: Maybe<SetChecklistSectionDueDatePayload>;
  readonly setConversationHome?: Maybe<SetConversationHomePayload>;
  readonly setReportingFavourite?: Maybe<SetReportingFavouritePayload>;
  readonly setReportingSchedule?: Maybe<SetReportingSchedulePayload>;
  readonly setResidencyCompletionDate?: Maybe<SetResidencyCompletionDatePayload>;
  readonly setResidentAppLocale?: Maybe<SetResidentAppLocalePayload>;
  readonly setSafetyDocumentBlock?: Maybe<SetSafetyDocumentBlock>;
  readonly setSafetyDocumentInSibPack?: Maybe<SetSafetyDocumentInSibPack>;
  readonly setSafetyDocumentResidentVisible?: Maybe<SetSafetyDocumentResidentVisible>;
  readonly setSafetySubjectContactEmail?: Maybe<SetSafetySubjectContactEmailPayload>;
  readonly setUpManager?: Maybe<SetUpManagerPayload>;
  readonly shareComplianceRequirement?: Maybe<ShareComplianceRequirementPayload>;
  readonly signOffChecklist?: Maybe<SignOffChecklistPayload>;
  readonly signOutCommunityVisitor?: Maybe<SignOutCommunityVisitorPayload>;
  readonly snoozeConversation?: Maybe<SnoozeConversationPayload>;
  readonly startBulkConversationClose?: Maybe<StartBulkConversationClose>;
  readonly startBulkDeactivation?: Maybe<StartBulkDeactivationPayload>;
  readonly submitEmployerReference?: Maybe<SubmitEmployerReferencePayload>;
  readonly submitIdentityVerification?: Maybe<SubmitIdentityVerificationPayload>;
  readonly submitLandlordReference?: Maybe<SubmitLandlordReferencePayload>;
  readonly submitTenantReference?: Maybe<SubmitTenantReferencePayload>;
  readonly subscribeLandlord?: Maybe<SubscribeLandlordPayload>;
  readonly subscribeToNotificationGroup?: Maybe<SubscribeToNotificationGroup>;
  readonly suggestRemediationSteps?: Maybe<SuggestRemediationStepsPayload>;
  readonly syncBlockGroups?: Maybe<SyncBlockGroupsPayload>;
  readonly tagConversation?: Maybe<TagConversationPayload>;
  readonly toggleAllResidentAppNotificationPreferences?: Maybe<ToggleAllResidentAppNotificationPreferencesPayload>;
  readonly toggleArchivedAtCommunityDocument?: Maybe<ToggleArchivedAtCommunityDocumentPayload>;
  readonly toggleArchivedAtCommunityUpdate?: Maybe<ToggleArchivedAtCommunityUpdatePayload>;
  readonly toggleClientTagArchivedAt?: Maybe<ToggleClientTagArchivedAtPayload>;
  readonly toggleCommunityUpdateBookmark?: Maybe<ToggleCommunityUpdateBookmarkPayload>;
  readonly toggleCommunityUpdateLike?: Maybe<ToggleCommunityUpdateLikePayload>;
  readonly toggleMarketplaceItemClose?: Maybe<ToggleMarketplaceItemClosePayload>;
  readonly toggleRuleActivated?: Maybe<ToggleRuleActivatedPayload>;
  readonly toggleTeamActivated?: Maybe<ToggleTeamActivatedPayload>;
  readonly unarchiveApplication?: Maybe<UnarchiveApplicationPayload>;
  readonly unarchiveKey?: Maybe<UnarchiveKeyPayload>;
  readonly unarchiveKeyholder?: Maybe<UnarchiveKeyholderPayload>;
  readonly unarchiveTask?: Maybe<UnarchiveTaskPayload>;
  readonly unarchiveTaskGroup?: Maybe<UnarchiveTaskGroupPayload>;
  readonly unarchiveTaskTemplate?: Maybe<UnarchiveTaskTemplatePayload>;
  readonly unassignClientTag?: Maybe<UnassignClientTagPayload>;
  readonly unassignClientTagFromCommunityDocument?: Maybe<UnassignClientTagFromCommunityDocumentPayload>;
  readonly unassignClientTagFromTaskDefinition?: Maybe<UnassignClientTagFromTaskDefinitionPayload>;
  readonly unassignClientTagFromUserDocument?: Maybe<UnassignClientTagFromUserDocumentPayload>;
  readonly unassignTeam?: Maybe<UnassignTeamPayload>;
  readonly unbookCommunityEvent?: Maybe<UnbookCommunityEventMutationPayload>;
  readonly unflagChecklistItem?: Maybe<UnflagChecklistItemPayload>;
  readonly unlabelConversation?: Maybe<UnlabelConversationPayload>;
  readonly unlinkTaskFromAsana?: Maybe<UnlinkTaskFromAsanaPayload>;
  readonly unlinkTaskFromFixflo?: Maybe<UnlinkTaskFromFixfloPayload>;
  readonly unreadAllNotificationsOnTarget?: Maybe<UnreadAllNotificationsOnTargetPayload>;
  readonly unreadNotification?: Maybe<UnreadNotificationPayload>;
  readonly unsnoozeConversation?: Maybe<UnsnoozeConversationPayload>;
  readonly unsubscribeFromNotificationGroup?: Maybe<UnsubscribeFromNotificationGroup>;
  readonly updateAmenityOperatingSchedule?: Maybe<UpdateAmenityOperatingSchedulePayload>;
  readonly updateAmenityType?: Maybe<UpdateAmenityTypePayload>;
  readonly updateApplicationCommunity?: Maybe<UpdateApplicationCommunity>;
  readonly updateApplicationHome?: Maybe<UpdateApplicationHome>;
  readonly updateAttachment?: Maybe<UpdateAttachmentPayload>;
  readonly updateBlock?: Maybe<UpdateBlockPayload>;
  readonly updateBlockGroupPinnedHomes?: Maybe<UpdateBlockGroupPinnedHomesPayload>;
  readonly updateBlockHomes?: Maybe<UpdateBlockHomesPayload>;
  readonly updateBlockSafetyIdentity?: Maybe<UpdateBlockSafetyIdentityPayload>;
  readonly updateChecklist?: Maybe<UpdateChecklistPayload>;
  readonly updateChecklistStructure?: Maybe<UpdateChecklistStructurePayload>;
  readonly updateClientAdmin?: Maybe<UpdateClientAdminPayload>;
  readonly updateClientContractorCompany?: Maybe<UpdateClientContractorCompanyPayload>;
  readonly updateClientContractorCompanyCommunities?: Maybe<UpdateClientContractorCompanyCommunitiesPayload>;
  readonly updateClientContractorCompanyContractors?: Maybe<UpdateClientContractorCompanyContractorsPayload>;
  readonly updateClientTag?: Maybe<UpdateClientTagPayload>;
  readonly updateClientTagColor?: Maybe<UpdateClientTagColorPayload>;
  readonly updateCommunityDocument?: Maybe<UpdateCommunityDocumentPayload>;
  readonly updateCommunityProduct?: Maybe<UpdateCommunityProductPayload>;
  /** Set the Responsible Person details printed on EES PDFs. */
  readonly updateCommunityResponsiblePerson?: Maybe<UpdateCommunityResponsiblePerson>;
  readonly updateCommunitySettings?: Maybe<UpdateCommunitySettingsPayload>;
  /** Toggle the annual SIB-pack review nudge and tweak the lead-time months. */
  readonly updateCommunitySibPackReviewSettings?: Maybe<UpdateCommunitySibPackReviewSettings>;
  readonly updateCommunityTaskDefinition?: Maybe<UpdateCommunityTaskDefinitionPayload>;
  readonly updateContactGroups?: Maybe<UpdateContactGroupsPayload>;
  readonly updateContractor?: Maybe<UpdateContractorPayload>;
  readonly updateConversationNote?: Maybe<UpdateConversationNotePayload>;
  readonly updateConversationParticipantType?: Maybe<UpdateConversationParticipantTypePayload>;
  readonly updateConversationTag?: Maybe<UpdateConversationTagPayload>;
  readonly updateConversationTitle?: Maybe<UpdateConversationTitlePayload>;
  readonly updateConversationUrgency?: Maybe<UpdateConversationUrgency>;
  readonly updateEmployerReference?: Maybe<UpdateEmployerReferencePayload>;
  readonly updateEmployerReferenceStep?: Maybe<UpdateEmployerReferenceStepPayload>;
  readonly updateGroup?: Maybe<UpdateGroupPayload>;
  readonly updateGroupDescription?: Maybe<UpdateGroupDescriptionPayload>;
  readonly updateHomeAddress?: Maybe<UpdateHomeAddressPayload>;
  readonly updateHomeDetails?: Maybe<UpdateHomeDetailsPayload>;
  readonly updateHomeFloorNumber?: Maybe<UpdateHomeFloorNumberPayload>;
  readonly updateKeyholder?: Maybe<UpdateKeyholderPayload>;
  readonly updateLandlord?: Maybe<UpdateLandlordPayload>;
  readonly updateLandlordReference?: Maybe<UpdateLandlordReferencePayload>;
  readonly updateLandlordReferenceComments?: Maybe<UpdateLandlordReferenceCommentsPayload>;
  readonly updateLandlordReferenceStep?: Maybe<UpdateLandlordReferenceStepPayload>;
  readonly updateManager?: Maybe<UpdateManagerPayload>;
  readonly updateManagerNotificationSettings?: Maybe<UpdateManagerNotificationSettingsPayload>;
  readonly updateMobileNumber?: Maybe<UpdateUserMobileNumberPayload>;
  readonly updateNotificationPreference?: Maybe<UpdateNotificationPreferencePayload>;
  readonly updatePackageLocation?: Maybe<UpdatePackageLocationPayload>;
  readonly updatePackageStatus?: Maybe<UpdatePackageStatusPayload>;
  readonly updateReferenceAddressHistory?: Maybe<UpdateReferenceAddressHistoryPayload>;
  readonly updateReferenceStartedOn?: Maybe<UpdateReferenceStartedOnPayload>;
  readonly updateReportingConfiguration?: Maybe<UpdateReportingConfigurationPayload>;
  readonly updateResidencyAndResidents?: Maybe<UpdateResidencyAndResidents>;
  readonly updateResidencyDocument?: Maybe<UpdateResidencyDocumentPayload>;
  readonly updateResidentAppNotificationPreferences?: Maybe<UpdateResidentAppNotificationPreferencesPayload>;
  readonly updateResidentSafetyRecord?: Maybe<UpdateResidentSafetyRecord>;
  readonly updateRightToRent?: Maybe<UpdateRightToRentPayload>;
  readonly updateRule?: Maybe<UpdateRulePayload>;
  readonly updateRuleCategoryContentTypes?: Maybe<UpdateRuleCategoryContentTypes>;
  readonly updateRuleCommunities?: Maybe<UpdateRuleCommunitiesPayload>;
  readonly updateRuleCondition?: Maybe<UpdateRuleConditionPayload>;
  readonly updateSafetyCenterDocument?: Maybe<UpdateSafetyCenterDocumentPayload>;
  readonly updateSafetyReviewInterval?: Maybe<UpdateSafetyReviewInterval>;
  readonly updateScheduledMessage?: Maybe<UpdateScheduledMessage>;
  readonly updateTask?: Maybe<UpdateTaskPayload>;
  readonly updateTaskDefinitionDescription?: Maybe<UpdateTaskDefinitionDescriptionPayload>;
  readonly updateTaskDefinitionPriority?: Maybe<UpdateTaskDefinitionPriorityPayload>;
  readonly updateTaskDefinitionVisibility?: Maybe<UpdateTaskDefinitionVisibilityPayload>;
  readonly updateTaskGroup?: Maybe<UpdateTaskGroupPayload>;
  readonly updateTaskPriority?: Maybe<UpdateTaskPriorityPayload>;
  readonly updateTaskTemplate?: Maybe<UpdateTaskTemplatePayload>;
  readonly updateTaskTemplateStructure?: Maybe<UpdateTaskTemplateStructurePayload>;
  readonly updateTeamCommunities?: Maybe<UpdateTeamCommunitiesPayload>;
  readonly updateTeamDetails?: Maybe<UpdateTeamDetailsPayload>;
  readonly updateTeamIcon?: Maybe<UpdateTeamIconPayload>;
  readonly updateTeamMembers?: Maybe<UpdateTeamMembersPayload>;
  readonly updateTenantReference?: Maybe<UpdateTenantReferencePayload>;
  readonly updateTenantReferenceStep?: Maybe<UpdateTenantReferenceStepPayload>;
  readonly updateUser?: Maybe<UpdateUserPayload>;
  readonly updateUserDocument?: Maybe<UpdateUserDocumentPayload>;
  readonly updateUserProfile?: Maybe<UpdateUserProfilePayload>;
  readonly upgradeLandlordToSubscription?: Maybe<UpgradeLandlordToSubscriptionPayload>;
  readonly viewFeatureAnnouncement?: Maybe<ViewFeatureAnnouncementPayload>;
  readonly viewUserFeatureAnnouncement?: Maybe<ViewUserFeatureAnnouncementPayload>;
  readonly voidSafetyDeclaration?: Maybe<VoidSafetyDeclaration>;
  readonly withdrawFireServiceConsent?: Maybe<WithdrawFireServiceConsent>;
};


export type MutationAcceptApplicationArgs = {
  application: Scalars['UUID']['input'];
  home?: InputMaybe<Scalars['UUID']['input']>;
};


export type MutationAcceptAsanaPendingTaskArgs = {
  input: AcceptAsanaPendingTaskInput;
};


export type MutationAcceptFeatureAnnouncementArgs = {
  input: AcceptFeatureAnnouncementInput;
};


export type MutationAcceptMessageSuggestionArgs = {
  input: AcceptMessageSuggestionInput;
};


export type MutationAcceptServiceChargeWaiverArgs = {
  input: AcceptServiceChargeWaiverInput;
};


export type MutationAcceptTermsAndConditionsArgs = {
  input: AcceptTermsAndConditionsInput;
};


export type MutationAcceptWaiverArgs = {
  input: AcceptWaiverInput;
};


export type MutationActivateGroupArgs = {
  input: ActivateGroupInput;
};


export type MutationActivateSafetyComplianceV2Args = {
  communityId: Scalars['UUID']['input'];
  confirm: Scalars['Boolean']['input'];
};


export type MutationActivateSafetyResponderTokenArgs = {
  packId: Scalars['UUID']['input'];
  replacementQrsInstalled: Scalars['Boolean']['input'];
};


export type MutationAddApplicationCommunityArgs = {
  application: Scalars['UUID']['input'];
  community: Scalars['UUID']['input'];
};


export type MutationAddApplicationHomeArgs = {
  application: Scalars['ID']['input'];
  home: Scalars['UUID']['input'];
};


export type MutationAddApplicationOwnershipTypeArgs = {
  application: Scalars['ID']['input'];
  isResident: Scalars['Boolean']['input'];
  ownershipType: Scalars['String']['input'];
};


export type MutationAddContractorToClientContractorCompanyArgs = {
  input: AddContractorToClientContractorCompanyInput;
};


export type MutationAddDocumentSentStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationAddFeatureToClientArgs = {
  input: AddFeatureToClientInput;
};


export type MutationAddMemberArgs = {
  input: AddMemberInput;
};


export type MutationAddMessageToThreadArgs = {
  input: AddMessageToThreadInput;
};


export type MutationAddPackageToHomeArgs = {
  input: AddPackageToHomeInput;
};


export type MutationAddTaskCommentArgs = {
  input: AddTaskCommentInput;
};


export type MutationAddTeamMembersArgs = {
  input: AddTeamMembersInput;
};


export type MutationAddUnknownCommunityStatusArgs = {
  application: Scalars['ID']['input'];
};


export type MutationAgreeEesArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationArchiveAllNotificationsOnTargetArgs = {
  input: ArchiveAllNotificationsOnTargetInput;
};


export type MutationArchiveApplicationArgs = {
  input: ArchiveApplicationInput;
};


export type MutationArchiveCommunityEventArgs = {
  input: ArchiveCommunityEventInput;
};


export type MutationArchiveContactNoteArgs = {
  input: ArchiveContactNoteInput;
};


export type MutationArchiveKeyArgs = {
  input: ArchiveKeyInput;
};


export type MutationArchiveKeyholderArgs = {
  input: ArchiveKeyholderInput;
};


export type MutationArchiveMarketplaceItemArgs = {
  input: ArchiveMarketplaceItemInput;
};


export type MutationArchiveNotificationArgs = {
  input: ArchiveNotificationInput;
};


export type MutationArchiveSafetyCenterDocumentArgs = {
  input: ArchiveSafetyCenterDocumentInput;
};


export type MutationArchiveSafetySubjectArgs = {
  input: ArchiveSafetySubjectInput;
};


export type MutationArchiveTagArgs = {
  input: ArchiveTagInput;
};


export type MutationArchiveTaskArgs = {
  input: ArchiveTaskInput;
};


export type MutationArchiveTaskGroupArgs = {
  input: ArchiveTaskGroupInput;
};


export type MutationArchiveTaskTemplateArgs = {
  input: ArchiveTaskTemplateInput;
};


export type MutationAssignChecklistItemArgs = {
  input: AssignChecklistItemInput;
};


export type MutationAssignChecklistSectionArgs = {
  input: AssignChecklistSectionInput;
};


export type MutationAssignClientTagArgs = {
  input: AssignClientTagInput;
};


export type MutationAssignClientTagToCommunityDocumentArgs = {
  input: AssignClientTagToCommunityDocumentInput;
};


export type MutationAssignClientTagToTaskDefinitionArgs = {
  input: AssignClientTagToTaskDefinitionInput;
};


export type MutationAssignClientTagToUserDocumentArgs = {
  input: AssignClientTagToUserDocumentInput;
};


export type MutationAssignCommunityStaffRoleArgs = {
  input: AssignCommunityStaffRoleInput;
};


export type MutationAssignContractorToTaskArgs = {
  input: AssignContractorToTaskInput;
};


export type MutationAssignTaskArgs = {
  input: AssignTaskInput;
};


export type MutationAssignTeamArgs = {
  input: AssignTeamInput;
};


export type MutationAssociateAgreementWithClientArgs = {
  input: AssociateAgreementWithClientInput;
};


export type MutationAssociateSection21WithClientArgs = {
  input: AssociateSection21WithClientInput;
};


export type MutationBatchCreateTaskDocumentsArgs = {
  input: BatchCreateTaskDocumentsInput;
};


export type MutationBookCommunityEventArgs = {
  input: BookCommunityEventMutationInput;
};


export type MutationBookPaidCommunityEventArgs = {
  input: BookPaidCommunityEventMutationInput;
};


export type MutationCancelAmenityReservationArgs = {
  input: CancelAmenityReservationInput;
};


export type MutationCancelPaymentArgs = {
  input: CancelPaymentInput;
};


export type MutationCancelScheduledMessageArgs = {
  input: CancelScheduledMessageInput;
};


export type MutationCancelScheduledPublishCommunityUpdateArgs = {
  input: CancelScheduledPublishCommunityUpdateInput;
};


export type MutationChangeTaskStatusArgs = {
  input: ChangeTaskStatusInput;
};


export type MutationCheckInKeyV2Args = {
  input: CheckInKeyV2Input;
};


export type MutationCheckOutKeyV2Args = {
  input: CheckOutKeyV2Input;
};


export type MutationCloseConversationArgs = {
  input: CloseConversationInput;
};


export type MutationCloseSurveyArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationCollectPackagesArgs = {
  input: CollectPackagesInput;
};


export type MutationCollectPackagesForHomeArgs = {
  input: CollectPackagesForHomeInput;
};


export type MutationCompleteChecklistItemArgs = {
  input: CompleteChecklistItemInput;
};


export type MutationConfirmBlockPlacementsArgs = {
  blockId: Scalars['ID']['input'];
};


export type MutationConfirmBlockSetupArgs = {
  communityId: Scalars['ID']['input'];
  runId: Scalars['ID']['input'];
};


export type MutationConfirmResidencyWillRollArgs = {
  input: ConfirmResidencyWillRollInput;
};


export type MutationContactApplicationSupportArgs = {
  input: ContactApplicationSupportInput;
};


export type MutationContactPackagesReminderArgs = {
  input: ContactPackagesReminderInput;
};


export type MutationCorrectInspectionSeriesArgs = {
  input: CorrectInspectionSeriesInput;
};


export type MutationCountersignAgreementArgs = {
  input: CountersignAgreementInput;
};


export type MutationCreateAgreementForTenancyArgs = {
  input: CreateAgreementForTenancyInput;
};


export type MutationCreateAmenityReservationArgs = {
  input: CreateAmenityReservationMutationInput;
};


export type MutationCreateApplicantAndApplicationArgs = {
  input: CreateApplicantAndApplicationInput;
};


export type MutationCreateApplicationArgs = {
  input: CreateApplicationInput;
};


export type MutationCreateApplicationThreadArgs = {
  input: CreateApplicationThreadMutationInput;
};


export type MutationCreateAttachmentOnHomeArgs = {
  input: CreateAttachmentOnHomeInput;
};


export type MutationCreateAttachmentOnRequirementItemArgs = {
  input: CreateAttachmentOnRequirementItemInput;
};


export type MutationCreateBlockComplianceRequirementItemArgs = {
  input: CreateBlockComplianceRequirementItemInput;
};


export type MutationCreateBlocksArgs = {
  blockNames?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communityId: Scalars['UUID']['input'];
};


export type MutationCreateBlocksComplianceRequirementArgs = {
  input: CreateBlocksComplianceRequirementInput;
};


export type MutationCreateChecklistArgs = {
  input: CreateChecklistInput;
};


export type MutationCreateChecklistFromTemplateArgs = {
  input: CreateChecklistFromTemplateInput;
};


export type MutationCreateChecklistItemCommentArgs = {
  input: CreateChecklistItemCommentInput;
};


export type MutationCreateChecklistItemMediaArgs = {
  input: CreateChecklistItemMediaInput;
};


export type MutationCreateChecklistWithStructureArgs = {
  input: CreateChecklistWithStructureInput;
};


export type MutationCreateCheckoutLinkArgs = {
  input: CreateCheckoutLinkInput;
};


export type MutationCreateClientContractorCompanyArgs = {
  input: CreateClientContractorCompanyInput;
};


export type MutationCreateClientTagArgs = {
  input: CreateClientTagInput;
};


export type MutationCreateCommunityDocumentArgs = {
  input: CreateCommunityDocumentInput;
};


export type MutationCreateCommunityDocumentReminderArgs = {
  input: CreateCommunityDocumentReminderInput;
};


export type MutationCreateCommunityDocumentTagArgs = {
  input: CreateCommunityDocumentTagInput;
};


export type MutationCreateCommunityDocumentViewArgs = {
  input: CreateCommunityDocumentViewInput;
};


export type MutationCreateCommunityProductArgs = {
  input: CreateCommunityProductInput;
};


export type MutationCreateCommunityProductPaymentArgs = {
  input: CreateCommunityProductPaymentInput;
};


export type MutationCreateCommunityTaskDefinitionArgs = {
  input: CreateCommunityTaskDefinitionInput;
};


export type MutationCreateCommunityUpdateReadArgs = {
  input: CreateCommunityUpdateReadInput;
};


export type MutationCreateCommunityVisitorArgs = {
  input: CreateCommunityVisitorInput;
};


export type MutationCreateComplianceRequirementArgs = {
  input: CreateComplianceRequirementInput;
};


export type MutationCreateComplianceUpdateReadArgs = {
  input: CreateComplianceUpdateReadInput;
};


export type MutationCreateContractorArgs = {
  input: CreateContractorInput;
};


export type MutationCreateConversationArgs = {
  input: CreateConversationInput;
  sender: ConversationRole;
};


export type MutationCreateConversationActionArgs = {
  input: CreateConversationActionInput;
};


export type MutationCreateConversationAndFirstMessageArgs = {
  input: CreateConversationAndFirstMessageInput;
};


export type MutationCreateConversationAssignmentArgs = {
  input: CreateConversationAssignmentInput;
};


export type MutationCreateConversationMessageArgs = {
  input: CreateConversationMessageInput;
  sender: ConversationRole;
};


export type MutationCreateConversationNoteArgs = {
  input: CreateConversationNoteInput;
};


export type MutationCreateConversationSummaryArgs = {
  input: CreateConversationSummaryInput;
};


export type MutationCreateConversationTagArgs = {
  input: CreateConversationTagInput;
};


export type MutationCreateFollowUpTaskFromChecklistItemArgs = {
  input: CreateFollowUpTaskFromChecklistItemInput;
};


export type MutationCreateFollowUpTasksFromChecklistItemsArgs = {
  input: CreateFollowUpTasksFromChecklistItemsInput;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupChatMessageArgs = {
  input: CreateGroupChatMessageInput;
};


export type MutationCreateGroupChatMessageReactionArgs = {
  input: CreateGroupChatMessageReactionInput;
};


export type MutationCreateGroupChatMessageReportArgs = {
  input: CreateGroupChatMessageReportInput;
};


export type MutationCreateKeyV2Args = {
  input: CreateKeyV2Input;
};


export type MutationCreateKeyholderV2Args = {
  input: CreateKeyholderV2Input;
};


export type MutationCreateManagerConversationReadArgs = {
  input: CreateManagerConversationReadInput;
};


export type MutationCreateManagerSafetyDeclarationArgs = {
  input: CreateManagerSafetyDeclarationInput;
};


export type MutationCreateMarketplaceItemCommentArgs = {
  input: CreateMarketplaceItemCommentInput;
};


export type MutationCreateMarketplaceItemThreadArgs = {
  input: CreateMarketplaceItemThreadInput;
};


export type MutationCreateNewDeviceArgs = {
  input: CreateNewDeviceInput;
};


export type MutationCreateOccupancySurveyArgs = {
  isOccupant: Scalars['Boolean']['input'];
  occupants?: InputMaybe<ReadonlyArray<InputMaybe<OccupantInput>>>;
  residencyId: Scalars['UUID']['input'];
};


export type MutationCreateOpenedConversationArgs = {
  input: CreateOpenedConversationInput;
};


export type MutationCreateOrUpdateUserSessionArgs = {
  input: CreateOrUpdateUserSessionInput;
};


export type MutationCreatePaymentArgs = {
  input: CreatePaymentInput;
};


export type MutationCreateReportingConfigurationArgs = {
  input: CreateReportingConfigurationInput;
};


export type MutationCreateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationCreateResidencyDocumentArgs = {
  input: CreateResidencyDocumentInput;
};


export type MutationCreateResidencyDocumentViewArgs = {
  input: CreateResidencyDocumentViewInput;
};


export type MutationCreateResidencyDocumentsArgs = {
  input: CreateResidencyDocumentsInput;
};


export type MutationCreateResidencySubscriptionArgs = {
  input: CreateResidencySubscriptionInput;
};


export type MutationCreateResidentSafetyRecordArgs = {
  input: CreateResidentSafetyRecordInput;
};


export type MutationCreateRuleArgs = {
  input: CreateRuleInput;
};


export type MutationCreateRuleActionArgs = {
  input: CreateRuleActionInput;
};


export type MutationCreateRuleConditionsArgs = {
  input: CreateRuleConditionsInput;
};


export type MutationCreateSafetyCenterDocumentArgs = {
  input: CreateSafetyCenterDocumentInput;
};


export type MutationCreateScheduledMessageArgs = {
  input: CreateScheduledMessageInput;
};


export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


export type MutationCreateTaskArgs = {
  input: CreateTaskInput;
};


export type MutationCreateTaskDefinitionArgs = {
  input: CreateTaskDefinitionInput;
};


export type MutationCreateTaskDocumentArgs = {
  input: CreateTaskDocumentInput;
};


export type MutationCreateTaskFromConversationArgs = {
  input: CreateTaskFromConversationInput;
};


export type MutationCreateTaskGroupArgs = {
  input: CreateTaskGroupInput;
};


export type MutationCreateTaskTemplateArgs = {
  input: CreateTaskTemplateInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTemplateFromChecklistArgs = {
  input: CreateTemplateFromChecklistInput;
};


export type MutationCreateTenancyApplicationArgs = {
  input: CreateTenancyApplicationInput;
};


export type MutationCreateUpdateCommentArgs = {
  input: CreateUpdateCommentInput;
};


export type MutationCreateUserDocumentArgs = {
  input: CreateUserDocumentInput;
};


export type MutationCreateUserDocumentTagArgs = {
  input: CreateUserDocumentTagInput;
};


export type MutationCreateUserDocumentViewArgs = {
  input: CreateUserDocumentViewInput;
};


export type MutationDeactivateClientUserArgs = {
  input: DeactivateClientUserInput;
};


export type MutationDeactivateGroupArgs = {
  input: DeactivateGroupInput;
};


export type MutationDeclinePcfraArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeclineSafetyConsentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationDeleteAmenityArgs = {
  input: DeleteAmenityInput;
};


export type MutationDeleteAttachmentArgs = {
  input: DeleteAttachmentInput;
};


export type MutationDeleteBlockArgs = {
  input: DeleteBlockInput;
};


export type MutationDeleteChecklistArgs = {
  input: DeleteChecklistInput;
};


export type MutationDeleteChecklistItemMediaArgs = {
  input: DeleteChecklistItemMediaInput;
};


export type MutationDeleteCommunityDocumentArgs = {
  input: DeleteCommunityDocumentInput;
};


export type MutationDeleteCommunityProductArgs = {
  input: DeleteCommunityProductInput;
};


export type MutationDeleteCommunityUpdateArgs = {
  input: DeleteCommunityUpdateInput;
};


export type MutationDeleteCommunityUpdateAttachmentArgs = {
  input: DeleteCommunityUpdateAttachmentInput;
};


export type MutationDeleteComplianceRequirementV2Args = {
  input: DeleteComplianceRequirementV2Input;
};


export type MutationDeleteConversationTagArgs = {
  input: DeleteConversationTagInput;
};


export type MutationDeleteGroupChatMessageReactionArgs = {
  input: DeleteGroupChatMessageReactionInput;
};


export type MutationDeleteHomeArgs = {
  input: DeleteHomeInput;
};


export type MutationDeleteHomeImageArgs = {
  input: DeleteHomeImageInput;
};


export type MutationDeleteMarketplaceItemImageArgs = {
  input: DeleteMarketplaceItemImageInput;
};


export type MutationDeleteReportingConfigurationArgs = {
  input: DeleteReportingConfigurationInput;
};


export type MutationDeleteRuleActionArgs = {
  input: DeleteRuleActionInput;
};


export type MutationDeleteRuleConditionArgs = {
  input: DeleteRuleConditionInput;
};


export type MutationDeleteUpdateCommentArgs = {
  input: DeleteCommunityUpdateCommentInput;
};


export type MutationDismissAsanaPendingTaskArgs = {
  input: DismissAsanaPendingTaskInput;
};


export type MutationDismissFeatureAnnouncementArgs = {
  input: DismissFeatureAnnouncementInput;
};


export type MutationEditKeyArgs = {
  input: EditKeyInput;
};


export type MutationEditMemberArgs = {
  input: EditMemberInput;
};


export type MutationEmployerUpdateEmploymentDetailsArgs = {
  input: EmployerUpdateEmploymentDetailsInput;
};


export type MutationEmployerUpdatePersonalDetailsArgs = {
  input: EmployerUpdatePersonalDetailsInput;
};


export type MutationFakeCreditCheckArgs = {
  input: FakeCreditCheckMutationInput;
};


export type MutationFakeSendTenantReferenceRequestArgs = {
  input: FakeSendTenantReferenceRequestInput;
};


export type MutationFakeStripeInvoicePaidEventArgs = {
  input: FakeStripeInvoicePaidEventInput;
};


export type MutationFlagChecklistItemArgs = {
  input: FlagChecklistItemInput;
};


export type MutationGenerateEesArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateHomeSafetyFormArgs = {
  homeId: Scalars['UUID']['input'];
  recordId?: InputMaybe<Scalars['UUID']['input']>;
  scope?: InputMaybe<SafetyPaperFormScope>;
};


export type MutationGeneratePeepsExportArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationGenerateSafetyDocumentQrPdfArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationGenerateSafetyRecordActivityPdfArgs = {
  recordId: Scalars['UUID']['input'];
};


export type MutationGenerateSibPackArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationGenerateSibPackQrPdfArgs = {
  communityId: Scalars['UUID']['input'];
};


export type MutationGiveFireServiceConsentArgs = {
  authority?: InputMaybe<SafetyComplianceAuthority>;
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  representativeName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGiveSafetyConsentArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationIgnoreMessageSuggestionArgs = {
  input: IgnoreMessageSuggestionInput;
};


export type MutationInitializeSignupArgs = {
  acceptedMarketing?: InputMaybe<Scalars['Boolean']['input']>;
  suppressWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationInviteDemoUserArgs = {
  input: InviteDemoUserInput;
};


export type MutationLabelConversationArgs = {
  input: LabelConversationInput;
};


export type MutationLandlordUpdateLandlordReferenceArgs = {
  input: LandlordUpdateLandlordReferenceInput;
};


export type MutationLandlordUpdateRentalDetailsArgs = {
  input: LandlordUpdateRentalDetailsInput;
};


export type MutationLinkConversationToTaskArgs = {
  input: LinkConversationToTaskInput;
};


export type MutationLinkSafetySubjectArgs = {
  input: LinkSafetySubjectInput;
};


export type MutationLinkTaskToAsanaArgs = {
  input: LinkTaskToAsanaInput;
};


export type MutationLinkTaskToFixfloArgs = {
  input: LinkTaskToFixfloInput;
};


export type MutationLogDocumentReadArgs = {
  input: LogDocumentReadInput;
};


export type MutationLogPublicDocumentReadArgs = {
  input: LogPublicDocumentReadInput;
};


export type MutationLogUserAppUseArgs = {
  input: LogUserAppUseInput;
};


export type MutationManagerAddApplicationHomeArgs = {
  input: ManagerAddApplicationHomeInput;
};


export type MutationManagerCancelAmenityReservationArgs = {
  input: ManagerCancelAmenityReservationInput;
};


export type MutationManagerCreateAmenityReservationArgs = {
  input: ManagerCreateAmenityReservationInput;
};


export type MutationManagerReserveAmenityArgs = {
  input: ManagerReserveAmenityInput;
};


export type MutationMarkApplicationThreadAsReadArgs = {
  input: MarkApplicationThreadAsReadInput;
};


export type MutationMarkSafetyReviewRequestOpenedArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationMarkSibPackPrintedArgs = {
  blockId: Scalars['UUID']['input'];
};


export type MutationMarkSuggestionShownArgs = {
  input: MarkSuggestionShownInput;
};


export type MutationMarkThreadMessagesAsReadArgs = {
  input: MarkThreadMessagesAsReadInput;
};


export type MutationNewCreateApplicationArgs = {
  input: NewCreateApplicationInput;
};


export type MutationOfferPcfraArgs = {
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  offeredAt?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationOfficiallyVerifyRightToRentArgs = {
  input: OfficiallyVerifyRightToRentInput;
};


export type MutationOrderConversationTagsArgs = {
  input: OrderConversationTagsInput;
};


export type MutationPackageReminderToAllArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationPackageReminderToHomeArgs = {
  input: PackageReminderToHomeInput;
};


export type MutationPayForDocumentArgs = {
  input: PayForDocumentInput;
};


export type MutationPayForUnpaidApplicationReferencesArgs = {
  input: PayForUnpaidApplicationReferencesInput;
};


export type MutationPublishCommunityUpdateArgs = {
  input: PublishCommunityUpdateInput;
};


export type MutationPushTaskToAsanaArgs = {
  input: PushTaskToAsanaInput;
};


export type MutationRateConversationArgs = {
  input: RateConversationInput;
};


export type MutationReOpenConversationArgs = {
  input: ReOpenConversationInput;
};


export type MutationReadAllNotificationsArgs = {
  input: ReadAllNotificationsInput;
};


export type MutationReadAllNotificationsOnTargetArgs = {
  input: ReadAllNotificationsOnTargetInput;
};


export type MutationReadNotificationArgs = {
  input: ReadNotificationInput;
};


export type MutationReconcileSafetyDeclarationArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationReconfirmSafetyRecordArgs = {
  id: Scalars['UUID']['input'];
};


export type MutationRecordConversationRatingPromptArgs = {
  input: RecordConversationRatingPromptInput;
};


export type MutationRecordReportingConfigurationOpenedArgs = {
  input: RecordReportingConfigurationOpenedInput;
};


export type MutationReferenceSignupErrorArgs = {
  input: ReferenceSignupErrorInput;
};


export type MutationRejectApplicationArgs = {
  application: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
};


export type MutationRemindAllApplicantsArgs = {
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};


export type MutationRemindApplicantArgs = {
  application: Scalars['UUID']['input'];
};


export type MutationRemindResidentArgs = {
  input: RemindResidentInput;
};


export type MutationRemoveBlockPlacementsArgs = {
  blockId: Scalars['ID']['input'];
  homeIds: ReadonlyArray<Scalars['ID']['input']>;
};


export type MutationRemoveConversationTagArgs = {
  input: RemoveConversationTagInput;
};


export type MutationRemoveResidentFromUnpaidEventsArgs = {
  input: RemoveResidentFromUnpaidEventsInput;
};


export type MutationRemoveResidentsFromResidencyArgs = {
  input: RemoveResidentsFromResidencyInput;
};


export type MutationRemoveTaskDocumentArgs = {
  input: RemoveTaskDocumentInput;
};


export type MutationRemoveTeamMemberArgs = {
  input: RemoveTeamMemberInput;
};


export type MutationRenameTaskArgs = {
  input: RenameTaskInput;
};


export type MutationResendMemberInviteEmailArgs = {
  input: ResendMemberInviteEmailInput;
};


export type MutationReserveAmenityArgs = {
  input: ReserveAmenityInput;
};


export type MutationReserveAmenitySlotArgs = {
  input: ReserveAmenitySlotInput;
};


export type MutationResidentArchiveKeyholderArgs = {
  input: ResidentArchiveKeyholderInput;
};


export type MutationResidentCreateKeyholderArgs = {
  input: ResidentCreateKeyholderInput;
};


export type MutationResidentUnarchiveKeyholderArgs = {
  input: ResidentUnarchiveKeyholderInput;
};


export type MutationResidentUpdateKeyholderArgs = {
  input: ResidentUpdateKeyholderInput;
};


export type MutationResolveChecklistActionArgs = {
  input: ResolveChecklistActionInput;
};


export type MutationRespondToContractorSuggestionArgs = {
  input: RespondToContractorSuggestionInput;
};


export type MutationRespondToPcfraArgs = {
  accepted: Scalars['Boolean']['input'];
  authority?: InputMaybe<SafetyComplianceAuthority>;
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
};


export type MutationRestartIdentityVerificationArgs = {
  input: RestartIdentityVerificationInput;
};


export type MutationRetryDocumentExtractionArgs = {
  input: RetryDocumentExtractionInput;
};


export type MutationReviewInspectionActionArgs = {
  input: ReviewInspectionActionInput;
};


export type MutationRevokeCommunityStaffRoleArgs = {
  input: RevokeCommunityStaffRoleInput;
};


export type MutationRevokeGeneratedAgreementArgs = {
  input: RevokeGeneratedAgreementInput;
};


export type MutationRotateSafetyResponderTokenArgs = {
  packId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationSaveAmenityArgs = {
  input: SaveAmenityInput;
};


export type MutationSaveAmenityOperatingTimesArgs = {
  input: SaveAmenityOperatingTimesInput;
};


export type MutationSaveCommunityEventArgs = {
  input: SaveCommunityEventInput;
};


export type MutationSaveCommunityUpdateArgs = {
  input: SaveCommunityUpdateInput;
};


export type MutationSaveContactNoteArgs = {
  input: SaveContactNoteInput;
};


export type MutationSaveGeneratedAgreementArgs = {
  input: SaveGeneratedAgreementInput;
};


export type MutationSaveGeneratedSection21Args = {
  input: SaveGeneratedSection21Input;
};


export type MutationSaveHomeArgs = {
  input: SaveHomeInput;
};


export type MutationSaveManagerProfileArgs = {
  input: SaveManagerProfileInput;
};


export type MutationSaveMarketplaceItemArgs = {
  input: SaveMarketplaceItemInput;
};


export type MutationSaveRequirementItemArgs = {
  input: SaveRequirementItemInput;
};


export type MutationSaveResidentSurveyAnswerArgs = {
  input: SaveResidentSurveyAnswerInput;
};


export type MutationSaveTenantEmploymentDetailsArgs = {
  input: SaveTenantEmploymentDetailsInput;
};


export type MutationSchedulePublishCommunityUpdateArgs = {
  input: SchedulePublishCommunityUpdateInput;
};


export type MutationSendAgreementForSigningArgs = {
  input: SendAgreementForSigningInput;
};


export type MutationSendApplicationSupportMessageArgs = {
  input: SendApplicationSupportMessageInput;
};


export type MutationSendApplicationThreadMessageArgs = {
  input: SendApplicationThreadMessageInput;
};


export type MutationSendConversationToAsanaArgs = {
  input: SendConversationToAsanaInput;
};


export type MutationSendDocumentArgs = {
  input: SendDocumentInput;
};


export type MutationSendManagerAmplitudeTestArgs = {
  input: SendManagerAmplitudeTestInput;
};


export type MutationSendPaymentReceiptEmailArgs = {
  input: SendPaymentReceiptEmailInput;
};


export type MutationSendSafetyReminderArgs = {
  recordId: Scalars['UUID']['input'];
};


export type MutationSendSafetyReviewRequestArgs = {
  channel?: InputMaybe<SafetyReviewAttemptChannel>;
  note?: InputMaybe<Scalars['String']['input']>;
  recordId: Scalars['UUID']['input'];
};


export type MutationSendTenantReferenceRequestsArgs = {
  input: SendTenantReferenceRequestsInput;
};


export type MutationSetChecklistItemDueDateArgs = {
  input: SetChecklistItemDueDateInput;
};


export type MutationSetChecklistSectionDueDateArgs = {
  input: SetChecklistSectionDueDateInput;
};


export type MutationSetConversationHomeArgs = {
  input: SetConversationHomeInput;
};


export type MutationSetReportingFavouriteArgs = {
  input: SetReportingFavouriteInput;
};


export type MutationSetReportingScheduleArgs = {
  input: SetReportingScheduleInput;
};


export type MutationSetResidencyCompletionDateArgs = {
  input: SetResidencyCompletionDateInput;
};


export type MutationSetResidentAppLocaleArgs = {
  input: SetResidentAppLocaleInput;
};


export type MutationSetSafetyDocumentBlockArgs = {
  blockId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
};


export type MutationSetSafetyDocumentInSibPackArgs = {
  id: Scalars['UUID']['input'];
  include: Scalars['Boolean']['input'];
};


export type MutationSetSafetyDocumentResidentVisibleArgs = {
  id: Scalars['UUID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationSetSafetySubjectContactEmailArgs = {
  input: SetSafetySubjectContactEmailInput;
};


export type MutationSetUpManagerArgs = {
  input: SetUpManagerInput;
};


export type MutationShareComplianceRequirementArgs = {
  input: ShareComplianceRequirementInput;
};


export type MutationSignOffChecklistArgs = {
  input: SignOffChecklistInput;
};


export type MutationSignOutCommunityVisitorArgs = {
  input: SignOutCommunityVisitorInput;
};


export type MutationSnoozeConversationArgs = {
  input: SnoozeConversationInput;
};


export type MutationStartBulkConversationCloseArgs = {
  action?: InputMaybe<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  conversationIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  filters?: InputMaybe<BulkConversationCloseFilterInput>;
  message?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationStartBulkDeactivationArgs = {
  input: StartBulkDeactivationInput;
};


export type MutationSubmitEmployerReferenceArgs = {
  input: SubmitEmployerReferenceInput;
};


export type MutationSubmitIdentityVerificationArgs = {
  input: SubmitIdentityVerificationInput;
};


export type MutationSubmitLandlordReferenceArgs = {
  input: SubmitLandlordReferenceInput;
};


export type MutationSubmitTenantReferenceArgs = {
  input: SubmitTenantReferenceInput;
};


export type MutationSubscribeLandlordArgs = {
  input: SubscribeLandlordInput;
};


export type MutationSubscribeToNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationSuggestRemediationStepsArgs = {
  input: SuggestRemediationStepsInput;
};


export type MutationSyncBlockGroupsArgs = {
  input: SyncBlockGroupsInput;
};


export type MutationTagConversationArgs = {
  input: TagConversationInput;
};


export type MutationToggleAllResidentAppNotificationPreferencesArgs = {
  input: ToggleAllResidentAppNotificationPreferencesInput;
};


export type MutationToggleArchivedAtCommunityDocumentArgs = {
  input: ToggleArchivedAtCommunityDocumentInput;
};


export type MutationToggleArchivedAtCommunityUpdateArgs = {
  input: ToggleArchivedAtCommunityUpdateInput;
};


export type MutationToggleClientTagArchivedAtArgs = {
  input: ToggleClientTagArchivedAtInput;
};


export type MutationToggleCommunityUpdateBookmarkArgs = {
  input: ToggleCommunityUpdateBookmarkInput;
};


export type MutationToggleCommunityUpdateLikeArgs = {
  input: ToggleCommunityUpdateLikeInput;
};


export type MutationToggleMarketplaceItemCloseArgs = {
  input: ToggleMarketplaceItemCloseInput;
};


export type MutationToggleRuleActivatedArgs = {
  input: ToggleRuleActivatedInput;
};


export type MutationToggleTeamActivatedArgs = {
  input: ToggleTeamActivatedInput;
};


export type MutationUnarchiveApplicationArgs = {
  input: UnarchiveApplicationInput;
};


export type MutationUnarchiveKeyArgs = {
  input: UnarchiveKeyInput;
};


export type MutationUnarchiveKeyholderArgs = {
  input: UnarchiveKeyholderInput;
};


export type MutationUnarchiveTaskArgs = {
  input: UnarchiveTaskInput;
};


export type MutationUnarchiveTaskGroupArgs = {
  input: UnarchiveTaskGroupInput;
};


export type MutationUnarchiveTaskTemplateArgs = {
  input: UnarchiveTaskTemplateInput;
};


export type MutationUnassignClientTagArgs = {
  input: UnassignClientTagInput;
};


export type MutationUnassignClientTagFromCommunityDocumentArgs = {
  input: UnassignClientTagFromCommunityDocumentInput;
};


export type MutationUnassignClientTagFromTaskDefinitionArgs = {
  input: UnassignClientTagFromTaskDefinitionInput;
};


export type MutationUnassignClientTagFromUserDocumentArgs = {
  input: UnassignClientTagFromUserDocumentInput;
};


export type MutationUnassignTeamArgs = {
  input: UnassignTeamInput;
};


export type MutationUnbookCommunityEventArgs = {
  input: UnbookCommunityEventMutationInput;
};


export type MutationUnflagChecklistItemArgs = {
  input: UnflagChecklistItemInput;
};


export type MutationUnlabelConversationArgs = {
  input: UnlabelConversationInput;
};


export type MutationUnlinkTaskFromAsanaArgs = {
  input: UnlinkTaskFromAsanaInput;
};


export type MutationUnlinkTaskFromFixfloArgs = {
  input: UnlinkTaskFromFixfloInput;
};


export type MutationUnreadAllNotificationsOnTargetArgs = {
  input: UnreadAllNotificationsOnTargetInput;
};


export type MutationUnreadNotificationArgs = {
  input: UnreadNotificationInput;
};


export type MutationUnsnoozeConversationArgs = {
  input: UnsnoozeConversationInput;
};


export type MutationUnsubscribeFromNotificationGroupArgs = {
  input: NotificationPreferencesInput;
};


export type MutationUpdateAmenityOperatingScheduleArgs = {
  input: UpdateAmenityOperatingScheduleInput;
};


export type MutationUpdateAmenityTypeArgs = {
  input: UpdateAmenityTypeInput;
};


export type MutationUpdateApplicationCommunityArgs = {
  input: UpdateApplicationCommunityInput;
};


export type MutationUpdateApplicationHomeArgs = {
  input: UpdateApplicationHomeInput;
};


export type MutationUpdateAttachmentArgs = {
  input: UpdateAttachmentInput;
};


export type MutationUpdateBlockArgs = {
  input: UpdateBlockInput;
};


export type MutationUpdateBlockGroupPinnedHomesArgs = {
  input: UpdateBlockGroupPinnedHomesInput;
};


export type MutationUpdateBlockHomesArgs = {
  input: UpdateBlockHomesInput;
};


export type MutationUpdateBlockSafetyIdentityArgs = {
  input: UpdateBlockSafetyIdentityInput;
};


export type MutationUpdateChecklistArgs = {
  input: UpdateChecklistInput;
};


export type MutationUpdateChecklistStructureArgs = {
  input: UpdateChecklistStructureInput;
};


export type MutationUpdateClientAdminArgs = {
  input: UpdateClientAdminInput;
};


export type MutationUpdateClientContractorCompanyArgs = {
  input: UpdateClientContractorCompanyInput;
};


export type MutationUpdateClientContractorCompanyCommunitiesArgs = {
  input: UpdateClientContractorCompanyCommunitiesInput;
};


export type MutationUpdateClientContractorCompanyContractorsArgs = {
  input: UpdateClientContractorCompanyContractorsInput;
};


export type MutationUpdateClientTagArgs = {
  input: UpdateClientTagInput;
};


export type MutationUpdateClientTagColorArgs = {
  input: UpdateClientTagColorInput;
};


export type MutationUpdateCommunityDocumentArgs = {
  input: UpdateCommunityDocumentInput;
};


export type MutationUpdateCommunityProductArgs = {
  input: UpdateCommunityProductInput;
};


export type MutationUpdateCommunityResponsiblePersonArgs = {
  communityId: Scalars['UUID']['input'];
  responsiblePersonName?: InputMaybe<Scalars['String']['input']>;
  responsiblePersonRole?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateCommunitySettingsArgs = {
  input: UpdateCommunitySettingsInput;
};


export type MutationUpdateCommunitySibPackReviewSettingsArgs = {
  communityId: Scalars['UUID']['input'];
  sibPackReviewNudgeMonths?: InputMaybe<Scalars['Int']['input']>;
  sibPackReviewRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateCommunityTaskDefinitionArgs = {
  input: UpdateCommunityTaskDefinitionInput;
};


export type MutationUpdateContactGroupsArgs = {
  input: UpdateContactGroupsInput;
};


export type MutationUpdateContractorArgs = {
  input: UpdateContractorInput;
};


export type MutationUpdateConversationNoteArgs = {
  input: UpdateConversationNoteInput;
};


export type MutationUpdateConversationParticipantTypeArgs = {
  input: UpdateConversationParticipantTypeInput;
};


export type MutationUpdateConversationTagArgs = {
  input: UpdateConversationTagInput;
};


export type MutationUpdateConversationTitleArgs = {
  input: UpdateConversationTitleInput;
};


export type MutationUpdateConversationUrgencyArgs = {
  input: UpdateConversationUrgencyInput;
};


export type MutationUpdateEmployerReferenceArgs = {
  input: UpdateEmployerReferenceInput;
};


export type MutationUpdateEmployerReferenceStepArgs = {
  input: UpdateEmployerReferenceStepInput;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
};


export type MutationUpdateGroupDescriptionArgs = {
  input: UpdateGroupDescriptionInput;
};


export type MutationUpdateHomeAddressArgs = {
  input: UpdateHomeAddressInput;
};


export type MutationUpdateHomeDetailsArgs = {
  input: UpdateHomeDetailsInput;
};


export type MutationUpdateHomeFloorNumberArgs = {
  input: UpdateHomeFloorNumberInput;
};


export type MutationUpdateKeyholderArgs = {
  input: UpdateKeyholderInput;
};


export type MutationUpdateLandlordArgs = {
  input: UpdateLandlordInput;
};


export type MutationUpdateLandlordReferenceArgs = {
  input: UpdateLandlordReferenceInput;
};


export type MutationUpdateLandlordReferenceCommentsArgs = {
  input: UpdateLandlordReferenceCommentsInput;
};


export type MutationUpdateLandlordReferenceStepArgs = {
  input: UpdateLandlordReferenceStepInput;
};


export type MutationUpdateManagerArgs = {
  input: UpdateManagerInput;
};


export type MutationUpdateManagerNotificationSettingsArgs = {
  input: UpdateManagerNotificationSettingsInput;
};


export type MutationUpdateMobileNumberArgs = {
  input: UpdateUserMobileNumberInput;
};


export type MutationUpdateNotificationPreferenceArgs = {
  input: UpdateNotificationPreferenceInput;
};


export type MutationUpdatePackageLocationArgs = {
  input: UpdatePackageLocationInput;
};


export type MutationUpdatePackageStatusArgs = {
  input: UpdatePackageStatusInput;
};


export type MutationUpdateReferenceAddressHistoryArgs = {
  input: UpdateReferenceAddressHistoryInput;
};


export type MutationUpdateReferenceStartedOnArgs = {
  input: UpdateReferenceStartedOnInput;
};


export type MutationUpdateReportingConfigurationArgs = {
  input: UpdateReportingConfigurationInput;
};


export type MutationUpdateResidencyAndResidentsArgs = {
  input: ResidencyAndResidentsInput;
};


export type MutationUpdateResidencyDocumentArgs = {
  input: UpdateResidencyDocumentInput;
};


export type MutationUpdateResidentAppNotificationPreferencesArgs = {
  input: UpdateResidentAppNotificationPreferencesInput;
};


export type MutationUpdateResidentSafetyRecordArgs = {
  id: Scalars['UUID']['input'];
  input: UpdateResidentSafetyRecordInput;
};


export type MutationUpdateRightToRentArgs = {
  input: UpdateRightToRentInput;
};


export type MutationUpdateRuleArgs = {
  input: UpdateRuleInput;
};


export type MutationUpdateRuleCategoryContentTypesArgs = {
  input: UpdateRuleCategoryContentTypesInput;
};


export type MutationUpdateRuleCommunitiesArgs = {
  input: UpdateRuleCommunitiesInput;
};


export type MutationUpdateRuleConditionArgs = {
  input: UpdateRuleConditionInput;
};


export type MutationUpdateSafetyCenterDocumentArgs = {
  input: UpdateSafetyCenterDocumentInput;
};


export type MutationUpdateSafetyReviewIntervalArgs = {
  communityId: Scalars['UUID']['input'];
  surveyReviewIntervalMonths: Scalars['Int']['input'];
};


export type MutationUpdateScheduledMessageArgs = {
  input: UpdateScheduledMessageInput;
};


export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};


export type MutationUpdateTaskDefinitionDescriptionArgs = {
  input: UpdateTaskDefinitionDescriptionInput;
};


export type MutationUpdateTaskDefinitionPriorityArgs = {
  input: UpdateTaskDefinitionPriorityInput;
};


export type MutationUpdateTaskDefinitionVisibilityArgs = {
  input: UpdateTaskDefinitionVisibilityInput;
};


export type MutationUpdateTaskGroupArgs = {
  input: UpdateTaskGroupInput;
};


export type MutationUpdateTaskPriorityArgs = {
  input: UpdateTaskPriorityInput;
};


export type MutationUpdateTaskTemplateArgs = {
  input: UpdateTaskTemplateInput;
};


export type MutationUpdateTaskTemplateStructureArgs = {
  input: UpdateTaskTemplateStructureInput;
};


export type MutationUpdateTeamCommunitiesArgs = {
  input: UpdateTeamCommunitiesInput;
};


export type MutationUpdateTeamDetailsArgs = {
  input: UpdateTeamDetailsInput;
};


export type MutationUpdateTeamIconArgs = {
  input: UpdateTeamIconInput;
};


export type MutationUpdateTeamMembersArgs = {
  input: UpdateTeamMembersInput;
};


export type MutationUpdateTenantReferenceArgs = {
  input: UpdateTenantReferenceInput;
};


export type MutationUpdateTenantReferenceStepArgs = {
  input: UpdateTenantReferenceStepInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserDocumentArgs = {
  input: UpdateUserDocumentInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpgradeLandlordToSubscriptionArgs = {
  input: UpgradeLandlordToSubscriptionInput;
};


export type MutationViewFeatureAnnouncementArgs = {
  input: ViewFeatureAnnouncementInput;
};


export type MutationViewUserFeatureAnnouncementArgs = {
  input: ViewUserFeatureAnnouncementInput;
};


export type MutationVoidSafetyDeclarationArgs = {
  id: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationWithdrawFireServiceConsentArgs = {
  channel?: InputMaybe<SafetyComplianceChannel>;
  id: Scalars['UUID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type NewCommunityOption = {
  readonly __typename?: 'NewCommunityOption';
  readonly distance?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type NewCreateApplication = {
  readonly __typename?: 'NewCreateApplication';
  readonly application?: Maybe<ApplicationNode>;
  readonly communities?: Maybe<ReadonlyArray<NewCommunityOption>>;
  readonly homes?: Maybe<ReadonlyArray<NewHomeOption>>;
  readonly status: Scalars['String']['output'];
};

export type NewCreateApplicationInput = {
  readonly communityId?: InputMaybe<Scalars['ID']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly flatNumber: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly ownershipType?: InputMaybe<ApplicationOwnershipType>;
  readonly postcode?: InputMaybe<Scalars['String']['input']>;
};

export type NewHomeOption = {
  readonly __typename?: 'NewHomeOption';
  readonly address: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type NotificationContentObjectType = ConversationNode | ResidencyType;

export type NotificationNavigationMeta = {
  readonly __typename?: 'NotificationNavigationMeta';
  readonly actionObjectType?: Maybe<Scalars['String']['output']>;
  readonly routeId?: Maybe<Scalars['String']['output']>;
  readonly secondaryId?: Maybe<Scalars['String']['output']>;
  readonly targetType?: Maybe<Scalars['String']['output']>;
};

export type NotificationNode = {
  readonly __typename?: 'NotificationNode';
  readonly actionObject?: Maybe<ActionObject>;
  readonly actor?: Maybe<Actor>;
  readonly actorName?: Maybe<Scalars['String']['output']>;
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly pulseTitle?: Maybe<Scalars['String']['output']>;
  readonly read: Scalars['Boolean']['output'];
  readonly recipient: UserType;
  readonly target?: Maybe<Target>;
  readonly title: Scalars['String']['output'];
  readonly type: Scalars['String']['output'];
  readonly verb?: Maybe<Scalars['String']['output']>;
};

export type NotificationNodeConnection = {
  readonly __typename?: 'NotificationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<NotificationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `NotificationNode` and its cursor. */
export type NotificationNodeEdge = {
  readonly __typename?: 'NotificationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<NotificationNode>;
};

export type NotificationPreferencesInput = {
  readonly type: Scalars['String']['input'];
};

export type OccupancySurveyNode = {
  readonly __typename?: 'OccupancySurveyNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOccupant: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly occupants: OccupantNodeConnection;
  readonly residency: ResidencyType;
  readonly user: UserType;
};


export type OccupancySurveyNodeOccupantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type OccupancySurveyNodeConnection = {
  readonly __typename?: 'OccupancySurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupancySurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupancySurveyNode` and its cursor. */
export type OccupancySurveyNodeEdge = {
  readonly __typename?: 'OccupancySurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupancySurveyNode>;
};

export type OccupantInput = {
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly first: Scalars['String']['input'];
  readonly last: Scalars['String']['input'];
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OccupantNode = {
  readonly __typename?: 'OccupantNode';
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly first: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly last: Scalars['String']['output'];
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly occupancySurvey: OccupancySurveyNode;
  readonly user?: Maybe<UserType>;
};

export type OccupantNodeConnection = {
  readonly __typename?: 'OccupantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<OccupantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `OccupantNode` and its cursor. */
export type OccupantNodeEdge = {
  readonly __typename?: 'OccupantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<OccupantNode>;
};

export type OfferPcfra = {
  readonly __typename?: 'OfferPcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type OfficiallyVerifyRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly officialExpiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly officialVerificationStatus?: InputMaybe<Scalars['String']['input']>;
};

export type OfficiallyVerifyRightToRentPayload = {
  readonly __typename?: 'OfficiallyVerifyRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<Scalars['String']['output']>;
};

export type OperatingTimeInput = {
  readonly endTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly isActivated: Scalars['Boolean']['input'];
  readonly startTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly weekDay: Scalars['Int']['input'];
};

export type OrderConversationTagsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type OrderConversationTagsPayload = {
  readonly __typename?: 'OrderConversationTagsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type PackageEventNode = {
  readonly __typename?: 'PackageEventNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly package: PackageNode;
  readonly performedBy?: Maybe<UserType>;
  readonly reason?: Maybe<Scalars['String']['output']>;
  readonly type: ResidentialManagementPackageEventTypeChoices;
};

export type PackageNode = {
  readonly __typename?: 'PackageNode';
  readonly addressee?: Maybe<Scalars['String']['output']>;
  readonly collectedBy?: Maybe<UserType>;
  readonly collectedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly collectionCode?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly events: ReadonlyArray<PackageEventNode>;
  readonly home?: Maybe<HomeType>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly label?: Maybe<Scalars['String']['output']>;
  readonly lastAction: Scalars['DateTime']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly lockerOutcome?: Maybe<Scalars['String']['output']>;
  readonly pickupLocation?: Maybe<Scalars['String']['output']>;
  readonly reminders?: Maybe<ReadonlyArray<PackageReminderNode>>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly resident?: Maybe<ResidentType>;
  readonly scannedInBy?: Maybe<UserType>;
  readonly status: ResidentialManagementPackageStatusChoices;
  readonly user?: Maybe<UserType>;
};

export type PackageNodeConnection = {
  readonly __typename?: 'PackageNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PackageNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PackageNode` and its cursor. */
export type PackageNodeEdge = {
  readonly __typename?: 'PackageNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PackageNode>;
};

export type PackageReminderNode = {
  readonly __typename?: 'PackageReminderNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type PackageReminderToAll = {
  readonly __typename?: 'PackageReminderToAll';
  readonly packages?: Maybe<ReadonlyArray<Maybe<PackageNode>>>;
};

export type PackageReminderToHomeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type PackageReminderToHomePayload = {
  readonly __typename?: 'PackageReminderToHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly home?: Maybe<HomeType>;
};

export type PackageReportingAgeBucketNode = {
  readonly __typename?: 'PackageReportingAgeBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type PackageReportingAgeingNode = {
  readonly __typename?: 'PackageReportingAgeingNode';
  readonly buckets: ReadonlyArray<PackageReportingAgeBucketNode>;
  readonly overTwoWeeks?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingCollectionPointNode = {
  readonly __typename?: 'PackageReportingCollectionPointNode';
  readonly count: Scalars['Int']['output'];
  readonly inLocker: Scalars['Boolean']['output'];
};

export type PackageReportingCountNode = {
  readonly __typename?: 'PackageReportingCountNode';
  readonly byDay: ReadonlyArray<PackageReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingDataQualityNode = {
  readonly __typename?: 'PackageReportingDataQualityNode';
  readonly markedAsDuplicate?: Maybe<Scalars['Int']['output']>;
  readonly markedAsIncorrectlyAssigned?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingDayCountNode = {
  readonly __typename?: 'PackageReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type PackageReportingDayDurationNode = {
  readonly __typename?: 'PackageReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type PackageReportingDurationNode = {
  readonly __typename?: 'PackageReportingDurationNode';
  readonly byDay: ReadonlyArray<PackageReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type PackageReportingHomeCountNode = {
  readonly __typename?: 'PackageReportingHomeCountNode';
  readonly count: Scalars['Int']['output'];
  readonly homeId: Scalars['UUID']['output'];
  readonly label: Scalars['String']['output'];
};

export type PackageReportingHourCountNode = {
  readonly __typename?: 'PackageReportingHourCountNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type PackageReportingLastReminderNode = {
  readonly __typename?: 'PackageReportingLastReminderNode';
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly medianShare?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type PackageReportingLocationCountNode = {
  readonly __typename?: 'PackageReportingLocationCountNode';
  readonly count: Scalars['Int']['output'];
  readonly location?: Maybe<Scalars['String']['output']>;
};

export type PackageReportingNode = {
  readonly __typename?: 'PackageReportingNode';
  readonly ageing: PackageReportingAgeingNode;
  readonly collected: PackageReportingCountNode;
  readonly collectionPattern: ReadonlyArray<PackageReportingHourCountNode>;
  readonly collectionPoints: ReadonlyArray<PackageReportingCollectionPointNode>;
  readonly dataQuality: PackageReportingDataQualityNode;
  readonly delivered: PackageReportingCountNode;
  readonly deliveryPattern: ReadonlyArray<PackageReportingHourCountNode>;
  readonly lastReminder: PackageReportingLastReminderNode;
  readonly locations: ReadonlyArray<PackageReportingLocationCountNode>;
  readonly overTwoWeeksAtEnd: Scalars['Int']['output'];
  readonly reminders: PackageReportingRemindersNode;
  readonly remindersPerPackage?: Maybe<Scalars['Float']['output']>;
  readonly timeToCollection: PackageReportingDurationNode;
  readonly uncollected: PackageReportingUncollectedNode;
  readonly waitingHomes: ReadonlyArray<PackageReportingHomeCountNode>;
};

export type PackageReportingRemindersNode = {
  readonly __typename?: 'PackageReportingRemindersNode';
  readonly collectedWithin48Hours?: Maybe<Scalars['Float']['output']>;
  readonly collectedWithin48HoursCount: Scalars['Int']['output'];
  readonly sampleCount: Scalars['Int']['output'];
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type PackageReportingUncollectedNode = {
  readonly __typename?: 'PackageReportingUncollectedNode';
  readonly atEnd?: Maybe<PackageReportingDayCountNode>;
  readonly byDay: ReadonlyArray<PackageReportingDayCountNode>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
};

export type PayForDocumentInput = {
  readonly agreementId?: InputMaybe<Scalars['ID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly section21Id?: InputMaybe<Scalars['ID']['input']>;
  readonly type: Scalars['String']['input'];
};

export type PayForDocumentPayload = {
  readonly __typename?: 'PayForDocumentPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly invoice?: Maybe<InvoiceNode>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PayForUnpaidApplicationReferencesInput = {
  readonly applicationUuid: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type PayForUnpaidApplicationReferencesPayload = {
  readonly __typename?: 'PayForUnpaidApplicationReferencesPayload';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccountNode = {
  readonly __typename?: 'PaymentAccountNode';
  readonly balance: Scalars['Decimal']['output'];
  readonly balanceLastUpdated?: Maybe<Scalars['DateTime']['output']>;
  readonly home?: Maybe<HomeNode>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastPayment?: Maybe<PaymentNode>;
  readonly leasehold?: Maybe<LeaseholdNode>;
  readonly paymentReference?: Maybe<Scalars['String']['output']>;
  readonly payments?: Maybe<PaymentNodeConnection>;
  readonly residency?: Maybe<ResidencyNode>;
  readonly unreconciledPaymentsTotal?: Maybe<Scalars['Float']['output']>;
};


export type PaymentAccountNodePaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type PaymentAccountNodeConnection = {
  readonly __typename?: 'PaymentAccountNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentAccountNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentAccountNode` and its cursor. */
export type PaymentAccountNodeEdge = {
  readonly __typename?: 'PaymentAccountNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentAccountNode>;
};

export type PaymentIntentType = {
  readonly __typename?: 'PaymentIntentType';
  readonly clientSecret?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type PaymentMethod = {
  readonly __typename?: 'PaymentMethod';
  readonly bacsDebit?: Maybe<BacsPaymentType>;
  readonly card?: Maybe<CardPaymentType>;
  readonly type: Scalars['String']['output'];
};

export type PaymentNode = {
  readonly __typename?: 'PaymentNode';
  readonly amount: Scalars['BigInt']['output'];
  readonly clientSecret: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly paymentIntentId: Scalars['String']['output'];
  readonly receipt?: Maybe<PaymentReceiptType>;
  readonly requestedPaymentMethod?: Maybe<Scalars['String']['output']>;
  readonly status: PaymentsPaymentStatusChoices;
  readonly type: PaymentsPaymentTypeChoices;
};

export type PaymentNodeConnection = {
  readonly __typename?: 'PaymentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<PaymentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `PaymentNode` and its cursor. */
export type PaymentNodeEdge = {
  readonly __typename?: 'PaymentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<PaymentNode>;
};

export type PaymentReceiptType = {
  readonly __typename?: 'PaymentReceiptType';
  readonly amountReceived?: Maybe<Scalars['Int']['output']>;
  readonly bankName?: Maybe<Scalars['String']['output']>;
  readonly cardBrand?: Maybe<Scalars['String']['output']>;
  readonly chargeId?: Maybe<Scalars['String']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly created?: Maybe<Scalars['Int']['output']>;
  readonly currency?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly last4?: Maybe<Scalars['String']['output']>;
  readonly paidTo?: Maybe<Scalars['String']['output']>;
  readonly paymentIntentId?: Maybe<Scalars['String']['output']>;
  readonly paymentIntentStatus?: Maybe<Scalars['String']['output']>;
  readonly paymentMethodDisplay?: Maybe<Scalars['String']['output']>;
  readonly paymentMethodType?: Maybe<Scalars['String']['output']>;
  readonly paymentReference?: Maybe<Scalars['String']['output']>;
  readonly receiptUrl?: Maybe<Scalars['String']['output']>;
  readonly statementDescriptor?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum PaymentsPaymentStatusChoices {
  /** Canceled */
  Ca = 'CA',
  /** Created */
  Cr = 'CR',
  /** Payment failed */
  Fa = 'FA',
  /** Partially funded */
  Pf = 'PF',
  /** Processing */
  Pr = 'PR',
  /** Requires action */
  Ra = 'RA',
  /** Succeeded */
  Su = 'SU'
}

/** An enumeration. */
export enum PaymentsPaymentTypeChoices {
  /** AST trial */
  At = 'AT',
  /** Community event */
  Ce = 'CE',
  /** Community product */
  Cp = 'CP',
  /** Deposit */
  De = 'DE',
  /** Payment account */
  Pa = 'PA'
}

/** An enumeration. */
export enum PeopleClientClientTypeChoices {
  /** Buy to let */
  Btl = 'BTL',
  /** Enterprise */
  Ent = 'ENT'
}

/** An enumeration. */
export enum PeopleUnsubscribeNotificationGroupTypeChoices {
  /** RESIDENT_APP_AMENITY */
  ResidentAppAmenity = 'RESIDENT_APP_AMENITY',
  /** RESIDENT_APP_COMMUNITY_PRODUCT */
  ResidentAppCommunityProduct = 'RESIDENT_APP_COMMUNITY_PRODUCT',
  /** RESIDENT_APP_CONVERSATION */
  ResidentAppConversation = 'RESIDENT_APP_CONVERSATION',
  /** RESIDENT_APP_DOCUMENT */
  ResidentAppDocument = 'RESIDENT_APP_DOCUMENT',
  /** RESIDENT_APP_EVENT */
  ResidentAppEvent = 'RESIDENT_APP_EVENT',
  /** RESIDENT_APP_GROUP_CHAT */
  ResidentAppGroupChat = 'RESIDENT_APP_GROUP_CHAT',
  /** RESIDENT_APP_KEY */
  ResidentAppKey = 'RESIDENT_APP_KEY',
  /** RESIDENT_APP_MARKETPLACE */
  ResidentAppMarketplace = 'RESIDENT_APP_MARKETPLACE',
  /** RESIDENT_APP_NEWSFEED */
  ResidentAppNewsfeed = 'RESIDENT_APP_NEWSFEED',
  /** RESIDENT_APP_PACKAGE */
  ResidentAppPackage = 'RESIDENT_APP_PACKAGE'
}

/** An enumeration. */
export enum PeopleUserCommunityRestrictionFeatureTypeChoices {
  /** AMENITIES */
  Amenities = 'AMENITIES',
  /** COMMUNITY_CHAT */
  CommunityChat = 'COMMUNITY_CHAT',
  /** MARKETPLACE */
  Marketplace = 'MARKETPLACE'
}

/** An enumeration. */
export enum PeopleUserSessionSessionTargetChoices {
  /** MANAGER_APP */
  ManagerApp = 'MANAGER_APP',
  /** MANAGER_DASHBOARD */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** RESIDENT_APP */
  ResidentApp = 'RESIDENT_APP'
}

export enum PermissionAuthority {
  Deny = 'DENY',
  Legacy = 'LEGACY',
  V2 = 'V2'
}

export type PermissionSnapshotType = {
  readonly __typename?: 'PermissionSnapshotType';
  readonly authority: PermissionAuthority;
  readonly clientId: Scalars['UUID']['output'];
  readonly permissions: ReadonlyArray<UserPermissionType>;
  readonly refreshAfter: Scalars['DateTime']['output'];
  readonly revision: Scalars['String']['output'];
};

export type PortfolioApplicationSourceNode = {
  readonly __typename?: 'PortfolioApplicationSourceNode';
  readonly inApp: Scalars['Int']['output'];
  readonly inAppShare?: Maybe<Scalars['Float']['output']>;
  readonly received: Scalars['Int']['output'];
};

export type PortfolioBookingNode = {
  readonly __typename?: 'PortfolioBookingNode';
  readonly communitiesWithBookings: Scalars['Int']['output'];
  readonly communityCount: Scalars['Int']['output'];
  readonly count: Scalars['Int']['output'];
};

export type PortfolioCoverageNode = {
  readonly __typename?: 'PortfolioCoverageNode';
  readonly active7: Scalars['Int']['output'];
  readonly active30: Scalars['Int']['output'];
  readonly active90: Scalars['Int']['output'];
  readonly appUsers: Scalars['Int']['output'];
  readonly people: Scalars['Int']['output'];
  readonly segment: PortfolioCoverageSegment;
};

/** An enumeration. */
export enum PortfolioCoverageSegment {
  Everyone = 'EVERYONE',
  Leaseholder = 'LEASEHOLDER',
  Resident = 'RESIDENT'
}

export type PortfolioEngagementReportingNode = {
  readonly __typename?: 'PortfolioEngagementReportingNode';
  readonly applications: PortfolioApplicationSourceNode;
  readonly bookings: PortfolioBookingNode;
  readonly coverage: ReadonlyArray<PortfolioCoverageNode>;
  readonly reach: ReadonlyArray<PortfolioReachRowNode>;
  readonly reachTrend: ReadonlyArray<PortfolioReachTrendNode>;
  readonly rows: ReadonlyArray<PortfolioEngagementRowNode>;
  readonly trend: ReadonlyArray<PortfolioEngagementTrendNode>;
};

export type PortfolioEngagementRowNode = {
  readonly __typename?: 'PortfolioEngagementRowNode';
  readonly activeHomes: Scalars['Int']['output'];
  readonly activeRate?: Maybe<Scalars['Float']['output']>;
  readonly activeUsers: Scalars['Int']['output'];
  readonly appHomes: Scalars['Int']['output'];
  readonly appUsers: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly downloadRate?: Maybe<Scalars['Float']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly homes: Scalars['Int']['output'];
  readonly occupiedHomes: Scalars['Int']['output'];
  readonly people: Scalars['Int']['output'];
};

export type PortfolioEngagementTrendNode = {
  readonly __typename?: 'PortfolioEngagementTrendNode';
  readonly rows: ReadonlyArray<PortfolioEngagementRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioIssueTypeNode = {
  readonly __typename?: 'PortfolioIssueTypeNode';
  readonly closed: Scalars['Int']['output'];
  readonly medianCloseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly name: Scalars['String']['output'];
  readonly openAtEnd: Scalars['Int']['output'];
  readonly tagId: Scalars['UUID']['output'];
};

export type PortfolioMaintenanceReportingNode = {
  readonly __typename?: 'PortfolioMaintenanceReportingNode';
  readonly closeTargetDays: Scalars['Int']['output'];
  readonly rows: ReadonlyArray<PortfolioMaintenanceRowNode>;
  readonly trend: ReadonlyArray<PortfolioMaintenanceTrendNode>;
  readonly types: ReadonlyArray<PortfolioIssueTypeNode>;
};

export type PortfolioMaintenanceRowNode = {
  readonly __typename?: 'PortfolioMaintenanceRowNode';
  readonly closed: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly homes: Scalars['Int']['output'];
  readonly judged: Scalars['Int']['output'];
  readonly medianCloseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly onTime: Scalars['Int']['output'];
  readonly openAtEnd: Scalars['Int']['output'];
  readonly openByAge: ReadonlyArray<Scalars['Int']['output']>;
  readonly openPerHundredHomes?: Maybe<Scalars['Float']['output']>;
  readonly opened: Scalars['Int']['output'];
};

export type PortfolioMaintenanceTrendNode = {
  readonly __typename?: 'PortfolioMaintenanceTrendNode';
  readonly rows: ReadonlyArray<PortfolioMaintenanceRowNode>;
  readonly window: PortfolioWindowNode;
};

/** An enumeration. */
export enum PortfolioRatingKind {
  Maintenance = 'MAINTENANCE',
  Other = 'OTHER'
}

export type PortfolioRatingKindNode = {
  readonly __typename?: 'PortfolioRatingKindNode';
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly kind: PortfolioRatingKind;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly positive: Scalars['Int']['output'];
  readonly rated: Scalars['Int']['output'];
};

export type PortfolioReachRowNode = {
  readonly __typename?: 'PortfolioReachRowNode';
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly documentViewShare?: Maybe<Scalars['Float']['output']>;
  readonly documentViewerHomes: Scalars['Int']['output'];
  readonly occupiedHomes: Scalars['Int']['output'];
  readonly updateReadShare?: Maybe<Scalars['Float']['output']>;
  readonly updateReaderHomes: Scalars['Int']['output'];
};

export type PortfolioReachTrendNode = {
  readonly __typename?: 'PortfolioReachTrendNode';
  readonly rows: ReadonlyArray<PortfolioReachRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioSatisfactionReportingNode = {
  readonly __typename?: 'PortfolioSatisfactionReportingNode';
  readonly kinds: ReadonlyArray<PortfolioRatingKindNode>;
  readonly rows: ReadonlyArray<PortfolioSatisfactionRowNode>;
  readonly timings: ReadonlyArray<PortfolioSatisfactionTimingNode>;
  readonly trend: ReadonlyArray<PortfolioSatisfactionTrendNode>;
};

export type PortfolioSatisfactionRowNode = {
  readonly __typename?: 'PortfolioSatisfactionRowNode';
  readonly closed: Scalars['Int']['output'];
  readonly closedRated: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly health?: Maybe<Scalars['Float']['output']>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly positive: Scalars['Int']['output'];
  readonly rated: Scalars['Int']['output'];
  readonly responseRate?: Maybe<Scalars['Float']['output']>;
  readonly stars: ReadonlyArray<Scalars['Int']['output']>;
};

export type PortfolioSatisfactionTimingNode = {
  readonly __typename?: 'PortfolioSatisfactionTimingNode';
  readonly closeSeconds?: Maybe<Scalars['Float']['output']>;
  readonly closes: Scalars['Int']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly firstResponseSeconds?: Maybe<Scalars['Float']['output']>;
  readonly firstResponses: Scalars['Int']['output'];
  readonly replies: Scalars['Int']['output'];
  readonly replySeconds?: Maybe<Scalars['Float']['output']>;
};

export type PortfolioSatisfactionTrendNode = {
  readonly __typename?: 'PortfolioSatisfactionTrendNode';
  readonly rows: ReadonlyArray<PortfolioSatisfactionRowNode>;
  readonly window: PortfolioWindowNode;
};

export type PortfolioWindowNode = {
  readonly __typename?: 'PortfolioWindowNode';
  readonly endDate: Scalars['Date']['output'];
  readonly startDate: Scalars['Date']['output'];
};

export type ProductCosts = {
  readonly __typename?: 'ProductCosts';
  readonly astCost?: Maybe<Scalars['Float']['output']>;
  readonly s21Cost?: Maybe<Scalars['Float']['output']>;
};

export enum ProfileHomesEnum {
  Application = 'application',
  Leasehold = 'leasehold',
  Residency = 'residency'
}

export type ProfileType = {
  readonly __typename?: 'ProfileType';
  readonly homes: ReadonlyArray<HomeNode>;
  readonly inProgressApplication?: Maybe<ApplicationNode>;
};


export type ProfileTypeHomesArgs = {
  userLinkType: ProfileHomesEnum;
};

export type PublicBlockType = {
  readonly __typename?: 'PublicBlockType';
  readonly dutyHolderLabel: Scalars['String']['output'];
  readonly homeCount?: Maybe<Scalars['Int']['output']>;
  readonly hrbReference?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly packUrl?: Maybe<Scalars['String']['output']>;
  readonly responsiblePerson?: Maybe<PublicResponsiblePersonType>;
  readonly rows?: Maybe<ReadonlyArray<PublicPeepRowType>>;
  readonly shortCode?: Maybe<Scalars['String']['output']>;
  readonly totalFloors?: Maybe<Scalars['Int']['output']>;
};

export type PublicContactType = {
  readonly __typename?: 'PublicContactType';
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type PublicPeepRowType = {
  readonly __typename?: 'PublicPeepRowType';
  readonly assistance?: Maybe<Scalars['String']['output']>;
  readonly communication?: Maybe<Scalars['String']['output']>;
  readonly eesInPlace?: Maybe<Scalars['Boolean']['output']>;
  readonly flat?: Maybe<Scalars['String']['output']>;
  readonly floor?: Maybe<Scalars['Int']['output']>;
  readonly pcfraInPlace?: Maybe<Scalars['Boolean']['output']>;
};

export type PublicResidencyDocumentType = {
  readonly __typename?: 'PublicResidencyDocumentType';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};

export type PublicResponsiblePersonType = {
  readonly __typename?: 'PublicResponsiblePersonType';
  readonly name: Scalars['String']['output'];
  readonly role?: Maybe<Scalars['String']['output']>;
};

export type PublicSafetyCenterDocumentType = {
  readonly __typename?: 'PublicSafetyCenterDocumentType';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly fileUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly sibCategory?: Maybe<Scalars['String']['output']>;
  readonly sibCategoryLabel?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
};

export type PublicSafetyPackType = {
  readonly __typename?: 'PublicSafetyPackType';
  readonly blocks?: Maybe<ReadonlyArray<PublicBlockType>>;
  readonly communityId: Scalars['UUID']['output'];
  readonly communityName: Scalars['String']['output'];
  readonly contacts?: Maybe<ReadonlyArray<PublicContactType>>;
  readonly documents?: Maybe<ReadonlyArray<PublicSafetyCenterDocumentType>>;
  readonly lastGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly responsiblePerson?: Maybe<PublicResponsiblePersonType>;
  readonly sibPackUrl?: Maybe<Scalars['String']['output']>;
  readonly totalHomes?: Maybe<Scalars['Int']['output']>;
  readonly totalOccupants?: Maybe<Scalars['Int']['output']>;
};

export type PublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type PublishCommunityUpdatePayload = {
  readonly __typename?: 'PublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type PushTaskToAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type PushTaskToAsanaPayload = {
  readonly __typename?: 'PushTaskToAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type RmcDirectorNode = {
  readonly __typename?: 'RMCDirectorNode';
  readonly communities: CommunityNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
};


export type RmcDirectorNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RateConversationInput = {
  readonly answers?: InputMaybe<ReadonlyArray<InputMaybe<ConversationRatingAnswerSerializerInput>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly conversation: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly rating: Scalars['Int']['input'];
  readonly surface?: InputMaybe<Surface>;
};

export type RateConversationPayload = {
  readonly __typename?: 'RateConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly rating?: Maybe<Scalars['Int']['output']>;
  readonly surface?: Maybe<Surface>;
};

export enum RatingDisplayStyle {
  Numbers = 'NUMBERS',
  Stars = 'STARS'
}

export type RatingPresentationType = {
  readonly __typename?: 'RatingPresentationType';
  readonly prompt: Scalars['String']['output'];
  readonly style: RatingDisplayStyle;
};

export enum RatingPromptSurface {
  AppOpen = 'APP_OPEN',
  Banner = 'BANNER'
}

export type ReOpenConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type ReOpenConversationPayload = {
  readonly __typename?: 'ReOpenConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type ReadAllNotificationsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type ReadAllNotificationsOnTargetPayload = {
  readonly __typename?: 'ReadAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type ReadAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type ReadAllNotificationsPayload = {
  readonly __typename?: 'ReadAllNotificationsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ReadNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ReadNotificationPayload = {
  readonly __typename?: 'ReadNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type ReconcileSafetyDeclaration = {
  readonly __typename?: 'ReconcileSafetyDeclaration';
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ReconfirmSafetyRecord = {
  readonly __typename?: 'ReconfirmSafetyRecord';
  readonly declaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type RecordConversationRatingPromptInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly closedAt: Scalars['DateTime']['input'];
  readonly dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RecordConversationRatingPromptPayload = {
  readonly __typename?: 'RecordConversationRatingPromptPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RecordReportingConfigurationOpenedInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type RecordReportingConfigurationOpenedPayload = {
  readonly __typename?: 'RecordReportingConfigurationOpenedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type ReferenceHistoricalAddressNode = {
  readonly __typename?: 'ReferenceHistoricalAddressNode';
  readonly buildingName?: Maybe<Scalars['String']['output']>;
  readonly buildingNumber?: Maybe<Scalars['String']['output']>;
  readonly city: Scalars['String']['output'];
  readonly country: Scalars['String']['output'];
  readonly fullAddress?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly postcode: Scalars['String']['output'];
  readonly startDate: Scalars['Date']['output'];
  readonly street?: Maybe<Scalars['String']['output']>;
};

export type ReferenceHistoricalAddressNodeConnection = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ReferenceHistoricalAddressNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ReferenceHistoricalAddressNode` and its cursor. */
export type ReferenceHistoricalAddressNodeEdge = {
  readonly __typename?: 'ReferenceHistoricalAddressNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ReferenceHistoricalAddressNode>;
};

export type ReferenceHistoricalAddressSerializerInput = {
  readonly buildingName?: InputMaybe<Scalars['String']['input']>;
  readonly buildingNumber?: InputMaybe<Scalars['String']['input']>;
  readonly city: Scalars['String']['input'];
  readonly country: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly postcode: Scalars['String']['input'];
  readonly startDate: Scalars['Date']['input'];
  readonly street?: InputMaybe<Scalars['String']['input']>;
};

export type ReferenceSignupErrorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
};

export type ReferenceSignupErrorPayload = {
  readonly __typename?: 'ReferenceSignupErrorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RejectApplication = {
  readonly __typename?: 'RejectApplication';
  readonly application?: Maybe<ApplicationNode>;
};

export type RemindAllApplicants = {
  readonly __typename?: 'RemindAllApplicants';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemindApplicant = {
  readonly __typename?: 'RemindApplicant';
  readonly application?: Maybe<ApplicationNode>;
};

export type RemindResidentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RemindResidentPayload = {
  readonly __typename?: 'RemindResidentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RemoveBlockPlacements = {
  readonly __typename?: 'RemoveBlockPlacements';
  readonly block?: Maybe<BlockNode>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type RemoveConversationTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type RemoveConversationTagPayload = {
  readonly __typename?: 'RemoveConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type RemoveResidentFromUnpaidEventsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveResidentFromUnpaidEventsPayload = {
  readonly __typename?: 'RemoveResidentFromUnpaidEventsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type RemoveResidentsFromResidencyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly residents?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type RemoveResidentsFromResidencyPayload = {
  readonly __typename?: 'RemoveResidentsFromResidencyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residency?: Maybe<ResidencyType>;
};

export type RemoveTaskDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveTaskDocumentPayload = {
  readonly __typename?: 'RemoveTaskDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDocument?: Maybe<TaskDocumentNode>;
};

export type RemoveTeamMemberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly user: Scalars['UUID']['input'];
};

export type RemoveTeamMemberPayload = {
  readonly __typename?: 'RemoveTeamMemberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type RenameTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly taskId: Scalars['UUID']['input'];
};

export type RenameTaskPayload = {
  readonly __typename?: 'RenameTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
};

export type ReportingConfigurationNode = {
  readonly __typename?: 'ReportingConfigurationNode';
  readonly configuration: Scalars['JSONString']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isFavourite: Scalars['Boolean']['output'];
  readonly lastOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reportKey: Scalars['String']['output'];
  readonly revision: Scalars['Int']['output'];
  readonly schedules: ReadonlyArray<ReportingScheduleNode>;
  readonly schemaVersion: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ReportingPeriodInput = {
  readonly endDate: Scalars['Date']['input'];
  readonly startDate: Scalars['Date']['input'];
};

/** An enumeration. */
export enum ReportingScheduleCadence {
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

export type ReportingScheduleNode = {
  readonly __typename?: 'ReportingScheduleNode';
  readonly cadence?: Maybe<ReportingScheduleCadence>;
  readonly id: Scalars['UUID']['output'];
  readonly nextRunAt: Scalars['DateTime']['output'];
};

export type RequirementItemNode = {
  readonly __typename?: 'RequirementItemNode';
  readonly attachment?: Maybe<LandlordAttachmentType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly requirement: ComplianceRequirementNode;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RequirementItemNodeConnection = {
  readonly __typename?: 'RequirementItemNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RequirementItemNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RequirementItemNode` and its cursor. */
export type RequirementItemNodeEdge = {
  readonly __typename?: 'RequirementItemNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RequirementItemNode>;
};

export type ResendMemberInviteEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type ResendMemberInviteEmailPayload = {
  readonly __typename?: 'ResendMemberInviteEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientUser?: Maybe<ClientUserNode>;
};

export type ReserveAmenityInput = {
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type ReserveAmenityPayload = {
  readonly __typename?: 'ReserveAmenityPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ReserveAmenitySlotInput = {
  readonly additionalAttendance?: InputMaybe<Scalars['Int']['input']>;
  readonly amenity?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly end: Scalars['DateTime']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type ReserveAmenitySlotPayload = {
  readonly __typename?: 'ReserveAmenitySlotPayload';
  readonly amenityReservation?: Maybe<AmenityReservationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ResidencyAndResidentsInput = {
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly endDate?: InputMaybe<Scalars['Date']['input']>;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
  readonly paymentFrequency: Scalars['String']['input'];
  readonly paymentStartDate?: InputMaybe<Scalars['Date']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly residencyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly sendTenantWelcomeEmail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<Tenants>>>;
};

export type ResidencyDocumentNode = {
  readonly __typename?: 'ResidencyDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly author?: Maybe<UserType>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly residency: ResidencyType;
  readonly title: Scalars['String']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly views: ResidencyDocumentViewNodeConnection;
};


export type ResidencyDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidencyDocumentNodeConnection = {
  readonly __typename?: 'ResidencyDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentNode` and its cursor. */
export type ResidencyDocumentNodeEdge = {
  readonly __typename?: 'ResidencyDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentNode>;
};

export type ResidencyDocumentViewNode = {
  readonly __typename?: 'ResidencyDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ResidencyDocumentViewNodeConnection = {
  readonly __typename?: 'ResidencyDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyDocumentViewNode` and its cursor. */
export type ResidencyDocumentViewNodeEdge = {
  readonly __typename?: 'ResidencyDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyDocumentViewNode>;
};

export type ResidencyNode = {
  readonly __typename?: 'ResidencyNode';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly depositPayment?: Maybe<PaymentNode>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly endDate: Scalars['Date']['output'];
  readonly externalId?: Maybe<Scalars['String']['output']>;
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages: PackageNodeConnection;
  readonly pastResidents?: Maybe<ArchivedContactNodeConnection>;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residentSafetyRecords: ResidentSafetyRecordNodeConnection;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
};


export type ResidencyNodeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyNodePastResidentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyNodeResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidencyNodeConnection = {
  readonly __typename?: 'ResidencyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidencyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidencyNode` and its cursor. */
export type ResidencyNodeEdge = {
  readonly __typename?: 'ResidencyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidencyNode>;
};

export type ResidencyType = {
  readonly __typename?: 'ResidencyType';
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  readonly complianceRequirements: ComplianceRequirementNodeConnection;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly emergencyNumber?: Maybe<Scalars['String']['output']>;
  readonly endDate: Scalars['Date']['output'];
  readonly generatedAgreements: GeneratedAgreementNodeConnection;
  readonly home: HomeNode;
  readonly howToRentShared: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly notifications?: Maybe<ReadonlyArray<Maybe<ManagerNotificationType>>>;
  readonly occupancySurveys: OccupancySurveyNodeConnection;
  readonly packages?: Maybe<PackageNodeConnection>;
  readonly paymentAccount?: Maybe<PaymentAccountNode>;
  readonly paymentFrequency: Scalars['String']['output'];
  readonly paymentStartDate?: Maybe<Scalars['Date']['output']>;
  readonly publicDocuments: ReadonlyArray<PublicResidencyDocumentType>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly residentSafetyRecords: ResidentSafetyRecordNodeConnection;
  readonly residents: ReadonlyArray<ResidentType>;
  readonly rollingConfirmed: Scalars['Boolean']['output'];
  readonly stage?: Maybe<Scalars['String']['output']>;
  readonly startDate: Scalars['Date']['output'];
  readonly subscription?: Maybe<SubscriptionNode>;
  readonly tenancyapplicationSet: TenancyApplicationNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type ResidencyTypeComplianceRequirementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidencyTypeConversationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeGeneratedAgreementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidencyTypeOccupancySurveysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypeResidentSafetyRecordsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidencyTypeTenancyapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasBeenSent?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ResidentAppNotificationPreferencesNode = {
  readonly __typename?: 'ResidentAppNotificationPreferencesNode';
  readonly amenityEmailEnabled: Scalars['Boolean']['output'];
  readonly amenityPushEnabled: Scalars['Boolean']['output'];
  readonly communityProductEmailEnabled: Scalars['Boolean']['output'];
  readonly communityProductPushEnabled: Scalars['Boolean']['output'];
  readonly conversationEmailEnabled: Scalars['Boolean']['output'];
  readonly conversationPushEnabled: Scalars['Boolean']['output'];
  readonly documentEmailEnabled: Scalars['Boolean']['output'];
  readonly documentPushEnabled: Scalars['Boolean']['output'];
  readonly environmentPushEnabled: Scalars['Boolean']['output'];
  readonly eventEmailEnabled: Scalars['Boolean']['output'];
  readonly eventPushEnabled: Scalars['Boolean']['output'];
  readonly groupChatEmailEnabled: Scalars['Boolean']['output'];
  readonly groupChatPushEnabled: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isMuted: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly keyEmailEnabled: Scalars['Boolean']['output'];
  readonly keyPushEnabled: Scalars['Boolean']['output'];
  readonly marketplaceEmailEnabled: Scalars['Boolean']['output'];
  readonly marketplacePushEnabled: Scalars['Boolean']['output'];
  readonly newsfeedEmailEnabled: Scalars['Boolean']['output'];
  readonly newsfeedPushEnabled: Scalars['Boolean']['output'];
  readonly packageEmailEnabled: Scalars['Boolean']['output'];
  readonly packagePushEnabled: Scalars['Boolean']['output'];
};

export type ResidentArchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentArchiveKeyholderPayload = {
  readonly __typename?: 'ResidentArchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholder = {
  readonly __typename?: 'ResidentCreateKeyholder';
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentCreateKeyholderInput = {
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['String']['input']>;
  readonly homeId?: InputMaybe<Scalars['ID']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate: Scalars['String']['input'];
};

export type ResidentNode = {
  readonly __typename?: 'ResidentNode';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversation?: Maybe<ConversationNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentNodeConversationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  client?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  direction?: InputMaybe<Scalars['String']['input']>;
  excludeId?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  residency?: InputMaybe<Scalars['UUID']['input']>;
  resident?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  subject_Icontains?: InputMaybe<Scalars['String']['input']>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type ResidentNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentNodePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentNodeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentNodeConnection = {
  readonly __typename?: 'ResidentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentNode` and its cursor. */
export type ResidentNodeEdge = {
  readonly __typename?: 'ResidentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentNode>;
};

export type ResidentSafetyDeclarationNode = {
  readonly __typename?: 'ResidentSafetyDeclarationNode';
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationDetails?: Maybe<Scalars['String']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly declarantName?: Maybe<Scalars['String']['output']>;
  readonly declaredAt: Scalars['DateTime']['output'];
  readonly evidenceFileUrl?: Maybe<Scalars['String']['output']>;
  readonly hasEvidence: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isAuthoritative: Scalars['Boolean']['output'];
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isVoided: Scalars['Boolean']['output'];
  readonly language: Scalars['String']['output'];
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityDetails?: Maybe<Scalars['String']['output']>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices;
  readonly record: ResidentSafetyRecordNode;
  readonly submittedBy?: Maybe<UserType>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly voidReason: Scalars['String']['output'];
  readonly voidedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly voidedBy?: Maybe<UserType>;
  readonly voidedByName?: Maybe<Scalars['String']['output']>;
};

export type ResidentSafetyDeclarationNodeConnection = {
  readonly __typename?: 'ResidentSafetyDeclarationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyDeclarationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyDeclarationNode` and its cursor. */
export type ResidentSafetyDeclarationNodeEdge = {
  readonly __typename?: 'ResidentSafetyDeclarationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyDeclarationNode>;
};

export type ResidentSafetyRecordAuditLogNode = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNode';
  readonly actor?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly eventType: ResidentialManagementResidentSafetyRecordAuditLogEventTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly metadata: Scalars['JSONString']['output'];
};

export type ResidentSafetyRecordAuditLogNodeConnection = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyRecordAuditLogNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyRecordAuditLogNode` and its cursor. */
export type ResidentSafetyRecordAuditLogNodeEdge = {
  readonly __typename?: 'ResidentSafetyRecordAuditLogNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyRecordAuditLogNode>;
};

export type ResidentSafetyRecordInput = {
  readonly braille?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly first: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly isOccupant: Scalars['Boolean']['input'];
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint?: InputMaybe<Scalars['Boolean']['input']>;
  readonly last: Scalars['String']['input'];
  readonly mobilityNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly textToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
  readonly userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidentSafetyRecordNode = {
  readonly __typename?: 'ResidentSafetyRecordNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly auditLogs?: Maybe<ResidentSafetyRecordAuditLogNodeConnection>;
  readonly authoritativeDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly consentDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly consentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly contactEmail?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly declarations?: Maybe<ResidentSafetyDeclarationNodeConnection>;
  readonly eesAgreedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly eesFileUrl?: Maybe<Scalars['String']['output']>;
  readonly eesGeneratedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentWithdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  readonly first: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isAppLinked: Scalars['Boolean']['output'];
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly language: Scalars['String']['output'];
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly last: Scalars['String']['output'];
  readonly lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly lifecycleStatus: Scalars['String']['output'];
  readonly linkSuggestions: ReadonlyArray<SafetySubjectLinkSuggestionType>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly outstandingActions?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly pcfraAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly pcfraCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraFileUrl?: Maybe<Scalars['String']['output']>;
  readonly pcfraOfferedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraParticipation?: Maybe<Scalars['String']['output']>;
  readonly reconciledAt?: Maybe<Scalars['DateTime']['output']>;
  readonly residency: ResidencyType;
  readonly reviewRequests: ReadonlyArray<SafetyReviewRequestNode>;
  readonly sharesWithFireService: Scalars['Boolean']['output'];
  readonly submittedBy?: Maybe<UserType>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};


export type ResidentSafetyRecordNodeAuditLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentSafetyRecordNodeDeclarationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  record?: InputMaybe<Scalars['UUID']['input']>;
};

export type ResidentSafetyRecordNodeConnection = {
  readonly __typename?: 'ResidentSafetyRecordNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSafetyRecordNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSafetyRecordNode` and its cursor. */
export type ResidentSafetyRecordNodeEdge = {
  readonly __typename?: 'ResidentSafetyRecordNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSafetyRecordNode>;
};

export type ResidentSurveyAnswerType = {
  readonly __typename?: 'ResidentSurveyAnswerType';
  readonly answer?: Maybe<ResidentSurveyOptionType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly resident?: Maybe<ResidentType>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type ResidentSurveyNode = {
  readonly __typename?: 'ResidentSurveyNode';
  readonly answers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly groups: CommunityGroupNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly options: ReadonlyArray<ResidentSurveyOptionType>;
  readonly publishedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly question: Scalars['String']['output'];
  readonly rawCsv: Scalars['String']['output'];
  readonly residentHasAnswered?: Maybe<Scalars['Boolean']['output']>;
  readonly status: Scalars['String']['output'];
  readonly totalResidents: Scalars['Int']['output'];
};


export type ResidentSurveyNodeGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type ResidentSurveyNodeConnection = {
  readonly __typename?: 'ResidentSurveyNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentSurveyNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentSurveyNode` and its cursor. */
export type ResidentSurveyNodeEdge = {
  readonly __typename?: 'ResidentSurveyNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentSurveyNode>;
};

export type ResidentSurveyOptionType = {
  readonly __typename?: 'ResidentSurveyOptionType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly option?: Maybe<Scalars['String']['output']>;
  readonly residents: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly totalResidents: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type ResidentTaskNode = {
  readonly __typename?: 'ResidentTaskNode';
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly residentStatus?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'id' instead. Retained for resident-app <= 4.20.x compatibility; remove once min-supported app version floor is raised above 4.20. */
  readonly taskId?: Maybe<Scalars['UUID']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<ReadonlyArray<ResidentTaskUpdateType>>;
};

export type ResidentTaskNodeConnection = {
  readonly __typename?: 'ResidentTaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ResidentTaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ResidentTaskNode` and its cursor. */
export type ResidentTaskNodeEdge = {
  readonly __typename?: 'ResidentTaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ResidentTaskNode>;
};

export type ResidentTaskUpdateType = {
  readonly __typename?: 'ResidentTaskUpdateType';
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly newStatus?: Maybe<Scalars['String']['output']>;
  readonly updateType?: Maybe<Scalars['String']['output']>;
};

export type ResidentType = {
  readonly __typename?: 'ResidentType';
  readonly avatar?: Maybe<Scalars['String']['output']>;
  readonly averageScore?: Maybe<Scalars['Float']['output']>;
  readonly conversations?: Maybe<ReadonlyArray<ConversationNode>>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly currentResidencies?: Maybe<ReadonlyArray<ResidencyType>>;
  readonly dateOfBirth?: Maybe<Scalars['String']['output']>;
  readonly documents: ResidencyDocumentNodeConnection;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasAcceptedArkTerms: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isLeaseholder?: Maybe<Scalars['Boolean']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly packages: PackageNodeConnection;
  readonly residencies: ReadonlyArray<ResidencyType>;
  readonly surveyAnswers: ReadonlyArray<ResidentSurveyAnswerType>;
  readonly tenancyapplicantSet: TenancyApplicantNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};


export type ResidentTypeConversationsArgs = {
  conversationLimit?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ResidentTypePackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  forUserOrUnassigned?: InputMaybe<Scalars['UUID']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};


export type ResidentTypeTenancyapplicantSetArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ResidentUnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ResidentUnarchiveKeyholderPayload = {
  readonly __typename?: 'ResidentUnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type ResidentUpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ResidentUpdateKeyholderPayload = {
  readonly __typename?: 'ResidentUpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

/** An enumeration. */
export enum ResidentialManagementAmenityTypeChoices {
  /** APPOINTMENT */
  Appointment = 'APPOINTMENT',
  /** FACILITY */
  Facility = 'FACILITY'
}

/** An enumeration. */
export enum ResidentialManagementApplicationAuditLogEventTypeChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Archived */
  Archived = 'ARCHIVED',
  /** Bulk Reminder Sent */
  BulkReminderSent = 'BULK_REMINDER_SENT',
  /** Community Found */
  CommunityFound = 'COMMUNITY_FOUND',
  /** Created */
  Created = 'CREATED',
  /** Document Uploaded */
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  /** Home Assigned */
  HomeAssigned = 'HOME_ASSIGNED',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Unarchived */
  Unarchived = 'UNARCHIVED'
}

/** An enumeration. */
export enum ResidentialManagementApplicationOwnershipTypeChoices {
  /** Owned */
  Ow = 'OW',
  /** Renting */
  Re = 'RE',
  /** Shared Ownership */
  So = 'SO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationSourceChoices {
  /** Applicant */
  Ap = 'AP',
  /** Concierge */
  Co = 'CO'
}

/** An enumeration. */
export enum ResidentialManagementApplicationStatusChoices {
  /** Approved */
  Ap = 'AP',
  /** Community Known */
  Ck = 'CK',
  /** Document Sent */
  Ds = 'DS',
  /** Multiple Communities */
  Mc = 'MC',
  /** Pending */
  Pe = 'PE',
  /** Rejected */
  Re = 'RE',
  /** Unknown Community */
  Uc = 'UC'
}

/** An enumeration. */
export enum ResidentialManagementApplicationSupportMessageSenderChoices {
  /** Applicant */
  Applicant = 'APPLICANT',
  /** Support */
  Support = 'SUPPORT'
}

/** An enumeration. */
export enum ResidentialManagementApplicationThreadMediaSenderChoices {
  /** Applicant */
  Ap = 'AP',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementApplicationThreadMessageSenderChoices {
  /** Applicant */
  Ap = 'AP',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobActionChoices {
  /** Close with message */
  CloseMessage = 'CLOSE_MESSAGE',
  /** Close silent */
  CloseSilent = 'CLOSE_SILENT'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobClosedReasonChoices {
  /** Manual */
  Manual = 'MANUAL',
  /** Stale - inactivity */
  StaleInactivity = 'STALE_INACTIVITY',
  /** Stale - unanswered */
  StaleUnanswered = 'STALE_UNANSWERED'
}

/** An enumeration. */
export enum ResidentialManagementBulkConversationActionJobStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING'
}

/** An enumeration. */
export enum ResidentialManagementClientContractorCompanyCompanyTypeChoices {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum ResidentialManagementCommunityDocumentViewersChoices {
  /** All */
  Al = 'AL',
  /** Leaseholders */
  Le = 'LE',
  /** Residents */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityFormProviderChoices {
  /** TYPEFORM */
  Typeform = 'TYPEFORM'
}

/** An enumeration. */
export enum ResidentialManagementCommunityGroupTypeChoices {
  /** Custom */
  Custom = 'CUSTOM',
  /** Everyone */
  Everyone = 'EVERYONE',
  /** Leaseholders */
  Leaseholders = 'LEASEHOLDERS',
  /** Residents */
  Residents = 'RESIDENTS'
}

/** An enumeration. */
export enum ResidentialManagementCommunityStatisticDataPointTypeChoices {
  /** ACTIVE_RESIDENT_COUNT */
  ActiveResidentCount = 'ACTIVE_RESIDENT_COUNT',
  /** AVERAGE_PACKAGE_COLLECTION_TIME */
  AveragePackageCollectionTime = 'AVERAGE_PACKAGE_COLLECTION_TIME',
  /** DOWNLOAD_RATE_PERCENTAGE */
  DownloadRatePercentage = 'DOWNLOAD_RATE_PERCENTAGE',
  /** FACILITY_BOOKINGS_COUNT */
  FacilityBookingsCount = 'FACILITY_BOOKINGS_COUNT',
  /** INCOMING_MESSAGES_COUNT */
  IncomingMessagesCount = 'INCOMING_MESSAGES_COUNT',
  /** KEY_IN_COUNT */
  KeyInCount = 'KEY_IN_COUNT',
  /** KEY_OUT_COUNT */
  KeyOutCount = 'KEY_OUT_COUNT',
  /** PACKAGE_COLLECTED_COUNT */
  PackageCollectedCount = 'PACKAGE_COLLECTED_COUNT',
  /** PACKAGE_DELIVERED_COUNT */
  PackageDeliveredCount = 'PACKAGE_DELIVERED_COUNT'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCommentUserTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateCreatorTypeChoices {
  /** Concierge */
  Co = 'CO',
  /** Manager */
  Ma = 'MA'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateLinkedFeatureChoices {
  /** MARKETPLACE_THREADS */
  MarketplaceThreads = 'MARKETPLACE_THREADS',
  /** SERVICE_CHARGE_TRANSPARENCY */
  ServiceChargeTransparency = 'SERVICE_CHARGE_TRANSPARENCY'
}

/** An enumeration. */
export enum ResidentialManagementCommunityUpdateLocaleVariantStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Error */
  Error = 'ERROR',
  /** Loading */
  Loading = 'LOADING'
}

/** An enumeration. */
export enum ResidentialManagementContractorCompanyTypeChoices {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum ResidentialManagementConversationCategoryChoices {
  /** Concierge */
  Co = 'CO',
  /** Documents */
  Do = 'DO',
  /** Electric */
  El = 'EL',
  /** Heating */
  He = 'HE',
  /** Other */
  Ot = 'OT',
  /** Payment Queries */
  Pa = 'PA'
}

/** An enumeration. */
export enum ResidentialManagementConversationClosedByChoices {
  /** System */
  System = 'SYSTEM',
  /** User */
  User = 'USER'
}

/** An enumeration. */
export enum ResidentialManagementConversationClosedReasonChoices {
  /** Manual */
  Manual = 'MANUAL',
  /** Stale - inactivity */
  StaleInactivity = 'STALE_INACTIVITY',
  /** Stale - unanswered */
  StaleUnanswered = 'STALE_UNANSWERED'
}

/** An enumeration. */
export enum ResidentialManagementConversationMediaSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementConversationMessageSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementConversationParticipantTypeChoices {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** LEASEHOLDER */
  Leaseholder = 'LEASEHOLDER',
  /** RESIDENT */
  Resident = 'RESIDENT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingDisplayStyleChoices {
  /** Numbers 1 to 5 */
  Numbers = 'NUMBERS',
  /** Stars */
  Stars = 'STARS'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingQuestionAnswerTypeChoices {
  /** 1 to 5 */
  Scale = 'SCALE',
  /** Text */
  Text = 'TEXT'
}

/** An enumeration. */
export enum ResidentialManagementConversationRatingSurfaceChoices {
  /** App open */
  AppOpen = 'APP_OPEN',
  /** Banner */
  Banner = 'BANNER',
  /** Chat footer */
  ChatFooter = 'CHAT_FOOTER',
  /** Push */
  Push = 'PUSH'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionModeChoices {
  /** Inspection */
  Inspection = 'INSPECTION',
  /** Template */
  Template = 'TEMPLATE'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionParseStrategyChoices {
  /** Docling */
  Docling = 'DOCLING',
  /** Gemini direct */
  GeminiDirect = 'GEMINI_DIRECT',
  /** OCTX DocAI */
  OctxDocai = 'OCTX_DOCAI',
  /** pdfplumber */
  Pdfplumber = 'PDFPLUMBER'
}

/** An enumeration. */
export enum ResidentialManagementDocumentExtractionStatusChoices {
  /** Extracting */
  Extracting = 'EXTRACTING',
  /** Failed */
  Failed = 'FAILED',
  /** Materializing */
  Materializing = 'MATERIALIZING',
  /** Parsing */
  Parsing = 'PARSING',
  /** Ready */
  Ready = 'READY',
  /** Uploaded */
  Uploaded = 'UPLOADED',
  /** Validating */
  Validating = 'VALIDATING'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices {
  /** Amber */
  Amber = 'AMBER',
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultAiRecommendationChoices {
  /** Approved */
  Approved = 'APPROVED',
  /** Needs Review */
  NeedsReview = 'NEEDS_REVIEW',
  /** Rejected */
  Rejected = 'REJECTED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultNameMatchStatusChoices {
  /** Amber */
  Amber = 'AMBER',
  /** Green */
  Green = 'GREEN',
  /** Red */
  Red = 'RED'
}

/** An enumeration. */
export enum ResidentialManagementDocumentVerificationResultStatusChoices {
  /** Completed */
  Completed = 'COMPLETED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Processing */
  Processing = 'PROCESSING'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsFurnishingChoices {
  /** Fully Furnished */
  Fu = 'FU',
  /** None */
  No = 'NO',
  /** Partially Furnished */
  Pa = 'PA',
  /** Unfurnished */
  Un = 'UN'
}

/** An enumeration. */
export enum ResidentialManagementHomeDetailsParkingChoices {
  /** Not Available */
  Na = 'NA',
  /** None */
  No = 'NO',
  /** Off-Street */
  Of = 'OF',
  /** On-Street */
  On = 'ON'
}

/** An enumeration. */
export enum ResidentialManagementKeyEventTypeChoices {
  /** Check in */
  In = 'IN',
  /** Check out */
  Ou = 'OU'
}

/** An enumeration. */
export enum ResidentialManagementMessageSuggestionActionChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Edited */
  Edited = 'EDITED',
  /** Ignored */
  Ignored = 'IGNORED'
}

/** An enumeration. */
export enum ResidentialManagementPackageEventTypeChoices {
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** COLLECTION */
  Collection = 'COLLECTION',
  /** COLLECTION_CONFIRMATION_CONFIRMATION */
  CollectionConfirmationConfirmation = 'COLLECTION_CONFIRMATION_CONFIRMATION',
  /** COLLECTION_CONFIRMATION_REJECTION */
  CollectionConfirmationRejection = 'COLLECTION_CONFIRMATION_REJECTION',
  /** COLLECTION_CONFIRMATION_REQUEST */
  CollectionConfirmationRequest = 'COLLECTION_CONFIRMATION_REQUEST',
  /** DELIVERY */
  Delivery = 'DELIVERY',
  /** MARKED_AS_DUPLICATE */
  MarkedAsDuplicate = 'MARKED_AS_DUPLICATE',
  /** MARKED_AS_INCORRECTLY_ASSIGNED */
  MarkedAsIncorrectlyAssigned = 'MARKED_AS_INCORRECTLY_ASSIGNED',
  /** REMINDER */
  Reminder = 'REMINDER'
}

/** An enumeration. */
export enum ResidentialManagementPackageStatusChoices {
  /** ARCHIVED */
  Archived = 'ARCHIVED',
  /** Collected */
  Co = 'CO',
  /** Delivered */
  De = 'DE',
  /** DUPLICATE */
  Duplicate = 'DUPLICATE',
  /** INCORRECTLY_ASSIGNED */
  IncorrectlyAssigned = 'INCORRECTLY_ASSIGNED',
  /** PENDING_COLLECTION_CONFIRMATION */
  PendingCollectionConfirmation = 'PENDING_COLLECTION_CONFIRMATION'
}

/** An enumeration. */
export enum ResidentialManagementResidentSafetyDeclarationOriginChoices {
  /** Legacy V1 */
  LegacyV1 = 'LEGACY_V1',
  /** Manager Direct */
  ManagerDirect = 'MANAGER_DIRECT',
  /** Manager Paper */
  ManagerPaper = 'MANAGER_PAPER',
  /** Manager Phone */
  ManagerPhone = 'MANAGER_PHONE',
  /** Reconfirmation */
  Reconfirmation = 'RECONFIRMATION',
  /** Resident App */
  ResidentApp = 'RESIDENT_APP',
  /** Rolling Deploy Repair */
  RollingDeployRepair = 'ROLLING_DEPLOY_REPAIR'
}

/** An enumeration. */
export enum ResidentialManagementResidentSafetyRecordAuditLogEventTypeChoices {
  /** Compliance V2 Activated */
  ComplianceV2Activated = 'COMPLIANCE_V2_ACTIVATED',
  /** Consent Declined */
  ConsentDeclined = 'CONSENT_DECLINED',
  /** Consent Given */
  ConsentGiven = 'CONSENT_GIVEN',
  /** Ees Agreed */
  EesAgreed = 'EES_AGREED',
  /** Ees Generated */
  EesGenerated = 'EES_GENERATED',
  /** Needs Submitted */
  NeedsSubmitted = 'NEEDS_SUBMITTED',
  /** Needs Updated */
  NeedsUpdated = 'NEEDS_UPDATED',
  /** Occupant Removed */
  OccupantRemoved = 'OCCUPANT_REMOVED',
  /** Pcfra Accepted */
  PcfraAccepted = 'PCFRA_ACCEPTED',
  /** Pcfra Completed */
  PcfraCompleted = 'PCFRA_COMPLETED',
  /** Pcfra Declined */
  PcfraDeclined = 'PCFRA_DECLINED',
  /** Pcfra Offered */
  PcfraOffered = 'PCFRA_OFFERED',
  /** Reminder Sent */
  ReminderSent = 'REMINDER_SENT',
  /** Review Reset */
  ReviewReset = 'REVIEW_RESET',
  /** Sharing Consent Given */
  SharingConsentGiven = 'SHARING_CONSENT_GIVEN',
  /** Sharing Consent Withdrawn */
  SharingConsentWithdrawn = 'SHARING_CONSENT_WITHDRAWN',
  /** Subject Archived */
  SubjectArchived = 'SUBJECT_ARCHIVED',
  /** Subject Linked */
  SubjectLinked = 'SUBJECT_LINKED',
  /** Subject Merged */
  SubjectMerged = 'SUBJECT_MERGED',
  /** Subject Restored */
  SubjectRestored = 'SUBJECT_RESTORED'
}

/** An enumeration. */
export enum ResidentialManagementSafetyCenterDocumentSibCategoryChoices {
  /** Access plan */
  AccessPlan = 'ACCESS_PLAN',
  /** Block plan */
  BlockPlan = 'BLOCK_PLAN',
  /** Contractor contacts */
  ContractorContacts = 'CONTRACTOR_CONTACTS',
  /** Fire strategy */
  FireStrategy = 'FIRE_STRATEGY',
  /** Floor plan */
  FloorPlan = 'FLOOR_PLAN',
  /** Hydrant map */
  HydrantMap = 'HYDRANT_MAP',
  /** Key holders */
  KeyHolders = 'KEY_HOLDERS',
  /** Other */
  Other = 'OTHER',
  /** Risk assessment */
  RiskAssessment = 'RISK_ASSESSMENT'
}

/** An enumeration. */
export enum ResidentialManagementSafetyReviewAttemptChannelChoices {
  /** Resident app */
  App = 'APP',
  /** Paper form */
  Paper = 'PAPER',
  /** Phone call */
  Phone = 'PHONE'
}

/** An enumeration. */
export enum ResidentialManagementSafetyReviewRequestRequestTypeChoices {
  /** Initial request */
  Initial = 'INITIAL',
  /** Review request */
  Review = 'REVIEW'
}

/** An enumeration. */
export enum ResidentialManagementScheduledMessageSenderChoices {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum ResidentialManagementScheduledMessageStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Failed */
  Failed = 'FAILED',
  /** Pending */
  Pending = 'PENDING',
  /** Sent */
  Sent = 'SENT'
}

/** An enumeration. */
export enum ResidentialManagementUserFeatureAnnouncementViewPlatformChoices {
  /** Manager App */
  ManagerApp = 'MANAGER_APP',
  /** Manager Dashboard */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** Resident App */
  ResidentApp = 'RESIDENT_APP'
}

/** An enumeration. */
export enum ResidentialManagementWaiverTypeChoices {
  /** KEY */
  Key = 'KEY',
  /** PACKAGE */
  Package = 'PACKAGE'
}

export type ResolveChecklistActionInput = {
  readonly actionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type ResolveChecklistActionPayload = {
  readonly __typename?: 'ResolveChecklistActionPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RespondToContractorSuggestionInput = {
  readonly classificationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly decision: ContractorDecision;
};

export type RespondToContractorSuggestionPayload = {
  readonly __typename?: 'RespondToContractorSuggestionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type RespondToPcfra = {
  readonly __typename?: 'RespondToPcfra';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type ResponseTimeType = {
  readonly __typename?: 'ResponseTimeType';
  readonly averageResponseTime?: Maybe<Scalars['Int']['output']>;
  readonly date?: Maybe<Scalars['Date']['output']>;
};

export type RestartIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RestartIdentityVerificationPayload = {
  readonly __typename?: 'RestartIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type RetryDocumentExtractionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RetryDocumentExtractionPayload = {
  readonly __typename?: 'RetryDocumentExtractionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly documentExtraction?: Maybe<DocumentExtractionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ReviewInspectionActionInput = {
  readonly actionId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dismissalNote?: InputMaybe<Scalars['String']['input']>;
  readonly dismissalReason?: InputMaybe<Scalars['String']['input']>;
  readonly reviewStatus: Scalars['String']['input'];
};

export type ReviewInspectionActionPayload = {
  readonly __typename?: 'ReviewInspectionActionPayload';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RevokeCommunityStaffRoleInput = {
  readonly assignmentId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeCommunityStaffRolePayload = {
  readonly __typename?: 'RevokeCommunityStaffRolePayload';
  readonly assignment: CommunityStaffRoleType;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type RevokeGeneratedAgreementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type RevokeGeneratedAgreementPayload = {
  readonly __typename?: 'RevokeGeneratedAgreementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type RightToRentNode = {
  readonly __typename?: 'RightToRentNode';
  readonly document?: Maybe<Scalars['String']['output']>;
  readonly hasShareCode: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly officialDocument?: Maybe<Scalars['String']['output']>;
  readonly officialExpiryDate?: Maybe<Scalars['Date']['output']>;
  readonly officialVerificationStatus?: Maybe<TenancyApplicationRightToRentOfficialVerificationStatusChoices>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
};

export type RotateSafetyResponderToken = {
  readonly __typename?: 'RotateSafetyResponderToken';
  readonly pack?: Maybe<SafetyResponderPackNode>;
  readonly residualWindow: Scalars['String']['output'];
};

export type RuleActionNode = {
  readonly __typename?: 'RuleActionNode';
  readonly action: RulesRuleActionActionChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['String']['output'];
  readonly target?: Maybe<RuleActionTargetUnion>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type RuleActionNodeConnection = {
  readonly __typename?: 'RuleActionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleActionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleActionNode` and its cursor. */
export type RuleActionNodeEdge = {
  readonly __typename?: 'RuleActionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleActionNode>;
};

export type RuleActionTargetUnion = TeamNode | UserType;

export type RuleConditionNode = {
  readonly __typename?: 'RuleConditionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly event: RulesRuleConditionEventChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId?: Maybe<Scalars['String']['output']>;
  readonly operator: RulesRuleConditionOperatorChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type RuleConditionNodeConnection = {
  readonly __typename?: 'RuleConditionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleConditionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleConditionNode` and its cursor. */
export type RuleConditionNodeEdge = {
  readonly __typename?: 'RuleConditionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleConditionNode>;
};

export type RuleNode = {
  readonly __typename?: 'RuleNode';
  readonly actions?: Maybe<RuleActionNodeConnection>;
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly categoryContentTypes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly communities: CommunityNodeConnection;
  readonly conditions?: Maybe<RuleConditionNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly executionCount: Scalars['Int']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};


export type RuleNodeActionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type RuleNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manager?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  referencingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type RuleNodeConditionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type RuleNodeConnection = {
  readonly __typename?: 'RuleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<RuleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `RuleNode` and its cursor. */
export type RuleNodeEdge = {
  readonly __typename?: 'RuleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<RuleNode>;
};

/** An enumeration. */
export enum RulesRuleActionActionChoices {
  /** ASSIGN_TEAM */
  AssignTeam = 'ASSIGN_TEAM',
  /** ASSIGN_USER */
  AssignUser = 'ASSIGN_USER',
  /** NOTIFY_TEAM */
  NotifyTeam = 'NOTIFY_TEAM',
  /** NOTIFY_USER */
  NotifyUser = 'NOTIFY_USER'
}

/** An enumeration. */
export enum RulesRuleConditionEventChoices {
  /** STATUS_CLOSED */
  StatusClosed = 'STATUS_CLOSED',
  /** STATUS_REOPENED */
  StatusReopened = 'STATUS_REOPENED',
  /** STATUS_SNOOZED */
  StatusSnoozed = 'STATUS_SNOOZED',
  /** TAG_ASSIGNMENT */
  TagAssignment = 'TAG_ASSIGNMENT'
}

/** An enumeration. */
export enum RulesRuleConditionOperatorChoices {
  /** EQUALS */
  Equals = 'EQUALS',
  /** NOT_EQUALS */
  NotEquals = 'NOT_EQUALS'
}

export type SafetyBlockReadinessType = {
  readonly __typename?: 'SafetyBlockReadinessType';
  readonly assessment: SafetyReadinessRatioType;
  readonly blockId: Scalars['UUID']['output'];
  readonly blockName: Scalars['String']['output'];
  readonly cohorts: SafetyReadinessCohortsType;
  readonly consent: SafetyReadinessRatioType;
  readonly currency: SafetyReadinessRatioType;
  readonly exclusions: ReadonlyArray<SafetyReadinessExclusionType>;
  readonly floorsKnown: Scalars['Boolean']['output'];
  readonly homes: Scalars['Int']['output'];
  readonly homesWithoutFloor: Scalars['Int']['output'];
  readonly packCurrent: Scalars['Boolean']['output'];
  readonly packGenerated: Scalars['Boolean']['output'];
  readonly response: SafetyReadinessRatioType;
  readonly responsiblePersonNamed: Scalars['Boolean']['output'];
  readonly unassignedResidents: Scalars['Int']['output'];
};

export type SafetyCenterDocumentNode = {
  readonly __typename?: 'SafetyCenterDocumentNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly block?: Maybe<BlockNode>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description: Scalars['String']['output'];
  readonly effectiveFileUrl?: Maybe<Scalars['String']['output']>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly fileName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly includeInSibPack: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly showInSafetyCenter: Scalars['Boolean']['output'];
  readonly sibCategory?: Maybe<ResidentialManagementSafetyCenterDocumentSibCategoryChoices>;
  readonly sourceDocument?: Maybe<CommunityDocumentNode>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type SafetyCenterDocumentNodeConnection = {
  readonly __typename?: 'SafetyCenterDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<SafetyCenterDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `SafetyCenterDocumentNode` and its cursor. */
export type SafetyCenterDocumentNodeEdge = {
  readonly __typename?: 'SafetyCenterDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<SafetyCenterDocumentNode>;
};

export type SafetyCommunityReadinessType = {
  readonly __typename?: 'SafetyCommunityReadinessType';
  readonly blocks: ReadonlyArray<SafetyBlockReadinessType>;
  readonly communityId: Scalars['UUID']['output'];
  readonly communityName: Scalars['String']['output'];
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export enum SafetyComplianceAuthority {
  PrescribedRepresentative = 'PRESCRIBED_REPRESENTATIVE',
  Resident = 'RESIDENT'
}

export enum SafetyComplianceChannel {
  App = 'APP',
  InPerson = 'IN_PERSON',
  Paper = 'PAPER',
  Phone = 'PHONE'
}

export type SafetyComplianceReadinessType = {
  readonly __typename?: 'SafetyComplianceReadinessType';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly awaitingExplicitConsentCount: Scalars['Int']['output'];
  readonly eligibleAfterActivation: Scalars['Int']['output'];
  readonly eligibleNow: Scalars['Int']['output'];
  readonly leavingPackCount: Scalars['Int']['output'];
  readonly pcfraOfferedNotCompletedCount: Scalars['Int']['output'];
  readonly pcfraStatusChangedCount: Scalars['Int']['output'];
};

export type SafetyHouseholdSubjectType = {
  readonly __typename?: 'SafetyHouseholdSubjectType';
  readonly answeredBySubject?: Maybe<Scalars['Boolean']['output']>;
  readonly braille?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly communicationNeeds?: Maybe<Scalars['String']['output']>;
  readonly consentDeclinedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly consentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  readonly declarations?: Maybe<ReadonlyArray<Maybe<ResidentSafetyDeclarationNode>>>;
  readonly fireServiceConsentGivenAt?: Maybe<Scalars['DateTime']['output']>;
  readonly fireServiceConsentWithdrawnAt?: Maybe<Scalars['DateTime']['output']>;
  readonly first?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['UUID']['output']>;
  readonly informationHeld?: Maybe<Scalars['Boolean']['output']>;
  readonly isOccupant?: Maybe<Scalars['Boolean']['output']>;
  readonly isSelf?: Maybe<Scalars['Boolean']['output']>;
  readonly language?: Maybe<Scalars['String']['output']>;
  readonly largePrint?: Maybe<Scalars['Boolean']['output']>;
  readonly last?: Maybe<Scalars['String']['output']>;
  readonly lastDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly lastDeclaredBy?: Maybe<Scalars['String']['output']>;
  readonly lastReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly mobilityNeedDeclared?: Maybe<Scalars['Boolean']['output']>;
  readonly mobilityNeeds?: Maybe<Scalars['String']['output']>;
  readonly outstandingActions?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly pcfraOfferedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly pcfraParticipation?: Maybe<Scalars['String']['output']>;
  readonly sharesWithFireService?: Maybe<Scalars['Boolean']['output']>;
  readonly textToSpeech?: Maybe<Scalars['Boolean']['output']>;
  readonly userId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyHouseholdType = {
  readonly __typename?: 'SafetyHouseholdType';
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
  readonly subjects?: Maybe<ReadonlyArray<Maybe<SafetyHouseholdSubjectType>>>;
};

export type SafetyPackEligibilityType = {
  readonly __typename?: 'SafetyPackEligibilityType';
  readonly eligibleCount: Scalars['Int']['output'];
  readonly excludedCount: Scalars['Int']['output'];
  readonly excludedRecords: ReadonlyArray<SafetyPackExcludedRecordType>;
  readonly exclusions: ReadonlyArray<SafetyPackExclusionType>;
  readonly totalCount: Scalars['Int']['output'];
};

export type SafetyPackExcludedRecordType = {
  readonly __typename?: 'SafetyPackExcludedRecordType';
  readonly blockName: Scalars['String']['output'];
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly homeName: Scalars['String']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
  readonly recordId: Scalars['UUID']['output'];
};

export type SafetyPackExclusionType = {
  readonly __typename?: 'SafetyPackExclusionType';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
};

export enum SafetyPaperFormScope {
  Blank = 'BLANK',
  Household = 'HOUSEHOLD',
  Individual = 'INDIVIDUAL'
}

export type SafetyReadinessCohortsType = {
  readonly __typename?: 'SafetyReadinessCohortsType';
  readonly declaredNeeds: Scalars['Int']['output'];
  readonly noNeeds: Scalars['Int']['output'];
  readonly notAnswered: Scalars['Int']['output'];
  readonly notOccupant: Scalars['Int']['output'];
};

export type SafetyReadinessExclusionType = {
  readonly __typename?: 'SafetyReadinessExclusionType';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly reason: Scalars['String']['output'];
};

export type SafetyReadinessRatioType = {
  readonly __typename?: 'SafetyReadinessRatioType';
  readonly denominator: Scalars['Int']['output'];
  readonly numerator: Scalars['Int']['output'];
};

export type SafetyResponderPackNode = {
  readonly __typename?: 'SafetyResponderPackNode';
  readonly block: BlockNode;
  readonly eligibility: SafetyPackEligibilityType;
  readonly fileUrl?: Maybe<Scalars['String']['output']>;
  readonly generatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isComplete: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isStale: Scalars['Boolean']['output'];
  readonly isTokenActive: Scalars['Boolean']['output'];
  readonly printedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly responderUrl?: Maybe<Scalars['String']['output']>;
  readonly reviewNudgeSentAt?: Maybe<Scalars['DateTime']['output']>;
  readonly rotationResidualWindow: Scalars['String']['output'];
  readonly token?: Maybe<Scalars['UUID']['output']>;
  readonly tokenActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tokenRotatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tokenRotationReason: Scalars['String']['output'];
};

export enum SafetyReviewAttemptChannel {
  App = 'APP',
  Paper = 'PAPER',
  Phone = 'PHONE'
}

export type SafetyReviewAttemptNode = {
  readonly __typename?: 'SafetyReviewAttemptNode';
  readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly initiatedByName?: Maybe<Scalars['String']['output']>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly note?: Maybe<Scalars['String']['output']>;
  readonly queuedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly request: SafetyReviewRequestNode;
};

/** Attempt fields read one prefetched list so a roster page stays flat. */
export type SafetyReviewRequestNode = {
  readonly __typename?: 'SafetyReviewRequestNode';
  readonly attemptCount: Scalars['Int']['output'];
  readonly attempts: ReadonlyArray<SafetyReviewAttemptNode>;
  readonly cancelledAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedByDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly escalationDueAt?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isEscalationDue: Scalars['Boolean']['output'];
  readonly isOpen: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly latestAttemptAt?: Maybe<Scalars['DateTime']['output']>;
  readonly openedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly recipient?: Maybe<UserType>;
  readonly record: ResidentSafetyRecordNode;
  readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices;
  readonly residencyId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyRosterCountsType = {
  readonly __typename?: 'SafetyRosterCountsType';
  readonly all: Scalars['Int']['output'];
  readonly declaredNeeds: Scalars['Int']['output'];
  readonly needsAction: Scalars['Int']['output'];
  readonly noNeeds: Scalars['Int']['output'];
  readonly notAnswered: Scalars['Int']['output'];
};

export type SafetyRosterEesCountsType = {
  readonly __typename?: 'SafetyRosterEesCountsType';
  readonly agreed: Scalars['Int']['output'];
  readonly generated: Scalars['Int']['output'];
  readonly notGenerated: Scalars['Int']['output'];
};

export type SafetyRosterPcfraCountsType = {
  readonly __typename?: 'SafetyRosterPcfraCountsType';
  readonly declined: Scalars['Int']['output'];
  readonly notOffered: Scalars['Int']['output'];
  readonly offered: Scalars['Int']['output'];
};

export type SafetyRosterRowType = {
  readonly __typename?: 'SafetyRosterRowType';
  readonly blockName?: Maybe<Scalars['String']['output']>;
  readonly communityName?: Maybe<Scalars['String']['output']>;
  readonly complianceActions: ReadonlyArray<Scalars['String']['output']>;
  readonly first: Scalars['String']['output'];
  readonly floorNumber?: Maybe<Scalars['Int']['output']>;
  readonly homeId?: Maybe<Scalars['UUID']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly isAppLinked: Scalars['Boolean']['output'];
  readonly isOverdue: Scalars['Boolean']['output'];
  readonly last: Scalars['String']['output'];
  readonly lastDeclaredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly latestDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly lifecycleStatus: Scalars['String']['output'];
  readonly needsAction: Scalars['Boolean']['output'];
  readonly needsReconciliation: Scalars['Boolean']['output'];
  readonly occupantKnown: Scalars['Boolean']['output'];
  readonly openReviewRequest?: Maybe<SafetyReviewRequestNode>;
  readonly record?: Maybe<ResidentSafetyRecordNode>;
  readonly residencyId: Scalars['UUID']['output'];
  readonly state: Scalars['String']['output'];
  readonly userId?: Maybe<Scalars['UUID']['output']>;
};

export type SafetyRosterType = {
  readonly __typename?: 'SafetyRosterType';
  readonly cohort: Scalars['String']['output'];
  readonly counts: SafetyRosterCountsType;
  readonly eesCounts: SafetyRosterEesCountsType;
  readonly hasMore: Scalars['Boolean']['output'];
  readonly pcfraCounts: SafetyRosterPcfraCountsType;
  readonly rows: ReadonlyArray<SafetyRosterRowType>;
  readonly totalCount: Scalars['Int']['output'];
};

export type SafetySubjectLinkSuggestionType = {
  readonly __typename?: 'SafetySubjectLinkSuggestionType';
  readonly email: Scalars['String']['output'];
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type SaveAmenityInput = {
  readonly archivedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly daysAvailable: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly description: Scalars['String']['input'];
  readonly endTime: Scalars['DateTime']['input'];
  readonly exclusive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly links?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly live?: InputMaybe<Scalars['Boolean']['input']>;
  readonly maxAdvanceReservationDays?: InputMaybe<Scalars['Int']['input']>;
  readonly maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  readonly maxHours?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: InputMaybe<Scalars['Int']['input']>;
  readonly maxReservations?: InputMaybe<Scalars['Int']['input']>;
  /** The maximum time in seconds */
  readonly maxTime?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly reservable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly startTime: Scalars['DateTime']['input'];
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type SaveAmenityOperatingTimesInput = {
  readonly amenity: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly endTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActivated?: InputMaybe<Scalars['Boolean']['input']>;
  readonly startTime?: InputMaybe<Scalars['DateTime']['input']>;
  readonly weekDay: Scalars['Int']['input'];
};

export type SaveAmenityOperatingTimesPayload = {
  readonly __typename?: 'SaveAmenityOperatingTimesPayload';
  readonly amenityOperatingTimes?: Maybe<AmenityOperatingTimesNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SaveAmenityPayload = {
  readonly __typename?: 'SaveAmenityPayload';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly daysAvailable?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly exclusive?: Maybe<Scalars['Boolean']['output']>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly links?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly live?: Maybe<Scalars['Boolean']['output']>;
  readonly maxAdvanceReservationDays?: Maybe<Scalars['Int']['output']>;
  readonly maxCapacity?: Maybe<Scalars['Int']['output']>;
  readonly maxHours?: Maybe<Scalars['Int']['output']>;
  /** The maximum reservation duration in seconds */
  readonly maxReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly maxReservations?: Maybe<Scalars['Int']['output']>;
  /** The maximum time in seconds */
  readonly maxTime?: Maybe<Scalars['Int']['output']>;
  /** Minimum time in seconds before the start time that a user must book this amenity. */
  readonly minBookingNotice?: Maybe<Scalars['Int']['output']>;
  /** The minimum reservation duration in seconds */
  readonly minReservationDuration?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly reservable?: Maybe<Scalars['Boolean']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type SaveCommunityEventInput = {
  readonly attendanceFee?: InputMaybe<Scalars['Decimal']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description: Scalars['String']['input'];
  readonly end: Scalars['DateTime']['input'];
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly links?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly maxAdditionalAttendees?: InputMaybe<Scalars['Int']['input']>;
  readonly maxSpaces: Scalars['Int']['input'];
  readonly name: Scalars['String']['input'];
  readonly start: Scalars['DateTime']['input'];
};

export type SaveCommunityEventPayload = {
  readonly __typename?: 'SaveCommunityEventPayload';
  readonly attendanceFee?: Maybe<Scalars['Decimal']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly end?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly links?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly maxAdditionalAttendees?: Maybe<Scalars['Int']['output']>;
  readonly maxSpaces?: Maybe<Scalars['Int']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly start?: Maybe<Scalars['DateTime']['output']>;
};

export type SaveCommunityUpdateInput = {
  readonly body: Scalars['String']['input'];
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly clearAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creatorType: Scalars['String']['input'];
  readonly document?: InputMaybe<Scalars['String']['input']>;
  readonly groups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly imageUrl?: InputMaybe<Scalars['String']['input']>;
  readonly status?: InputMaybe<Scalars['String']['input']>;
  readonly summary?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type SaveCommunityUpdatePayload = {
  readonly __typename?: 'SaveCommunityUpdatePayload';
  readonly body?: Maybe<Scalars['String']['output']>;
  readonly category?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creatorType?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly groups?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly imageUrl?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly summary?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveContactNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['UUID']['input'];
  readonly text: Scalars['String']['input'];
  readonly user: Scalars['UUID']['input'];
};

export type SaveContactNotePayload = {
  readonly __typename?: 'SaveContactNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contactNote?: Maybe<ContactNoteNode>;
};

export type SaveGeneratedAgreementInput = {
  readonly additionalTerms?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly depositAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly furnished?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordMobile?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly rentAmount?: InputMaybe<Scalars['Decimal']['input']>;
  readonly tenancyEnd?: InputMaybe<Scalars['Date']['input']>;
  readonly tenancyStart?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants: ReadonlyArray<InputMaybe<TenantSerializerInput>>;
  readonly utilitiesIncluded?: InputMaybe<Scalars['String']['input']>;
};

export type SaveGeneratedAgreementPayload = {
  readonly __typename?: 'SaveGeneratedAgreementPayload';
  readonly additionalTerms?: Maybe<Scalars['String']['output']>;
  readonly agreement?: Maybe<GeneratedAgreementNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly depositAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly furnished?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordMobile?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly rentAmount?: Maybe<Scalars['Decimal']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyEnd?: Maybe<Scalars['Date']['output']>;
  readonly tenancyStart?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementTenantNode>>>;
  readonly utilitiesIncluded?: Maybe<Scalars['String']['output']>;
};

export type SaveGeneratedSection21Input = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deadlineDate?: InputMaybe<Scalars['Date']['input']>;
  readonly depositCertificateProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home?: InputMaybe<Scalars['String']['input']>;
  readonly homeCity?: InputMaybe<Scalars['String']['input']>;
  readonly homeName?: InputMaybe<Scalars['String']['input']>;
  readonly homePostcode?: InputMaybe<Scalars['String']['input']>;
  readonly homeRegion?: InputMaybe<Scalars['String']['input']>;
  readonly htrgProvided?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly inspectionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly landlordAddress?: InputMaybe<Scalars['String']['input']>;
  readonly landlordEmail?: InputMaybe<Scalars['String']['input']>;
  readonly landlordName?: InputMaybe<Scalars['String']['input']>;
  readonly landlordPhone?: InputMaybe<Scalars['String']['input']>;
  readonly leadTenantEmail?: InputMaybe<Scalars['String']['input']>;
  readonly possessionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenants?: InputMaybe<Scalars['String']['input']>;
  readonly viewedOnArk?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SaveGeneratedSection21Payload = {
  readonly __typename?: 'SaveGeneratedSection21Payload';
  readonly client?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly deadlineDate?: Maybe<Scalars['Date']['output']>;
  readonly depositCertificateProvided?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly homeCity?: Maybe<Scalars['String']['output']>;
  readonly homeName?: Maybe<Scalars['String']['output']>;
  readonly homePostcode?: Maybe<Scalars['String']['output']>;
  readonly homeRegion?: Maybe<Scalars['String']['output']>;
  readonly htrgProvided?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly inspectionDate?: Maybe<Scalars['Date']['output']>;
  readonly landlordAddress?: Maybe<Scalars['String']['output']>;
  readonly landlordEmail?: Maybe<Scalars['String']['output']>;
  readonly landlordName?: Maybe<Scalars['String']['output']>;
  readonly landlordPhone?: Maybe<Scalars['String']['output']>;
  readonly leadTenantEmail?: Maybe<Scalars['String']['output']>;
  readonly possessionDate?: Maybe<Scalars['Date']['output']>;
  readonly tenants?: Maybe<Scalars['String']['output']>;
  readonly viewedOnArk?: Maybe<Scalars['Boolean']['output']>;
};

export type SaveHomeInput = {
  readonly HMO?: InputMaybe<Scalars['Boolean']['input']>;
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly numRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly postcode: Scalars['String']['input'];
};

export type SaveHomePayload = {
  readonly __typename?: 'SaveHomePayload';
  readonly HMO?: Maybe<Scalars['Boolean']['output']>;
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly numRooms?: Maybe<Scalars['Int']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type SaveManagerProfileInput = {
  readonly ASTPageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly complianceEmailExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  readonly compliancePageViewed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly complianceUpdateEmails?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly valueQuestionnaireAnswer?: InputMaybe<Scalars['Int']['input']>;
};

export type SaveManagerProfilePayload = {
  readonly __typename?: 'SaveManagerProfilePayload';
  readonly ASTPageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly complianceEmailExplanation?: Maybe<Scalars['Boolean']['output']>;
  readonly compliancePageViewed?: Maybe<Scalars['Boolean']['output']>;
  readonly complianceUpdateEmails?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly valueQuestionnaireAnswer?: Maybe<Scalars['Int']['output']>;
};

export type SaveMarketplaceItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly condition?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly price: Scalars['Decimal']['input'];
  readonly title: Scalars['String']['input'];
};

export type SaveMarketplaceItemPayload = {
  readonly __typename?: 'SaveMarketplaceItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly condition?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly price?: Maybe<Scalars['Decimal']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type SaveRequirementItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comment?: InputMaybe<Scalars['String']['input']>;
  readonly expiryDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly requirement: Scalars['String']['input'];
};

export type SaveRequirementItemPayload = {
  readonly __typename?: 'SaveRequirementItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly expiryDate?: Maybe<Scalars['Date']['output']>;
  readonly home?: Maybe<HomeType>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly requirement?: Maybe<Scalars['String']['output']>;
};

export type SaveResidentSurveyAnswerInput = {
  readonly answer?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly resident?: InputMaybe<Scalars['String']['input']>;
  readonly survey?: InputMaybe<Scalars['String']['input']>;
};

export type SaveResidentSurveyAnswerPayload = {
  readonly __typename?: 'SaveResidentSurveyAnswerPayload';
  readonly answer?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly resident?: Maybe<Scalars['String']['output']>;
  readonly survey?: Maybe<Scalars['String']['output']>;
};

export type SaveTenantEmploymentDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly employmentEnding?: InputMaybe<Scalars['Boolean']['input']>;
  readonly employmentType?: InputMaybe<Scalars['String']['input']>;
  readonly fullOrPartTime?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly income?: InputMaybe<Scalars['Decimal']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly paymentFrequency?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['Date']['input']>;
  readonly tenantReferenceId: Scalars['String']['input'];
};

export type SaveTenantEmploymentDetailsPayload = {
  readonly __typename?: 'SaveTenantEmploymentDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly employmentEnding?: Maybe<Scalars['Boolean']['output']>;
  readonly employmentType?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly fullOrPartTime?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly income?: Maybe<Scalars['Decimal']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly paymentFrequency?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['Date']['output']>;
};

export type ScheduleFinancialYearCategoryTotalNode = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNode';
  readonly category: FinanceScheduleFinancialYearCategoryTotalCategoryChoices;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly scheduleFinancialYear: ScheduleFinancialYearNode;
  readonly totalActual: Scalars['Decimal']['output'];
  readonly totalBudget: Scalars['Decimal']['output'];
  readonly variance?: Maybe<Scalars['Decimal']['output']>;
  readonly variancePercentage?: Maybe<Scalars['Float']['output']>;
};

export type ScheduleFinancialYearCategoryTotalNodeConnection = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleFinancialYearCategoryTotalNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleFinancialYearCategoryTotalNode` and its cursor. */
export type ScheduleFinancialYearCategoryTotalNodeEdge = {
  readonly __typename?: 'ScheduleFinancialYearCategoryTotalNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleFinancialYearCategoryTotalNode>;
};

export type ScheduleFinancialYearNode = {
  readonly __typename?: 'ScheduleFinancialYearNode';
  readonly actual: Scalars['JSONString']['output'];
  readonly budget: Scalars['JSONString']['output'];
  readonly budgetDocument?: Maybe<Scalars['String']['output']>;
  readonly budgetDocumentUrl?: Maybe<Scalars['String']['output']>;
  readonly categoryTotals: ScheduleFinancialYearCategoryTotalNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly demandMatchesCalculated?: Maybe<Scalars['Boolean']['output']>;
  readonly endDate: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly schedule: ScheduleNode;
  readonly startDate: Scalars['DateTime']['output'];
  readonly totalActual?: Maybe<Scalars['Decimal']['output']>;
  readonly totalBudget?: Maybe<Scalars['Decimal']['output']>;
  readonly yearEndDocument?: Maybe<Scalars['String']['output']>;
  readonly yearEndDocumentUrl?: Maybe<Scalars['String']['output']>;
};


export type ScheduleFinancialYearNodeCategoryTotalsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduleFinancialYearNodeDemandMatchesCalculatedArgs = {
  leaseholdId: Scalars['UUID']['input'];
};

export type ScheduleFinancialYearNodeConnection = {
  readonly __typename?: 'ScheduleFinancialYearNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleFinancialYearNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleFinancialYearNode` and its cursor. */
export type ScheduleFinancialYearNodeEdge = {
  readonly __typename?: 'ScheduleFinancialYearNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleFinancialYearNode>;
};

export type ScheduleNode = {
  readonly __typename?: 'ScheduleNode';
  readonly community?: Maybe<CommunityNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly financialYears: ScheduleFinancialYearNodeConnection;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly latestFinancialYear?: Maybe<ScheduleFinancialYearNode>;
  readonly leaseholdSchedules: LeaseholdScheduleNodeConnection;
  readonly name: Scalars['String']['output'];
  readonly totalBudget?: Maybe<Scalars['Decimal']['output']>;
};


export type ScheduleNodeFinancialYearsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type ScheduleNodeLeaseholdSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type ScheduleNodeConnection = {
  readonly __typename?: 'ScheduleNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<ScheduleNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `ScheduleNode` and its cursor. */
export type ScheduleNodeEdge = {
  readonly __typename?: 'ScheduleNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<ScheduleNode>;
};

export type SchedulePublishCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SchedulePublishCommunityUpdatePayload = {
  readonly __typename?: 'SchedulePublishCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ScheduledMessageMediaType = {
  readonly __typename?: 'ScheduledMessageMediaType';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly user: UserType;
};

export type ScheduledMessageType = {
  readonly __typename?: 'ScheduledMessageType';
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<Maybe<ScheduledMessageMediaType>>>;
  readonly sendAt: Scalars['DateTime']['output'];
  readonly sender: ResidentialManagementScheduledMessageSenderChoices;
  readonly status: ResidentialManagementScheduledMessageStatusChoices;
  readonly user: UserType;
};

export type SendAgreementForSigning = {
  readonly __typename?: 'SendAgreementForSigning';
  readonly tenants?: Maybe<ReadonlyArray<Maybe<AgreementSignatureOutput>>>;
};

export type SendAgreementForSigningInput = {
  readonly agreementId?: InputMaybe<Scalars['UUID']['input']>;
  readonly tenants?: InputMaybe<ReadonlyArray<InputMaybe<AgreementSignaturesTenant>>>;
};

export type SendApplicationSupportMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly thread: Scalars['String']['input'];
};

export type SendApplicationSupportMessagePayload = {
  readonly __typename?: 'SendApplicationSupportMessagePayload';
  readonly applicationSupportMessage?: Maybe<ApplicationSupportMessageNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SendApplicationThreadMessageInput = {
  readonly body: Scalars['String']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly thread: Scalars['String']['input'];
};

export type SendApplicationThreadMessagePayload = {
  readonly __typename?: 'SendApplicationThreadMessagePayload';
  readonly applicationThreadMessage?: Maybe<ApplicationThreadMessageNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SendConversationToAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly summary: Scalars['String']['input'];
};

export type SendConversationToAsanaPayload = {
  readonly __typename?: 'SendConversationToAsanaPayload';
  readonly asanaSendPending: Scalars['Boolean']['output'];
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly task?: Maybe<TaskNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type SendDocument = {
  readonly __typename?: 'SendDocument';
  readonly section21?: Maybe<GeneratedSection21Type>;
};

export type SendDocumentInput = {
  readonly emails?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id: Scalars['String']['input'];
};

export type SendManagerAmplitudeTestInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SendManagerAmplitudeTestPayload = {
  readonly __typename?: 'SendManagerAmplitudeTestPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type SendPaymentReceiptEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly payment: Scalars['UUID']['input'];
};

export type SendPaymentReceiptEmailPayload = {
  readonly __typename?: 'SendPaymentReceiptEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly ok: Scalars['Boolean']['output'];
};

export type SendSafetyReminder = {
  readonly __typename?: 'SendSafetyReminder';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type SendSafetyReviewRequest = {
  readonly __typename?: 'SendSafetyReviewRequest';
  readonly attempt?: Maybe<SafetyReviewAttemptNode>;
  readonly reviewRequest?: Maybe<SafetyReviewRequestNode>;
};

export type SendTenantReferenceRequestsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SendTenantReferenceRequestsPayload = {
  readonly __typename?: 'SendTenantReferenceRequestsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly tenancyApplication?: Maybe<TenancyApplicationNode>;
};

export type SetChecklistItemDueDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly itemId: Scalars['UUID']['input'];
};

export type SetChecklistItemDueDatePayload = {
  readonly __typename?: 'SetChecklistItemDueDatePayload';
  readonly checklistItem?: Maybe<TaskChecklistItemNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SetChecklistSectionDueDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['Date']['input']>;
  readonly sectionId: Scalars['UUID']['input'];
};

export type SetChecklistSectionDueDatePayload = {
  readonly __typename?: 'SetChecklistSectionDueDatePayload';
  readonly checklistSection?: Maybe<TaskChecklistSectionNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SetConversationHomeInput = {
  readonly classificationId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly decision: ConversationHomeDecision;
  readonly homeId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SetConversationHomePayload = {
  readonly __typename?: 'SetConversationHomePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type SetReportingFavouriteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly favourite: Scalars['Boolean']['input'];
  readonly id: Scalars['UUID']['input'];
};

export type SetReportingFavouritePayload = {
  readonly __typename?: 'SetReportingFavouritePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type SetReportingScheduleInput = {
  readonly cadence: ReportingScheduleCadence;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly enabled: Scalars['Boolean']['input'];
  readonly id: Scalars['UUID']['input'];
};

export type SetReportingSchedulePayload = {
  readonly __typename?: 'SetReportingSchedulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
};

export type SetResidencyCompletionDateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly completionDate?: InputMaybe<Scalars['Date']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SetResidencyCompletionDatePayload = {
  readonly __typename?: 'SetResidencyCompletionDatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly completionDate?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SetResidentAppLocaleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly locale: Scalars['String']['input'];
};

export type SetResidentAppLocalePayload = {
  readonly __typename?: 'SetResidentAppLocalePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type SetSafetyDocumentBlock = {
  readonly __typename?: 'SetSafetyDocumentBlock';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetyDocumentInSibPack = {
  readonly __typename?: 'SetSafetyDocumentInSibPack';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetyDocumentResidentVisible = {
  readonly __typename?: 'SetSafetyDocumentResidentVisible';
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type SetSafetySubjectContactEmailInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contactEmail?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SetSafetySubjectContactEmailPayload = {
  readonly __typename?: 'SetSafetySubjectContactEmailPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type SetUpManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly managerEmail: Scalars['String']['input'];
};

export type SetUpManagerPayload = {
  readonly __typename?: 'SetUpManagerPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type ShareComplianceRequirementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ShareComplianceRequirementPayload = {
  readonly __typename?: 'ShareComplianceRequirementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SignOffChecklistInput = {
  readonly approvedBy?: InputMaybe<Scalars['UUID']['input']>;
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly nextAssessmentDate?: InputMaybe<Scalars['Date']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly riskConsequence?: InputMaybe<Scalars['String']['input']>;
  readonly riskLikelihood?: InputMaybe<Scalars['String']['input']>;
  readonly riskRating?: InputMaybe<Scalars['String']['input']>;
};

export type SignOffChecklistPayload = {
  readonly __typename?: 'SignOffChecklistPayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type SignOutCommunityVisitorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SignOutCommunityVisitorPayload = {
  readonly __typename?: 'SignOutCommunityVisitorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityVisitor?: Maybe<CommunityVisitorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type SnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly snoozeForSeconds: Scalars['Int']['input'];
};

export type SnoozeConversationPayload = {
  readonly __typename?: 'SnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type SourceDocumentNode = {
  readonly __typename?: 'SourceDocumentNode';
  readonly firstPage?: Maybe<SourceDocumentPageNode>;
  readonly id: Scalars['UUID']['output'];
  readonly pageCount?: Maybe<Scalars['Int']['output']>;
  readonly parserVersion: Scalars['String']['output'];
};

export type SourceDocumentPageNode = {
  readonly __typename?: 'SourceDocumentPageNode';
  readonly height?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly image?: Maybe<Scalars['String']['output']>;
  readonly pageNo: Scalars['Int']['output'];
  readonly width?: Maybe<Scalars['Int']['output']>;
};

export type SourceRegionNode = {
  readonly __typename?: 'SourceRegionNode';
  readonly bboxNormB: Scalars['Float']['output'];
  readonly bboxNormL: Scalars['Float']['output'];
  readonly bboxNormR: Scalars['Float']['output'];
  readonly bboxNormT: Scalars['Float']['output'];
  readonly crop?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly selfRef: Scalars['String']['output'];
};

export type StaffRoleCatalogType = {
  readonly __typename?: 'StaffRoleCatalogType';
  readonly name: Scalars['String']['output'];
  readonly slug: Scalars['String']['output'];
};

export type StartBulkConversationClose = {
  readonly __typename?: 'StartBulkConversationClose';
  readonly job?: Maybe<BulkConversationActionJobNode>;
};

export type StartBulkDeactivationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
};

export type StartBulkDeactivationPayload = {
  readonly __typename?: 'StartBulkDeactivationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly job?: Maybe<BulkDeactivationJobNode>;
};

export type SubmitEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitEmployerReferencePayload = {
  readonly __typename?: 'SubmitEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitIdentityVerificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitIdentityVerificationPayload = {
  readonly __typename?: 'SubmitIdentityVerificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitLandlordReferencePayload = {
  readonly __typename?: 'SubmitLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubmitTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitTenantReferencePayload = {
  readonly __typename?: 'SubmitTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type SubscribeLandlordInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly discountCode?: InputMaybe<Scalars['String']['input']>;
  readonly includeSetupFee?: InputMaybe<Scalars['Boolean']['input']>;
  readonly source?: InputMaybe<Scalars['String']['input']>;
};

export type SubscribeLandlordPayload = {
  readonly __typename?: 'SubscribeLandlordPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly discountCodeValid?: Maybe<Scalars['Boolean']['output']>;
  readonly firstMonthCost?: Maybe<Scalars['Float']['output']>;
  readonly monthlyCost?: Maybe<Scalars['Float']['output']>;
  readonly stripeClientSecret?: Maybe<Scalars['String']['output']>;
  readonly tierUpTo?: Maybe<Scalars['Int']['output']>;
};

export type SubscribeToNotificationGroup = {
  readonly __typename?: 'SubscribeToNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type SubscriptionDetails = {
  readonly __typename?: 'SubscriptionDetails';
  readonly endDate: Scalars['String']['output'];
  readonly paymentMethod?: Maybe<PaymentMethod>;
  readonly price: Scalars['Float']['output'];
  readonly startDate: Scalars['String']['output'];
  readonly status: Scalars['String']['output'];
};

export type SubscriptionNode = {
  readonly __typename?: 'SubscriptionNode';
  readonly details?: Maybe<SubscriptionDetails>;
  readonly id: Scalars['UUID']['output'];
  readonly invoices?: Maybe<ReadonlyArray<Invoices>>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly residency?: Maybe<ResidencyNode>;
  readonly type?: Maybe<Scalars['String']['output']>;
  readonly upcomingInvoice?: Maybe<Invoices>;
};

export type SuggestRemediationStepsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly taskId: Scalars['UUID']['input'];
};

export type SuggestRemediationStepsPayload = {
  readonly __typename?: 'SuggestRemediationStepsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly steps?: Maybe<ReadonlyArray<SuggestedRemediationStepNode>>;
};

export type SuggestedRemediationStepNode = {
  readonly __typename?: 'SuggestedRemediationStepNode';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly guidance?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
};

export type SyncBlockGroupsInput = {
  readonly blockId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type SyncBlockGroupsPayload = {
  readonly __typename?: 'SyncBlockGroupsPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly results: ReadonlyArray<BlockGroupSyncResultNode>;
};

export type TagAssignmentContent = CommunityDocumentNode | ConversationNode | TaskDefinitionNode | UserDocumentNode;

export type TagAssignmentNode = {
  readonly __typename?: 'TagAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly confidenceScore?: Maybe<Scalars['Decimal']['output']>;
  readonly contentObject?: Maybe<TagAssignmentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly tag: ClientTagNode;
};

export type TagAssignmentNodeConnection = {
  readonly __typename?: 'TagAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TagAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TagAssignmentNode` and its cursor. */
export type TagAssignmentNodeEdge = {
  readonly __typename?: 'TagAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TagAssignmentNode>;
};

export type TagConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type TagConversationPayload = {
  readonly __typename?: 'TagConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationTag?: Maybe<ConversationTagNode>;
};

export type TagNode = {
  readonly __typename?: 'TagNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly color?: Maybe<Scalars['String']['output']>;
  /** Confidence score (0-1) that this tag is appropriate for the document */
  readonly confidenceScore?: Maybe<Scalars['Decimal']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type TagNodeConnection = {
  readonly __typename?: 'TagNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TagNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TagNode` and its cursor. */
export type TagNodeEdge = {
  readonly __typename?: 'TagNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TagNode>;
};

export type Target = AmenityNode | ApplicationNode | ApplicationSupportThreadNode | ApplicationThreadNode | CommunityDocumentNode | CommunityEventNode | CommunityNode | CommunityProductNode | CommunityUpdateNode | ConversationAssignmentNode | ConversationNode | DocumentExtractionNode | FeatureAnnouncementNode | GroupChatNode | HomeNode | KeyNode | MarketplaceItemNode | MarketplaceItemThreadNode | PackageNode | ResidencyDocumentNode | ResidentSurveyNode | TaskNode | TeamAssignmentNode | TenantReferenceNode | UserDocumentNode | UserType;

export type TaskCategoryNode = {
  readonly __typename?: 'TaskCategoryNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
};

export type TaskCategoryNodeConnection = {
  readonly __typename?: 'TaskCategoryNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskCategoryNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskCategoryNode` and its cursor. */
export type TaskCategoryNodeEdge = {
  readonly __typename?: 'TaskCategoryNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskCategoryNode>;
};

export type TaskChecklistItemCommentNode = {
  readonly __typename?: 'TaskChecklistItemCommentNode';
  readonly author?: Maybe<UserType>;
  readonly body: Scalars['String']['output'];
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly item: TaskChecklistItemNode;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistItemMediaNode = {
  readonly __typename?: 'TaskChecklistItemMediaNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly response?: Maybe<TaskChecklistItemResponseNode>;
  readonly uploadedBy?: Maybe<UserType>;
};

export type TaskChecklistItemNode = {
  readonly __typename?: 'TaskChecklistItemNode';
  readonly action?: Maybe<ChecklistActionNode>;
  readonly actions?: Maybe<ReadonlyArray<ChecklistActionNode>>;
  readonly assignedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignedUser?: Maybe<UserType>;
  readonly checklist: TaskChecklistNode;
  readonly comments?: Maybe<ReadonlyArray<TaskChecklistItemCommentNode>>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly completedBy?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly guidance: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isCompleted: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRequired: Scalars['Boolean']['output'];
  readonly media?: Maybe<ReadonlyArray<TaskChecklistItemMediaNode>>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order: Scalars['Int']['output'];
  readonly referenceCode?: Maybe<Scalars['String']['output']>;
  readonly requiresPhoto: Scalars['Boolean']['output'];
  readonly responseBoolean?: Maybe<Scalars['Boolean']['output']>;
  readonly responseChoice?: Maybe<Scalars['String']['output']>;
  readonly responseDate?: Maybe<Scalars['Date']['output']>;
  readonly responseNumber?: Maybe<Scalars['Decimal']['output']>;
  readonly responseText: Scalars['String']['output'];
  readonly responseTime?: Maybe<Scalars['Time']['output']>;
  readonly responses?: Maybe<ReadonlyArray<TaskChecklistItemResponseNode>>;
  readonly section?: Maybe<TaskChecklistSectionNode>;
  readonly stepType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistItemResponseNode = {
  readonly __typename?: 'TaskChecklistItemResponseNode';
  readonly answeredAt?: Maybe<Scalars['DateTime']['output']>;
  readonly answeredBy?: Maybe<UserType>;
  readonly config?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inputType?: Maybe<Scalars['String']['output']>;
  readonly isRequired: Scalars['Boolean']['output'];
  readonly item: TaskChecklistItemNode;
  readonly label: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly sourceInput?: Maybe<TaskTemplateStepInputNode>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly valueBoolean?: Maybe<Scalars['Boolean']['output']>;
  readonly valueChoice?: Maybe<Scalars['String']['output']>;
  readonly valueDate?: Maybe<Scalars['Date']['output']>;
  readonly valueNumber?: Maybe<Scalars['Decimal']['output']>;
  readonly valueText: Scalars['String']['output'];
  readonly valueTime?: Maybe<Scalars['Time']['output']>;
};

export type TaskChecklistNode = {
  readonly __typename?: 'TaskChecklistNode';
  readonly actions?: Maybe<ReadonlyArray<ChecklistActionNode>>;
  readonly approvedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly approvedBy?: Maybe<UserType>;
  readonly assessedBy?: Maybe<UserType>;
  readonly assessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly assessorName?: Maybe<Scalars['String']['output']>;
  readonly autoCompleteTask: Scalars['Boolean']['output'];
  readonly complianceRecord?: Maybe<ChecklistComplianceRecordNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isManuallyCompletable: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSignedOff: Scalars['Boolean']['output'];
  readonly items?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly kind?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly nextAssessmentDate?: Maybe<Scalars['Date']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly providerName?: Maybe<Scalars['String']['output']>;
  readonly requiresSignOff: Scalars['Boolean']['output'];
  readonly riskConsequence?: Maybe<Scalars['String']['output']>;
  readonly riskLikelihood?: Maybe<Scalars['String']['output']>;
  readonly riskRating?: Maybe<Scalars['String']['output']>;
  readonly sections?: Maybe<ReadonlyArray<TaskChecklistSectionNode>>;
  readonly showsComplianceCeremony: Scalars['Boolean']['output'];
  readonly signedOffAt?: Maybe<Scalars['DateTime']['output']>;
  readonly signedOffBy?: Maybe<UserType>;
  readonly sourceExtraction?: Maybe<DocumentExtractionNode>;
  readonly structureRevision: Scalars['Int']['output'];
  readonly task: TaskNode;
  readonly template?: Maybe<TaskTemplateNode>;
  readonly templateStructureRevision?: Maybe<Scalars['Int']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskChecklistSectionNode = {
  readonly __typename?: 'TaskChecklistSectionNode';
  readonly assignedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignedUser?: Maybe<UserType>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly dueDate?: Maybe<Scalars['Date']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly items?: Maybe<ReadonlyArray<TaskChecklistItemNode>>;
  readonly order: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskDefinitionNode = {
  readonly __typename?: 'TaskDefinitionNode';
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly communityTaskDefinitions?: Maybe<CommunityTaskDefinitionNodeConnection>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isVisibleToResidents: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly priority?: Maybe<TasksTaskDefinitionPriorityChoices>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly visibleToGroups?: Maybe<CommunityGroupNodeConnection>;
  readonly watchers: ReadonlyArray<UserType>;
};


export type TaskDefinitionNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type TaskDefinitionNodeCommunityTaskDefinitionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
  taskGroup?: InputMaybe<Scalars['UUID']['input']>;
};


export type TaskDefinitionNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskDefinitionNodeVisibleToGroupsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type TaskDefinitionNodeConnection = {
  readonly __typename?: 'TaskDefinitionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskDefinitionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskDefinitionNode` and its cursor. */
export type TaskDefinitionNodeEdge = {
  readonly __typename?: 'TaskDefinitionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskDefinitionNode>;
};

export type TaskDocumentItemInput = {
  readonly communityDocument?: InputMaybe<Scalars['UUID']['input']>;
  readonly title: Scalars['String']['input'];
};

export type TaskDocumentNode = {
  readonly __typename?: 'TaskDocumentNode';
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly taskGroup?: Maybe<TaskGroupNode>;
  readonly title: Scalars['String']['output'];
  readonly uploadedBy?: Maybe<UserType>;
  readonly url?: Maybe<Scalars['String']['output']>;
};

export type TaskDocumentNodeConnection = {
  readonly __typename?: 'TaskDocumentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskDocumentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskDocumentNode` and its cursor. */
export type TaskDocumentNodeEdge = {
  readonly __typename?: 'TaskDocumentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskDocumentNode>;
};

export type TaskGroupNode = {
  readonly __typename?: 'TaskGroupNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly documents?: Maybe<TaskDocumentNodeConnection>;
  readonly generationHorizon?: Maybe<Scalars['Float']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly lastGeneratedUntil?: Maybe<Scalars['Date']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly schedule?: Maybe<Scalars['JSONString']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
  readonly tasks?: Maybe<TaskNodeConnection>;
};


export type TaskGroupNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskGroupNodeTasksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedUser?: InputMaybe<Scalars['UUID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['UUID']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
  dueDateBefore?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  overdue?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  taskDefinition?: InputMaybe<Scalars['UUID']['input']>;
};

export type TaskGroupNodeConnection = {
  readonly __typename?: 'TaskGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskGroupNode` and its cursor. */
export type TaskGroupNodeEdge = {
  readonly __typename?: 'TaskGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskGroupNode>;
};

export type TaskNode = {
  readonly __typename?: 'TaskNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly asanaId?: Maybe<Scalars['String']['output']>;
  readonly asanaUrl?: Maybe<Scalars['String']['output']>;
  readonly assignedTeam?: Maybe<TeamNode>;
  readonly assignedUser?: Maybe<UserType>;
  readonly category?: Maybe<TaskCategoryNode>;
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly completedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly contractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly contractorUsers: ContractorNodeConnection;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly documents?: Maybe<TaskDocumentNodeConnection>;
  readonly dueDate?: Maybe<Scalars['DateTime']['output']>;
  readonly fixfloId?: Maybe<Scalars['String']['output']>;
  readonly fixfloUrl?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly linkedConversations?: Maybe<ReadonlyArray<Maybe<ConversationNode>>>;
  readonly priority?: Maybe<Scalars['String']['output']>;
  readonly scheduledFor?: Maybe<Scalars['Date']['output']>;
  readonly sharesDefinition: Scalars['Boolean']['output'];
  readonly sourceAction?: Maybe<ChecklistActionNode>;
  readonly status: TasksTaskStatusChoices;
  readonly taskDefinition: TaskDefinitionNode;
  readonly taskGroups: TaskGroupNodeConnection;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly updates?: Maybe<TaskUpdateNodeConnection>;
};


export type TaskNodeContractorUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskNodeDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TaskNodeTaskGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type TaskNodeUpdatesArgs = {
  actor?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['UUID']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  task?: InputMaybe<Scalars['UUID']['input']>;
  updateType?: InputMaybe<Scalars['String']['input']>;
};

export type TaskNodeConnection = {
  readonly __typename?: 'TaskNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskNode` and its cursor. */
export type TaskNodeEdge = {
  readonly __typename?: 'TaskNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskNode>;
};

export type TaskTemplateNode = {
  readonly __typename?: 'TaskTemplateNode';
  readonly archivedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly autoCompleteTask: Scalars['Boolean']['output'];
  readonly communityIds?: Maybe<ReadonlyArray<Scalars['UUID']['output']>>;
  readonly complianceType?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly draftSourceTitle?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isActive: Scalars['Boolean']['output'];
  readonly isDraft: Scalars['Boolean']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isSystem: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly pdfExportEnabled: Scalars['Boolean']['output'];
  readonly requiresSignOff: Scalars['Boolean']['output'];
  readonly scope?: Maybe<Scalars['String']['output']>;
  readonly sections?: Maybe<ReadonlyArray<TaskTemplateSectionNode>>;
  readonly stepCount: Scalars['Int']['output'];
  readonly steps?: Maybe<ReadonlyArray<TaskTemplateStepNode>>;
  readonly structureRevision: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateNodeConnection = {
  readonly __typename?: 'TaskTemplateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskTemplateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskTemplateNode` and its cursor. */
export type TaskTemplateNodeEdge = {
  readonly __typename?: 'TaskTemplateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskTemplateNode>;
};

export type TaskTemplateSectionInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly steps?: InputMaybe<ReadonlyArray<TaskTemplateStepInput>>;
  readonly title: Scalars['String']['input'];
};

export type TaskTemplateSectionNode = {
  readonly __typename?: 'TaskTemplateSectionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly order: Scalars['Int']['output'];
  readonly steps?: Maybe<ReadonlyArray<TaskTemplateStepNode>>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateStepFieldInput = {
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputType: Scalars['String']['input'];
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly label?: InputMaybe<Scalars['String']['input']>;
};

export type TaskTemplateStepInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['UUID']['input']>;
  readonly inputs?: InputMaybe<ReadonlyArray<TaskTemplateStepFieldInput>>;
  readonly isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly referenceCode?: InputMaybe<Scalars['String']['input']>;
  readonly requiresPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  readonly stepType?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type TaskTemplateStepInputNode = {
  readonly __typename?: 'TaskTemplateStepInputNode';
  readonly config?: Maybe<Scalars['JSONString']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly inputType?: Maybe<Scalars['String']['output']>;
  readonly isRequired: Scalars['Boolean']['output'];
  readonly label: Scalars['String']['output'];
  readonly order: Scalars['Int']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskTemplateStepNode = {
  readonly __typename?: 'TaskTemplateStepNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly inputs?: Maybe<ReadonlyArray<TaskTemplateStepInputNode>>;
  readonly isOwner: Scalars['Boolean']['output'];
  readonly isRequired: Scalars['Boolean']['output'];
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly order: Scalars['Int']['output'];
  readonly referenceCode?: Maybe<Scalars['String']['output']>;
  readonly requiresPhoto: Scalars['Boolean']['output'];
  readonly sectionId?: Maybe<Scalars['UUID']['output']>;
  readonly stepType?: Maybe<Scalars['String']['output']>;
  readonly title: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type TaskUpdateNode = {
  readonly __typename?: 'TaskUpdateNode';
  readonly actor?: Maybe<UserType>;
  readonly comment?: Maybe<Scalars['String']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly newStatus?: Maybe<TasksTaskUpdateNewStatusChoices>;
  readonly objectId?: Maybe<Scalars['UUID']['output']>;
  readonly source?: Maybe<TasksTaskUpdateSourceChoices>;
  readonly target?: Maybe<UserType>;
  readonly targetAction?: Maybe<ChecklistActionNode>;
  readonly targetContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly targetConversation?: Maybe<ConversationNode>;
  readonly targetDocument?: Maybe<TaskDocumentNode>;
  readonly task: TaskNode;
  readonly updateType: TasksTaskUpdateUpdateTypeChoices;
};

export type TaskUpdateNodeConnection = {
  readonly __typename?: 'TaskUpdateNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TaskUpdateNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TaskUpdateNode` and its cursor. */
export type TaskUpdateNodeEdge = {
  readonly __typename?: 'TaskUpdateNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TaskUpdateNode>;
};

/** An enumeration. */
export enum TasksAsanaPendingTaskStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Dismissed */
  Dismissed = 'DISMISSED',
  /** Pending */
  Pending = 'PENDING'
}

/** An enumeration. */
export enum TasksTaskDefinitionPriorityChoices {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** Urgent */
  Urgent = 'URGENT'
}

/** An enumeration. */
export enum TasksTaskStatusChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum TasksTaskUpdateNewStatusChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum TasksTaskUpdateSourceChoices {
  /** Asana */
  Asana = 'ASANA',
  /** Fixflo */
  Fixflo = 'FIXFLO'
}

/** An enumeration. */
export enum TasksTaskUpdateUpdateTypeChoices {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Asana Assignment Synced */
  AsanaAssignmentSynced = 'ASANA_ASSIGNMENT_SYNCED',
  /** Asana Comment Synced */
  AsanaCommentSynced = 'ASANA_COMMENT_SYNCED',
  /** Asana Linked */
  AsanaLinked = 'ASANA_LINKED',
  /** Asana Status Synced */
  AsanaStatusSynced = 'ASANA_STATUS_SYNCED',
  /** Asana Unlinked */
  AsanaUnlinked = 'ASANA_UNLINKED',
  /** Assigned */
  Assigned = 'ASSIGNED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Checklist Action Flagged */
  ChecklistActionFlagged = 'CHECKLIST_ACTION_FLAGGED',
  /** Checklist Action Resolved */
  ChecklistActionResolved = 'CHECKLIST_ACTION_RESOLVED',
  /** Checklist Action Task Created */
  ChecklistActionTaskCreated = 'CHECKLIST_ACTION_TASK_CREATED',
  /** Checklist Action Unflagged */
  ChecklistActionUnflagged = 'CHECKLIST_ACTION_UNFLAGGED',
  /** Checklist Attached */
  ChecklistAttached = 'CHECKLIST_ATTACHED',
  /** Checklist Comment Added */
  ChecklistCommentAdded = 'CHECKLIST_COMMENT_ADDED',
  /** Checklist Completed */
  ChecklistCompleted = 'CHECKLIST_COMPLETED',
  /** Checklist Item Assigned */
  ChecklistItemAssigned = 'CHECKLIST_ITEM_ASSIGNED',
  /** Checklist Item Completed */
  ChecklistItemCompleted = 'CHECKLIST_ITEM_COMPLETED',
  /** Checklist Item Uncompleted */
  ChecklistItemUncompleted = 'CHECKLIST_ITEM_UNCOMPLETED',
  /** Checklist Section Assigned */
  ChecklistSectionAssigned = 'CHECKLIST_SECTION_ASSIGNED',
  /** Checklist Signed Off */
  ChecklistSignedOff = 'CHECKLIST_SIGNED_OFF',
  /** Comment Added */
  CommentAdded = 'COMMENT_ADDED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Contractor Assigned */
  ContractorAssigned = 'CONTRACTOR_ASSIGNED',
  /** Contractor Unassigned */
  ContractorUnassigned = 'CONTRACTOR_UNASSIGNED',
  /** Conversation Linked */
  ConversationLinked = 'CONVERSATION_LINKED',
  /** Created */
  Created = 'CREATED',
  /** Created From Conversation */
  CreatedFromConversation = 'CREATED_FROM_CONVERSATION',
  /** Description Updated */
  DescriptionUpdated = 'DESCRIPTION_UPDATED',
  /** Document Added */
  DocumentAdded = 'DOCUMENT_ADDED',
  /** Document Removed */
  DocumentRemoved = 'DOCUMENT_REMOVED',
  /** Due Date Changed */
  DueDateChanged = 'DUE_DATE_CHANGED',
  /** Fixflo Comment Synced */
  FixfloCommentSynced = 'FIXFLO_COMMENT_SYNCED',
  /** Fixflo Linked */
  FixfloLinked = 'FIXFLO_LINKED',
  /** Fixflo Status Synced */
  FixfloStatusSynced = 'FIXFLO_STATUS_SYNCED',
  /** Fixflo Unlinked */
  FixfloUnlinked = 'FIXFLO_UNLINKED',
  /** Priority Changed */
  PriorityChanged = 'PRIORITY_CHANGED',
  /** Reopened */
  Reopened = 'REOPENED',
  /** Scheduled Activated */
  ScheduledActivated = 'SCHEDULED_ACTIVATED',
  /** Status Updated */
  StatusUpdated = 'STATUS_UPDATED',
  /** Tag Assigned */
  TagAssigned = 'TAG_ASSIGNED',
  /** Tag Unassigned */
  TagUnassigned = 'TAG_UNASSIGNED',
  /** Unarchived */
  Unarchived = 'UNARCHIVED',
  /** Unassigned */
  Unassigned = 'UNASSIGNED'
}

export type TeamActivityReportingNode = {
  readonly __typename?: 'TeamActivityReportingNode';
  readonly presence: TeamPresenceNode;
  readonly sessionLength: TeamDurationNode;
};

export type TeamApplicationReportingNode = {
  readonly __typename?: 'TeamApplicationReportingNode';
  readonly decisions: TeamDecisionsNode;
};

export type TeamAssignmentContent = CommunityDocumentNode | ConversationNode | UserDocumentNode;

export type TeamAssignmentNode = {
  readonly __typename?: 'TeamAssignmentNode';
  readonly assignedBy?: Maybe<UserType>;
  readonly contentObject?: Maybe<TeamAssignmentContent>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly objectId: Scalars['UUID']['output'];
  readonly team: TeamNode;
};

export type TeamAssignmentNodeConnection = {
  readonly __typename?: 'TeamAssignmentNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamAssignmentNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TeamAssignmentNode` and its cursor. */
export type TeamAssignmentNodeEdge = {
  readonly __typename?: 'TeamAssignmentNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamAssignmentNode>;
};

export type TeamConversationReportingNode = {
  readonly __typename?: 'TeamConversationReportingNode';
  readonly assigned: TeamCountNode;
  readonly firstResponse: TeamDurationNode;
  readonly memberRatings: ReadonlyArray<TeamRatedConversationNode>;
  readonly openConversations: TeamOpenNode;
  readonly resolved: TeamCountNode;
  readonly responseTime: TeamDurationNode;
  readonly satisfaction: TeamSatisfactionNode;
  readonly topics: ReadonlyArray<TeamMemberTopicNode>;
};


export type TeamConversationReportingNodeMemberRatingsArgs = {
  userId: Scalars['UUID']['input'];
};

export type TeamCountNode = {
  readonly __typename?: 'TeamCountNode';
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberCountNode>;
  readonly total: Scalars['Int']['output'];
};

export type TeamDayValueNode = {
  readonly __typename?: 'TeamDayValueNode';
  readonly day: Scalars['Date']['output'];
  readonly value?: Maybe<Scalars['Float']['output']>;
};

export type TeamDecisionsNode = {
  readonly __typename?: 'TeamDecisionsNode';
  readonly approved: Scalars['Int']['output'];
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberDecisionsNode>;
  readonly medianActionSeconds?: Maybe<Scalars['Float']['output']>;
  readonly rejected: Scalars['Int']['output'];
};

export type TeamDocumentReachNode = {
  readonly __typename?: 'TeamDocumentReachNode';
  readonly byMember: ReadonlyArray<TeamMemberDocumentReachNode>;
  readonly documentCount: Scalars['Int']['output'];
  readonly neverViewedCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
  readonly viewsPerDocument?: Maybe<Scalars['Float']['output']>;
};

export type TeamDocumentReportingNode = {
  readonly __typename?: 'TeamDocumentReportingNode';
  readonly reach: TeamDocumentReachNode;
  readonly uploaded: TeamCountNode;
};

export type TeamDurationNode = {
  readonly __typename?: 'TeamDurationNode';
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

export type TeamMemberCountNode = {
  readonly __typename?: 'TeamMemberCountNode';
  readonly count: Scalars['Int']['output'];
  readonly member: TeamMemberNode;
};

export type TeamMemberDecisionsNode = {
  readonly __typename?: 'TeamMemberDecisionsNode';
  readonly approved: Scalars['Int']['output'];
  readonly medianActionSeconds?: Maybe<Scalars['Float']['output']>;
  readonly member: TeamMemberNode;
  readonly rejected: Scalars['Int']['output'];
};

export type TeamMemberDocumentReachNode = {
  readonly __typename?: 'TeamMemberDocumentReachNode';
  readonly documentCount: Scalars['Int']['output'];
  readonly member: TeamMemberNode;
  readonly neverViewedCount: Scalars['Int']['output'];
  readonly viewCount: Scalars['Int']['output'];
};

export type TeamMemberDurationNode = {
  readonly __typename?: 'TeamMemberDurationNode';
  readonly medianSeconds: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly sampleCount: Scalars['Int']['output'];
};

export type TeamMemberNode = {
  readonly __typename?: 'TeamMemberNode';
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type TeamMemberRatingNode = {
  readonly __typename?: 'TeamMemberRatingNode';
  readonly meanRating: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly ratedCount: Scalars['Int']['output'];
};

export type TeamMemberReachNode = {
  readonly __typename?: 'TeamMemberReachNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly likeCount: Scalars['Int']['output'];
  readonly likesPerUpdate: Scalars['Float']['output'];
  readonly member: TeamMemberNode;
  readonly readRate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly readersPerUpdate: Scalars['Float']['output'];
  readonly updateCount: Scalars['Int']['output'];
};

export type TeamMemberTopicNode = {
  readonly __typename?: 'TeamMemberTopicNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
  readonly member: TeamMemberNode;
  readonly tagId: Scalars['UUID']['output'];
};

export type TeamNode = {
  readonly __typename?: 'TeamNode';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly assignments?: Maybe<TeamAssignmentNodeConnection>;
  readonly communities?: Maybe<CommunityNodeConnection>;
  readonly deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly icon?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly userCount: Scalars['Int']['output'];
  readonly users: ReadonlyArray<UserType>;
};


export type TeamNodeAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type TeamNodeCommunitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TeamNodeConnection = {
  readonly __typename?: 'TeamNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TeamNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TeamNode` and its cursor. */
export type TeamNodeEdge = {
  readonly __typename?: 'TeamNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TeamNode>;
};

export type TeamOpenNode = {
  readonly __typename?: 'TeamOpenNode';
  readonly atEnd?: Maybe<TeamDayValueNode>;
  readonly byDay: ReadonlyArray<TeamDayValueNode>;
  readonly byMember: ReadonlyArray<TeamMemberCountNode>;
};

export type TeamPresenceNode = {
  readonly __typename?: 'TeamPresenceNode';
  readonly activeMemberCount: Scalars['Int']['output'];
  readonly medianSessionsPerMember?: Maybe<Scalars['Float']['output']>;
  readonly memberCount: Scalars['Int']['output'];
};

export type TeamRatedConversationNode = {
  readonly __typename?: 'TeamRatedConversationNode';
  readonly conversationId: Scalars['UUID']['output'];
  readonly ratedAt: Scalars['DateTime']['output'];
  readonly stars: Scalars['Int']['output'];
  readonly subject: Scalars['String']['output'];
};

export type TeamReachNode = {
  readonly __typename?: 'TeamReachNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly byMember: ReadonlyArray<TeamMemberReachNode>;
  readonly likeCount: Scalars['Int']['output'];
  readonly likesPerUpdate?: Maybe<Scalars['Float']['output']>;
  readonly readRate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly readersPerUpdate?: Maybe<Scalars['Float']['output']>;
  readonly updateCount: Scalars['Int']['output'];
};

export type TeamRosterMemberNode = {
  readonly __typename?: 'TeamRosterMemberNode';
  readonly communityIds: ReadonlyArray<Scalars['UUID']['output']>;
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type TeamSatisfactionNode = {
  readonly __typename?: 'TeamSatisfactionNode';
  readonly byMember: ReadonlyArray<TeamMemberRatingNode>;
  readonly meanRating?: Maybe<Scalars['Float']['output']>;
  readonly ratedCount: Scalars['Int']['output'];
};

export type TeamUpdateReportingNode = {
  readonly __typename?: 'TeamUpdateReportingNode';
  readonly published: TeamCountNode;
  readonly reach: TeamReachNode;
};

export type TenancyApplicantNode = {
  readonly __typename?: 'TenancyApplicantNode';
  readonly email: Scalars['String']['output'];
  readonly firstName: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly lastName: Scalars['String']['output'];
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly reference?: Maybe<TenantReferenceNode>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly tenancyApplication: TenancyApplicationNode;
};

export type TenancyApplicantNodeConnection = {
  readonly __typename?: 'TenancyApplicantNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicantNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicantNode` and its cursor. */
export type TenancyApplicantNodeEdge = {
  readonly __typename?: 'TenancyApplicantNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicantNode>;
};

/** An enumeration. */
export enum TenancyApplicationEmployerReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** PERSONAL */
  Personal = 'PERSONAL'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsEmploymentTypeChoices {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** EMPLOYED */
  Employed = 'EMPLOYED',
  /** SELF_EMPLOYED */
  SelfEmployed = 'SELF_EMPLOYED',
  /** UNEMPLOYED */
  Unemployed = 'UNEMPLOYED'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsFullOrPartTimeChoices {
  /** FULL_TIME */
  FullTime = 'FULL_TIME',
  /** PART_TIME */
  PartTime = 'PART_TIME'
}

/** An enumeration. */
export enum TenancyApplicationEmploymentDetailsPaymentFrequencyChoices {
  /** MONTHLY */
  Monthly = 'MONTHLY',
  /** WEEKLY */
  Weekly = 'WEEKLY'
}

/** An enumeration. */
export enum TenancyApplicationIdentityVerificationStatusChoices {
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** FAILED */
  Failed = 'FAILED',
  /** STARTED */
  Started = 'STARTED',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceHasOutstandingRentChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceRentPaidOnTimeChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceStepChoices {
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** COMMENTS */
  Comments = 'COMMENTS',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RENTAL_DETAILS */
  RentalDetails = 'RENTAL_DETAILS'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTenancyTypeChoices {
  /** HMO */
  Hmo = 'HMO',
  /** PRIVATE_RESIDENTIAL */
  PrivateResidential = 'PRIVATE_RESIDENTIAL',
  /** SHARED */
  Shared = 'SHARED',
  /** SOCIAL_HOUSING */
  SocialHousing = 'SOCIAL_HOUSING'
}

/** An enumeration. */
export enum TenancyApplicationLandlordReferenceTreatedPropertyWellChoices {
  /** NO */
  No = 'NO',
  /** YES */
  Yes = 'YES'
}

export type TenancyApplicationNode = {
  readonly __typename?: 'TenancyApplicationNode';
  readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices;
  readonly applicantNames?: Maybe<Scalars['String']['output']>;
  readonly applicants: TenancyApplicantNodeConnection;
  readonly combinedAffordability?: Maybe<Scalars['Int']['output']>;
  readonly completedOn?: Maybe<Scalars['Date']['output']>;
  readonly home: HomeType;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly references?: Maybe<ReadonlyArray<Maybe<TenantReferenceNode>>>;
  readonly rentAmount: Scalars['Decimal']['output'];
  readonly status: TenancyApplicationTenancyApplicationStatusChoices;
  readonly unpaidTenantReferenceCount?: Maybe<Scalars['Int']['output']>;
  readonly unpaidTenantReferencesTotalCost?: Maybe<Scalars['Float']['output']>;
};


export type TenancyApplicationNodeApplicantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenancyApplicationNodeConnection = {
  readonly __typename?: 'TenancyApplicationNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenancyApplicationNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenancyApplicationNode` and its cursor. */
export type TenancyApplicationNodeEdge = {
  readonly __typename?: 'TenancyApplicationNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenancyApplicationNode>;
};

/** An enumeration. */
export enum TenancyApplicationRightToRentOfficialVerificationStatusChoices {
  /** LIMITED */
  Limited = 'LIMITED',
  /** PENDING */
  Pending = 'PENDING',
  /** REJECTED */
  Rejected = 'REJECTED',
  /** UNLIMITED */
  Unlimited = 'UNLIMITED'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationAffordabilityStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenancyApplicationStatusChoices {
  /** CAUTION */
  Caution = 'CAUTION',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** WAITING */
  Waiting = 'WAITING'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceStepChoices {
  /** ADDRESS_HISTORY */
  AddressHistory = 'ADDRESS_HISTORY',
  /** ALMOST_DONE */
  AlmostDone = 'ALMOST_DONE',
  /** EMPLOYER */
  Employer = 'EMPLOYER',
  /** EMPLOYMENT */
  Employment = 'EMPLOYMENT',
  /** IDENTITY */
  Identity = 'IDENTITY',
  /** LANDLORD */
  Landlord = 'LANDLORD',
  /** PERSONAL */
  Personal = 'PERSONAL',
  /** RIGHT_TO_RENT */
  RightToRent = 'RIGHT_TO_RENT'
}

/** An enumeration. */
export enum TenancyApplicationTenantReferenceTitleChoices {
  /** DR */
  Dr = 'DR',
  /** MISS */
  Miss = 'MISS',
  /** MR */
  Mr = 'MR',
  /** MRS */
  Mrs = 'MRS',
  /** MS */
  Ms = 'MS',
  /** MX */
  Mx = 'MX'
}

export type TenantReferenceNode = {
  readonly __typename?: 'TenantReferenceNode';
  readonly applicant: TenancyApplicantNode;
  readonly application: TenancyApplicationNode;
  readonly clientType?: Maybe<Scalars['String']['output']>;
  readonly creditCheck?: Maybe<CreditCheckNode>;
  readonly creditCheckPermission: Scalars['Boolean']['output'];
  readonly creditCheckStatus?: Maybe<Scalars['String']['output']>;
  readonly currentAddress?: Maybe<ReferenceHistoricalAddressNode>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly employerReference?: Maybe<EmployerReferenceNode>;
  readonly employmentStatus?: Maybe<Scalars['String']['output']>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly historicalAddresses: ReferenceHistoricalAddressNodeConnection;
  readonly home: HomeNode;
  readonly id: Scalars['UUID']['output'];
  readonly identityVerification?: Maybe<IdentityVerificationNode>;
  readonly identityVerificationStatus?: Maybe<Scalars['String']['output']>;
  readonly isPaid?: Maybe<Scalars['Boolean']['output']>;
  readonly landlordReference?: Maybe<LandlordReferenceNode>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly lettingHistoryStatus?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly rentAffordability?: Maybe<Scalars['Decimal']['output']>;
  readonly rightToRent?: Maybe<RightToRentNode>;
  readonly rightToRentStatus?: Maybe<Scalars['String']['output']>;
  readonly sentAt?: Maybe<Scalars['DateTime']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<TenancyApplicationTenantReferenceStepChoices>;
  readonly submittedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly tenantEmploymentDetails?: Maybe<EmploymentDetailsNode>;
  readonly title?: Maybe<TenancyApplicationTenantReferenceTitleChoices>;
};


export type TenantReferenceNodeHistoricalAddressesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type TenantReferenceNodeConnection = {
  readonly __typename?: 'TenantReferenceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TenantReferenceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `TenantReferenceNode` and its cursor. */
export type TenantReferenceNodeEdge = {
  readonly __typename?: 'TenantReferenceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TenantReferenceNode>;
};

export type TenantSerializerInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type Tenants = {
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type TimeSlot = {
  readonly end?: InputMaybe<Scalars['DateTime']['input']>;
  readonly start?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ToggleAllResidentAppNotificationPreferencesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly enabled: Scalars['Boolean']['input'];
};

export type ToggleAllResidentAppNotificationPreferencesPayload = {
  readonly __typename?: 'ToggleAllResidentAppNotificationPreferencesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
};

export type ToggleArchivedAtCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleArchivedAtCommunityDocumentPayload = {
  readonly __typename?: 'ToggleArchivedAtCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleArchivedAtCommunityUpdateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleArchivedAtCommunityUpdatePayload = {
  readonly __typename?: 'ToggleArchivedAtCommunityUpdatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleClientTagArchivedAtInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleClientTagArchivedAtPayload = {
  readonly __typename?: 'ToggleClientTagArchivedAtPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleCommunityUpdateBookmarkInput = {
  readonly bookmarkedBy?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleCommunityUpdateBookmarkPayload = {
  readonly __typename?: 'ToggleCommunityUpdateBookmarkPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityUpdate?: Maybe<CommunityUpdateType>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type ToggleCommunityUpdateLikeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
};

export type ToggleCommunityUpdateLikePayload = {
  readonly __typename?: 'ToggleCommunityUpdateLikePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly update?: Maybe<CommunityUpdateNode>;
};

export type ToggleMarketplaceItemCloseInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleMarketplaceItemClosePayload = {
  readonly __typename?: 'ToggleMarketplaceItemClosePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly marketplaceItem?: Maybe<MarketplaceItemNode>;
};

export type ToggleRuleActivatedInput = {
  readonly activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleRuleActivatedPayload = {
  readonly __typename?: 'ToggleRuleActivatedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type ToggleTeamActivatedInput = {
  readonly activatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly deactivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type ToggleTeamActivatedPayload = {
  readonly __typename?: 'ToggleTeamActivatedPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type TypeformQuestionConnection = {
  readonly __typename?: 'TypeformQuestionConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TypeformQuestionEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TypeformQuestion` and its cursor. */
export type TypeformQuestionEdge = {
  readonly __typename?: 'TypeformQuestionEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TypeformQuestionType>;
};

export type TypeformQuestionType = {
  readonly __typename?: 'TypeformQuestionType';
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly properties?: Maybe<Scalars['JSONString']['output']>;
  readonly ref?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type?: Maybe<Scalars['String']['output']>;
};

export type TypeformResponseConnection = {
  readonly __typename?: 'TypeformResponseConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<TypeformResponseEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `TypeformResponse` and its cursor. */
export type TypeformResponseEdge = {
  readonly __typename?: 'TypeformResponseEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<TypeformResponseType>;
};

export type TypeformResponseType = {
  readonly __typename?: 'TypeformResponseType';
  readonly answers?: Maybe<Scalars['JSONString']['output']>;
  readonly hidden?: Maybe<Scalars['JSONString']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly submittedAt?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UnarchiveApplicationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveApplicationPayload = {
  readonly __typename?: 'UnarchiveApplicationPayload';
  readonly application?: Maybe<ApplicationNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnarchiveKeyInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyPayload = {
  readonly __typename?: 'UnarchiveKeyPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly key?: Maybe<KeyNode>;
};

export type UnarchiveKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveKeyholderPayload = {
  readonly __typename?: 'UnarchiveKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly keyholder?: Maybe<KeyholderNode>;
};

export type UnarchiveTaskGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveTaskGroupPayload = {
  readonly __typename?: 'UnarchiveTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type UnarchiveTaskInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnarchiveTaskPayload = {
  readonly __typename?: 'UnarchiveTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnarchiveTaskTemplateInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
};

export type UnarchiveTaskTemplatePayload = {
  readonly __typename?: 'UnarchiveTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UnassignClientTagFromCommunityDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromCommunityDocumentPayload = {
  readonly __typename?: 'UnassignClientTagFromCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignClientTagFromTaskDefinitionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly tagId: Scalars['UUID']['input'];
  readonly taskDefinitionId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromTaskDefinitionPayload = {
  readonly __typename?: 'UnassignClientTagFromTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UnassignClientTagFromUserDocumentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly documentId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagFromUserDocumentPayload = {
  readonly __typename?: 'UnassignClientTagFromUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
  readonly tagId: Scalars['UUID']['input'];
};

export type UnassignClientTagPayload = {
  readonly __typename?: 'UnassignClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly tagAssignment?: Maybe<TagAssignmentNode>;
};

export type UnassignTeamInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type UnassignTeamPayload = {
  readonly __typename?: 'UnassignTeamPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type UnbookCommunityEventMutationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly eventId: Scalars['UUID']['input'];
};

export type UnbookCommunityEventMutationPayload = {
  readonly __typename?: 'UnbookCommunityEventMutationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly event?: Maybe<CommunityEventNode>;
};

export type UnflagChecklistItemInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnflagChecklistItemPayload = {
  readonly __typename?: 'UnflagChecklistItemPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskChecklistItem?: Maybe<TaskChecklistItemNode>;
};

export type UnlabelConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly tags: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type UnlabelConversationPayload = {
  readonly __typename?: 'UnlabelConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UnlinkTaskFromAsanaInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkTaskFromAsanaPayload = {
  readonly __typename?: 'UnlinkTaskFromAsanaPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnlinkTaskFromFixfloInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnlinkTaskFromFixfloPayload = {
  readonly __typename?: 'UnlinkTaskFromFixfloPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UnreadAllNotificationsOnTargetInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
};

export type UnreadAllNotificationsOnTargetPayload = {
  readonly __typename?: 'UnreadAllNotificationsOnTargetPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly notifications: NotificationNodeConnection;
};


export type UnreadAllNotificationsOnTargetPayloadNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasActor?: InputMaybe<Scalars['Boolean']['input']>;
  hasTarget?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadNotificationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UnreadNotificationPayload = {
  readonly __typename?: 'UnreadNotificationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly notification?: Maybe<NotificationNode>;
};

export type UnsnoozeConversationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly conversationId: Scalars['UUID']['input'];
};

export type UnsnoozeConversationPayload = {
  readonly __typename?: 'UnsnoozeConversationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
};

export type UnsubscribeFromNotificationGroup = {
  readonly __typename?: 'UnsubscribeFromNotificationGroup';
  readonly unsubscribeNotificationGroup?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UnsubscribeNotificationGroupNode = {
  readonly __typename?: 'UnsubscribeNotificationGroupNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: PeopleUnsubscribeNotificationGroupTypeChoices;
  readonly users: ReadonlyArray<UserType>;
};

export type UnsubscribeNotificationGroupNodeConnection = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UnsubscribeNotificationGroupNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UnsubscribeNotificationGroupNode` and its cursor. */
export type UnsubscribeNotificationGroupNodeEdge = {
  readonly __typename?: 'UnsubscribeNotificationGroupNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UnsubscribeNotificationGroupNode>;
};

export type UpdateAmenityOperatingScheduleInput = {
  readonly amenityId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly schedule: ReadonlyArray<InputMaybe<OperatingTimeInput>>;
};

export type UpdateAmenityOperatingSchedulePayload = {
  readonly __typename?: 'UpdateAmenityOperatingSchedulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAmenityTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAmenityTypePayload = {
  readonly __typename?: 'UpdateAmenityTypePayload';
  readonly amenity?: Maybe<AmenityNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateApplicationCommunity = {
  readonly __typename?: 'UpdateApplicationCommunity';
  readonly application?: Maybe<ApplicationNode>;
  readonly homes?: Maybe<ReadonlyArray<NewHomeOption>>;
  readonly status: Scalars['String']['output'];
};

export type UpdateApplicationCommunityInput = {
  readonly applicationId: Scalars['ID']['input'];
  readonly communityId: Scalars['ID']['input'];
};

export type UpdateApplicationHome = {
  readonly __typename?: 'UpdateApplicationHome';
  readonly application?: Maybe<ApplicationNode>;
};

export type UpdateApplicationHomeInput = {
  readonly applicationId: Scalars['ID']['input'];
  readonly homeId: Scalars['ID']['input'];
};

export type UpdateAttachmentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homeId: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAttachmentPayload = {
  readonly __typename?: 'UpdateAttachmentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homeId?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateBlockGroupPinnedHomesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly groupId: Scalars['UUID']['input'];
  readonly homeIds: ReadonlyArray<Scalars['UUID']['input']>;
};

export type UpdateBlockGroupPinnedHomesPayload = {
  readonly __typename?: 'UpdateBlockGroupPinnedHomesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly group?: Maybe<CommunityGroupNode>;
};

export type UpdateBlockHomesInput = {
  readonly blockId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly homesToAdd: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
  readonly homesToRemove: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>;
};

export type UpdateBlockHomesPayload = {
  readonly __typename?: 'UpdateBlockHomesPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateBlockInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly totalFloors?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBlockPayload = {
  readonly __typename?: 'UpdateBlockPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateBlockSafetyIdentityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly hrbReference?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly responsiblePersonName?: InputMaybe<Scalars['String']['input']>;
  readonly responsiblePersonRole?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBlockSafetyIdentityPayload = {
  readonly __typename?: 'UpdateBlockSafetyIdentityPayload';
  readonly block?: Maybe<BlockNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateChecklistInput = {
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateChecklistPayload = {
  readonly __typename?: 'UpdateChecklistPayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateChecklistStructureInput = {
  readonly checklistId: Scalars['UUID']['input'];
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly sections: ReadonlyArray<ChecklistSectionInput>;
};

export type UpdateChecklistStructurePayload = {
  readonly __typename?: 'UpdateChecklistStructurePayload';
  readonly checklist?: Maybe<TaskChecklistNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateClientAdminInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateClientAdminPayload = {
  readonly __typename?: 'UpdateClientAdminPayload';
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UpdateClientContractorCompanyCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyCommunitiesPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyCommunitiesPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientContractorCompanyContractorsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractors?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyContractorsPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyContractorsPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientContractorCompanyInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyType?: InputMaybe<Company_Type>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly website?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientContractorCompanyPayload = {
  readonly __typename?: 'UpdateClientContractorCompanyPayload';
  readonly clientContractorCompany?: Maybe<ClientContractorCompanyNode>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientTagColorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientTagColorPayload = {
  readonly __typename?: 'UpdateClientTagColorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateClientTagInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly color?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type UpdateClientTagPayload = {
  readonly __typename?: 'UpdateClientTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly clientTag?: Maybe<ClientTagNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunityDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community: Scalars['String']['input'];
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly viewers?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityDocumentPayload = {
  readonly __typename?: 'UpdateCommunityDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityDocument?: Maybe<CommunityDocumentNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateCommunityProductInput = {
  readonly active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly price?: InputMaybe<Scalars['Decimal']['input']>;
};

export type UpdateCommunityProductPayload = {
  readonly __typename?: 'UpdateCommunityProductPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityProduct?: Maybe<CommunityProductNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

/** Set the Responsible Person details printed on EES PDFs. */
export type UpdateCommunityResponsiblePerson = {
  readonly __typename?: 'UpdateCommunityResponsiblePerson';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateCommunitySettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly commentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communityChatEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly deactivatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly marketplaceEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly officeHoursEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly openPeriods: ReadonlyArray<InputMaybe<CommunityOpenPeriodSerializerInput>>;
  readonly outOfOfficeMessage?: InputMaybe<Scalars['String']['input']>;
  readonly paymentsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly status: Scalars['String']['input'];
};

export type UpdateCommunitySettingsPayload = {
  readonly __typename?: 'UpdateCommunitySettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly commentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly communityChatEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deactivatedOn?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly marketplaceEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly officeHoursEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly openPeriods?: Maybe<ReadonlyArray<Maybe<CommunityOpenPeriodNode>>>;
  readonly outOfOfficeMessage?: Maybe<Scalars['String']['output']>;
  readonly paymentsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

/** Toggle the annual SIB-pack review nudge and tweak the lead-time months. */
export type UpdateCommunitySibPackReviewSettings = {
  readonly __typename?: 'UpdateCommunitySibPackReviewSettings';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateCommunityTaskDefinitionInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly taskGroup?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCommunityTaskDefinitionPayload = {
  readonly __typename?: 'UpdateCommunityTaskDefinitionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityTaskDefinition?: Maybe<CommunityTaskDefinitionNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateContactGroupsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contactId: Scalars['String']['input'];
  readonly groups: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
};

export type UpdateContactGroupsPayload = {
  readonly __typename?: 'UpdateContactGroupsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contact?: Maybe<ContactNode>;
};

export type UpdateContractorInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContractorPayload = {
  readonly __typename?: 'UpdateContractorPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly contractor?: Maybe<ContractorNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationNoteInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly text: Scalars['String']['input'];
};

export type UpdateConversationNotePayload = {
  readonly __typename?: 'UpdateConversationNotePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversationNote?: Maybe<ConversationNoteNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationParticipantTypeInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly participantType: Participant_Type;
};

export type UpdateConversationParticipantTypePayload = {
  readonly __typename?: 'UpdateConversationParticipantTypePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationTagInput = {
  readonly client?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateConversationTagPayload = {
  readonly __typename?: 'UpdateConversationTagPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
};

export type UpdateConversationTitleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly subject: Scalars['String']['input'];
};

export type UpdateConversationTitlePayload = {
  readonly __typename?: 'UpdateConversationTitlePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly conversation?: Maybe<ConversationNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateConversationUrgency = {
  readonly __typename?: 'UpdateConversationUrgency';
  readonly conversation?: Maybe<ConversationNode>;
};

export type UpdateConversationUrgencyInput = {
  readonly conversationId: Scalars['UUID']['input'];
  readonly urgency: Scalars['String']['input'];
};

export type UpdateEmployerReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly companyName?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly jobTitle?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferencePayload = {
  readonly __typename?: 'UpdateEmployerReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly companyName?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly jobTitle?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
};

export type UpdateEmployerReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEmployerReferenceStepPayload = {
  readonly __typename?: 'UpdateEmployerReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateGroupDescriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupDescriptionPayload = {
  readonly __typename?: 'UpdateGroupDescriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly communityGroup?: Maybe<CommunityGroupNode>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
};

export type UpdateGroupInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly community?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly homes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateGroupPayload = {
  readonly __typename?: 'UpdateGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly community?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly homes?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly users?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
};

export type UpdateHomeAddressInput = {
  readonly addressLine1?: InputMaybe<Scalars['String']['input']>;
  readonly city?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly postcode: Scalars['String']['input'];
};

export type UpdateHomeAddressPayload = {
  readonly __typename?: 'UpdateHomeAddressPayload';
  readonly addressLine1?: Maybe<Scalars['String']['output']>;
  readonly city?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly postcode?: Maybe<Scalars['String']['output']>;
};

export type UpdateHomeDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly furnishing?: InputMaybe<Scalars['String']['input']>;
  readonly garden?: InputMaybe<Scalars['Boolean']['input']>;
  readonly home: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly kitchen?: InputMaybe<Scalars['Boolean']['input']>;
  readonly numBathrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numBedrooms?: InputMaybe<Scalars['Int']['input']>;
  readonly numEnsuites?: InputMaybe<Scalars['Int']['input']>;
  readonly numLivingRooms?: InputMaybe<Scalars['Int']['input']>;
  readonly office?: InputMaybe<Scalars['Boolean']['input']>;
  readonly parking?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeDetailsPayload = {
  readonly __typename?: 'UpdateHomeDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly furnishing?: Maybe<Scalars['String']['output']>;
  readonly garden?: Maybe<Scalars['Boolean']['output']>;
  readonly home?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly kitchen?: Maybe<Scalars['Boolean']['output']>;
  readonly numBathrooms?: Maybe<Scalars['Int']['output']>;
  readonly numBedrooms?: Maybe<Scalars['Int']['output']>;
  readonly numEnsuites?: Maybe<Scalars['Int']['output']>;
  readonly numLivingRooms?: Maybe<Scalars['Int']['output']>;
  readonly office?: Maybe<Scalars['Boolean']['output']>;
  readonly parking?: Maybe<Scalars['String']['output']>;
};

export type UpdateHomeFloorNumberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly floorNumber?: InputMaybe<Scalars['Int']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateHomeFloorNumberPayload = {
  readonly __typename?: 'UpdateHomeFloorNumberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly home?: Maybe<HomeType>;
};

export type UpdateKeyholderInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly company?: InputMaybe<Scalars['String']['input']>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly endDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly notes?: InputMaybe<Scalars['String']['input']>;
  readonly phoneNumber?: InputMaybe<Scalars['String']['input']>;
  readonly startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateKeyholderPayload = {
  readonly __typename?: 'UpdateKeyholderPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly company?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<Scalars['String']['output']>;
  readonly phoneNumber?: Maybe<Scalars['String']['output']>;
  readonly startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UpdateLandlordInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly emailPreferences: Scalars['Boolean']['input'];
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly smsPreferences: Scalars['Boolean']['input'];
};

export type UpdateLandlordPayload = {
  readonly __typename?: 'UpdateLandlordPayload';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly emailPreferences?: Maybe<Scalars['Boolean']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly smsPreferences?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateLandlordReferenceCommentsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly comments?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceCommentsPayload = {
  readonly __typename?: 'UpdateLandlordReferenceCommentsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly comments?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly email: Scalars['String']['input'];
  readonly firstName: Scalars['String']['input'];
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly landlordOrAgent: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
  readonly mobile: Scalars['String']['input'];
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateLandlordReferencePayload = {
  readonly __typename?: 'UpdateLandlordReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly landlordOrAgent?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateLandlordReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLandlordReferenceStepPayload = {
  readonly __typename?: 'UpdateLandlordReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateManagerInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateManagerNotificationSettingsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly emailPreferences: Scalars['Boolean']['input'];
};

export type UpdateManagerNotificationSettingsPayload = {
  readonly __typename?: 'UpdateManagerNotificationSettingsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdateManagerPayload = {
  readonly __typename?: 'UpdateManagerPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly manager?: Maybe<ManagerType>;
};

export type UpdateNotificationPreferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly managerAmenityEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerAmenityPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationMessageEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationMessagePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerApplicationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityEventEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityEventPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityProductEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityProductPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityUpdateEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerCommunityUpdatePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationAssignmentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerConversationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerSurveysEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerSurveysPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskCommentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTaskUpdatePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTeamAssignmentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly managerTeamAssignmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateNotificationPreferencePayload = {
  readonly __typename?: 'UpdateNotificationPreferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userNotificationPreference?: Maybe<UserNotificationPreferenceNode>;
};

export type UpdatePackageLocationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly location?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePackageLocationPayload = {
  readonly __typename?: 'UpdatePackageLocationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly package?: Maybe<PackageNode>;
};

export type UpdatePackageStatusInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly reason?: InputMaybe<Scalars['String']['input']>;
  readonly status: Scalars['String']['input'];
};

export type UpdatePackageStatusPayload = {
  readonly __typename?: 'UpdatePackageStatusPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly package: PackageNode;
};

export type UpdateReferenceAddressHistoryInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly historicalAddresses: ReadonlyArray<InputMaybe<ReferenceHistoricalAddressSerializerInput>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceAddressHistoryPayload = {
  readonly __typename?: 'UpdateReferenceAddressHistoryPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly historicalAddresses?: Maybe<ReadonlyArray<Maybe<ReferenceHistoricalAddressNode>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
};

export type UpdateReferenceStartedOnInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateReferenceStartedOnPayload = {
  readonly __typename?: 'UpdateReferenceStartedOnPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum UpdateReportingCategory {
  Community = 'COMMUNITY',
  Events = 'EVENTS',
  Maintenance = 'MAINTENANCE',
  Offers = 'OFFERS',
  Other = 'OTHER',
  Urgent = 'URGENT'
}

export type UpdateReportingCategoryCountNode = {
  readonly __typename?: 'UpdateReportingCategoryCountNode';
  readonly category: UpdateReportingCategory;
  readonly count: Scalars['Int']['output'];
};

export type UpdateReportingConfigurationInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly configuration?: InputMaybe<Scalars['JSONString']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly id: Scalars['UUID']['input'];
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly schemaVersion?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReportingConfigurationPayload = {
  readonly __typename?: 'UpdateReportingConfigurationPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly configuration: ReportingConfigurationNode;
  readonly conflict: Scalars['Boolean']['output'];
};

export type UpdateReportingContentMixNode = {
  readonly __typename?: 'UpdateReportingContentMixNode';
  readonly attachmentShare?: Maybe<Scalars['Float']['output']>;
  readonly imageShare?: Maybe<Scalars['Float']['output']>;
  readonly publishedCount: Scalars['Int']['output'];
  readonly withAttachmentCount: Scalars['Int']['output'];
  readonly withImageCount: Scalars['Int']['output'];
};

export type UpdateReportingCountNode = {
  readonly __typename?: 'UpdateReportingCountNode';
  readonly byDay: ReadonlyArray<UpdateReportingDayCountNode>;
  readonly byWeek: ReadonlyArray<UpdateReportingWeekCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type UpdateReportingDayCountNode = {
  readonly __typename?: 'UpdateReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type UpdateReportingEngagementNode = {
  readonly __typename?: 'UpdateReportingEngagementNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly byUpdate: ReadonlyArray<UpdateReportingUpdateEngagementNode>;
  readonly comments: Scalars['Int']['output'];
  readonly index?: Maybe<Scalars['Float']['output']>;
  readonly likes: Scalars['Int']['output'];
  readonly uniqueViews: Scalars['Int']['output'];
};

export type UpdateReportingNode = {
  readonly __typename?: 'UpdateReportingNode';
  readonly categories: ReadonlyArray<UpdateReportingCategoryCountNode>;
  readonly comments: UpdateReportingCountNode;
  readonly contentMix: UpdateReportingContentMixNode;
  readonly engagement: UpdateReportingEngagementNode;
  readonly likes: UpdateReportingCountNode;
  readonly published: UpdateReportingCountNode;
  readonly publishedByStaff: ReadonlyArray<UpdateReportingStaffCountNode>;
  readonly readRate: UpdateReportingReadRateNode;
  readonly scheduled: UpdateReportingScheduledNode;
  readonly topUpdates: ReadonlyArray<UpdateReportingTopUpdateNode>;
  readonly uniqueReaders: Scalars['Int']['output'];
};

export type UpdateReportingReadRateNode = {
  readonly __typename?: 'UpdateReportingReadRateNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly rate?: Maybe<Scalars['Float']['output']>;
  readonly readerCount: Scalars['Int']['output'];
  readonly updateCount: Scalars['Int']['output'];
};

export type UpdateReportingScheduledNode = {
  readonly __typename?: 'UpdateReportingScheduledNode';
  readonly publishedCount: Scalars['Int']['output'];
  readonly scheduledCount: Scalars['Int']['output'];
  readonly share?: Maybe<Scalars['Float']['output']>;
};

export type UpdateReportingStaffCountNode = {
  readonly __typename?: 'UpdateReportingStaffCountNode';
  readonly count: Scalars['Int']['output'];
  readonly name: Scalars['String']['output'];
  readonly userId: Scalars['UUID']['output'];
};

export type UpdateReportingTopUpdateNode = {
  readonly __typename?: 'UpdateReportingTopUpdateNode';
  readonly readerCount: Scalars['Int']['output'];
  readonly title: Scalars['String']['output'];
  readonly updateId: Scalars['UUID']['output'];
};

export type UpdateReportingUpdateEngagementNode = {
  readonly __typename?: 'UpdateReportingUpdateEngagementNode';
  readonly audienceSize: Scalars['Int']['output'];
  readonly comments: Scalars['Int']['output'];
  readonly engagementIndex?: Maybe<Scalars['Float']['output']>;
  readonly likes: Scalars['Int']['output'];
  readonly publishedAt: Scalars['DateTime']['output'];
  readonly title: Scalars['String']['output'];
  readonly uniqueViews: Scalars['Int']['output'];
  readonly updateId?: Maybe<Scalars['UUID']['output']>;
  readonly views: Scalars['Int']['output'];
};

export type UpdateReportingWeekCountNode = {
  readonly __typename?: 'UpdateReportingWeekCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly week: Scalars['Date']['output'];
};

export type UpdateResidencyAndResidents = {
  readonly __typename?: 'UpdateResidencyAndResidents';
  readonly ok?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateResidencyDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly residency?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResidencyDocumentPayload = {
  readonly __typename?: 'UpdateResidencyDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residencyDocument?: Maybe<ResidencyDocumentNode>;
};

export type UpdateResidentAppNotificationPreferencesInput = {
  readonly amenityEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly amenityPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityProductEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communityProductPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly conversationEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly conversationPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly documentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly environmentPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eventEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly eventPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groupChatEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly groupChatPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly keyEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly keyPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly marketplaceEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly marketplacePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly newsfeedEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly newsfeedPushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly packageEmailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly packagePushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateResidentAppNotificationPreferencesPayload = {
  readonly __typename?: 'UpdateResidentAppNotificationPreferencesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly residentAppNotificationPreferences?: Maybe<ResidentAppNotificationPreferencesNode>;
};

export type UpdateResidentSafetyRecord = {
  readonly __typename?: 'UpdateResidentSafetyRecord';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type UpdateResidentSafetyRecordInput = {
  readonly braille?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly communicationNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  readonly language?: InputMaybe<Scalars['String']['input']>;
  readonly largePrint?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeedDeclared?: InputMaybe<Scalars['Boolean']['input']>;
  readonly mobilityNeeds?: InputMaybe<Scalars['String']['input']>;
  readonly textToSpeech?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateRightToRentInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly document?: InputMaybe<Scalars['String']['input']>;
  readonly hasShareCode?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly shareCode?: InputMaybe<Scalars['String']['input']>;
  readonly tenantReference: Scalars['String']['input'];
};

export type UpdateRightToRentPayload = {
  readonly __typename?: 'UpdateRightToRentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly hasShareCode?: Maybe<Scalars['Boolean']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly shareCode?: Maybe<Scalars['String']['output']>;
  readonly tenantReference?: Maybe<Scalars['String']['output']>;
};

export type UpdateRuleCategoryContentTypes = {
  readonly __typename?: 'UpdateRuleCategoryContentTypes';
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateRuleCategoryContentTypesInput = {
  readonly categoryContentTypes: ReadonlyArray<InputMaybe<Scalars['String']['input']>>;
  readonly id: Scalars['UUID']['input'];
};

export type UpdateRuleCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRuleCommunitiesPayload = {
  readonly __typename?: 'UpdateRuleCommunitiesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateRuleConditionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly event: Event;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly objectId?: InputMaybe<Scalars['String']['input']>;
  readonly operator: Operator;
};

export type UpdateRuleConditionPayload = {
  readonly __typename?: 'UpdateRuleConditionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly ruleCondition?: Maybe<RuleConditionNode>;
};

export type UpdateRuleInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
};

export type UpdateRulePayload = {
  readonly __typename?: 'UpdateRulePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly rule?: Maybe<RuleNode>;
};

export type UpdateSafetyCenterDocumentInput = {
  readonly block?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly includeInSibPack?: InputMaybe<Scalars['Boolean']['input']>;
  readonly showInSafetyCenter?: InputMaybe<Scalars['Boolean']['input']>;
  readonly sibCategory?: InputMaybe<Sib_Category>;
  readonly sourceDocument?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
};

export type UpdateSafetyCenterDocumentPayload = {
  readonly __typename?: 'UpdateSafetyCenterDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly safetyCenterDocument?: Maybe<SafetyCenterDocumentNode>;
};

export type UpdateSafetyReviewInterval = {
  readonly __typename?: 'UpdateSafetyReviewInterval';
  readonly community?: Maybe<CommunityNode>;
};

export type UpdateScheduledMessage = {
  readonly __typename?: 'UpdateScheduledMessage';
  readonly success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateScheduledMessageInput = {
  readonly body?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly sendAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateTaskDefinitionDescriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaskDefinitionDescriptionPayload = {
  readonly __typename?: 'UpdateTaskDefinitionDescriptionPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskDefinitionPriorityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Priority>;
};

export type UpdateTaskDefinitionPriorityPayload = {
  readonly __typename?: 'UpdateTaskDefinitionPriorityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskDefinitionVisibilityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly isVisibleToResidents?: InputMaybe<Scalars['Boolean']['input']>;
  readonly visibleToGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTaskDefinitionVisibilityPayload = {
  readonly __typename?: 'UpdateTaskDefinitionVisibilityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskDefinition?: Maybe<TaskDefinitionNode>;
};

export type UpdateTaskGroupInput = {
  readonly assignedUserId?: InputMaybe<Scalars['UUID']['input']>;
  readonly categoryId?: InputMaybe<Scalars['UUID']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly contractorCompanyId?: InputMaybe<Scalars['UUID']['input']>;
  readonly contractorUserIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly generationHorizonDays?: InputMaybe<Scalars['Int']['input']>;
  readonly id: Scalars['UUID']['input'];
  readonly isActive?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Scalars['String']['input']>;
  readonly schedule?: InputMaybe<Scalars['JSONString']['input']>;
  readonly taskTemplateId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UpdateTaskGroupPayload = {
  readonly __typename?: 'UpdateTaskGroupPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskGroup?: Maybe<TaskGroupNode>;
};

export type UpdateTaskInput = {
  readonly category?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly scheduledFor?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateTaskPayload = {
  readonly __typename?: 'UpdateTaskPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UpdateTaskPriorityInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly priority?: InputMaybe<Priority>;
};

export type UpdateTaskPriorityPayload = {
  readonly __typename?: 'UpdateTaskPriorityPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly task?: Maybe<TaskNode>;
};

export type UpdateTaskTemplateInput = {
  readonly autoCompleteTask?: InputMaybe<Scalars['Boolean']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communityIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id: Scalars['String']['input'];
  readonly isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly pdfExportEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly requiresSignOff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateTaskTemplatePayload = {
  readonly __typename?: 'UpdateTaskTemplatePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UpdateTaskTemplateStructureInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly expectedRevision: Scalars['Int']['input'];
  readonly sections: ReadonlyArray<TaskTemplateSectionInput>;
  readonly templateId: Scalars['UUID']['input'];
};

export type UpdateTaskTemplateStructurePayload = {
  readonly __typename?: 'UpdateTaskTemplateStructurePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly taskTemplate?: Maybe<TaskTemplateNode>;
};

export type UpdateTeamCommunitiesInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamCommunitiesPayload = {
  readonly __typename?: 'UpdateTeamCommunitiesPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamDetailsInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamDetailsPayload = {
  readonly __typename?: 'UpdateTeamDetailsPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamIconInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly icon?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamIconPayload = {
  readonly __typename?: 'UpdateTeamIconPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTeamMembersInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTeamMembersPayload = {
  readonly __typename?: 'UpdateTeamMembersPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly team?: Maybe<TeamNode>;
};

export type UpdateTenantReferenceInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly creditCheckPermission?: InputMaybe<Scalars['Boolean']['input']>;
  readonly dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  readonly firstName?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly lastName?: InputMaybe<Scalars['String']['input']>;
  readonly mobile?: InputMaybe<Scalars['String']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferencePayload = {
  readonly __typename?: 'UpdateTenantReferencePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly creditCheckPermission?: Maybe<Scalars['Boolean']['output']>;
  readonly dateOfBirth?: Maybe<Scalars['Date']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
};

export type UpdateTenantReferenceStepInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly step?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTenantReferenceStepPayload = {
  readonly __typename?: 'UpdateTenantReferenceStepPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly id?: Maybe<Scalars['String']['output']>;
  readonly step?: Maybe<Scalars['String']['output']>;
};

export type UpdateUserDocumentInput = {
  readonly activatedOn?: InputMaybe<Scalars['DateTime']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly file?: InputMaybe<Scalars['String']['input']>;
  readonly id?: InputMaybe<Scalars['String']['input']>;
  readonly link?: InputMaybe<Scalars['String']['input']>;
  readonly title: Scalars['String']['input'];
  readonly users?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUserDocumentPayload = {
  readonly __typename?: 'UpdateUserDocumentPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userDocument?: Maybe<UserDocumentNode>;
};

export type UpdateUserInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly firstName: Scalars['String']['input'];
  readonly lastName: Scalars['String']['input'];
};

export type UpdateUserMobileNumberInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly mobile: Scalars['String']['input'];
};

export type UpdateUserMobileNumberPayload = {
  readonly __typename?: 'UpdateUserMobileNumberPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly error?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpdateUserPayload = {
  readonly __typename?: 'UpdateUserPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly user?: Maybe<UserType>;
};

export type UpdateUserProfileInput = {
  readonly biography?: InputMaybe<Scalars['String']['input']>;
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly displayRole?: InputMaybe<Scalars['String']['input']>;
  readonly residentAppVisibility?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateUserProfilePayload = {
  readonly __typename?: 'UpdateUserProfilePayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  /** May contain more than one error for same field. */
  readonly errors?: Maybe<ReadonlyArray<Maybe<ErrorType>>>;
  readonly userProfile?: Maybe<UserProfileNode>;
};

export type UpgradeLandlordToSubscriptionInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly generatedAgreementUuid?: InputMaybe<Scalars['String']['input']>;
};

export type UpgradeLandlordToSubscriptionPayload = {
  readonly __typename?: 'UpgradeLandlordToSubscriptionPayload';
  readonly client?: Maybe<ClientType>;
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
};

export type UserAppUseNode = {
  readonly __typename?: 'UserAppUseNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly deviceBrand: Scalars['String']['output'];
  readonly deviceNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  readonly deviceType: Scalars['String']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly locale?: Maybe<Scalars['String']['output']>;
  readonly systemName: Scalars['String']['output'];
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user?: Maybe<UserType>;
};

export type UserAppUseNodeConnection = {
  readonly __typename?: 'UserAppUseNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserAppUseNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserAppUseNode` and its cursor. */
export type UserAppUseNodeEdge = {
  readonly __typename?: 'UserAppUseNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserAppUseNode>;
};

export type UserCommunityRestrictionNode = {
  readonly __typename?: 'UserCommunityRestrictionNode';
  readonly activatedDate: Scalars['DateTime']['output'];
  readonly appliedBy?: Maybe<UserType>;
  readonly community: CommunityNode;
  /** Leave blank for permanent restrictions */
  readonly endDate?: Maybe<Scalars['DateTime']['output']>;
  readonly featureType: PeopleUserCommunityRestrictionFeatureTypeChoices;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  /** Reason for applying the restriction */
  readonly reason: Scalars['String']['output'];
  readonly user: UserType;
};

export type UserCommunityRestrictionNodeConnection = {
  readonly __typename?: 'UserCommunityRestrictionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserCommunityRestrictionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserCommunityRestrictionNode` and its cursor. */
export type UserCommunityRestrictionNodeEdge = {
  readonly __typename?: 'UserCommunityRestrictionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserCommunityRestrictionNode>;
};

export type UserDocumentNode = {
  readonly __typename?: 'UserDocumentNode';
  readonly activatedOn?: Maybe<Scalars['DateTime']['output']>;
  readonly availableClientTags?: Maybe<ClientTagNodeConnection>;
  readonly community: CommunityNode;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly createdBy?: Maybe<UserType>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly document?: Maybe<DocumentNode>;
  readonly file?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly link?: Maybe<Scalars['String']['output']>;
  readonly tagAssignments?: Maybe<TagAssignmentNodeConnection>;
  readonly tags?: Maybe<TagNodeConnection>;
  readonly title: Scalars['String']['output'];
  readonly url?: Maybe<Scalars['String']['output']>;
  readonly users: ReadonlyArray<UserType>;
  readonly views: UserDocumentViewNodeConnection;
};


export type UserDocumentNodeAvailableClientTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserDocumentNodeTagAssignmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDocumentNodeTagsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserDocumentNodeViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type UserDocumentViewNode = {
  readonly __typename?: 'UserDocumentViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly user: UserType;
};

export type UserDocumentViewNodeConnection = {
  readonly __typename?: 'UserDocumentViewNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserDocumentViewNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserDocumentViewNode` and its cursor. */
export type UserDocumentViewNodeEdge = {
  readonly __typename?: 'UserDocumentViewNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserDocumentViewNode>;
};

export type UserFeatureAnnouncementNode = {
  readonly __typename?: 'UserFeatureAnnouncementNode';
  readonly activatedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly createdAt: Scalars['DateTime']['output'];
  readonly crossPlatform: Scalars['Boolean']['output'];
  readonly currentUserView?: Maybe<UserFeatureAnnouncementViewNode>;
  readonly featureAnnouncement: FeatureAnnouncementNode;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly platforms: ReadonlyArray<Scalars['String']['output']>;
};


export type UserFeatureAnnouncementNodeCurrentUserViewArgs = {
  platform: Scalars['String']['input'];
};

export type UserFeatureAnnouncementNodeConnection = {
  readonly __typename?: 'UserFeatureAnnouncementNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserFeatureAnnouncementNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserFeatureAnnouncementNode` and its cursor. */
export type UserFeatureAnnouncementNodeEdge = {
  readonly __typename?: 'UserFeatureAnnouncementNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserFeatureAnnouncementNode>;
};

export type UserFeatureAnnouncementViewNode = {
  readonly __typename?: 'UserFeatureAnnouncementViewNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly platform: ResidentialManagementUserFeatureAnnouncementViewPlatformChoices;
  readonly userFeatureAnnouncement: UserFeatureAnnouncementNode;
  readonly viewedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly viewedBy: UserType;
};

export type UserNotificationPreferenceNode = {
  readonly __typename?: 'UserNotificationPreferenceNode';
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly managerAmenityEmailEnabled: Scalars['Boolean']['output'];
  readonly managerAmenityPushEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationEmailEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationMessageEmailEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationMessagePushEnabled: Scalars['Boolean']['output'];
  readonly managerApplicationPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityEventEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityEventPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityProductEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityProductPushEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityUpdateEmailEnabled: Scalars['Boolean']['output'];
  readonly managerCommunityUpdatePushEnabled: Scalars['Boolean']['output'];
  readonly managerConversationAssignmentEmailEnabled: Scalars['Boolean']['output'];
  readonly managerConversationAssignmentPushEnabled: Scalars['Boolean']['output'];
  readonly managerConversationEmailEnabled: Scalars['Boolean']['output'];
  readonly managerConversationPushEnabled: Scalars['Boolean']['output'];
  readonly managerSurveysEmailEnabled: Scalars['Boolean']['output'];
  readonly managerSurveysPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskAssignmentPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskCommentPushEnabled: Scalars['Boolean']['output'];
  readonly managerTaskUpdatePushEnabled: Scalars['Boolean']['output'];
  readonly managerTeamAssignmentEmailEnabled: Scalars['Boolean']['output'];
  readonly managerTeamAssignmentPushEnabled: Scalars['Boolean']['output'];
};

export type UserNotificationPreferenceNodeConnection = {
  readonly __typename?: 'UserNotificationPreferenceNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserNotificationPreferenceNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
};

/** A Relay edge containing a `UserNotificationPreferenceNode` and its cursor. */
export type UserNotificationPreferenceNodeEdge = {
  readonly __typename?: 'UserNotificationPreferenceNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserNotificationPreferenceNode>;
};

export type UserPermissionType = {
  readonly __typename?: 'UserPermissionType';
  readonly actions: ReadonlyArray<Scalars['String']['output']>;
  readonly clientId: Scalars['UUID']['output'];
  readonly communityId?: Maybe<Scalars['UUID']['output']>;
  readonly resource: Scalars['String']['output'];
};

export type UserProfileNode = {
  readonly __typename?: 'UserProfileNode';
  readonly biography?: Maybe<Scalars['String']['output']>;
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly displayRole?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly residentAppVisibility: Scalars['Boolean']['output'];
};

export type UserSessionNode = {
  readonly __typename?: 'UserSessionNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly endTime?: Maybe<Scalars['DateTime']['output']>;
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly sessionTarget: PeopleUserSessionSessionTargetChoices;
  readonly startTime?: Maybe<Scalars['DateTime']['output']>;
  readonly updatedAt: Scalars['DateTime']['output'];
};

export type UserSessionNodeConnection = {
  readonly __typename?: 'UserSessionNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<UserSessionNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `UserSessionNode` and its cursor. */
export type UserSessionNodeEdge = {
  readonly __typename?: 'UserSessionNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<UserSessionNode>;
};

export type UserType = {
  readonly __typename?: 'UserType';
  readonly appUses?: Maybe<UserAppUseNodeConnection>;
  readonly applicant?: Maybe<ApplicantNode>;
  readonly appliedCommunityChatRestriction?: Maybe<UserCommunityRestrictionNode>;
  readonly appliedRestrictions?: Maybe<UserCommunityRestrictionNodeConnection>;
  readonly clientAdmin?: Maybe<ClientAdminNode>;
  readonly communityManager?: Maybe<CommunityManagerNode>;
  readonly concierge?: Maybe<ConciergeNode>;
  readonly dateJoined: Scalars['DateTime']['output'];
  readonly displayPicture?: Maybe<Scalars['String']['output']>;
  readonly email: Scalars['String']['output'];
  readonly firstName?: Maybe<Scalars['String']['output']>;
  readonly hasUsedApp: Scalars['Boolean']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isDemo: Scalars['Boolean']['output'];
  readonly landlord?: Maybe<LandlordNode>;
  readonly lastAppUse?: Maybe<Scalars['DateTime']['output']>;
  readonly lastName?: Maybe<Scalars['String']['output']>;
  readonly leaseholder?: Maybe<LeaseholderNode>;
  readonly manager?: Maybe<ManagerType>;
  readonly mobile?: Maybe<Scalars['String']['output']>;
  readonly name: Scalars['String']['output'];
  readonly permissionSnapshot?: Maybe<PermissionSnapshotType>;
  readonly permissions: ReadonlyArray<Maybe<UserPermissionType>>;
  readonly profile?: Maybe<UserProfileNode>;
  readonly resident?: Maybe<ResidentType>;
  readonly restrictions?: Maybe<UserCommunityRestrictionNodeConnection>;
  readonly rmcDirector?: Maybe<RmcDirectorNode>;
  readonly teams?: Maybe<TeamNodeConnection>;
  readonly termsAndConditionsAcceptedAt?: Maybe<Scalars['DateTime']['output']>;
  readonly unsubscribeNotificationGroups?: Maybe<UnsubscribeNotificationGroupNodeConnection>;
  readonly waivers: WaiverNodeConnection;
};


export type UserTypeAppUsesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeAppliedRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypePermissionSnapshotArgs = {
  clientId: Scalars['UUID']['input'];
};


export type UserTypeRestrictionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTypeTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserTypeUnsubscribeNotificationGroupsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
};


export type UserTypeWaiversArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>>>;
  user?: InputMaybe<Scalars['UUID']['input']>;
};

export type ViewFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly featureAnnouncementId: Scalars['UUID']['input'];
};

export type ViewFeatureAnnouncementPayload = {
  readonly __typename?: 'ViewFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly featureAnnouncementView?: Maybe<FeatureAnnouncementViewNode>;
};

export type ViewUserFeatureAnnouncementInput = {
  readonly clientMutationId?: InputMaybe<Scalars['String']['input']>;
  readonly platform: Scalars['String']['input'];
  readonly userFeatureAnnouncementId: Scalars['UUID']['input'];
};

export type ViewUserFeatureAnnouncementPayload = {
  readonly __typename?: 'ViewUserFeatureAnnouncementPayload';
  readonly clientMutationId?: Maybe<Scalars['String']['output']>;
  readonly userFeatureAnnouncementView?: Maybe<UserFeatureAnnouncementViewNode>;
};

export type VisitReportingAgeBucketNode = {
  readonly __typename?: 'VisitReportingAgeBucketNode';
  readonly count: Scalars['Int']['output'];
  readonly maxDays?: Maybe<Scalars['Int']['output']>;
  readonly minDays: Scalars['Int']['output'];
};

export type VisitReportingArrivalNode = {
  readonly __typename?: 'VisitReportingArrivalNode';
  readonly count: Scalars['Int']['output'];
  readonly hour: Scalars['Int']['output'];
  readonly weekday: Scalars['Int']['output'];
};

export type VisitReportingCompanyNode = {
  readonly __typename?: 'VisitReportingCompanyNode';
  readonly count: Scalars['Int']['output'];
  readonly label: Scalars['String']['output'];
};

export type VisitReportingCountNode = {
  readonly __typename?: 'VisitReportingCountNode';
  readonly byDay: ReadonlyArray<VisitReportingDayCountNode>;
  readonly total?: Maybe<Scalars['Int']['output']>;
};

export type VisitReportingDayCountNode = {
  readonly __typename?: 'VisitReportingDayCountNode';
  readonly count?: Maybe<Scalars['Int']['output']>;
  readonly day: Scalars['Date']['output'];
};

export type VisitReportingDayDurationNode = {
  readonly __typename?: 'VisitReportingDayDurationNode';
  readonly day: Scalars['Date']['output'];
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
};

export type VisitReportingNode = {
  readonly __typename?: 'VisitReportingNode';
  readonly arrivals: ReadonlyArray<VisitReportingArrivalNode>;
  readonly companies: ReadonlyArray<VisitReportingCompanyNode>;
  readonly notSignedOut: VisitReportingNotSignedOutNode;
  readonly onSiteNow: Scalars['Int']['output'];
  readonly signIns: VisitReportingCountNode;
  readonly signOuts: VisitReportingCountNode;
  readonly timeOnSite: VisitReportingTimeOnSiteNode;
  readonly visitorTypes: ReadonlyArray<VisitReportingVisitorTypeNode>;
};

export type VisitReportingNotSignedOutNode = {
  readonly __typename?: 'VisitReportingNotSignedOutNode';
  readonly buckets: ReadonlyArray<VisitReportingAgeBucketNode>;
  readonly total: Scalars['Int']['output'];
};

export type VisitReportingTimeOnSiteNode = {
  readonly __typename?: 'VisitReportingTimeOnSiteNode';
  readonly byDay: ReadonlyArray<VisitReportingDayDurationNode>;
  readonly medianSeconds?: Maybe<Scalars['Float']['output']>;
  readonly sampleCount: Scalars['Int']['output'];
};

/** An enumeration. */
export enum VisitReportingVisitorType {
  Contractor = 'CONTRACTOR',
  Guest = 'GUEST'
}

export type VisitReportingVisitorTypeNode = {
  readonly __typename?: 'VisitReportingVisitorTypeNode';
  readonly count: Scalars['Int']['output'];
  readonly visitorType?: Maybe<VisitReportingVisitorType>;
};

export type VoidSafetyDeclaration = {
  readonly __typename?: 'VoidSafetyDeclaration';
  readonly residentSafetyDeclaration?: Maybe<ResidentSafetyDeclarationNode>;
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

export type WaiverNode = {
  readonly __typename?: 'WaiverNode';
  readonly createdAt: Scalars['DateTime']['output'];
  readonly id: Scalars['UUID']['output'];
  readonly isOwner: Scalars['Boolean']['output'];
  readonly type: ResidentialManagementWaiverTypeChoices;
  readonly updatedAt: Scalars['DateTime']['output'];
  readonly user: UserType;
};

export type WaiverNodeConnection = {
  readonly __typename?: 'WaiverNodeConnection';
  /** Contains the nodes in this connection. */
  readonly edges: ReadonlyArray<Maybe<WaiverNodeEdge>>;
  /** Pagination data for this connection. */
  readonly pageInfo: PageInfo;
  readonly totalCount: Scalars['Int']['output'];
};

/** A Relay edge containing a `WaiverNode` and its cursor. */
export type WaiverNodeEdge = {
  readonly __typename?: 'WaiverNodeEdge';
  /** A cursor for use in pagination */
  readonly cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  readonly node?: Maybe<WaiverNode>;
};

export type WithdrawFireServiceConsent = {
  readonly __typename?: 'WithdrawFireServiceConsent';
  readonly residentSafetyRecord?: Maybe<ResidentSafetyRecordNode>;
};

/** An enumeration. */
export enum Action {
  /** ASSIGN_TEAM */
  AssignTeam = 'ASSIGN_TEAM',
  /** ASSIGN_USER */
  AssignUser = 'ASSIGN_USER',
  /** NOTIFY_TEAM */
  NotifyTeam = 'NOTIFY_TEAM',
  /** NOTIFY_USER */
  NotifyUser = 'NOTIFY_USER'
}

/** An enumeration. */
export enum Company_Type {
  /** CARPENTRY */
  Carpentry = 'CARPENTRY',
  /** CLEANING */
  Cleaning = 'CLEANING',
  /** ELECTRICIAN */
  Electrician = 'ELECTRICIAN',
  /** FIRE_SAFETY */
  FireSafety = 'FIRE_SAFETY',
  /** GENERAL_MAINTENANCE */
  GeneralMaintenance = 'GENERAL_MAINTENANCE',
  /** HVAC */
  Hvac = 'HVAC',
  /** LANDSCAPING */
  Landscaping = 'LANDSCAPING',
  /** LOCKSMITH */
  Locksmith = 'LOCKSMITH',
  /** OTHER */
  Other = 'OTHER',
  /** PAINTING */
  Painting = 'PAINTING',
  /** PEST_CONTROL */
  PestControl = 'PEST_CONTROL',
  /** PLUMBER */
  Plumber = 'PLUMBER',
  /** ROOFING */
  Roofing = 'ROOFING',
  /** SECURITY */
  Security = 'SECURITY'
}

/** An enumeration. */
export enum Compliance_Type {
  /** Asbestos Survey */
  Asbestos = 'ASBESTOS',
  /** Electrical Installation Condition Report */
  Eicr = 'EICR',
  /** Emergency Lighting */
  EmergencyLighting = 'EMERGENCY_LIGHTING',
  /** External Wall System (FRAEW) */
  EwsFraew = 'EWS_FRAEW',
  /** Fire Alarm & Detection */
  FireAlarm = 'FIRE_ALARM',
  /** Fire Door Inspection */
  FireDoor = 'FIRE_DOOR',
  /** Fire Risk Assessment */
  Fra = 'FRA',
  /** Gas Safety */
  GasSafety = 'GAS_SAFETY',
  /** H&S Risk Assessment */
  HsRiskAssessment = 'HS_RISK_ASSESSMENT',
  /** Legionella / Water Hygiene */
  Legionella = 'LEGIONELLA',
  /** Lift LOLER Examination */
  LiftLoler = 'LIFT_LOLER',
  /** Lightning Protection */
  LightningProtection = 'LIGHTNING_PROTECTION',
  /** Other */
  Other = 'OTHER',
  /** Portable Appliance Testing */
  Pat = 'PAT',
  /** Smoke Control / AOV */
  SmokeControl = 'SMOKE_CONTROL',
  /** Sprinkler System */
  Sprinkler = 'SPRINKLER'
}

/** An enumeration. */
export enum Event {
  /** STATUS_CLOSED */
  StatusClosed = 'STATUS_CLOSED',
  /** STATUS_REOPENED */
  StatusReopened = 'STATUS_REOPENED',
  /** STATUS_SNOOZED */
  StatusSnoozed = 'STATUS_SNOOZED',
  /** TAG_ASSIGNMENT */
  TagAssignment = 'TAG_ASSIGNMENT'
}

/** An enumeration. */
export enum Operator {
  /** EQUALS */
  Equals = 'EQUALS',
  /** NOT_EQUALS */
  NotEquals = 'NOT_EQUALS'
}

/** An enumeration. */
export enum Participant_Type {
  /** CONTRACTOR */
  Contractor = 'CONTRACTOR',
  /** INTERNAL */
  Internal = 'INTERNAL',
  /** LEASEHOLDER */
  Leaseholder = 'LEASEHOLDER',
  /** RESIDENT */
  Resident = 'RESIDENT',
  /** UNKNOWN */
  Unknown = 'UNKNOWN'
}

/** An enumeration. */
export enum Priority {
  /** High */
  High = 'HIGH',
  /** Low */
  Low = 'LOW',
  /** Medium */
  Medium = 'MEDIUM',
  /** Urgent */
  Urgent = 'URGENT'
}

/** An enumeration. */
export enum Response_Choice {
  /** N/A */
  Na = 'NA',
  /** No */
  No = 'NO',
  /** Yes */
  Yes = 'YES'
}

/** An enumeration. */
export enum Sender {
  /** Concierge */
  Co = 'CO',
  /** Leaseholder */
  Le = 'LE',
  /** Manager */
  Ma = 'MA',
  /** Resident */
  Re = 'RE'
}

/** An enumeration. */
export enum Session_Target {
  /** MANAGER_APP */
  ManagerApp = 'MANAGER_APP',
  /** MANAGER_DASHBOARD */
  ManagerDashboard = 'MANAGER_DASHBOARD',
  /** RESIDENT_APP */
  ResidentApp = 'RESIDENT_APP'
}

/** An enumeration. */
export enum Sib_Category {
  /** Access plan */
  AccessPlan = 'ACCESS_PLAN',
  /** Block plan */
  BlockPlan = 'BLOCK_PLAN',
  /** Contractor contacts */
  ContractorContacts = 'CONTRACTOR_CONTACTS',
  /** Fire strategy */
  FireStrategy = 'FIRE_STRATEGY',
  /** Floor plan */
  FloorPlan = 'FLOOR_PLAN',
  /** Hydrant map */
  HydrantMap = 'HYDRANT_MAP',
  /** Key holders */
  KeyHolders = 'KEY_HOLDERS',
  /** Other */
  Other = 'OTHER',
  /** Risk assessment */
  RiskAssessment = 'RISK_ASSESSMENT'
}

/** An enumeration. */
export enum Status {
  /** Archived */
  Archived = 'ARCHIVED',
  /** Blocked */
  Blocked = 'BLOCKED',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** In Progress */
  InProgress = 'IN_PROGRESS',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum Surface {
  /** App open */
  AppOpen = 'APP_OPEN',
  /** Banner */
  Banner = 'BANNER',
  /** Chat footer */
  ChatFooter = 'CHAT_FOOTER',
  /** Push */
  Push = 'PUSH'
}

export type RemoveResidentsFromResidencyMutationVariables = Exact<{
  input: RemoveResidentsFromResidencyInput;
}>;


export type RemoveResidentsFromResidencyMutation = { readonly __typename?: 'Mutation', readonly removeResidentsFromResidency?: { readonly __typename?: 'RemoveResidentsFromResidencyPayload', readonly residency?: { readonly __typename?: 'ResidencyType', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ConversationListItemFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly name: string, readonly email: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly email: string, readonly firstName: string, readonly lastName: string } | null } | null> } | null } | null, readonly client: { readonly __typename?: 'ClientType', readonly id: string, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly isSelected?: boolean | null, readonly suggested?: boolean | null } | null } | null> } | null } } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null };

export type HasAsanaIntegrationQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type HasAsanaIntegrationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean } | null } | null } | null };

export type SendConversationToAsanaMutationVariables = Exact<{
  input: SendConversationToAsanaInput;
}>;


export type SendConversationToAsanaMutation = { readonly __typename?: 'Mutation', readonly sendConversationToAsana?: { readonly __typename?: 'SendConversationToAsanaPayload', readonly asanaSendPending: boolean, readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string } | null, readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null };

export type CommunityTeamMembersFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly displayPicture?: string | null } | null } | null> } | null };

export type CommunityTeamMembersQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type CommunityTeamMembersQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly displayPicture?: string | null } | null } | null> } | null } | null };

export type ConversationAssignmentDataFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null };

export type ConversationAssignmentDataQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationAssignmentDataQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null };

export type CreateConversationAssignmentMutationVariables = Exact<{
  input: CreateConversationAssignmentInput;
}>;


export type CreateConversationAssignmentMutation = { readonly __typename?: 'Mutation', readonly createConversationAssignment?: { readonly __typename?: 'CreateConversationAssignmentPayload', readonly conversationAssignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } } | null } | null };

export type HasDwellantIntegrationQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type HasDwellantIntegrationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasDwellantIntegration?: boolean | null } | null } | null } | null };

export type SendToDwellantInfoQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type SendToDwellantInfoQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly dwellantTaskCategories?: ReadonlyArray<string | null> | null } | null } | null, readonly summary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly summary: string } | null } | null };

export type ConversationForwardingEmailsQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationForwardingEmailsQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly conversationForwardingEmails: ReadonlyArray<{ readonly __typename?: 'ConversationForwardingEmailType', readonly id: string, readonly name?: string | null, readonly emails?: ReadonlyArray<string> | null }> } } | null } | null } | null };

export type AssignClientTagMutationVariables = Exact<{
  input: AssignClientTagInput;
}>;


export type AssignClientTagMutation = { readonly __typename?: 'Mutation', readonly assignClientTag?: { readonly __typename?: 'AssignClientTagPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string } } | null } | null };

export type AvailableClientTagFragment = { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null };

export type AvailableClientTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableClientTagsQuery = { readonly __typename?: 'DebugSchema', readonly clientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null } | null } | null> } | null };

export type ConversationTagAssignmentFragmentFragment = { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } };

export type ConversationTagAssignmentsQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationTagAssignmentsQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null } | null } | null> } | null } | null };

export type UnassignClientTagMutationVariables = Exact<{
  input: UnassignClientTagInput;
}>;


export type UnassignClientTagMutation = { readonly __typename?: 'Mutation', readonly unassignClientTag?: { readonly __typename?: 'UnassignClientTagPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string } } | null } | null };

export type AvailableConversationLabelsQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type AvailableConversationLabelsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type ConversationLabelFragment = { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null };

export type ActiveConversationLabelsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ActiveConversationLabelsQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null };

export type LabelConversationMutationVariables = Exact<{
  input: LabelConversationInput;
}>;


export type LabelConversationMutation = { readonly __typename?: 'Mutation', readonly labelConversation?: { readonly __typename?: 'LabelConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly availableTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type UnlabelConversationMutationVariables = Exact<{
  input: UnlabelConversationInput;
}>;


export type UnlabelConversationMutation = { readonly __typename?: 'Mutation', readonly unlabelConversation?: { readonly __typename?: 'UnlabelConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly availableTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type UpdateConversationTitleMutationVariables = Exact<{
  input: UpdateConversationTitleInput;
}>;


export type UpdateConversationTitleMutation = { readonly __typename?: 'Mutation', readonly updateConversationTitle?: { readonly __typename?: 'UpdateConversationTitlePayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null } | null };

export type ConversationSummaryQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ConversationSummaryQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly summary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly summary: string } | null } | null };

export type CreateConversationSummaryMutationVariables = Exact<{
  input: CreateConversationSummaryInput;
}>;


export type CreateConversationSummaryMutation = { readonly __typename?: 'Mutation', readonly createConversationSummary?: { readonly __typename?: 'CreateConversationSummaryPayload', readonly conversationSummary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string, readonly summary?: { readonly __typename?: 'ConversationSummaryNode', readonly id: string, readonly summary: string } | null } } | null } | null };

export type GetFixFloQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type GetFixFloQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null } } | null } | null } | null };

export type CreateManagerConversationReadMutationVariables = Exact<{
  input: CreateManagerConversationReadInput;
}>;


export type CreateManagerConversationReadMutation = { readonly __typename?: 'Mutation', readonly createManagerConversationRead?: { readonly __typename?: 'CreateManagerConversationReadPayload', readonly conversation?: string | null, readonly unread?: boolean | null } | null };

export type ListOtherConversationsQueryVariables = Exact<{
  currentConversationId?: InputMaybe<Scalars['UUID']['input']>;
  contact?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListOtherConversationsQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly createdAt: string } | null } | null } | null> } | null };

export type OrderConversationTagsMutationVariables = Exact<{
  input: OrderConversationTagsInput;
}>;


export type OrderConversationTagsMutation = { readonly __typename?: 'Mutation', readonly orderConversationTags?: { readonly __typename?: 'OrderConversationTagsPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type CreateConversationNoteMutationVariables = Exact<{
  input: CreateConversationNoteInput;
}>;


export type CreateConversationNoteMutation = { readonly __typename?: 'Mutation', readonly createConversationNote?: { readonly __typename?: 'CreateConversationNotePayload', readonly conversationNote?: { readonly __typename?: 'ConversationNoteNode', readonly id: string, readonly text: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | null } | null };

export type AcceptMessageSuggestionMutationVariables = Exact<{
  input: AcceptMessageSuggestionInput;
}>;


export type AcceptMessageSuggestionMutation = { readonly __typename?: 'Mutation', readonly acceptMessageSuggestion?: { readonly __typename?: 'AcceptMessageSuggestionPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null, readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly suggestion?: string | null, readonly action?: ResidentialManagementMessageSuggestionActionChoices | null } | null }> } | null } | null };

export type ActionItemQueryVariables = Exact<{
  conversationId: Scalars['UUID']['input'];
}>;


export type ActionItemQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly dwellantOrgId?: string | null } } | null } | null } | null };

export type IgnoreMessageSuggestionMutationVariables = Exact<{
  input: IgnoreMessageSuggestionInput;
}>;


export type IgnoreMessageSuggestionMutation = { readonly __typename?: 'Mutation', readonly ignoreMessageSuggestion?: { readonly __typename?: 'IgnoreMessageSuggestionPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly id: string } | null }> } | null } | null };

export type MarkSuggestionShownMutationVariables = Exact<{
  input: MarkSuggestionShownInput;
}>;


export type MarkSuggestionShownMutation = { readonly __typename?: 'Mutation', readonly markSuggestionShown?: { readonly __typename?: 'MarkSuggestionShownPayload', readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly id: string } | null } | null };

export type ContractorSuggestionFragment = { readonly __typename?: 'ContractorSuggestionType', readonly id: string, readonly isContractor: boolean, readonly isContractorDecision?: ContractorDecision | null, readonly contractorConfidence?: number | null, readonly homeConfidence?: number | null, readonly contractorHasCompany: boolean, readonly suggestedHome?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null };

export type RatingAnswerFragment = { readonly __typename?: 'ConversationRatingAnswerType', readonly id: string, readonly valueText: string, readonly question: { readonly __typename?: 'ConversationRatingQuestionType', readonly id: string, readonly questionText: string, readonly answerType: ResidentialManagementConversationRatingQuestionAnswerTypeChoices } };

export type AddContractorToClientContractorCompanyMutationVariables = Exact<{
  input: AddContractorToClientContractorCompanyInput;
}>;


export type AddContractorToClientContractorCompanyMutation = { readonly __typename?: 'Mutation', readonly addContractorToClientContractorCompany?: { readonly __typename?: 'AddContractorToClientContractorCompanyPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly contractorSuggestion?: { readonly __typename?: 'ContractorSuggestionType', readonly id: string, readonly contractorHasCompany: boolean } | null } | null } | null };

export type CancelScheduledMessageMutationVariables = Exact<{
  input: CancelScheduledMessageInput;
}>;


export type CancelScheduledMessageMutation = { readonly __typename?: 'Mutation', readonly cancelScheduledMessage?: { readonly __typename?: 'CancelScheduledMessage', readonly success?: boolean | null } | null };

export type CloseConversationMutationVariables = Exact<{
  input: CloseConversationInput;
}>;


export type CloseConversationMutation = { readonly __typename?: 'Mutation', readonly closeConversation?: { readonly __typename?: 'CloseConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type ContractorSuggestionCompaniesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractorSuggestionCompaniesQuery = { readonly __typename?: 'DebugSchema', readonly clientContractorCompanies?: { readonly __typename?: 'ClientContractorCompanyNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientContractorCompanyNodeEdge', readonly node?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractorCompany: { readonly __typename?: 'ContractorCompanyNode', readonly name: string } } | null } | null> } | null };

export type CreateConversationMutationVariables = Exact<{
  input: CreateConversationInput;
  sender: ConversationRole;
}>;


export type CreateConversationMutation = { readonly __typename?: 'Mutation', readonly createConversation?: { readonly __typename?: 'CreateConversation', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string } | null } | null } | null };

export type CreateConversationActionMutationVariables = Exact<{
  input: CreateConversationActionInput;
}>;


export type CreateConversationActionMutation = { readonly __typename?: 'Mutation', readonly createConversationAction?: { readonly __typename?: 'CreateConversationActionPayload', readonly conversation?: string | null, readonly id?: string | null, readonly createdAt?: string | null, readonly type?: string | null, readonly extra?: string | null } | null };

export type CreateConversationMessageMutationVariables = Exact<{
  input: CreateConversationMessageInput;
  sender: ConversationRole;
}>;


export type CreateConversationMessageMutation = { readonly __typename?: 'Mutation', readonly createConversationMessage?: { readonly __typename?: 'CreateConversationMessage', readonly message?: { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices } | null } | null };

export type CreateScheduledMessageMutationVariables = Exact<{
  input: CreateScheduledMessageInput;
}>;


export type CreateScheduledMessageMutation = { readonly __typename?: 'Mutation', readonly createScheduledMessage?: { readonly __typename?: 'CreateScheduledMessagePayload', readonly scheduledMessage?: { readonly __typename?: 'ScheduledMessageType', readonly id: string } | null } | null };

export type FindConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindConversationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string } | null } | null };

export type FindFullConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindFullConversationQuery = { readonly __typename?: 'DebugSchema', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly source?: string | null, readonly participantType: ResidentialManagementConversationParticipantTypeChoices, readonly closedAt?: string | null, readonly ratingPresentation: { readonly __typename?: 'RatingPresentationType', readonly style: RatingDisplayStyle }, readonly rating?: { readonly __typename?: 'ConversationRatingType', readonly id: string, readonly createdAt: string, readonly rating: number, readonly comment?: string | null, readonly answers: ReadonlyArray<{ readonly __typename?: 'ConversationRatingAnswerType', readonly id: string, readonly valueText: string, readonly question: { readonly __typename?: 'ConversationRatingQuestionType', readonly id: string, readonly questionText: string, readonly answerType: ResidentialManagementConversationRatingQuestionAnswerTypeChoices } }> } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string } | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly contractorSuggestion?: { readonly __typename?: 'ContractorSuggestionType', readonly id: string, readonly isContractor: boolean, readonly isContractorDecision?: ContractorDecision | null, readonly contractorConfidence?: number | null, readonly homeConfidence?: number | null, readonly contractorHasCompany: boolean, readonly suggestedHome?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null, readonly media: ReadonlyArray<{ readonly __typename?: 'ConversationMediaType', readonly id: string, readonly file: string, readonly createdAt: string, readonly sender: ResidentialManagementConversationMediaSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null }>, readonly messages: ReadonlyArray<{ readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly quotedText?: string | null, readonly createdAt: string, readonly sender: ResidentialManagementConversationMessageSenderChoices, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null, readonly suggestion?: { readonly __typename?: 'MessageSuggestionType', readonly id: string, readonly suggestion?: string | null, readonly action?: ResidentialManagementMessageSuggestionActionChoices | null, readonly createdAt: string, readonly version: number, readonly citations?: string | null, readonly model?: string | null, readonly promptVersion?: string | null } | null }>, readonly actions: ReadonlyArray<{ readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null, readonly extra?: string | null }>, readonly latestOpen?: { readonly __typename?: 'ConversationOpenedType', readonly id: string, readonly createdAt: string } | null, readonly notes?: { readonly __typename?: 'ConversationNoteNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNoteNodeEdge', readonly node?: { readonly __typename?: 'ConversationNoteNode', readonly id: string, readonly text: string, readonly createdAt: string, readonly updatedAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly media?: ReadonlyArray<{ readonly __typename?: 'ConversationNoteMediaNode', readonly id: string, readonly file: string } | null> | null } | null } | null> } | null, readonly scheduledMessages?: ReadonlyArray<{ readonly __typename?: 'ScheduledMessageType', readonly id: string, readonly body: string, readonly sendAt: string, readonly status: ResidentialManagementScheduledMessageStatusChoices, readonly sender: ResidentialManagementScheduledMessageSenderChoices, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly media?: ReadonlyArray<{ readonly __typename?: 'ScheduledMessageMediaType', readonly id: string, readonly file: string } | null> | null } | null> | null, readonly tags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null } | null } | null> } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly linkedTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string } } | null> | null } | null };

export type ReOpenConversationMutationVariables = Exact<{
  input: ReOpenConversationInput;
}>;


export type ReOpenConversationMutation = { readonly __typename?: 'Mutation', readonly reOpenConversation?: { readonly __typename?: 'ReOpenConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string } | null } | null };

export type RespondToContractorSuggestionMutationVariables = Exact<{
  input: RespondToContractorSuggestionInput;
}>;


export type RespondToContractorSuggestionMutation = { readonly __typename?: 'Mutation', readonly respondToContractorSuggestion?: { readonly __typename?: 'RespondToContractorSuggestionPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly participantType: ResidentialManagementConversationParticipantTypeChoices } | null } | null };

export type SetConversationHomeMutationVariables = Exact<{
  input: SetConversationHomeInput;
}>;


export type SetConversationHomeMutation = { readonly __typename?: 'Mutation', readonly setConversationHome?: { readonly __typename?: 'SetConversationHomePayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null } | null };

export type SnoozeConversationMutationVariables = Exact<{
  input: SnoozeConversationInput;
}>;


export type SnoozeConversationMutation = { readonly __typename?: 'Mutation', readonly snoozeConversation?: { readonly __typename?: 'SnoozeConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly snoozedUntil?: string | null } | null } | null };

export type UnsnoozeConversationMutationVariables = Exact<{
  input: UnsnoozeConversationInput;
}>;


export type UnsnoozeConversationMutation = { readonly __typename?: 'Mutation', readonly unsnoozeConversation?: { readonly __typename?: 'UnsnoozeConversationPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly snoozedUntil?: string | null } | null } | null };

export type UpdateConversationParticipantTypeMutationVariables = Exact<{
  input: UpdateConversationParticipantTypeInput;
}>;


export type UpdateConversationParticipantTypeMutation = { readonly __typename?: 'Mutation', readonly updateConversationParticipantType?: { readonly __typename?: 'UpdateConversationParticipantTypePayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly participantType: ResidentialManagementConversationParticipantTypeChoices } | null } | null };

export type UpdateScheduledMessageMutationVariables = Exact<{
  input: UpdateScheduledMessageInput;
}>;


export type UpdateScheduledMessageMutation = { readonly __typename?: 'Mutation', readonly updateScheduledMessage?: { readonly __typename?: 'UpdateScheduledMessage', readonly success?: boolean | null } | null };

export type UpdateConversationUrgencyMutationVariables = Exact<{
  input: UpdateConversationUrgencyInput;
}>;


export type UpdateConversationUrgencyMutation = { readonly __typename?: 'Mutation', readonly updateConversationUrgency?: { readonly __typename?: 'UpdateConversationUrgency', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly currentUrgency?: string | null } | null } | null };

export type DocumentSentApplicationsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type DocumentSentApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number } | null };

export type AllConversationCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  teamIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AllConversationCountsQuery = { readonly __typename?: 'DebugSchema', readonly conversationCounts?: { readonly __typename?: 'ConversationCountsNode', readonly all: number, readonly needsResponse: number, readonly snoozed: number, readonly assigned: number, readonly assignedToMyTeam: number, readonly unassigned: number, readonly fromEmail: number, readonly fromArk: number, readonly inactive: number, readonly inactiveOwed: number } | null };

export type UnansweredMessagesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnansweredMessagesQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly totalCount: number } | null };

export type SafetyRosterNeedsActionCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SafetyRosterNeedsActionCountQuery = { readonly __typename?: 'DebugSchema', readonly safetyRoster?: { readonly __typename?: 'SafetyRosterType', readonly counts: { readonly __typename?: 'SafetyRosterCountsType', readonly needsAction: number } } | null };

export type BlockFilterOptionsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockFilterOptionsQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type ClientTagLabelNodeFragment = { readonly __typename?: 'ClientTagNode', readonly name: string, readonly color?: string | null };

export type CommunityForFilterCommunityFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly deactivatedOn?: string | null };

export type CommunitiesForFilterQueryVariables = Exact<{
  includeDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommunitiesForFilterQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly deactivatedOn?: string | null } | null } | null> } | null };

export type CommunityTeamMemberFragment = { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly displayPicture?: string | null, readonly isManager?: boolean | null, readonly isCommunityManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null };

export type CommunityTeamMembersBatchQueryVariables = Exact<{
  communityIds: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CommunityTeamMembersBatchQuery = { readonly __typename?: 'DebugSchema', readonly communityTeamMembersBulk?: ReadonlyArray<{ readonly __typename?: 'CommunityTeamMembersGroupType', readonly communityId: string, readonly members: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly name: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly displayPicture?: string | null, readonly isManager?: boolean | null, readonly isCommunityManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null }> }> | null };

export type ContactAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  home?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ContactAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null } | null } | null> } | null };

export type GroupAutocompleteQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GroupAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type HomeAutocompleteQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type HomeAutocompleteQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ContractorCompaniesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContractorCompaniesQuery = { readonly __typename?: 'DebugSchema', readonly clientContractorCompanies?: { readonly __typename?: 'ClientContractorCompanyNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientContractorCompanyNodeEdge', readonly node?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null } | null> } | null };

export type FormResidenciesQueryVariables = Exact<{
  home?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FormResidenciesQuery = { readonly __typename?: 'DebugSchema', readonly residencies?: { readonly __typename?: 'ResidencyNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyNodeEdge', readonly node?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null } | null> } | null };

export type AllTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllTeamsQuery = { readonly __typename?: 'DebugSchema', readonly teams?: { readonly __typename?: 'TeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TeamNodeEdge', readonly node?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | null } | null> } | null };

export type CommunityGroupFilterGroupFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly communityId?: string | null, readonly communityName?: string | null, readonly isCommunityScoped?: boolean | null, readonly isBlockScoped?: boolean | null };

export type CommunityGroupFilterGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityGroupFilterGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroupsAll?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly communityId?: string | null, readonly communityName?: string | null, readonly isCommunityScoped?: boolean | null, readonly isBlockScoped?: boolean | null } | null } | null> } | null };

export type UserCommunityItemFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } };

export type ClientAdminItemFragment = { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type ConciergeItemFragment = { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null };

export type ManagerItemFragment = { readonly __typename?: 'ManagerType', readonly id: string, readonly email?: string | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type RmcDirectorItemFragment = { readonly __typename?: 'RMCDirectorNode', readonly id: string, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } };

export type GetUserTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserTypeQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string, readonly mobile?: string | null, readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null } | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly email?: string | null, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string, readonly clientType: PeopleClientClientTypeChoices } | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string } | null, readonly rmcDirector?: { readonly __typename?: 'RMCDirectorNode', readonly id: string, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly packageLocations?: ReadonlyArray<string | null> | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } } | null } | null };

export type CommunitySettingsFragment = { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean };

export type CreateOrUpdateUserSessionMutationVariables = Exact<{
  input: CreateOrUpdateUserSessionInput;
}>;


export type CreateOrUpdateUserSessionMutation = { readonly __typename?: 'Mutation', readonly createOrUpdateUserSession?: { readonly __typename?: 'CreateOrUpdateUserSessionPayload', readonly userSession?: { readonly __typename?: 'UserSessionNode', readonly id: string, readonly sessionTarget: PeopleUserSessionSessionTargetChoices } | null } | null };

export type NotificationHookFragment = { readonly __typename?: 'NotificationNode', readonly id: string, readonly verb?: string | null, readonly actor?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'ConciergeNode', readonly id: string } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'ManagerType' } | { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'TenancyApplicantNode' } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null };

export type CreateDeviceMutationVariables = Exact<{
  input: CreateNewDeviceInput;
}>;


export type CreateDeviceMutation = { readonly __typename?: 'Mutation', readonly createNewDevice?: { readonly __typename?: 'CreateNewDevice', readonly ok?: boolean | null } | null };

export type FindNotificationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindNotificationQuery = { readonly __typename?: 'DebugSchema', readonly notification?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly verb?: string | null, readonly actor?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'ConciergeNode', readonly id: string } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'ManagerType' } | { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | { readonly __typename?: 'TenancyApplicantNode' } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null } | null };

export type LogManagerDashUseMutationVariables = Exact<{ [key: string]: never; }>;


export type LogManagerDashUseMutation = { readonly __typename?: 'Mutation', readonly logManagerDashUse?: { readonly __typename?: 'LogManagerDashUse', readonly ok?: boolean | null } | null };

export type GetClientTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientTypeQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly clientType: PeopleClientClientTypeChoices } | null };

export type GetFeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeaturesQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly features: ReadonlyArray<{ readonly __typename?: 'FeatureType', readonly id: string, readonly name?: string | null, readonly isBeta: boolean }> } | null };

export type GetClientPaymentsEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientPaymentsEnabledQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly paymentsEnabled?: boolean | null } | null };

export type GetClientStripeLoginLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientStripeLoginLinkQuery = { readonly __typename?: 'DebugSchema', readonly getClient?: { readonly __typename?: 'ClientType', readonly id: string, readonly stripeDashboardLink?: string | null } | null };

export type LeanNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LeanNotificationsQuery = { readonly __typename?: 'DebugSchema', readonly leanNotifications?: { readonly __typename?: 'LeanNotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'LeanNotificationNodeEdge', readonly node?: { readonly __typename?: 'LeanNotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly type: string, readonly platform?: string | null, readonly targetType?: string | null, readonly targetObjectId?: string | null, readonly actionObjectType?: string | null, readonly actionObjectObjectId?: string | null, readonly isFeatureAnnouncement: boolean, readonly navigationMeta?: { readonly __typename?: 'NotificationNavigationMeta', readonly targetType?: string | null, readonly actionObjectType?: string | null, readonly routeId?: string | null, readonly secondaryId?: string | null } | null } | null } | null> } | null };

export type NotificationsMenuNotificationFragment = { readonly __typename?: 'NotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null };

export type NotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationsQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'NotificationNodeEdge', readonly node?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null } | null } | null> } | null };

export type ReadAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllNotificationsMutation = { readonly __typename?: 'Mutation', readonly readAllNotifications?: { readonly __typename?: 'ReadAllNotificationsPayload', readonly clientMutationId?: string | null } | null };

export type ReadAllNotificationsOnTargetMutationVariables = Exact<{
  input: ReadAllNotificationsOnTargetInput;
}>;


export type ReadAllNotificationsOnTargetMutation = { readonly __typename?: 'Mutation', readonly readAllNotificationsOnTarget?: { readonly __typename?: 'ReadAllNotificationsOnTargetPayload', readonly clientMutationId?: string | null } | null };

export type ReadNotificationMutationVariables = Exact<{
  input: ReadNotificationInput;
}>;


export type ReadNotificationMutation = { readonly __typename?: 'Mutation', readonly readNotification?: { readonly __typename?: 'ReadNotificationPayload', readonly notification?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly read: boolean } | null } | null };

export type UnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadNotificationsCountQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number } | null };

export type TeamFilterItemFragment = { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null };

export type GetClientUserQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GetClientUserQuery = { readonly __typename?: 'DebugSchema', readonly clientUserById?: { readonly __typename?: 'ClientUserNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly dateJoined: string, readonly mfaEnabled: boolean, readonly lastActive?: string | null, readonly teams?: { readonly __typename?: 'TeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TeamNodeEdge', readonly node?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string } | null } | null> } | null } | null } | null> } | null, readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string, readonly isActive?: boolean | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string } | null } | null> } | null } | null, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly isActive?: boolean | null, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string } | null } | null> } | null } | null, readonly concierge?: { readonly __typename?: 'ConciergeNode', readonly id: string, readonly isActive?: boolean | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string } | null } | null> } | null } | null } | null };

export type AddMemberMutationVariables = Exact<{
  input: AddMemberInput;
}>;


export type AddMemberMutation = { readonly __typename?: 'Mutation', readonly addMember?: { readonly __typename?: 'AddMemberPayload', readonly createdUserId?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null, readonly clientUser?: { readonly __typename?: 'ClientUserNode', readonly id: string } | null } | null };

export type DeactivateClientUserMutationVariables = Exact<{
  input: DeactivateClientUserInput;
}>;


export type DeactivateClientUserMutation = { readonly __typename?: 'Mutation', readonly deactivateClientUser?: { readonly __typename?: 'DeactivateClientUserPayload', readonly clientUser?: { readonly __typename?: 'ClientUserNode', readonly id: string } | null } | null };

export type EditMemberMutationVariables = Exact<{
  input: EditMemberInput;
}>;


export type EditMemberMutation = { readonly __typename?: 'Mutation', readonly editMember?: { readonly __typename?: 'EditMemberPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ResendMemberInviteEmailMutationVariables = Exact<{
  input: ResendMemberInviteEmailInput;
}>;


export type ResendMemberInviteEmailMutation = { readonly __typename?: 'Mutation', readonly resendMemberInviteEmail?: { readonly __typename?: 'ResendMemberInviteEmailPayload', readonly clientUser?: { readonly __typename?: 'ClientUserNode', readonly id: string } | null } | null };

export type ClientStaffMembersQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ClientStaffMembersQuery = { readonly __typename?: 'DebugSchema', readonly clientStaffMembers?: { readonly __typename?: 'ClientStaffMemberNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientStaffMemberNodeEdge', readonly node?: { readonly __typename?: 'ClientStaffMemberNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mfaEnabled: boolean, readonly lastActive?: string | null, readonly role?: string | null, readonly isRoleActive?: boolean | null, readonly roleCommunityCount: number, readonly communityIds: ReadonlyArray<string | null>, readonly teamIds: ReadonlyArray<string | null>, readonly roleCommunitiesPreview?: ReadonlyArray<{ readonly __typename?: 'ClientUserCommunityType', readonly id?: string | null, readonly name?: string | null } | null> | null, readonly profile?: { readonly __typename?: 'UserProfileNode', readonly displayPicture?: string | null } | null, readonly teams?: ReadonlyArray<{ readonly __typename?: 'ClientStaffMemberTeamType', readonly id?: string | null, readonly name?: string | null, readonly icon?: string | null } | null> | null } | null } | null> } | null };

export type BulkDeactivationJobQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BulkDeactivationJobQuery = { readonly __typename?: 'DebugSchema', readonly bulkDeactivationJob?: { readonly __typename?: 'BulkDeactivationJobNode', readonly id: string, readonly status?: string | null, readonly total: number, readonly processed: number, readonly succeeded: number, readonly failed: number, readonly startedAt?: string | null, readonly finishedAt?: string | null } | null };

export type StartBulkDeactivationMutationVariables = Exact<{
  ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type StartBulkDeactivationMutation = { readonly __typename?: 'Mutation', readonly startBulkDeactivation?: { readonly __typename?: 'StartBulkDeactivationPayload', readonly job?: { readonly __typename?: 'BulkDeactivationJobNode', readonly id: string, readonly status?: string | null, readonly total: number, readonly processed: number, readonly succeeded: number, readonly failed: number, readonly startedAt?: string | null, readonly finishedAt?: string | null } | null } | null };

export type GetClientAdminQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClientAdminQuery = { readonly __typename?: 'DebugSchema', readonly getClientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string, readonly client?: { readonly __typename?: 'ClientType', readonly id: string, readonly clientType: PeopleClientClientTypeChoices, readonly paymentsEnabled?: boolean | null } | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly mobile?: string | null }, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null };

export type UpdateClientAdminMutationVariables = Exact<{
  input: UpdateClientAdminInput;
}>;


export type UpdateClientAdminMutation = { readonly __typename?: 'Mutation', readonly updateClientAdmin?: { readonly __typename?: 'UpdateClientAdminPayload', readonly clientAdmin?: { readonly __typename?: 'ClientAdminNode', readonly id: string } | null } | null };

export type ConversationTagQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ConversationTagQuery = { readonly __typename?: 'DebugSchema', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string } | null };

export type ConversationTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConversationTagsQuery = { readonly __typename?: 'DebugSchema', readonly conversationTags?: { readonly __typename?: 'ConversationTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationTagNodeEdge', readonly node?: { readonly __typename?: 'ConversationTagNode', readonly id: string, readonly name: string, readonly client: { readonly __typename?: 'ClientType', readonly name: string } } | null } | null> } | null };

export type CreateConversationTagMutationVariables = Exact<{
  input: CreateConversationTagInput;
}>;


export type CreateConversationTagMutation = { readonly __typename?: 'Mutation', readonly createConversationTag?: { readonly __typename?: 'CreateConversationTagPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteConversationTagMutationVariables = Exact<{
  input: DeleteConversationTagInput;
}>;


export type DeleteConversationTagMutation = { readonly __typename?: 'Mutation', readonly deleteConversationTag?: { readonly __typename?: 'DeleteConversationTagPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type RemoveConversationTagMutationVariables = Exact<{
  input: RemoveConversationTagInput;
}>;


export type RemoveConversationTagMutation = { readonly __typename?: 'Mutation', readonly removeConversationTag?: { readonly __typename?: 'RemoveConversationTagPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type TagConversationMutationVariables = Exact<{
  input: TagConversationInput;
}>;


export type TagConversationMutation = { readonly __typename?: 'Mutation', readonly tagConversation?: { readonly __typename?: 'TagConversationPayload', readonly conversationTag?: { readonly __typename?: 'ConversationTagNode', readonly id: string } | null } | null };

export type UpdateConversationTagMutationVariables = Exact<{
  input: UpdateConversationTagInput;
}>;


export type UpdateConversationTagMutation = { readonly __typename?: 'Mutation', readonly updateConversationTag?: { readonly __typename?: 'UpdateConversationTagPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ClientTagMinimalFragment = { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null };

export type ClientTagsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ClientTagsQuery = { readonly __typename?: 'DebugSchema', readonly clientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly description?: string | null, readonly archivedAt?: string | null, readonly id: string, readonly name: string, readonly color?: string | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string } | null, readonly client: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string } } | null } | null> } | null };

export type ClientTagQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ClientTagQuery = { readonly __typename?: 'DebugSchema', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly color?: string | null, readonly archivedAt?: string | null, readonly isSystemManaged: boolean, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } | null, readonly client: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string } } | null };

export type ClientTagItemFragment = { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly color?: string | null, readonly archivedAt?: string | null, readonly isSystemManaged: boolean, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string, readonly displayPicture?: string | null } | null, readonly client: { readonly __typename?: 'ClientType', readonly id: string, readonly name: string } };

export type TagConversationsQueryVariables = Exact<{
  tagId: Scalars['UUID']['input'];
}>;


export type TagConversationsQuery = { readonly __typename?: 'DebugSchema', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly assignments: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'ConversationNode', readonly id: string, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly currentUrgency?: string | null, readonly latestUpdatedDate?: string | null, readonly latestMessage?: { readonly __typename?: 'ConversationMessageType', readonly seen?: boolean | null } | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | { readonly __typename?: 'TaskDefinitionNode' } | { readonly __typename?: 'UserDocumentNode' } | null } | null } | null> } } | null };

export type TaggedConversationItemFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly currentUrgency?: string | null, readonly latestUpdatedDate?: string | null, readonly latestMessage?: { readonly __typename?: 'ConversationMessageType', readonly seen?: boolean | null } | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null };

export type TagDocumentsQueryVariables = Exact<{
  tagId: Scalars['UUID']['input'];
}>;


export type TagDocumentsQuery = { readonly __typename?: 'DebugSchema', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly assignments: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'TaskDefinitionNode' } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly url?: string | null, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null } | null } | null> } } | null };

export type TaggedCommunityDocumentItemFragment = { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type TaggedUserDocumentItemFragment = { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly url?: string | null, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null };

export type ToggleClientTagArchivedAtMutationVariables = Exact<{
  input: ToggleClientTagArchivedAtInput;
}>;


export type ToggleClientTagArchivedAtMutation = { readonly __typename?: 'Mutation', readonly toggleClientTagArchivedAt?: { readonly __typename?: 'ToggleClientTagArchivedAtPayload', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateClientTagMutationVariables = Exact<{
  input: UpdateClientTagInput;
}>;


export type UpdateClientTagMutation = { readonly __typename?: 'Mutation', readonly updateClientTag?: { readonly __typename?: 'UpdateClientTagPayload', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly color?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateClientTagMutationVariables = Exact<{
  input: CreateClientTagInput;
}>;


export type CreateClientTagMutation = { readonly __typename?: 'Mutation', readonly createClientTag?: { readonly __typename?: 'CreateClientTagPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateClientTagColorMutationVariables = Exact<{
  input: UpdateClientTagColorInput;
}>;


export type UpdateClientTagColorMutation = { readonly __typename?: 'Mutation', readonly updateClientTagColor?: { readonly __typename?: 'UpdateClientTagColorPayload', readonly clientTag?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly color?: string | null } | null } | null };

export type TeamsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamsQuery = { readonly __typename?: 'DebugSchema', readonly teams?: { readonly __typename?: 'TeamNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TeamNodeEdge', readonly node?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly icon?: string | null, readonly userCount: number, readonly activatedAt?: string | null, readonly deactivatedAt?: string | null, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null } | null> } | null };

export type CreateTeamMutationVariables = Exact<{
  input: CreateTeamInput;
}>;


export type CreateTeamMutation = { readonly __typename?: 'Mutation', readonly createTeam?: { readonly __typename?: 'CreateTeamPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly activatedAt?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string }>, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunitiesTabQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommunitiesTabQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly avatar?: string | null, readonly homeCount: number, readonly residentCount: number } | null } | null> } | null };

export type UpdateTeamCommunitiesMutationVariables = Exact<{
  input: UpdateTeamCommunitiesInput;
}>;


export type UpdateTeamCommunitiesMutation = { readonly __typename?: 'Mutation', readonly updateTeamCommunities?: { readonly __typename?: 'UpdateTeamCommunitiesPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AddOtherMembersModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AddOtherMembersModalQuery = { readonly __typename?: 'DebugSchema', readonly clientStaffMembers?: { readonly __typename?: 'ClientStaffMemberNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientStaffMemberNodeEdge', readonly node?: { readonly __typename?: 'ClientStaffMemberNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastActive?: string | null, readonly role?: string | null, readonly communityIds: ReadonlyArray<string | null>, readonly teamIds: ReadonlyArray<string | null> } | null } | null> } | null };

export type AddTeamMembersMutationVariables = Exact<{
  input: AddTeamMembersInput;
}>;


export type AddTeamMembersMutation = { readonly __typename?: 'Mutation', readonly addTeamMembers?: { readonly __typename?: 'AddTeamMembersPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type MemberItemFragment = { readonly __typename?: 'ClientStaffMemberNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastActive?: string | null, readonly role?: string | null, readonly communityIds: ReadonlyArray<string | null>, readonly teamIds: ReadonlyArray<string | null> };

export type TeamMemberCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMemberCandidatesQuery = { readonly __typename?: 'DebugSchema', readonly clientStaffMembers?: { readonly __typename?: 'ClientStaffMemberNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientStaffMemberNodeEdge', readonly node?: { readonly __typename?: 'ClientStaffMemberNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastActive?: string | null, readonly role?: string | null, readonly communityIds: ReadonlyArray<string | null>, readonly teamIds: ReadonlyArray<string | null> } | null } | null> } | null };

export type RemoveTeamMemberMutationVariables = Exact<{
  input: RemoveTeamMemberInput;
}>;


export type RemoveTeamMemberMutation = { readonly __typename?: 'Mutation', readonly removeTeamMember?: { readonly __typename?: 'RemoveTeamMemberPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type TeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamMembersQuery = { readonly __typename?: 'DebugSchema', readonly clientStaffMembers?: { readonly __typename?: 'ClientStaffMemberNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientStaffMemberNodeEdge', readonly node?: { readonly __typename?: 'ClientStaffMemberNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly lastActive?: string | null, readonly role?: string | null, readonly communityIds: ReadonlyArray<string | null>, readonly teamIds: ReadonlyArray<string | null> } | null } | null> } | null };

export type UpdateTeamMembersMutationVariables = Exact<{
  input: UpdateTeamMembersInput;
}>;


export type UpdateTeamMembersMutation = { readonly __typename?: 'Mutation', readonly updateTeamMembers?: { readonly __typename?: 'UpdateTeamMembersPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type TeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TeamQuery = { readonly __typename?: 'DebugSchema', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly icon?: string | null, readonly activatedAt?: string | null, readonly deactivatedAt?: string | null, readonly updatedAt: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string }> } | null };

export type ToggleTeamActivatedMutationVariables = Exact<{
  input: ToggleTeamActivatedInput;
}>;


export type ToggleTeamActivatedMutation = { readonly __typename?: 'Mutation', readonly toggleTeamActivated?: { readonly __typename?: 'ToggleTeamActivatedPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly activatedAt?: string | null, readonly deactivatedAt?: string | null, readonly updatedAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateTeamDetailsMutationVariables = Exact<{
  input: UpdateTeamDetailsInput;
}>;


export type UpdateTeamDetailsMutation = { readonly __typename?: 'Mutation', readonly updateTeamDetails?: { readonly __typename?: 'UpdateTeamDetailsPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly updatedAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type TeamItemFragment = { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly icon?: string | null, readonly activatedAt?: string | null, readonly deactivatedAt?: string | null, readonly updatedAt: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string }> };

export type UpdateTeamIconMutationVariables = Exact<{
  input: UpdateTeamIconInput;
}>;


export type UpdateTeamIconMutation = { readonly __typename?: 'Mutation', readonly updateTeamIcon?: { readonly __typename?: 'UpdateTeamIconPayload', readonly team?: { readonly __typename?: 'TeamNode', readonly id: string, readonly icon?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AmenityGroupCommunitiesQueryVariables = Exact<{
  ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type AmenityGroupCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null> } | null };

export type UpdateAmenityTypeMutationVariables = Exact<{
  input: UpdateAmenityTypeInput;
}>;


export type UpdateAmenityTypeMutation = { readonly __typename?: 'Mutation', readonly updateAmenityType?: { readonly __typename?: 'UpdateAmenityTypePayload', readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly type?: ResidentialManagementAmenityTypeChoices | null } | null } | null };

export type DeleteAmenityMutationVariables = Exact<{
  input: DeleteAmenityInput;
}>;


export type DeleteAmenityMutation = { readonly __typename?: 'Mutation', readonly deleteAmenity?: { readonly __typename?: 'DeleteAmenityPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AmenityAvailabilityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  date?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AmenityAvailabilityQuery = { readonly __typename?: 'DebugSchema', readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly daysAvailable: ReadonlyArray<string>, readonly startTime: string, readonly endTime: string, readonly reservations: { readonly __typename?: 'AmenityReservationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityReservationNodeEdge', readonly node?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string } | null } | null> }, readonly operatingTimes: { readonly __typename?: 'AmenityOperatingTimesNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityOperatingTimesNodeEdge', readonly node?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean } | null } | null> } } | null };

export type ManagerReserveAmenityMutationVariables = Exact<{
  input: ManagerReserveAmenityInput;
}>;


export type ManagerReserveAmenityMutation = { readonly __typename?: 'Mutation', readonly managerReserveAmenity?: { readonly __typename?: 'ManagerReserveAmenityPayload', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SaveAmenityMutationVariables = Exact<{
  input: SaveAmenityInput;
}>;


export type SaveAmenityMutation = { readonly __typename?: 'Mutation', readonly saveAmenity?: { readonly __typename?: 'SaveAmenityPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SaveAmenityOperatingTimesMutationVariables = Exact<{
  input: SaveAmenityOperatingTimesInput;
}>;


export type SaveAmenityOperatingTimesMutation = { readonly __typename?: 'Mutation', readonly saveAmenityOperatingTimes?: { readonly __typename?: 'SaveAmenityOperatingTimesPayload', readonly amenityOperatingTimes?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateAmenityOperatingScheduleMutationVariables = Exact<{
  input: UpdateAmenityOperatingScheduleInput;
}>;


export type UpdateAmenityOperatingScheduleMutation = { readonly __typename?: 'Mutation', readonly updateAmenityOperatingSchedule?: { readonly __typename?: 'UpdateAmenityOperatingSchedulePayload', readonly success?: boolean | null, readonly errors?: ReadonlyArray<string | null> | null } | null };

export type AmenityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AmenityQuery = { readonly __typename?: 'DebugSchema', readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly description: string, readonly image?: string | null, readonly reservable: boolean, readonly status: AmenityStatusEnum, readonly live: boolean, readonly maxHours?: number | null, readonly maxCapacity?: number | null, readonly maxAdvanceReservationDays: number, readonly minBookingNotice?: number | null, readonly maxReservations?: number | null, readonly todaysBookingCount: number, readonly archivedAt?: string | null, readonly startDate?: string | null, readonly maxTime?: number | null, readonly minTime?: number | null, readonly minReservationDuration?: number | null, readonly maxReservationDuration?: number | null, readonly type?: ResidentialManagementAmenityTypeChoices | null, readonly exclusive: boolean, readonly links?: ReadonlyArray<string> | null, readonly operatingTimes: { readonly __typename?: 'AmenityOperatingTimesNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityOperatingTimesNodeEdge', readonly node?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean } | null } | null> }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null };

export type AmenityReservationItemFragment = { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly reason?: string | null, readonly isManager: boolean, readonly additionalAttendance: number, readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string, readonly residencies: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } }> } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null } | null> } } | null } | null };

export type AmenityReservationsQueryVariables = Exact<{
  amenity: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
  toDate?: InputMaybe<Scalars['Date']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AmenityReservationsQuery = { readonly __typename?: 'DebugSchema', readonly amenityReservations?: { readonly __typename?: 'AmenityReservationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityReservationNodeEdge', readonly node?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly reason?: string | null, readonly isManager: boolean, readonly additionalAttendance: number, readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly resident?: { readonly __typename?: 'ResidentType', readonly id: string, readonly residencies: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } }> } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null } | null> } } | null } | null } | null } | null> } | null };

export type AmenityReservationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AmenityReservationQuery = { readonly __typename?: 'DebugSchema', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null };

export type ManagerCancelAmenityReservationMutationVariables = Exact<{
  input: ManagerCancelAmenityReservationInput;
}>;


export type ManagerCancelAmenityReservationMutation = { readonly __typename?: 'Mutation', readonly managerCancelAmenityReservation?: { readonly __typename?: 'ManagerCancelAmenityReservationPayload', readonly amenityReservation?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly cancellationMessage?: string | null } | null } | null };

export type AmenitiesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AmenitiesQuery = { readonly __typename?: 'DebugSchema', readonly amenities?: { readonly __typename?: 'AmenityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityNodeEdge', readonly node?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly image?: string | null, readonly status: AmenityStatusEnum, readonly type?: ResidentialManagementAmenityTypeChoices | null, readonly description: string, readonly todaysBookingCount: number, readonly maxReservations?: number | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly operatingTimes: { readonly __typename?: 'AmenityOperatingTimesNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityOperatingTimesNodeEdge', readonly node?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type AmenityItemFragment = { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly image?: string | null, readonly status: AmenityStatusEnum, readonly type?: ResidentialManagementAmenityTypeChoices | null, readonly description: string, readonly todaysBookingCount: number, readonly maxReservations?: number | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly operatingTimes: { readonly __typename?: 'AmenityOperatingTimesNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityOperatingTimesNodeEdge', readonly node?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean } | null } | null> } };

export type ApplicationItemFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly name?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string } | null, readonly thread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null };

export type AcceptApplicationMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
  home?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type AcceptApplicationMutation = { readonly __typename?: 'Mutation', readonly acceptApplication?: { readonly __typename?: 'AcceptApplication', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly approvedAt?: string | null } | null } | null };

export type RejectApplicationMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
  rejectionReason: Scalars['String']['input'];
}>;


export type RejectApplicationMutation = { readonly __typename?: 'Mutation', readonly rejectApplication?: { readonly __typename?: 'RejectApplication', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly lastRejectionReason?: string | null } | null } | null };

export type RemindApplicantMutationVariables = Exact<{
  application: Scalars['UUID']['input'];
}>;


export type RemindApplicantMutation = { readonly __typename?: 'Mutation', readonly remindApplicant?: { readonly __typename?: 'RemindApplicant', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string } | null } | null };

export type ManagerAddApplicationHomeMutationVariables = Exact<{
  input: ManagerAddApplicationHomeInput;
}>;


export type ManagerAddApplicationHomeMutation = { readonly __typename?: 'Mutation', readonly managerAddApplicationHome?: { readonly __typename?: 'ManagerAddApplicationHomePayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SearchHomesQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchHomesQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null }> | null };

export type RemindAllApplicantsMutationVariables = Exact<{
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>;
}>;


export type RemindAllApplicantsMutation = { readonly __typename?: 'Mutation', readonly remindAllApplicants?: { readonly __typename?: 'RemindAllApplicants', readonly ok?: boolean | null } | null };

export type ApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly name?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string } | null, readonly thread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null } | null } | null> } | null };

export type ApplicationStatusPillFragment = { readonly __typename?: 'ApplicationNode', readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null };

export type ApplicantDocumentFragment = { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly verificationResult?: { readonly __typename?: 'DocumentVerificationResultNode', readonly id: string, readonly status: ResidentialManagementDocumentVerificationResultStatusChoices, readonly documentType?: string | null, readonly isProofOfAddress: boolean, readonly appearsAuthentic?: boolean | null, readonly authenticityDetail?: string | null, readonly extractedName?: string | null, readonly extractedAddress?: string | null, readonly nameMatchStatus?: ResidentialManagementDocumentVerificationResultNameMatchStatusChoices | null, readonly addressMatchStatus?: ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices | null, readonly nameMatchDetail?: string | null, readonly addressMatchDetail?: string | null, readonly aiRecommendation?: ResidentialManagementDocumentVerificationResultAiRecommendationChoices | null, readonly confidence?: number | null } | null };

export type ApplicantDocumentsFragment = { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly verificationResult?: { readonly __typename?: 'DocumentVerificationResultNode', readonly id: string, readonly status: ResidentialManagementDocumentVerificationResultStatusChoices, readonly documentType?: string | null, readonly isProofOfAddress: boolean, readonly appearsAuthentic?: boolean | null, readonly authenticityDetail?: string | null, readonly extractedName?: string | null, readonly extractedAddress?: string | null, readonly nameMatchStatus?: ResidentialManagementDocumentVerificationResultNameMatchStatusChoices | null, readonly addressMatchStatus?: ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices | null, readonly nameMatchDetail?: string | null, readonly addressMatchDetail?: string | null, readonly aiRecommendation?: ResidentialManagementDocumentVerificationResultAiRecommendationChoices | null, readonly confidence?: number | null } | null } | null } | null> } } | null } | null> } };

export type ApplicantDocumentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApplicantDocumentsQuery = { readonly __typename?: 'DebugSchema', readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly verificationResult?: { readonly __typename?: 'DocumentVerificationResultNode', readonly id: string, readonly status: ResidentialManagementDocumentVerificationResultStatusChoices, readonly documentType?: string | null, readonly isProofOfAddress: boolean, readonly appearsAuthentic?: boolean | null, readonly authenticityDetail?: string | null, readonly extractedName?: string | null, readonly extractedAddress?: string | null, readonly nameMatchStatus?: ResidentialManagementDocumentVerificationResultNameMatchStatusChoices | null, readonly addressMatchStatus?: ResidentialManagementDocumentVerificationResultAddressMatchStatusChoices | null, readonly nameMatchDetail?: string | null, readonly addressMatchDetail?: string | null, readonly aiRecommendation?: ResidentialManagementDocumentVerificationResultAiRecommendationChoices | null, readonly confidence?: number | null } | null } | null } | null> } } | null } | null> } } | null };

export type ApplicationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplicationQuery = { readonly __typename?: 'DebugSchema', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly createdAt: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly townOrCity?: string | null, readonly region?: string | null, readonly postcode: string, readonly ownershipType?: ResidentialManagementApplicationOwnershipTypeChoices | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly lastRejectionReason?: string | null, readonly approvedAt?: string | null, readonly archivedAt?: string | null, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null, readonly mobile?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string, readonly address: string } | null, readonly thread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> } } | null };

export type ApplicationAttemptsFragment = { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> };

export type ApplicationAuditLogsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApplicationAuditLogsQuery = { readonly __typename?: 'DebugSchema', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly auditLogs: { readonly __typename?: 'ApplicationAuditLogNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAuditLogNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAuditLogNode', readonly id: string, readonly eventType: ResidentialManagementApplicationAuditLogEventTypeChoices, readonly metadata: string, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null> } } | null };

export type ApplicationAuditLogEntryFragment = { readonly __typename?: 'ApplicationAuditLogNode', readonly id: string, readonly eventType: ResidentialManagementApplicationAuditLogEventTypeChoices, readonly metadata: string, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type ApplicationFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly createdAt: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly townOrCity?: string | null, readonly region?: string | null, readonly postcode: string, readonly ownershipType?: ResidentialManagementApplicationOwnershipTypeChoices | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly lastRejectionReason?: string | null, readonly approvedAt?: string | null, readonly archivedAt?: string | null, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email?: string | null, readonly mobile?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string, readonly address: string } | null, readonly thread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null, readonly applicationAttempts: { readonly __typename?: 'ApplicationAttemptNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationAttemptNodeEdge', readonly node?: { readonly __typename?: 'ApplicationAttemptNode', readonly id: string, readonly createdAt: string, readonly proofOfAddress?: string | null, readonly rejectionReason?: string | null, readonly rejectedOn?: string | null, readonly reviewer?: { readonly __typename?: 'ManagerType', readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null } } | null } | null } | null> } };

export type ApplicationThreadByApplicationQueryVariables = Exact<{
  applicationId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  mediaAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type ApplicationThreadByApplicationQuery = { readonly __typename?: 'DebugSchema', readonly applicationThreadByApplication?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly createdAt: string, readonly closedAt?: string | null, readonly messages: { readonly __typename?: 'ApplicationThreadMessageNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationThreadMessageNodeEdge', readonly node?: { readonly __typename?: 'ApplicationThreadMessageNode', readonly id: string, readonly body: string, readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices, readonly createdAt: string, readonly readAt?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> }, readonly media: { readonly __typename?: 'ApplicationThreadMediaNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationThreadMediaNodeEdge', readonly node?: { readonly __typename?: 'ApplicationThreadMediaNode', readonly id: string, readonly file: string, readonly sender: ResidentialManagementApplicationThreadMediaSenderChoices, readonly createdAt: string, readonly readAt?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null };

export type ApplicationThreadMediaFragment = { readonly __typename?: 'ApplicationThreadMediaNode', readonly id: string, readonly file: string, readonly sender: ResidentialManagementApplicationThreadMediaSenderChoices, readonly createdAt: string, readonly readAt?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } };

export type ApplicationThreadMessageFragment = { readonly __typename?: 'ApplicationThreadMessageNode', readonly id: string, readonly body: string, readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices, readonly createdAt: string, readonly readAt?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } };

export type ArchiveApplicationMutationVariables = Exact<{
  input: ArchiveApplicationInput;
}>;


export type ArchiveApplicationMutation = { readonly __typename?: 'Mutation', readonly archiveApplication?: { readonly __typename?: 'ArchiveApplicationPayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null } | null } | null };

export type CreateApplicationThreadMutationVariables = Exact<{
  input: CreateApplicationThreadMutationInput;
}>;


export type CreateApplicationThreadMutation = { readonly __typename?: 'Mutation', readonly createApplicationThread?: { readonly __typename?: 'CreateApplicationThreadMutationPayload', readonly applicationThread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly createdAt: string, readonly messages: { readonly __typename?: 'ApplicationThreadMessageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationThreadMessageNodeEdge', readonly node?: { readonly __typename?: 'ApplicationThreadMessageNode', readonly id: string, readonly body: string, readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices, readonly createdAt: string } | null } | null> } } | null } | null };

export type MarkApplicationThreadAsReadMutationVariables = Exact<{
  input: MarkApplicationThreadAsReadInput;
}>;


export type MarkApplicationThreadAsReadMutation = { readonly __typename?: 'Mutation', readonly markApplicationThreadAsRead?: { readonly __typename?: 'MarkApplicationThreadAsReadPayload', readonly applicationThread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SendApplicationThreadMessageMutationVariables = Exact<{
  input: SendApplicationThreadMessageInput;
}>;


export type SendApplicationThreadMessageMutation = { readonly __typename?: 'Mutation', readonly sendApplicationThreadMessage?: { readonly __typename?: 'SendApplicationThreadMessagePayload', readonly applicationThreadMessage?: { readonly __typename?: 'ApplicationThreadMessageNode', readonly id: string, readonly body: string, readonly sender: ResidentialManagementApplicationThreadMessageSenderChoices, readonly createdAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UnarchiveApplicationMutationVariables = Exact<{
  input: UnarchiveApplicationInput;
}>;


export type UnarchiveApplicationMutation = { readonly __typename?: 'Mutation', readonly unarchiveApplication?: { readonly __typename?: 'UnarchiveApplicationPayload', readonly application?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null } | null } | null };

export type AppointmentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type AppointmentsQuery = { readonly __typename?: 'DebugSchema', readonly amenities?: { readonly __typename?: 'AmenityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityNodeEdge', readonly node?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly startTime: string, readonly endTime: string, readonly daysAvailable: ReadonlyArray<string>, readonly image?: string | null, readonly status: AmenityStatusEnum, readonly type?: ResidentialManagementAmenityTypeChoices | null, readonly description: string, readonly todaysBookingCount: number, readonly maxReservations?: number | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly operatingTimes: { readonly __typename?: 'AmenityOperatingTimesNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityOperatingTimesNodeEdge', readonly node?: { readonly __typename?: 'AmenityOperatingTimesNode', readonly id: string, readonly weekDay: number, readonly startTime?: string | null, readonly endTime?: string | null, readonly isActivated: boolean } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type CreateBlocksMutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  blockNames: ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type CreateBlocksMutation = { readonly __typename?: 'Mutation', readonly createBlocks?: { readonly __typename?: 'CreateBlocks', readonly blocks?: ReadonlyArray<{ readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null> | null } | null };

export type BlockItemFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly createdAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type BlockListItemFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly imageUrl?: string | null, readonly isDefault: boolean, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly everyoneCount?: number | null, readonly residentsCount?: number | null, readonly leaseholdersCount?: number | null, readonly status: BlockStatus, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type BlockListQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockListQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly imageUrl?: string | null, readonly isDefault: boolean, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly everyoneCount?: number | null, readonly residentsCount?: number | null, readonly leaseholdersCount?: number | null, readonly status: BlockStatus, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type BlocksQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BlocksQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly createdAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type ConfirmBlockSetupMutationVariables = Exact<{
  communityId: Scalars['ID']['input'];
  runId: Scalars['ID']['input'];
}>;


export type ConfirmBlockSetupMutation = { readonly __typename?: 'Mutation', readonly confirmBlockSetup?: { readonly __typename?: 'ConfirmBlockSetup', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly pendingBlockSetup?: { readonly __typename?: 'BlockSetupSummaryType', readonly runId: string, readonly appliedAt: string, readonly blocksCreated: number, readonly homesPlaced: number, readonly unconfirmedCount: number } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type PendingBlockSetupCommunityFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly pendingBlockSetup?: { readonly __typename?: 'BlockSetupSummaryType', readonly runId: string, readonly appliedAt: string, readonly blocksCreated: number, readonly homesPlaced: number, readonly unconfirmedCount: number } | null };

export type PendingBlockSetupsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type PendingBlockSetupsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly pendingBlockSetup?: { readonly __typename?: 'BlockSetupSummaryType', readonly runId: string, readonly appliedAt: string, readonly blocksCreated: number, readonly homesPlaced: number, readonly unconfirmedCount: number } | null } | null } | null> } | null };

export type BlockDetailFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null };

export type BlockQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockQuery = { readonly __typename?: 'DebugSchema', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null };

export type BlockAssignSourcesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockAssignSourcesQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly homesCount?: number | null } | null } | null> } | null };

export type BlockHomeAddressFragment = { readonly __typename?: 'HomeNode', readonly name: string, readonly addressLine1?: string | null, readonly postcode: string };

export type BlockHomeRowFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly floorNumber?: number | null, readonly occupantCount: number, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null };

export type BlockHomesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly floorNumber?: number | null, readonly occupantCount: number, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null } | null } | null> } | null };

export type DeleteBlockMutationVariables = Exact<{
  input: DeleteBlockInput;
}>;


export type DeleteBlockMutation = { readonly __typename?: 'Mutation', readonly deleteBlock?: { readonly __typename?: 'DeleteBlockPayload', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type BlockDocumentsQueryVariables = Exact<{
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockDocumentsQuery = { readonly __typename?: 'DebugSchema', readonly documents?: { readonly __typename?: 'DocumentNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'DocumentNodeEdge', readonly node?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string, readonly createdAt: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'UserDocumentNode' } | null } | null } | null> } | null };

export type BlockGroupCardFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly type: ResidentialManagementCommunityGroupTypeChoices, readonly description?: string | null, readonly defaultDescription?: string | null, readonly numUsers?: number | null, readonly pinnedHomes: ReadonlyArray<{ readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null }> };

export type BlockGroupsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockGroupsQuery = { readonly __typename?: 'DebugSchema', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly groups: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly type: ResidentialManagementCommunityGroupTypeChoices, readonly description?: string | null, readonly defaultDescription?: string | null, readonly numUsers?: number | null, readonly pinnedHomes: ReadonlyArray<{ readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null }> }> } | null };

export type BlockPinHomesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockPinHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null } | null } | null> } | null };

export type CommunityWideGroupsQueryVariables = Exact<{
  community: Scalars['UUID']['input'];
}>;


export type CommunityWideGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null };

export type SyncBlockGroupsMutationVariables = Exact<{
  input: SyncBlockGroupsInput;
}>;


export type SyncBlockGroupsMutation = { readonly __typename?: 'Mutation', readonly syncBlockGroups?: { readonly __typename?: 'SyncBlockGroupsPayload', readonly results: ReadonlyArray<{ readonly __typename?: 'BlockGroupSyncResultNode', readonly membersAdded: number, readonly membersRemoved: number, readonly group: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly type: ResidentialManagementCommunityGroupTypeChoices, readonly description?: string | null, readonly defaultDescription?: string | null, readonly numUsers?: number | null, readonly pinnedHomes: ReadonlyArray<{ readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null }> } }> } | null };

export type UpdateBlockGroupPinnedHomesMutationVariables = Exact<{
  input: UpdateBlockGroupPinnedHomesInput;
}>;


export type UpdateBlockGroupPinnedHomesMutation = { readonly __typename?: 'Mutation', readonly updateBlockGroupPinnedHomes?: { readonly __typename?: 'UpdateBlockGroupPinnedHomesPayload', readonly group?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly type: ResidentialManagementCommunityGroupTypeChoices, readonly description?: string | null, readonly defaultDescription?: string | null, readonly numUsers?: number | null, readonly pinnedHomes: ReadonlyArray<{ readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean } | null }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type BlockPlacementRowFragment = { readonly __typename?: 'BlockPlacementType', readonly id: string, readonly method: BlockPlacementMethod, readonly placedAt: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string } };

export type BlockPlacementsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockPlacementsQuery = { readonly __typename?: 'DebugSchema', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly unconfirmedPlacements: ReadonlyArray<{ readonly __typename?: 'BlockPlacementType', readonly id: string, readonly method: BlockPlacementMethod, readonly placedAt: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string } }> } | null };

export type ConfirmBlockPlacementsMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
}>;


export type ConfirmBlockPlacementsMutation = { readonly __typename?: 'Mutation', readonly confirmBlockPlacements?: { readonly __typename?: 'ConfirmBlockPlacements', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null } | null };

export type RemoveBlockPlacementsMutationVariables = Exact<{
  blockId: Scalars['ID']['input'];
  homeIds: ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type RemoveBlockPlacementsMutation = { readonly __typename?: 'Mutation', readonly removeBlockPlacements?: { readonly __typename?: 'RemoveBlockPlacements', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateBlockMutationVariables = Exact<{
  input: UpdateBlockInput;
}>;


export type UpdateBlockMutation = { readonly __typename?: 'Mutation', readonly updateBlock?: { readonly __typename?: 'UpdateBlockPayload', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateBlockHomesMutationVariables = Exact<{
  input: UpdateBlockHomesInput;
}>;


export type UpdateBlockHomesMutation = { readonly __typename?: 'Mutation', readonly updateBlockHomes?: { readonly __typename?: 'UpdateBlockHomesPayload', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly isDefault: boolean, readonly imageUrl?: string | null, readonly homesCount?: number | null, readonly unassignedHomesCount: number, readonly status: BlockStatus, readonly deleteRefusal?: string | null, readonly unconfirmedHomesCount: number, readonly isNewUnconfirmed: boolean, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } }, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateCommunityGroupDescriptionMutationVariables = Exact<{
  input: UpdateGroupDescriptionInput;
}>;


export type UpdateCommunityGroupDescriptionMutation = { readonly __typename?: 'Mutation', readonly updateGroupDescription?: { readonly __typename?: 'UpdateGroupDescriptionPayload', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly description?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type BlockGroupRefsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockGroupRefsQuery = { readonly __typename?: 'DebugSchema', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly groups: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null }> } | null };

export type BlockUpdatesQueryVariables = Exact<{
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlockUpdatesQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdates?: { readonly __typename?: 'CommunityUpdateNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly status: CommunityUpdateStatusEnum, readonly publishedAt?: string | null, readonly groups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type CommunityOpenPeriodFragment = { readonly __typename?: 'CommunityOpenPeriodNode', readonly id: string, readonly start: string, readonly end: string, readonly weekdayIndex: number };

export type CommunitySettingsDialogQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunitySettingsDialogQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly status: string, readonly deactivatedOn?: string | null, readonly avatar?: string | null, readonly commentsEnabled: boolean, readonly communityChatEnabled: boolean, readonly marketplaceEnabled: boolean, readonly paymentsEnabled: boolean, readonly officeHoursEnabled: boolean, readonly outOfOfficeMessage?: string | null, readonly openPeriods?: ReadonlyArray<{ readonly __typename?: 'CommunityOpenPeriodNode', readonly id: string, readonly start: string, readonly end: string, readonly weekdayIndex: number }> | null } | null };

export type UpdateCommunitySettingsMutationVariables = Exact<{
  input: UpdateCommunitySettingsInput;
}>;


export type UpdateCommunitySettingsMutation = { readonly __typename?: 'Mutation', readonly updateCommunitySettings?: { readonly __typename?: 'UpdateCommunitySettingsPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type TeamMemberItemFragment = { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly isManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null, readonly isCommunityManager?: boolean | null };

export type CommunityTeamQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityTeamQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTeamNodeEdge', readonly node?: { readonly __typename?: 'CommunityTeamNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly isManager?: boolean | null, readonly isAdmin?: boolean | null, readonly isConcierge?: boolean | null, readonly isCommunityManager?: boolean | null } | null } | null> } | null } | null };

export type CommunitiesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isManager?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null, readonly avatar?: string | null, readonly homeCount: number, readonly residentCount: number, readonly engagementScore?: string | null, readonly openConversationsCount?: number | null, readonly status: string, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null } | null> } | null };

export type CommunityDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  uuid: Scalars['UUID']['input'];
}>;


export type CommunityDetailsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null, readonly requisiteDate?: string | null, readonly engagementScore?: string | null, readonly openConversationsCount?: number | null, readonly satisfactionScore?: number | null, readonly homeCount: number, readonly residentCount: number, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null, readonly communityGroups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number }, readonly communityEvents: { readonly __typename?: 'CommunityEventNodeConnection', readonly totalCount: number }, readonly team?: { readonly __typename?: 'CommunityTeamNodeConnection', readonly totalCount: number } | null } | null, readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number } | null, readonly communityUpdates?: { readonly __typename?: 'CommunityUpdateNodeConnection', readonly totalCount: number } | null, readonly communityDocuments?: { readonly __typename?: 'CommunityDocumentNodeConnection', readonly totalCount: number } | null, readonly amenities?: { readonly __typename?: 'AmenityNodeConnection', readonly totalCount: number } | null, readonly surveys?: { readonly __typename?: 'ResidentSurveyNodeConnection', readonly totalCount: number } | null, readonly applications?: { readonly __typename?: 'ApplicationNodeConnection', readonly totalCount: number } | null, readonly communityProducts?: { readonly __typename?: 'CommunityProductNodeConnection', readonly totalCount: number } | null, readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number } | null, readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number } | null, readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number } | null };

export type CommunityHeaderQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityHeaderQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly avatar?: string | null, readonly name: string, readonly status: string, readonly postcode?: string | null } | null };

export type CommunityNameQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityNameQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null } | null };

export type CommunitySettingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunitySettingsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly newsfeed: boolean, readonly messages: boolean, readonly surveys: boolean, readonly documents: boolean, readonly events: boolean, readonly facilities: boolean, readonly marketplace: boolean, readonly accounts: boolean, readonly products: boolean } } | null };

export type CommunityStatsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityStatsQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly engagementScore?: string | null, readonly satisfactionScore?: number | null, readonly engagementScoreDifference?: number | null, readonly downloadRateDifference?: number | null, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null };

export type CreateCommunityProductMutationVariables = Exact<{
  input: CreateCommunityProductInput;
}>;


export type CreateCommunityProductMutation = { readonly __typename?: 'Mutation', readonly createCommunityProduct?: { readonly __typename?: 'CreateCommunityProductPayload', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteCommunityProductMutationVariables = Exact<{
  input: DeleteCommunityProductInput;
}>;


export type DeleteCommunityProductMutation = { readonly __typename?: 'Mutation', readonly deleteCommunityProduct?: { readonly __typename?: 'DeleteCommunityProductPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityProductFragment = { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } };

export type CommunityProductsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityProductsQuery = { readonly __typename?: 'DebugSchema', readonly communityProducts?: { readonly __typename?: 'CommunityProductNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityProductNodeEdge', readonly node?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null> } | null };

export type FindCommunityProductDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindCommunityProductDetailsQuery = { readonly __typename?: 'DebugSchema', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null };

export type FindCommunityProductPurchasesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type FindCommunityProductPurchasesQuery = { readonly __typename?: 'DebugSchema', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly purchases: { readonly __typename?: 'CommunityProductPurchaseNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityProductPurchaseNodeEdge', readonly node?: { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string, readonly createdAt: string, readonly address?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null } | null } | null> } } | null };

export type UpdateCommunityProductMutationVariables = Exact<{
  input: UpdateCommunityProductInput;
}>;


export type UpdateCommunityProductMutation = { readonly __typename?: 'Mutation', readonly updateCommunityProduct?: { readonly __typename?: 'UpdateCommunityProductPayload', readonly communityProduct?: { readonly __typename?: 'CommunityProductNode', readonly id: string, readonly name: string, readonly description: string, readonly active: boolean, readonly price?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ComplianceBlockItemFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly missingComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly checkedComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly totalComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number } };

export type ComplianceBlocksQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ComplianceBlocksQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly missingComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiredComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly expiringComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly checkedComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number }, readonly totalComplianceCount: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number } } | null } | null> } | null };

export type CreateBlocksComplianceRequirementMutationVariables = Exact<{
  input: CreateBlocksComplianceRequirementInput;
}>;


export type CreateBlocksComplianceRequirementMutation = { readonly __typename?: 'Mutation', readonly createBlocksComplianceRequirement?: { readonly __typename?: 'CreateBlocksComplianceRequirementPayload', readonly blocksComplianceRequirement?: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly blocks: { readonly __typename?: 'BlockNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string } | null } | null> } } | null } | null };

export type BlockComplianceRequirementFragment = { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null };

export type BlockComplianceRequirementsQueryVariables = Exact<{
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BlockComplianceRequirementsQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirements?: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null } | null> } | null };

export type CreateBlockComplianceRequirementItemMutationVariables = Exact<{
  input: CreateBlockComplianceRequirementItemInput;
}>;


export type CreateBlockComplianceRequirementItemMutation = { readonly __typename?: 'Mutation', readonly createBlockComplianceRequirementItem?: { readonly __typename?: 'CreateBlockComplianceRequirementItemPayload', readonly blockComplianceRequirementItem?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly blockComplianceRequirements: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null } | null> } } | null } | null };

export type RequirementItemBlocksQueryVariables = Exact<{
  requirementId: Scalars['UUID']['input'];
}>;


export type RequirementItemBlocksQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirement?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly blockComplianceRequirements: { readonly __typename?: 'BlockComplianceRequirementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } } | null } | null> } } } | null };

export type BlockComplianceRequirementQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BlockComplianceRequirementQuery = { readonly __typename?: 'DebugSchema', readonly blockComplianceRequirement?: { readonly __typename?: 'BlockComplianceRequirementNode', readonly id: string, readonly status: BlockComplianceRequirementStatus, readonly block: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } }, readonly requirement: { readonly __typename?: 'BlocksComplianceRequirementNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly shared: boolean }, readonly item?: { readonly __typename?: 'BlockComplianceRequirementItemNode', readonly id: string, readonly expiryDate: string, readonly createdAt: string, readonly attachments: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockComplianceRequirementItemAttachmentNodeEdge', readonly node?: { readonly __typename?: 'BlockComplianceRequirementItemAttachmentNode', readonly id: string, readonly file?: string | null, readonly url?: string | null, readonly createdAt: string } | null } | null> } } | null } | null };

export type ContactBasicInfoQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContactBasicInfoQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly email: string, readonly name?: string | null } | null };

export type ContactDownloadCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ContactDownloadCountsQuery = { readonly __typename?: 'DebugSchema', readonly downloaded?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number } | null, readonly notDownloaded?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number } | null };

export type ContactPageListItemFragment = { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly lastAppUse?: string | null, readonly communities?: ReadonlyArray<{ readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null> | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null } | null } | null> } } | null };

export type ContactsListItemFieldsFragment = { readonly __typename?: 'ContactNode', readonly firstName: string, readonly lastName: string, readonly id: string, readonly name?: string | null, readonly email: string, readonly lastAppUse?: string | null, readonly communities?: ReadonlyArray<{ readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null> | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null } | null } | null> } } | null };

export type ListContactProfilesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  userType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListContactProfilesQuery = { readonly __typename?: 'DebugSchema', readonly contacts?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly firstName: string, readonly lastName: string, readonly id: string, readonly name?: string | null, readonly email: string, readonly lastAppUse?: string | null, readonly communities?: ReadonlyArray<{ readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null> | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null } | null } | null> } } | null } | null } | null> } | null };

export type ContactAmenityReservationFragment = { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly type?: ResidentialManagementAmenityTypeChoices | null } | null };

export type ContactAmenityBookingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ContactAmenityBookingsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly amenityReservations: { readonly __typename?: 'AmenityReservationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AmenityReservationNodeEdge', readonly node?: { readonly __typename?: 'AmenityReservationNode', readonly id: string, readonly start: string, readonly end: string, readonly cancellationMessage?: string | null, readonly amenity?: { readonly __typename?: 'AmenityNode', readonly id: string, readonly name: string, readonly type?: ResidentialManagementAmenityTypeChoices | null } | null } | null } | null> } } | null };

export type ContactEventBookingsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  eventEndDateAfter?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ContactEventBookingsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly eventParties?: { readonly __typename?: 'CommunityEventPartyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityEventPartyNodeEdge', readonly node?: { readonly __typename?: 'CommunityEventPartyNode', readonly id: string, readonly additionalAttendance: number, readonly event?: { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly name: string, readonly start: string, readonly end: string } | null } | null } | null> } | null } | null };

export type ContactConversationsQueryVariables = Exact<{
  contact: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ContactConversationsQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly createdAt: string } | null } | null } | null> } | null };

export type ContactApplicationItemFragment = { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null };

export type ContactNoteItemFragment = { readonly __typename?: 'ContactNoteNode', readonly id: string, readonly text: string, readonly createdAt: string, readonly author: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type ArchiveContactNoteMutationVariables = Exact<{
  input: ArchiveContactNoteInput;
}>;


export type ArchiveContactNoteMutation = { readonly __typename?: 'Mutation', readonly archiveContactNote?: { readonly __typename?: 'ArchiveContactNotePayload', readonly contactNote?: { readonly __typename?: 'ContactNoteNode', readonly id: string } | null } | null };

export type SaveContactNoteMutationVariables = Exact<{
  input: SaveContactNoteInput;
}>;


export type SaveContactNoteMutation = { readonly __typename?: 'Mutation', readonly saveContactNote?: { readonly __typename?: 'SaveContactNotePayload', readonly contactNote?: { readonly __typename?: 'ContactNoteNode', readonly id: string, readonly text: string, readonly createdAt: string, readonly author: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null };

export type ContactProfileHeaderDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContactProfileHeaderDetailsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly name?: string | null, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly createdAt: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly addressLine2?: string | null, readonly approvedAt?: string | null, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null } | null } | null> } } | null, readonly contactNotes: { readonly __typename?: 'ContactNoteNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNoteNodeEdge', readonly node?: { readonly __typename?: 'ContactNoteNode', readonly id: string, readonly text: string, readonly createdAt: string, readonly author: { readonly __typename?: 'UserType', readonly id: string, readonly name: string }, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> }, readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly isAutomatic: boolean, readonly isSystemManaged: boolean, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null } | null> } | null } | null };

export type UpdateContactGroupsMutationVariables = Exact<{
  input: UpdateContactGroupsInput;
}>;


export type UpdateContactGroupsMutation = { readonly __typename?: 'Mutation', readonly updateContactGroups?: { readonly __typename?: 'UpdateContactGroupsPayload', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string } | null } | null };

export type ContactFormItemFragment = { readonly __typename?: 'CommunityFormNode', readonly id: string, readonly title?: string | null, readonly responses?: { readonly __typename?: 'TypeformResponseConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformResponseEdge', readonly node?: { readonly __typename?: 'TypeformResponseType', readonly id?: string | null, readonly submittedAt?: string | null, readonly answers?: string | null, readonly hidden?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string } | null } | null } | null> } | null, readonly questions?: { readonly __typename?: 'TypeformQuestionConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformQuestionEdge', readonly node?: { readonly __typename?: 'TypeformQuestionType', readonly id?: string | null, readonly ref?: string | null, readonly title?: string | null, readonly type?: string | null, readonly properties?: string | null } | null } | null> } | null };

export type ContactFormsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContactFormsQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly waivers: { readonly __typename?: 'WaiverNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'WaiverNodeEdge', readonly node?: { readonly __typename?: 'WaiverNode', readonly id: string, readonly type: ResidentialManagementWaiverTypeChoices, readonly createdAt: string } | null } | null> }, readonly forms?: ReadonlyArray<{ readonly __typename?: 'CommunityFormNode', readonly id: string, readonly title?: string | null, readonly responses?: { readonly __typename?: 'TypeformResponseConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformResponseEdge', readonly node?: { readonly __typename?: 'TypeformResponseType', readonly id?: string | null, readonly submittedAt?: string | null, readonly answers?: string | null, readonly hidden?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string } | null } | null } | null> } | null, readonly questions?: { readonly __typename?: 'TypeformQuestionConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformQuestionEdge', readonly node?: { readonly __typename?: 'TypeformQuestionType', readonly id?: string | null, readonly ref?: string | null, readonly title?: string | null, readonly type?: string | null, readonly properties?: string | null } | null } | null> } | null } | null> | null } | null };

export type ContactPackagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContactPackagesQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly packages: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly lastAction: string, readonly location?: string | null, readonly pickupLocation?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly postcode: string } | null } | null } | null> } } | null };

export type ContactPackagesReminderMutationVariables = Exact<{
  input: ContactPackagesReminderInput;
}>;


export type ContactPackagesReminderMutation = { readonly __typename?: 'Mutation', readonly contactPackagesReminder?: { readonly __typename?: 'ContactPackagesReminderPayload', readonly ok?: boolean | null } | null };

export type ContactSafetyRecordItemFragment = { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly lastReviewedAt?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean, readonly surveyReviewIntervalMonths: number } } | null } } };

export type ContactSafetyRecordsQueryVariables = Exact<{
  contactId: Scalars['UUID']['input'];
}>;


export type ContactSafetyRecordsQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecords?: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly lastReviewedAt?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean, readonly surveyReviewIntervalMonths: number } } | null } } } | null } | null> } | null };

export type ResidentItemFragment = { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } };

export type ClientContractorCompanyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ClientContractorCompanyQuery = { readonly __typename?: 'DebugSchema', readonly clientContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly companyType?: ResidentialManagementClientContractorCompanyCompanyTypeChoices | null, readonly email?: string | null, readonly phone?: string | null, readonly address?: string | null, readonly website?: string | null, readonly notes?: string | null, readonly isActive: boolean, readonly contractorCount?: number | null, readonly createdAt: string, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null };

export type CreateClientContractorCompanyMutationVariables = Exact<{
  input: CreateClientContractorCompanyInput;
}>;


export type CreateClientContractorCompanyMutation = { readonly __typename?: 'Mutation', readonly createClientContractorCompany?: { readonly __typename?: 'CreateClientContractorCompanyPayload', readonly clientContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly companyType?: ResidentialManagementClientContractorCompanyCompanyTypeChoices | null, readonly email?: string | null, readonly phone?: string | null, readonly address?: string | null, readonly website?: string | null, readonly notes?: string | null, readonly isActive: boolean, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> }, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateContractorMutationVariables = Exact<{
  input: CreateContractorInput;
}>;


export type CreateContractorMutation = { readonly __typename?: 'Mutation', readonly createContractor?: { readonly __typename?: 'CreateContractorPayload', readonly clientContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SearchContractorCompaniesQueryVariables = Exact<{
  search: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchContractorCompaniesQuery = { readonly __typename?: 'DebugSchema', readonly clientContractorCompanies?: { readonly __typename?: 'ClientContractorCompanyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientContractorCompanyNodeEdge', readonly node?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null> } | null };

export type UpdateClientContractorCompanyMutationVariables = Exact<{
  input: UpdateClientContractorCompanyInput;
}>;


export type UpdateClientContractorCompanyMutation = { readonly __typename?: 'Mutation', readonly updateClientContractorCompany?: { readonly __typename?: 'UpdateClientContractorCompanyPayload', readonly clientContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly companyType?: ResidentialManagementClientContractorCompanyCompanyTypeChoices | null, readonly email?: string | null, readonly phone?: string | null, readonly address?: string | null, readonly website?: string | null, readonly notes?: string | null, readonly isActive: boolean } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateClientContractorCompanyCommunitiesMutationVariables = Exact<{
  input: UpdateClientContractorCompanyCommunitiesInput;
}>;


export type UpdateClientContractorCompanyCommunitiesMutation = { readonly __typename?: 'Mutation', readonly updateClientContractorCompanyCommunities?: { readonly __typename?: 'UpdateClientContractorCompanyCommunitiesPayload', readonly clientContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateContractorMutationVariables = Exact<{
  input: UpdateContractorInput;
}>;


export type UpdateContractorMutation = { readonly __typename?: 'Mutation', readonly updateContractor?: { readonly __typename?: 'UpdateContractorPayload', readonly contractor?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ContractorCompanyItemFragment = { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly companyType?: ResidentialManagementClientContractorCompanyCompanyTypeChoices | null, readonly email?: string | null, readonly phone?: string | null, readonly address?: string | null, readonly website?: string | null, readonly notes?: string | null, readonly isActive: boolean, readonly contractorCount?: number | null, readonly createdAt: string, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } };

export type ClientContractorCompaniesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClientContractorCompaniesQuery = { readonly __typename?: 'DebugSchema', readonly clientContractorCompanies?: { readonly __typename?: 'ClientContractorCompanyNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientContractorCompanyNodeEdge', readonly node?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly companyType?: ResidentialManagementClientContractorCompanyCompanyTypeChoices | null, readonly email?: string | null, readonly phone?: string | null, readonly address?: string | null, readonly website?: string | null, readonly notes?: string | null, readonly isActive: boolean, readonly contractorCount?: number | null, readonly createdAt: string, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null } | null> } | null };

export type CommunityStatusQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityStatusQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly status: string } | null };

export type AssigneeFragment = { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null, readonly email: string };

export type ConversationListItemLightFragment = { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly isResidentWaiting: boolean, readonly lastActivityAt?: string | null, readonly contractorSuggestion?: { readonly __typename?: 'ContractorSuggestionType', readonly id: string, readonly isContractorDecision?: ContractorDecision | null, readonly contractorHasCompany: boolean } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null, readonly email: string } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null };

export type ListConversationsLightQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isUrgent?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Date']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  contactId?: InputMaybe<Scalars['UUID']['input']>;
  clientId?: InputMaybe<Scalars['UUID']['input']>;
  residencyId?: InputMaybe<Scalars['UUID']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  unanswered?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListConversationsLightQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly snoozedUntil?: string | null, readonly closedAt?: string | null, readonly hasUnread: boolean, readonly isResidentWaiting: boolean, readonly lastActivityAt?: string | null, readonly contractorSuggestion?: { readonly __typename?: 'ContractorSuggestionType', readonly id: string, readonly isContractorDecision?: ContractorDecision | null, readonly contractorHasCompany: boolean } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string, readonly type?: string | null } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string, readonly mediaSender: ResidentialManagementConversationMediaSenderChoices } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly createdAt: string, readonly messageSender: ResidentialManagementConversationMessageSenderChoices } | null, readonly assignment?: { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly assignedTo: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null, readonly email: string } } | null, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null> } | null };

export type ListHomesToMessageQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListHomesToMessageQuery = { readonly __typename?: 'DebugSchema', readonly listHomes?: ReadonlyArray<{ readonly __typename?: 'HomeType', readonly id: string, readonly name: string }> | null };

export type UpdateConversationNoteMutationVariables = Exact<{
  input: UpdateConversationNoteInput;
}>;


export type UpdateConversationNoteMutation = { readonly __typename?: 'Mutation', readonly updateConversationNote?: { readonly __typename?: 'UpdateConversationNotePayload', readonly conversationNote?: { readonly __typename?: 'ConversationNoteNode', readonly id: string, readonly text: string, readonly updatedAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null };

export type AssignTeamMutationVariables = Exact<{
  input: AssignTeamInput;
}>;


export type AssignTeamMutation = { readonly __typename?: 'Mutation', readonly assignTeam?: { readonly __typename?: 'AssignTeamPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null } | null } | null };

export type TeamsForAssignmentQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TeamsForAssignmentQuery = { readonly __typename?: 'DebugSchema', readonly teams?: { readonly __typename?: 'TeamNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TeamNodeEdge', readonly node?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | null } | null> } | null };

export type UnassignTeamMutationVariables = Exact<{
  input: UnassignTeamInput;
}>;


export type UnassignTeamMutation = { readonly __typename?: 'Mutation', readonly unassignTeam?: { readonly __typename?: 'UnassignTeamPayload', readonly conversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly teamAssignment?: { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly team: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } } | null } | null } | null };

export type BulkConversationActionJobQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type BulkConversationActionJobQuery = { readonly __typename?: 'DebugSchema', readonly bulkConversationActionJob?: { readonly __typename?: 'BulkConversationActionJobNode', readonly id: string, readonly status: ResidentialManagementBulkConversationActionJobStatusChoices, readonly total: number, readonly processed: number, readonly succeeded: number, readonly skipped: number, readonly failed: number, readonly startedAt?: string | null, readonly finishedAt?: string | null } | null };

export type InactiveOwedBreakdownQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  assignedTo?: InputMaybe<Scalars['String']['input']>;
  assignedUsers?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  teams?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  source?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  participantType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type InactiveOwedBreakdownQuery = { readonly __typename?: 'DebugSchema', readonly owed?: { readonly __typename?: 'ConversationNodeConnection', readonly totalCount: number } | null };

export type StartBulkConversationCloseMutationVariables = Exact<{
  conversationIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
  filters?: InputMaybe<BulkConversationCloseFilterInput>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  action?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  notify?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type StartBulkConversationCloseMutation = { readonly __typename?: 'Mutation', readonly startBulkConversationClose?: { readonly __typename?: 'StartBulkConversationClose', readonly job?: { readonly __typename?: 'BulkConversationActionJobNode', readonly id: string, readonly status: ResidentialManagementBulkConversationActionJobStatusChoices, readonly total: number, readonly processed: number, readonly succeeded: number, readonly skipped: number, readonly failed: number, readonly startedAt?: string | null, readonly finishedAt?: string | null } | null } | null };

export type NewContactConversationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  contact: Scalars['UUID']['input'];
}>;


export type NewContactConversationQuery = { readonly __typename?: 'DebugSchema', readonly contact?: { readonly __typename?: 'ContactNode', readonly id: string, readonly email: string, readonly name?: string | null } | null, readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ListResidenciesWithResidentsQueryVariables = Exact<{
  communityId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ListResidenciesWithResidentsQuery = { readonly __typename?: 'DebugSchema', readonly listResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly hasUsedApp: boolean } }> }> | null };

export type ActiveResidentCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type ActiveResidentCountQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly activeResidentCountDifference?: number | null, readonly activeResidentCount?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type ActiveResidentsHistoricalDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type ActiveResidentsHistoricalDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type AverageDownloadRateQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type AverageDownloadRateQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly downloadRateDifference?: number | null, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type AveragePackageCollectionTimeDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type AveragePackageCollectionTimeDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type DashboardPageQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type DashboardPageQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly openCount?: number | null, readonly averageResponseTime?: number | null, readonly responseTimeDifference?: number | null, readonly allTimeSatisfaction?: string | null } | null };

export type DeliveredPackagesCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type DeliveredPackagesCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type GetDownloadRatePerCommunityQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type GetDownloadRatePerCommunityQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly downloadRate?: { readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly value: number } | null } | null } | null> } | null };

export type FacilityBookingsCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type FacilityBookingsCountQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type IncomingMessagesCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type IncomingMessagesCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type IncomingMessagesHistoricalDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type IncomingMessagesHistoricalDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeyOutCountsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type KeyOutCountsQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly statisticDataPoints?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeysGraphDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type KeysGraphDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly keyInStats?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null, readonly keyOutStats?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type KeysOutLiveCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type KeysOutLiveCountQuery = { readonly __typename?: 'DebugSchema', readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number } | null };

export type PackagesGraphDataQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  fromDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type PackagesGraphDataQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly delivered?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null, readonly collected?: ReadonlyArray<{ readonly __typename?: 'CommunityStatisticDataPointNode', readonly id: string, readonly date: string, readonly value: number } | null> | null } | null } | null> } | null };

export type PackagesHeldCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type PackagesHeldCountQuery = { readonly __typename?: 'DebugSchema', readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number } | null };

export type VisitorsOnsiteCountQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type VisitorsOnsiteCountQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number } | null };

export type ResponseTimeDashboardQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  hasResponseTime?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ResponseTimeDashboardQuery = { readonly __typename?: 'DebugSchema', readonly conversations?: { readonly __typename?: 'ConversationNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ConversationNodeEdge', readonly node?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly responseTime?: number | null, readonly closedAt?: string | null, readonly snoozedUntil?: string | null, readonly hasUnread: boolean, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string } | null, readonly latestEvent?: { readonly __typename?: 'ConversationActionModelType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMediaType', readonly id: string, readonly createdAt: string } | { readonly __typename?: 'ConversationMessageType', readonly id: string, readonly body: string, readonly createdAt: string } | null } | null } | null> } | null };

export type GetAverageResponseTimeQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetAverageResponseTimeQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly responseTimeOverTime?: ReadonlyArray<{ readonly __typename?: 'ResponseTimeType', readonly date?: string | null, readonly averageResponseTime?: number | null } | null> | null } | null };

export type GetAverageSatisfactionScoresQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetAverageSatisfactionScoresQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly ratingsOverTime?: ReadonlyArray<{ readonly __typename?: 'AverageConversationRatingType', readonly date?: string | null, readonly averageRating?: number | null } | null> | null } | null };

export type GetDownloadRateQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type GetDownloadRateQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly downloadRateOverTime?: ReadonlyArray<{ readonly __typename?: 'DownloadRateType', readonly date?: string | null, readonly downloadRate?: number | null } | null> | null } | null };

export type ListDashboardResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListDashboardResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly averageScore?: number | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null }, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly city?: string | null } }> | null } | null } | null> } | null };

export type ListEngagementResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  downloaded?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListEngagementResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } } | null } | null> } | null };

export type ListEngagementScoresQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
}>;


export type ListEngagementScoresQuery = { readonly __typename?: 'DebugSchema', readonly dashboard?: { readonly __typename?: 'CommunityDashboardType', readonly listEngagementScores?: ReadonlyArray<{ readonly __typename?: 'CommunityEngagementScoreType', readonly score: string, readonly createdAt: string }> | null } | null };

export type ListSatisfactionScoreResidentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  withRating?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListSatisfactionScoreResidentsQuery = { readonly __typename?: 'DebugSchema', readonly residents?: { readonly __typename?: 'ResidentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentNodeEdge', readonly node?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null } }> | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly lastAppUse?: string | null } } | null } | null> } | null };

export type CommunityDocumentListItemFragment = { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null };

export type CreateCommunityDocumentReminderMutationVariables = Exact<{
  input: CreateCommunityDocumentReminderInput;
}>;


export type CreateCommunityDocumentReminderMutation = { readonly __typename?: 'Mutation', readonly createCommunityDocumentReminder?: { readonly __typename?: 'CreateCommunityDocumentReminderPayload', readonly communityDocumentReminder?: { readonly __typename?: 'CommunityDocumentReminderNode', readonly id: string, readonly document?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateCommunityDocumentMutationVariables = Exact<{
  input: CreateCommunityDocumentInput;
}>;


export type CreateCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly createCommunityDocument?: { readonly __typename?: 'CreateCommunityDocumentPayload', readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateResidencyDocumentMutationVariables = Exact<{
  input: CreateResidencyDocumentInput;
}>;


export type CreateResidencyDocumentMutation = { readonly __typename?: 'Mutation', readonly createResidencyDocument?: { readonly __typename?: 'CreateResidencyDocumentPayload', readonly residencyDocument?: { readonly __typename?: 'ResidencyDocumentNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateUserDocumentMutationVariables = Exact<{
  input: CreateUserDocumentInput;
}>;


export type CreateUserDocumentMutation = { readonly __typename?: 'Mutation', readonly createUserDocument?: { readonly __typename?: 'CreateUserDocumentPayload', readonly userDocument?: { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly title: string, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateCommunityDocumentMutationVariables = Exact<{
  input: UpdateCommunityDocumentInput;
}>;


export type UpdateCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly updateCommunityDocument?: { readonly __typename?: 'UpdateCommunityDocumentPayload', readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateResidencyDocumentMutationVariables = Exact<{
  input: UpdateResidencyDocumentInput;
}>;


export type UpdateResidencyDocumentMutation = { readonly __typename?: 'Mutation', readonly updateResidencyDocument?: { readonly __typename?: 'UpdateResidencyDocumentPayload', readonly residencyDocument?: { readonly __typename?: 'ResidencyDocumentNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateUserDocumentMutationVariables = Exact<{
  input: UpdateUserDocumentInput;
}>;


export type UpdateUserDocumentMutation = { readonly __typename?: 'Mutation', readonly updateUserDocument?: { readonly __typename?: 'UpdateUserDocumentPayload', readonly userDocument?: { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly title: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityDocumentFragment = { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly totalPotentialViewers: number, readonly archivedAt?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null, readonly archivedAt?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } };

export type CommunityDocumentRemindersQueryVariables = Exact<{
  documentId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type CommunityDocumentRemindersQuery = { readonly __typename?: 'DebugSchema', readonly communityDocumentReminders?: { readonly __typename?: 'CommunityDocumentReminderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentReminderNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentReminderNode', readonly id: string, readonly createdAt: string, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly document?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string } | null } | null } | null> } | null };

export type DocumentQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentQuery = { readonly __typename?: 'DebugSchema', readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly totalPotentialViewers: number, readonly archivedAt?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null, readonly archivedAt?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } }>, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'ResidencyDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly name: string }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'UserDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'UserDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null } | null } | null };

export type AssignClientTagToCommunityDocumentMutationVariables = Exact<{
  input: AssignClientTagToCommunityDocumentInput;
}>;


export type AssignClientTagToCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly assignClientTagToCommunityDocument?: { readonly __typename?: 'AssignClientTagToCommunityDocumentPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'TaskDefinitionNode' } | { readonly __typename?: 'UserDocumentNode' } | null, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string } } | null } | null };

export type AssignClientTagToUserDocumentMutationVariables = Exact<{
  input: AssignClientTagToUserDocumentInput;
}>;


export type AssignClientTagToUserDocumentMutation = { readonly __typename?: 'Mutation', readonly assignClientTagToUserDocument?: { readonly __typename?: 'AssignClientTagToUserDocumentPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'TaskDefinitionNode' } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string } } | null } | null };

export type DocumentClientTagsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DocumentClientTagsQuery = { readonly __typename?: 'DebugSchema', readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null };

export type UnassignClientTagFromCommunityDocumentMutationVariables = Exact<{
  input: UnassignClientTagFromCommunityDocumentInput;
}>;


export type UnassignClientTagFromCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly unassignClientTagFromCommunityDocument?: { readonly __typename?: 'UnassignClientTagFromCommunityDocumentPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string } | null } | null };

export type UnassignClientTagFromUserDocumentMutationVariables = Exact<{
  input: UnassignClientTagFromUserDocumentInput;
}>;


export type UnassignClientTagFromUserDocumentMutation = { readonly __typename?: 'Mutation', readonly unassignClientTagFromUserDocument?: { readonly __typename?: 'UnassignClientTagFromUserDocumentPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string } | null } | null };

export type ArchiveTagMutationVariables = Exact<{
  input: ArchiveTagInput;
}>;


export type ArchiveTagMutation = { readonly __typename?: 'Mutation', readonly archiveTag?: { readonly __typename?: 'ArchiveTagPayload', readonly tag?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null, readonly confidenceScore?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateCommunityDocumentTagMutationVariables = Exact<{
  input: CreateCommunityDocumentTagInput;
}>;


export type CreateCommunityDocumentTagMutation = { readonly __typename?: 'Mutation', readonly createCommunityDocumentTag?: { readonly __typename?: 'CreateCommunityDocumentTagPayload', readonly tag?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null, readonly confidenceScore?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateUserDocumentTagMutationVariables = Exact<{
  input: CreateUserDocumentTagInput;
}>;


export type CreateUserDocumentTagMutation = { readonly __typename?: 'Mutation', readonly createUserDocumentTag?: { readonly __typename?: 'CreateUserDocumentTagPayload', readonly tag?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly archivedAt?: string | null, readonly confidenceScore?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DocumentTagItemFragment = { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null };

export type DocumentTagsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DocumentTagsQuery = { readonly __typename?: 'DebugSchema', readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null };

export type ResidencyDocumentFragment = { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly startDate: string, readonly completionDate?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } }>, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidencyDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'ResidencyDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } };

export type ToggleArchivedAtCommunityDocumentMutationVariables = Exact<{
  input: ToggleArchivedAtCommunityDocumentInput;
}>;


export type ToggleArchivedAtCommunityDocumentMutation = { readonly __typename?: 'Mutation', readonly toggleArchivedAtCommunityDocument?: { readonly __typename?: 'ToggleArchivedAtCommunityDocumentPayload', readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UserDocumentFragment = { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly description?: string | null, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly name: string }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'UserDocumentViewNodeEdge', readonly node?: { readonly __typename?: 'UserDocumentViewNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null };

export type DocumentsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  home?: InputMaybe<Scalars['UUID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  tags?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  tags2?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type DocumentsQuery = { readonly __typename?: 'DebugSchema', readonly documents?: { readonly __typename?: 'DocumentNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'DocumentNodeEdge', readonly node?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly url?: string | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number } } | { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null } | null> } | null };

export type ResidencyDocumentListItemFragment = { readonly __typename?: 'ResidencyDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly url?: string | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly address: string } }, readonly views: { readonly __typename?: 'ResidencyDocumentViewNodeConnection', readonly totalCount: number } };

export type UserDocumentListItemFragment = { readonly __typename?: 'UserDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly url?: string | null, readonly activatedOn?: string | null, readonly users: ReadonlyArray<{ readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null }>, readonly views: { readonly __typename?: 'UserDocumentViewNodeConnection', readonly totalCount: number }, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null };

export type CommunityEventItemFragment = { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly maxAdditionalAttendees: number, readonly availableSpaces?: number | null, readonly links?: ReadonlyArray<string> | null, readonly archivedAt?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } };

export type CommunityEventQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  partiesAfter?: InputMaybe<Scalars['String']['input']>;
  usersAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityEventQuery = { readonly __typename?: 'DebugSchema', readonly communityEvent?: { readonly __typename?: 'CommunityEventNode', readonly description: string, readonly attendanceFee?: string | null, readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly maxAdditionalAttendees: number, readonly availableSpaces?: number | null, readonly links?: ReadonlyArray<string> | null, readonly archivedAt?: string | null, readonly guests?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly email: string } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null, readonly parties: { readonly __typename?: 'CommunityEventPartyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityEventPartyNodeEdge', readonly node?: { readonly __typename?: 'CommunityEventPartyNode', readonly id: string, readonly additionalAttendance: number, readonly users?: { readonly __typename?: 'ContactNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly residencies: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } }> } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null } | null> } } | null } | null } | null> } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } }, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null };

export type CommunityEventPartyUserFragment = { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly residencies: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } }> } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null } | null } | null> } } | null };

export type ArchiveCommunityEventMutationVariables = Exact<{
  input: ArchiveCommunityEventInput;
}>;


export type ArchiveCommunityEventMutation = { readonly __typename?: 'Mutation', readonly archiveCommunityEvent?: { readonly __typename?: 'ArchiveCommunityEventPayload', readonly communityEvent?: { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SaveCommunityEventMutationVariables = Exact<{
  input: SaveCommunityEventInput;
}>;


export type SaveCommunityEventMutation = { readonly __typename?: 'Mutation', readonly saveCommunityEvent?: { readonly __typename?: 'SaveCommunityEventPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityEventsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityEventsQuery = { readonly __typename?: 'DebugSchema', readonly communityEvents?: { readonly __typename?: 'CommunityEventNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityEventNodeEdge', readonly node?: { readonly __typename?: 'CommunityEventNode', readonly id: string, readonly name: string, readonly start: string, readonly end: string, readonly maxSpaces: number, readonly maxAdditionalAttendees: number, readonly availableSpaces?: number | null, readonly links?: ReadonlyArray<string> | null, readonly archivedAt?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type AcceptFeatureAnnouncementMutationVariables = Exact<{
  featureAnnouncementId: Scalars['UUID']['input'];
}>;


export type AcceptFeatureAnnouncementMutation = { readonly __typename?: 'Mutation', readonly acceptFeatureAnnouncement?: { readonly __typename?: 'AcceptFeatureAnnouncementPayload', readonly featureAnnouncementView?: { readonly __typename?: 'FeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly acceptedAt?: string | null, readonly dismissedAt?: string | null } | null } | null };

export type DismissFeatureAnnouncementMutationVariables = Exact<{
  featureAnnouncementId: Scalars['UUID']['input'];
}>;


export type DismissFeatureAnnouncementMutation = { readonly __typename?: 'Mutation', readonly dismissFeatureAnnouncement?: { readonly __typename?: 'DismissFeatureAnnouncementPayload', readonly featureAnnouncementView?: { readonly __typename?: 'FeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly acceptedAt?: string | null, readonly dismissedAt?: string | null } | null } | null };

export type GetFeatureAnnouncementBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetFeatureAnnouncementBySlugQuery = { readonly __typename?: 'DebugSchema', readonly featureAnnouncementBySlug?: { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly title: string, readonly slug: string, readonly subtitle: string, readonly body: string, readonly image?: string | null, readonly createdAt: string, readonly currentUserView?: { readonly __typename?: 'FeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly acceptedAt?: string | null, readonly dismissedAt?: string | null } | null, readonly stats: { readonly __typename?: 'FeatureAnnouncementStatsType', readonly viewCount: number, readonly acceptanceCount: number, readonly dismissalCount: number, readonly acceptanceRate: number } } | null };

export type ListFeatureAnnouncementsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFeatureAnnouncementsQuery = { readonly __typename?: 'DebugSchema', readonly featureAnnouncements?: { readonly __typename?: 'FeatureAnnouncementNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'FeatureAnnouncementNodeEdge', readonly node?: { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly title: string, readonly slug: string, readonly subtitle: string, readonly image?: string | null, readonly createdAt: string, readonly currentUserView?: { readonly __typename?: 'FeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly acceptedAt?: string | null, readonly dismissedAt?: string | null } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type ViewFeatureAnnouncementMutationVariables = Exact<{
  featureAnnouncementId: Scalars['UUID']['input'];
}>;


export type ViewFeatureAnnouncementMutation = { readonly __typename?: 'Mutation', readonly viewFeatureAnnouncement?: { readonly __typename?: 'ViewFeatureAnnouncementPayload', readonly featureAnnouncementView?: { readonly __typename?: 'FeatureAnnouncementViewNode', readonly id: string, readonly viewedAt?: string | null, readonly acceptedAt?: string | null, readonly dismissedAt?: string | null } | null } | null };

export type FormQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FormQuery = { readonly __typename?: 'DebugSchema', readonly communityForm?: { readonly __typename?: 'CommunityFormNode', readonly id: string, readonly externalId: string, readonly provider: ResidentialManagementCommunityFormProviderChoices, readonly activatedOn?: string | null, readonly deactivatedOn?: string | null, readonly title?: string | null, readonly questions?: { readonly __typename?: 'TypeformQuestionConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformQuestionEdge', readonly node?: { readonly __typename?: 'TypeformQuestionType', readonly id?: string | null, readonly ref?: string | null, readonly title?: string | null, readonly type?: string | null, readonly properties?: string | null } | null } | null> } | null, readonly responses?: { readonly __typename?: 'TypeformResponseConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformResponseEdge', readonly node?: { readonly __typename?: 'TypeformResponseType', readonly id?: string | null, readonly submittedAt?: string | null, readonly answers?: string | null, readonly hidden?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string } | null } | null } | null> } | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null };

export type FormItemFragment = { readonly __typename?: 'CommunityFormNode', readonly id: string, readonly externalId: string, readonly provider: ResidentialManagementCommunityFormProviderChoices, readonly activatedOn?: string | null, readonly deactivatedOn?: string | null, readonly title?: string | null, readonly responses?: { readonly __typename?: 'TypeformResponseConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformResponseEdge', readonly node?: { readonly __typename?: 'TypeformResponseType', readonly id?: string | null, readonly submittedAt?: string | null, readonly answers?: string | null, readonly hidden?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string } | null } | null } | null> } | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type FormsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type FormsQuery = { readonly __typename?: 'DebugSchema', readonly communityForms?: { readonly __typename?: 'CommunityFormNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityFormNodeEdge', readonly node?: { readonly __typename?: 'CommunityFormNode', readonly id: string, readonly externalId: string, readonly provider: ResidentialManagementCommunityFormProviderChoices, readonly activatedOn?: string | null, readonly deactivatedOn?: string | null, readonly title?: string | null, readonly responses?: { readonly __typename?: 'TypeformResponseConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TypeformResponseEdge', readonly node?: { readonly __typename?: 'TypeformResponseType', readonly id?: string | null, readonly submittedAt?: string | null, readonly answers?: string | null, readonly hidden?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly name: string } | null } | null } | null> } | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null } | null> } | null };

export type ActivateGroupMutationVariables = Exact<{
  input: ActivateGroupInput;
}>;


export type ActivateGroupMutation = { readonly __typename?: 'Mutation', readonly activateGroup?: { readonly __typename?: 'ActivateGroupPayload', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly deactivatedOn?: string | null } | null } | null };

export type CommunityGroupQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  homesAfter?: InputMaybe<Scalars['String']['input']>;
  contactsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityGroupQuery = { readonly __typename?: 'DebugSchema', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly isAutomatic: boolean, readonly isSystemManaged: boolean, readonly isCommunityManager?: boolean | null, readonly numUsers?: number | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } | null } | null> } | null, readonly users?: { readonly __typename?: 'ContactNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ContactNodeEdge', readonly node?: { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null } | null } | null> } | null } | null };

export type CommunityManagerCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type CommunityManagerCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null, readonly communityManager?: { readonly __typename?: 'CommunityManagerNode', readonly id: string, readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null } | null };

export type CreateGroupMutationVariables = Exact<{
  input: CreateGroupInput;
}>;


export type CreateGroupMutation = { readonly __typename?: 'Mutation', readonly createGroup?: { readonly __typename?: 'CreateGroupPayload', readonly id?: string | null, readonly name?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeactivateGroupMutationVariables = Exact<{
  input: DeactivateGroupInput;
}>;


export type DeactivateGroupMutation = { readonly __typename?: 'Mutation', readonly deactivateGroup?: { readonly __typename?: 'DeactivateGroupPayload', readonly communityGroup?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly deactivatedOn?: string | null } | null } | null };

export type UpdateGroupMutationVariables = Exact<{
  input: UpdateGroupInput;
}>;


export type UpdateGroupMutation = { readonly __typename?: 'Mutation', readonly updateGroup?: { readonly __typename?: 'UpdateGroupPayload', readonly id?: string | null, readonly name?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ContactItemFragment = { readonly __typename?: 'ContactNode', readonly id: string, readonly name?: string | null, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly lastAppUse?: string | null, readonly resident?: { readonly __typename?: 'ResidentNode', readonly id: string, readonly avatar?: string | null, readonly averageScore?: number | null, readonly currentResidencies?: ReadonlyArray<{ readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } }> | null } | null, readonly leaseholder?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly leaseholds: { readonly __typename?: 'LeaseholdNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholdNodeEdge', readonly node?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string } | null } | null } | null } | null> } } | null, readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string } | null } | null> } } | null };

export type CommunityGroupItemFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly isAutomatic: boolean, readonly isSystemManaged: boolean, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null };

export type CommunityGroupsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isAutomatic?: InputMaybe<Scalars['Boolean']['input']>;
  groupType?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CommunityGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly deactivatedOn?: string | null, readonly numUsers?: number | null, readonly isAutomatic: boolean, readonly isSystemManaged: boolean, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type HomeGroupsQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type HomeGroupsQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly communityGroups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null } | null } | null> } } | null };

export type UpdateHomeFloorNumberMutationVariables = Exact<{
  input: UpdateHomeFloorNumberInput;
}>;


export type UpdateHomeFloorNumberMutation = { readonly __typename?: 'Mutation', readonly updateHomeFloorNumber?: { readonly __typename?: 'UpdateHomeFloorNumberPayload', readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly floorNumber?: number | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type HomeDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type HomeDetailsQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address: string, readonly city?: string | null, readonly postcode: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyCenter: boolean } } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly pastResidents?: { readonly __typename?: 'ArchivedContactNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ArchivedContactNodeEdge', readonly node?: { readonly __typename?: 'ArchivedContactNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly removalDate?: string | null } | null } | null> } | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly averageScore?: number | null, readonly name?: string | null, readonly email: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly lastAppUse?: string | null } }>, readonly residentSafetyRecords: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean } | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> }, readonly occupancySurveys: { readonly __typename?: 'OccupancySurveyNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'OccupancySurveyNodeEdge', readonly node?: { readonly __typename?: 'OccupancySurveyNode', readonly id: string, readonly isOccupant: boolean, readonly user: { readonly __typename?: 'UserType', readonly id: string }, readonly occupants: { readonly __typename?: 'OccupantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'OccupantNodeEdge', readonly node?: { readonly __typename?: 'OccupantNode', readonly id: string, readonly first: string, readonly last: string, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> } } | null } | null> } } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly lastAppUse?: string | null } } | null } | null> }, readonly pastLeaseholders?: { readonly __typename?: 'ArchivedContactNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ArchivedContactNodeEdge', readonly node?: { readonly __typename?: 'ArchivedContactNode', readonly id: string, readonly name?: string | null, readonly email: string, readonly removalDate?: string | null } | null } | null> } | null } | null, readonly applications: { readonly __typename?: 'ApplicationNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ApplicationNodeEdge', readonly node?: { readonly __typename?: 'ApplicationNode', readonly id: string, readonly addressLine1?: string | null, readonly postcode: string, readonly createdAt: string, readonly status: ResidentialManagementApplicationStatusChoices, readonly archivedAt?: string | null, readonly source: ResidentialManagementApplicationSourceChoices, readonly applicant: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly name?: string | null, readonly email?: string | null }, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly postcode: string } | null, readonly thread?: { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly unreadCount?: number | null } | null } | null } | null> }, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null } | null };

export type HomeItemFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address: string, readonly city?: string | null, readonly postcode: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } } | null } | null> } } | null };

export type ListEntHomesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  hasBlock?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ListEntHomesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address: string, readonly city?: string | null, readonly postcode: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly email: string } } | null } | null> } } | null } | null } | null> } | null };

export type CreateKeyholderV2MutationVariables = Exact<{
  input: CreateKeyholderV2Input;
}>;


export type CreateKeyholderV2Mutation = { readonly __typename?: 'Mutation', readonly createKeyholderV2?: { readonly __typename?: 'CreateKeyholderV2Payload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly key: { readonly __typename?: 'KeyNode', readonly id: string, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null> } } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type KeyCommunityQueryVariables = Exact<{
  keyId: Scalars['UUID']['input'];
}>;


export type KeyCommunityQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null };

export type OnSiteVisitorItemFragment = { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null };

export type OnSiteVisitorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OnSiteVisitorsQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityVisitorNodeEdge', readonly node?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null } | null } | null> } | null };

export type ArchiveKeyMutationVariables = Exact<{
  input: ArchiveKeyInput;
}>;


export type ArchiveKeyMutation = { readonly __typename?: 'Mutation', readonly archiveKey?: { readonly __typename?: 'ArchiveKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly status: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type ArchiveKeyholderMutationVariables = Exact<{
  input: ArchiveKeyholderInput;
}>;


export type ArchiveKeyholderMutation = { readonly __typename?: 'Mutation', readonly archiveKeyholder?: { readonly __typename?: 'ArchiveKeyholderPayload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly archivedAt?: string | null, readonly type: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type AuthorisedKeyholdersQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthorisedKeyholdersQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string } | null } | null> } } | null };

export type CheckInKeyV2MutationVariables = Exact<{
  input: CheckInKeyV2Input;
}>;


export type CheckInKeyV2Mutation = { readonly __typename?: 'Mutation', readonly checkInKeyV2?: { readonly __typename?: 'CheckInKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly checkoutDate?: string | null, readonly status: string, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CheckOutKeyV2MutationVariables = Exact<{
  input: CheckOutKeyV2Input;
}>;


export type CheckOutKeyV2Mutation = { readonly __typename?: 'Mutation', readonly checkOutKeyV2?: { readonly __typename?: 'CheckOutKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly checkoutDate?: string | null, readonly status: string, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateKeyMutationVariables = Exact<{
  input: CreateKeyV2Input;
}>;


export type CreateKeyMutation = { readonly __typename?: 'Mutation', readonly createKeyV2?: { readonly __typename?: 'CreateKeyV2Payload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type EditKeyMutationVariables = Exact<{
  input: EditKeyInput;
}>;


export type EditKeyMutation = { readonly __typename?: 'Mutation', readonly editKey?: { readonly __typename?: 'EditKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly notes?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateKeyholderMutationVariables = Exact<{
  input: UpdateKeyholderInput;
}>;


export type UpdateKeyholderMutation = { readonly __typename?: 'Mutation', readonly updateKeyholder?: { readonly __typename?: 'UpdateKeyholderPayload', readonly id?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type KeyDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  keyholdersAfter?: InputMaybe<Scalars['String']['input']>;
  eventsAfter?: InputMaybe<Scalars['String']['input']>;
}>;


export type KeyDetailsQuery = { readonly __typename?: 'DebugSchema', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly checkoutDate?: string | null, readonly notes?: string | null, readonly status: string, readonly archivedAt?: string | null, readonly image?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address: string, readonly postcode: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null } | null, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null, readonly keyholders: { readonly __typename?: 'KeyholderNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyholderNodeEdge', readonly node?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null } | null } | null> }, readonly events: { readonly __typename?: 'KeyEventNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyEventNodeEdge', readonly node?: { readonly __typename?: 'KeyEventNode', readonly id: string, readonly type: ResidentialManagementKeyEventTypeChoices, readonly createdAt: string, readonly keyholder: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string }, readonly performedBy: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } } | null } | null> } } | null };

export type KeyEventItemFragment = { readonly __typename?: 'KeyEventNode', readonly id: string, readonly type: ResidentialManagementKeyEventTypeChoices, readonly createdAt: string, readonly keyholder: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string }, readonly performedBy: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } };

export type KeyHomeItemFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly address: string, readonly postcode: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null, readonly email: string }> } | null };

export type KeyholderItemFragment = { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly type: string, readonly phoneNumber?: string | null };

export type KeyholderQueryVariables = Exact<{
  keyholderId: Scalars['UUID']['input'];
  keyId: Scalars['UUID']['input'];
}>;


export type KeyholderQuery = { readonly __typename?: 'DebugSchema', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string, readonly startDate: string, readonly endDate?: string | null, readonly phoneNumber?: string | null, readonly type: string, readonly notes?: string | null, readonly email?: string | null, readonly company?: string | null, readonly archivedAt?: string | null } | null, readonly key?: { readonly __typename?: 'KeyNode', readonly checkoutDate?: string | null, readonly name?: string | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string } | null } | null };

export type UnarchiveKeyMutationVariables = Exact<{
  input: UnarchiveKeyInput;
}>;


export type UnarchiveKeyMutation = { readonly __typename?: 'Mutation', readonly unarchiveKey?: { readonly __typename?: 'UnarchiveKeyPayload', readonly key?: { readonly __typename?: 'KeyNode', readonly id: string, readonly status: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UnarchiveKeyholderMutationVariables = Exact<{
  input: UnarchiveKeyholderInput;
}>;


export type UnarchiveKeyholderMutation = { readonly __typename?: 'Mutation', readonly unarchiveKeyholder?: { readonly __typename?: 'UnarchiveKeyholderPayload', readonly keyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly archivedAt?: string | null, readonly type: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type KeyItemFragment = { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly status: string, readonly checkoutDate?: string | null, readonly image?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string } | null };

export type KeysQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search2?: InputMaybe<Scalars['String']['input']>;
  hasCurrentKeyholder?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type KeysQuery = { readonly __typename?: 'DebugSchema', readonly keys?: { readonly __typename?: 'KeyNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'KeyNodeEdge', readonly node?: { readonly __typename?: 'KeyNode', readonly id: string, readonly name?: string | null, readonly reference?: string | null, readonly status: string, readonly checkoutDate?: string | null, readonly image?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null, readonly currentKeyholder?: { readonly __typename?: 'KeyholderNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type ArchiveMarketplaceItemMutationVariables = Exact<{
  input: ArchiveMarketplaceItemInput;
}>;


export type ArchiveMarketplaceItemMutation = { readonly __typename?: 'Mutation', readonly archiveMarketplaceItem?: { readonly __typename?: 'ArchiveMarketplaceItemPayload', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type MarketplaceItemQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type MarketplaceItemQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null };

export type MarketplaceItemCommentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplaceItemCommentsQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItem?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemCommentNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string, readonly comment: string, readonly name: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> } } | null };

export type MarketplaceItemFragment = { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type MarketplaceItemsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type MarketplaceItemsQuery = { readonly __typename?: 'DebugSchema', readonly marketplaceItems?: { readonly __typename?: 'MarketplaceItemNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly price: string, readonly condition?: string | null, readonly createdAt: string, readonly closedOn?: string | null, readonly archivedOn?: string | null, readonly archivedReason?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly name: string }, readonly images: { readonly __typename?: 'MarketplaceItemImageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'MarketplaceItemImageNodeEdge', readonly node?: { readonly __typename?: 'MarketplaceItemImageNode', readonly id: string, readonly image: string } | null } | null> }, readonly user: { readonly __typename?: 'UserType', readonly firstName?: string | null, readonly lastName?: string | null, readonly id: string }, readonly comments: { readonly __typename?: 'MarketplaceItemCommentNodeConnection', readonly totalCount: number }, readonly archivedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type LeanNotificationCenterNotificationFragment = { readonly __typename?: 'LeanNotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly type: string, readonly platform?: string | null, readonly targetType?: string | null, readonly targetObjectId?: string | null, readonly actionObjectType?: string | null, readonly actionObjectObjectId?: string | null, readonly isFeatureAnnouncement: boolean, readonly navigationMeta?: { readonly __typename?: 'NotificationNavigationMeta', readonly targetType?: string | null, readonly actionObjectType?: string | null, readonly routeId?: string | null, readonly secondaryId?: string | null } | null };

export type LeanNotificationCenterNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LeanNotificationCenterNotificationsQuery = { readonly __typename?: 'DebugSchema', readonly leanNotifications?: { readonly __typename?: 'LeanNotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'LeanNotificationNodeEdge', readonly node?: { readonly __typename?: 'LeanNotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly type: string, readonly platform?: string | null, readonly targetType?: string | null, readonly targetObjectId?: string | null, readonly actionObjectType?: string | null, readonly actionObjectObjectId?: string | null, readonly isFeatureAnnouncement: boolean, readonly navigationMeta?: { readonly __typename?: 'NotificationNavigationMeta', readonly targetType?: string | null, readonly actionObjectType?: string | null, readonly routeId?: string | null, readonly secondaryId?: string | null } | null } | null } | null> } | null };

export type LeanUnreadNotificationsCountQueryVariables = Exact<{ [key: string]: never; }>;


export type LeanUnreadNotificationsCountQuery = { readonly __typename?: 'DebugSchema', readonly leanNotifications?: { readonly __typename?: 'LeanNotificationNodeConnection', readonly totalCount: number } | null };

type NotificationActionObject_AmenityReservationNode_Fragment = { readonly __typename?: 'AmenityReservationNode', readonly id: string };

type NotificationActionObject_ApplicationNode_Fragment = { readonly __typename?: 'ApplicationNode', readonly id: string };

type NotificationActionObject_ApplicationSupportMessageNode_Fragment = { readonly __typename?: 'ApplicationSupportMessageNode' };

type NotificationActionObject_ApplicationThreadMessageNode_Fragment = { readonly __typename?: 'ApplicationThreadMessageNode' };

type NotificationActionObject_CommunityEventNode_Fragment = { readonly __typename?: 'CommunityEventNode' };

type NotificationActionObject_CommunityProductPurchaseNode_Fragment = { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string };

type NotificationActionObject_CommunityUpdateCommentNode_Fragment = { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string };

type NotificationActionObject_CommunityUpdateLikeType_Fragment = { readonly __typename?: 'CommunityUpdateLikeType' };

type NotificationActionObject_ConversationNode_Fragment = { readonly __typename?: 'ConversationNode' };

type NotificationActionObject_GroupChatMessageNode_Fragment = { readonly __typename?: 'GroupChatMessageNode' };

type NotificationActionObject_KeyholderNode_Fragment = { readonly __typename?: 'KeyholderNode', readonly id: string };

type NotificationActionObject_MarketplaceItemCommentNode_Fragment = { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string };

type NotificationActionObject_MarketplaceItemNode_Fragment = { readonly __typename?: 'MarketplaceItemNode' };

type NotificationActionObject_MarketplaceItemThreadMessageNode_Fragment = { readonly __typename?: 'MarketplaceItemThreadMessageNode' };

type NotificationActionObject_ResidentSurveyAnswerType_Fragment = { readonly __typename?: 'ResidentSurveyAnswerType' };

type NotificationActionObject_SafetyReviewAttemptNode_Fragment = { readonly __typename?: 'SafetyReviewAttemptNode' };

export type NotificationActionObjectFragment = NotificationActionObject_AmenityReservationNode_Fragment | NotificationActionObject_ApplicationNode_Fragment | NotificationActionObject_ApplicationSupportMessageNode_Fragment | NotificationActionObject_ApplicationThreadMessageNode_Fragment | NotificationActionObject_CommunityEventNode_Fragment | NotificationActionObject_CommunityProductPurchaseNode_Fragment | NotificationActionObject_CommunityUpdateCommentNode_Fragment | NotificationActionObject_CommunityUpdateLikeType_Fragment | NotificationActionObject_ConversationNode_Fragment | NotificationActionObject_GroupChatMessageNode_Fragment | NotificationActionObject_KeyholderNode_Fragment | NotificationActionObject_MarketplaceItemCommentNode_Fragment | NotificationActionObject_MarketplaceItemNode_Fragment | NotificationActionObject_MarketplaceItemThreadMessageNode_Fragment | NotificationActionObject_ResidentSurveyAnswerType_Fragment | NotificationActionObject_SafetyReviewAttemptNode_Fragment;

export type NotificationCenterNotificationFragment = { readonly __typename?: 'NotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode' } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null };

export type NotificationCenterNotificationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type NotificationCenterNotificationsQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'NotificationNodeEdge', readonly node?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly createdAt: string, readonly verb?: string | null, readonly read: boolean, readonly title: string, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode' } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null } | null } | null> } | null, readonly unreadNotifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number } | null };

type NotificationTarget_AmenityNode_Fragment = { readonly __typename?: 'AmenityNode', readonly id: string };

type NotificationTarget_ApplicationNode_Fragment = { readonly __typename?: 'ApplicationNode', readonly id: string };

type NotificationTarget_ApplicationSupportThreadNode_Fragment = { readonly __typename?: 'ApplicationSupportThreadNode' };

type NotificationTarget_ApplicationThreadNode_Fragment = { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } };

type NotificationTarget_CommunityDocumentNode_Fragment = { readonly __typename?: 'CommunityDocumentNode' };

type NotificationTarget_CommunityEventNode_Fragment = { readonly __typename?: 'CommunityEventNode', readonly id: string };

type NotificationTarget_CommunityNode_Fragment = { readonly __typename?: 'CommunityNode' };

type NotificationTarget_CommunityProductNode_Fragment = { readonly __typename?: 'CommunityProductNode', readonly id: string };

type NotificationTarget_CommunityUpdateNode_Fragment = { readonly __typename?: 'CommunityUpdateNode', readonly id: string };

type NotificationTarget_ConversationAssignmentNode_Fragment = { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } };

type NotificationTarget_ConversationNode_Fragment = { readonly __typename?: 'ConversationNode', readonly id: string };

type NotificationTarget_DocumentExtractionNode_Fragment = { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null };

type NotificationTarget_FeatureAnnouncementNode_Fragment = { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string };

type NotificationTarget_GroupChatNode_Fragment = { readonly __typename?: 'GroupChatNode' };

type NotificationTarget_HomeNode_Fragment = { readonly __typename?: 'HomeNode' };

type NotificationTarget_KeyNode_Fragment = { readonly __typename?: 'KeyNode', readonly id: string };

type NotificationTarget_MarketplaceItemNode_Fragment = { readonly __typename?: 'MarketplaceItemNode' };

type NotificationTarget_MarketplaceItemThreadNode_Fragment = { readonly __typename?: 'MarketplaceItemThreadNode' };

type NotificationTarget_PackageNode_Fragment = { readonly __typename?: 'PackageNode' };

type NotificationTarget_ResidencyDocumentNode_Fragment = { readonly __typename?: 'ResidencyDocumentNode' };

type NotificationTarget_ResidentSurveyNode_Fragment = { readonly __typename?: 'ResidentSurveyNode', readonly id: string };

type NotificationTarget_TaskNode_Fragment = { readonly __typename?: 'TaskNode', readonly id: string };

type NotificationTarget_TeamAssignmentNode_Fragment = { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string };

type NotificationTarget_TenantReferenceNode_Fragment = { readonly __typename?: 'TenantReferenceNode', readonly uuid: string };

type NotificationTarget_UserDocumentNode_Fragment = { readonly __typename?: 'UserDocumentNode' };

type NotificationTarget_UserType_Fragment = { readonly __typename?: 'UserType' };

export type NotificationTargetFragment = NotificationTarget_AmenityNode_Fragment | NotificationTarget_ApplicationNode_Fragment | NotificationTarget_ApplicationSupportThreadNode_Fragment | NotificationTarget_ApplicationThreadNode_Fragment | NotificationTarget_CommunityDocumentNode_Fragment | NotificationTarget_CommunityEventNode_Fragment | NotificationTarget_CommunityNode_Fragment | NotificationTarget_CommunityProductNode_Fragment | NotificationTarget_CommunityUpdateNode_Fragment | NotificationTarget_ConversationAssignmentNode_Fragment | NotificationTarget_ConversationNode_Fragment | NotificationTarget_DocumentExtractionNode_Fragment | NotificationTarget_FeatureAnnouncementNode_Fragment | NotificationTarget_GroupChatNode_Fragment | NotificationTarget_HomeNode_Fragment | NotificationTarget_KeyNode_Fragment | NotificationTarget_MarketplaceItemNode_Fragment | NotificationTarget_MarketplaceItemThreadNode_Fragment | NotificationTarget_PackageNode_Fragment | NotificationTarget_ResidencyDocumentNode_Fragment | NotificationTarget_ResidentSurveyNode_Fragment | NotificationTarget_TaskNode_Fragment | NotificationTarget_TeamAssignmentNode_Fragment | NotificationTarget_TenantReferenceNode_Fragment | NotificationTarget_UserDocumentNode_Fragment | NotificationTarget_UserType_Fragment;

export type UnreadNotificationMutationVariables = Exact<{
  input: UnreadNotificationInput;
}>;


export type UnreadNotificationMutation = { readonly __typename?: 'Mutation', readonly unreadNotification?: { readonly __typename?: 'UnreadNotificationPayload', readonly notification?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly read: boolean } | null } | null };

export type CollectPackagesForHomeMutationVariables = Exact<{
  input: CollectPackagesForHomeInput;
}>;


export type CollectPackagesForHomeMutation = { readonly __typename?: 'Mutation', readonly collectPackagesForHome?: { readonly __typename?: 'CollectPackagesForHomePayload', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly uncollectedPackageCount: number, readonly uncollectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly createdAt: string } | null } | null> } | null, readonly collectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly collectedOn?: string | null } | null } | null> } | null } | null } | null };

export type HomePackagesQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type HomePackagesQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly addressee?: string | null, readonly lastAction: string, readonly location?: string | null, readonly pickupLocation?: string | null, readonly status: ResidentialManagementPackageStatusChoices } | null } | null> } | null, readonly uncollectedPackages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number } | null } | null };

export type PackageReminderToHomeMutationVariables = Exact<{
  input: PackageReminderToHomeInput;
}>;


export type PackageReminderToHomeMutation = { readonly __typename?: 'Mutation', readonly packageReminderToHome?: { readonly __typename?: 'PackageReminderToHomePayload', readonly home?: { readonly __typename?: 'HomeType', readonly id: string } | null } | null };

export type AddPackageToHomeMutationVariables = Exact<{
  input: AddPackageToHomeInput;
}>;


export type AddPackageToHomeMutation = { readonly __typename?: 'Mutation', readonly addPackageToHome?: { readonly __typename?: 'AddPackageToHomePayload', readonly package?: { readonly __typename?: 'PackageNode', readonly id: string } | null } | null };

export type CreateApplicantAndApplicationMutationVariables = Exact<{
  input: CreateApplicantAndApplicationInput;
}>;


export type CreateApplicantAndApplicationMutation = { readonly __typename?: 'Mutation', readonly createApplicantAndApplication?: { readonly __typename?: 'CreateApplicantAndApplicationPayload', readonly applicant?: { readonly __typename?: 'ApplicantNode', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string } } | null } | null };

export type CollectPackagesMutationVariables = Exact<{
  input: CollectPackagesInput;
}>;


export type CollectPackagesMutation = { readonly __typename?: 'Mutation', readonly collectPackages?: { readonly __typename?: 'CollectPackagesPayload', readonly packages: ReadonlyArray<{ readonly __typename?: 'PackageNode', readonly id: string, readonly status: ResidentialManagementPackageStatusChoices, readonly collectedOn?: string | null, readonly collectedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly uncollectedPackageCount: number } | null } | null> } | null };

export type PackageQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PackageQuery = { readonly __typename?: 'DebugSchema', readonly package?: { readonly __typename?: 'PackageNode', readonly id: string, readonly createdAt: string, readonly status: ResidentialManagementPackageStatusChoices, readonly image?: string | null, readonly addressee?: string | null, readonly collectedOn?: string | null, readonly location?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly collectedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly scannedInBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly reminders?: ReadonlyArray<{ readonly __typename?: 'PackageReminderNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }> | null, readonly events: ReadonlyArray<{ readonly __typename?: 'PackageEventNode', readonly id: string, readonly createdAt: string, readonly type: ResidentialManagementPackageEventTypeChoices, readonly reason?: string | null, readonly performedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null }> } | null };

export type PackageEventFragment = { readonly __typename?: 'PackageEventNode', readonly id: string, readonly createdAt: string, readonly type: ResidentialManagementPackageEventTypeChoices, readonly reason?: string | null, readonly performedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type RemindResidentMutationVariables = Exact<{
  input: RemindResidentInput;
}>;


export type RemindResidentMutation = { readonly __typename?: 'Mutation', readonly remindResident?: { readonly __typename?: 'RemindResidentPayload', readonly id?: string | null } | null };

export type UpdatePackageStatusMutationVariables = Exact<{
  input: UpdatePackageStatusInput;
}>;


export type UpdatePackageStatusMutation = { readonly __typename?: 'Mutation', readonly updatePackageStatus?: { readonly __typename?: 'UpdatePackageStatusPayload', readonly package: { readonly __typename?: 'PackageNode', readonly id: string, readonly status: ResidentialManagementPackageStatusChoices, readonly collectedOn?: string | null, readonly collectedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } } | null };

export type PackageReminderToAllMutationVariables = Exact<{
  communities: ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>;
}>;


export type PackageReminderToAllMutation = { readonly __typename?: 'Mutation', readonly packageReminderToAll?: { readonly __typename?: 'PackageReminderToAll', readonly packages?: ReadonlyArray<{ readonly __typename?: 'PackageNode', readonly id: string, readonly reminders?: ReadonlyArray<{ readonly __typename?: 'PackageReminderNode', readonly id: string, readonly createdAt: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } }> | null } | null> | null } | null };

export type ExportPackagesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type ExportPackagesQuery = { readonly __typename?: 'DebugSchema', readonly packagesExport?: string | null };

export type HomesWithPackagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  icontainsSearch?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  hasUncollected?: InputMaybe<Scalars['Boolean']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type HomesWithPackagesQuery = { readonly __typename?: 'DebugSchema', readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly city?: string | null, readonly postcode: string, readonly uncollectedPackageCount: number, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type PackagesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  locations?: InputMaybe<ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
}>;


export type PackagesQuery = { readonly __typename?: 'DebugSchema', readonly packages?: { readonly __typename?: 'PackageNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'PackageNodeEdge', readonly node?: { readonly __typename?: 'PackageNode', readonly id: string, readonly createdAt: string, readonly status: ResidentialManagementPackageStatusChoices, readonly lastAction: string, readonly collectedOn?: string | null, readonly addressee?: string | null, readonly location?: string | null, readonly home?: { readonly __typename?: 'HomeType', readonly name: string, readonly addressLine1?: string | null, readonly postcode: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } | null };

export type AccountTransactionItemFragment = { readonly __typename?: 'AccountTransactionNode', readonly id: string, readonly createdAt: string, readonly amount: any, readonly status: PaymentsPaymentStatusChoices, readonly account?: { readonly __typename?: 'PaymentAccountNode', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly externalId?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly externalId?: string | null, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null };

export type AccountTransactionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type AccountTransactionsQuery = { readonly __typename?: 'DebugSchema', readonly accountTransactions?: { readonly __typename?: 'AccountTransactionNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'AccountTransactionNodeEdge', readonly node?: { readonly __typename?: 'AccountTransactionNode', readonly id: string, readonly createdAt: string, readonly amount: any, readonly status: PaymentsPaymentStatusChoices, readonly account?: { readonly __typename?: 'PaymentAccountNode', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly address: string, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null, readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly externalId?: string | null, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly name?: string | null }> } | null, readonly leasehold?: { readonly __typename?: 'LeaseholdNode', readonly id: string, readonly externalId?: string | null, readonly leaseholder: { readonly __typename?: 'LeaseholderNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'LeaseholderNodeEdge', readonly node?: { readonly __typename?: 'LeaseholderNode', readonly id: string, readonly name?: string | null } | null } | null> } } | null } | null } | null } | null> } | null };

export type ProfileNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileNotificationSettingsQuery = { readonly __typename?: 'DebugSchema', readonly getManager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly emailPreferences: boolean } | null };

export type UpdateManagerMutationVariables = Exact<{
  input: UpdateManagerInput;
}>;


export type UpdateManagerMutation = { readonly __typename?: 'Mutation', readonly updateManager?: { readonly __typename?: 'UpdateManagerPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null };

export type UpdateManagerNotificationSettingsMutationVariables = Exact<{
  input: UpdateManagerNotificationSettingsInput;
}>;


export type UpdateManagerNotificationSettingsMutation = { readonly __typename?: 'Mutation', readonly updateManagerNotificationSettings?: { readonly __typename?: 'UpdateManagerNotificationSettingsPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly emailPreferences: boolean } | null } | null };

export type UpdateMobileMutationVariables = Exact<{
  input: UpdateUserMobileNumberInput;
}>;


export type UpdateMobileMutation = { readonly __typename?: 'Mutation', readonly updateMobileNumber?: { readonly __typename?: 'UpdateUserMobileNumberPayload', readonly error?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly email: string, readonly mobile?: string | null } | null } | null };

export type ResidentAppNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResidentAppNotificationPreferencesQuery = { readonly __typename?: 'DebugSchema', readonly residentAppNotificationPreferences?: { readonly __typename?: 'ResidentAppNotificationPreferencesNode', readonly id: string, readonly isMuted: boolean } | null };

export type ToggleAllResidentAppNotificationPreferencesMutationVariables = Exact<{
  input: ToggleAllResidentAppNotificationPreferencesInput;
}>;


export type ToggleAllResidentAppNotificationPreferencesMutation = { readonly __typename?: 'Mutation', readonly toggleAllResidentAppNotificationPreferences?: { readonly __typename?: 'ToggleAllResidentAppNotificationPreferencesPayload', readonly residentAppNotificationPreferences?: { readonly __typename?: 'ResidentAppNotificationPreferencesNode', readonly id: string, readonly isMuted: boolean } | null } | null };

export type UpdateNotificationPreferenceMutationVariables = Exact<{
  input: UpdateNotificationPreferenceInput;
}>;


export type UpdateNotificationPreferenceMutation = { readonly __typename?: 'Mutation', readonly updateNotificationPreference?: { readonly __typename?: 'UpdateNotificationPreferencePayload', readonly userNotificationPreference?: { readonly __typename?: 'UserNotificationPreferenceNode', readonly id: string, readonly managerAmenityPushEnabled: boolean, readonly managerAmenityEmailEnabled: boolean, readonly managerApplicationPushEnabled: boolean, readonly managerApplicationEmailEnabled: boolean, readonly managerApplicationMessagePushEnabled: boolean, readonly managerApplicationMessageEmailEnabled: boolean, readonly managerCommunityEventPushEnabled: boolean, readonly managerCommunityEventEmailEnabled: boolean, readonly managerCommunityProductPushEnabled: boolean, readonly managerCommunityProductEmailEnabled: boolean, readonly managerCommunityUpdatePushEnabled: boolean, readonly managerCommunityUpdateEmailEnabled: boolean, readonly managerConversationAssignmentPushEnabled: boolean, readonly managerConversationAssignmentEmailEnabled: boolean, readonly managerTeamAssignmentPushEnabled: boolean, readonly managerTeamAssignmentEmailEnabled: boolean, readonly managerConversationPushEnabled: boolean, readonly managerConversationEmailEnabled: boolean, readonly managerSurveysPushEnabled: boolean, readonly managerSurveysEmailEnabled: boolean, readonly managerTaskAssignmentPushEnabled: boolean, readonly managerTaskUpdatePushEnabled: boolean, readonly managerTaskCommentPushEnabled: boolean } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateUserProfileMutation = { readonly __typename?: 'Mutation', readonly updateUserProfile?: { readonly __typename?: 'UpdateUserProfilePayload', readonly userProfile?: { readonly __typename?: 'UserProfileNode', readonly id: string, readonly biography?: string | null, readonly residentAppVisibility: boolean, readonly displayRole?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UserNotificationPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationPreferencesQuery = { readonly __typename?: 'DebugSchema', readonly userNotificationPreferences?: { readonly __typename?: 'UserNotificationPreferenceNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'UserNotificationPreferenceNodeEdge', readonly node?: { readonly __typename?: 'UserNotificationPreferenceNode', readonly id: string, readonly managerAmenityPushEnabled: boolean, readonly managerAmenityEmailEnabled: boolean, readonly managerApplicationPushEnabled: boolean, readonly managerApplicationEmailEnabled: boolean, readonly managerApplicationMessagePushEnabled: boolean, readonly managerApplicationMessageEmailEnabled: boolean, readonly managerCommunityEventPushEnabled: boolean, readonly managerCommunityEventEmailEnabled: boolean, readonly managerCommunityProductPushEnabled: boolean, readonly managerCommunityProductEmailEnabled: boolean, readonly managerCommunityUpdatePushEnabled: boolean, readonly managerCommunityUpdateEmailEnabled: boolean, readonly managerConversationAssignmentPushEnabled: boolean, readonly managerConversationAssignmentEmailEnabled: boolean, readonly managerTeamAssignmentPushEnabled: boolean, readonly managerTeamAssignmentEmailEnabled: boolean, readonly managerConversationPushEnabled: boolean, readonly managerConversationEmailEnabled: boolean, readonly managerSurveysPushEnabled: boolean, readonly managerSurveysEmailEnabled: boolean, readonly managerTaskAssignmentPushEnabled: boolean, readonly managerTaskUpdatePushEnabled: boolean, readonly managerTaskCommentPushEnabled: boolean } | null } | null> } | null };

export type LeanPulseNotificationFragment = { readonly __typename?: 'LeanNotificationNode', readonly id: string, readonly createdAt: string, readonly read: boolean, readonly title: string, readonly actorName?: string | null, readonly targetType?: string | null, readonly targetObjectId?: string | null, readonly actionObjectType?: string | null, readonly actionObjectObjectId?: string | null, readonly isFeatureAnnouncement: boolean, readonly navigationMeta?: { readonly __typename?: 'NotificationNavigationMeta', readonly targetType?: string | null, readonly actionObjectType?: string | null, readonly routeId?: string | null, readonly secondaryId?: string | null } | null };

export type LeanPulseQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type LeanPulseQuery = { readonly __typename?: 'DebugSchema', readonly leanNotifications?: { readonly __typename?: 'LeanNotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'LeanNotificationNodeEdge', readonly node?: { readonly __typename?: 'LeanNotificationNode', readonly id: string, readonly createdAt: string, readonly read: boolean, readonly title: string, readonly actorName?: string | null, readonly targetType?: string | null, readonly targetObjectId?: string | null, readonly actionObjectType?: string | null, readonly actionObjectObjectId?: string | null, readonly isFeatureAnnouncement: boolean, readonly navigationMeta?: { readonly __typename?: 'NotificationNavigationMeta', readonly targetType?: string | null, readonly actionObjectType?: string | null, readonly routeId?: string | null, readonly secondaryId?: string | null } | null } | null } | null> } | null, readonly leanUnreadNotifications?: { readonly __typename?: 'LeanNotificationNodeConnection', readonly totalCount: number } | null };

export type PulseNotificationFragment = { readonly __typename?: 'NotificationNode', readonly id: string, readonly actorName?: string | null, readonly pulseTitle?: string | null, readonly createdAt: string, readonly read: boolean, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode' } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null };

export type PulseQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type PulseQuery = { readonly __typename?: 'DebugSchema', readonly notifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'NotificationNodeEdge', readonly node?: { readonly __typename?: 'NotificationNode', readonly id: string, readonly actorName?: string | null, readonly pulseTitle?: string | null, readonly createdAt: string, readonly read: boolean, readonly target?: { readonly __typename?: 'AmenityNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportThreadNode' } | { readonly __typename?: 'ApplicationThreadNode', readonly id: string, readonly applicationId?: string | null, readonly application: { readonly __typename?: 'ApplicationNode', readonly id: string } } | { readonly __typename?: 'CommunityDocumentNode' } | { readonly __typename?: 'CommunityEventNode', readonly id: string } | { readonly __typename?: 'CommunityNode' } | { readonly __typename?: 'CommunityProductNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateNode', readonly id: string } | { readonly __typename?: 'ConversationAssignmentNode', readonly id: string, readonly conversation: { readonly __typename?: 'ConversationNode', readonly id: string } } | { readonly __typename?: 'ConversationNode', readonly id: string } | { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly extractedTaskId?: string | null } | { readonly __typename?: 'FeatureAnnouncementNode', readonly id: string, readonly slug: string } | { readonly __typename?: 'GroupChatNode' } | { readonly __typename?: 'HomeNode' } | { readonly __typename?: 'KeyNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadNode' } | { readonly __typename?: 'PackageNode' } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'ResidentSurveyNode', readonly id: string } | { readonly __typename?: 'TaskNode', readonly id: string } | { readonly __typename?: 'TeamAssignmentNode', readonly id: string, readonly objectId: string } | { readonly __typename?: 'TenantReferenceNode', readonly uuid: string } | { readonly __typename?: 'UserDocumentNode' } | { readonly __typename?: 'UserType' } | null, readonly actionObject?: { readonly __typename?: 'AmenityReservationNode', readonly id: string } | { readonly __typename?: 'ApplicationNode', readonly id: string } | { readonly __typename?: 'ApplicationSupportMessageNode' } | { readonly __typename?: 'ApplicationThreadMessageNode' } | { readonly __typename?: 'CommunityEventNode' } | { readonly __typename?: 'CommunityProductPurchaseNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string } | { readonly __typename?: 'CommunityUpdateLikeType' } | { readonly __typename?: 'ConversationNode' } | { readonly __typename?: 'GroupChatMessageNode' } | { readonly __typename?: 'KeyholderNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemCommentNode', readonly id: string } | { readonly __typename?: 'MarketplaceItemNode' } | { readonly __typename?: 'MarketplaceItemThreadMessageNode' } | { readonly __typename?: 'ResidentSurveyAnswerType' } | { readonly __typename?: 'SafetyReviewAttemptNode' } | null } | null } | null> } | null, readonly unreadNotifications?: { readonly __typename?: 'NotificationNodeConnection', readonly totalCount: number } | null };

export type ReadAllPulsesMutationVariables = Exact<{ [key: string]: never; }>;


export type ReadAllPulsesMutation = { readonly __typename?: 'Mutation', readonly readAllNotifications?: { readonly __typename?: 'ReadAllNotificationsPayload', readonly clientMutationId?: string | null } | null };

export type TenancyApplicantItemFragment = { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null, readonly identityVerificationStatus?: string | null, readonly creditCheckStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly employmentStatus?: string | null, readonly rightToRentStatus?: string | null } | null };

export type ApplicationDetailsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ApplicationDetailsQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly applicantNames?: string | null, readonly combinedAffordability?: number | null, readonly affordabilityStatus: TenancyApplicationTenancyApplicationAffordabilityStatusChoices, readonly rentAmount: string, readonly completedOn?: string | null, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null }, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly email: string, readonly mobile?: string | null, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null, readonly identityVerificationStatus?: string | null, readonly creditCheckStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly employmentStatus?: string | null, readonly rightToRentStatus?: string | null } | null } | null } | null> } } | null };

export type CreateTenancyApplicationMutationVariables = Exact<{
  input: CreateTenancyApplicationInput;
}>;


export type CreateTenancyApplicationMutation = { readonly __typename?: 'Mutation', readonly createTenancyApplication?: { readonly __typename?: 'CreateTenancyApplicationPayload', readonly tenancyApplication?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string } | null } | null };

export type ReferencingDisabledCommunitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencingDisabledCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string } | null } | null> } | null } | null } | null };

export type TenantReferenceQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type TenantReferenceQuery = { readonly __typename?: 'DebugSchema', readonly tenantReference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly submittedAt?: string | null, readonly status?: string | null, readonly dateOfBirth?: string | null, readonly employmentStatus?: string | null, readonly lettingHistoryStatus?: string | null, readonly rentAffordability?: string | null, readonly creditCheckStatus?: string | null, readonly identityVerificationStatus?: string | null, readonly rightToRentStatus?: string | null, readonly applicant: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly tenancyApplication: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly rentAmount: string, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly status?: string | null } | null } | null } | null> } } }, readonly currentAddress?: { readonly __typename?: 'ReferenceHistoricalAddressNode', readonly id: string, readonly fullAddress?: string | null } | null, readonly tenantEmploymentDetails?: { readonly __typename?: 'EmploymentDetailsNode', readonly income?: string | null, readonly id: string, readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices, readonly jobTitle?: string | null, readonly companyName?: string | null, readonly fullOrPartTime?: TenancyApplicationEmploymentDetailsFullOrPartTimeChoices | null, readonly startDate?: string | null, readonly paymentFrequency?: TenancyApplicationEmploymentDetailsPaymentFrequencyChoices | null, readonly employmentEnding?: boolean | null } | null, readonly historicalAddresses: { readonly __typename?: 'ReferenceHistoricalAddressNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ReferenceHistoricalAddressNodeEdge', readonly node?: { readonly __typename?: 'ReferenceHistoricalAddressNode', readonly id: string, readonly fullAddress?: string | null } | null } | null> }, readonly creditCheck?: { readonly __typename?: 'CreditCheckNode', readonly id: string, readonly riskLevel?: string | null, readonly score: number, readonly aliases: ReadonlyArray<string>, readonly createdAt: string, readonly totalCountyCourtJudgements: number, readonly activeCountyCourtJudgements: number, readonly totalBankruptcies: number, readonly activeBankruptcies: number } | null, readonly identityVerification?: { readonly __typename?: 'IdentityVerificationNode', readonly id: string, readonly status: TenancyApplicationIdentityVerificationStatusChoices, readonly passport?: string | null, readonly passportSelfie?: string | null, readonly nationality?: string | null, readonly documentType?: string | null, readonly documentNumber?: string | null, readonly documentExpiryDate?: string | null, readonly selfie?: string | null, readonly hasRightToRent?: boolean | null } | null, readonly rightToRent?: { readonly __typename?: 'RightToRentNode', readonly id: string, readonly shareCode?: string | null, readonly document?: string | null, readonly officialVerificationStatus?: TenancyApplicationRightToRentOfficialVerificationStatusChoices | null, readonly officialExpiryDate?: string | null, readonly officialDocument?: string | null } | null, readonly employerReference?: { readonly __typename?: 'EmployerReferenceNode', readonly id: string, readonly submittedAt?: string | null, readonly firstName?: string | null, readonly lastName?: string | null, readonly jobTitle?: string | null, readonly mobile?: string | null, readonly email?: string | null, readonly companyName?: string | null, readonly employerEmploymentDetails?: { readonly __typename?: 'EmploymentDetailsNode', readonly id: string, readonly employmentType: TenancyApplicationEmploymentDetailsEmploymentTypeChoices, readonly jobTitle?: string | null, readonly fullOrPartTime?: TenancyApplicationEmploymentDetailsFullOrPartTimeChoices | null, readonly startDate?: string | null, readonly income?: string | null, readonly paymentFrequency?: TenancyApplicationEmploymentDetailsPaymentFrequencyChoices | null, readonly employmentEnding?: boolean | null, readonly companyName?: string | null } | null } | null, readonly landlordReference?: { readonly __typename?: 'LandlordReferenceNode', readonly id: string, readonly firstName: string, readonly lastName: string, readonly mobile: string, readonly email: string, readonly submittedAt?: string | null, readonly landlordOrAgent: string, readonly comments?: string | null, readonly tenantMoveInDate?: string | null, readonly tenancyType: TenancyApplicationLandlordReferenceTenancyTypeChoices, readonly monthlyRentAmount: string, readonly hasOutstandingRent: TenancyApplicationLandlordReferenceHasOutstandingRentChoices, readonly rentPaidOnTime: TenancyApplicationLandlordReferenceRentPaidOnTimeChoices, readonly treatedPropertyWell: TenancyApplicationLandlordReferenceTreatedPropertyWellChoices } | null } | null };

export type TenantDetailsHeaderQueryVariables = Exact<{
  uuid: Scalars['UUID']['input'];
}>;


export type TenantDetailsHeaderQuery = { readonly __typename?: 'DebugSchema', readonly tenantReference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string, readonly applicant: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null }, readonly application: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly address?: string | null } } } | null };

export type TenancyApplicationCountsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TenancyApplicationCountsQuery = { readonly __typename?: 'DebugSchema', readonly waitingApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly issueApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly passedApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null, readonly totalApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number } | null };

export type TenancyApplicationItemFragment = { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly applicantNames?: string | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string } | null } | null } | null> }, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } };

export type TenancyApplicationsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type TenancyApplicationsQuery = { readonly __typename?: 'DebugSchema', readonly tenancyApplications?: { readonly __typename?: 'TenancyApplicationNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicationNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicationNode', readonly id: string, readonly status: TenancyApplicationTenancyApplicationStatusChoices, readonly applicantNames?: string | null, readonly applicants: { readonly __typename?: 'TenancyApplicantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TenancyApplicantNodeEdge', readonly node?: { readonly __typename?: 'TenancyApplicantNode', readonly id: string, readonly reference?: { readonly __typename?: 'TenantReferenceNode', readonly id: string } | null } | null } | null> }, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type ApplicationReceivedFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly received: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ApplicationApprovedFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly approved: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly approvedByProof: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingProofCountNode', readonly hasProofOfAddress?: boolean | null, readonly count: number }> };

export type ApplicationPendingFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly pending: { readonly __typename?: 'ApplicationReportingPendingNode', readonly atEnd?: { readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ApplicationPendingByWaitFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly pendingByWait: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingWaitBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> };

export type ApplicationTimeToApprovalFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly timeToApproval: { readonly __typename?: 'ApplicationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type ApplicationOutcomesFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly outcomes: { readonly __typename?: 'ApplicationReportingOutcomesNode', readonly approvalRate?: number | null, readonly decidedCount: number, readonly byStatus: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingStatusCountNode', readonly status: ApplicationReportingStatus, readonly count: number }> } };

export type ApplicationResubmissionsFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly resubmissions: { readonly __typename?: 'ApplicationReportingResubmissionsNode', readonly attemptsPerApproval?: number | null, readonly approvedCount: number, readonly resubmittedCount: number } };

export type ApplicationFunnelFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly funnel: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingFunnelStageNode', readonly stage: ApplicationReportingFunnelStage, readonly count: number }> };

export type BookingMadeFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly bookings: { readonly __typename?: 'BookingReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'BookingReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type BookingFacilityFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly byFacility: ReadonlyArray<{ readonly __typename?: 'BookingReportingFacilityNode', readonly amenityId?: string | null, readonly label: string, readonly count: number }> };

export type BookingCancellationFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly cancellations: { readonly __typename?: 'BookingReportingCancellationNode', readonly total?: number | null, readonly rate?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'BookingReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type BookingLeadTimeFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly leadTime: { readonly __typename?: 'BookingReportingLeadTimeNode', readonly medianSeconds?: number | null, readonly sampleCount: number } };

export type BookingBookersFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly bookers: { readonly __typename?: 'BookingReportingBookersNode', readonly uniqueBookers: number, readonly bookingsPerBooker?: number | null, readonly frequency: ReadonlyArray<{ readonly __typename?: 'BookingReportingFrequencyNode', readonly minBookings: number, readonly maxBookings?: number | null, readonly bookers: number }> } };

export type BookingBookedByFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly bookedBy: ReadonlyArray<{ readonly __typename?: 'BookingReportingBookedByNode', readonly bookedByStaff: boolean, readonly count: number }> };

export type BookingSlotPatternFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly slotPattern: ReadonlyArray<{ readonly __typename?: 'BookingReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type ConversationOpenedFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly opened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ConversationClosedFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly closed: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ConversationReopenedFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly reopened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ConversationOpenFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly openConversations: { readonly __typename?: 'ConversationReportingOpenNode', readonly atEnd?: { readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type ConversationFirstResponseFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly firstResponse: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type ConversationResponseTimeFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly responseTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type ConversationSatisfactionFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly satisfaction: { readonly __typename?: 'ConversationReportingSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number, readonly byStar: ReadonlyArray<{ readonly __typename?: 'ConversationReportingStarCountNode', readonly stars: number, readonly count: number }> } };

export type ConversationTopicsFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly topics: ReadonlyArray<{ readonly __typename?: 'ConversationReportingTopicNode', readonly tagId: string, readonly label: string, readonly count: number }> };

export type DocumentLiveFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly live: { readonly __typename?: 'DocumentReportingLiveNode', readonly count: number, readonly viewedCount: number, readonly viewedShare?: number | null } };

export type DocumentAddedFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly added: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type DocumentViewedFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly uniqueViewers: number, readonly mostViewed: ReadonlyArray<{ readonly __typename?: 'DocumentReportingTopDocumentNode', readonly documentId: string, readonly title: string, readonly viewerCount: number }> };

export type DocumentNeverViewedFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly neverViewed: { readonly __typename?: 'DocumentReportingNeverViewedNode', readonly total: number, readonly byAge: ReadonlyArray<{ readonly __typename?: 'DocumentReportingAgeCountNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> } };

export type DocumentTagsFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly tags: ReadonlyArray<{ readonly __typename?: 'DocumentReportingTagNode', readonly tagId: string, readonly label: string, readonly count: number }> };

export type DocumentRemindersFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly reminders: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null } };

export type KeyMovementsFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly movements: { readonly __typename?: 'KeyReportingMovementsNode', readonly checkedOut?: number | null, readonly checkedIn?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayMovementNode', readonly day: string, readonly checkedOut?: number | null, readonly checkedIn?: number | null }> } };

export type KeysOutFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly keysOut: { readonly __typename?: 'KeyReportingKeysOutNode', readonly atEnd?: { readonly __typename?: 'KeyReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type KeyTimeHeldFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly timeHeld: { readonly __typename?: 'KeyReportingTimeHeldNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type KeyDaysHeldFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly daysHeld: { readonly __typename?: 'KeyReportingDaysHeldNode', readonly overdueCount: number, readonly buckets: ReadonlyArray<{ readonly __typename?: 'KeyReportingDaysHeldBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number, readonly overdue: boolean }> } };

export type KeyHolderCompaniesFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly holderCompanies: ReadonlyArray<{ readonly __typename?: 'KeyReportingHolderCompanyNode', readonly label: string, readonly count: number }> };

export type PackageDeliveredFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly delivered: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type PackageCollectedFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly collected: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type PackageUncollectedFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly uncollected: { readonly __typename?: 'PackageReportingUncollectedNode', readonly atEnd?: { readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type PackageTimeToCollectionFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly timeToCollection: { readonly __typename?: 'PackageReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type PackageAgeingFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly ageing: { readonly __typename?: 'PackageReportingAgeingNode', readonly overTwoWeeks?: number | null, readonly buckets: ReadonlyArray<{ readonly __typename?: 'PackageReportingAgeBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> } };

export type PackageDeliveryPatternFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly deliveryPattern: ReadonlyArray<{ readonly __typename?: 'PackageReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type PackageRemindersFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly reminders: { readonly __typename?: 'PackageReportingRemindersNode', readonly total?: number | null, readonly collectedWithin48Hours?: number | null, readonly sampleCount: number } };

export type PackageCollectionPointFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly collectionPoints: ReadonlyArray<{ readonly __typename?: 'PackageReportingCollectionPointNode', readonly inLocker: boolean, readonly count: number }> };

export type PackageDataQualityFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly dataQuality: { readonly __typename?: 'PackageReportingDataQualityNode', readonly markedAsDuplicate?: number | null, readonly markedAsIncorrectlyAssigned?: number | null } };

export type PortfolioEngagementReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  withTrend: Scalars['Boolean']['input'];
}>;


export type PortfolioEngagementReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingPortfolioEngagement: { readonly __typename?: 'PortfolioEngagementReportingNode', readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementRowNode', readonly communityId?: string | null, readonly homes: number, readonly occupiedHomes: number, readonly appHomes: number, readonly activeHomes: number, readonly people: number, readonly appUsers: number, readonly activeUsers: number, readonly health?: number | null, readonly downloadRate?: number | null, readonly activeRate?: number | null }>, readonly reach: ReadonlyArray<{ readonly __typename?: 'PortfolioReachRowNode', readonly communityId?: string | null, readonly occupiedHomes: number, readonly updateReaderHomes: number, readonly documentViewerHomes: number, readonly updateReadShare?: number | null, readonly documentViewShare?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementRowNode', readonly communityId?: string | null, readonly homes: number, readonly occupiedHomes: number, readonly appHomes: number, readonly activeHomes: number, readonly people: number, readonly appUsers: number, readonly activeUsers: number, readonly health?: number | null, readonly downloadRate?: number | null, readonly activeRate?: number | null }> }>, readonly reachTrend?: ReadonlyArray<{ readonly __typename?: 'PortfolioReachTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioReachRowNode', readonly communityId?: string | null, readonly occupiedHomes: number, readonly updateReaderHomes: number, readonly documentViewerHomes: number, readonly updateReadShare?: number | null, readonly documentViewShare?: number | null }> }>, readonly coverage?: ReadonlyArray<{ readonly __typename?: 'PortfolioCoverageNode', readonly segment: PortfolioCoverageSegment, readonly people: number, readonly appUsers: number, readonly active7: number, readonly active30: number, readonly active90: number }>, readonly bookings?: { readonly __typename?: 'PortfolioBookingNode', readonly count: number, readonly communitiesWithBookings: number, readonly communityCount: number }, readonly applications?: { readonly __typename?: 'PortfolioApplicationSourceNode', readonly received: number, readonly inApp: number, readonly inAppShare?: number | null } } };

export type PortfolioWindowFieldsFragment = { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string };

export type PortfolioEngagementRowFieldsFragment = { readonly __typename?: 'PortfolioEngagementRowNode', readonly communityId?: string | null, readonly homes: number, readonly occupiedHomes: number, readonly appHomes: number, readonly activeHomes: number, readonly people: number, readonly appUsers: number, readonly activeUsers: number, readonly health?: number | null, readonly downloadRate?: number | null, readonly activeRate?: number | null };

export type PortfolioReachRowFieldsFragment = { readonly __typename?: 'PortfolioReachRowNode', readonly communityId?: string | null, readonly occupiedHomes: number, readonly updateReaderHomes: number, readonly documentViewerHomes: number, readonly updateReadShare?: number | null, readonly documentViewShare?: number | null };

export type PortfolioMaintenanceRowFieldsFragment = { readonly __typename?: 'PortfolioMaintenanceRowNode', readonly communityId?: string | null, readonly homes: number, readonly opened: number, readonly judged: number, readonly onTime: number, readonly closed: number, readonly medianCloseSeconds?: number | null, readonly openAtEnd: number, readonly openByAge: ReadonlyArray<number>, readonly health?: number | null, readonly openPerHundredHomes?: number | null };

export type PortfolioSatisfactionRowFieldsFragment = { readonly __typename?: 'PortfolioSatisfactionRowNode', readonly communityId?: string | null, readonly rated: number, readonly positive: number, readonly stars: ReadonlyArray<number>, readonly closed: number, readonly closedRated: number, readonly health?: number | null, readonly meanRating?: number | null, readonly responseRate?: number | null };

export type PortfolioCoverageFieldsFragment = { readonly __typename?: 'PortfolioCoverageNode', readonly segment: PortfolioCoverageSegment, readonly people: number, readonly appUsers: number, readonly active7: number, readonly active30: number, readonly active90: number };

export type PortfolioIssueTypeFieldsFragment = { readonly __typename?: 'PortfolioIssueTypeNode', readonly tagId: string, readonly name: string, readonly openAtEnd: number, readonly closed: number, readonly medianCloseSeconds?: number | null };

export type PortfolioRatingKindFieldsFragment = { readonly __typename?: 'PortfolioRatingKindNode', readonly kind: PortfolioRatingKind, readonly rated: number, readonly positive: number, readonly health?: number | null, readonly meanRating?: number | null };

export type PortfolioSatisfactionTimingFieldsFragment = { readonly __typename?: 'PortfolioSatisfactionTimingNode', readonly communityId?: string | null, readonly firstResponseSeconds?: number | null, readonly firstResponses: number, readonly replySeconds?: number | null, readonly replies: number, readonly closeSeconds?: number | null, readonly closes: number };

export type PortfolioMaintenanceReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  withTrend: Scalars['Boolean']['input'];
}>;


export type PortfolioMaintenanceReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingPortfolioMaintenance: { readonly __typename?: 'PortfolioMaintenanceReportingNode', readonly closeTargetDays: number, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceRowNode', readonly communityId?: string | null, readonly homes: number, readonly opened: number, readonly judged: number, readonly onTime: number, readonly closed: number, readonly medianCloseSeconds?: number | null, readonly openAtEnd: number, readonly openByAge: ReadonlyArray<number>, readonly health?: number | null, readonly openPerHundredHomes?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceRowNode', readonly communityId?: string | null, readonly homes: number, readonly opened: number, readonly judged: number, readonly onTime: number, readonly closed: number, readonly medianCloseSeconds?: number | null, readonly openAtEnd: number, readonly openByAge: ReadonlyArray<number>, readonly health?: number | null, readonly openPerHundredHomes?: number | null }> }>, readonly types?: ReadonlyArray<{ readonly __typename?: 'PortfolioIssueTypeNode', readonly tagId: string, readonly name: string, readonly openAtEnd: number, readonly closed: number, readonly medianCloseSeconds?: number | null }> } };

export type PortfolioOverviewReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  withTrend: Scalars['Boolean']['input'];
}>;


export type PortfolioOverviewReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingPortfolioEngagement: { readonly __typename?: 'PortfolioEngagementReportingNode', readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementRowNode', readonly communityId?: string | null, readonly homes: number, readonly occupiedHomes: number, readonly appHomes: number, readonly activeHomes: number, readonly people: number, readonly appUsers: number, readonly activeUsers: number, readonly health?: number | null, readonly downloadRate?: number | null, readonly activeRate?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioEngagementRowNode', readonly communityId?: string | null, readonly homes: number, readonly occupiedHomes: number, readonly appHomes: number, readonly activeHomes: number, readonly people: number, readonly appUsers: number, readonly activeUsers: number, readonly health?: number | null, readonly downloadRate?: number | null, readonly activeRate?: number | null }> }> }, readonly reportingPortfolioMaintenance: { readonly __typename?: 'PortfolioMaintenanceReportingNode', readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceRowNode', readonly communityId?: string | null, readonly homes: number, readonly opened: number, readonly judged: number, readonly onTime: number, readonly closed: number, readonly medianCloseSeconds?: number | null, readonly openAtEnd: number, readonly openByAge: ReadonlyArray<number>, readonly health?: number | null, readonly openPerHundredHomes?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioMaintenanceRowNode', readonly communityId?: string | null, readonly homes: number, readonly opened: number, readonly judged: number, readonly onTime: number, readonly closed: number, readonly medianCloseSeconds?: number | null, readonly openAtEnd: number, readonly openByAge: ReadonlyArray<number>, readonly health?: number | null, readonly openPerHundredHomes?: number | null }> }> }, readonly reportingPortfolioSatisfaction: { readonly __typename?: 'PortfolioSatisfactionReportingNode', readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionRowNode', readonly communityId?: string | null, readonly rated: number, readonly positive: number, readonly stars: ReadonlyArray<number>, readonly closed: number, readonly closedRated: number, readonly health?: number | null, readonly meanRating?: number | null, readonly responseRate?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionRowNode', readonly communityId?: string | null, readonly rated: number, readonly positive: number, readonly stars: ReadonlyArray<number>, readonly closed: number, readonly closedRated: number, readonly health?: number | null, readonly meanRating?: number | null, readonly responseRate?: number | null }> }> } };

export type PortfolioSatisfactionReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  withTrend: Scalars['Boolean']['input'];
}>;


export type PortfolioSatisfactionReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingPortfolioSatisfaction: { readonly __typename?: 'PortfolioSatisfactionReportingNode', readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionRowNode', readonly communityId?: string | null, readonly rated: number, readonly positive: number, readonly stars: ReadonlyArray<number>, readonly closed: number, readonly closedRated: number, readonly health?: number | null, readonly meanRating?: number | null, readonly responseRate?: number | null }>, readonly trend?: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionTrendNode', readonly window: { readonly __typename?: 'PortfolioWindowNode', readonly startDate: string, readonly endDate: string }, readonly rows: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionRowNode', readonly communityId?: string | null, readonly rated: number, readonly positive: number, readonly stars: ReadonlyArray<number>, readonly closed: number, readonly closedRated: number, readonly health?: number | null, readonly meanRating?: number | null, readonly responseRate?: number | null }> }>, readonly kinds: ReadonlyArray<{ readonly __typename?: 'PortfolioRatingKindNode', readonly kind: PortfolioRatingKind, readonly rated: number, readonly positive: number, readonly health?: number | null, readonly meanRating?: number | null }>, readonly timings: ReadonlyArray<{ readonly __typename?: 'PortfolioSatisfactionTimingNode', readonly communityId?: string | null, readonly firstResponseSeconds?: number | null, readonly firstResponses: number, readonly replySeconds?: number | null, readonly replies: number, readonly closeSeconds?: number | null, readonly closes: number }> } };

export type ApplicationComparisonFiguresFragment = { readonly __typename?: 'ApplicationReportingNode', readonly receivedWithMultipleAttempts: number, readonly received: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null }, readonly approved: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null }, readonly approvedByProof: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingProofCountNode', readonly hasProofOfAddress?: boolean | null, readonly count: number }>, readonly pending: { readonly __typename?: 'ApplicationReportingPendingNode', readonly atEnd?: { readonly __typename?: 'ApplicationReportingDayCountNode', readonly count?: number | null } | null }, readonly timeToApproval: { readonly __typename?: 'ApplicationReportingDurationNode', readonly medianSeconds?: number | null }, readonly outcomes: { readonly __typename?: 'ApplicationReportingOutcomesNode', readonly approvalRate?: number | null }, readonly resubmissions: { readonly __typename?: 'ApplicationReportingResubmissionsNode', readonly attemptsPerApproval?: number | null, readonly medianAttemptsPerApproval?: number | null, readonly resubmittedCount: number } };

export type ApplicationMedianAttemptsFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly resubmissions: { readonly __typename?: 'ApplicationReportingResubmissionsNode', readonly medianAttemptsPerApproval?: number | null } };

export type ApplicationMultipleAttemptsFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly receivedWithMultipleAttempts: number };

export type ApplicationFlowFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly flow: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingFlowLinkNode', readonly source: ApplicationReportingFlowStage, readonly target: ApplicationReportingFlowStage, readonly count: number }> };

export type ApplicationRejectionReasonFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly rejectionReasons: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingRejectionReasonCountNode', readonly reason?: string | null, readonly count: number }> };

export type ApplicationSubmissionSourceFigureFragment = { readonly __typename?: 'ApplicationReportingNode', readonly bySubmissionSource: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingSubmissionSourceCountNode', readonly submissionSource?: ApplicationReportingSubmissionSource | null, readonly count: number }> };

export type SiteApplicationReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteApplicationReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'ApplicationReportingNode', readonly receivedWithMultipleAttempts: number, readonly received: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly approved: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly approvedByProof: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingProofCountNode', readonly hasProofOfAddress?: boolean | null, readonly count: number }>, readonly pending: { readonly __typename?: 'ApplicationReportingPendingNode', readonly atEnd?: { readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly pendingByWait: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingWaitBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }>, readonly timeToApproval: { readonly __typename?: 'ApplicationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly outcomes: { readonly __typename?: 'ApplicationReportingOutcomesNode', readonly approvalRate?: number | null, readonly decidedCount: number, readonly byStatus: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingStatusCountNode', readonly status: ApplicationReportingStatus, readonly count: number }> }, readonly resubmissions: { readonly __typename?: 'ApplicationReportingResubmissionsNode', readonly attemptsPerApproval?: number | null, readonly approvedCount: number, readonly resubmittedCount: number, readonly medianAttemptsPerApproval?: number | null }, readonly flow: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingFlowLinkNode', readonly source: ApplicationReportingFlowStage, readonly target: ApplicationReportingFlowStage, readonly count: number }>, readonly rejectionReasons: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingRejectionReasonCountNode', readonly reason?: string | null, readonly count: number }>, readonly bySubmissionSource: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingSubmissionSourceCountNode', readonly submissionSource?: ApplicationReportingSubmissionSource | null, readonly count: number }> }, readonly previous: { readonly __typename?: 'ApplicationReportingNode', readonly receivedWithMultipleAttempts: number, readonly received: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null }, readonly approved: { readonly __typename?: 'ApplicationReportingCountNode', readonly total?: number | null }, readonly approvedByProof: ReadonlyArray<{ readonly __typename?: 'ApplicationReportingProofCountNode', readonly hasProofOfAddress?: boolean | null, readonly count: number }>, readonly pending: { readonly __typename?: 'ApplicationReportingPendingNode', readonly atEnd?: { readonly __typename?: 'ApplicationReportingDayCountNode', readonly count?: number | null } | null }, readonly timeToApproval: { readonly __typename?: 'ApplicationReportingDurationNode', readonly medianSeconds?: number | null }, readonly outcomes: { readonly __typename?: 'ApplicationReportingOutcomesNode', readonly approvalRate?: number | null }, readonly resubmissions: { readonly __typename?: 'ApplicationReportingResubmissionsNode', readonly attemptsPerApproval?: number | null, readonly medianAttemptsPerApproval?: number | null, readonly resubmittedCount: number } } };

export type BookingComparisonFiguresFragment = { readonly __typename?: 'BookingReportingNode', readonly bookings: { readonly __typename?: 'BookingReportingCountNode', readonly total?: number | null }, readonly cancellations: { readonly __typename?: 'BookingReportingCancellationNode', readonly total?: number | null, readonly rate?: number | null }, readonly leadTime: { readonly __typename?: 'BookingReportingLeadTimeNode', readonly medianSeconds?: number | null }, readonly residentReach: { readonly __typename?: 'BookingReportingResidentReachNode', readonly bookerCount: number, readonly share?: number | null } };

export type BookingCapacityFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly capacityUse: ReadonlyArray<{ readonly __typename?: 'BookingReportingCapacityNode', readonly amenityId: string, readonly label: string, readonly usedHours: number, readonly capacityHours?: number | null, readonly share?: number | null }> };

export type BookingResidentReachFigureFragment = { readonly __typename?: 'BookingReportingNode', readonly residentReach: { readonly __typename?: 'BookingReportingResidentReachNode', readonly bookerCount: number, readonly residentCount: number, readonly share?: number | null } };

export type SiteBookingReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteBookingReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'BookingReportingNode', readonly bookings: { readonly __typename?: 'BookingReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'BookingReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly byFacility: ReadonlyArray<{ readonly __typename?: 'BookingReportingFacilityNode', readonly amenityId?: string | null, readonly label: string, readonly count: number }>, readonly cancellations: { readonly __typename?: 'BookingReportingCancellationNode', readonly total?: number | null, readonly rate?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'BookingReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly leadTime: { readonly __typename?: 'BookingReportingLeadTimeNode', readonly medianSeconds?: number | null, readonly sampleCount: number }, readonly bookedBy: ReadonlyArray<{ readonly __typename?: 'BookingReportingBookedByNode', readonly bookedByStaff: boolean, readonly count: number }>, readonly slotPattern: ReadonlyArray<{ readonly __typename?: 'BookingReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly capacityUse: ReadonlyArray<{ readonly __typename?: 'BookingReportingCapacityNode', readonly amenityId: string, readonly label: string, readonly usedHours: number, readonly capacityHours?: number | null, readonly share?: number | null }>, readonly residentReach: { readonly __typename?: 'BookingReportingResidentReachNode', readonly bookerCount: number, readonly residentCount: number, readonly share?: number | null } }, readonly previous: { readonly __typename?: 'BookingReportingNode', readonly bookings: { readonly __typename?: 'BookingReportingCountNode', readonly total?: number | null }, readonly cancellations: { readonly __typename?: 'BookingReportingCancellationNode', readonly total?: number | null, readonly rate?: number | null }, readonly leadTime: { readonly __typename?: 'BookingReportingLeadTimeNode', readonly medianSeconds?: number | null }, readonly residentReach: { readonly __typename?: 'BookingReportingResidentReachNode', readonly bookerCount: number, readonly share?: number | null } } };

export type ConversationComparisonFiguresFragment = { readonly __typename?: 'ConversationReportingNode', readonly ratedShare?: number | null, readonly opened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly closed: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly reopened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly openConversations: { readonly __typename?: 'ConversationReportingOpenNode', readonly atEnd?: { readonly __typename?: 'ConversationReportingDayCountNode', readonly count?: number | null } | null }, readonly firstResponse: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly responseTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly resolutionTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly satisfaction: { readonly __typename?: 'ConversationReportingSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number } };

export type ConversationResolutionTimeFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly resolutionTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type ConversationSatisfactionByMonthFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly satisfactionByMonth: ReadonlyArray<{ readonly __typename?: 'ConversationReportingMonthRatingNode', readonly month: string, readonly meanRating?: number | null, readonly ratedCount: number }> };

export type ConversationBlockTagsFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly blockTags: ReadonlyArray<{ readonly __typename?: 'ConversationReportingBlockTagNode', readonly blockId: string, readonly blockLabel: string, readonly tagId: string, readonly count: number }> };

export type ConversationRatedShareFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly ratedShare?: number | null };

export type ConversationTopicComparisonFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly tagUseTotal: number, readonly topicComparison: ReadonlyArray<{ readonly __typename?: 'ConversationReportingTopicComparisonNode', readonly tagId: string, readonly label: string, readonly count: number, readonly yearAverage?: number | null }> };

export type ConversationTopicSatisfactionFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly satisfactionByTopic: ReadonlyArray<{ readonly __typename?: 'ConversationReportingTopicSatisfactionNode', readonly tagId: string, readonly label: string, readonly conversationCount: number, readonly meanRating: number }> };

export type ConversationOpenedPatternFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly openedPattern: ReadonlyArray<{ readonly __typename?: 'ConversationReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type ConversationChannelFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly byChannel: ReadonlyArray<{ readonly __typename?: 'ConversationReportingChannelCountNode', readonly channel: ConversationReportingChannel, readonly count: number }> };

export type ConversationSenderCategoryFigureFragment = { readonly __typename?: 'ConversationReportingNode', readonly bySenderCategory: ReadonlyArray<{ readonly __typename?: 'ConversationReportingSenderCategoryCountNode', readonly senderCategory: ConversationReportingSenderCategory, readonly count: number }> };

export type SiteConversationReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  tags: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteConversationReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'ConversationReportingNode', readonly ratedShare?: number | null, readonly opened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly closed: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly reopened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly openConversations: { readonly __typename?: 'ConversationReportingOpenNode', readonly atEnd?: { readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly firstResponse: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly responseTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly resolutionTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'ConversationReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly satisfaction: { readonly __typename?: 'ConversationReportingSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number, readonly byStar: ReadonlyArray<{ readonly __typename?: 'ConversationReportingStarCountNode', readonly stars: number, readonly count: number }> }, readonly satisfactionByMonth: ReadonlyArray<{ readonly __typename?: 'ConversationReportingMonthRatingNode', readonly month: string, readonly meanRating?: number | null, readonly ratedCount: number }>, readonly openedPattern: ReadonlyArray<{ readonly __typename?: 'ConversationReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly byChannel: ReadonlyArray<{ readonly __typename?: 'ConversationReportingChannelCountNode', readonly channel: ConversationReportingChannel, readonly count: number }>, readonly bySenderCategory: ReadonlyArray<{ readonly __typename?: 'ConversationReportingSenderCategoryCountNode', readonly senderCategory: ConversationReportingSenderCategory, readonly count: number }> }, readonly previous: { readonly __typename?: 'ConversationReportingNode', readonly ratedShare?: number | null, readonly opened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly closed: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly reopened: { readonly __typename?: 'ConversationReportingCountNode', readonly total?: number | null }, readonly openConversations: { readonly __typename?: 'ConversationReportingOpenNode', readonly atEnd?: { readonly __typename?: 'ConversationReportingDayCountNode', readonly count?: number | null } | null }, readonly firstResponse: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly responseTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly resolutionTime: { readonly __typename?: 'ConversationReportingDurationNode', readonly medianSeconds?: number | null }, readonly satisfaction: { readonly __typename?: 'ConversationReportingSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number } }, readonly topics: { readonly __typename?: 'ConversationReportingNode', readonly tagUseTotal: number, readonly satisfaction: { readonly __typename?: 'ConversationReportingSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number }, readonly topicComparison: ReadonlyArray<{ readonly __typename?: 'ConversationReportingTopicComparisonNode', readonly tagId: string, readonly label: string, readonly count: number, readonly yearAverage?: number | null }>, readonly satisfactionByTopic: ReadonlyArray<{ readonly __typename?: 'ConversationReportingTopicSatisfactionNode', readonly tagId: string, readonly label: string, readonly conversationCount: number, readonly meanRating: number }>, readonly blockTags: ReadonlyArray<{ readonly __typename?: 'ConversationReportingBlockTagNode', readonly blockId: string, readonly blockLabel: string, readonly tagId: string, readonly count: number }> } };

export type DocumentComparisonFiguresFragment = { readonly __typename?: 'DocumentReportingNode', readonly uniqueViewers: number, readonly added: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null }, readonly reminders: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null }, readonly liveByDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }> };

export type DocumentLiveByDayFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly liveByDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }> };

export type DocumentAllViewedFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly allViewed: { readonly __typename?: 'DocumentReportingAllViewedNode', readonly residentCount: number, readonly audienceCount: number, readonly viewedAllCount: number, readonly share?: number | null } };

export type DocumentReachFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly reach: ReadonlyArray<{ readonly __typename?: 'DocumentReportingReachNode', readonly documentId: string, readonly title: string, readonly audienceCount: number, readonly viewerCount: number, readonly share: number }> };

export type DocumentFirstViewsFigureFragment = { readonly __typename?: 'DocumentReportingNode', readonly firstViews: ReadonlyArray<{ readonly __typename?: 'DocumentReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type SiteDocumentReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  tags: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteDocumentReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'DocumentReportingNode', readonly uniqueViewers: number, readonly live: { readonly __typename?: 'DocumentReportingLiveNode', readonly count: number, readonly viewedCount: number, readonly viewedShare?: number | null }, readonly added: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly mostViewed: ReadonlyArray<{ readonly __typename?: 'DocumentReportingTopDocumentNode', readonly documentId: string, readonly title: string, readonly viewerCount: number }>, readonly tags: ReadonlyArray<{ readonly __typename?: 'DocumentReportingTagNode', readonly tagId: string, readonly label: string, readonly count: number }>, readonly reminders: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null }, readonly liveByDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }>, readonly allViewed: { readonly __typename?: 'DocumentReportingAllViewedNode', readonly residentCount: number, readonly audienceCount: number, readonly viewedAllCount: number, readonly share?: number | null }, readonly firstViews: ReadonlyArray<{ readonly __typename?: 'DocumentReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly reach: ReadonlyArray<{ readonly __typename?: 'DocumentReportingReachNode', readonly documentId: string, readonly title: string, readonly audienceCount: number, readonly viewerCount: number, readonly share: number }> }, readonly previous: { readonly __typename?: 'DocumentReportingNode', readonly uniqueViewers: number, readonly added: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null }, readonly reminders: { readonly __typename?: 'DocumentReportingCountNode', readonly total?: number | null }, readonly liveByDay: ReadonlyArray<{ readonly __typename?: 'DocumentReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type KeyComparisonFiguresFragment = { readonly __typename?: 'KeyReportingNode', readonly overdueAtEnd: number, readonly movements: { readonly __typename?: 'KeyReportingMovementsNode', readonly checkedOut?: number | null, readonly checkedIn?: number | null }, readonly keysOut: { readonly __typename?: 'KeyReportingKeysOutNode', readonly atEnd?: { readonly __typename?: 'KeyReportingDayCountNode', readonly count?: number | null } | null }, readonly timeHeld: { readonly __typename?: 'KeyReportingTimeHeldNode', readonly medianSeconds?: number | null } };

export type KeyOverdueAtEndFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly overdueAtEnd: number };

export type KeyActiveHoldersFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly activeHolders: number };

export type KeyLongestHeldFigureFragment = { readonly __typename?: 'KeyReportingNode', readonly longestHeld: ReadonlyArray<{ readonly __typename?: 'KeyReportingHeldKeyNode', readonly keyId: string, readonly label: string, readonly heldSeconds: number }> };

export type SiteKeyReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteKeyReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'KeyReportingNode', readonly activeHolders: number, readonly overdueAtEnd: number, readonly movements: { readonly __typename?: 'KeyReportingMovementsNode', readonly checkedOut?: number | null, readonly checkedIn?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayMovementNode', readonly day: string, readonly checkedOut?: number | null, readonly checkedIn?: number | null }> }, readonly keysOut: { readonly __typename?: 'KeyReportingKeysOutNode', readonly atEnd?: { readonly __typename?: 'KeyReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly timeHeld: { readonly __typename?: 'KeyReportingTimeHeldNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'KeyReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly daysHeld: { readonly __typename?: 'KeyReportingDaysHeldNode', readonly overdueCount: number, readonly buckets: ReadonlyArray<{ readonly __typename?: 'KeyReportingDaysHeldBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number, readonly overdue: boolean }> }, readonly holderCompanies: ReadonlyArray<{ readonly __typename?: 'KeyReportingHolderCompanyNode', readonly label: string, readonly count: number }>, readonly longestHeld: ReadonlyArray<{ readonly __typename?: 'KeyReportingHeldKeyNode', readonly keyId: string, readonly label: string, readonly heldSeconds: number }> }, readonly previous: { readonly __typename?: 'KeyReportingNode', readonly overdueAtEnd: number, readonly movements: { readonly __typename?: 'KeyReportingMovementsNode', readonly checkedOut?: number | null, readonly checkedIn?: number | null }, readonly keysOut: { readonly __typename?: 'KeyReportingKeysOutNode', readonly atEnd?: { readonly __typename?: 'KeyReportingDayCountNode', readonly count?: number | null } | null }, readonly timeHeld: { readonly __typename?: 'KeyReportingTimeHeldNode', readonly medianSeconds?: number | null } } };

export type PackageComparisonFiguresFragment = { readonly __typename?: 'PackageReportingNode', readonly overTwoWeeksAtEnd: number, readonly remindersPerPackage?: number | null, readonly delivered: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null }, readonly collected: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null }, readonly uncollected: { readonly __typename?: 'PackageReportingUncollectedNode', readonly atEnd?: { readonly __typename?: 'PackageReportingDayCountNode', readonly count?: number | null } | null }, readonly timeToCollection: { readonly __typename?: 'PackageReportingDurationNode', readonly medianSeconds?: number | null }, readonly reminders: { readonly __typename?: 'PackageReportingRemindersNode', readonly total?: number | null, readonly collectedWithin48HoursCount: number }, readonly lastReminder: { readonly __typename?: 'PackageReportingLastReminderNode', readonly medianSeconds?: number | null }, readonly dataQuality: { readonly __typename?: 'PackageReportingDataQualityNode', readonly markedAsDuplicate?: number | null, readonly markedAsIncorrectlyAssigned?: number | null } };

export type PackageCollectionPatternFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly collectionPattern: ReadonlyArray<{ readonly __typename?: 'PackageReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type PackageWaitingHomesFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly waitingHomes: ReadonlyArray<{ readonly __typename?: 'PackageReportingHomeCountNode', readonly homeId: string, readonly label: string, readonly count: number }> };

export type PackageCollectedAfterReminderFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly reminders: { readonly __typename?: 'PackageReportingRemindersNode', readonly total?: number | null, readonly collectedWithin48HoursCount: number } };

export type PackageRemindersPerPackageFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly remindersPerPackage?: number | null };

export type PackageLastReminderFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly lastReminder: { readonly __typename?: 'PackageReportingLastReminderNode', readonly medianSeconds?: number | null, readonly sampleCount: number } };

export type PackageWaitingAtEndFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly overTwoWeeksAtEnd: number };

export type PackageLocationFigureFragment = { readonly __typename?: 'PackageReportingNode', readonly locations: ReadonlyArray<{ readonly __typename?: 'PackageReportingLocationCountNode', readonly location?: string | null, readonly count: number }> };

export type SitePackageReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SitePackageReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'PackageReportingNode', readonly remindersPerPackage?: number | null, readonly overTwoWeeksAtEnd: number, readonly delivered: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly collected: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly uncollected: { readonly __typename?: 'PackageReportingUncollectedNode', readonly atEnd?: { readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly timeToCollection: { readonly __typename?: 'PackageReportingDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'PackageReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly ageing: { readonly __typename?: 'PackageReportingAgeingNode', readonly overTwoWeeks?: number | null, readonly buckets: ReadonlyArray<{ readonly __typename?: 'PackageReportingAgeBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> }, readonly deliveryPattern: ReadonlyArray<{ readonly __typename?: 'PackageReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly reminders: { readonly __typename?: 'PackageReportingRemindersNode', readonly total?: number | null, readonly collectedWithin48HoursCount: number }, readonly dataQuality: { readonly __typename?: 'PackageReportingDataQualityNode', readonly markedAsDuplicate?: number | null, readonly markedAsIncorrectlyAssigned?: number | null }, readonly collectionPattern: ReadonlyArray<{ readonly __typename?: 'PackageReportingHourCountNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly waitingHomes: ReadonlyArray<{ readonly __typename?: 'PackageReportingHomeCountNode', readonly homeId: string, readonly label: string, readonly count: number }>, readonly lastReminder: { readonly __typename?: 'PackageReportingLastReminderNode', readonly medianSeconds?: number | null, readonly sampleCount: number }, readonly locations: ReadonlyArray<{ readonly __typename?: 'PackageReportingLocationCountNode', readonly location?: string | null, readonly count: number }> }, readonly previous: { readonly __typename?: 'PackageReportingNode', readonly overTwoWeeksAtEnd: number, readonly remindersPerPackage?: number | null, readonly delivered: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null }, readonly collected: { readonly __typename?: 'PackageReportingCountNode', readonly total?: number | null }, readonly uncollected: { readonly __typename?: 'PackageReportingUncollectedNode', readonly atEnd?: { readonly __typename?: 'PackageReportingDayCountNode', readonly count?: number | null } | null }, readonly timeToCollection: { readonly __typename?: 'PackageReportingDurationNode', readonly medianSeconds?: number | null }, readonly reminders: { readonly __typename?: 'PackageReportingRemindersNode', readonly total?: number | null, readonly collectedWithin48HoursCount: number }, readonly lastReminder: { readonly __typename?: 'PackageReportingLastReminderNode', readonly medianSeconds?: number | null }, readonly dataQuality: { readonly __typename?: 'PackageReportingDataQualityNode', readonly markedAsDuplicate?: number | null, readonly markedAsIncorrectlyAssigned?: number | null } } };

export type UpdateComparisonFiguresFragment = { readonly __typename?: 'UpdateReportingNode', readonly uniqueReaders: number, readonly published: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly readRate: { readonly __typename?: 'UpdateReportingReadRateNode', readonly rate?: number | null }, readonly likes: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly comments: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly scheduled: { readonly __typename?: 'UpdateReportingScheduledNode', readonly share?: number | null }, readonly contentMix: { readonly __typename?: 'UpdateReportingContentMixNode', readonly imageShare?: number | null, readonly attachmentShare?: number | null }, readonly engagement: { readonly __typename?: 'UpdateReportingEngagementNode', readonly index?: number | null } };

export type UpdateEngagementRowFragment = { readonly __typename?: 'UpdateReportingUpdateEngagementNode', readonly updateId?: string | null, readonly title: string, readonly publishedAt: string, readonly likes: number, readonly comments: number, readonly views: number, readonly uniqueViews: number, readonly audienceSize: number, readonly engagementIndex?: number | null };

export type UpdateEngagementTableFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly engagement: { readonly __typename?: 'UpdateReportingEngagementNode', readonly likes: number, readonly comments: number, readonly uniqueViews: number, readonly audienceSize: number, readonly index?: number | null, readonly byUpdate: ReadonlyArray<{ readonly __typename?: 'UpdateReportingUpdateEngagementNode', readonly updateId?: string | null, readonly title: string, readonly publishedAt: string, readonly likes: number, readonly comments: number, readonly views: number, readonly uniqueViews: number, readonly audienceSize: number, readonly engagementIndex?: number | null }> } };

export type UpdateContentMixFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly contentMix: { readonly __typename?: 'UpdateReportingContentMixNode', readonly publishedCount: number, readonly withImageCount: number, readonly withAttachmentCount: number, readonly imageShare?: number | null, readonly attachmentShare?: number | null } };

export type UpdatePublishedByWeekFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly published: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null, readonly byWeek: ReadonlyArray<{ readonly __typename?: 'UpdateReportingWeekCountNode', readonly week: string, readonly count?: number | null }> } };

export type UpdatePublishedByStaffFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly publishedByStaff: ReadonlyArray<{ readonly __typename?: 'UpdateReportingStaffCountNode', readonly userId: string, readonly name: string, readonly count: number }> };

export type SiteUpdateReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  blocks: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type SiteUpdateReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'UpdateReportingNode', readonly uniqueReaders: number, readonly published: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null, readonly byWeek: ReadonlyArray<{ readonly __typename?: 'UpdateReportingWeekCountNode', readonly week: string, readonly count?: number | null }> }, readonly readRate: { readonly __typename?: 'UpdateReportingReadRateNode', readonly rate?: number | null, readonly updateCount: number }, readonly likes: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly comments: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly categories: ReadonlyArray<{ readonly __typename?: 'UpdateReportingCategoryCountNode', readonly category: UpdateReportingCategory, readonly count: number }>, readonly topUpdates: ReadonlyArray<{ readonly __typename?: 'UpdateReportingTopUpdateNode', readonly updateId: string, readonly title: string, readonly readerCount: number }>, readonly scheduled: { readonly __typename?: 'UpdateReportingScheduledNode', readonly share?: number | null, readonly scheduledCount: number, readonly publishedCount: number }, readonly engagement: { readonly __typename?: 'UpdateReportingEngagementNode', readonly likes: number, readonly comments: number, readonly uniqueViews: number, readonly audienceSize: number, readonly index?: number | null, readonly byUpdate: ReadonlyArray<{ readonly __typename?: 'UpdateReportingUpdateEngagementNode', readonly updateId?: string | null, readonly title: string, readonly publishedAt: string, readonly likes: number, readonly comments: number, readonly views: number, readonly uniqueViews: number, readonly audienceSize: number, readonly engagementIndex?: number | null }> }, readonly contentMix: { readonly __typename?: 'UpdateReportingContentMixNode', readonly publishedCount: number, readonly withImageCount: number, readonly withAttachmentCount: number, readonly imageShare?: number | null, readonly attachmentShare?: number | null }, readonly publishedByStaff: ReadonlyArray<{ readonly __typename?: 'UpdateReportingStaffCountNode', readonly userId: string, readonly name: string, readonly count: number }> }, readonly previous: { readonly __typename?: 'UpdateReportingNode', readonly uniqueReaders: number, readonly published: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly readRate: { readonly __typename?: 'UpdateReportingReadRateNode', readonly rate?: number | null }, readonly likes: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly comments: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly scheduled: { readonly __typename?: 'UpdateReportingScheduledNode', readonly share?: number | null }, readonly contentMix: { readonly __typename?: 'UpdateReportingContentMixNode', readonly imageShare?: number | null, readonly attachmentShare?: number | null }, readonly engagement: { readonly __typename?: 'UpdateReportingEngagementNode', readonly index?: number | null } } };

export type VisitComparisonFiguresFragment = { readonly __typename?: 'VisitReportingNode', readonly signIns: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null }, readonly signOuts: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null }, readonly timeOnSite: { readonly __typename?: 'VisitReportingTimeOnSiteNode', readonly medianSeconds?: number | null }, readonly notSignedOut: { readonly __typename?: 'VisitReportingNotSignedOutNode', readonly total: number } };

export type VisitSignOutsFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly signOuts: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type SiteVisitReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  previousPeriod: ReportingPeriodInput;
  visitorTypes: ReadonlyArray<VisitReportingVisitorType> | VisitReportingVisitorType;
}>;


export type SiteVisitReportQuery = { readonly __typename?: 'DebugSchema', readonly current: { readonly __typename?: 'VisitReportingNode', readonly onSiteNow: number, readonly signIns: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly signOuts: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayCountNode', readonly day: string, readonly count?: number | null }> }, readonly visitorTypes: ReadonlyArray<{ readonly __typename?: 'VisitReportingVisitorTypeNode', readonly visitorType?: VisitReportingVisitorType | null, readonly count: number }>, readonly timeOnSite: { readonly __typename?: 'VisitReportingTimeOnSiteNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> }, readonly notSignedOut: { readonly __typename?: 'VisitReportingNotSignedOutNode', readonly total: number, readonly buckets: ReadonlyArray<{ readonly __typename?: 'VisitReportingAgeBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> }, readonly arrivals: ReadonlyArray<{ readonly __typename?: 'VisitReportingArrivalNode', readonly weekday: number, readonly hour: number, readonly count: number }>, readonly companies: ReadonlyArray<{ readonly __typename?: 'VisitReportingCompanyNode', readonly label: string, readonly count: number }> }, readonly previous: { readonly __typename?: 'VisitReportingNode', readonly signIns: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null }, readonly signOuts: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null }, readonly timeOnSite: { readonly __typename?: 'VisitReportingTimeOnSiteNode', readonly medianSeconds?: number | null }, readonly notSignedOut: { readonly __typename?: 'VisitReportingNotSignedOutNode', readonly total: number } } };

export type UpdatePublishedFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly published: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'UpdateReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type UpdateReadersFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly uniqueReaders: number };

export type UpdateReadRateFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly readRate: { readonly __typename?: 'UpdateReportingReadRateNode', readonly rate?: number | null, readonly updateCount: number } };

export type UpdateEngagementFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly likes: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null }, readonly comments: { readonly __typename?: 'UpdateReportingCountNode', readonly total?: number | null } };

export type UpdateCategoryFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly categories: ReadonlyArray<{ readonly __typename?: 'UpdateReportingCategoryCountNode', readonly category: UpdateReportingCategory, readonly count: number }> };

export type UpdateTopUpdatesFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly topUpdates: ReadonlyArray<{ readonly __typename?: 'UpdateReportingTopUpdateNode', readonly updateId: string, readonly title: string, readonly readerCount: number }> };

export type UpdateScheduledFigureFragment = { readonly __typename?: 'UpdateReportingNode', readonly scheduled: { readonly __typename?: 'UpdateReportingScheduledNode', readonly share?: number | null, readonly scheduledCount: number, readonly publishedCount: number } };

export type VisitOnSiteFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly onSiteNow: number };

export type VisitSignInsFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly signIns: { readonly __typename?: 'VisitReportingCountNode', readonly total?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayCountNode', readonly day: string, readonly count?: number | null }> } };

export type VisitorTypesFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly visitorTypes: ReadonlyArray<{ readonly __typename?: 'VisitReportingVisitorTypeNode', readonly visitorType?: VisitReportingVisitorType | null, readonly count: number }> };

export type VisitTimeOnSiteFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly timeOnSite: { readonly __typename?: 'VisitReportingTimeOnSiteNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'VisitReportingDayDurationNode', readonly day: string, readonly medianSeconds?: number | null }> } };

export type VisitNotSignedOutFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly notSignedOut: { readonly __typename?: 'VisitReportingNotSignedOutNode', readonly total: number, readonly buckets: ReadonlyArray<{ readonly __typename?: 'VisitReportingAgeBucketNode', readonly minDays: number, readonly maxDays?: number | null, readonly count: number }> } };

export type VisitArrivalsFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly arrivals: ReadonlyArray<{ readonly __typename?: 'VisitReportingArrivalNode', readonly weekday: number, readonly hour: number, readonly count: number }> };

export type VisitCompaniesFigureFragment = { readonly __typename?: 'VisitReportingNode', readonly companies: ReadonlyArray<{ readonly __typename?: 'VisitReportingCompanyNode', readonly label: string, readonly count: number }> };

export type CreateReportingConfigurationMutationVariables = Exact<{
  input: CreateReportingConfigurationInput;
}>;


export type CreateReportingConfigurationMutation = { readonly __typename?: 'Mutation', readonly createReportingConfiguration?: { readonly __typename?: 'CreateReportingConfigurationPayload', readonly configuration: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly name: string, readonly reportKey: string, readonly schemaVersion: number, readonly configuration: string, readonly revision: number, readonly isFavourite: boolean, readonly lastOpenedAt?: string | null, readonly createdAt: string } } | null };

export type DeleteReportingConfigurationMutationVariables = Exact<{
  input: DeleteReportingConfigurationInput;
}>;


export type DeleteReportingConfigurationMutation = { readonly __typename?: 'Mutation', readonly deleteReportingConfiguration?: { readonly __typename?: 'DeleteReportingConfigurationPayload', readonly deletedId: string } | null };

export type RecordReportingConfigurationOpenedMutationVariables = Exact<{
  input: RecordReportingConfigurationOpenedInput;
}>;


export type RecordReportingConfigurationOpenedMutation = { readonly __typename?: 'Mutation', readonly recordReportingConfigurationOpened?: { readonly __typename?: 'RecordReportingConfigurationOpenedPayload', readonly configuration: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly lastOpenedAt?: string | null } } | null };

export type ReportingConfigurationQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReportingConfigurationQuery = { readonly __typename?: 'DebugSchema', readonly reportingConfiguration?: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly name: string, readonly reportKey: string, readonly schemaVersion: number, readonly configuration: string, readonly revision: number, readonly isFavourite: boolean, readonly lastOpenedAt?: string | null, readonly createdAt: string, readonly schedules: ReadonlyArray<{ readonly __typename?: 'ReportingScheduleNode', readonly id: string, readonly cadence?: ReportingScheduleCadence | null, readonly nextRunAt: string }> } | null };

export type ReportingConfigurationFieldsFragment = { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly name: string, readonly reportKey: string, readonly schemaVersion: number, readonly configuration: string, readonly revision: number, readonly isFavourite: boolean, readonly lastOpenedAt?: string | null, readonly createdAt: string };

export type ReportingConfigurationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportingConfigurationsQuery = { readonly __typename?: 'DebugSchema', readonly reportingConfigurations: ReadonlyArray<{ readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly name: string, readonly reportKey: string, readonly schemaVersion: number, readonly configuration: string, readonly revision: number, readonly isFavourite: boolean, readonly lastOpenedAt?: string | null, readonly createdAt: string }> };

export type ReportingScheduleFieldsFragment = { readonly __typename?: 'ReportingScheduleNode', readonly id: string, readonly cadence?: ReportingScheduleCadence | null, readonly nextRunAt: string };

export type ReportingTeamMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type ReportingTeamMembersQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamMembers: ReadonlyArray<{ readonly __typename?: 'TeamRosterMemberNode', readonly userId: string, readonly name: string, readonly communityIds: ReadonlyArray<string> }> };

export type SetReportingFavouriteMutationVariables = Exact<{
  input: SetReportingFavouriteInput;
}>;


export type SetReportingFavouriteMutation = { readonly __typename?: 'Mutation', readonly setReportingFavourite?: { readonly __typename?: 'SetReportingFavouritePayload', readonly configuration: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly isFavourite: boolean } } | null };

export type SetReportingScheduleMutationVariables = Exact<{
  input: SetReportingScheduleInput;
}>;


export type SetReportingScheduleMutation = { readonly __typename?: 'Mutation', readonly setReportingSchedule?: { readonly __typename?: 'SetReportingSchedulePayload', readonly configuration: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly schedules: ReadonlyArray<{ readonly __typename?: 'ReportingScheduleNode', readonly id: string, readonly cadence?: ReportingScheduleCadence | null, readonly nextRunAt: string }> } } | null };

export type TeamActivityFiguresFragment = { readonly __typename?: 'TeamActivityReportingNode', readonly sessionLength: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly presence: { readonly __typename?: 'TeamPresenceNode', readonly activeMemberCount: number, readonly memberCount: number, readonly medianSessionsPerMember?: number | null } };

export type TeamActivityReportQueryVariables = Exact<{
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type TeamActivityReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamActivity: { readonly __typename?: 'TeamActivityReportingNode', readonly sessionLength: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly presence: { readonly __typename?: 'TeamPresenceNode', readonly activeMemberCount: number, readonly memberCount: number, readonly medianSessionsPerMember?: number | null } } };

export type TeamApplicationFiguresFragment = { readonly __typename?: 'TeamApplicationReportingNode', readonly decisions: { readonly __typename?: 'TeamDecisionsNode', readonly approved: number, readonly rejected: number, readonly medianActionSeconds?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDecisionsNode', readonly approved: number, readonly rejected: number, readonly medianActionSeconds?: number | null, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } };

export type TeamApplicationReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type TeamApplicationReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamApplications: { readonly __typename?: 'TeamApplicationReportingNode', readonly decisions: { readonly __typename?: 'TeamDecisionsNode', readonly approved: number, readonly rejected: number, readonly medianActionSeconds?: number | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDecisionsNode', readonly approved: number, readonly rejected: number, readonly medianActionSeconds?: number | null, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } } };

export type TeamTopicFieldsFragment = { readonly __typename?: 'TeamMemberTopicNode', readonly tagId: string, readonly label: string, readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } };

export type TeamMemberRatingFragment = { readonly __typename?: 'TeamMemberRatingNode', readonly meanRating: number, readonly ratedCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } };

export type TeamConversationFiguresFragment = { readonly __typename?: 'TeamConversationReportingNode', readonly responseTime: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly firstResponse: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly resolved: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly assigned: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly openConversations: { readonly __typename?: 'TeamOpenNode', readonly atEnd?: { readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly satisfaction: { readonly __typename?: 'TeamSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberRatingNode', readonly meanRating: number, readonly ratedCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly topics: ReadonlyArray<{ readonly __typename?: 'TeamMemberTopicNode', readonly tagId: string, readonly label: string, readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> };

export type TeamConversationReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type TeamConversationReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamConversations: { readonly __typename?: 'TeamConversationReportingNode', readonly responseTime: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly firstResponse: { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly resolved: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly assigned: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly openConversations: { readonly __typename?: 'TeamOpenNode', readonly atEnd?: { readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null } | null, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly satisfaction: { readonly __typename?: 'TeamSatisfactionNode', readonly meanRating?: number | null, readonly ratedCount: number, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberRatingNode', readonly meanRating: number, readonly ratedCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly topics: ReadonlyArray<{ readonly __typename?: 'TeamMemberTopicNode', readonly tagId: string, readonly label: string, readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } };

export type TeamDocumentFiguresFragment = { readonly __typename?: 'TeamDocumentReportingNode', readonly uploaded: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly reach: { readonly __typename?: 'TeamDocumentReachNode', readonly documentCount: number, readonly viewCount: number, readonly neverViewedCount: number, readonly viewsPerDocument?: number | null, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDocumentReachNode', readonly documentCount: number, readonly viewCount: number, readonly neverViewedCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } };

export type TeamDocumentReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type TeamDocumentReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamDocuments: { readonly __typename?: 'TeamDocumentReportingNode', readonly uploaded: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly reach: { readonly __typename?: 'TeamDocumentReachNode', readonly documentCount: number, readonly viewCount: number, readonly neverViewedCount: number, readonly viewsPerDocument?: number | null, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDocumentReachNode', readonly documentCount: number, readonly viewCount: number, readonly neverViewedCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } } };

export type TeamMemberFieldsFragment = { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string };

export type TeamRosterMemberFieldsFragment = { readonly __typename?: 'TeamRosterMemberNode', readonly userId: string, readonly name: string, readonly communityIds: ReadonlyArray<string> };

export type TeamDayFieldsFragment = { readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null };

export type TeamCountFieldsFragment = { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> };

export type TeamDurationFieldsFragment = { readonly __typename?: 'TeamDurationNode', readonly medianSeconds?: number | null, readonly sampleCount: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberDurationNode', readonly medianSeconds: number, readonly sampleCount: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> };

export type TeamMemberRatingsQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  userId: Scalars['UUID']['input'];
}>;


export type TeamMemberRatingsQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamConversations: { readonly __typename?: 'TeamConversationReportingNode', readonly memberRatings: ReadonlyArray<{ readonly __typename?: 'TeamRatedConversationNode', readonly conversationId: string, readonly subject: string, readonly stars: number, readonly ratedAt: string }> } };

export type TeamUpdateFiguresFragment = { readonly __typename?: 'TeamUpdateReportingNode', readonly published: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly reach: { readonly __typename?: 'TeamReachNode', readonly updateCount: number, readonly readerCount: number, readonly likeCount: number, readonly audienceSize: number, readonly readersPerUpdate?: number | null, readonly likesPerUpdate?: number | null, readonly readRate?: number | null, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberReachNode', readonly updateCount: number, readonly readerCount: number, readonly likeCount: number, readonly readersPerUpdate: number, readonly likesPerUpdate: number, readonly readRate?: number | null, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } };

export type TeamUpdateReportQueryVariables = Exact<{
  communities: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  period: ReportingPeriodInput;
  staff?: InputMaybe<ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input']>;
}>;


export type TeamUpdateReportQuery = { readonly __typename?: 'DebugSchema', readonly reportingTeamUpdates: { readonly __typename?: 'TeamUpdateReportingNode', readonly published: { readonly __typename?: 'TeamCountNode', readonly total: number, readonly byDay: ReadonlyArray<{ readonly __typename?: 'TeamDayValueNode', readonly day: string, readonly value?: number | null }>, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberCountNode', readonly count: number, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> }, readonly reach: { readonly __typename?: 'TeamReachNode', readonly updateCount: number, readonly readerCount: number, readonly likeCount: number, readonly audienceSize: number, readonly readersPerUpdate?: number | null, readonly likesPerUpdate?: number | null, readonly readRate?: number | null, readonly byMember: ReadonlyArray<{ readonly __typename?: 'TeamMemberReachNode', readonly updateCount: number, readonly readerCount: number, readonly likeCount: number, readonly readersPerUpdate: number, readonly likesPerUpdate: number, readonly readRate?: number | null, readonly member: { readonly __typename?: 'TeamMemberNode', readonly userId: string, readonly name: string } }> } } };

export type UpdateReportingConfigurationMutationVariables = Exact<{
  input: UpdateReportingConfigurationInput;
}>;


export type UpdateReportingConfigurationMutation = { readonly __typename?: 'Mutation', readonly updateReportingConfiguration?: { readonly __typename?: 'UpdateReportingConfigurationPayload', readonly conflict: boolean, readonly configuration: { readonly __typename?: 'ReportingConfigurationNode', readonly id: string, readonly name: string, readonly reportKey: string, readonly schemaVersion: number, readonly configuration: string, readonly revision: number, readonly isFavourite: boolean, readonly lastOpenedAt?: string | null, readonly createdAt: string } } | null };

export type GetRulesQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRulesQuery = { readonly __typename?: 'DebugSchema', readonly rules?: { readonly __typename?: 'RuleNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleNodeEdge', readonly node?: { readonly __typename?: 'RuleNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly activatedAt?: string | null, readonly executionCount: number, readonly createdAt: string, readonly updatedAt: string, readonly categoryContentTypes?: ReadonlyArray<string | null> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> }, readonly conditions?: { readonly __typename?: 'RuleConditionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleConditionNodeEdge', readonly node?: { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null } | null> } | null, readonly actions?: { readonly __typename?: 'RuleActionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleActionNodeEdge', readonly node?: { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null } | null } | null> } | null } | null } | null> } | null };

export type CreateRuleMutationVariables = Exact<{
  input: CreateRuleInput;
}>;


export type CreateRuleMutation = { readonly __typename?: 'Mutation', readonly createRule?: { readonly __typename?: 'CreateRulePayload', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly activatedAt?: string | null, readonly executionCount: number, readonly createdAt: string, readonly updatedAt: string, readonly categoryContentTypes?: ReadonlyArray<string | null> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> }, readonly conditions?: { readonly __typename?: 'RuleConditionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleConditionNodeEdge', readonly node?: { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null } | null> } | null, readonly actions?: { readonly __typename?: 'RuleActionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleActionNodeEdge', readonly node?: { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null } | null } | null> } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type RuleConditionFragment = { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string };

export type RuleActionFragment = { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null };

export type RuleFragment = { readonly __typename?: 'RuleNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly activatedAt?: string | null, readonly executionCount: number, readonly createdAt: string, readonly updatedAt: string, readonly categoryContentTypes?: ReadonlyArray<string | null> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> }, readonly conditions?: { readonly __typename?: 'RuleConditionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleConditionNodeEdge', readonly node?: { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null } | null> } | null, readonly actions?: { readonly __typename?: 'RuleActionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleActionNodeEdge', readonly node?: { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null } | null } | null> } | null };

export type CreateRuleActionMutationVariables = Exact<{
  input: CreateRuleActionInput;
}>;


export type CreateRuleActionMutation = { readonly __typename?: 'Mutation', readonly createRuleAction?: { readonly __typename?: 'CreateRuleActionPayload', readonly ruleAction?: { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteRuleActionMutationVariables = Exact<{
  input: DeleteRuleActionInput;
}>;


export type DeleteRuleActionMutation = { readonly __typename?: 'Mutation', readonly deleteRuleAction?: { readonly __typename?: 'DeleteRuleActionPayload', readonly ruleAction?: { readonly __typename?: 'RuleActionNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateRuleConditionsMutationVariables = Exact<{
  input: CreateRuleConditionsInput;
}>;


export type CreateRuleConditionsMutation = { readonly __typename?: 'Mutation', readonly createRuleConditions?: { readonly __typename?: 'CreateRuleConditions', readonly ruleConditions?: ReadonlyArray<{ readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null> | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type DeleteRuleConditionMutationVariables = Exact<{
  input: DeleteRuleConditionInput;
}>;


export type DeleteRuleConditionMutation = { readonly __typename?: 'Mutation', readonly deleteRuleCondition?: { readonly __typename?: 'DeleteRuleConditionPayload', readonly ruleCondition?: { readonly __typename?: 'RuleConditionNode', readonly id: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateRuleConditionMutationVariables = Exact<{
  input: UpdateRuleConditionInput;
}>;


export type UpdateRuleConditionMutation = { readonly __typename?: 'Mutation', readonly updateRuleCondition?: { readonly __typename?: 'UpdateRuleConditionPayload', readonly ruleCondition?: { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type RuleCommunityFragment = { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly avatar?: string | null, readonly residentCount: number, readonly homeCount: number };

export type RuleCommunitiesQueryVariables = Exact<{
  orderBy?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type RuleCommunitiesQuery = { readonly __typename?: 'DebugSchema', readonly communities?: { readonly __typename?: 'CommunityNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly avatar?: string | null, readonly residentCount: number, readonly homeCount: number } | null } | null> } | null };

export type UpdateRuleCategoryContentTypesMutationVariables = Exact<{
  input: UpdateRuleCategoryContentTypesInput;
}>;


export type UpdateRuleCategoryContentTypesMutation = { readonly __typename?: 'Mutation', readonly updateRuleCategoryContentTypes?: { readonly __typename?: 'UpdateRuleCategoryContentTypes', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly categoryContentTypes?: ReadonlyArray<string | null> | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateRuleCommunitiesMutationVariables = Exact<{
  input: UpdateRuleCommunitiesInput;
}>;


export type UpdateRuleCommunitiesMutation = { readonly __typename?: 'Mutation', readonly updateRuleCommunities?: { readonly __typename?: 'UpdateRuleCommunitiesPayload', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type RuleQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type RuleQuery = { readonly __typename?: 'DebugSchema', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly activatedAt?: string | null, readonly executionCount: number, readonly createdAt: string, readonly updatedAt: string, readonly categoryContentTypes?: ReadonlyArray<string | null> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly email: string } | null, readonly communities: { readonly __typename?: 'CommunityNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityNodeEdge', readonly node?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null> }, readonly conditions?: { readonly __typename?: 'RuleConditionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleConditionNodeEdge', readonly node?: { readonly __typename?: 'RuleConditionNode', readonly id: string, readonly event: RulesRuleConditionEventChoices, readonly operator: RulesRuleConditionOperatorChoices, readonly objectId?: string | null, readonly createdAt: string, readonly updatedAt: string } | null } | null> } | null, readonly actions?: { readonly __typename?: 'RuleActionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'RuleActionNodeEdge', readonly node?: { readonly __typename?: 'RuleActionNode', readonly id: string, readonly action: RulesRuleActionActionChoices, readonly objectId: string, readonly createdAt: string, readonly updatedAt: string, readonly target?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null, readonly icon?: string | null } | { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly displayPicture?: string | null } | null } | null } | null> } | null } | null };

export type ToggleRuleActivatedMutationVariables = Exact<{
  input: ToggleRuleActivatedInput;
}>;


export type ToggleRuleActivatedMutation = { readonly __typename?: 'Mutation', readonly toggleRuleActivated?: { readonly __typename?: 'ToggleRuleActivatedPayload', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly activatedAt?: string | null, readonly updatedAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateRuleMutationVariables = Exact<{
  input: UpdateRuleInput;
}>;


export type UpdateRuleMutation = { readonly __typename?: 'Mutation', readonly updateRule?: { readonly __typename?: 'UpdateRulePayload', readonly rule?: { readonly __typename?: 'RuleNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly executionCount: number, readonly updatedAt: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SafetyComplianceReadinessQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type SafetyComplianceReadinessQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyComplianceV2ActivatedAt?: string | null }, readonly safetyComplianceReadiness: { readonly __typename?: 'SafetyComplianceReadinessType', readonly activatedAt?: string | null, readonly eligibleNow: number, readonly eligibleAfterActivation: number, readonly leavingPackCount: number, readonly awaitingExplicitConsentCount: number, readonly pcfraOfferedNotCompletedCount: number, readonly pcfraStatusChangedCount: number } } | null };

export type ActivateSafetyComplianceV2MutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  confirm: Scalars['Boolean']['input'];
}>;


export type ActivateSafetyComplianceV2Mutation = { readonly __typename?: 'Mutation', readonly activateSafetyComplianceV2?: { readonly __typename?: 'ActivateSafetyComplianceV2', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly readiness: { readonly __typename?: 'SafetyComplianceReadinessType', readonly activatedAt?: string | null, readonly eligibleNow: number, readonly eligibleAfterActivation: number, readonly leavingPackCount: number, readonly awaitingExplicitConsentCount: number, readonly pcfraOfferedNotCompletedCount: number, readonly pcfraStatusChangedCount: number } } | null };

export type ActivateSafetyResponderTokenMutationVariables = Exact<{
  packId: Scalars['UUID']['input'];
  installed: Scalars['Boolean']['input'];
}>;


export type ActivateSafetyResponderTokenMutation = { readonly __typename?: 'Mutation', readonly activateSafetyResponderToken?: { readonly __typename?: 'ActivateSafetyResponderToken', readonly pack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null };

export type RotateSafetyResponderTokenMutationVariables = Exact<{
  packId: Scalars['UUID']['input'];
  reason: Scalars['String']['input'];
}>;


export type RotateSafetyResponderTokenMutation = { readonly __typename?: 'Mutation', readonly rotateSafetyResponderToken?: { readonly __typename?: 'RotateSafetyResponderToken', readonly residualWindow: string, readonly pack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null };

export type SafetyReviewCadenceQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type SafetyReviewCadenceQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number } } | null };

export type UpdateSafetyReviewIntervalMutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  months: Scalars['Int']['input'];
}>;


export type UpdateSafetyReviewIntervalMutation = { readonly __typename?: 'Mutation', readonly updateSafetyReviewInterval?: { readonly __typename?: 'UpdateSafetyReviewInterval', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number } } | null } | null };

export type LatestDeclarationFragment = { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean };

export type SafetyDocumentBuildingFragment = { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null };

export type SafetyCenterDocumentItemFragment = { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly title: string, readonly description: string, readonly sibCategory?: ResidentialManagementSafetyCenterDocumentSibCategoryChoices | null, readonly includeInSibPack: boolean, readonly showInSafetyCenter: boolean, readonly fileName?: string | null, readonly effectiveFileUrl?: string | null, readonly updatedAt: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null, readonly sourceDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null };

export type SafetyDocumentsCommunityQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SafetyDocumentsCommunityQuery = { readonly __typename?: 'DebugSchema', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly postcode?: string | null, readonly homeCount: number, readonly residentCount: number, readonly sibPackUrl?: string | null, readonly sibPackStale: boolean, readonly sibTaggedDocumentCount: number, readonly sibResidentNeedCount: number, readonly lastSibPackGeneratedAt?: string | null, readonly lastSibPackPrintedAt?: string | null, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly sibPackReviewRemindersEnabled: boolean, readonly sibPackReviewNudgeMonths: number, readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null };

export type SafetyDocumentsBlocksQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
}>;


export type SafetyDocumentsBlocksQuery = { readonly __typename?: 'DebugSchema', readonly blocks?: { readonly __typename?: 'BlockNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'BlockNodeEdge', readonly node?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly homesCount?: number | null, readonly totalFloors?: number | null, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string, readonly safetyResponderPack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null } | null } | null> } | null };

export type SafetyCenterDocumentsForCommunityQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type SafetyCenterDocumentsForCommunityQuery = { readonly __typename?: 'DebugSchema', readonly safetyCenterDocuments?: { readonly __typename?: 'SafetyCenterDocumentNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'SafetyCenterDocumentNodeEdge', readonly node?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly title: string, readonly description: string, readonly sibCategory?: ResidentialManagementSafetyCenterDocumentSibCategoryChoices | null, readonly includeInSibPack: boolean, readonly showInSafetyCenter: boolean, readonly fileName?: string | null, readonly effectiveFileUrl?: string | null, readonly updatedAt: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null, readonly sourceDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null } | null } | null> } | null };

export type SafetyDocumentsCandidatesQueryVariables = Exact<{
  communityId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SafetyDocumentsCandidatesQuery = { readonly __typename?: 'DebugSchema', readonly communityDocuments?: { readonly __typename?: 'CommunityDocumentNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityDocumentNodeEdge', readonly node?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string, readonly file?: string | null, readonly link?: string | null, readonly updatedAt: string } | null } | null> } | null };

export type SafetyPackExcludedRecordFragment = { readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string };

export type SafetyPackExclusionFragment = { readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number };

export type SafetyPackInclusionFragment = { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> };

export type SafetyResponderPackStateFragment = { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } };

export type ActionPlanTaskFragment = { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly id: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null }, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly actions?: ReadonlyArray<{ readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } }> | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null };

export type InspectionActionPlanQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type InspectionActionPlanQuery = { readonly __typename?: 'DebugSchema', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly id: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null }, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly actions?: ReadonlyArray<{ readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } }> | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type ReviewInspectionActionMutationVariables = Exact<{
  input: ReviewInspectionActionInput;
}>;


export type ReviewInspectionActionMutation = { readonly __typename?: 'Mutation', readonly reviewInspectionAction?: { readonly __typename?: 'ReviewInspectionActionPayload', readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null } | null };

export type FlagInspectionActionMutationVariables = Exact<{
  input: FlagChecklistItemInput;
}>;


export type FlagInspectionActionMutation = { readonly __typename?: 'Mutation', readonly flagChecklistItem?: { readonly __typename?: 'FlagChecklistItemPayload', readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null } | null };

export type CreateFollowUpTaskFromActionMutationVariables = Exact<{
  input: CreateFollowUpTaskFromChecklistItemInput;
}>;


export type CreateFollowUpTaskFromActionMutation = { readonly __typename?: 'Mutation', readonly createFollowUpTaskFromChecklistItem?: { readonly __typename?: 'CreateFollowUpTaskFromChecklistItemPayload', readonly created: boolean, readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null } | null, readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type CreateFollowUpTasksFromActionsMutationVariables = Exact<{
  input: CreateFollowUpTasksFromChecklistItemsInput;
}>;


export type CreateFollowUpTasksFromActionsMutation = { readonly __typename?: 'Mutation', readonly createFollowUpTasksFromChecklistItems?: { readonly __typename?: 'CreateFollowUpTasksFromChecklistItemsPayload', readonly createdCount: number, readonly existingCount: number, readonly tasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly checklistItems?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null };

export type CreateTemplateFromChecklistMutationVariables = Exact<{
  input: CreateTemplateFromChecklistInput;
}>;


export type CreateTemplateFromChecklistMutation = { readonly __typename?: 'Mutation', readonly createTemplateFromChecklist?: { readonly __typename?: 'CreateTemplateFromChecklistPayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string } | null } | null };

export type InspectionSourceRegionFragment = { readonly __typename?: 'SourceRegionNode', readonly id: string, readonly kind?: string | null, readonly selfRef: string, readonly crop?: string | null, readonly bboxNormL: number, readonly bboxNormT: number, readonly bboxNormR: number, readonly bboxNormB: number };

export type InspectionSourceRegionEntryFragment = { readonly __typename?: 'ActionSourceRegionNode', readonly role: string, readonly region: { readonly __typename?: 'SourceRegionNode', readonly id: string, readonly kind?: string | null, readonly selfRef: string, readonly crop?: string | null, readonly bboxNormL: number, readonly bboxNormT: number, readonly bboxNormR: number, readonly bboxNormB: number } };

export type InspectionActionSourceQueryVariables = Exact<{
  actionId: Scalars['UUID']['input'];
}>;


export type InspectionActionSourceQuery = { readonly __typename?: 'DebugSchema', readonly checklistActionSource?: { readonly __typename?: 'ChecklistActionSourceNode', readonly actionId: string, readonly isRegionLevel: boolean, readonly page?: { readonly __typename?: 'SourceDocumentPageNode', readonly id: string, readonly pageNo: number, readonly image?: string | null, readonly width?: number | null, readonly height?: number | null } | null, readonly regions: ReadonlyArray<{ readonly __typename?: 'ActionSourceRegionNode', readonly role: string, readonly region: { readonly __typename?: 'SourceRegionNode', readonly id: string, readonly kind?: string | null, readonly selfRef: string, readonly crop?: string | null, readonly bboxNormL: number, readonly bboxNormT: number, readonly bboxNormR: number, readonly bboxNormB: number } }> } | null };

export type InspectionExtractionFragment = { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string, readonly status: ResidentialManagementDocumentExtractionStatusChoices, readonly statusMessage?: string | null, readonly failedStage?: string | null, readonly extractionConfidence?: number | null, readonly extractedTaskId?: string | null, readonly complianceType?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type InspectionExtractionProgressFragment = { readonly __typename?: 'DocumentExtractionNode', readonly parseStrategy?: ResidentialManagementDocumentExtractionParseStrategyChoices | null, readonly validationVerdict?: string | null, readonly id: string, readonly title: string, readonly status: ResidentialManagementDocumentExtractionStatusChoices, readonly statusMessage?: string | null, readonly failedStage?: string | null, readonly extractionConfidence?: number | null, readonly extractedTaskId?: string | null, readonly complianceType?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly progress?: ReadonlyArray<{ readonly __typename?: 'ExtractionStageEventType', readonly stage: string, readonly status: string, readonly detail?: string | null, readonly at?: string | null }> | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type InspectionReportsQueryVariables = Exact<{
  community?: InputMaybe<Scalars['UUID']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  complianceTypes?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InspectionReportsQuery = { readonly __typename?: 'DebugSchema', readonly documentExtractions?: { readonly __typename?: 'DocumentExtractionNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'DocumentExtractionNodeEdge', readonly node?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string, readonly status: ResidentialManagementDocumentExtractionStatusChoices, readonly statusMessage?: string | null, readonly failedStage?: string | null, readonly extractionConfidence?: number | null, readonly extractedTaskId?: string | null, readonly complianceType?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type InspectionReportStatusQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type InspectionReportStatusQuery = { readonly __typename?: 'DebugSchema', readonly documentExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly parseStrategy?: ResidentialManagementDocumentExtractionParseStrategyChoices | null, readonly validationVerdict?: string | null, readonly id: string, readonly title: string, readonly status: ResidentialManagementDocumentExtractionStatusChoices, readonly statusMessage?: string | null, readonly failedStage?: string | null, readonly extractionConfidence?: number | null, readonly extractedTaskId?: string | null, readonly complianceType?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly progress?: ReadonlyArray<{ readonly __typename?: 'ExtractionStageEventType', readonly stage: string, readonly status: string, readonly detail?: string | null, readonly at?: string | null }> | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null };

export type RetryInspectionExtractionMutationVariables = Exact<{
  input: RetryDocumentExtractionInput;
}>;


export type RetryInspectionExtractionMutation = { readonly __typename?: 'Mutation', readonly retryDocumentExtraction?: { readonly __typename?: 'RetryDocumentExtractionPayload', readonly documentExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string, readonly status: ResidentialManagementDocumentExtractionStatusChoices, readonly statusMessage?: string | null, readonly failedStage?: string | null, readonly extractionConfidence?: number | null, readonly extractedTaskId?: string | null, readonly complianceType?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type InspectionOverviewCountFragment = { readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number };

export type InspectionOverviewExtractionFragment = { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string, readonly file?: string | null, readonly fileName?: string | null, readonly createdAt: string, readonly overviewNarrative: string, readonly extractedTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string } | null, readonly sourceDocument?: { readonly __typename?: 'SourceDocumentNode', readonly id: string, readonly pageCount?: number | null, readonly firstPage?: { readonly __typename?: 'SourceDocumentPageNode', readonly id: string, readonly pageNo: number, readonly image?: string | null, readonly width?: number | null, readonly height?: number | null } | null } | null, readonly overviewStats: { readonly __typename?: 'InspectionOverviewStatsNode', readonly reportItemsTotal: number, readonly reportItemsPassed: number, readonly reportItemsNeedingAction: number, readonly actionsTotal: number, readonly actionsOutstanding: number, readonly actionsWithTasks: number, readonly actionsInProgress: number, readonly actionsComplete: number, readonly actionsDismissed: number, readonly actionsOverdue: number, readonly byPriority: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byArea: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byReviewer: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byResolver: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }> } };

export type InspectionOverviewQueryVariables = Exact<{
  taskId: Scalars['UUID']['input'];
}>;


export type InspectionOverviewQuery = { readonly __typename?: 'DebugSchema', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string, readonly file?: string | null, readonly fileName?: string | null, readonly createdAt: string, readonly overviewNarrative: string, readonly extractedTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string } | null, readonly sourceDocument?: { readonly __typename?: 'SourceDocumentNode', readonly id: string, readonly pageCount?: number | null, readonly firstPage?: { readonly __typename?: 'SourceDocumentPageNode', readonly id: string, readonly pageNo: number, readonly image?: string | null, readonly width?: number | null, readonly height?: number | null } | null } | null, readonly overviewStats: { readonly __typename?: 'InspectionOverviewStatsNode', readonly reportItemsTotal: number, readonly reportItemsPassed: number, readonly reportItemsNeedingAction: number, readonly actionsTotal: number, readonly actionsOutstanding: number, readonly actionsWithTasks: number, readonly actionsInProgress: number, readonly actionsComplete: number, readonly actionsDismissed: number, readonly actionsOverdue: number, readonly byPriority: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byArea: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byReviewer: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }>, readonly byResolver: ReadonlyArray<{ readonly __typename?: 'InspectionOverviewCountNode', readonly key: string, readonly label: string, readonly count: number }> } } | null } | null } | null };

export type WorkspaceUpdateFragment = { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly createdAt: string, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null };

export type InspectionWorkspaceActivityQueryVariables = Exact<{
  taskId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type InspectionWorkspaceActivityQuery = { readonly __typename?: 'DebugSchema', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly createdAt: string, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null } | null };

export type ManagerDeclarationResidencyFragment = { readonly __typename?: 'ResidencyNode', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }>, readonly residentSafetyRecords: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly first: string, readonly last: string, readonly isAppLinked: boolean, readonly archivedAt?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> } };

export type ManagerDeclarationTargetsQueryVariables = Exact<{
  residencyId: Scalars['UUID']['input'];
}>;


export type ManagerDeclarationTargetsQuery = { readonly __typename?: 'DebugSchema', readonly residency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly home: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string, readonly address?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null }, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentType', readonly id: string, readonly user: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } }>, readonly residentSafetyRecords: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly first: string, readonly last: string, readonly isAppLinked: boolean, readonly archivedAt?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string } | null } | null } | null> } } | null };

export type HomeActiveResidencyForDeclarationQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type HomeActiveResidencyForDeclarationQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string } | null } | null };

export type SafetyListItemFragment = { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } };

export type SafetyRecordsQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  isOccupant?: InputMaybe<Scalars['Boolean']['input']>;
  hasConsent?: InputMaybe<Scalars['Boolean']['input']>;
  hasNeeds?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pcfraStatus?: InputMaybe<Scalars['String']['input']>;
  eesStatus?: InputMaybe<Scalars['String']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SafetyRecordsQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecords?: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } } | null } | null> } | null };

export type SafetyRosterRowFragment = { readonly __typename?: 'SafetyRosterRowType', readonly id: string, readonly state: string, readonly lifecycleStatus: string, readonly needsAction: boolean, readonly needsReconciliation: boolean, readonly isOverdue: boolean, readonly isAppLinked: boolean, readonly occupantKnown: boolean, readonly complianceActions: ReadonlyArray<string>, readonly first: string, readonly last: string, readonly homeId?: string | null, readonly homeName?: string | null, readonly communityName?: string | null, readonly blockName?: string | null, readonly floorNumber?: number | null, readonly residencyId: string, readonly lastDeclaredAt?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean } | null, readonly openReviewRequest?: { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean } | null, readonly record?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } } | null };

export type SafetyRosterQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  blocks?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['UUID']['input']>> | InputMaybe<Scalars['UUID']['input']>>;
  cohort?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  pcfraStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  eesStatuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  issue?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SafetyRosterQuery = { readonly __typename?: 'DebugSchema', readonly safetyRoster?: { readonly __typename?: 'SafetyRosterType', readonly cohort: string, readonly totalCount: number, readonly hasMore: boolean, readonly counts: { readonly __typename?: 'SafetyRosterCountsType', readonly needsAction: number, readonly declaredNeeds: number, readonly noNeeds: number, readonly notAnswered: number, readonly all: number }, readonly pcfraCounts: { readonly __typename?: 'SafetyRosterPcfraCountsType', readonly notOffered: number, readonly offered: number, readonly declined: number }, readonly eesCounts: { readonly __typename?: 'SafetyRosterEesCountsType', readonly notGenerated: number, readonly generated: number, readonly agreed: number }, readonly rows: ReadonlyArray<{ readonly __typename?: 'SafetyRosterRowType', readonly id: string, readonly state: string, readonly lifecycleStatus: string, readonly needsAction: boolean, readonly needsReconciliation: boolean, readonly isOverdue: boolean, readonly isAppLinked: boolean, readonly occupantKnown: boolean, readonly complianceActions: ReadonlyArray<string>, readonly first: string, readonly last: string, readonly homeId?: string | null, readonly homeName?: string | null, readonly communityName?: string | null, readonly blockName?: string | null, readonly floorNumber?: number | null, readonly residencyId: string, readonly lastDeclaredAt?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly declarantName?: string | null, readonly isVoided: boolean } | null, readonly openReviewRequest?: { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean } | null, readonly record?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } } } | null }> } | null };

export type SafetyPortfolioQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type SafetyPortfolioQuery = { readonly __typename?: 'DebugSchema', readonly safetyPortfolio: ReadonlyArray<{ readonly __typename?: 'SafetyCommunityReadinessType', readonly communityId: string, readonly communityName: string, readonly postcode?: string | null, readonly blocks: ReadonlyArray<{ readonly __typename?: 'SafetyBlockReadinessType', readonly blockId: string, readonly blockName: string, readonly homes: number, readonly homesWithoutFloor: number, readonly packGenerated: boolean, readonly packCurrent: boolean, readonly responsiblePersonNamed: boolean, readonly floorsKnown: boolean, readonly unassignedResidents: number, readonly response: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly currency: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly consent: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly assessment: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly cohorts: { readonly __typename?: 'SafetyReadinessCohortsType', readonly declaredNeeds: number, readonly noNeeds: number, readonly notAnswered: number, readonly notOccupant: number } }> }> };

export type HomesMissingFloorQueryVariables = Exact<{
  block: Scalars['UUID']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type HomesMissingFloorQuery = { readonly __typename?: 'DebugSchema', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly totalFloors?: number | null } | null, readonly homes?: { readonly __typename?: 'HomeNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'HomeNodeEdge', readonly node?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly addressLine1?: string | null, readonly floorNumber?: number | null } | null } | null> } | null };

export type SafetyBlockReadinessFragment = { readonly __typename?: 'SafetyBlockReadinessType', readonly blockId: string, readonly blockName: string, readonly homes: number, readonly homesWithoutFloor: number, readonly packGenerated: boolean, readonly packCurrent: boolean, readonly responsiblePersonNamed: boolean, readonly floorsKnown: boolean, readonly unassignedResidents: number, readonly response: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly currency: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly consent: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly assessment: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly cohorts: { readonly __typename?: 'SafetyReadinessCohortsType', readonly declaredNeeds: number, readonly noNeeds: number, readonly notAnswered: number, readonly notOccupant: number } };

export type SafetyReadinessQueryVariables = Exact<{
  community: Scalars['UUID']['input'];
}>;


export type SafetyReadinessQuery = { readonly __typename?: 'DebugSchema', readonly safetyReadiness: ReadonlyArray<{ readonly __typename?: 'SafetyBlockReadinessType', readonly blockId: string, readonly blockName: string, readonly homes: number, readonly homesWithoutFloor: number, readonly packGenerated: boolean, readonly packCurrent: boolean, readonly responsiblePersonNamed: boolean, readonly floorsKnown: boolean, readonly unassignedResidents: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyReadinessExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly response: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly currency: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly consent: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly assessment: { readonly __typename?: 'SafetyReadinessRatioType', readonly numerator: number, readonly denominator: number }, readonly cohorts: { readonly __typename?: 'SafetyReadinessCohortsType', readonly declaredNeeds: number, readonly noNeeds: number, readonly notAnswered: number, readonly notOccupant: number } }> };

export type GenerateHomeSafetyFormMutationVariables = Exact<{
  homeId: Scalars['UUID']['input'];
  scope?: InputMaybe<SafetyPaperFormScope>;
  recordId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type GenerateHomeSafetyFormMutation = { readonly __typename?: 'Mutation', readonly generateHomeSafetyForm?: { readonly __typename?: 'GenerateHomeSafetyForm', readonly pdfBase64?: string | null, readonly filename?: string | null, readonly residencyId?: string | null } | null };

export type PaperFormHomeOccupantsQueryVariables = Exact<{
  homeId: Scalars['UUID']['input'];
}>;


export type PaperFormHomeOccupantsQuery = { readonly __typename?: 'DebugSchema', readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly activeResidency?: { readonly __typename?: 'ResidencyNode', readonly id: string, readonly residentSafetyRecords: { readonly __typename?: 'ResidentSafetyRecordNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly first: string, readonly last: string, readonly archivedAt?: string | null, readonly isAppLinked: boolean } | null } | null> } } | null } | null };

export type LegacySafetyPackQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type LegacySafetyPackQuery = { readonly __typename?: 'DebugSchema', readonly legacySafetyPack?: { readonly __typename?: 'PublicSafetyPackType', readonly communityId: string, readonly communityName: string, readonly sibPackUrl?: string | null, readonly lastGeneratedAt?: string | null, readonly totalHomes?: number | null, readonly totalOccupants?: number | null, readonly responsiblePerson?: { readonly __typename?: 'PublicResponsiblePersonType', readonly name: string, readonly role?: string | null } | null, readonly contacts?: ReadonlyArray<{ readonly __typename?: 'PublicContactType', readonly role?: string | null, readonly name?: string | null, readonly email?: string | null, readonly phone?: string | null }> | null, readonly blocks?: ReadonlyArray<{ readonly __typename?: 'PublicBlockType', readonly name?: string | null, readonly shortCode?: string | null, readonly totalFloors?: number | null, readonly homeCount?: number | null, readonly dutyHolderLabel: string, readonly packUrl?: string | null, readonly packGeneratedAt?: string | null, readonly responsiblePerson?: { readonly __typename?: 'PublicResponsiblePersonType', readonly name: string, readonly role?: string | null } | null, readonly rows?: ReadonlyArray<{ readonly __typename?: 'PublicPeepRowType', readonly flat?: string | null, readonly floor?: number | null, readonly assistance?: string | null, readonly communication?: string | null, readonly eesInPlace?: boolean | null, readonly pcfraInPlace?: boolean | null }> | null }> | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'PublicSafetyCenterDocumentType', readonly id: string, readonly title: string, readonly description?: string | null, readonly sibCategory?: string | null, readonly sibCategoryLabel?: string | null, readonly fileUrl?: string | null }> | null } | null };

export type LegacySafetyCenterDocumentQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  id: Scalars['UUID']['input'];
}>;


export type LegacySafetyCenterDocumentQuery = { readonly __typename?: 'DebugSchema', readonly legacySafetyCenterDocument?: { readonly __typename?: 'PublicSafetyCenterDocumentType', readonly id: string, readonly title: string, readonly fileUrl?: string | null } | null };

export type SafetyRecordAuditLogsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SafetyRecordAuditLogsQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly auditLogs?: { readonly __typename?: 'ResidentSafetyRecordAuditLogNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyRecordAuditLogNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyRecordAuditLogNode', readonly id: string, readonly eventType: ResidentialManagementResidentSafetyRecordAuditLogEventTypeChoices, readonly metadata: string, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null> } | null } | null };

export type DeclarationHistoryEntryFragment = { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly createdAt: string, readonly declarantName?: string | null, readonly isVoided: boolean, readonly isAuthoritative: boolean, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly voidReason: string, readonly voidedByName?: string | null, readonly isOccupant?: boolean | null, readonly mobilityNeedDeclared?: boolean | null, readonly mobilityDetails?: string | null, readonly communicationNeedDeclared?: boolean | null, readonly communicationDetails?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null };

export type SafetyDeclarationHistoryQueryVariables = Exact<{
  recordId: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SafetyDeclarationHistoryQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly needsReconciliation: boolean, readonly authoritativeDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string } | null, readonly declarations?: { readonly __typename?: 'ResidentSafetyDeclarationNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSafetyDeclarationNodeEdge', readonly node?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly createdAt: string, readonly declarantName?: string | null, readonly isVoided: boolean, readonly isAuthoritative: boolean, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly voidReason: string, readonly voidedByName?: string | null, readonly isOccupant?: boolean | null, readonly mobilityNeedDeclared?: boolean | null, readonly mobilityDetails?: string | null, readonly communicationNeedDeclared?: boolean | null, readonly communicationDetails?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null } | null } | null> } | null } | null };

export type SafetyRecordHomeFragment = { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null };

export type SafetyCenterRecordFieldsFragment = { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly needsReconciliation: boolean, readonly consentGivenAt?: string | null, readonly consentDeclinedAt?: string | null, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean, readonly pcfraParticipation?: string | null, readonly pcfraAcceptedAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly pcfraAssessmentDate?: string | null, readonly pcfraFileUrl?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly eesFileUrl?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly contactEmail?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly submittedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }>, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly dateJoined: string } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null } } };

export type SafetyCenterRecordQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SafetyCenterRecordQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly needsReconciliation: boolean, readonly consentGivenAt?: string | null, readonly consentDeclinedAt?: string | null, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean, readonly pcfraParticipation?: string | null, readonly pcfraAcceptedAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly pcfraAssessmentDate?: string | null, readonly pcfraFileUrl?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly eesFileUrl?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly contactEmail?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly submittedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }>, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly dateJoined: string } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null } } } | null };

export type SafetyReviewAttemptEntryFragment = { readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null };

export type SafetyReviewRequestStateFragment = { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean };

export type SafetyReviewRequestDetailFragment = { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean, readonly recipient?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly attempts: ReadonlyArray<{ readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null }> };

export type SafetyReviewRequestsQueryVariables = Exact<{
  recordId: Scalars['UUID']['input'];
}>;


export type SafetyReviewRequestsQuery = { readonly __typename?: 'DebugSchema', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isAppLinked: boolean, readonly openReviewRequest?: { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean, readonly recipient?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly attempts: ReadonlyArray<{ readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null }> } | null, readonly reviewRequests: ReadonlyArray<{ readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean, readonly recipient?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly attempts: ReadonlyArray<{ readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null }> }> } | null };

export type SendSafetyReviewRequestMutationVariables = Exact<{
  recordId: Scalars['UUID']['input'];
  channel?: InputMaybe<SafetyReviewAttemptChannel>;
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendSafetyReviewRequestMutation = { readonly __typename?: 'Mutation', readonly sendSafetyReviewRequest?: { readonly __typename?: 'SendSafetyReviewRequest', readonly reviewRequest?: { readonly __typename?: 'SafetyReviewRequestNode', readonly id: string, readonly requestType: ResidentialManagementSafetyReviewRequestRequestTypeChoices, readonly createdAt: string, readonly openedAt?: string | null, readonly completedAt?: string | null, readonly cancelledAt?: string | null, readonly isOpen: boolean, readonly attemptCount: number, readonly latestAttemptAt?: string | null, readonly escalationDueAt?: string | null, readonly isEscalationDue: boolean, readonly recipient?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly attempts: ReadonlyArray<{ readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null }> } | null, readonly attempt?: { readonly __typename?: 'SafetyReviewAttemptNode', readonly id: string, readonly channel: ResidentialManagementSafetyReviewAttemptChannelChoices, readonly createdAt: string, readonly queuedAt?: string | null, readonly initiatedByName?: string | null, readonly note?: string | null } | null } | null };

export type OfferPcfraMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type OfferPcfraMutation = { readonly __typename?: 'Mutation', readonly offerPcfra?: { readonly __typename?: 'OfferPcfra', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly pcfraOfferedAt?: string | null } | null } | null };

export type DeclinePcfraMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type DeclinePcfraMutation = { readonly __typename?: 'Mutation', readonly declinePcfra?: { readonly __typename?: 'DeclinePcfra', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly pcfraDeclinedAt?: string | null } | null } | null };

export type SendSafetyReminderMutationVariables = Exact<{
  recordId: Scalars['UUID']['input'];
}>;


export type SendSafetyReminderMutation = { readonly __typename?: 'Mutation', readonly sendSafetyReminder?: { readonly __typename?: 'SendSafetyReminder', readonly success?: boolean | null } | null };

export type GenerateEesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GenerateEesMutation = { readonly __typename?: 'Mutation', readonly generateEes?: { readonly __typename?: 'GenerateEes', readonly url?: string | null, readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly eesFileUrl?: string | null } | null } | null };

export type AgreeEesMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type AgreeEesMutation = { readonly __typename?: 'Mutation', readonly agreeEes?: { readonly __typename?: 'AgreeEes', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly eesAgreedAt?: string | null } | null } | null };

export type GeneratePeepsExportMutationVariables = Exact<{
  blockId: Scalars['UUID']['input'];
}>;


export type GeneratePeepsExportMutation = { readonly __typename?: 'Mutation', readonly generatePeepsExport?: { readonly __typename?: 'GeneratePeepsExport', readonly url?: string | null, readonly qrDataUri?: string | null, readonly liveUrl?: string | null, readonly occupantCount?: number | null } | null };

export type GenerateSibPackMutationVariables = Exact<{
  blockId: Scalars['UUID']['input'];
}>;


export type GenerateSibPackMutation = { readonly __typename?: 'Mutation', readonly generateSibPack?: { readonly __typename?: 'GenerateSibPack', readonly url?: string | null, readonly occupantCount?: number | null, readonly documentCount?: number | null, readonly appendedPdfCount?: number | null, readonly pack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly sibPackUrl?: string | null, readonly sibPackStale: boolean, readonly lastSibPackGeneratedAt?: string | null, readonly lastSibPackPrintedAt?: string | null } | null } | null };

export type MarkSibPackPrintedMutationVariables = Exact<{
  blockId: Scalars['UUID']['input'];
}>;


export type MarkSibPackPrintedMutation = { readonly __typename?: 'Mutation', readonly markSibPackPrinted?: { readonly __typename?: 'MarkSibPackPrinted', readonly pack?: { readonly __typename?: 'SafetyResponderPackNode', readonly id: string, readonly fileUrl?: string | null, readonly isComplete: boolean, readonly isStale: boolean, readonly generatedAt?: string | null, readonly printedAt?: string | null, readonly isTokenActive: boolean, readonly tokenActivatedAt?: string | null, readonly tokenRotatedAt?: string | null, readonly tokenRotationReason: string, readonly responderUrl?: string | null, readonly rotationResidualWindow: string, readonly eligibility: { readonly __typename?: 'SafetyPackEligibilityType', readonly totalCount: number, readonly eligibleCount: number, readonly excludedCount: number, readonly exclusions: ReadonlyArray<{ readonly __typename?: 'SafetyPackExclusionType', readonly reason: string, readonly label: string, readonly count: number }>, readonly excludedRecords: ReadonlyArray<{ readonly __typename?: 'SafetyPackExcludedRecordType', readonly recordId: string, readonly reason: string, readonly label: string, readonly homeName: string, readonly floorNumber?: number | null, readonly blockName: string }> } } | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly sibPackUrl?: string | null, readonly sibPackStale: boolean, readonly lastSibPackGeneratedAt?: string | null, readonly lastSibPackPrintedAt?: string | null } | null } | null };

export type GenerateSibPackQrPdfMutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
}>;


export type GenerateSibPackQrPdfMutation = { readonly __typename?: 'Mutation', readonly generateSibPackQrPdf?: { readonly __typename?: 'GenerateSibPackQrPdf', readonly pdfBase64?: string | null, readonly filename?: string | null } | null };

export type SetSafetyDocumentInSibPackMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  include: Scalars['Boolean']['input'];
}>;


export type SetSafetyDocumentInSibPackMutation = { readonly __typename?: 'Mutation', readonly setSafetyDocumentInSibPack?: { readonly __typename?: 'SetSafetyDocumentInSibPack', readonly safetyCenterDocument?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly includeInSibPack: boolean } | null } | null };

export type SetSafetyDocumentResidentVisibleMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  visible: Scalars['Boolean']['input'];
}>;


export type SetSafetyDocumentResidentVisibleMutation = { readonly __typename?: 'Mutation', readonly setSafetyDocumentResidentVisible?: { readonly __typename?: 'SetSafetyDocumentResidentVisible', readonly safetyCenterDocument?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly showInSafetyCenter: boolean } | null } | null };

export type GenerateSafetyRecordActivityPdfMutationVariables = Exact<{
  recordId: Scalars['UUID']['input'];
}>;


export type GenerateSafetyRecordActivityPdfMutation = { readonly __typename?: 'Mutation', readonly generateSafetyRecordActivityPdf?: { readonly __typename?: 'GenerateSafetyRecordActivityPdf', readonly pdfBase64?: string | null, readonly filename?: string | null } | null };

export type CreateSafetyCenterDocumentMutationVariables = Exact<{
  input: CreateSafetyCenterDocumentInput;
}>;


export type CreateSafetyCenterDocumentMutation = { readonly __typename?: 'Mutation', readonly createSafetyCenterDocument?: { readonly __typename?: 'CreateSafetyCenterDocumentPayload', readonly safetyCenterDocument?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly title: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SetSafetyDocumentBlockMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  blockId?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type SetSafetyDocumentBlockMutation = { readonly __typename?: 'Mutation', readonly setSafetyDocumentBlock?: { readonly __typename?: 'SetSafetyDocumentBlock', readonly safetyCenterDocument?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null } | null };

export type ArchiveSafetyCenterDocumentMutationVariables = Exact<{
  input: ArchiveSafetyCenterDocumentInput;
}>;


export type ArchiveSafetyCenterDocumentMutation = { readonly __typename?: 'Mutation', readonly archiveSafetyCenterDocument?: { readonly __typename?: 'ArchiveSafetyCenterDocumentPayload', readonly safetyCenterDocument?: { readonly __typename?: 'SafetyCenterDocumentNode', readonly id: string, readonly archivedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type GenerateSafetyDocumentQrPdfMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type GenerateSafetyDocumentQrPdfMutation = { readonly __typename?: 'Mutation', readonly generateSafetyDocumentQrPdf?: { readonly __typename?: 'GenerateSafetyDocumentQrPdf', readonly pdfBase64?: string | null, readonly filename?: string | null } | null };

export type UpdateBlockSafetyIdentityMutationVariables = Exact<{
  input: UpdateBlockSafetyIdentityInput;
}>;


export type UpdateBlockSafetyIdentityMutation = { readonly __typename?: 'Mutation', readonly updateBlockSafetyIdentity?: { readonly __typename?: 'UpdateBlockSafetyIdentityPayload', readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly responsiblePersonName: string, readonly responsiblePersonRole: string, readonly hrbReference?: string | null, readonly dutyHolderLabel: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UpdateCommunitySibPackReviewSettingsMutationVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  sibPackReviewRemindersEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  sibPackReviewNudgeMonths?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateCommunitySibPackReviewSettingsMutation = { readonly __typename?: 'Mutation', readonly updateCommunitySibPackReviewSettings?: { readonly __typename?: 'UpdateCommunitySibPackReviewSettings', readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly sibPackReviewRemindersEnabled: boolean, readonly sibPackReviewNudgeMonths: number } } | null } | null };

export type ArchiveSafetySubjectMutationVariables = Exact<{
  input: ArchiveSafetySubjectInput;
}>;


export type ArchiveSafetySubjectMutation = { readonly __typename?: 'Mutation', readonly archiveSafetySubject?: { readonly __typename?: 'ArchiveSafetySubjectPayload', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type LinkSafetySubjectMutationVariables = Exact<{
  input: LinkSafetySubjectInput;
}>;


export type LinkSafetySubjectMutation = { readonly __typename?: 'Mutation', readonly linkSafetySubject?: { readonly __typename?: 'LinkSafetySubjectPayload', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly first: string, readonly last: string, readonly isAppLinked: boolean, readonly contactEmail?: string | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }>, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SetSafetySubjectContactEmailMutationVariables = Exact<{
  input: SetSafetySubjectContactEmailInput;
}>;


export type SetSafetySubjectContactEmailMutation = { readonly __typename?: 'Mutation', readonly setSafetySubjectContactEmail?: { readonly __typename?: 'SetSafetySubjectContactEmailPayload', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly contactEmail?: string | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }> } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CreateManagerSafetyDeclarationMutationVariables = Exact<{
  input: CreateManagerSafetyDeclarationInput;
}>;


export type CreateManagerSafetyDeclarationMutation = { readonly __typename?: 'Mutation', readonly createManagerSafetyDeclaration?: { readonly __typename?: 'CreateManagerSafetyDeclarationPayload', readonly needsReconciliation: boolean, readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly needsReconciliation: boolean, readonly consentGivenAt?: string | null, readonly consentDeclinedAt?: string | null, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean, readonly pcfraParticipation?: string | null, readonly pcfraAcceptedAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly pcfraAssessmentDate?: string | null, readonly pcfraFileUrl?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly eesFileUrl?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly contactEmail?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly submittedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }>, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly dateJoined: string } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null } } } | null, readonly declaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string } | null } | null };

export type GiveFireServiceConsentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  channel?: InputMaybe<SafetyComplianceChannel>;
  authority?: InputMaybe<SafetyComplianceAuthority>;
  representativeName?: InputMaybe<Scalars['String']['input']>;
}>;


export type GiveFireServiceConsentMutation = { readonly __typename?: 'Mutation', readonly giveFireServiceConsent?: { readonly __typename?: 'GiveFireServiceConsent', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean } | null } | null };

export type WithdrawFireServiceConsentMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  channel?: InputMaybe<SafetyComplianceChannel>;
  reason?: InputMaybe<Scalars['String']['input']>;
}>;


export type WithdrawFireServiceConsentMutation = { readonly __typename?: 'Mutation', readonly withdrawFireServiceConsent?: { readonly __typename?: 'WithdrawFireServiceConsent', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean } | null } | null };

export type ReconcileSafetyDeclarationMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ReconcileSafetyDeclarationMutation = { readonly __typename?: 'Mutation', readonly reconcileSafetyDeclaration?: { readonly __typename?: 'ReconcileSafetyDeclaration', readonly residentSafetyDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly isAuthoritative: boolean } | null, readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly needsReconciliation: boolean, readonly isOccupant?: boolean | null, readonly first: string, readonly last: string, readonly mobilityNeedDeclared?: boolean | null, readonly communicationNeedDeclared?: boolean | null, readonly mobilityNeeds?: string | null, readonly communicationNeeds?: string | null, readonly language: string, readonly largePrint?: boolean | null, readonly braille?: boolean | null, readonly textToSpeech?: boolean | null, readonly consentGivenAt?: string | null, readonly consentDeclinedAt?: string | null, readonly fireServiceConsentGivenAt?: string | null, readonly fireServiceConsentWithdrawnAt?: string | null, readonly sharesWithFireService: boolean, readonly pcfraParticipation?: string | null, readonly pcfraAcceptedAt?: string | null, readonly pcfraOfferedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraCompletedAt?: string | null, readonly pcfraAssessmentDate?: string | null, readonly pcfraFileUrl?: string | null, readonly eesGeneratedAt?: string | null, readonly eesAgreedAt?: string | null, readonly eesFileUrl?: string | null, readonly lastReviewedAt?: string | null, readonly createdAt: string, readonly archivedAt?: string | null, readonly lifecycleStatus: string, readonly isAppLinked: boolean, readonly contactEmail?: string | null, readonly latestDeclaration?: { readonly __typename?: 'ResidentSafetyDeclarationNode', readonly id: string, readonly origin: ResidentialManagementResidentSafetyDeclarationOriginChoices, readonly declaredAt: string, readonly hasEvidence: boolean, readonly evidenceFileUrl?: string | null, readonly submittedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null, readonly linkSuggestions: ReadonlyArray<{ readonly __typename?: 'SafetySubjectLinkSuggestionType', readonly userId: string, readonly email: string, readonly name: string }>, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly firstName?: string | null, readonly lastName?: string | null, readonly dateJoined: string } | null, readonly residency: { readonly __typename?: 'ResidencyType', readonly id: string, readonly home: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly floorNumber?: number | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly surveyReviewIntervalMonths: number, readonly safetyComplianceV2ActivatedAt?: string | null } } | null, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string, readonly totalFloors?: number | null } | null } } } | null } | null };

export type RespondToPcfraMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  accepted: Scalars['Boolean']['input'];
  channel?: InputMaybe<SafetyComplianceChannel>;
  authority?: InputMaybe<SafetyComplianceAuthority>;
}>;


export type RespondToPcfraMutation = { readonly __typename?: 'Mutation', readonly respondToPcfra?: { readonly __typename?: 'RespondToPcfra', readonly residentSafetyRecord?: { readonly __typename?: 'ResidentSafetyRecordNode', readonly id: string, readonly pcfraAcceptedAt?: string | null, readonly pcfraDeclinedAt?: string | null, readonly pcfraParticipation?: string | null } | null } | null };

export type CloseSurveyMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CloseSurveyMutation = { readonly __typename?: 'Mutation', readonly closeSurvey?: { readonly __typename?: 'CloseSurvey', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly status: string } | null } | null };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { readonly __typename?: 'Mutation', readonly createSurvey?: { readonly __typename?: 'CreateSurveyPayload', readonly id?: string | null, readonly question?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type FindSurveyQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type FindSurveyQuery = { readonly __typename?: 'DebugSchema', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly question: string, readonly createdAt: string, readonly status: string, readonly link?: string | null, readonly totalResidents: number, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number, readonly residents: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyAnswerType', readonly id: string, readonly homeName?: string | null, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string } | null }> }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly answers: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyAnswerType', readonly id: string }> } | null };

export type SurveyResultsCsvQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SurveyResultsCsvQuery = { readonly __typename?: 'DebugSchema', readonly survey?: { readonly __typename?: 'ResidentSurveyNode', readonly rawCsv: string } | null };

export type ListResidentSurveyQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ListResidentSurveyQuery = { readonly __typename?: 'DebugSchema', readonly surveys?: { readonly __typename?: 'ResidentSurveyNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyNodeEdge', readonly node?: { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly createdAt: string, readonly question: string, readonly status: string, readonly link?: string | null, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type SurveyItemFragment = { readonly __typename?: 'ResidentSurveyNode', readonly id: string, readonly createdAt: string, readonly question: string, readonly status: string, readonly link?: string | null, readonly options: ReadonlyArray<{ readonly __typename?: 'ResidentSurveyOptionType', readonly id: string, readonly option?: string | null, readonly totalResidents: number }>, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> } };

export type AssignClientTagToTaskDefinitionMutationVariables = Exact<{
  input: AssignClientTagToTaskDefinitionInput;
}>;


export type AssignClientTagToTaskDefinitionMutation = { readonly __typename?: 'Mutation', readonly assignClientTagToTaskDefinition?: { readonly __typename?: 'AssignClientTagToTaskDefinitionPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null, readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null };

export type AssignTaskMutationVariables = Exact<{
  input: AssignTaskInput;
}>;


export type AssignTaskMutation = { readonly __typename?: 'Mutation', readonly assignTask?: { readonly __typename?: 'AssignTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null } | null } | null };

export type AsanaPendingTaskCardFragment = { readonly __typename?: 'AsanaPendingTaskNode', readonly id: string, readonly asanaId: string, readonly asanaUrl: string, readonly name: string, readonly notes: string, readonly asanaCreatedByGid?: string | null, readonly asanaCreatedAt?: string | null, readonly createdAt: string, readonly asanaCreatedByUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } };

export type AsanaPendingTasksQueryVariables = Exact<{
  communityIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AsanaPendingTasksQuery = { readonly __typename?: 'DebugSchema', readonly asanaPendingTasks?: { readonly __typename?: 'AsanaPendingTaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'AsanaPendingTaskNodeEdge', readonly node?: { readonly __typename?: 'AsanaPendingTaskNode', readonly id: string, readonly asanaId: string, readonly asanaUrl: string, readonly name: string, readonly notes: string, readonly asanaCreatedByGid?: string | null, readonly asanaCreatedAt?: string | null, readonly createdAt: string, readonly asanaCreatedByUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null };

export type AsanaPendingTasksCountQueryVariables = Exact<{
  communityIds: ReadonlyArray<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type AsanaPendingTasksCountQuery = { readonly __typename?: 'DebugSchema', readonly asanaPendingTasksCount: number };

export type AcceptAsanaPendingTaskMutationVariables = Exact<{
  input: AcceptAsanaPendingTaskInput;
}>;


export type AcceptAsanaPendingTaskMutation = { readonly __typename?: 'Mutation', readonly acceptAsanaPendingTask?: { readonly __typename?: 'AcceptAsanaPendingTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string } | null, readonly pending?: { readonly __typename?: 'AsanaPendingTaskNode', readonly id: string, readonly status: TasksAsanaPendingTaskStatusChoices } | null } | null };

export type DismissAsanaPendingTaskMutationVariables = Exact<{
  input: DismissAsanaPendingTaskInput;
}>;


export type DismissAsanaPendingTaskMutation = { readonly __typename?: 'Mutation', readonly dismissAsanaPendingTask?: { readonly __typename?: 'DismissAsanaPendingTaskPayload', readonly pending?: { readonly __typename?: 'AsanaPendingTaskNode', readonly id: string, readonly status: TasksAsanaPendingTaskStatusChoices } | null } | null };

export type CreateTaskGroupMutationVariables = Exact<{
  input: CreateTaskGroupInput;
}>;


export type CreateTaskGroupMutation = { readonly __typename?: 'Mutation', readonly createTaskGroup?: { readonly __typename?: 'CreateTaskGroupPayload', readonly tasksCreatedCount?: number | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly name?: string | null, readonly schedule?: string | null, readonly isActive: boolean, readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string } | null, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly id: string, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string } } | null } | null> } | null } | null } | null };

export type TaskCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TaskCategoriesQuery = { readonly __typename?: 'DebugSchema', readonly taskCategories?: { readonly __typename?: 'TaskCategoryNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskCategoryNodeEdge', readonly node?: { readonly __typename?: 'TaskCategoryNode', readonly id: string, readonly name: string } | null } | null> } | null };

export type CreateTaskDefinitionMutationVariables = Exact<{
  input: CreateTaskDefinitionInput;
}>;


export type CreateTaskDefinitionMutation = { readonly __typename?: 'Mutation', readonly createTaskDefinition?: { readonly __typename?: 'CreateTaskDefinitionPayload', readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string } | null, readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null };

export type CreateTaskFromConversationMutationVariables = Exact<{
  input: CreateTaskFromConversationInput;
}>;


export type CreateTaskFromConversationMutation = { readonly __typename?: 'Mutation', readonly createTaskFromConversation?: { readonly __typename?: 'CreateTaskFromConversationPayload', readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string } | null, readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null };

export type LinkConversationToTaskMutationVariables = Exact<{
  input: LinkConversationToTaskInput;
}>;


export type LinkConversationToTaskMutation = { readonly __typename?: 'Mutation', readonly linkConversationToTask?: { readonly __typename?: 'LinkConversationToTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string } | null } | null };

export type LinkTaskSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type LinkTaskSearchQuery = { readonly __typename?: 'DebugSchema', readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null } } | null } | null> } | null };

export type TasksQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  clientTags?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type TasksQuery = { readonly __typename?: 'DebugSchema', readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null> } | null };

export type RenameTaskMutationVariables = Exact<{
  input: RenameTaskInput;
}>;


export type RenameTaskMutation = { readonly __typename?: 'Mutation', readonly renameTask?: { readonly __typename?: 'RenameTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly sharesDefinition: boolean, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string } } | null } | null };

export type TaskGroupDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  dueDateAfter?: InputMaybe<Scalars['Date']['input']>;
}>;


export type TaskGroupDetailQuery = { readonly __typename?: 'DebugSchema', readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly priority?: string | null, readonly schedule?: string | null, readonly isActive: boolean, readonly generationHorizon?: number | null, readonly createdAt: string, readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string } | null, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly scheduledFor?: string | null, readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly category?: { readonly __typename?: 'TaskCategoryNode', readonly id: string, readonly name: string } | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null> } | null, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly templateTask?: { readonly __typename?: 'TaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly id: string, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null } | null> } | null } | null };

export type TaskGroupItemFragment = { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly name?: string | null, readonly schedule?: string | null, readonly isActive: boolean, readonly createdAt: string, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly totalCount: number } | null, readonly communityTasks?: { readonly __typename?: 'TaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null } } | null } | null> } | null };

export type TaskGroupPastTasksQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  statuses?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type TaskGroupPastTasksQuery = { readonly __typename?: 'DebugSchema', readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly scheduledFor?: string | null, readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly category?: { readonly __typename?: 'TaskCategoryNode', readonly id: string, readonly name: string } | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } } | null } | null> } | null } | null };

export type TaskGroupsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type TaskGroupsQuery = { readonly __typename?: 'DebugSchema', readonly taskGroups?: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly name?: string | null, readonly schedule?: string | null, readonly isActive: boolean, readonly createdAt: string, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly totalCount: number } | null, readonly communityTasks?: { readonly __typename?: 'TaskNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskNodeEdge', readonly node?: { readonly __typename?: 'TaskNode', readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null } } | null } | null> } | null } | null } | null> } | null };

export type ArchiveTaskGroupMutationVariables = Exact<{
  input: ArchiveTaskGroupInput;
}>;


export type ArchiveTaskGroupMutation = { readonly __typename?: 'Mutation', readonly archiveTaskGroup?: { readonly __typename?: 'ArchiveTaskGroupPayload', readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly archivedAt?: string | null, readonly isActive: boolean } | null } | null };

export type UpdateTaskGroupMutationVariables = Exact<{
  input: UpdateTaskGroupInput;
}>;


export type UpdateTaskGroupMutation = { readonly __typename?: 'Mutation', readonly updateTaskGroup?: { readonly __typename?: 'UpdateTaskGroupPayload', readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string, readonly name?: string | null, readonly description?: string | null, readonly priority?: string | null, readonly schedule?: string | null, readonly isActive: boolean, readonly generationHorizon?: number | null, readonly createdAt: string, readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string } | null, readonly tasks?: { readonly __typename?: 'TaskNodeConnection', readonly totalCount: number } | null } | null } | null };

export type ArchiveTaskMutationVariables = Exact<{
  input: ArchiveTaskInput;
}>;


export type ArchiveTaskMutation = { readonly __typename?: 'Mutation', readonly archiveTask?: { readonly __typename?: 'ArchiveTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly archivedAt?: string | null } | null } | null };

export type AssignContractorToTaskMutationVariables = Exact<{
  input: AssignContractorToTaskInput;
}>;


export type AssignContractorToTaskMutation = { readonly __typename?: 'Mutation', readonly assignContractorToTask?: { readonly __typename?: 'AssignContractorToTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null } | null } | null };

export type ChangeTaskStatusMutationVariables = Exact<{
  input: ChangeTaskStatusInput;
}>;


export type ChangeTaskStatusMutation = { readonly __typename?: 'Mutation', readonly changeTaskStatus?: { readonly __typename?: 'ChangeTaskStatusPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null, readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly completedAt?: string | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null } | null } | null };

export type ChecklistItemMediaFragment = { readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null };

export type ChecklistFollowUpTaskFragment = { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null };

export type ChecklistItemResponseFragment = { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null };

export type ChecklistItemCommentFragment = { readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null };

export type ChecklistActionFragment = { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } };

export type ChecklistItemFragment = { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null };

export type ChecklistSectionFragment = { readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null };

export type TaskChecklistFragment = { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null };

export type FlagChecklistItemMutationVariables = Exact<{
  input: FlagChecklistItemInput;
}>;


export type FlagChecklistItemMutation = { readonly __typename?: 'Mutation', readonly flagChecklistItem?: { readonly __typename?: 'FlagChecklistItemPayload', readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type UnflagChecklistItemMutationVariables = Exact<{
  input: UnflagChecklistItemInput;
}>;


export type UnflagChecklistItemMutation = { readonly __typename?: 'Mutation', readonly unflagChecklistItem?: { readonly __typename?: 'UnflagChecklistItemPayload', readonly taskChecklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type CreateFollowUpTaskFromChecklistItemMutationVariables = Exact<{
  input: CreateFollowUpTaskFromChecklistItemInput;
}>;


export type CreateFollowUpTaskFromChecklistItemMutation = { readonly __typename?: 'Mutation', readonly createFollowUpTaskFromChecklistItem?: { readonly __typename?: 'CreateFollowUpTaskFromChecklistItemPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null } | null, readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type AssignChecklistItemMutationVariables = Exact<{
  input: AssignChecklistItemInput;
}>;


export type AssignChecklistItemMutation = { readonly __typename?: 'Mutation', readonly assignChecklistItem?: { readonly __typename?: 'AssignChecklistItemPayload', readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type AssignChecklistSectionMutationVariables = Exact<{
  input: AssignChecklistSectionInput;
}>;


export type AssignChecklistSectionMutation = { readonly __typename?: 'Mutation', readonly assignChecklistSection?: { readonly __typename?: 'AssignChecklistSectionPayload', readonly checklistSection?: { readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type CreateChecklistItemCommentMutationVariables = Exact<{
  input: CreateChecklistItemCommentInput;
}>;


export type CreateChecklistItemCommentMutation = { readonly __typename?: 'Mutation', readonly createChecklistItemComment?: { readonly __typename?: 'CreateChecklistItemCommentPayload', readonly taskChecklistItemComment?: { readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CompleteChecklistItemMutationVariables = Exact<{
  input: CompleteChecklistItemInput;
}>;


export type CompleteChecklistItemMutation = { readonly __typename?: 'Mutation', readonly completeChecklistItem?: { readonly __typename?: 'CompleteChecklistItemPayload', readonly taskChecklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type CreateChecklistItemMediaMutationVariables = Exact<{
  input: CreateChecklistItemMediaInput;
}>;


export type CreateChecklistItemMediaMutation = { readonly __typename?: 'Mutation', readonly createChecklistItemMedia?: { readonly __typename?: 'CreateChecklistItemMediaPayload', readonly taskChecklistItemMedia?: { readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string } | null } | null };

export type DeleteChecklistItemMediaMutationVariables = Exact<{
  input: DeleteChecklistItemMediaInput;
}>;


export type DeleteChecklistItemMediaMutation = { readonly __typename?: 'Mutation', readonly deleteChecklistItemMedia?: { readonly __typename?: 'DeleteChecklistItemMediaPayload', readonly deletedMediaId?: string | null } | null };

export type SetChecklistItemDueDateMutationVariables = Exact<{
  input: SetChecklistItemDueDateInput;
}>;


export type SetChecklistItemDueDateMutation = { readonly __typename?: 'Mutation', readonly setChecklistItemDueDate?: { readonly __typename?: 'SetChecklistItemDueDatePayload', readonly checklistItem?: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null } | null } | null };

export type SetChecklistSectionDueDateMutationVariables = Exact<{
  input: SetChecklistSectionDueDateInput;
}>;


export type SetChecklistSectionDueDateMutation = { readonly __typename?: 'Mutation', readonly setChecklistSectionDueDate?: { readonly __typename?: 'SetChecklistSectionDueDatePayload', readonly checklistSection?: { readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type CreateChecklistMutationVariables = Exact<{
  input: CreateChecklistInput;
}>;


export type CreateChecklistMutation = { readonly __typename?: 'Mutation', readonly createChecklist?: { readonly __typename?: 'CreateChecklistPayload', readonly taskChecklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type CreateChecklistFromTemplateMutationVariables = Exact<{
  input: CreateChecklistFromTemplateInput;
}>;


export type CreateChecklistFromTemplateMutation = { readonly __typename?: 'Mutation', readonly createChecklistFromTemplate?: { readonly __typename?: 'CreateChecklistFromTemplatePayload', readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type CreateChecklistWithStructureMutationVariables = Exact<{
  input: CreateChecklistWithStructureInput;
}>;


export type CreateChecklistWithStructureMutation = { readonly __typename?: 'Mutation', readonly createChecklistWithStructure?: { readonly __typename?: 'CreateChecklistWithStructurePayload', readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type UpdateChecklistStructureMutationVariables = Exact<{
  input: UpdateChecklistStructureInput;
}>;


export type UpdateChecklistStructureMutation = { readonly __typename?: 'Mutation', readonly updateChecklistStructure?: { readonly __typename?: 'UpdateChecklistStructurePayload', readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type DeleteChecklistMutationVariables = Exact<{
  input: DeleteChecklistInput;
}>;


export type DeleteChecklistMutation = { readonly __typename?: 'Mutation', readonly deleteChecklist?: { readonly __typename?: 'DeleteChecklistPayload', readonly deletedChecklistId?: string | null } | null };

export type UpdateChecklistMutationVariables = Exact<{
  input: UpdateChecklistInput;
}>;


export type UpdateChecklistMutation = { readonly __typename?: 'Mutation', readonly updateChecklist?: { readonly __typename?: 'UpdateChecklistPayload', readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly requiresSignOff: boolean } | null } | null };

export type SignOffChecklistMutationVariables = Exact<{
  input: SignOffChecklistInput;
}>;


export type SignOffChecklistMutation = { readonly __typename?: 'Mutation', readonly signOffChecklist?: { readonly __typename?: 'SignOffChecklistPayload', readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null } | null };

export type SuggestRemediationStepsMutationVariables = Exact<{
  input: SuggestRemediationStepsInput;
}>;


export type SuggestRemediationStepsMutation = { readonly __typename?: 'Mutation', readonly suggestRemediationSteps?: { readonly __typename?: 'SuggestRemediationStepsPayload', readonly steps?: ReadonlyArray<{ readonly __typename?: 'SuggestedRemediationStepNode', readonly title: string, readonly description?: string | null, readonly guidance?: string | null }> | null } | null };

export type BatchCreateTaskDocumentsMutationVariables = Exact<{
  input: BatchCreateTaskDocumentsInput;
}>;


export type BatchCreateTaskDocumentsMutation = { readonly __typename?: 'Mutation', readonly batchCreateTaskDocuments?: { readonly __typename?: 'BatchCreateTaskDocumentsPayload', readonly taskDocuments?: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> | null } | null };

export type CreateTaskDocumentMutationVariables = Exact<{
  input: CreateTaskDocumentInput;
}>;


export type CreateTaskDocumentMutation = { readonly __typename?: 'Mutation', readonly createTaskDocument?: { readonly __typename?: 'CreateTaskDocumentPayload', readonly taskDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null };

export type RemoveTaskDocumentMutationVariables = Exact<{
  input: RemoveTaskDocumentInput;
}>;


export type RemoveTaskDocumentMutation = { readonly __typename?: 'Mutation', readonly removeTaskDocument?: { readonly __typename?: 'RemoveTaskDocumentPayload', readonly taskDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type UnassignClientTagFromTaskDefinitionMutationVariables = Exact<{
  input: UnassignClientTagFromTaskDefinitionInput;
}>;


export type UnassignClientTagFromTaskDefinitionMutation = { readonly __typename?: 'Mutation', readonly unassignClientTagFromTaskDefinition?: { readonly __typename?: 'UnassignClientTagFromTaskDefinitionPayload', readonly tagAssignment?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string } } | null, readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | null } | null };

export type UpdateTaskDefinitionDescriptionMutationVariables = Exact<{
  input: UpdateTaskDefinitionDescriptionInput;
}>;


export type UpdateTaskDefinitionDescriptionMutation = { readonly __typename?: 'Mutation', readonly updateTaskDefinitionDescription?: { readonly __typename?: 'UpdateTaskDefinitionDescriptionPayload', readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly description?: string | null } | null } | null };

export type UpdateTaskDefinitionPriorityMutationVariables = Exact<{
  input: UpdateTaskDefinitionPriorityInput;
}>;


export type UpdateTaskDefinitionPriorityMutation = { readonly __typename?: 'Mutation', readonly updateTaskDefinitionPriority?: { readonly __typename?: 'UpdateTaskDefinitionPriorityPayload', readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null } | null } | null };

export type UpdateTaskDefinitionVisibilityMutationVariables = Exact<{
  input: UpdateTaskDefinitionVisibilityInput;
}>;


export type UpdateTaskDefinitionVisibilityMutation = { readonly __typename?: 'Mutation', readonly updateTaskDefinitionVisibility?: { readonly __typename?: 'UpdateTaskDefinitionVisibilityPayload', readonly taskDefinition?: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly isVisibleToResidents: boolean, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null } | null } | null };

export type UpdateTaskPriorityMutationVariables = Exact<{
  input: UpdateTaskPriorityInput;
}>;


export type UpdateTaskPriorityMutation = { readonly __typename?: 'Mutation', readonly updateTaskPriority?: { readonly __typename?: 'UpdateTaskPriorityPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly priority?: string | null } | null } | null };

export type TaskQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TaskQuery = { readonly __typename?: 'DebugSchema', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null };

export type TaskCommunityFragment = { readonly __typename?: 'TaskNode', readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null } };

export type TaskDetailFragment = { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null };

export type TaskSourceActionFragment = { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } };

export type TaskDocumentFragment = { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null };

export type TaskItemFragment = { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly fixfloUrl?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> } };

export type TaskUpdateFragment = { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null };

export type VisibleGroupFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null };

export type TaskVisibilityFragment = { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly isVisibleToResidents: boolean, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null };

export type TaskTemplateStepFieldInputFragment = { readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean };

export type TaskTemplateStepFragment = { readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null };

export type TaskTemplateSectionFragment = { readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number };

export type TaskTemplateListItemFragment = { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type TaskTemplateDetailFragment = { readonly __typename?: 'TaskTemplateNode', readonly structureRevision: number, readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number }> | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null }> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null };

export type CreateTaskTemplateMutationVariables = Exact<{
  input: CreateTaskTemplateInput;
}>;


export type CreateTaskTemplateMutation = { readonly __typename?: 'Mutation', readonly createTaskTemplate?: { readonly __typename?: 'CreateTaskTemplatePayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly structureRevision: number, readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number }> | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null }> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null };

export type UpdateTaskTemplateMutationVariables = Exact<{
  input: UpdateTaskTemplateInput;
}>;


export type UpdateTaskTemplateMutation = { readonly __typename?: 'Mutation', readonly updateTaskTemplate?: { readonly __typename?: 'UpdateTaskTemplatePayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly structureRevision: number, readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number }> | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null }> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null };

export type UpdateTaskTemplateStructureMutationVariables = Exact<{
  input: UpdateTaskTemplateStructureInput;
}>;


export type UpdateTaskTemplateStructureMutation = { readonly __typename?: 'Mutation', readonly updateTaskTemplateStructure?: { readonly __typename?: 'UpdateTaskTemplateStructurePayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly structureRevision: number, readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number }> | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null }> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null };

export type ArchiveTaskTemplateMutationVariables = Exact<{
  input: ArchiveTaskTemplateInput;
}>;


export type ArchiveTaskTemplateMutation = { readonly __typename?: 'Mutation', readonly archiveTaskTemplate?: { readonly __typename?: 'ArchiveTaskTemplatePayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null };

export type UnarchiveTaskTemplateMutationVariables = Exact<{
  input: UnarchiveTaskTemplateInput;
}>;


export type UnarchiveTaskTemplateMutation = { readonly __typename?: 'Mutation', readonly unarchiveTaskTemplate?: { readonly __typename?: 'UnarchiveTaskTemplatePayload', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null };

export type TaskTemplatesQueryVariables = Exact<{
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDraft?: InputMaybe<Scalars['Boolean']['input']>;
  community?: InputMaybe<Scalars['UUID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type TaskTemplatesQuery = { readonly __typename?: 'DebugSchema', readonly taskTemplates?: { readonly __typename?: 'TaskTemplateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskTemplateNodeEdge', readonly node?: { readonly __typename?: 'TaskTemplateNode', readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null } | null> } | null };

export type TaskTemplateDetailQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type TaskTemplateDetailQuery = { readonly __typename?: 'DebugSchema', readonly taskTemplate?: { readonly __typename?: 'TaskTemplateNode', readonly structureRevision: number, readonly id: string, readonly name: string, readonly description?: string | null, readonly isSystem: boolean, readonly isActive: boolean, readonly isDraft: boolean, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly pdfExportEnabled: boolean, readonly stepCount: number, readonly communityIds?: ReadonlyArray<string> | null, readonly scope?: string | null, readonly complianceType?: string | null, readonly draftSourceTitle?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number }> | null, readonly steps?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly notes?: string | null, readonly sectionId?: string | null, readonly inputs?: ReadonlyArray<{ readonly __typename?: 'TaskTemplateStepInputNode', readonly id: string, readonly order: number, readonly inputType?: string | null, readonly label: string, readonly isRequired: boolean }> | null }> | null, readonly createdBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null } | null };

export type UpdateTaskMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type UpdateTaskMutation = { readonly __typename?: 'Mutation', readonly updateTask?: { readonly __typename?: 'UpdateTaskPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly dueDate?: string | null, readonly category?: { readonly __typename?: 'TaskCategoryNode', readonly id: string, readonly name: string } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null } | null } | null };

export type AddTaskCommentMutationVariables = Exact<{
  input: AddTaskCommentInput;
}>;


export type AddTaskCommentMutation = { readonly __typename?: 'Mutation', readonly addTaskComment?: { readonly __typename?: 'AddTaskCommentPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null, readonly taskUpdate?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string } | null } | null } | null };

export type GetFixfloIssueQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  issueRef: Scalars['String']['input'];
}>;


export type GetFixfloIssueQuery = { readonly __typename?: 'DebugSchema', readonly getFixfloIssue?: { readonly __typename?: 'FixfloIssueType', readonly id?: string | null, readonly title?: string | null, readonly faultCategory?: string | null, readonly status?: string | null, readonly faultPriority?: string | null, readonly created?: string | null, readonly address?: string | null } | null };

export type LinkTaskToAsanaMutationVariables = Exact<{
  input: LinkTaskToAsanaInput;
}>;


export type LinkTaskToAsanaMutation = { readonly __typename?: 'Mutation', readonly linkTaskToAsana?: { readonly __typename?: 'LinkTaskToAsanaPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null } | null };

export type LinkTaskToFixfloMutationVariables = Exact<{
  input: LinkTaskToFixfloInput;
}>;


export type LinkTaskToFixfloMutation = { readonly __typename?: 'Mutation', readonly linkTaskToFixflo?: { readonly __typename?: 'LinkTaskToFixfloPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null } | null };

export type PushTaskToAsanaMutationVariables = Exact<{
  input: PushTaskToAsanaInput;
}>;


export type PushTaskToAsanaMutation = { readonly __typename?: 'Mutation', readonly pushTaskToAsana?: { readonly __typename?: 'PushTaskToAsanaPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null } | null };

export type SearchAsanaTasksQueryVariables = Exact<{
  communityId: Scalars['UUID']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchAsanaTasksQuery = { readonly __typename?: 'DebugSchema', readonly searchAsanaTasks?: ReadonlyArray<{ readonly __typename?: 'AsanaTaskSearchResultType', readonly gid?: string | null, readonly name?: string | null, readonly permalinkUrl?: string | null } | null> | null };

export type UnlinkTaskFromAsanaMutationVariables = Exact<{
  input: UnlinkTaskFromAsanaInput;
}>;


export type UnlinkTaskFromAsanaMutation = { readonly __typename?: 'Mutation', readonly unlinkTaskFromAsana?: { readonly __typename?: 'UnlinkTaskFromAsanaPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null } | null };

export type UnlinkTaskFromFixfloMutationVariables = Exact<{
  input: UnlinkTaskFromFixfloInput;
}>;


export type UnlinkTaskFromFixfloMutation = { readonly __typename?: 'Mutation', readonly unlinkTaskFromFixflo?: { readonly __typename?: 'UnlinkTaskFromFixfloPayload', readonly task?: { readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly priority?: string | null, readonly dueDate?: string | null, readonly completedAt?: string | null, readonly scheduledFor?: string | null, readonly createdAt: string, readonly updatedAt: string, readonly fixfloId?: string | null, readonly fixfloUrl?: string | null, readonly asanaId?: string | null, readonly asanaUrl?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly name: string, readonly description?: string | null, readonly priority?: TasksTaskDefinitionPriorityChoices | null, readonly id: string, readonly isVisibleToResidents: boolean, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null, readonly availableClientTags?: { readonly __typename?: 'ClientTagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ClientTagNodeEdge', readonly node?: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } | null } | null> } | null, readonly communityTaskDefinitions?: { readonly __typename?: 'CommunityTaskDefinitionNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityTaskDefinitionNodeEdge', readonly node?: { readonly __typename?: 'CommunityTaskDefinitionNode', readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly hasAsanaIntegration: boolean, readonly name: string, readonly settings: { readonly __typename?: 'CommunitySettingsType', readonly fixfloUrl?: string | null, readonly residentVisibleTasks: boolean } } } | null } | null> } | null, readonly visibleToGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null } | null } | null> } | null }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly email: string, readonly displayPicture?: string | null } | null, readonly assignedTeam?: { readonly __typename?: 'TeamNode', readonly id: string, readonly name?: string | null } | null, readonly contractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null, readonly contractors: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> } } | null, readonly contractorUsers: { readonly __typename?: 'ContractorNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'ContractorNodeEdge', readonly node?: { readonly __typename?: 'ContractorNode', readonly id: string, readonly name?: string | null, readonly email?: string | null, readonly jobTitle?: string | null } | null } | null> }, readonly documents?: { readonly __typename?: 'TaskDocumentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskDocumentNodeEdge', readonly node?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string, readonly url?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string } | null, readonly taskGroup?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null } | null> } | null, readonly updates?: { readonly __typename?: 'TaskUpdateNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskUpdateNodeEdge', readonly node?: { readonly __typename?: 'TaskUpdateNode', readonly id: string, readonly updateType: TasksTaskUpdateUpdateTypeChoices, readonly comment?: string | null, readonly source?: TasksTaskUpdateSourceChoices | null, readonly newStatus?: TasksTaskUpdateNewStatusChoices | null, readonly createdAt: string, readonly actor?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly target?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly targetContractorCompany?: { readonly __typename?: 'ClientContractorCompanyNode', readonly id: string, readonly name?: string | null } | null, readonly targetConversation?: { readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string } | null, readonly targetDocument?: { readonly __typename?: 'TaskDocumentNode', readonly id: string, readonly title: string } | null, readonly targetAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string } } | null } | null } | null> } | null, readonly taskGroups: { readonly __typename?: 'TaskGroupNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'TaskGroupNodeEdge', readonly node?: { readonly __typename?: 'TaskGroupNode', readonly id: string } | null } | null> }, readonly linkedConversations?: ReadonlyArray<{ readonly __typename?: 'ConversationNode', readonly id: string, readonly subject: string, readonly createdAt: string, readonly user?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly home?: { readonly __typename?: 'HomeType', readonly id: string, readonly name: string } | null } | null> | null, readonly checklist?: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly showsComplianceCeremony: boolean, readonly isManuallyCompletable: boolean, readonly structureRevision: number, readonly requiresSignOff: boolean, readonly autoCompleteTask: boolean, readonly isSignedOff: boolean, readonly riskRating?: string | null, readonly riskLikelihood?: string | null, readonly riskConsequence?: string | null, readonly assessmentDate?: string | null, readonly nextAssessmentDate?: string | null, readonly assessorName?: string | null, readonly providerName?: string | null, readonly signedOffAt?: string | null, readonly approvedAt?: string | null, readonly notes?: string | null, readonly assessedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly signedOffBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly approvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly sections?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistSectionNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly dueDate?: string | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null }> | null, readonly items?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly order: number, readonly stepType?: string | null, readonly isRequired: boolean, readonly requiresPhoto: boolean, readonly referenceCode?: string | null, readonly guidance: string, readonly isCompleted: boolean, readonly completedAt?: string | null, readonly dueDate?: string | null, readonly responseBoolean?: boolean | null, readonly responseChoice?: string | null, readonly responseText: string, readonly responseNumber?: string | null, readonly responseDate?: string | null, readonly responseTime?: string | null, readonly notes?: string | null, readonly completedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly responses?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string, readonly order: number, readonly label: string, readonly isRequired: boolean, readonly inputType?: string | null, readonly valueBoolean?: boolean | null, readonly valueChoice?: string | null, readonly valueText: string, readonly valueNumber?: string | null, readonly valueDate?: string | null, readonly valueTime?: string | null }> | null, readonly action?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly origin?: string | null, readonly isSuggested: boolean, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly priorityRaw: string, readonly dueDate?: string | null, readonly plannedDate?: string | null, readonly location: string, readonly locations: ReadonlyArray<string>, readonly legislationReference: string, readonly sourceQuote: string, readonly confidence?: number | null, readonly reviewStatus?: string | null, readonly dismissalReason?: string | null, readonly dismissalNote: string, readonly reviewedAt?: string | null, readonly status?: string | null, readonly resolvedAt?: string | null, readonly followUpTaskCount: number, readonly reviewedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly resolvedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly followUpTasks?: ReadonlyArray<{ readonly __typename?: 'TaskNode', readonly id: string, readonly status: TasksTaskStatusChoices, readonly dueDate?: string | null, readonly taskDefinition: { readonly __typename?: 'TaskDefinitionNode', readonly id: string, readonly name: string }, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly notes?: string | null, readonly isCompleted: boolean } } | null, readonly assignedUser?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null, readonly media?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemMediaNode', readonly id: string, readonly file?: string | null, readonly createdAt: string, readonly uploadedBy?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string } | null, readonly response?: { readonly __typename?: 'TaskChecklistItemResponseNode', readonly id: string } | null }> | null, readonly comments?: ReadonlyArray<{ readonly __typename?: 'TaskChecklistItemCommentNode', readonly id: string, readonly body: string, readonly createdAt: string, readonly author?: { readonly __typename?: 'UserType', readonly id: string, readonly name: string, readonly displayPicture?: string | null } | null }> | null }> | null } | null, readonly sourceAction?: { readonly __typename?: 'ChecklistActionNode', readonly id: string, readonly finding: string, readonly recommendation: string, readonly priority?: string | null, readonly location: string, readonly legislationReference: string, readonly sourceQuote: string, readonly sourceExtraction?: { readonly __typename?: 'DocumentExtractionNode', readonly id: string, readonly title: string } | null, readonly item: { readonly __typename?: 'TaskChecklistItemNode', readonly id: string, readonly title: string, readonly description?: string | null, readonly referenceCode?: string | null, readonly checklist: { readonly __typename?: 'TaskChecklistNode', readonly id: string, readonly name: string, readonly kind?: string | null, readonly task: { readonly __typename?: 'TaskNode', readonly id: string } } } } | null } | null } | null };

export type ToggleArchivedAtCommunityUpdateMutationVariables = Exact<{
  input: ToggleArchivedAtCommunityUpdateInput;
}>;


export type ToggleArchivedAtCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly toggleArchivedAtCommunityUpdate?: { readonly __typename?: 'ToggleArchivedAtCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string } | null } | null };

export type CommunityUpdateQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type CommunityUpdateQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly body: string, readonly summary: string, readonly category: string, readonly image?: string | null, readonly attachment?: string | null, readonly isArk: boolean, readonly publishedAt?: string | null, readonly scheduledFor?: string | null, readonly imageUrl?: string | null, readonly imageSearchTerm?: string | null, readonly archivedAt?: string | null, readonly status: CommunityUpdateStatusEnum, readonly attachments?: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateAttachmentNode', readonly id: string, readonly file?: string | null, readonly fileName?: string | null } | null> | null, readonly groups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly locales?: ReadonlyArray<string | null> | null, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string, readonly commentsEnabled: boolean } | null } | null } | null> } | null, readonly variants?: { readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateLocaleVariantNode', readonly id: string, readonly locale?: string | null } | null } | null> } | null, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number, readonly totalReads: number, readonly totalComments: number }, readonly communityDocument?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly title: string, readonly file?: string | null, readonly document?: { readonly __typename?: 'DocumentNode', readonly id: string } | null } | null } | null };

export type DeleteCommunityUpdateMutationVariables = Exact<{
  input: DeleteCommunityUpdateInput;
}>;


export type DeleteCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly deleteCommunityUpdate?: { readonly __typename?: 'DeleteCommunityUpdatePayload', readonly id?: string | null } | null };

export type SaveCommunityUpdateMutationVariables = Exact<{
  input: SaveCommunityUpdateInput;
}>;


export type SaveCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly saveCommunityUpdate?: { readonly __typename?: 'SaveCommunityUpdatePayload', readonly id?: string | null, readonly title?: string | null, readonly summary?: string | null, readonly body?: string | null, readonly category?: string | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SelectDocumentDialogQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SelectDocumentDialogQuery = { readonly __typename?: 'DebugSchema', readonly documents?: { readonly __typename?: 'DocumentNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'DocumentNodeEdge', readonly node?: { readonly __typename?: 'DocumentNode', readonly id: string, readonly contentObject?: { readonly __typename?: 'CommunityDocumentNode', readonly id: string, readonly createdAt: string, readonly file?: string | null, readonly link?: string | null, readonly title: string, readonly activatedOn?: string | null, readonly archivedAt?: string | null, readonly url?: string | null, readonly groups: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } | null } | null } | null> }, readonly views: { readonly __typename?: 'CommunityDocumentViewNodeConnection', readonly totalCount: number }, readonly tags?: { readonly __typename?: 'TagNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagNodeEdge', readonly node?: { readonly __typename?: 'TagNode', readonly id: string, readonly name: string, readonly color?: string | null, readonly confidenceScore?: string | null } | null } | null> } | null, readonly tagAssignments?: { readonly __typename?: 'TagAssignmentNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'TagAssignmentNodeEdge', readonly node?: { readonly __typename?: 'TagAssignmentNode', readonly id: string, readonly tag: { readonly __typename?: 'ClientTagNode', readonly id: string, readonly name: string, readonly color?: string | null } } | null } | null> } | null } | { readonly __typename?: 'ResidencyDocumentNode' } | { readonly __typename?: 'UserDocumentNode' } | null } | null } | null> } | null };

export type CancelScheduledPublishCommunityUpdateMutationVariables = Exact<{
  input: CancelScheduledPublishCommunityUpdateInput;
}>;


export type CancelScheduledPublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly cancelScheduledPublishCommunityUpdate?: { readonly __typename?: 'CancelScheduledPublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommunityUpdateCommentsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityUpdateCommentsQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly comments?: { readonly __typename?: 'CommunityUpdateCommentNodeConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateCommentNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateCommentNode', readonly id: string, readonly name: string, readonly comment: string, readonly createdAt: string, readonly userType: ResidentialManagementCommunityUpdateCommentUserTypeChoices } | null } | null> } | null } | null };

export type CreateUpdateCommentMutationVariables = Exact<{
  input: CreateUpdateCommentInput;
}>;


export type CreateUpdateCommentMutation = { readonly __typename?: 'Mutation', readonly createUpdateComment?: { readonly __typename?: 'CreateUpdateCommentPayload', readonly communityUpdateComment?: { readonly __typename?: 'CommunityUpdateCommentNode', readonly comment: string } | null } | null };

export type DeleteUpdateCommentMutationVariables = Exact<{
  input: DeleteCommunityUpdateCommentInput;
}>;


export type DeleteUpdateCommentMutation = { readonly __typename?: 'Mutation', readonly deleteUpdateComment?: { readonly __typename?: 'DeleteCommunityUpdateCommentPayload', readonly id?: string | null } | null };

export type CommunityUpdateAttachmentFragment = { readonly __typename?: 'CommunityUpdateAttachmentNode', readonly id: string, readonly file?: string | null, readonly fileName?: string | null };

export type DeleteCommunityUpdateAttachmentMutationVariables = Exact<{
  input: DeleteCommunityUpdateAttachmentInput;
}>;


export type DeleteCommunityUpdateAttachmentMutation = { readonly __typename?: 'Mutation', readonly deleteCommunityUpdateAttachment?: { readonly __typename?: 'DeleteCommunityUpdateAttachmentPayload', readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type LocalesForGroupsQueryVariables = Exact<{
  ids: ReadonlyArray<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type LocalesForGroupsQuery = { readonly __typename?: 'DebugSchema', readonly communityGroups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly locales?: ReadonlyArray<string | null> | null } | null };

export type PreviewCommunityUpdateVariantsQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type PreviewCommunityUpdateVariantsQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly body: string, readonly publishedAt?: string | null, readonly summary: string, readonly category: string, readonly image?: string | null, readonly attachment?: string | null, readonly imageUrl?: string | null, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number }, readonly variants?: { readonly __typename?: 'CommunityUpdateLocaleVariantNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateLocaleVariantNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateLocaleVariantNode', readonly id: string, readonly locale?: string | null, readonly title?: string | null, readonly summary?: string | null, readonly body?: string | null, readonly status: ResidentialManagementCommunityUpdateLocaleVariantStatusChoices } | null } | null> } | null } | null };

export type PublishCommunityUpdateMutationVariables = Exact<{
  input: PublishCommunityUpdateInput;
}>;


export type PublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly publishCommunityUpdate?: { readonly __typename?: 'PublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum, readonly publishedAt?: string | null } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type SchedulePublishCommunityUpdateMutationVariables = Exact<{
  input: SchedulePublishCommunityUpdateInput;
}>;


export type SchedulePublishCommunityUpdateMutation = { readonly __typename?: 'Mutation', readonly schedulePublishCommunityUpdate?: { readonly __typename?: 'SchedulePublishCommunityUpdatePayload', readonly communityUpdate?: { readonly __typename?: 'CommunityUpdateType', readonly id: string, readonly status: CommunityUpdateStatusEnum } | null, readonly errors?: ReadonlyArray<{ readonly __typename?: 'ErrorType', readonly field: string, readonly messages: ReadonlyArray<string> } | null> | null } | null };

export type CommmunityUpdateGroupItemFragment = { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null };

export type CommunityUpdatesQueryVariables = Exact<{
  communities?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  communityGroups?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  category?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunityUpdatesQuery = { readonly __typename?: 'DebugSchema', readonly communityUpdates?: { readonly __typename?: 'CommunityUpdateNodeConnection', readonly totalCount: number, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityUpdateNodeEdge', readonly node?: { readonly __typename?: 'CommunityUpdateNode', readonly id: string, readonly title: string, readonly summary: string, readonly image?: string | null, readonly imageUrl?: string | null, readonly category: string, readonly publishedAt?: string | null, readonly status: CommunityUpdateStatusEnum, readonly stats: { readonly __typename?: 'CommunityUpdateStatsType', readonly totalLikes: number, readonly totalReads: number, readonly totalComments: number }, readonly groups?: { readonly __typename?: 'CommunityGroupNodeConnection', readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityGroupNodeEdge', readonly node?: { readonly __typename?: 'CommunityGroupNode', readonly id: string, readonly name?: string | null, readonly community?: { readonly __typename?: 'CommunityNode', readonly name: string } | null } | null } | null> } | null } | null } | null>, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null } } | null };

export type SignOutCommunityVisitorMutationVariables = Exact<{
  input: SignOutCommunityVisitorInput;
}>;


export type SignOutCommunityVisitorMutation = { readonly __typename?: 'Mutation', readonly signOutCommunityVisitor?: { readonly __typename?: 'SignOutCommunityVisitorPayload', readonly communityVisitor?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly signedOutAt?: string | null } | null } | null };

export type VisitorQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type VisitorQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitor?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly email: string, readonly mobile?: string | null, readonly createdAt: string, readonly residentName?: string | null, readonly reasonForVisit?: string | null, readonly signedOutAt?: string | null, readonly vehicleRegistration?: string | null, readonly company?: string | null, readonly type?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string } } | null };

export type VisitorItemFragment = { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly residentName?: string | null, readonly signedOutAt?: string | null, readonly reasonForVisit?: string | null, readonly type?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null };

export type VisitorsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  communities?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  visitorType?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  signedOut?: InputMaybe<Scalars['Boolean']['input']>;
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  block?: InputMaybe<Scalars['UUID']['input']>;
}>;


export type VisitorsQuery = { readonly __typename?: 'DebugSchema', readonly communityVisitors?: { readonly __typename?: 'CommunityVisitorNodeConnection', readonly totalCount: number, readonly pageInfo: { readonly __typename?: 'PageInfo', readonly endCursor?: string | null, readonly hasNextPage: boolean }, readonly edges: ReadonlyArray<{ readonly __typename?: 'CommunityVisitorNodeEdge', readonly node?: { readonly __typename?: 'CommunityVisitorNode', readonly id: string, readonly name: string, readonly createdAt: string, readonly residentName?: string | null, readonly signedOutAt?: string | null, readonly reasonForVisit?: string | null, readonly type?: string | null, readonly community: { readonly __typename?: 'CommunityNode', readonly id: string, readonly name: string }, readonly home?: { readonly __typename?: 'HomeNode', readonly id: string, readonly name: string, readonly block?: { readonly __typename?: 'BlockNode', readonly id: string, readonly name: string } | null } | null } | null } | null> } | null };

export type SendManagerAmplitudeTestMutationVariables = Exact<{
  input: SendManagerAmplitudeTestInput;
}>;


export type SendManagerAmplitudeTestMutation = { readonly __typename?: 'Mutation', readonly sendManagerAmplitudeTest?: { readonly __typename?: 'SendManagerAmplitudeTestPayload', readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string } | null } | null };

export type ReferencingEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type ReferencingEnabledQuery = { readonly __typename?: 'DebugSchema', readonly getUser?: { readonly __typename?: 'UserType', readonly id: string, readonly manager?: { readonly __typename?: 'ManagerType', readonly id: string, readonly community?: { readonly __typename?: 'CommunityNodeConnection', readonly totalCount: number } | null } | null } | null };

export const ConversationListItemFragmentDoc = gql`
    fragment ConversationListItem on ConversationNode {
  id
  subject
  snoozedUntil
  closedAt
  user {
    id
    firstName
    lastName
    name
    email
  }
  home {
    id
    name
    community {
      id
      name
      team {
        edges {
          node {
            id
            name
            email
            firstName
            lastName
          }
        }
      }
    }
  }
  hasUnread
  latestEvent {
    ... on ConversationMessageType {
      id
      body
      createdAt
      messageSender: sender
      user {
        id
        firstName
        lastName
      }
    }
    ... on ConversationMediaType {
      id
      createdAt
      mediaSender: sender
      user {
        id
        firstName
        lastName
      }
    }
    ... on ConversationActionModelType {
      id
      createdAt
      type
      extra
    }
  }
  assignment {
    id
    assignedTo {
      id
      name
      email
      firstName
      lastName
      displayPicture
    }
  }
  teamAssignment {
    id
    team {
      id
      name
      icon
    }
  }
  home {
    id
    client {
      id
      tags {
        edges {
          node {
            id
            name
            isSelected
            suggested
          }
        }
      }
    }
  }
  tags {
    totalCount
    edges {
      node {
        id
        name
        color
      }
    }
  }
  tagAssignments {
    totalCount
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
}
    `;
export const CommunityTeamMembersFragmentDoc = gql`
    fragment CommunityTeamMembers on CommunityNode {
  id
  team {
    edges {
      node {
        id
        name
        firstName
        lastName
        email
        displayPicture
      }
    }
  }
}
    `;
export const ConversationAssignmentDataFragmentDoc = gql`
    fragment ConversationAssignmentData on ConversationNode {
  id
  assignment {
    id
    assignedTo {
      id
      name
      firstName
      lastName
      email
      displayPicture
    }
  }
  teamAssignment {
    id
    team {
      id
      name
      icon
    }
  }
  home {
    id
    community {
      id
    }
  }
}
    `;
export const AvailableClientTagFragmentDoc = gql`
    fragment AvailableClientTag on ClientTagNode {
  id
  name
  color
  archivedAt
}
    `;
export const ConversationTagAssignmentFragmentFragmentDoc = gql`
    fragment ConversationTagAssignmentFragment on TagAssignmentNode {
  id
  tag {
    id
    name
    color
  }
}
    `;
export const ConversationLabelFragmentDoc = gql`
    fragment ConversationLabel on ConversationTagNode {
  id
  name
  color
}
    `;
export const ContractorSuggestionFragmentDoc = gql`
    fragment ContractorSuggestion on ContractorSuggestionType {
  id
  isContractor
  isContractorDecision
  contractorConfidence
  homeConfidence
  contractorHasCompany
  suggestedHome {
    id
    name
  }
}
    `;
export const RatingAnswerFragmentDoc = gql`
    fragment RatingAnswer on ConversationRatingAnswerType {
  id
  valueText
  question {
    id
    questionText
    answerType
  }
}
    `;
export const ClientTagLabelNodeFragmentDoc = gql`
    fragment ClientTagLabelNode on ClientTagNode {
  name
  color
}
    `;
export const CommunityForFilterCommunityFragmentDoc = gql`
    fragment CommunityForFilterCommunity on CommunityNode {
  id
  name
  status
  deactivatedOn
}
    `;
export const CommunityTeamMemberFragmentDoc = gql`
    fragment CommunityTeamMember on CommunityTeamNode {
  id
  name
  firstName
  lastName
  email
  displayPicture
  isManager
  isCommunityManager
  isAdmin
  isConcierge
}
    `;
export const CommunityGroupFilterGroupFragmentDoc = gql`
    fragment CommunityGroupFilterGroup on CommunityGroupNode {
  id
  name
  communityId
  communityName
  isCommunityScoped
  isBlockScoped
}
    `;
export const CommunitySettingsFragmentDoc = gql`
    fragment CommunitySettings on CommunitySettingsType {
  newsfeed
  messages
  surveys
  documents
  events
  facilities
  marketplace
  accounts
  products
}
    `;
export const UserCommunityItemFragmentDoc = gql`
    fragment UserCommunityItem on CommunityNode {
  id
  name
  status
  settings {
    ...CommunitySettings
  }
  packageLocations
}
    ${CommunitySettingsFragmentDoc}`;
export const ClientAdminItemFragmentDoc = gql`
    fragment ClientAdminItem on ClientAdminNode {
  id
  client {
    id
    name
    clientType
  }
  communities {
    edges {
      node {
        ...UserCommunityItem
      }
    }
    totalCount
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const ConciergeItemFragmentDoc = gql`
    fragment ConciergeItem on ConciergeNode {
  id
  communities(orderBy: "name") {
    edges {
      node {
        ...UserCommunityItem
      }
    }
    totalCount
  }
  client {
    id
    name
    clientType
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const ManagerItemFragmentDoc = gql`
    fragment ManagerItem on ManagerType {
  id
  email
  client {
    id
    name
    clientType
  }
  community(orderBy: "name") {
    totalCount
    edges {
      node {
        ...UserCommunityItem
      }
    }
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const RmcDirectorItemFragmentDoc = gql`
    fragment RMCDirectorItem on RMCDirectorNode {
  id
  communities {
    edges {
      node {
        ...UserCommunityItem
      }
    }
  }
}
    ${UserCommunityItemFragmentDoc}`;
export const NotificationHookFragmentDoc = gql`
    fragment NotificationHook on NotificationNode {
  id
  verb
  actor {
    ... on ResidentNode {
      id
      firstName
      lastName
    }
    ... on ApplicantNode {
      id
      firstName
      lastName
    }
    ... on ConciergeNode {
      id
    }
    ... on UserType {
      id
      firstName
      lastName
    }
  }
  target {
    ... on CommunityUpdateNode {
      id
    }
    ... on ConversationNode {
      id
    }
    ... on ResidentSurveyNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyNode {
      id
    }
    ... on CommunityProductNode {
      id
    }
    ... on AmenityNode {
      id
    }
    ... on CommunityEventNode {
      id
    }
    ... on TenantReferenceNode {
      uuid: id
    }
    ... on ConversationAssignmentNode {
      id
      conversation {
        id
      }
    }
    ... on TeamAssignmentNode {
      id
      objectId
    }
    ... on FeatureAnnouncementNode {
      id
      slug
    }
    ... on TaskNode {
      id
    }
    ... on ApplicationThreadNode {
      id
      applicationId
      application {
        id
      }
    }
    ... on DocumentExtractionNode {
      id
      extractedTaskId
    }
  }
  actionObject {
    ... on CommunityUpdateCommentNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyholderNode {
      id
    }
    ... on CommunityProductPurchaseNode {
      id
    }
    ... on AmenityReservationNode {
      id
    }
    ... on MarketplaceItemCommentNode {
      id
    }
    ... on CommunityEventNode {
      id
    }
  }
}
    `;
export const NotificationsMenuNotificationFragmentDoc = gql`
    fragment NotificationsMenuNotification on NotificationNode {
  id
  createdAt
  verb
  read
  title
  target {
    ... on CommunityUpdateNode {
      id
    }
    ... on ConversationNode {
      id
    }
    ... on ResidentSurveyNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyNode {
      id
    }
    ... on CommunityProductNode {
      id
    }
    ... on AmenityNode {
      id
    }
    ... on CommunityEventNode {
      id
    }
    ... on TenantReferenceNode {
      uuid: id
    }
    ... on ConversationAssignmentNode {
      id
      conversation {
        id
      }
    }
    ... on TeamAssignmentNode {
      id
      objectId
    }
    ... on FeatureAnnouncementNode {
      id
      slug
    }
    ... on TaskNode {
      id
    }
    ... on ApplicationThreadNode {
      id
      applicationId
      application {
        id
      }
    }
    ... on DocumentExtractionNode {
      id
      extractedTaskId
    }
  }
  actionObject {
    ... on CommunityUpdateCommentNode {
      id
    }
    ... on ApplicationNode {
      id
    }
    ... on KeyholderNode {
      id
    }
    ... on CommunityProductPurchaseNode {
      id
    }
    ... on AmenityReservationNode {
      id
    }
    ... on MarketplaceItemCommentNode {
      id
    }
    ... on CommunityEventNode {
      id
    }
  }
}
    `;
export const TeamFilterItemFragmentDoc = gql`
    fragment TeamFilterItem on TeamNode {
  id
  name
  icon
}
    `;
export const ClientTagMinimalFragmentDoc = gql`
    fragment ClientTagMinimal on ClientTagNode {
  id
  name
  color
}
    `;
export const ClientTagItemFragmentDoc = gql`
    fragment ClientTagItem on ClientTagNode {
  id
  name
  description
  color
  archivedAt
  isSystemManaged
  createdBy {
    id
    firstName
    lastName
    email
    displayPicture
  }
  client {
    id
    name
  }
}
    `;
export const TaggedConversationItemFragmentDoc = gql`
    fragment TaggedConversationItem on ConversationNode {
  id
  closedAt
  snoozedUntil
  currentUrgency
  latestMessage {
    seen
  }
  latestUpdatedDate
  resident {
    id
    firstName
    lastName
  }
  community {
    id
    name
  }
}
    `;
export const TaggedCommunityDocumentItemFragmentDoc = gql`
    fragment TaggedCommunityDocumentItem on CommunityDocumentNode {
  id
  createdAt
  file
  link
  title
  activatedOn
  archivedAt
  url
  document {
    id
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const TaggedUserDocumentItemFragmentDoc = gql`
    fragment TaggedUserDocumentItem on UserDocumentNode {
  id
  createdAt
  file
  link
  title
  activatedOn
  url
  document {
    id
  }
  users {
    id
    firstName
    lastName
  }
  createdBy {
    id
    firstName
    lastName
  }
}
    `;
export const MemberItemFragmentDoc = gql`
    fragment MemberItem on ClientStaffMemberNode {
  id
  firstName
  lastName
  email
  lastActive
  role
  communityIds
  teamIds
}
    `;
export const TeamItemFragmentDoc = gql`
    fragment TeamItem on TeamNode {
  id
  name
  description
  icon
  communities {
    edges {
      node {
        id
        name
      }
    }
  }
  users {
    id
    firstName
    lastName
    email
  }
  activatedAt
  deactivatedAt
  updatedAt
}
    `;
export const AmenityReservationItemFragmentDoc = gql`
    fragment AmenityReservationItem on AmenityReservationNode {
  id
  start
  end
  cancellationMessage
  reason
  isManager
  additionalAttendance
  amenity {
    id
    community {
      id
      name
    }
  }
  user {
    id
    name
    resident {
      id
      residencies {
        id
        home {
          id
          name
          community {
            id
          }
        }
      }
    }
    leaseholder {
      id
      leaseholds {
        edges {
          node {
            id
            home {
              id
              name
              community {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const AmenityItemFragmentDoc = gql`
    fragment AmenityItem on AmenityNode {
  id
  name
  startTime
  endTime
  daysAvailable
  image
  status
  type
  description
  todaysBookingCount
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
  operatingTimes {
    edges {
      node {
        id
        weekDay
        startTime
        endTime
        isActivated
      }
    }
  }
  maxReservations
}
    `;
export const ApplicationItemFragmentDoc = gql`
    fragment ApplicationItem on ApplicationNode {
  id
  addressLine1
  postcode
  createdAt
  status
  archivedAt
  applicant {
    id
    name
    email
  }
  community {
    id
    name
  }
  home {
    id
    name
    postcode
  }
  thread {
    id
    unreadCount
  }
  source
}
    `;
export const ApplicationStatusPillFragmentDoc = gql`
    fragment ApplicationStatusPill on ApplicationNode {
  status
  archivedAt
}
    `;
export const ApplicantDocumentFragmentDoc = gql`
    fragment ApplicantDocument on ApplicationAttemptNode {
  id
  createdAt
  proofOfAddress
  verificationResult {
    id
    status
    documentType
    isProofOfAddress
    appearsAuthentic
    authenticityDetail
    extractedName
    extractedAddress
    nameMatchStatus
    addressMatchStatus
    nameMatchDetail
    addressMatchDetail
    aiRecommendation
    confidence
  }
}
    `;
export const ApplicantDocumentsFragmentDoc = gql`
    fragment ApplicantDocuments on ApplicantNode {
  id
  applications {
    edges {
      node {
        id
        applicationAttempts(orderBy: "-created_at") {
          edges {
            node {
              ...ApplicantDocument
            }
          }
        }
      }
    }
  }
}
    ${ApplicantDocumentFragmentDoc}`;
export const ApplicationAuditLogEntryFragmentDoc = gql`
    fragment ApplicationAuditLogEntry on ApplicationAuditLogNode {
  id
  eventType
  actor {
    id
    name
  }
  metadata
  createdAt
}
    `;
export const ApplicationAttemptsFragmentDoc = gql`
    fragment ApplicationAttempts on ApplicationAttemptNodeConnection {
  totalCount
  pageInfo {
    endCursor
    hasNextPage
  }
  edges {
    node {
      id
      createdAt
      proofOfAddress
      rejectionReason
      rejectedOn
      reviewer {
        user {
          firstName
          lastName
        }
      }
    }
  }
}
    `;
export const ApplicationFragmentDoc = gql`
    fragment Application on ApplicationNode {
  id
  status
  createdAt
  addressLine1
  addressLine2
  townOrCity
  region
  postcode
  ownershipType
  source
  lastRejectionReason
  approvedAt
  archivedAt
  applicant {
    id
    firstName
    lastName
    email
    mobile
  }
  community {
    id
    name
  }
  home {
    id
    name
    postcode
    address
  }
  thread {
    id
    unreadCount
  }
  applicationAttempts(after: $after, orderBy: "-created_at") {
    ...ApplicationAttempts
  }
}
    ${ApplicationAttemptsFragmentDoc}`;
export const ApplicationThreadMediaFragmentDoc = gql`
    fragment ApplicationThreadMedia on ApplicationThreadMediaNode {
  id
  file
  sender
  user {
    id
    name
  }
  createdAt
  readAt
}
    `;
export const ApplicationThreadMessageFragmentDoc = gql`
    fragment ApplicationThreadMessage on ApplicationThreadMessageNode {
  id
  body
  sender
  user {
    id
    name
  }
  createdAt
  readAt
}
    `;
export const BlockItemFragmentDoc = gql`
    fragment BlockItem on BlockNode {
  id
  name
  community {
    id
    name
  }
  homesCount
  createdAt
}
    `;
export const BlockListItemFragmentDoc = gql`
    fragment BlockListItem on BlockNode {
  id
  name
  imageUrl
  isDefault
  community {
    id
    name
  }
  homesCount
  unassignedHomesCount
  everyoneCount
  residentsCount
  leaseholdersCount
  status
  unconfirmedHomesCount
  isNewUnconfirmed
}
    `;
export const PendingBlockSetupCommunityFragmentDoc = gql`
    fragment PendingBlockSetupCommunity on CommunityNode {
  id
  name
  pendingBlockSetup {
    runId
    appliedAt
    blocksCreated
    homesPlaced
    unconfirmedCount
  }
}
    `;
export const SafetyPackExclusionFragmentDoc = gql`
    fragment SafetyPackExclusion on SafetyPackExclusionType {
  reason
  label
  count
}
    `;
export const SafetyPackExcludedRecordFragmentDoc = gql`
    fragment SafetyPackExcludedRecord on SafetyPackExcludedRecordType {
  recordId
  reason
  label
  homeName
  floorNumber
  blockName
}
    `;
export const SafetyPackInclusionFragmentDoc = gql`
    fragment SafetyPackInclusion on SafetyPackEligibilityType {
  totalCount
  eligibleCount
  excludedCount
  exclusions {
    ...SafetyPackExclusion
  }
  excludedRecords {
    ...SafetyPackExcludedRecord
  }
}
    ${SafetyPackExclusionFragmentDoc}
${SafetyPackExcludedRecordFragmentDoc}`;
export const SafetyResponderPackStateFragmentDoc = gql`
    fragment SafetyResponderPackState on SafetyResponderPackNode {
  id
  fileUrl
  isComplete
  isStale
  generatedAt
  printedAt
  isTokenActive
  tokenActivatedAt
  tokenRotatedAt
  tokenRotationReason
  responderUrl
  rotationResidualWindow
  eligibility {
    ...SafetyPackInclusion
  }
}
    ${SafetyPackInclusionFragmentDoc}`;
export const SafetyDocumentBuildingFragmentDoc = gql`
    fragment SafetyDocumentBuilding on BlockNode {
  id
  name
  homesCount
  totalFloors
  responsiblePersonName
  responsiblePersonRole
  hrbReference
  dutyHolderLabel
  safetyResponderPack {
    ...SafetyResponderPackState
  }
}
    ${SafetyResponderPackStateFragmentDoc}`;
export const BlockDetailFragmentDoc = gql`
    fragment BlockDetail on BlockNode {
  id
  name
  isDefault
  imageUrl
  homesCount
  unassignedHomesCount
  status
  deleteRefusal
  unconfirmedHomesCount
  isNewUnconfirmed
  community {
    id
    name
    settings {
      safetyCenter
    }
  }
  ...SafetyDocumentBuilding
}
    ${SafetyDocumentBuildingFragmentDoc}`;
export const BlockHomeAddressFragmentDoc = gql`
    fragment BlockHomeAddress on HomeNode {
  name
  addressLine1
  postcode
}
    `;
export const BlockHomeRowFragmentDoc = gql`
    fragment BlockHomeRow on HomeNode {
  id
  ...BlockHomeAddress
  floorNumber
  block {
    id
    name
    isDefault
  }
  occupantCount
}
    ${BlockHomeAddressFragmentDoc}`;
export const BlockGroupCardFragmentDoc = gql`
    fragment BlockGroupCard on CommunityGroupNode {
  id
  name
  type
  description
  defaultDescription
  numUsers
  pinnedHomes {
    id
    name
    block {
      id
      name
      isDefault
    }
  }
}
    `;
export const BlockPlacementRowFragmentDoc = gql`
    fragment BlockPlacementRow on BlockPlacementType {
  id
  method
  placedAt
  home {
    id
    ...BlockHomeAddress
  }
}
    ${BlockHomeAddressFragmentDoc}`;
export const CommunityOpenPeriodFragmentDoc = gql`
    fragment CommunityOpenPeriod on CommunityOpenPeriodNode {
  id
  start
  end
  weekdayIndex
}
    `;
export const TeamMemberItemFragmentDoc = gql`
    fragment TeamMemberItem on CommunityTeamNode {
  id
  firstName
  lastName
  email
  isManager
  isAdmin
  isConcierge
  isCommunityManager
}
    `;
export const CommunityProductFragmentDoc = gql`
    fragment CommunityProduct on CommunityProductNode {
  id
  name
  description
  active
  communities {
    edges {
      node {
        id
        name
      }
    }
  }
  price
}
    `;
export const ComplianceBlockItemFragmentDoc = gql`
    fragment ComplianceBlockItem on BlockNode {
  id
  name
  createdAt
  community {
    id
    name
  }
  missingComplianceCount: blockComplianceRequirements(status: "MISSING") {
    totalCount
  }
  expiredComplianceCount: blockComplianceRequirements(status: "EXPIRED") {
    totalCount
  }
  expiringComplianceCount: blockComplianceRequirements(status: "EXPIRING") {
    totalCount
  }
  checkedComplianceCount: blockComplianceRequirements(status: "CHECKED") {
    totalCount
  }
  totalComplianceCount: blockComplianceRequirements {
    totalCount
  }
}
    `;
export const BlockComplianceRequirementFragmentDoc = gql`
    fragment BlockComplianceRequirement on BlockComplianceRequirementNode {
  id
  status
  block {
    id
    name
    community {
      id
      name
    }
  }
  requirement {
    id
    name
    description
    shared
  }
  item {
    id
    expiryDate
    createdAt
    attachments {
      edges {
        node {
          id
          file
          url
          createdAt
        }
      }
    }
  }
}
    `;
export const ContactPageListItemFragmentDoc = gql`
    fragment ContactPageListItem on ContactNode {
  id
  name
  email
  lastAppUse
  communities {
    id
    name
  }
  resident {
    id
    avatar
    averageScore
    currentResidencies {
      id
      home {
        id
        name
      }
    }
  }
  leaseholder {
    id
    leaseholds {
      edges {
        node {
          id
          createdAt
          home {
            id
            name
            address
            community {
              id
              name
            }
          }
        }
      }
    }
  }
  applicant {
    id
    applications {
      edges {
        node {
          id
          home {
            id
          }
          addressLine1
          addressLine2
          approvedAt
          createdAt
          status
        }
      }
    }
  }
}
    `;
export const ContactsListItemFieldsFragmentDoc = gql`
    fragment ContactsListItemFields on ContactNode {
  ...ContactPageListItem
  firstName
  lastName
}
    ${ContactPageListItemFragmentDoc}`;
export const ContactAmenityReservationFragmentDoc = gql`
    fragment ContactAmenityReservation on AmenityReservationNode {
  id
  amenity {
    id
    name
    type
  }
  start
  end
  cancellationMessage
}
    `;
export const ContactApplicationItemFragmentDoc = gql`
    fragment ContactApplicationItem on ApplicationNode {
  id
  home {
    id
  }
  addressLine1
  addressLine2
  approvedAt
  createdAt
  status
}
    `;
export const ContactNoteItemFragmentDoc = gql`
    fragment ContactNoteItem on ContactNoteNode {
  id
  text
  author {
    id
    name
  }
  community {
    id
    name
  }
  createdAt
}
    `;
export const ContactFormItemFragmentDoc = gql`
    fragment ContactFormItem on CommunityFormNode {
  id
  title
  responses(contactId: $id) {
    edges {
      node {
        id
        submittedAt
        answers
        hidden
        user {
          id
          email
          name
        }
      }
    }
  }
  questions {
    edges {
      node {
        id
        ref
        title
        type
        properties
      }
    }
  }
}
    `;
export const LatestDeclarationFragmentDoc = gql`
    fragment LatestDeclaration on ResidentSafetyDeclarationNode {
  id
  origin
  declaredAt
  declarantName
  isVoided
}
    `;
export const ContactSafetyRecordItemFragmentDoc = gql`
    fragment ContactSafetyRecordItem on ResidentSafetyRecordNode {
  id
  isOccupant
  first
  last
  mobilityNeeds
  communicationNeeds
  language
  largePrint
  braille
  textToSpeech
  consentGivenAt
  lastReviewedAt
  latestDeclaration {
    ...LatestDeclaration
  }
  residency {
    id
    home {
      id
      address
      community {
        id
        name
        settings {
          safetyCenter
          surveyReviewIntervalMonths
        }
      }
    }
  }
}
    ${LatestDeclarationFragmentDoc}`;
export const ResidentItemFragmentDoc = gql`
    fragment ResidentItem on ResidentNode {
  id
  name
  email
  avatar
  averageScore
  currentResidencies {
    home {
      id
      name
      addressLine1
      city
    }
  }
  user {
    id
    lastAppUse
  }
}
    `;
export const ContractorCompanyItemFragmentDoc = gql`
    fragment ContractorCompanyItem on ClientContractorCompanyNode {
  id
  name
  companyType
  email
  phone
  address
  website
  notes
  contractors {
    edges {
      node {
        id
        name
        email
        phone
        jobTitle
      }
    }
  }
  communities {
    edges {
      node {
        id
        name
      }
    }
  }
  isActive
  contractorCount
  createdAt
}
    `;
export const AssigneeFragmentDoc = gql`
    fragment Assignee on UserType {
  id
  firstName
  lastName
  displayPicture
  email
}
    `;
export const ConversationListItemLightFragmentDoc = gql`
    fragment ConversationListItemLight on ConversationNode {
  id
  subject
  snoozedUntil
  closedAt
  hasUnread
  isResidentWaiting
  lastActivityAt
  contractorSuggestion {
    id
    isContractorDecision
    contractorHasCompany
  }
  user {
    id
    name
  }
  home {
    id
    name
    community {
      id
      name
    }
  }
  community {
    id
    name
  }
  latestEvent {
    ... on ConversationMessageType {
      id
      createdAt
      messageSender: sender
    }
    ... on ConversationMediaType {
      id
      createdAt
      mediaSender: sender
    }
    ... on ConversationActionModelType {
      id
      createdAt
      type
    }
  }
  assignment {
    id
    assignedTo {
      ...Assignee
    }
  }
  teamAssignment {
    id
    team {
      id
      name
      icon
    }
  }
  tagAssignments {
    totalCount
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
}
    ${AssigneeFragmentDoc}`;
export const DocumentTagItemFragmentDoc = gql`
    fragment DocumentTagItem on TagNode {
  id
  name
  color
  confidenceScore
}
    `;
export const CommunityDocumentListItemFragmentDoc = gql`
    fragment CommunityDocumentListItem on CommunityDocumentNode {
  id
  createdAt
  file
  link
  title
  activatedOn
  archivedAt
  url
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
  views {
    totalCount
  }
  tags(archivedAt: false) {
    edges {
      node {
        ...DocumentTagItem
      }
    }
  }
  tagAssignments {
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
}
    ${DocumentTagItemFragmentDoc}`;
export const CommunityDocumentFragmentDoc = gql`
    fragment CommunityDocument on CommunityDocumentNode {
  id
  createdAt
  file
  link
  title
  description
  url
  activatedOn
  totalPotentialViewers
  archivedAt
  community {
    id
    name
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
  tags(archivedAt: false) {
    edges {
      node {
        id
        name
        color
        confidenceScore
        archivedAt
      }
    }
  }
  tagAssignments {
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
  availableClientTags {
    edges {
      node {
        id
        name
        color
      }
    }
  }
  views(after: $after) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        user {
          id
          name
        }
      }
    }
  }
}
    `;
export const ResidencyDocumentFragmentDoc = gql`
    fragment ResidencyDocument on ResidencyDocumentNode {
  id
  createdAt
  file
  link
  title
  description
  url
  activatedOn
  community {
    id
    name
  }
  residency {
    id
    startDate
    completionDate
    residents {
      id
      name
      user {
        id
        email
      }
    }
    home {
      id
      name
      address
    }
  }
  views(after: $after) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        user {
          id
          name
        }
      }
    }
  }
}
    `;
export const UserDocumentFragmentDoc = gql`
    fragment UserDocument on UserDocumentNode {
  id
  createdAt
  file
  link
  title
  description
  url
  users {
    id
    name
  }
  views {
    totalCount
    edges {
      node {
        id
        createdAt
        user {
          id
          name
        }
      }
    }
  }
  createdBy {
    id
    name
  }
  activatedOn
  community {
    id
    name
  }
  tags(archivedAt: false) {
    edges {
      node {
        ...DocumentTagItem
      }
    }
  }
  tagAssignments {
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
  availableClientTags {
    edges {
      node {
        id
        name
        color
      }
    }
  }
}
    ${DocumentTagItemFragmentDoc}`;
export const ResidencyDocumentListItemFragmentDoc = gql`
    fragment ResidencyDocumentListItem on ResidencyDocumentNode {
  id
  createdAt
  file
  link
  title
  activatedOn
  url
  residency {
    id
    home {
      id
      name
      address
    }
  }
  views {
    totalCount
  }
}
    `;
export const UserDocumentListItemFragmentDoc = gql`
    fragment UserDocumentListItem on UserDocumentNode {
  id
  createdAt
  file
  link
  title
  url
  users {
    id
    firstName
    lastName
  }
  views {
    totalCount
  }
  createdBy {
    id
    firstName
    lastName
  }
  activatedOn
  tags(archivedAt: false) {
    edges {
      node {
        ...DocumentTagItem
      }
    }
  }
  tagAssignments {
    edges {
      node {
        id
        tag {
          id
          name
          color
        }
      }
    }
  }
}
    ${DocumentTagItemFragmentDoc}`;
export const CommunityEventItemFragmentDoc = gql`
    fragment CommunityEventItem on CommunityEventNode {
  id
  name
  start
  end
  maxSpaces
  maxAdditionalAttendees
  availableSpaces
  links
  community {
    id
    name
  }
  groups {
    edges {
      node {
        id
        name
      }
    }
  }
  archivedAt
}
    `;
export const CommunityEventPartyUserFragmentDoc = gql`
    fragment CommunityEventPartyUser on ContactNode {
  id
  name
  email
  resident {
    id
    residencies {
      id
      home {
        id
        name
        community {
          id
        }
      }
    }
  }
  leaseholder {
    id
    leaseholds {
      edges {
        node {
          id
          home {
            id
            name
            community {
              id
            }
          }
        }
      }
    }
  }
}
    `;
export const FormItemFragmentDoc = gql`
    fragment FormItem on CommunityFormNode {
  id
  externalId
  provider
  activatedOn
  deactivatedOn
  title
  responses {
    edges {
      node {
        id
        submittedAt
        answers
        hidden
        user {
          id
          email
          name
        }
      }
    }
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const ContactItemFragmentDoc = gql`
    fragment ContactItem on ContactNode {
  id
  name
  firstName
  lastName
  email
  mobile
  lastAppUse
  resident {
    id
    avatar
    averageScore
    currentResidencies {
      id
      home {
        id
        address
        block {
          id
        }
      }
    }
  }
  leaseholder {
    id
    leaseholds {
      edges {
        node {
          id
          home {
            id
            address
            block {
              id
            }
          }
        }
      }
    }
  }
  applicant {
    id
    applications {
      edges {
        node {
          id
          addressLine1
          postcode
        }
      }
    }
  }
}
    `;
export const CommunityGroupItemFragmentDoc = gql`
    fragment CommunityGroupItem on CommunityGroupNode {
  id
  name
  description
  deactivatedOn
  numUsers
  community {
    id
    name
  }
  block {
    id
    name
  }
  isAutomatic
  isSystemManaged
}
    `;
export const HomeItemFragmentDoc = gql`
    fragment HomeItem on HomeNode {
  id
  name
  addressLine1
  address
  city
  postcode
  community {
    id
    name
  }
  floorNumber
  block {
    id
    name
    totalFloors
  }
  activeResidency {
    id
    residents {
      id
      name
      email
    }
  }
  leasehold {
    id
    leaseholder {
      edges {
        node {
          id
          user {
            id
            email
          }
        }
      }
    }
  }
}
    `;
export const OnSiteVisitorItemFragmentDoc = gql`
    fragment OnSiteVisitorItem on CommunityVisitorNode {
  id
  name
  email
  mobile
}
    `;
export const KeyEventItemFragmentDoc = gql`
    fragment KeyEventItem on KeyEventNode {
  id
  type
  createdAt
  keyholder {
    id
    name
  }
  performedBy {
    id
    name
  }
}
    `;
export const KeyHomeItemFragmentDoc = gql`
    fragment KeyHomeItem on HomeNode {
  id
  name
  addressLine1
  address
  postcode
  activeResidency {
    residents {
      id
      name
      email
    }
  }
}
    `;
export const KeyholderItemFragmentDoc = gql`
    fragment KeyholderItem on KeyholderNode {
  id
  name
  type
  phoneNumber
}
    `;
export const KeyItemFragmentDoc = gql`
    fragment KeyItem on KeyNode {
  id
  name
  reference
  status
  checkoutDate
  image
  community {
    id
    name
  }
  home {
    id
    name
    addressLine1
    block {
      id
      name
    }
  }
  currentKeyholder {
    id
    name
  }
}
    `;
export const MarketplaceItemFragmentDoc = gql`
    fragment MarketplaceItem on MarketplaceItemNode {
  id
  title
  description
  price
  condition
  createdAt
  closedOn
  condition
  community {
    name
  }
  images {
    edges {
      node {
        id
        image
      }
    }
  }
  user {
    firstName
    lastName
    id
  }
  comments {
    totalCount
  }
  archivedBy {
    id
    name
  }
  archivedOn
  archivedReason
}
    `;
export const LeanNotificationCenterNotificationFragmentDoc = gql`
    fragment LeanNotificationCenterNotification on LeanNotificationNode {
  id
  createdAt
  verb
  read
  title
  type
  platform
  targetType
  targetObjectId
  actionObjectType
  actionObjectObjectId
  isFeatureAnnouncement
  navigationMeta {
    targetType
    actionObjectType
    routeId
    secondaryId
  }
}
    `;
export const NotificationTargetFragmentDoc = gql`
    fragment NotificationTarget on Target {
  ... on CommunityUpdateNode {
    id
  }
  ... on ConversationNode {
    id
  }
  ... on ResidentSurveyNode {
    id
  }
  ... on ApplicationNode {
    id
  }
  ... on KeyNode {
    id
  }
  ... on CommunityProductNode {
    id
  }
  ... on AmenityNode {
    id
  }
  ... on CommunityEventNode {
    id
  }
  ... on TenantReferenceNode {
    uuid: id
  }
  ... on ConversationAssignmentNode {
    id
    conversation {
      id
    }
  }
  ... on TeamAssignmentNode {
    id
    objectId
  }
  ... on FeatureAnnouncementNode {
    id
    slug
  }
  ... on TaskNode {
    id
  }
  ... on ApplicationThreadNode {
    id
    applicationId
    application {
      id
    }
  }
  ... on DocumentExtractionNode {
    id
    extractedTaskId
  }
}
    `;
export const NotificationActionObjectFragmentDoc = gql`
    fragment NotificationActionObject on ActionObject {
  ... on CommunityUpdateCommentNode {
    id
  }
  ... on ApplicationNode {
    id
  }
  ... on KeyholderNode {
    id
  }
  ... on CommunityProductPurchaseNode {
    id
  }
  ... on AmenityReservationNode {
    id
  }
  ... on MarketplaceItemCommentNode {
    id
  }
}
    `;
export const NotificationCenterNotificationFragmentDoc = gql`
    fragment NotificationCenterNotification on NotificationNode {
  id
  createdAt
  verb
  read
  title
  target {
    ...NotificationTarget
  }
  actionObject {
    ...NotificationActionObject
  }
}
    ${NotificationTargetFragmentDoc}
${NotificationActionObjectFragmentDoc}`;
export const PackageEventFragmentDoc = gql`
    fragment PackageEvent on PackageEventNode {
  id
  createdAt
  type
  performedBy {
    id
    name
  }
  reason
}
    `;
export const AccountTransactionItemFragmentDoc = gql`
    fragment AccountTransactionItem on AccountTransactionNode {
  id
  createdAt
  amount
  status
  account {
    home {
      id
      address
      community {
        id
        name
      }
    }
    residency {
      id
      externalId
      residents {
        id
        name
      }
    }
    leasehold {
      id
      externalId
      leaseholder {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const LeanPulseNotificationFragmentDoc = gql`
    fragment LeanPulseNotification on LeanNotificationNode {
  id
  createdAt
  read
  title
  actorName
  targetType
  targetObjectId
  actionObjectType
  actionObjectObjectId
  isFeatureAnnouncement
  navigationMeta {
    targetType
    actionObjectType
    routeId
    secondaryId
  }
}
    `;
export const PulseNotificationFragmentDoc = gql`
    fragment PulseNotification on NotificationNode {
  id
  actorName
  pulseTitle
  createdAt
  read
  target {
    ...NotificationTarget
  }
  actionObject {
    ...NotificationActionObject
  }
}
    ${NotificationTargetFragmentDoc}
${NotificationActionObjectFragmentDoc}`;
export const TenancyApplicantItemFragmentDoc = gql`
    fragment TenancyApplicantItem on TenancyApplicantNode {
  id
  firstName
  lastName
  email
  mobile
  reference {
    id
    status
    identityVerificationStatus
    creditCheckStatus
    lettingHistoryStatus
    employmentStatus
    rightToRentStatus
  }
}
    `;
export const TenancyApplicationItemFragmentDoc = gql`
    fragment TenancyApplicationItem on TenancyApplicationNode {
  id
  status
  applicantNames
  applicants {
    edges {
      node {
        id
        reference {
          id
        }
      }
    }
  }
  home {
    id
    address
    community {
      id
      name
    }
  }
}
    `;
export const ApplicationReceivedFigureFragmentDoc = gql`
    fragment ApplicationReceivedFigure on ApplicationReportingNode {
  received {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const ApplicationApprovedFigureFragmentDoc = gql`
    fragment ApplicationApprovedFigure on ApplicationReportingNode {
  approved {
    total
    byDay {
      day
      count
    }
  }
  approvedByProof {
    hasProofOfAddress
    count
  }
}
    `;
export const ApplicationPendingFigureFragmentDoc = gql`
    fragment ApplicationPendingFigure on ApplicationReportingNode {
  pending {
    atEnd {
      day
      count
    }
    byDay {
      day
      count
    }
  }
}
    `;
export const ApplicationPendingByWaitFigureFragmentDoc = gql`
    fragment ApplicationPendingByWaitFigure on ApplicationReportingNode {
  pendingByWait {
    minDays
    maxDays
    count
  }
}
    `;
export const ApplicationTimeToApprovalFigureFragmentDoc = gql`
    fragment ApplicationTimeToApprovalFigure on ApplicationReportingNode {
  timeToApproval {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const ApplicationOutcomesFigureFragmentDoc = gql`
    fragment ApplicationOutcomesFigure on ApplicationReportingNode {
  outcomes {
    approvalRate
    decidedCount
    byStatus {
      status
      count
    }
  }
}
    `;
export const ApplicationResubmissionsFigureFragmentDoc = gql`
    fragment ApplicationResubmissionsFigure on ApplicationReportingNode {
  resubmissions {
    attemptsPerApproval
    approvedCount
    resubmittedCount
  }
}
    `;
export const ApplicationFunnelFigureFragmentDoc = gql`
    fragment ApplicationFunnelFigure on ApplicationReportingNode {
  funnel {
    stage
    count
  }
}
    `;
export const BookingMadeFigureFragmentDoc = gql`
    fragment BookingMadeFigure on BookingReportingNode {
  bookings {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const BookingFacilityFigureFragmentDoc = gql`
    fragment BookingFacilityFigure on BookingReportingNode {
  byFacility {
    amenityId
    label
    count
  }
}
    `;
export const BookingCancellationFigureFragmentDoc = gql`
    fragment BookingCancellationFigure on BookingReportingNode {
  cancellations {
    total
    rate
    byDay {
      day
      count
    }
  }
}
    `;
export const BookingLeadTimeFigureFragmentDoc = gql`
    fragment BookingLeadTimeFigure on BookingReportingNode {
  leadTime {
    medianSeconds
    sampleCount
  }
}
    `;
export const BookingBookersFigureFragmentDoc = gql`
    fragment BookingBookersFigure on BookingReportingNode {
  bookers {
    uniqueBookers
    bookingsPerBooker
    frequency {
      minBookings
      maxBookings
      bookers
    }
  }
}
    `;
export const BookingBookedByFigureFragmentDoc = gql`
    fragment BookingBookedByFigure on BookingReportingNode {
  bookedBy {
    bookedByStaff
    count
  }
}
    `;
export const BookingSlotPatternFigureFragmentDoc = gql`
    fragment BookingSlotPatternFigure on BookingReportingNode {
  slotPattern {
    weekday
    hour
    count
  }
}
    `;
export const ConversationOpenedFigureFragmentDoc = gql`
    fragment ConversationOpenedFigure on ConversationReportingNode {
  opened {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const ConversationClosedFigureFragmentDoc = gql`
    fragment ConversationClosedFigure on ConversationReportingNode {
  closed {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const ConversationReopenedFigureFragmentDoc = gql`
    fragment ConversationReopenedFigure on ConversationReportingNode {
  reopened {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const ConversationOpenFigureFragmentDoc = gql`
    fragment ConversationOpenFigure on ConversationReportingNode {
  openConversations {
    atEnd {
      day
      count
    }
    byDay {
      day
      count
    }
  }
}
    `;
export const ConversationFirstResponseFigureFragmentDoc = gql`
    fragment ConversationFirstResponseFigure on ConversationReportingNode {
  firstResponse {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const ConversationResponseTimeFigureFragmentDoc = gql`
    fragment ConversationResponseTimeFigure on ConversationReportingNode {
  responseTime {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const ConversationSatisfactionFigureFragmentDoc = gql`
    fragment ConversationSatisfactionFigure on ConversationReportingNode {
  satisfaction {
    meanRating
    ratedCount
    byStar {
      stars
      count
    }
  }
}
    `;
export const ConversationTopicsFigureFragmentDoc = gql`
    fragment ConversationTopicsFigure on ConversationReportingNode {
  topics {
    tagId
    label
    count
  }
}
    `;
export const DocumentLiveFigureFragmentDoc = gql`
    fragment DocumentLiveFigure on DocumentReportingNode {
  live {
    count
    viewedCount
    viewedShare
  }
}
    `;
export const DocumentAddedFigureFragmentDoc = gql`
    fragment DocumentAddedFigure on DocumentReportingNode {
  added {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const DocumentViewedFigureFragmentDoc = gql`
    fragment DocumentViewedFigure on DocumentReportingNode {
  uniqueViewers
  mostViewed {
    documentId
    title
    viewerCount
  }
}
    `;
export const DocumentNeverViewedFigureFragmentDoc = gql`
    fragment DocumentNeverViewedFigure on DocumentReportingNode {
  neverViewed {
    total
    byAge {
      minDays
      maxDays
      count
    }
  }
}
    `;
export const DocumentTagsFigureFragmentDoc = gql`
    fragment DocumentTagsFigure on DocumentReportingNode {
  tags {
    tagId
    label
    count
  }
}
    `;
export const DocumentRemindersFigureFragmentDoc = gql`
    fragment DocumentRemindersFigure on DocumentReportingNode {
  reminders {
    total
  }
}
    `;
export const KeyMovementsFigureFragmentDoc = gql`
    fragment KeyMovementsFigure on KeyReportingNode {
  movements {
    checkedOut
    checkedIn
    byDay {
      day
      checkedOut
      checkedIn
    }
  }
}
    `;
export const KeysOutFigureFragmentDoc = gql`
    fragment KeysOutFigure on KeyReportingNode {
  keysOut {
    atEnd {
      day
      count
    }
    byDay {
      day
      count
    }
  }
}
    `;
export const KeyTimeHeldFigureFragmentDoc = gql`
    fragment KeyTimeHeldFigure on KeyReportingNode {
  timeHeld {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const KeyDaysHeldFigureFragmentDoc = gql`
    fragment KeyDaysHeldFigure on KeyReportingNode {
  daysHeld {
    overdueCount
    buckets {
      minDays
      maxDays
      count
      overdue
    }
  }
}
    `;
export const KeyHolderCompaniesFigureFragmentDoc = gql`
    fragment KeyHolderCompaniesFigure on KeyReportingNode {
  holderCompanies {
    label
    count
  }
}
    `;
export const PackageDeliveredFigureFragmentDoc = gql`
    fragment PackageDeliveredFigure on PackageReportingNode {
  delivered {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const PackageCollectedFigureFragmentDoc = gql`
    fragment PackageCollectedFigure on PackageReportingNode {
  collected {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const PackageUncollectedFigureFragmentDoc = gql`
    fragment PackageUncollectedFigure on PackageReportingNode {
  uncollected {
    atEnd {
      day
      count
    }
    byDay {
      day
      count
    }
  }
}
    `;
export const PackageTimeToCollectionFigureFragmentDoc = gql`
    fragment PackageTimeToCollectionFigure on PackageReportingNode {
  timeToCollection {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const PackageAgeingFigureFragmentDoc = gql`
    fragment PackageAgeingFigure on PackageReportingNode {
  ageing {
    overTwoWeeks
    buckets {
      minDays
      maxDays
      count
    }
  }
}
    `;
export const PackageDeliveryPatternFigureFragmentDoc = gql`
    fragment PackageDeliveryPatternFigure on PackageReportingNode {
  deliveryPattern {
    weekday
    hour
    count
  }
}
    `;
export const PackageRemindersFigureFragmentDoc = gql`
    fragment PackageRemindersFigure on PackageReportingNode {
  reminders {
    total
    collectedWithin48Hours
    sampleCount
  }
}
    `;
export const PackageCollectionPointFigureFragmentDoc = gql`
    fragment PackageCollectionPointFigure on PackageReportingNode {
  collectionPoints {
    inLocker
    count
  }
}
    `;
export const PackageDataQualityFigureFragmentDoc = gql`
    fragment PackageDataQualityFigure on PackageReportingNode {
  dataQuality {
    markedAsDuplicate
    markedAsIncorrectlyAssigned
  }
}
    `;
export const PortfolioWindowFieldsFragmentDoc = gql`
    fragment PortfolioWindowFields on PortfolioWindowNode {
  startDate
  endDate
}
    `;
export const PortfolioEngagementRowFieldsFragmentDoc = gql`
    fragment PortfolioEngagementRowFields on PortfolioEngagementRowNode {
  communityId
  homes
  occupiedHomes
  appHomes
  activeHomes
  people
  appUsers
  activeUsers
  health
  downloadRate
  activeRate
}
    `;
export const PortfolioReachRowFieldsFragmentDoc = gql`
    fragment PortfolioReachRowFields on PortfolioReachRowNode {
  communityId
  occupiedHomes
  updateReaderHomes
  documentViewerHomes
  updateReadShare
  documentViewShare
}
    `;
export const PortfolioMaintenanceRowFieldsFragmentDoc = gql`
    fragment PortfolioMaintenanceRowFields on PortfolioMaintenanceRowNode {
  communityId
  homes
  opened
  judged
  onTime
  closed
  medianCloseSeconds
  openAtEnd
  openByAge
  health
  openPerHundredHomes
}
    `;
export const PortfolioSatisfactionRowFieldsFragmentDoc = gql`
    fragment PortfolioSatisfactionRowFields on PortfolioSatisfactionRowNode {
  communityId
  rated
  positive
  stars
  closed
  closedRated
  health
  meanRating
  responseRate
}
    `;
export const PortfolioCoverageFieldsFragmentDoc = gql`
    fragment PortfolioCoverageFields on PortfolioCoverageNode {
  segment
  people
  appUsers
  active7
  active30
  active90
}
    `;
export const PortfolioIssueTypeFieldsFragmentDoc = gql`
    fragment PortfolioIssueTypeFields on PortfolioIssueTypeNode {
  tagId
  name
  openAtEnd
  closed
  medianCloseSeconds
}
    `;
export const PortfolioRatingKindFieldsFragmentDoc = gql`
    fragment PortfolioRatingKindFields on PortfolioRatingKindNode {
  kind
  rated
  positive
  health
  meanRating
}
    `;
export const PortfolioSatisfactionTimingFieldsFragmentDoc = gql`
    fragment PortfolioSatisfactionTimingFields on PortfolioSatisfactionTimingNode {
  communityId
  firstResponseSeconds
  firstResponses
  replySeconds
  replies
  closeSeconds
  closes
}
    `;
export const ApplicationComparisonFiguresFragmentDoc = gql`
    fragment ApplicationComparisonFigures on ApplicationReportingNode {
  received {
    total
  }
  approved {
    total
  }
  approvedByProof {
    hasProofOfAddress
    count
  }
  pending {
    atEnd {
      count
    }
  }
  timeToApproval {
    medianSeconds
  }
  outcomes {
    approvalRate
  }
  resubmissions {
    attemptsPerApproval
    medianAttemptsPerApproval
    resubmittedCount
  }
  receivedWithMultipleAttempts
}
    `;
export const ApplicationMedianAttemptsFigureFragmentDoc = gql`
    fragment ApplicationMedianAttemptsFigure on ApplicationReportingNode {
  resubmissions {
    medianAttemptsPerApproval
  }
}
    `;
export const ApplicationMultipleAttemptsFigureFragmentDoc = gql`
    fragment ApplicationMultipleAttemptsFigure on ApplicationReportingNode {
  receivedWithMultipleAttempts
}
    `;
export const ApplicationFlowFigureFragmentDoc = gql`
    fragment ApplicationFlowFigure on ApplicationReportingNode {
  flow {
    source
    target
    count
  }
}
    `;
export const ApplicationRejectionReasonFigureFragmentDoc = gql`
    fragment ApplicationRejectionReasonFigure on ApplicationReportingNode {
  rejectionReasons {
    reason
    count
  }
}
    `;
export const ApplicationSubmissionSourceFigureFragmentDoc = gql`
    fragment ApplicationSubmissionSourceFigure on ApplicationReportingNode {
  bySubmissionSource {
    submissionSource
    count
  }
}
    `;
export const BookingComparisonFiguresFragmentDoc = gql`
    fragment BookingComparisonFigures on BookingReportingNode {
  bookings {
    total
  }
  cancellations {
    total
    rate
  }
  leadTime {
    medianSeconds
  }
  residentReach {
    bookerCount
    share
  }
}
    `;
export const BookingCapacityFigureFragmentDoc = gql`
    fragment BookingCapacityFigure on BookingReportingNode {
  capacityUse {
    amenityId
    label
    usedHours
    capacityHours
    share
  }
}
    `;
export const BookingResidentReachFigureFragmentDoc = gql`
    fragment BookingResidentReachFigure on BookingReportingNode {
  residentReach {
    bookerCount
    residentCount
    share
  }
}
    `;
export const ConversationComparisonFiguresFragmentDoc = gql`
    fragment ConversationComparisonFigures on ConversationReportingNode {
  opened {
    total
  }
  closed {
    total
  }
  reopened {
    total
  }
  openConversations {
    atEnd {
      count
    }
  }
  firstResponse {
    medianSeconds
  }
  responseTime {
    medianSeconds
  }
  resolutionTime {
    medianSeconds
  }
  satisfaction {
    meanRating
    ratedCount
  }
  ratedShare
}
    `;
export const ConversationResolutionTimeFigureFragmentDoc = gql`
    fragment ConversationResolutionTimeFigure on ConversationReportingNode {
  resolutionTime {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const ConversationSatisfactionByMonthFigureFragmentDoc = gql`
    fragment ConversationSatisfactionByMonthFigure on ConversationReportingNode {
  satisfactionByMonth {
    month
    meanRating
    ratedCount
  }
}
    `;
export const ConversationBlockTagsFigureFragmentDoc = gql`
    fragment ConversationBlockTagsFigure on ConversationReportingNode {
  blockTags {
    blockId
    blockLabel
    tagId
    count
  }
}
    `;
export const ConversationRatedShareFigureFragmentDoc = gql`
    fragment ConversationRatedShareFigure on ConversationReportingNode {
  ratedShare
}
    `;
export const ConversationTopicComparisonFigureFragmentDoc = gql`
    fragment ConversationTopicComparisonFigure on ConversationReportingNode {
  topicComparison {
    tagId
    label
    count
    yearAverage
  }
  tagUseTotal
}
    `;
export const ConversationTopicSatisfactionFigureFragmentDoc = gql`
    fragment ConversationTopicSatisfactionFigure on ConversationReportingNode {
  satisfactionByTopic {
    tagId
    label
    conversationCount
    meanRating
  }
}
    `;
export const ConversationOpenedPatternFigureFragmentDoc = gql`
    fragment ConversationOpenedPatternFigure on ConversationReportingNode {
  openedPattern {
    weekday
    hour
    count
  }
}
    `;
export const ConversationChannelFigureFragmentDoc = gql`
    fragment ConversationChannelFigure on ConversationReportingNode {
  byChannel {
    channel
    count
  }
}
    `;
export const ConversationSenderCategoryFigureFragmentDoc = gql`
    fragment ConversationSenderCategoryFigure on ConversationReportingNode {
  bySenderCategory {
    senderCategory
    count
  }
}
    `;
export const DocumentComparisonFiguresFragmentDoc = gql`
    fragment DocumentComparisonFigures on DocumentReportingNode {
  added {
    total
  }
  uniqueViewers
  reminders {
    total
  }
  liveByDay {
    day
    count
  }
}
    `;
export const DocumentLiveByDayFigureFragmentDoc = gql`
    fragment DocumentLiveByDayFigure on DocumentReportingNode {
  liveByDay {
    day
    count
  }
}
    `;
export const DocumentAllViewedFigureFragmentDoc = gql`
    fragment DocumentAllViewedFigure on DocumentReportingNode {
  allViewed {
    residentCount
    audienceCount
    viewedAllCount
    share
  }
}
    `;
export const DocumentReachFigureFragmentDoc = gql`
    fragment DocumentReachFigure on DocumentReportingNode {
  reach {
    documentId
    title
    audienceCount
    viewerCount
    share
  }
}
    `;
export const DocumentFirstViewsFigureFragmentDoc = gql`
    fragment DocumentFirstViewsFigure on DocumentReportingNode {
  firstViews {
    weekday
    hour
    count
  }
}
    `;
export const KeyComparisonFiguresFragmentDoc = gql`
    fragment KeyComparisonFigures on KeyReportingNode {
  overdueAtEnd
  movements {
    checkedOut
    checkedIn
  }
  keysOut {
    atEnd {
      count
    }
  }
  timeHeld {
    medianSeconds
  }
}
    `;
export const KeyOverdueAtEndFigureFragmentDoc = gql`
    fragment KeyOverdueAtEndFigure on KeyReportingNode {
  overdueAtEnd
}
    `;
export const KeyActiveHoldersFigureFragmentDoc = gql`
    fragment KeyActiveHoldersFigure on KeyReportingNode {
  activeHolders
}
    `;
export const KeyLongestHeldFigureFragmentDoc = gql`
    fragment KeyLongestHeldFigure on KeyReportingNode {
  longestHeld {
    keyId
    label
    heldSeconds
  }
}
    `;
export const PackageComparisonFiguresFragmentDoc = gql`
    fragment PackageComparisonFigures on PackageReportingNode {
  overTwoWeeksAtEnd
  delivered {
    total
  }
  collected {
    total
  }
  uncollected {
    atEnd {
      count
    }
  }
  timeToCollection {
    medianSeconds
  }
  reminders {
    total
    collectedWithin48HoursCount
  }
  remindersPerPackage
  lastReminder {
    medianSeconds
  }
  dataQuality {
    markedAsDuplicate
    markedAsIncorrectlyAssigned
  }
}
    `;
export const PackageCollectionPatternFigureFragmentDoc = gql`
    fragment PackageCollectionPatternFigure on PackageReportingNode {
  collectionPattern {
    weekday
    hour
    count
  }
}
    `;
export const PackageWaitingHomesFigureFragmentDoc = gql`
    fragment PackageWaitingHomesFigure on PackageReportingNode {
  waitingHomes {
    homeId
    label
    count
  }
}
    `;
export const PackageCollectedAfterReminderFigureFragmentDoc = gql`
    fragment PackageCollectedAfterReminderFigure on PackageReportingNode {
  reminders {
    total
    collectedWithin48HoursCount
  }
}
    `;
export const PackageRemindersPerPackageFigureFragmentDoc = gql`
    fragment PackageRemindersPerPackageFigure on PackageReportingNode {
  remindersPerPackage
}
    `;
export const PackageLastReminderFigureFragmentDoc = gql`
    fragment PackageLastReminderFigure on PackageReportingNode {
  lastReminder {
    medianSeconds
    sampleCount
  }
}
    `;
export const PackageWaitingAtEndFigureFragmentDoc = gql`
    fragment PackageWaitingAtEndFigure on PackageReportingNode {
  overTwoWeeksAtEnd
}
    `;
export const PackageLocationFigureFragmentDoc = gql`
    fragment PackageLocationFigure on PackageReportingNode {
  locations {
    location
    count
  }
}
    `;
export const UpdateComparisonFiguresFragmentDoc = gql`
    fragment UpdateComparisonFigures on UpdateReportingNode {
  published {
    total
  }
  uniqueReaders
  readRate {
    rate
  }
  likes {
    total
  }
  comments {
    total
  }
  scheduled {
    share
  }
  contentMix {
    imageShare
    attachmentShare
  }
  engagement {
    index
  }
}
    `;
export const UpdateEngagementRowFragmentDoc = gql`
    fragment UpdateEngagementRow on UpdateReportingUpdateEngagementNode {
  updateId
  title
  publishedAt
  likes
  comments
  views
  uniqueViews
  audienceSize
  engagementIndex
}
    `;
export const UpdateEngagementTableFigureFragmentDoc = gql`
    fragment UpdateEngagementTableFigure on UpdateReportingNode {
  engagement {
    likes
    comments
    uniqueViews
    audienceSize
    index
    byUpdate {
      ...UpdateEngagementRow
    }
  }
}
    ${UpdateEngagementRowFragmentDoc}`;
export const UpdateContentMixFigureFragmentDoc = gql`
    fragment UpdateContentMixFigure on UpdateReportingNode {
  contentMix {
    publishedCount
    withImageCount
    withAttachmentCount
    imageShare
    attachmentShare
  }
}
    `;
export const UpdatePublishedByWeekFigureFragmentDoc = gql`
    fragment UpdatePublishedByWeekFigure on UpdateReportingNode {
  published {
    total
    byWeek {
      week
      count
    }
  }
}
    `;
export const UpdatePublishedByStaffFigureFragmentDoc = gql`
    fragment UpdatePublishedByStaffFigure on UpdateReportingNode {
  publishedByStaff {
    userId
    name
    count
  }
}
    `;
export const VisitComparisonFiguresFragmentDoc = gql`
    fragment VisitComparisonFigures on VisitReportingNode {
  signIns {
    total
  }
  signOuts {
    total
  }
  timeOnSite {
    medianSeconds
  }
  notSignedOut {
    total
  }
}
    `;
export const VisitSignOutsFigureFragmentDoc = gql`
    fragment VisitSignOutsFigure on VisitReportingNode {
  signOuts {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const UpdatePublishedFigureFragmentDoc = gql`
    fragment UpdatePublishedFigure on UpdateReportingNode {
  published {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const UpdateReadersFigureFragmentDoc = gql`
    fragment UpdateReadersFigure on UpdateReportingNode {
  uniqueReaders
}
    `;
export const UpdateReadRateFigureFragmentDoc = gql`
    fragment UpdateReadRateFigure on UpdateReportingNode {
  readRate {
    rate
    updateCount
  }
}
    `;
export const UpdateEngagementFigureFragmentDoc = gql`
    fragment UpdateEngagementFigure on UpdateReportingNode {
  likes {
    total
  }
  comments {
    total
  }
}
    `;
export const UpdateCategoryFigureFragmentDoc = gql`
    fragment UpdateCategoryFigure on UpdateReportingNode {
  categories {
    category
    count
  }
}
    `;
export const UpdateTopUpdatesFigureFragmentDoc = gql`
    fragment UpdateTopUpdatesFigure on UpdateReportingNode {
  topUpdates {
    updateId
    title
    readerCount
  }
}
    `;
export const UpdateScheduledFigureFragmentDoc = gql`
    fragment UpdateScheduledFigure on UpdateReportingNode {
  scheduled {
    share
    scheduledCount
    publishedCount
  }
}
    `;
export const VisitOnSiteFigureFragmentDoc = gql`
    fragment VisitOnSiteFigure on VisitReportingNode {
  onSiteNow
}
    `;
export const VisitSignInsFigureFragmentDoc = gql`
    fragment VisitSignInsFigure on VisitReportingNode {
  signIns {
    total
    byDay {
      day
      count
    }
  }
}
    `;
export const VisitorTypesFigureFragmentDoc = gql`
    fragment VisitorTypesFigure on VisitReportingNode {
  visitorTypes {
    visitorType
    count
  }
}
    `;
export const VisitTimeOnSiteFigureFragmentDoc = gql`
    fragment VisitTimeOnSiteFigure on VisitReportingNode {
  timeOnSite {
    medianSeconds
    sampleCount
    byDay {
      day
      medianSeconds
    }
  }
}
    `;
export const VisitNotSignedOutFigureFragmentDoc = gql`
    fragment VisitNotSignedOutFigure on VisitReportingNode {
  notSignedOut {
    total
    buckets {
      minDays
      maxDays
      count
    }
  }
}
    `;
export const VisitArrivalsFigureFragmentDoc = gql`
    fragment VisitArrivalsFigure on VisitReportingNode {
  arrivals {
    weekday
    hour
    count
  }
}
    `;
export const VisitCompaniesFigureFragmentDoc = gql`
    fragment VisitCompaniesFigure on VisitReportingNode {
  companies {
    label
    count
  }
}
    `;
export const ReportingConfigurationFieldsFragmentDoc = gql`
    fragment ReportingConfigurationFields on ReportingConfigurationNode {
  id
  name
  reportKey
  schemaVersion
  configuration
  revision
  isFavourite
  lastOpenedAt
  createdAt
}
    `;
export const ReportingScheduleFieldsFragmentDoc = gql`
    fragment ReportingScheduleFields on ReportingScheduleNode {
  id
  cadence
  nextRunAt
}
    `;
export const TeamDayFieldsFragmentDoc = gql`
    fragment TeamDayFields on TeamDayValueNode {
  day
  value
}
    `;
export const TeamMemberFieldsFragmentDoc = gql`
    fragment TeamMemberFields on TeamMemberNode {
  userId
  name
}
    `;
export const TeamDurationFieldsFragmentDoc = gql`
    fragment TeamDurationFields on TeamDurationNode {
  medianSeconds
  sampleCount
  byDay {
    ...TeamDayFields
  }
  byMember {
    member {
      ...TeamMemberFields
    }
    medianSeconds
    sampleCount
  }
}
    ${TeamDayFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}`;
export const TeamActivityFiguresFragmentDoc = gql`
    fragment TeamActivityFigures on TeamActivityReportingNode {
  sessionLength {
    ...TeamDurationFields
  }
  presence {
    activeMemberCount
    memberCount
    medianSessionsPerMember
  }
}
    ${TeamDurationFieldsFragmentDoc}`;
export const TeamApplicationFiguresFragmentDoc = gql`
    fragment TeamApplicationFigures on TeamApplicationReportingNode {
  decisions {
    approved
    rejected
    medianActionSeconds
    byDay {
      ...TeamDayFields
    }
    byMember {
      member {
        ...TeamMemberFields
      }
      approved
      rejected
      medianActionSeconds
    }
  }
}
    ${TeamDayFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}`;
export const TeamCountFieldsFragmentDoc = gql`
    fragment TeamCountFields on TeamCountNode {
  total
  byDay {
    ...TeamDayFields
  }
  byMember {
    member {
      ...TeamMemberFields
    }
    count
  }
}
    ${TeamDayFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}`;
export const TeamMemberRatingFragmentDoc = gql`
    fragment TeamMemberRating on TeamMemberRatingNode {
  member {
    ...TeamMemberFields
  }
  meanRating
  ratedCount
}
    ${TeamMemberFieldsFragmentDoc}`;
export const TeamTopicFieldsFragmentDoc = gql`
    fragment TeamTopicFields on TeamMemberTopicNode {
  member {
    ...TeamMemberFields
  }
  tagId
  label
  count
}
    ${TeamMemberFieldsFragmentDoc}`;
export const TeamConversationFiguresFragmentDoc = gql`
    fragment TeamConversationFigures on TeamConversationReportingNode {
  responseTime {
    ...TeamDurationFields
  }
  firstResponse {
    ...TeamDurationFields
  }
  resolved {
    ...TeamCountFields
  }
  assigned {
    ...TeamCountFields
  }
  openConversations {
    atEnd {
      ...TeamDayFields
    }
    byDay {
      ...TeamDayFields
    }
    byMember {
      member {
        ...TeamMemberFields
      }
      count
    }
  }
  satisfaction {
    meanRating
    ratedCount
    byMember {
      ...TeamMemberRating
    }
  }
  topics {
    ...TeamTopicFields
  }
}
    ${TeamDurationFieldsFragmentDoc}
${TeamCountFieldsFragmentDoc}
${TeamDayFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}
${TeamMemberRatingFragmentDoc}
${TeamTopicFieldsFragmentDoc}`;
export const TeamDocumentFiguresFragmentDoc = gql`
    fragment TeamDocumentFigures on TeamDocumentReportingNode {
  uploaded {
    ...TeamCountFields
  }
  reach {
    documentCount
    viewCount
    neverViewedCount
    viewsPerDocument
    byMember {
      member {
        ...TeamMemberFields
      }
      documentCount
      viewCount
      neverViewedCount
    }
  }
}
    ${TeamCountFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}`;
export const TeamRosterMemberFieldsFragmentDoc = gql`
    fragment TeamRosterMemberFields on TeamRosterMemberNode {
  userId
  name
  communityIds
}
    `;
export const TeamUpdateFiguresFragmentDoc = gql`
    fragment TeamUpdateFigures on TeamUpdateReportingNode {
  published {
    ...TeamCountFields
  }
  reach {
    updateCount
    readerCount
    likeCount
    audienceSize
    readersPerUpdate
    likesPerUpdate
    readRate
    byMember {
      member {
        ...TeamMemberFields
      }
      updateCount
      readerCount
      likeCount
      readersPerUpdate
      likesPerUpdate
      readRate
    }
  }
}
    ${TeamCountFieldsFragmentDoc}
${TeamMemberFieldsFragmentDoc}`;
export const RuleConditionFragmentDoc = gql`
    fragment RuleCondition on RuleConditionNode {
  id
  event
  operator
  objectId
  createdAt
  updatedAt
}
    `;
export const RuleActionFragmentDoc = gql`
    fragment RuleAction on RuleActionNode {
  id
  action
  objectId
  createdAt
  updatedAt
  target {
    ... on TeamNode {
      id
      name
      icon
    }
    ... on UserType {
      id
      firstName
      lastName
      displayPicture
    }
  }
}
    `;
export const RuleFragmentDoc = gql`
    fragment Rule on RuleNode {
  id
  name
  description
  activatedAt
  executionCount
  createdAt
  updatedAt
  categoryContentTypes
  createdBy {
    id
    firstName
    lastName
    email
  }
  communities {
    edges {
      node {
        id
        name
      }
    }
  }
  conditions {
    edges {
      node {
        ...RuleCondition
      }
    }
  }
  actions {
    edges {
      node {
        ...RuleAction
      }
    }
  }
}
    ${RuleConditionFragmentDoc}
${RuleActionFragmentDoc}`;
export const RuleCommunityFragmentDoc = gql`
    fragment RuleCommunity on CommunityNode {
  id
  name
  avatar
  residentCount
  homeCount
}
    `;
export const SafetyCenterDocumentItemFragmentDoc = gql`
    fragment SafetyCenterDocumentItem on SafetyCenterDocumentNode {
  id
  title
  description
  sibCategory
  block {
    id
    name
  }
  includeInSibPack
  showInSafetyCenter
  fileName
  effectiveFileUrl
  sourceDocument {
    id
    title
  }
  updatedAt
}
    `;
export const TaskSourceActionFragmentDoc = gql`
    fragment TaskSourceAction on ChecklistActionNode {
  id
  finding
  recommendation
  priority
  location
  legislationReference
  sourceQuote
  sourceExtraction {
    id
    title
  }
  item {
    id
    title
    description
    referenceCode
    checklist {
      id
      name
      kind
      task {
        id
      }
    }
  }
}
    `;
export const ChecklistItemResponseFragmentDoc = gql`
    fragment ChecklistItemResponse on TaskChecklistItemResponseNode {
  id
  order
  label
  isRequired
  inputType
  valueBoolean
  valueChoice
  valueText
  valueNumber
  valueDate
  valueTime
}
    `;
export const ChecklistFollowUpTaskFragmentDoc = gql`
    fragment ChecklistFollowUpTask on TaskNode {
  id
  status
  dueDate
  taskDefinition {
    id
    name
  }
  assignedUser {
    id
    name
    displayPicture
  }
}
    `;
export const ChecklistActionFragmentDoc = gql`
    fragment ChecklistAction on ChecklistActionNode {
  id
  origin
  isSuggested
  finding
  recommendation
  priority
  priorityRaw
  dueDate
  plannedDate
  location
  locations
  legislationReference
  sourceQuote
  confidence
  reviewStatus
  dismissalReason
  dismissalNote
  reviewedAt
  reviewedBy {
    id
    name
    displayPicture
  }
  status
  resolvedAt
  resolvedBy {
    id
    name
    displayPicture
  }
  followUpTaskCount
  followUpTasks {
    ...ChecklistFollowUpTask
  }
  item {
    id
    title
    description
    referenceCode
    notes
    isCompleted
  }
}
    ${ChecklistFollowUpTaskFragmentDoc}`;
export const ChecklistItemMediaFragmentDoc = gql`
    fragment ChecklistItemMedia on TaskChecklistItemMediaNode {
  id
  file
  createdAt
  uploadedBy {
    id
    name
  }
  response {
    id
  }
}
    `;
export const ChecklistItemCommentFragmentDoc = gql`
    fragment ChecklistItemComment on TaskChecklistItemCommentNode {
  id
  body
  createdAt
  author {
    id
    name
    displayPicture
  }
}
    `;
export const ChecklistItemFragmentDoc = gql`
    fragment ChecklistItem on TaskChecklistItemNode {
  id
  title
  description
  order
  stepType
  isRequired
  requiresPhoto
  referenceCode
  guidance
  isCompleted
  completedAt
  completedBy {
    id
    name
  }
  dueDate
  responseBoolean
  responseChoice
  responseText
  responseNumber
  responseDate
  responseTime
  responses {
    ...ChecklistItemResponse
  }
  notes
  action {
    ...ChecklistAction
  }
  assignedUser {
    id
    name
    displayPicture
  }
  media {
    ...ChecklistItemMedia
  }
  comments {
    ...ChecklistItemComment
  }
}
    ${ChecklistItemResponseFragmentDoc}
${ChecklistActionFragmentDoc}
${ChecklistItemMediaFragmentDoc}
${ChecklistItemCommentFragmentDoc}`;
export const ChecklistSectionFragmentDoc = gql`
    fragment ChecklistSection on TaskChecklistSectionNode {
  id
  title
  description
  order
  dueDate
  assignedUser {
    id
    name
    displayPicture
  }
  items {
    ...ChecklistItem
  }
}
    ${ChecklistItemFragmentDoc}`;
export const TaskChecklistFragmentDoc = gql`
    fragment TaskChecklist on TaskChecklistNode {
  id
  name
  showsComplianceCeremony
  isManuallyCompletable
  structureRevision
  requiresSignOff
  autoCompleteTask
  isSignedOff
  riskRating
  riskLikelihood
  riskConsequence
  assessmentDate
  nextAssessmentDate
  assessorName
  providerName
  signedOffAt
  approvedAt
  notes
  assessedBy {
    id
    name
    displayPicture
  }
  signedOffBy {
    id
    name
    displayPicture
  }
  approvedBy {
    id
    name
    displayPicture
  }
  sections {
    ...ChecklistSection
  }
  items {
    ...ChecklistItem
  }
}
    ${ChecklistSectionFragmentDoc}
${ChecklistItemFragmentDoc}`;
export const ActionPlanTaskFragmentDoc = gql`
    fragment ActionPlanTask on TaskNode {
  id
  status
  taskDefinition {
    id
    name
    communityTaskDefinitions {
      edges {
        node {
          id
          community {
            id
            name
          }
        }
      }
    }
  }
  sourceAction {
    ...TaskSourceAction
  }
  checklist {
    ...TaskChecklist
    actions {
      ...ChecklistAction
    }
  }
}
    ${TaskSourceActionFragmentDoc}
${TaskChecklistFragmentDoc}
${ChecklistActionFragmentDoc}`;
export const InspectionSourceRegionFragmentDoc = gql`
    fragment InspectionSourceRegion on SourceRegionNode {
  id
  kind
  selfRef
  crop
  bboxNormL
  bboxNormT
  bboxNormR
  bboxNormB
}
    `;
export const InspectionSourceRegionEntryFragmentDoc = gql`
    fragment InspectionSourceRegionEntry on ActionSourceRegionNode {
  role
  region {
    ...InspectionSourceRegion
  }
}
    ${InspectionSourceRegionFragmentDoc}`;
export const InspectionExtractionFragmentDoc = gql`
    fragment InspectionExtraction on DocumentExtractionNode {
  id
  title
  status
  statusMessage
  failedStage
  extractionConfidence
  extractedTaskId
  complianceType
  community {
    id
    name
  }
  createdAt
  updatedAt
}
    `;
export const InspectionExtractionProgressFragmentDoc = gql`
    fragment InspectionExtractionProgress on DocumentExtractionNode {
  ...InspectionExtraction
  parseStrategy
  validationVerdict
  progress {
    stage
    status
    detail
    at
  }
}
    ${InspectionExtractionFragmentDoc}`;
export const InspectionOverviewCountFragmentDoc = gql`
    fragment InspectionOverviewCount on InspectionOverviewCountNode {
  key
  label
  count
}
    `;
export const InspectionOverviewExtractionFragmentDoc = gql`
    fragment InspectionOverviewExtraction on DocumentExtractionNode {
  id
  title
  file
  fileName
  createdAt
  overviewNarrative
  extractedTemplate {
    id
    name
  }
  sourceDocument {
    id
    pageCount
    firstPage {
      id
      pageNo
      image
      width
      height
    }
  }
  overviewStats {
    reportItemsTotal
    reportItemsPassed
    reportItemsNeedingAction
    actionsTotal
    actionsOutstanding
    actionsWithTasks
    actionsInProgress
    actionsComplete
    actionsDismissed
    actionsOverdue
    byPriority {
      ...InspectionOverviewCount
    }
    byArea {
      ...InspectionOverviewCount
    }
    byReviewer {
      ...InspectionOverviewCount
    }
    byResolver {
      ...InspectionOverviewCount
    }
  }
}
    ${InspectionOverviewCountFragmentDoc}`;
export const WorkspaceUpdateFragmentDoc = gql`
    fragment WorkspaceUpdate on TaskUpdateNode {
  id
  updateType
  comment
  createdAt
  newStatus
  source
  actor {
    id
    name
    displayPicture
  }
  target {
    id
    name
  }
  targetAction {
    id
    item {
      id
      title
    }
  }
}
    `;
export const ManagerDeclarationResidencyFragmentDoc = gql`
    fragment ManagerDeclarationResidency on ResidencyNode {
  id
  home {
    id
    name
    address
    community {
      id
      name
    }
  }
  residents {
    id
    user {
      id
      name
    }
  }
  residentSafetyRecords {
    edges {
      node {
        id
        first
        last
        isAppLinked
        archivedAt
        user {
          id
        }
      }
    }
  }
}
    `;
export const SafetyReviewRequestStateFragmentDoc = gql`
    fragment SafetyReviewRequestState on SafetyReviewRequestNode {
  id
  requestType
  createdAt
  openedAt
  completedAt
  cancelledAt
  isOpen
  attemptCount
  latestAttemptAt
  escalationDueAt
  isEscalationDue
}
    `;
export const SafetyListItemFragmentDoc = gql`
    fragment SafetyListItem on ResidentSafetyRecordNode {
  id
  isOccupant
  first
  last
  mobilityNeedDeclared
  communicationNeedDeclared
  mobilityNeeds
  communicationNeeds
  language
  largePrint
  braille
  textToSpeech
  consentGivenAt
  pcfraOfferedAt
  pcfraDeclinedAt
  pcfraCompletedAt
  eesGeneratedAt
  eesAgreedAt
  lastReviewedAt
  createdAt
  archivedAt
  lifecycleStatus
  isAppLinked
  residency {
    id
    home {
      id
      name
      floorNumber
      block {
        id
        name
        totalFloors
      }
      community {
        id
        name
      }
    }
  }
}
    `;
export const SafetyRosterRowFragmentDoc = gql`
    fragment SafetyRosterRow on SafetyRosterRowType {
  id
  state
  lifecycleStatus
  needsAction
  needsReconciliation
  isOverdue
  isAppLinked
  occupantKnown
  complianceActions
  first
  last
  homeId
  homeName
  communityName
  blockName
  floorNumber
  residencyId
  lastDeclaredAt
  latestDeclaration {
    ...LatestDeclaration
  }
  openReviewRequest {
    ...SafetyReviewRequestState
  }
  record {
    ...SafetyListItem
  }
}
    ${LatestDeclarationFragmentDoc}
${SafetyReviewRequestStateFragmentDoc}
${SafetyListItemFragmentDoc}`;
export const SafetyBlockReadinessFragmentDoc = gql`
    fragment SafetyBlockReadiness on SafetyBlockReadinessType {
  blockId
  blockName
  homes
  homesWithoutFloor
  response {
    numerator
    denominator
  }
  currency {
    numerator
    denominator
  }
  consent {
    numerator
    denominator
  }
  assessment {
    numerator
    denominator
  }
  packGenerated
  packCurrent
  responsiblePersonNamed
  floorsKnown
  unassignedResidents
  cohorts {
    declaredNeeds
    noNeeds
    notAnswered
    notOccupant
  }
}
    `;
export const DeclarationHistoryEntryFragmentDoc = gql`
    fragment DeclarationHistoryEntry on ResidentSafetyDeclarationNode {
  id
  origin
  declaredAt
  createdAt
  declarantName
  isVoided
  isAuthoritative
  hasEvidence
  evidenceFileUrl
  voidReason
  voidedByName
  isOccupant
  mobilityNeedDeclared
  mobilityDetails
  communicationNeedDeclared
  communicationDetails
  language
  largePrint
  braille
  textToSpeech
}
    `;
export const SafetyRecordHomeFragmentDoc = gql`
    fragment SafetyRecordHome on HomeNode {
  id
  name
  floorNumber
  community {
    id
    name
    settings {
      surveyReviewIntervalMonths
      safetyComplianceV2ActivatedAt
    }
  }
  block {
    id
    name
    totalFloors
  }
}
    `;
export const SafetyCenterRecordFieldsFragmentDoc = gql`
    fragment SafetyCenterRecordFields on ResidentSafetyRecordNode {
  id
  isOccupant
  first
  last
  mobilityNeedDeclared
  communicationNeedDeclared
  mobilityNeeds
  communicationNeeds
  language
  largePrint
  braille
  textToSpeech
  needsReconciliation
  consentGivenAt
  consentDeclinedAt
  fireServiceConsentGivenAt
  fireServiceConsentWithdrawnAt
  sharesWithFireService
  pcfraParticipation
  pcfraAcceptedAt
  pcfraOfferedAt
  pcfraDeclinedAt
  pcfraCompletedAt
  pcfraAssessmentDate
  pcfraFileUrl
  eesGeneratedAt
  eesAgreedAt
  eesFileUrl
  lastReviewedAt
  createdAt
  archivedAt
  lifecycleStatus
  isAppLinked
  contactEmail
  latestDeclaration {
    id
    origin
    declaredAt
    hasEvidence
    evidenceFileUrl
    submittedBy {
      id
      name
    }
  }
  linkSuggestions {
    userId
    email
    name
  }
  user {
    id
    firstName
    lastName
    dateJoined
  }
  residency {
    id
    home {
      ...SafetyRecordHome
    }
  }
}
    ${SafetyRecordHomeFragmentDoc}`;
export const SafetyReviewAttemptEntryFragmentDoc = gql`
    fragment SafetyReviewAttemptEntry on SafetyReviewAttemptNode {
  id
  channel
  createdAt
  queuedAt
  initiatedByName
  note
}
    `;
export const SafetyReviewRequestDetailFragmentDoc = gql`
    fragment SafetyReviewRequestDetail on SafetyReviewRequestNode {
  ...SafetyReviewRequestState
  recipient {
    id
    name
  }
  createdBy {
    id
    name
  }
  attempts {
    ...SafetyReviewAttemptEntry
  }
}
    ${SafetyReviewRequestStateFragmentDoc}
${SafetyReviewAttemptEntryFragmentDoc}`;
export const SurveyItemFragmentDoc = gql`
    fragment SurveyItem on ResidentSurveyNode {
  id
  createdAt
  question
  status
  link
  options {
    id
    option
    totalResidents
  }
  groups {
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;
export const AsanaPendingTaskCardFragmentDoc = gql`
    fragment AsanaPendingTaskCard on AsanaPendingTaskNode {
  id
  asanaId
  asanaUrl
  name
  notes
  asanaCreatedByGid
  asanaCreatedAt
  createdAt
  asanaCreatedByUser {
    id
    name
  }
  community {
    id
    name
  }
}
    `;
export const TaskCommunityFragmentDoc = gql`
    fragment TaskCommunity on TaskNode {
  taskDefinition {
    communityTaskDefinitions(first: 1) {
      edges {
        node {
          community {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const TaskGroupItemFragmentDoc = gql`
    fragment TaskGroupItem on TaskGroupNode {
  id
  name
  schedule
  isActive
  createdAt
  tasks {
    totalCount
  }
  communityTasks: tasks(first: 1) {
    edges {
      node {
        ...TaskCommunity
      }
    }
  }
}
    ${TaskCommunityFragmentDoc}`;
export const VisibleGroupFragmentDoc = gql`
    fragment VisibleGroup on CommunityGroupNode {
  id
  name
}
    `;
export const TaskVisibilityFragmentDoc = gql`
    fragment TaskVisibility on TaskDefinitionNode {
  id
  isVisibleToResidents
  visibleToGroups {
    edges {
      node {
        ...VisibleGroup
      }
    }
  }
}
    ${VisibleGroupFragmentDoc}`;
export const TaskDocumentFragmentDoc = gql`
    fragment TaskDocument on TaskDocumentNode {
  id
  title
  url
  uploadedBy {
    id
    name
  }
  communityDocument {
    id
    title
  }
  taskGroup {
    id
  }
  createdAt
}
    `;
export const TaskUpdateFragmentDoc = gql`
    fragment TaskUpdate on TaskUpdateNode {
  id
  updateType
  comment
  source
  newStatus
  createdAt
  actor {
    id
    name
    displayPicture
  }
  target {
    id
    name
  }
  targetContractorCompany {
    id
    name
  }
  targetConversation {
    id
    subject
  }
  targetDocument {
    id
    title
  }
  targetAction {
    id
    item {
      id
      title
    }
  }
}
    `;
export const TaskDetailFragmentDoc = gql`
    fragment TaskDetail on TaskNode {
  ...TaskCommunity
  id
  status
  priority
  dueDate
  completedAt
  scheduledFor
  createdAt
  updatedAt
  fixfloId
  fixfloUrl
  asanaId
  asanaUrl
  taskDefinition {
    ...TaskVisibility
    name
    description
    priority
    tagAssignments {
      edges {
        node {
          id
          tag {
            id
            name
            color
          }
        }
      }
    }
    availableClientTags {
      edges {
        node {
          id
          name
          color
        }
      }
    }
    communityTaskDefinitions(first: 1) {
      edges {
        node {
          community {
            id
            settings {
              fixfloUrl
              residentVisibleTasks
            }
            hasAsanaIntegration
          }
        }
      }
    }
  }
  assignedUser {
    id
    name
    email
    displayPicture
  }
  assignedTeam {
    id
    name
  }
  contractorCompany {
    id
    name
    contractors {
      edges {
        node {
          id
          name
          email
          jobTitle
        }
      }
    }
  }
  contractorUsers {
    edges {
      node {
        id
        name
        email
        jobTitle
      }
    }
  }
  documents {
    edges {
      node {
        ...TaskDocument
      }
    }
  }
  updates {
    edges {
      node {
        ...TaskUpdate
      }
    }
  }
  taskGroups(first: 1) {
    totalCount
    edges {
      node {
        id
      }
    }
  }
  linkedConversations {
    id
    subject
    createdAt
    user {
      id
      name
    }
    home {
      id
      name
    }
  }
  checklist {
    ...TaskChecklist
  }
  sourceAction {
    ...TaskSourceAction
  }
}
    ${TaskCommunityFragmentDoc}
${TaskVisibilityFragmentDoc}
${TaskDocumentFragmentDoc}
${TaskUpdateFragmentDoc}
${TaskChecklistFragmentDoc}
${TaskSourceActionFragmentDoc}`;
export const TaskItemFragmentDoc = gql`
    fragment TaskItem on TaskNode {
  ...TaskCommunity
  id
  status
  priority
  dueDate
  completedAt
  fixfloUrl
  asanaUrl
  taskDefinition {
    ...TaskVisibility
    name
    priority
    tagAssignments {
      edges {
        node {
          id
          tag {
            id
            name
            color
          }
        }
      }
    }
    availableClientTags {
      edges {
        node {
          id
          name
          color
        }
      }
    }
  }
  assignedUser {
    id
    name
  }
  contractorCompany {
    id
    name
  }
  taskGroups {
    totalCount
    edges {
      node {
        id
      }
    }
  }
}
    ${TaskCommunityFragmentDoc}
${TaskVisibilityFragmentDoc}`;
export const TaskTemplateListItemFragmentDoc = gql`
    fragment TaskTemplateListItem on TaskTemplateNode {
  id
  name
  description
  isSystem
  isActive
  isDraft
  requiresSignOff
  autoCompleteTask
  pdfExportEnabled
  stepCount
  communityIds
  scope
  complianceType
  draftSourceTitle
  createdAt
  updatedAt
  createdBy {
    id
    name
  }
}
    `;
export const TaskTemplateSectionFragmentDoc = gql`
    fragment TaskTemplateSection on TaskTemplateSectionNode {
  id
  title
  description
  order
}
    `;
export const TaskTemplateStepFieldInputFragmentDoc = gql`
    fragment TaskTemplateStepFieldInput on TaskTemplateStepInputNode {
  id
  order
  inputType
  label
  isRequired
}
    `;
export const TaskTemplateStepFragmentDoc = gql`
    fragment TaskTemplateStep on TaskTemplateStepNode {
  id
  title
  description
  order
  stepType
  isRequired
  requiresPhoto
  referenceCode
  notes
  sectionId
  inputs {
    ...TaskTemplateStepFieldInput
  }
}
    ${TaskTemplateStepFieldInputFragmentDoc}`;
export const TaskTemplateDetailFragmentDoc = gql`
    fragment TaskTemplateDetail on TaskTemplateNode {
  ...TaskTemplateListItem
  structureRevision
  sections {
    ...TaskTemplateSection
  }
  steps {
    ...TaskTemplateStep
  }
}
    ${TaskTemplateListItemFragmentDoc}
${TaskTemplateSectionFragmentDoc}
${TaskTemplateStepFragmentDoc}`;
export const CommunityUpdateAttachmentFragmentDoc = gql`
    fragment CommunityUpdateAttachment on CommunityUpdateAttachmentNode {
  id
  file
  fileName
}
    `;
export const CommmunityUpdateGroupItemFragmentDoc = gql`
    fragment CommmunityUpdateGroupItem on CommunityGroupNode {
  id
  name
  community {
    name
  }
}
    `;
export const VisitorItemFragmentDoc = gql`
    fragment VisitorItem on CommunityVisitorNode {
  id
  name
  createdAt
  residentName
  signedOutAt
  reasonForVisit
  type
  community {
    id
    name
  }
  home {
    id
    name
    block {
      id
      name
    }
  }
}
    `;
export const RemoveResidentsFromResidencyDocument = gql`
    mutation RemoveResidentsFromResidency($input: RemoveResidentsFromResidencyInput!) {
  removeResidentsFromResidency(input: $input) {
    residency {
      id
      residents {
        id
        name
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type RemoveResidentsFromResidencyMutationFn = Apollo.MutationFunction<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>;

/**
 * __useRemoveResidentsFromResidencyMutation__
 *
 * To run a mutation, you first call `useRemoveResidentsFromResidencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveResidentsFromResidencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeResidentsFromResidencyMutation, { data, loading, error }] = useRemoveResidentsFromResidencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveResidentsFromResidencyMutation(baseOptions?: Apollo.MutationHookOptions<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>(RemoveResidentsFromResidencyDocument, options);
      }
export type RemoveResidentsFromResidencyMutationHookResult = ReturnType<typeof useRemoveResidentsFromResidencyMutation>;
export type RemoveResidentsFromResidencyMutationResult = Apollo.MutationResult<RemoveResidentsFromResidencyMutation>;
export type RemoveResidentsFromResidencyMutationOptions = Apollo.BaseMutationOptions<RemoveResidentsFromResidencyMutation, RemoveResidentsFromResidencyMutationVariables>;
export const HasAsanaIntegrationDocument = gql`
    query HasAsanaIntegration($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    community {
      id
      hasAsanaIntegration
    }
    home {
      id
      community {
        id
        hasAsanaIntegration
      }
    }
  }
}
    `;

/**
 * __useHasAsanaIntegrationQuery__
 *
 * To run a query within a React component, call `useHasAsanaIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasAsanaIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasAsanaIntegrationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useHasAsanaIntegrationQuery(baseOptions: Apollo.QueryHookOptions<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>(HasAsanaIntegrationDocument, options);
      }
export function useHasAsanaIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>(HasAsanaIntegrationDocument, options);
        }
export type HasAsanaIntegrationQueryHookResult = ReturnType<typeof useHasAsanaIntegrationQuery>;
export type HasAsanaIntegrationLazyQueryHookResult = ReturnType<typeof useHasAsanaIntegrationLazyQuery>;
export type HasAsanaIntegrationQueryResult = Apollo.QueryResult<HasAsanaIntegrationQuery, HasAsanaIntegrationQueryVariables>;
export const SendConversationToAsanaDocument = gql`
    mutation SendConversationToAsana($input: SendConversationToAsanaInput!) {
  sendConversationToAsana(input: $input) {
    asanaSendPending
    taskDefinition {
      id
      name
    }
    task {
      ...TaskItem
    }
  }
}
    ${TaskItemFragmentDoc}`;
export type SendConversationToAsanaMutationFn = Apollo.MutationFunction<SendConversationToAsanaMutation, SendConversationToAsanaMutationVariables>;

/**
 * __useSendConversationToAsanaMutation__
 *
 * To run a mutation, you first call `useSendConversationToAsanaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConversationToAsanaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConversationToAsanaMutation, { data, loading, error }] = useSendConversationToAsanaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendConversationToAsanaMutation(baseOptions?: Apollo.MutationHookOptions<SendConversationToAsanaMutation, SendConversationToAsanaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConversationToAsanaMutation, SendConversationToAsanaMutationVariables>(SendConversationToAsanaDocument, options);
      }
export type SendConversationToAsanaMutationHookResult = ReturnType<typeof useSendConversationToAsanaMutation>;
export type SendConversationToAsanaMutationResult = Apollo.MutationResult<SendConversationToAsanaMutation>;
export type SendConversationToAsanaMutationOptions = Apollo.BaseMutationOptions<SendConversationToAsanaMutation, SendConversationToAsanaMutationVariables>;
export const CommunityTeamMembersDocument = gql`
    query CommunityTeamMembers($communityId: UUID!) {
  community(id: $communityId) {
    ...CommunityTeamMembers
  }
}
    ${CommunityTeamMembersFragmentDoc}`;

/**
 * __useCommunityTeamMembersQuery__
 *
 * To run a query within a React component, call `useCommunityTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamMembersQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useCommunityTeamMembersQuery(baseOptions: Apollo.QueryHookOptions<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>(CommunityTeamMembersDocument, options);
      }
export function useCommunityTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>(CommunityTeamMembersDocument, options);
        }
export type CommunityTeamMembersQueryHookResult = ReturnType<typeof useCommunityTeamMembersQuery>;
export type CommunityTeamMembersLazyQueryHookResult = ReturnType<typeof useCommunityTeamMembersLazyQuery>;
export type CommunityTeamMembersQueryResult = Apollo.QueryResult<CommunityTeamMembersQuery, CommunityTeamMembersQueryVariables>;
export const ConversationAssignmentDataDocument = gql`
    query ConversationAssignmentData($conversationId: UUID!) {
  conversation(id: $conversationId) {
    ...ConversationAssignmentData
  }
}
    ${ConversationAssignmentDataFragmentDoc}`;

/**
 * __useConversationAssignmentDataQuery__
 *
 * To run a query within a React component, call `useConversationAssignmentDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationAssignmentDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationAssignmentDataQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationAssignmentDataQuery(baseOptions: Apollo.QueryHookOptions<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>(ConversationAssignmentDataDocument, options);
      }
export function useConversationAssignmentDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>(ConversationAssignmentDataDocument, options);
        }
export type ConversationAssignmentDataQueryHookResult = ReturnType<typeof useConversationAssignmentDataQuery>;
export type ConversationAssignmentDataLazyQueryHookResult = ReturnType<typeof useConversationAssignmentDataLazyQuery>;
export type ConversationAssignmentDataQueryResult = Apollo.QueryResult<ConversationAssignmentDataQuery, ConversationAssignmentDataQueryVariables>;
export const CreateConversationAssignmentDocument = gql`
    mutation CreateConversationAssignment($input: CreateConversationAssignmentInput!) {
  createConversationAssignment(input: $input) {
    conversationAssignment {
      id
      conversation {
        ...ConversationAssignmentData
      }
    }
  }
}
    ${ConversationAssignmentDataFragmentDoc}`;
export type CreateConversationAssignmentMutationFn = Apollo.MutationFunction<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>;

/**
 * __useCreateConversationAssignmentMutation__
 *
 * To run a mutation, you first call `useCreateConversationAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationAssignmentMutation, { data, loading, error }] = useCreateConversationAssignmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationAssignmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>(CreateConversationAssignmentDocument, options);
      }
export type CreateConversationAssignmentMutationHookResult = ReturnType<typeof useCreateConversationAssignmentMutation>;
export type CreateConversationAssignmentMutationResult = Apollo.MutationResult<CreateConversationAssignmentMutation>;
export type CreateConversationAssignmentMutationOptions = Apollo.BaseMutationOptions<CreateConversationAssignmentMutation, CreateConversationAssignmentMutationVariables>;
export const HasDwellantIntegrationDocument = gql`
    query HasDwellantIntegration($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        hasDwellantIntegration
      }
    }
  }
}
    `;

/**
 * __useHasDwellantIntegrationQuery__
 *
 * To run a query within a React component, call `useHasDwellantIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasDwellantIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasDwellantIntegrationQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useHasDwellantIntegrationQuery(baseOptions: Apollo.QueryHookOptions<HasDwellantIntegrationQuery, HasDwellantIntegrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HasDwellantIntegrationQuery, HasDwellantIntegrationQueryVariables>(HasDwellantIntegrationDocument, options);
      }
export function useHasDwellantIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HasDwellantIntegrationQuery, HasDwellantIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HasDwellantIntegrationQuery, HasDwellantIntegrationQueryVariables>(HasDwellantIntegrationDocument, options);
        }
export type HasDwellantIntegrationQueryHookResult = ReturnType<typeof useHasDwellantIntegrationQuery>;
export type HasDwellantIntegrationLazyQueryHookResult = ReturnType<typeof useHasDwellantIntegrationLazyQuery>;
export type HasDwellantIntegrationQueryResult = Apollo.QueryResult<HasDwellantIntegrationQuery, HasDwellantIntegrationQueryVariables>;
export const SendToDwellantInfoDocument = gql`
    query SendToDwellantInfo($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      community {
        id
        dwellantTaskCategories
      }
    }
    summary {
      id
      summary
    }
  }
}
    `;

/**
 * __useSendToDwellantInfoQuery__
 *
 * To run a query within a React component, call `useSendToDwellantInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSendToDwellantInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSendToDwellantInfoQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useSendToDwellantInfoQuery(baseOptions: Apollo.QueryHookOptions<SendToDwellantInfoQuery, SendToDwellantInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SendToDwellantInfoQuery, SendToDwellantInfoQueryVariables>(SendToDwellantInfoDocument, options);
      }
export function useSendToDwellantInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SendToDwellantInfoQuery, SendToDwellantInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SendToDwellantInfoQuery, SendToDwellantInfoQueryVariables>(SendToDwellantInfoDocument, options);
        }
export type SendToDwellantInfoQueryHookResult = ReturnType<typeof useSendToDwellantInfoQuery>;
export type SendToDwellantInfoLazyQueryHookResult = ReturnType<typeof useSendToDwellantInfoLazyQuery>;
export type SendToDwellantInfoQueryResult = Apollo.QueryResult<SendToDwellantInfoQuery, SendToDwellantInfoQueryVariables>;
export const ConversationForwardingEmailsDocument = gql`
    query ConversationForwardingEmails($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        settings {
          conversationForwardingEmails {
            id
            name
            emails
          }
        }
      }
    }
  }
}
    `;

/**
 * __useConversationForwardingEmailsQuery__
 *
 * To run a query within a React component, call `useConversationForwardingEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationForwardingEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationForwardingEmailsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationForwardingEmailsQuery(baseOptions: Apollo.QueryHookOptions<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>(ConversationForwardingEmailsDocument, options);
      }
export function useConversationForwardingEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>(ConversationForwardingEmailsDocument, options);
        }
export type ConversationForwardingEmailsQueryHookResult = ReturnType<typeof useConversationForwardingEmailsQuery>;
export type ConversationForwardingEmailsLazyQueryHookResult = ReturnType<typeof useConversationForwardingEmailsLazyQuery>;
export type ConversationForwardingEmailsQueryResult = Apollo.QueryResult<ConversationForwardingEmailsQuery, ConversationForwardingEmailsQueryVariables>;
export const AssignClientTagDocument = gql`
    mutation AssignClientTag($input: AssignClientTagInput!) {
  assignClientTag(input: $input) {
    tagAssignment {
      id
      tag {
        id
      }
    }
  }
}
    `;
export type AssignClientTagMutationFn = Apollo.MutationFunction<AssignClientTagMutation, AssignClientTagMutationVariables>;

/**
 * __useAssignClientTagMutation__
 *
 * To run a mutation, you first call `useAssignClientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientTagMutation, { data, loading, error }] = useAssignClientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignClientTagMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientTagMutation, AssignClientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientTagMutation, AssignClientTagMutationVariables>(AssignClientTagDocument, options);
      }
export type AssignClientTagMutationHookResult = ReturnType<typeof useAssignClientTagMutation>;
export type AssignClientTagMutationResult = Apollo.MutationResult<AssignClientTagMutation>;
export type AssignClientTagMutationOptions = Apollo.BaseMutationOptions<AssignClientTagMutation, AssignClientTagMutationVariables>;
export const AvailableClientTagsDocument = gql`
    query AvailableClientTags {
  clientTags(status: ["ACTIVATED"]) {
    edges {
      node {
        ...AvailableClientTag
      }
    }
  }
}
    ${AvailableClientTagFragmentDoc}`;

/**
 * __useAvailableClientTagsQuery__
 *
 * To run a query within a React component, call `useAvailableClientTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableClientTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableClientTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableClientTagsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableClientTagsQuery, AvailableClientTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableClientTagsQuery, AvailableClientTagsQueryVariables>(AvailableClientTagsDocument, options);
      }
export function useAvailableClientTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableClientTagsQuery, AvailableClientTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableClientTagsQuery, AvailableClientTagsQueryVariables>(AvailableClientTagsDocument, options);
        }
export type AvailableClientTagsQueryHookResult = ReturnType<typeof useAvailableClientTagsQuery>;
export type AvailableClientTagsLazyQueryHookResult = ReturnType<typeof useAvailableClientTagsLazyQuery>;
export type AvailableClientTagsQueryResult = Apollo.QueryResult<AvailableClientTagsQuery, AvailableClientTagsQueryVariables>;
export const ConversationTagAssignmentsDocument = gql`
    query ConversationTagAssignments($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    tagAssignments {
      edges {
        node {
          ...ConversationTagAssignmentFragment
        }
      }
    }
    availableClientTags {
      edges {
        node {
          id
          name
          color
          archivedAt
        }
      }
    }
  }
}
    ${ConversationTagAssignmentFragmentFragmentDoc}`;

/**
 * __useConversationTagAssignmentsQuery__
 *
 * To run a query within a React component, call `useConversationTagAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationTagAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationTagAssignmentsQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationTagAssignmentsQuery(baseOptions: Apollo.QueryHookOptions<ConversationTagAssignmentsQuery, ConversationTagAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationTagAssignmentsQuery, ConversationTagAssignmentsQueryVariables>(ConversationTagAssignmentsDocument, options);
      }
export function useConversationTagAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationTagAssignmentsQuery, ConversationTagAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationTagAssignmentsQuery, ConversationTagAssignmentsQueryVariables>(ConversationTagAssignmentsDocument, options);
        }
export type ConversationTagAssignmentsQueryHookResult = ReturnType<typeof useConversationTagAssignmentsQuery>;
export type ConversationTagAssignmentsLazyQueryHookResult = ReturnType<typeof useConversationTagAssignmentsLazyQuery>;
export type ConversationTagAssignmentsQueryResult = Apollo.QueryResult<ConversationTagAssignmentsQuery, ConversationTagAssignmentsQueryVariables>;
export const UnassignClientTagDocument = gql`
    mutation UnassignClientTag($input: UnassignClientTagInput!) {
  unassignClientTag(input: $input) {
    tagAssignment {
      id
      tag {
        id
      }
    }
  }
}
    `;
export type UnassignClientTagMutationFn = Apollo.MutationFunction<UnassignClientTagMutation, UnassignClientTagMutationVariables>;

/**
 * __useUnassignClientTagMutation__
 *
 * To run a mutation, you first call `useUnassignClientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignClientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignClientTagMutation, { data, loading, error }] = useUnassignClientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignClientTagMutation(baseOptions?: Apollo.MutationHookOptions<UnassignClientTagMutation, UnassignClientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignClientTagMutation, UnassignClientTagMutationVariables>(UnassignClientTagDocument, options);
      }
export type UnassignClientTagMutationHookResult = ReturnType<typeof useUnassignClientTagMutation>;
export type UnassignClientTagMutationResult = Apollo.MutationResult<UnassignClientTagMutation>;
export type UnassignClientTagMutationOptions = Apollo.BaseMutationOptions<UnassignClientTagMutation, UnassignClientTagMutationVariables>;
export const AvailableConversationLabelsDocument = gql`
    query AvailableConversationLabels($communityId: UUID!) {
  community(id: $communityId) {
    id
    client {
      id
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;

/**
 * __useAvailableConversationLabelsQuery__
 *
 * To run a query within a React component, call `useAvailableConversationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableConversationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableConversationLabelsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useAvailableConversationLabelsQuery(baseOptions: Apollo.QueryHookOptions<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>(AvailableConversationLabelsDocument, options);
      }
export function useAvailableConversationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>(AvailableConversationLabelsDocument, options);
        }
export type AvailableConversationLabelsQueryHookResult = ReturnType<typeof useAvailableConversationLabelsQuery>;
export type AvailableConversationLabelsLazyQueryHookResult = ReturnType<typeof useAvailableConversationLabelsLazyQuery>;
export type AvailableConversationLabelsQueryResult = Apollo.QueryResult<AvailableConversationLabelsQuery, AvailableConversationLabelsQueryVariables>;
export const ActiveConversationLabelsDocument = gql`
    query ActiveConversationLabels($id: UUID!) {
  conversation(id: $id) {
    tags {
      totalCount
      edges {
        node {
          ...ConversationLabel
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;

/**
 * __useActiveConversationLabelsQuery__
 *
 * To run a query within a React component, call `useActiveConversationLabelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveConversationLabelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveConversationLabelsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActiveConversationLabelsQuery(baseOptions: Apollo.QueryHookOptions<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>(ActiveConversationLabelsDocument, options);
      }
export function useActiveConversationLabelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>(ActiveConversationLabelsDocument, options);
        }
export type ActiveConversationLabelsQueryHookResult = ReturnType<typeof useActiveConversationLabelsQuery>;
export type ActiveConversationLabelsLazyQueryHookResult = ReturnType<typeof useActiveConversationLabelsLazyQuery>;
export type ActiveConversationLabelsQueryResult = Apollo.QueryResult<ActiveConversationLabelsQuery, ActiveConversationLabelsQueryVariables>;
export const LabelConversationDocument = gql`
    mutation LabelConversation($input: LabelConversationInput!) {
  labelConversation(input: $input) {
    conversation {
      id
      availableTags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;
export type LabelConversationMutationFn = Apollo.MutationFunction<LabelConversationMutation, LabelConversationMutationVariables>;

/**
 * __useLabelConversationMutation__
 *
 * To run a mutation, you first call `useLabelConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLabelConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [labelConversationMutation, { data, loading, error }] = useLabelConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLabelConversationMutation(baseOptions?: Apollo.MutationHookOptions<LabelConversationMutation, LabelConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LabelConversationMutation, LabelConversationMutationVariables>(LabelConversationDocument, options);
      }
export type LabelConversationMutationHookResult = ReturnType<typeof useLabelConversationMutation>;
export type LabelConversationMutationResult = Apollo.MutationResult<LabelConversationMutation>;
export type LabelConversationMutationOptions = Apollo.BaseMutationOptions<LabelConversationMutation, LabelConversationMutationVariables>;
export const UnlabelConversationDocument = gql`
    mutation UnlabelConversation($input: UnlabelConversationInput!) {
  unlabelConversation(input: $input) {
    conversation {
      id
      availableTags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
      tags {
        edges {
          node {
            ...ConversationLabel
          }
        }
      }
    }
  }
}
    ${ConversationLabelFragmentDoc}`;
export type UnlabelConversationMutationFn = Apollo.MutationFunction<UnlabelConversationMutation, UnlabelConversationMutationVariables>;

/**
 * __useUnlabelConversationMutation__
 *
 * To run a mutation, you first call `useUnlabelConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlabelConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlabelConversationMutation, { data, loading, error }] = useUnlabelConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlabelConversationMutation(baseOptions?: Apollo.MutationHookOptions<UnlabelConversationMutation, UnlabelConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlabelConversationMutation, UnlabelConversationMutationVariables>(UnlabelConversationDocument, options);
      }
export type UnlabelConversationMutationHookResult = ReturnType<typeof useUnlabelConversationMutation>;
export type UnlabelConversationMutationResult = Apollo.MutationResult<UnlabelConversationMutation>;
export type UnlabelConversationMutationOptions = Apollo.BaseMutationOptions<UnlabelConversationMutation, UnlabelConversationMutationVariables>;
export const UpdateConversationTitleDocument = gql`
    mutation UpdateConversationTitle($input: UpdateConversationTitleInput!) {
  updateConversationTitle(input: $input) {
    conversation {
      id
      subject
    }
  }
}
    `;
export type UpdateConversationTitleMutationFn = Apollo.MutationFunction<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;

/**
 * __useUpdateConversationTitleMutation__
 *
 * To run a mutation, you first call `useUpdateConversationTitleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationTitleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationTitleMutation, { data, loading, error }] = useUpdateConversationTitleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationTitleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>(UpdateConversationTitleDocument, options);
      }
export type UpdateConversationTitleMutationHookResult = ReturnType<typeof useUpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationResult = Apollo.MutationResult<UpdateConversationTitleMutation>;
export type UpdateConversationTitleMutationOptions = Apollo.BaseMutationOptions<UpdateConversationTitleMutation, UpdateConversationTitleMutationVariables>;
export const ConversationSummaryDocument = gql`
    query ConversationSummary($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    summary {
      id
      summary
    }
  }
}
    `;

/**
 * __useConversationSummaryQuery__
 *
 * To run a query within a React component, call `useConversationSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationSummaryQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useConversationSummaryQuery(baseOptions: Apollo.QueryHookOptions<ConversationSummaryQuery, ConversationSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationSummaryQuery, ConversationSummaryQueryVariables>(ConversationSummaryDocument, options);
      }
export function useConversationSummaryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationSummaryQuery, ConversationSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationSummaryQuery, ConversationSummaryQueryVariables>(ConversationSummaryDocument, options);
        }
export type ConversationSummaryQueryHookResult = ReturnType<typeof useConversationSummaryQuery>;
export type ConversationSummaryLazyQueryHookResult = ReturnType<typeof useConversationSummaryLazyQuery>;
export type ConversationSummaryQueryResult = Apollo.QueryResult<ConversationSummaryQuery, ConversationSummaryQueryVariables>;
export const CreateConversationSummaryDocument = gql`
    mutation CreateConversationSummary($input: CreateConversationSummaryInput!) {
  createConversationSummary(input: $input) {
    conversationSummary {
      id
      conversation {
        id
        summary {
          id
          summary
        }
      }
    }
  }
}
    `;
export type CreateConversationSummaryMutationFn = Apollo.MutationFunction<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>;

/**
 * __useCreateConversationSummaryMutation__
 *
 * To run a mutation, you first call `useCreateConversationSummaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationSummaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationSummaryMutation, { data, loading, error }] = useCreateConversationSummaryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationSummaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>(CreateConversationSummaryDocument, options);
      }
export type CreateConversationSummaryMutationHookResult = ReturnType<typeof useCreateConversationSummaryMutation>;
export type CreateConversationSummaryMutationResult = Apollo.MutationResult<CreateConversationSummaryMutation>;
export type CreateConversationSummaryMutationOptions = Apollo.BaseMutationOptions<CreateConversationSummaryMutation, CreateConversationSummaryMutationVariables>;
export const GetFixFloDocument = gql`
    query GetFixFlo($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        settings {
          fixfloUrl
        }
      }
    }
  }
}
    `;

/**
 * __useGetFixFloQuery__
 *
 * To run a query within a React component, call `useGetFixFloQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixFloQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixFloQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useGetFixFloQuery(baseOptions: Apollo.QueryHookOptions<GetFixFloQuery, GetFixFloQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFixFloQuery, GetFixFloQueryVariables>(GetFixFloDocument, options);
      }
export function useGetFixFloLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFixFloQuery, GetFixFloQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFixFloQuery, GetFixFloQueryVariables>(GetFixFloDocument, options);
        }
export type GetFixFloQueryHookResult = ReturnType<typeof useGetFixFloQuery>;
export type GetFixFloLazyQueryHookResult = ReturnType<typeof useGetFixFloLazyQuery>;
export type GetFixFloQueryResult = Apollo.QueryResult<GetFixFloQuery, GetFixFloQueryVariables>;
export const CreateManagerConversationReadDocument = gql`
    mutation CreateManagerConversationRead($input: CreateManagerConversationReadInput!) {
  createManagerConversationRead(input: $input) {
    conversation
    unread
  }
}
    `;
export type CreateManagerConversationReadMutationFn = Apollo.MutationFunction<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>;

/**
 * __useCreateManagerConversationReadMutation__
 *
 * To run a mutation, you first call `useCreateManagerConversationReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagerConversationReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagerConversationReadMutation, { data, loading, error }] = useCreateManagerConversationReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManagerConversationReadMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>(CreateManagerConversationReadDocument, options);
      }
export type CreateManagerConversationReadMutationHookResult = ReturnType<typeof useCreateManagerConversationReadMutation>;
export type CreateManagerConversationReadMutationResult = Apollo.MutationResult<CreateManagerConversationReadMutation>;
export type CreateManagerConversationReadMutationOptions = Apollo.BaseMutationOptions<CreateManagerConversationReadMutation, CreateManagerConversationReadMutationVariables>;
export const ListOtherConversationsDocument = gql`
    query listOtherConversations($currentConversationId: UUID, $contact: UUID) {
  conversations(contact: $contact, excludeId: $currentConversationId, first: 3) {
    edges {
      node {
        id
        subject
        snoozedUntil
        closedAt
        latestEvent {
          ... on ConversationMessageType {
            createdAt
          }
          ... on ConversationMediaType {
            createdAt
          }
          ... on ConversationActionModelType {
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListOtherConversationsQuery__
 *
 * To run a query within a React component, call `useListOtherConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOtherConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOtherConversationsQuery({
 *   variables: {
 *      currentConversationId: // value for 'currentConversationId'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useListOtherConversationsQuery(baseOptions?: Apollo.QueryHookOptions<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>(ListOtherConversationsDocument, options);
      }
export function useListOtherConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>(ListOtherConversationsDocument, options);
        }
export type ListOtherConversationsQueryHookResult = ReturnType<typeof useListOtherConversationsQuery>;
export type ListOtherConversationsLazyQueryHookResult = ReturnType<typeof useListOtherConversationsLazyQuery>;
export type ListOtherConversationsQueryResult = Apollo.QueryResult<ListOtherConversationsQuery, ListOtherConversationsQueryVariables>;
export const OrderConversationTagsDocument = gql`
    mutation OrderConversationTags($input: OrderConversationTagsInput!) {
  orderConversationTags(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type OrderConversationTagsMutationFn = Apollo.MutationFunction<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>;

/**
 * __useOrderConversationTagsMutation__
 *
 * To run a mutation, you first call `useOrderConversationTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrderConversationTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [orderConversationTagsMutation, { data, loading, error }] = useOrderConversationTagsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrderConversationTagsMutation(baseOptions?: Apollo.MutationHookOptions<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>(OrderConversationTagsDocument, options);
      }
export type OrderConversationTagsMutationHookResult = ReturnType<typeof useOrderConversationTagsMutation>;
export type OrderConversationTagsMutationResult = Apollo.MutationResult<OrderConversationTagsMutation>;
export type OrderConversationTagsMutationOptions = Apollo.BaseMutationOptions<OrderConversationTagsMutation, OrderConversationTagsMutationVariables>;
export const CreateConversationNoteDocument = gql`
    mutation CreateConversationNote($input: CreateConversationNoteInput!) {
  createConversationNote(input: $input) {
    conversationNote {
      id
      text
      user {
        id
        name
      }
      conversation {
        id
      }
    }
  }
}
    `;
export type CreateConversationNoteMutationFn = Apollo.MutationFunction<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>;

/**
 * __useCreateConversationNoteMutation__
 *
 * To run a mutation, you first call `useCreateConversationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationNoteMutation, { data, loading, error }] = useCreateConversationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>(CreateConversationNoteDocument, options);
      }
export type CreateConversationNoteMutationHookResult = ReturnType<typeof useCreateConversationNoteMutation>;
export type CreateConversationNoteMutationResult = Apollo.MutationResult<CreateConversationNoteMutation>;
export type CreateConversationNoteMutationOptions = Apollo.BaseMutationOptions<CreateConversationNoteMutation, CreateConversationNoteMutationVariables>;
export const AcceptMessageSuggestionDocument = gql`
    mutation AcceptMessageSuggestion($input: AcceptMessageSuggestionInput!) {
  acceptMessageSuggestion(input: $input) {
    conversation {
      id
      messages {
        id
        body
        createdAt
        sender
        user {
          id
          firstName
          lastName
          concierge {
            id
          }
          manager {
            id
          }
        }
        suggestion {
          suggestion
          action
        }
      }
    }
  }
}
    `;
export type AcceptMessageSuggestionMutationFn = Apollo.MutationFunction<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>;

/**
 * __useAcceptMessageSuggestionMutation__
 *
 * To run a mutation, you first call `useAcceptMessageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptMessageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptMessageSuggestionMutation, { data, loading, error }] = useAcceptMessageSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptMessageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>(AcceptMessageSuggestionDocument, options);
      }
export type AcceptMessageSuggestionMutationHookResult = ReturnType<typeof useAcceptMessageSuggestionMutation>;
export type AcceptMessageSuggestionMutationResult = Apollo.MutationResult<AcceptMessageSuggestionMutation>;
export type AcceptMessageSuggestionMutationOptions = Apollo.BaseMutationOptions<AcceptMessageSuggestionMutation, AcceptMessageSuggestionMutationVariables>;
export const ActionItemDocument = gql`
    query ActionItem($conversationId: UUID!) {
  conversation(id: $conversationId) {
    id
    home {
      id
      community {
        id
        settings {
          fixfloUrl
          dwellantOrgId
        }
      }
    }
  }
}
    `;

/**
 * __useActionItemQuery__
 *
 * To run a query within a React component, call `useActionItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useActionItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActionItemQuery({
 *   variables: {
 *      conversationId: // value for 'conversationId'
 *   },
 * });
 */
export function useActionItemQuery(baseOptions: Apollo.QueryHookOptions<ActionItemQuery, ActionItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActionItemQuery, ActionItemQueryVariables>(ActionItemDocument, options);
      }
export function useActionItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActionItemQuery, ActionItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActionItemQuery, ActionItemQueryVariables>(ActionItemDocument, options);
        }
export type ActionItemQueryHookResult = ReturnType<typeof useActionItemQuery>;
export type ActionItemLazyQueryHookResult = ReturnType<typeof useActionItemLazyQuery>;
export type ActionItemQueryResult = Apollo.QueryResult<ActionItemQuery, ActionItemQueryVariables>;
export const IgnoreMessageSuggestionDocument = gql`
    mutation IgnoreMessageSuggestion($input: IgnoreMessageSuggestionInput!) {
  ignoreMessageSuggestion(input: $input) {
    conversation {
      id
      messages {
        suggestion {
          id
        }
      }
    }
  }
}
    `;
export type IgnoreMessageSuggestionMutationFn = Apollo.MutationFunction<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>;

/**
 * __useIgnoreMessageSuggestionMutation__
 *
 * To run a mutation, you first call `useIgnoreMessageSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIgnoreMessageSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ignoreMessageSuggestionMutation, { data, loading, error }] = useIgnoreMessageSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIgnoreMessageSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>(IgnoreMessageSuggestionDocument, options);
      }
export type IgnoreMessageSuggestionMutationHookResult = ReturnType<typeof useIgnoreMessageSuggestionMutation>;
export type IgnoreMessageSuggestionMutationResult = Apollo.MutationResult<IgnoreMessageSuggestionMutation>;
export type IgnoreMessageSuggestionMutationOptions = Apollo.BaseMutationOptions<IgnoreMessageSuggestionMutation, IgnoreMessageSuggestionMutationVariables>;
export const MarkSuggestionShownDocument = gql`
    mutation MarkSuggestionShown($input: MarkSuggestionShownInput!) {
  markSuggestionShown(input: $input) {
    suggestion {
      id
    }
  }
}
    `;
export type MarkSuggestionShownMutationFn = Apollo.MutationFunction<MarkSuggestionShownMutation, MarkSuggestionShownMutationVariables>;

/**
 * __useMarkSuggestionShownMutation__
 *
 * To run a mutation, you first call `useMarkSuggestionShownMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSuggestionShownMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSuggestionShownMutation, { data, loading, error }] = useMarkSuggestionShownMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkSuggestionShownMutation(baseOptions?: Apollo.MutationHookOptions<MarkSuggestionShownMutation, MarkSuggestionShownMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSuggestionShownMutation, MarkSuggestionShownMutationVariables>(MarkSuggestionShownDocument, options);
      }
export type MarkSuggestionShownMutationHookResult = ReturnType<typeof useMarkSuggestionShownMutation>;
export type MarkSuggestionShownMutationResult = Apollo.MutationResult<MarkSuggestionShownMutation>;
export type MarkSuggestionShownMutationOptions = Apollo.BaseMutationOptions<MarkSuggestionShownMutation, MarkSuggestionShownMutationVariables>;
export const AddContractorToClientContractorCompanyDocument = gql`
    mutation AddContractorToClientContractorCompany($input: AddContractorToClientContractorCompanyInput!) {
  addContractorToClientContractorCompany(input: $input) {
    conversation {
      id
      contractorSuggestion {
        id
        contractorHasCompany
      }
    }
  }
}
    `;
export type AddContractorToClientContractorCompanyMutationFn = Apollo.MutationFunction<AddContractorToClientContractorCompanyMutation, AddContractorToClientContractorCompanyMutationVariables>;

/**
 * __useAddContractorToClientContractorCompanyMutation__
 *
 * To run a mutation, you first call `useAddContractorToClientContractorCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddContractorToClientContractorCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addContractorToClientContractorCompanyMutation, { data, loading, error }] = useAddContractorToClientContractorCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddContractorToClientContractorCompanyMutation(baseOptions?: Apollo.MutationHookOptions<AddContractorToClientContractorCompanyMutation, AddContractorToClientContractorCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddContractorToClientContractorCompanyMutation, AddContractorToClientContractorCompanyMutationVariables>(AddContractorToClientContractorCompanyDocument, options);
      }
export type AddContractorToClientContractorCompanyMutationHookResult = ReturnType<typeof useAddContractorToClientContractorCompanyMutation>;
export type AddContractorToClientContractorCompanyMutationResult = Apollo.MutationResult<AddContractorToClientContractorCompanyMutation>;
export type AddContractorToClientContractorCompanyMutationOptions = Apollo.BaseMutationOptions<AddContractorToClientContractorCompanyMutation, AddContractorToClientContractorCompanyMutationVariables>;
export const CancelScheduledMessageDocument = gql`
    mutation CancelScheduledMessage($input: CancelScheduledMessageInput!) {
  cancelScheduledMessage(input: $input) {
    success
  }
}
    `;
export type CancelScheduledMessageMutationFn = Apollo.MutationFunction<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>;

/**
 * __useCancelScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCancelScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledMessageMutation, { data, loading, error }] = useCancelScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>(CancelScheduledMessageDocument, options);
      }
export type CancelScheduledMessageMutationHookResult = ReturnType<typeof useCancelScheduledMessageMutation>;
export type CancelScheduledMessageMutationResult = Apollo.MutationResult<CancelScheduledMessageMutation>;
export type CancelScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CancelScheduledMessageMutation, CancelScheduledMessageMutationVariables>;
export const CloseConversationDocument = gql`
    mutation CloseConversation($input: CloseConversationInput!) {
  closeConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type CloseConversationMutationFn = Apollo.MutationFunction<CloseConversationMutation, CloseConversationMutationVariables>;

/**
 * __useCloseConversationMutation__
 *
 * To run a mutation, you first call `useCloseConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeConversationMutation, { data, loading, error }] = useCloseConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCloseConversationMutation(baseOptions?: Apollo.MutationHookOptions<CloseConversationMutation, CloseConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseConversationMutation, CloseConversationMutationVariables>(CloseConversationDocument, options);
      }
export type CloseConversationMutationHookResult = ReturnType<typeof useCloseConversationMutation>;
export type CloseConversationMutationResult = Apollo.MutationResult<CloseConversationMutation>;
export type CloseConversationMutationOptions = Apollo.BaseMutationOptions<CloseConversationMutation, CloseConversationMutationVariables>;
export const ContractorSuggestionCompaniesDocument = gql`
    query ContractorSuggestionCompanies($communities: [ID!], $isActive: Boolean, $search: String, $after: String) {
  clientContractorCompanies(
    communities: $communities
    isActive: $isActive
    search: $search
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        contractorCompany {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useContractorSuggestionCompaniesQuery__
 *
 * To run a query within a React component, call `useContractorSuggestionCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorSuggestionCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorSuggestionCompaniesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      isActive: // value for 'isActive'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContractorSuggestionCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ContractorSuggestionCompaniesQuery, ContractorSuggestionCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractorSuggestionCompaniesQuery, ContractorSuggestionCompaniesQueryVariables>(ContractorSuggestionCompaniesDocument, options);
      }
export function useContractorSuggestionCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractorSuggestionCompaniesQuery, ContractorSuggestionCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractorSuggestionCompaniesQuery, ContractorSuggestionCompaniesQueryVariables>(ContractorSuggestionCompaniesDocument, options);
        }
export type ContractorSuggestionCompaniesQueryHookResult = ReturnType<typeof useContractorSuggestionCompaniesQuery>;
export type ContractorSuggestionCompaniesLazyQueryHookResult = ReturnType<typeof useContractorSuggestionCompaniesLazyQuery>;
export type ContractorSuggestionCompaniesQueryResult = Apollo.QueryResult<ContractorSuggestionCompaniesQuery, ContractorSuggestionCompaniesQueryVariables>;
export const CreateConversationDocument = gql`
    mutation CreateConversation($input: CreateConversationInput!, $sender: ConversationRole!) {
  createConversation(sender: $sender, input: $input) {
    conversation {
      id
      subject
      user {
        id
        firstName
        lastName
      }
      home {
        name
      }
    }
  }
}
    `;
export type CreateConversationMutationFn = Apollo.MutationFunction<CreateConversationMutation, CreateConversationMutationVariables>;

/**
 * __useCreateConversationMutation__
 *
 * To run a mutation, you first call `useCreateConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMutation, { data, loading, error }] = useCreateConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sender: // value for 'sender'
 *   },
 * });
 */
export function useCreateConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMutation, CreateConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMutation, CreateConversationMutationVariables>(CreateConversationDocument, options);
      }
export type CreateConversationMutationHookResult = ReturnType<typeof useCreateConversationMutation>;
export type CreateConversationMutationResult = Apollo.MutationResult<CreateConversationMutation>;
export type CreateConversationMutationOptions = Apollo.BaseMutationOptions<CreateConversationMutation, CreateConversationMutationVariables>;
export const CreateConversationActionDocument = gql`
    mutation CreateConversationAction($input: CreateConversationActionInput!) {
  createConversationAction(input: $input) {
    conversation
    id
    createdAt
    type
    extra
  }
}
    `;
export type CreateConversationActionMutationFn = Apollo.MutationFunction<CreateConversationActionMutation, CreateConversationActionMutationVariables>;

/**
 * __useCreateConversationActionMutation__
 *
 * To run a mutation, you first call `useCreateConversationActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationActionMutation, { data, loading, error }] = useCreateConversationActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationActionMutation, CreateConversationActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationActionMutation, CreateConversationActionMutationVariables>(CreateConversationActionDocument, options);
      }
export type CreateConversationActionMutationHookResult = ReturnType<typeof useCreateConversationActionMutation>;
export type CreateConversationActionMutationResult = Apollo.MutationResult<CreateConversationActionMutation>;
export type CreateConversationActionMutationOptions = Apollo.BaseMutationOptions<CreateConversationActionMutation, CreateConversationActionMutationVariables>;
export const CreateConversationMessageDocument = gql`
    mutation CreateConversationMessage($input: CreateConversationMessageInput!, $sender: ConversationRole!) {
  createConversationMessage(input: $input, sender: $sender) {
    message {
      id
      body
      createdAt
      sender
    }
  }
}
    `;
export type CreateConversationMessageMutationFn = Apollo.MutationFunction<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>;

/**
 * __useCreateConversationMessageMutation__
 *
 * To run a mutation, you first call `useCreateConversationMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationMessageMutation, { data, loading, error }] = useCreateConversationMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *      sender: // value for 'sender'
 *   },
 * });
 */
export function useCreateConversationMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>(CreateConversationMessageDocument, options);
      }
export type CreateConversationMessageMutationHookResult = ReturnType<typeof useCreateConversationMessageMutation>;
export type CreateConversationMessageMutationResult = Apollo.MutationResult<CreateConversationMessageMutation>;
export type CreateConversationMessageMutationOptions = Apollo.BaseMutationOptions<CreateConversationMessageMutation, CreateConversationMessageMutationVariables>;
export const CreateScheduledMessageDocument = gql`
    mutation CreateScheduledMessage($input: CreateScheduledMessageInput!) {
  createScheduledMessage(input: $input) {
    scheduledMessage {
      id
    }
  }
}
    `;
export type CreateScheduledMessageMutationFn = Apollo.MutationFunction<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;

/**
 * __useCreateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useCreateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createScheduledMessageMutation, { data, loading, error }] = useCreateScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>(CreateScheduledMessageDocument, options);
      }
export type CreateScheduledMessageMutationHookResult = ReturnType<typeof useCreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationResult = Apollo.MutationResult<CreateScheduledMessageMutation>;
export type CreateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<CreateScheduledMessageMutation, CreateScheduledMessageMutationVariables>;
export const FindConversationDocument = gql`
    query FindConversation($id: UUID!) {
  conversation(id: $id) {
    id
    subject
    user {
      id
      firstName
      lastName
    }
    home {
      id
      name
    }
    hasUnread
    latestEvent {
      ... on ConversationMessageType {
        id
        body
        createdAt
      }
      ... on ConversationMediaType {
        id
        createdAt
      }
      ... on ConversationActionModelType {
        id
        createdAt
        type
      }
    }
  }
}
    `;

/**
 * __useFindConversationQuery__
 *
 * To run a query within a React component, call `useFindConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindConversationQuery(baseOptions: Apollo.QueryHookOptions<FindConversationQuery, FindConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindConversationQuery, FindConversationQueryVariables>(FindConversationDocument, options);
      }
export function useFindConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindConversationQuery, FindConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindConversationQuery, FindConversationQueryVariables>(FindConversationDocument, options);
        }
export type FindConversationQueryHookResult = ReturnType<typeof useFindConversationQuery>;
export type FindConversationLazyQueryHookResult = ReturnType<typeof useFindConversationLazyQuery>;
export type FindConversationQueryResult = Apollo.QueryResult<FindConversationQuery, FindConversationQueryVariables>;
export const FindFullConversationDocument = gql`
    query FindFullConversation($id: UUID!) {
  conversation(id: $id) {
    id
    subject
    snoozedUntil
    source
    participantType
    closedAt
    ratingPresentation {
      style
    }
    rating {
      id
      createdAt
      rating
      comment
      answers {
        ...RatingAnswer
      }
    }
    user {
      resident {
        id
      }
      id
      name
      email
    }
    home {
      id
      name
      community {
        id
        name
      }
    }
    community {
      id
      name
    }
    contractorSuggestion {
      ...ContractorSuggestion
    }
    media {
      id
      file
      createdAt
      sender
      user {
        id
        name
      }
    }
    messages {
      id
      body
      quotedText
      createdAt
      sender
      user {
        id
        name
        concierge {
          id
        }
        manager {
          id
        }
      }
      suggestion {
        id
        suggestion
        action
        createdAt
        version
        citations
        model
        promptVersion
      }
    }
    actions {
      id
      createdAt
      type
      extra
    }
    latestOpen {
      id
      createdAt
    }
    notes {
      edges {
        node {
          id
          text
          createdAt
          updatedAt
          user {
            id
            name
          }
          media {
            id
            file
          }
        }
      }
    }
    scheduledMessages {
      id
      body
      sendAt
      status
      sender
      createdAt
      user {
        id
        name
      }
      media {
        id
        file
      }
    }
    tags {
      totalCount
      edges {
        node {
          id
          name
          color
        }
      }
    }
    tagAssignments {
      totalCount
      edges {
        node {
          id
          tag {
            id
            name
            color
          }
        }
      }
    }
    availableClientTags {
      edges {
        node {
          id
          name
          color
          archivedAt
        }
      }
    }
    assignment {
      id
      assignedTo {
        id
        name
        firstName
        lastName
        email
        displayPicture
      }
    }
    teamAssignment {
      id
      team {
        id
        name
        icon
      }
    }
    linkedTasks {
      id
      status
      taskDefinition {
        id
        name
      }
    }
  }
}
    ${RatingAnswerFragmentDoc}
${ContractorSuggestionFragmentDoc}`;

/**
 * __useFindFullConversationQuery__
 *
 * To run a query within a React component, call `useFindFullConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindFullConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindFullConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindFullConversationQuery(baseOptions: Apollo.QueryHookOptions<FindFullConversationQuery, FindFullConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindFullConversationQuery, FindFullConversationQueryVariables>(FindFullConversationDocument, options);
      }
export function useFindFullConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindFullConversationQuery, FindFullConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindFullConversationQuery, FindFullConversationQueryVariables>(FindFullConversationDocument, options);
        }
export type FindFullConversationQueryHookResult = ReturnType<typeof useFindFullConversationQuery>;
export type FindFullConversationLazyQueryHookResult = ReturnType<typeof useFindFullConversationLazyQuery>;
export type FindFullConversationQueryResult = Apollo.QueryResult<FindFullConversationQuery, FindFullConversationQueryVariables>;
export const ReOpenConversationDocument = gql`
    mutation ReOpenConversation($input: ReOpenConversationInput!) {
  reOpenConversation(input: $input) {
    conversation {
      id
    }
  }
}
    `;
export type ReOpenConversationMutationFn = Apollo.MutationFunction<ReOpenConversationMutation, ReOpenConversationMutationVariables>;

/**
 * __useReOpenConversationMutation__
 *
 * To run a mutation, you first call `useReOpenConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReOpenConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reOpenConversationMutation, { data, loading, error }] = useReOpenConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReOpenConversationMutation(baseOptions?: Apollo.MutationHookOptions<ReOpenConversationMutation, ReOpenConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReOpenConversationMutation, ReOpenConversationMutationVariables>(ReOpenConversationDocument, options);
      }
export type ReOpenConversationMutationHookResult = ReturnType<typeof useReOpenConversationMutation>;
export type ReOpenConversationMutationResult = Apollo.MutationResult<ReOpenConversationMutation>;
export type ReOpenConversationMutationOptions = Apollo.BaseMutationOptions<ReOpenConversationMutation, ReOpenConversationMutationVariables>;
export const RespondToContractorSuggestionDocument = gql`
    mutation RespondToContractorSuggestion($input: RespondToContractorSuggestionInput!) {
  respondToContractorSuggestion(input: $input) {
    conversation {
      id
      participantType
    }
  }
}
    `;
export type RespondToContractorSuggestionMutationFn = Apollo.MutationFunction<RespondToContractorSuggestionMutation, RespondToContractorSuggestionMutationVariables>;

/**
 * __useRespondToContractorSuggestionMutation__
 *
 * To run a mutation, you first call `useRespondToContractorSuggestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToContractorSuggestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToContractorSuggestionMutation, { data, loading, error }] = useRespondToContractorSuggestionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRespondToContractorSuggestionMutation(baseOptions?: Apollo.MutationHookOptions<RespondToContractorSuggestionMutation, RespondToContractorSuggestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToContractorSuggestionMutation, RespondToContractorSuggestionMutationVariables>(RespondToContractorSuggestionDocument, options);
      }
export type RespondToContractorSuggestionMutationHookResult = ReturnType<typeof useRespondToContractorSuggestionMutation>;
export type RespondToContractorSuggestionMutationResult = Apollo.MutationResult<RespondToContractorSuggestionMutation>;
export type RespondToContractorSuggestionMutationOptions = Apollo.BaseMutationOptions<RespondToContractorSuggestionMutation, RespondToContractorSuggestionMutationVariables>;
export const SetConversationHomeDocument = gql`
    mutation SetConversationHome($input: SetConversationHomeInput!) {
  setConversationHome(input: $input) {
    conversation {
      id
      home {
        id
        name
      }
    }
  }
}
    `;
export type SetConversationHomeMutationFn = Apollo.MutationFunction<SetConversationHomeMutation, SetConversationHomeMutationVariables>;

/**
 * __useSetConversationHomeMutation__
 *
 * To run a mutation, you first call `useSetConversationHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConversationHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConversationHomeMutation, { data, loading, error }] = useSetConversationHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetConversationHomeMutation(baseOptions?: Apollo.MutationHookOptions<SetConversationHomeMutation, SetConversationHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetConversationHomeMutation, SetConversationHomeMutationVariables>(SetConversationHomeDocument, options);
      }
export type SetConversationHomeMutationHookResult = ReturnType<typeof useSetConversationHomeMutation>;
export type SetConversationHomeMutationResult = Apollo.MutationResult<SetConversationHomeMutation>;
export type SetConversationHomeMutationOptions = Apollo.BaseMutationOptions<SetConversationHomeMutation, SetConversationHomeMutationVariables>;
export const SnoozeConversationDocument = gql`
    mutation SnoozeConversation($input: SnoozeConversationInput!) {
  snoozeConversation(input: $input) {
    conversation {
      id
      snoozedUntil
    }
  }
}
    `;
export type SnoozeConversationMutationFn = Apollo.MutationFunction<SnoozeConversationMutation, SnoozeConversationMutationVariables>;

/**
 * __useSnoozeConversationMutation__
 *
 * To run a mutation, you first call `useSnoozeConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSnoozeConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [snoozeConversationMutation, { data, loading, error }] = useSnoozeConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSnoozeConversationMutation(baseOptions?: Apollo.MutationHookOptions<SnoozeConversationMutation, SnoozeConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SnoozeConversationMutation, SnoozeConversationMutationVariables>(SnoozeConversationDocument, options);
      }
export type SnoozeConversationMutationHookResult = ReturnType<typeof useSnoozeConversationMutation>;
export type SnoozeConversationMutationResult = Apollo.MutationResult<SnoozeConversationMutation>;
export type SnoozeConversationMutationOptions = Apollo.BaseMutationOptions<SnoozeConversationMutation, SnoozeConversationMutationVariables>;
export const UnsnoozeConversationDocument = gql`
    mutation UnsnoozeConversation($input: UnsnoozeConversationInput!) {
  unsnoozeConversation(input: $input) {
    conversation {
      id
      snoozedUntil
    }
  }
}
    `;
export type UnsnoozeConversationMutationFn = Apollo.MutationFunction<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>;

/**
 * __useUnsnoozeConversationMutation__
 *
 * To run a mutation, you first call `useUnsnoozeConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsnoozeConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsnoozeConversationMutation, { data, loading, error }] = useUnsnoozeConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnsnoozeConversationMutation(baseOptions?: Apollo.MutationHookOptions<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>(UnsnoozeConversationDocument, options);
      }
export type UnsnoozeConversationMutationHookResult = ReturnType<typeof useUnsnoozeConversationMutation>;
export type UnsnoozeConversationMutationResult = Apollo.MutationResult<UnsnoozeConversationMutation>;
export type UnsnoozeConversationMutationOptions = Apollo.BaseMutationOptions<UnsnoozeConversationMutation, UnsnoozeConversationMutationVariables>;
export const UpdateConversationParticipantTypeDocument = gql`
    mutation UpdateConversationParticipantType($input: UpdateConversationParticipantTypeInput!) {
  updateConversationParticipantType(input: $input) {
    conversation {
      id
      participantType
    }
  }
}
    `;
export type UpdateConversationParticipantTypeMutationFn = Apollo.MutationFunction<UpdateConversationParticipantTypeMutation, UpdateConversationParticipantTypeMutationVariables>;

/**
 * __useUpdateConversationParticipantTypeMutation__
 *
 * To run a mutation, you first call `useUpdateConversationParticipantTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationParticipantTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationParticipantTypeMutation, { data, loading, error }] = useUpdateConversationParticipantTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationParticipantTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationParticipantTypeMutation, UpdateConversationParticipantTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationParticipantTypeMutation, UpdateConversationParticipantTypeMutationVariables>(UpdateConversationParticipantTypeDocument, options);
      }
export type UpdateConversationParticipantTypeMutationHookResult = ReturnType<typeof useUpdateConversationParticipantTypeMutation>;
export type UpdateConversationParticipantTypeMutationResult = Apollo.MutationResult<UpdateConversationParticipantTypeMutation>;
export type UpdateConversationParticipantTypeMutationOptions = Apollo.BaseMutationOptions<UpdateConversationParticipantTypeMutation, UpdateConversationParticipantTypeMutationVariables>;
export const UpdateScheduledMessageDocument = gql`
    mutation UpdateScheduledMessage($input: UpdateScheduledMessageInput!) {
  updateScheduledMessage(input: $input) {
    success
  }
}
    `;
export type UpdateScheduledMessageMutationFn = Apollo.MutationFunction<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>;

/**
 * __useUpdateScheduledMessageMutation__
 *
 * To run a mutation, you first call `useUpdateScheduledMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScheduledMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScheduledMessageMutation, { data, loading, error }] = useUpdateScheduledMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScheduledMessageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>(UpdateScheduledMessageDocument, options);
      }
export type UpdateScheduledMessageMutationHookResult = ReturnType<typeof useUpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationResult = Apollo.MutationResult<UpdateScheduledMessageMutation>;
export type UpdateScheduledMessageMutationOptions = Apollo.BaseMutationOptions<UpdateScheduledMessageMutation, UpdateScheduledMessageMutationVariables>;
export const UpdateConversationUrgencyDocument = gql`
    mutation UpdateConversationUrgency($input: UpdateConversationUrgencyInput!) {
  updateConversationUrgency(input: $input) {
    conversation {
      id
      currentUrgency
    }
  }
}
    `;
export type UpdateConversationUrgencyMutationFn = Apollo.MutationFunction<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>;

/**
 * __useUpdateConversationUrgencyMutation__
 *
 * To run a mutation, you first call `useUpdateConversationUrgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationUrgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationUrgencyMutation, { data, loading, error }] = useUpdateConversationUrgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationUrgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>(UpdateConversationUrgencyDocument, options);
      }
export type UpdateConversationUrgencyMutationHookResult = ReturnType<typeof useUpdateConversationUrgencyMutation>;
export type UpdateConversationUrgencyMutationResult = Apollo.MutationResult<UpdateConversationUrgencyMutation>;
export type UpdateConversationUrgencyMutationOptions = Apollo.BaseMutationOptions<UpdateConversationUrgencyMutation, UpdateConversationUrgencyMutationVariables>;
export const DocumentSentApplicationsDocument = gql`
    query DocumentSentApplications($communities: [ID]) {
  applications(communities: $communities, status: ["DS"]) {
    totalCount
  }
}
    `;

/**
 * __useDocumentSentApplicationsQuery__
 *
 * To run a query within a React component, call `useDocumentSentApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSentApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSentApplicationsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useDocumentSentApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>(DocumentSentApplicationsDocument, options);
      }
export function useDocumentSentApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>(DocumentSentApplicationsDocument, options);
        }
export type DocumentSentApplicationsQueryHookResult = ReturnType<typeof useDocumentSentApplicationsQuery>;
export type DocumentSentApplicationsLazyQueryHookResult = ReturnType<typeof useDocumentSentApplicationsLazyQuery>;
export type DocumentSentApplicationsQueryResult = Apollo.QueryResult<DocumentSentApplicationsQuery, DocumentSentApplicationsQueryVariables>;
export const AllConversationCountsDocument = gql`
    query AllConversationCounts($communities: [ID], $userId: String, $teamIds: [String], $dateFrom: Date, $dateTo: Date, $clientTags: [String], $assignedUsers: [String], $participantType: [String]) {
  conversationCounts(
    communities: $communities
    userId: $userId
    teamIds: $teamIds
    dateFrom: $dateFrom
    dateTo: $dateTo
    clientTags: $clientTags
    assignedUsers: $assignedUsers
    participantType: $participantType
  ) {
    all
    needsResponse
    snoozed
    assigned
    assignedToMyTeam
    unassigned
    fromEmail
    fromArk
    inactive
    inactiveOwed
  }
}
    `;

/**
 * __useAllConversationCountsQuery__
 *
 * To run a query within a React component, call `useAllConversationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllConversationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllConversationCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      userId: // value for 'userId'
 *      teamIds: // value for 'teamIds'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      clientTags: // value for 'clientTags'
 *      assignedUsers: // value for 'assignedUsers'
 *      participantType: // value for 'participantType'
 *   },
 * });
 */
export function useAllConversationCountsQuery(baseOptions?: Apollo.QueryHookOptions<AllConversationCountsQuery, AllConversationCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllConversationCountsQuery, AllConversationCountsQueryVariables>(AllConversationCountsDocument, options);
      }
export function useAllConversationCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllConversationCountsQuery, AllConversationCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllConversationCountsQuery, AllConversationCountsQueryVariables>(AllConversationCountsDocument, options);
        }
export type AllConversationCountsQueryHookResult = ReturnType<typeof useAllConversationCountsQuery>;
export type AllConversationCountsLazyQueryHookResult = ReturnType<typeof useAllConversationCountsLazyQuery>;
export type AllConversationCountsQueryResult = Apollo.QueryResult<AllConversationCountsQuery, AllConversationCountsQueryVariables>;
export const UnansweredMessagesDocument = gql`
    query UnansweredMessages($communities: [ID], $assignedTo: String) {
  conversations(
    communities: $communities
    status: ["OP"]
    assignedTo: $assignedTo
    unanswered: "unanswered"
  ) {
    totalCount
  }
}
    `;

/**
 * __useUnansweredMessagesQuery__
 *
 * To run a query within a React component, call `useUnansweredMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnansweredMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnansweredMessagesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      assignedTo: // value for 'assignedTo'
 *   },
 * });
 */
export function useUnansweredMessagesQuery(baseOptions?: Apollo.QueryHookOptions<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>(UnansweredMessagesDocument, options);
      }
export function useUnansweredMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>(UnansweredMessagesDocument, options);
        }
export type UnansweredMessagesQueryHookResult = ReturnType<typeof useUnansweredMessagesQuery>;
export type UnansweredMessagesLazyQueryHookResult = ReturnType<typeof useUnansweredMessagesLazyQuery>;
export type UnansweredMessagesQueryResult = Apollo.QueryResult<UnansweredMessagesQuery, UnansweredMessagesQueryVariables>;
export const SafetyRosterNeedsActionCountDocument = gql`
    query SafetyRosterNeedsActionCount($communities: [ID]) {
  safetyRoster(communities: $communities, cohort: "needs_action", limit: 1) {
    counts {
      needsAction
    }
  }
}
    `;

/**
 * __useSafetyRosterNeedsActionCountQuery__
 *
 * To run a query within a React component, call `useSafetyRosterNeedsActionCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyRosterNeedsActionCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyRosterNeedsActionCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useSafetyRosterNeedsActionCountQuery(baseOptions?: Apollo.QueryHookOptions<SafetyRosterNeedsActionCountQuery, SafetyRosterNeedsActionCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyRosterNeedsActionCountQuery, SafetyRosterNeedsActionCountQueryVariables>(SafetyRosterNeedsActionCountDocument, options);
      }
export function useSafetyRosterNeedsActionCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyRosterNeedsActionCountQuery, SafetyRosterNeedsActionCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyRosterNeedsActionCountQuery, SafetyRosterNeedsActionCountQueryVariables>(SafetyRosterNeedsActionCountDocument, options);
        }
export type SafetyRosterNeedsActionCountQueryHookResult = ReturnType<typeof useSafetyRosterNeedsActionCountQuery>;
export type SafetyRosterNeedsActionCountLazyQueryHookResult = ReturnType<typeof useSafetyRosterNeedsActionCountLazyQuery>;
export type SafetyRosterNeedsActionCountQueryResult = Apollo.QueryResult<SafetyRosterNeedsActionCountQuery, SafetyRosterNeedsActionCountQueryVariables>;
export const BlockFilterOptionsDocument = gql`
    query BlockFilterOptions($communities: [ID], $after: String) {
  blocks(communities: $communities, after: $after, orderBy: "name") {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        isDefault
        community {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useBlockFilterOptionsQuery__
 *
 * To run a query within a React component, call `useBlockFilterOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockFilterOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockFilterOptionsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlockFilterOptionsQuery(baseOptions?: Apollo.QueryHookOptions<BlockFilterOptionsQuery, BlockFilterOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockFilterOptionsQuery, BlockFilterOptionsQueryVariables>(BlockFilterOptionsDocument, options);
      }
export function useBlockFilterOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockFilterOptionsQuery, BlockFilterOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockFilterOptionsQuery, BlockFilterOptionsQueryVariables>(BlockFilterOptionsDocument, options);
        }
export type BlockFilterOptionsQueryHookResult = ReturnType<typeof useBlockFilterOptionsQuery>;
export type BlockFilterOptionsLazyQueryHookResult = ReturnType<typeof useBlockFilterOptionsLazyQuery>;
export type BlockFilterOptionsQueryResult = Apollo.QueryResult<BlockFilterOptionsQuery, BlockFilterOptionsQueryVariables>;
export const CommunitiesForFilterDocument = gql`
    query CommunitiesForFilter($includeDeactivated: Boolean) {
  communities(includeDeactivated: $includeDeactivated, orderBy: "name") {
    edges {
      node {
        ...CommunityForFilterCommunity
      }
    }
  }
}
    ${CommunityForFilterCommunityFragmentDoc}`;

/**
 * __useCommunitiesForFilterQuery__
 *
 * To run a query within a React component, call `useCommunitiesForFilterQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesForFilterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesForFilterQuery({
 *   variables: {
 *      includeDeactivated: // value for 'includeDeactivated'
 *   },
 * });
 */
export function useCommunitiesForFilterQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesForFilterQuery, CommunitiesForFilterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesForFilterQuery, CommunitiesForFilterQueryVariables>(CommunitiesForFilterDocument, options);
      }
export function useCommunitiesForFilterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesForFilterQuery, CommunitiesForFilterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesForFilterQuery, CommunitiesForFilterQueryVariables>(CommunitiesForFilterDocument, options);
        }
export type CommunitiesForFilterQueryHookResult = ReturnType<typeof useCommunitiesForFilterQuery>;
export type CommunitiesForFilterLazyQueryHookResult = ReturnType<typeof useCommunitiesForFilterLazyQuery>;
export type CommunitiesForFilterQueryResult = Apollo.QueryResult<CommunitiesForFilterQuery, CommunitiesForFilterQueryVariables>;
export const CommunityTeamMembersBatchDocument = gql`
    query CommunityTeamMembersBatch($communityIds: [UUID!]!) {
  communityTeamMembersBulk(communityIds: $communityIds) {
    communityId
    members {
      ...CommunityTeamMember
    }
  }
}
    ${CommunityTeamMemberFragmentDoc}`;

/**
 * __useCommunityTeamMembersBatchQuery__
 *
 * To run a query within a React component, call `useCommunityTeamMembersBatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamMembersBatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamMembersBatchQuery({
 *   variables: {
 *      communityIds: // value for 'communityIds'
 *   },
 * });
 */
export function useCommunityTeamMembersBatchQuery(baseOptions: Apollo.QueryHookOptions<CommunityTeamMembersBatchQuery, CommunityTeamMembersBatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamMembersBatchQuery, CommunityTeamMembersBatchQueryVariables>(CommunityTeamMembersBatchDocument, options);
      }
export function useCommunityTeamMembersBatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamMembersBatchQuery, CommunityTeamMembersBatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamMembersBatchQuery, CommunityTeamMembersBatchQueryVariables>(CommunityTeamMembersBatchDocument, options);
        }
export type CommunityTeamMembersBatchQueryHookResult = ReturnType<typeof useCommunityTeamMembersBatchQuery>;
export type CommunityTeamMembersBatchLazyQueryHookResult = ReturnType<typeof useCommunityTeamMembersBatchLazyQuery>;
export type CommunityTeamMembersBatchQueryResult = Apollo.QueryResult<CommunityTeamMembersBatchQuery, CommunityTeamMembersBatchQueryVariables>;
export const ContactAutocompleteDocument = gql`
    query ContactAutocomplete($after: String, $search: String, $community: UUID, $communities: [ID], $home: UUID) {
  contacts(
    after: $after
    community: $community
    communities: $communities
    search: $search
    home: $home
    orderBy: "firstName"
    allowApplicants: false
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...ContactItem
      }
    }
  }
}
    ${ContactItemFragmentDoc}`;

/**
 * __useContactAutocompleteQuery__
 *
 * To run a query within a React component, call `useContactAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      community: // value for 'community'
 *      communities: // value for 'communities'
 *      home: // value for 'home'
 *   },
 * });
 */
export function useContactAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>(ContactAutocompleteDocument, options);
      }
export function useContactAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>(ContactAutocompleteDocument, options);
        }
export type ContactAutocompleteQueryHookResult = ReturnType<typeof useContactAutocompleteQuery>;
export type ContactAutocompleteLazyQueryHookResult = ReturnType<typeof useContactAutocompleteLazyQuery>;
export type ContactAutocompleteQueryResult = Apollo.QueryResult<ContactAutocompleteQuery, ContactAutocompleteQueryVariables>;
export const GroupAutocompleteDocument = gql`
    query GroupAutocomplete($after: String, $search: String, $community: UUID, $communities: [ID], $groupType: [String]) {
  communityGroups(
    after: $after
    search: $search
    community: $community
    communities: $communities
    active: true
    groupType: $groupType
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        community {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGroupAutocompleteQuery__
 *
 * To run a query within a React component, call `useGroupAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupAutocompleteQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      community: // value for 'community'
 *      communities: // value for 'communities'
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useGroupAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>(GroupAutocompleteDocument, options);
      }
export function useGroupAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>(GroupAutocompleteDocument, options);
        }
export type GroupAutocompleteQueryHookResult = ReturnType<typeof useGroupAutocompleteQuery>;
export type GroupAutocompleteLazyQueryHookResult = ReturnType<typeof useGroupAutocompleteLazyQuery>;
export type GroupAutocompleteQueryResult = Apollo.QueryResult<GroupAutocompleteQuery, GroupAutocompleteQueryVariables>;
export const HomeAutocompleteDocument = gql`
    query HomeAutocomplete($communities: [ID!], $after: String, $icontainsSearch: String, $block: UUID) {
  homes(
    communities: $communities
    block: $block
    after: $after
    icontainsSearch: $icontainsSearch
    orderBy: "number_in_address,name"
    includeDemoHomes: false
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        address
        block {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useHomeAutocompleteQuery__
 *
 * To run a query within a React component, call `useHomeAutocompleteQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeAutocompleteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeAutocompleteQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      icontainsSearch: // value for 'icontainsSearch'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useHomeAutocompleteQuery(baseOptions?: Apollo.QueryHookOptions<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>(HomeAutocompleteDocument, options);
      }
export function useHomeAutocompleteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>(HomeAutocompleteDocument, options);
        }
export type HomeAutocompleteQueryHookResult = ReturnType<typeof useHomeAutocompleteQuery>;
export type HomeAutocompleteLazyQueryHookResult = ReturnType<typeof useHomeAutocompleteLazyQuery>;
export type HomeAutocompleteQueryResult = Apollo.QueryResult<HomeAutocompleteQuery, HomeAutocompleteQueryVariables>;
export const ContractorCompaniesDocument = gql`
    query ContractorCompanies($communities: [ID!], $isActive: Boolean, $search: String, $after: String) {
  clientContractorCompanies(
    communities: $communities
    isActive: $isActive
    search: $search
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useContractorCompaniesQuery__
 *
 * To run a query within a React component, call `useContractorCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractorCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractorCompaniesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      isActive: // value for 'isActive'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContractorCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ContractorCompaniesQuery, ContractorCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractorCompaniesQuery, ContractorCompaniesQueryVariables>(ContractorCompaniesDocument, options);
      }
export function useContractorCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractorCompaniesQuery, ContractorCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractorCompaniesQuery, ContractorCompaniesQueryVariables>(ContractorCompaniesDocument, options);
        }
export type ContractorCompaniesQueryHookResult = ReturnType<typeof useContractorCompaniesQuery>;
export type ContractorCompaniesLazyQueryHookResult = ReturnType<typeof useContractorCompaniesLazyQuery>;
export type ContractorCompaniesQueryResult = Apollo.QueryResult<ContractorCompaniesQuery, ContractorCompaniesQueryVariables>;
export const FormResidenciesDocument = gql`
    query FormResidencies($home: UUID, $after: String) {
  residencies(home: $home, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        startDate
        completionDate
        residents {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useFormResidenciesQuery__
 *
 * To run a query within a React component, call `useFormResidenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormResidenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormResidenciesQuery({
 *   variables: {
 *      home: // value for 'home'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFormResidenciesQuery(baseOptions?: Apollo.QueryHookOptions<FormResidenciesQuery, FormResidenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormResidenciesQuery, FormResidenciesQueryVariables>(FormResidenciesDocument, options);
      }
export function useFormResidenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormResidenciesQuery, FormResidenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormResidenciesQuery, FormResidenciesQueryVariables>(FormResidenciesDocument, options);
        }
export type FormResidenciesQueryHookResult = ReturnType<typeof useFormResidenciesQuery>;
export type FormResidenciesLazyQueryHookResult = ReturnType<typeof useFormResidenciesLazyQuery>;
export type FormResidenciesQueryResult = Apollo.QueryResult<FormResidenciesQuery, FormResidenciesQueryVariables>;
export const AllTeamsDocument = gql`
    query AllTeams {
  teams {
    edges {
      node {
        ...TeamFilterItem
      }
    }
  }
}
    ${TeamFilterItemFragmentDoc}`;

/**
 * __useAllTeamsQuery__
 *
 * To run a query within a React component, call `useAllTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllTeamsQuery(baseOptions?: Apollo.QueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, options);
      }
export function useAllTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTeamsQuery, AllTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTeamsQuery, AllTeamsQueryVariables>(AllTeamsDocument, options);
        }
export type AllTeamsQueryHookResult = ReturnType<typeof useAllTeamsQuery>;
export type AllTeamsLazyQueryHookResult = ReturnType<typeof useAllTeamsLazyQuery>;
export type AllTeamsQueryResult = Apollo.QueryResult<AllTeamsQuery, AllTeamsQueryVariables>;
export const CommunityGroupFilterGroupsDocument = gql`
    query CommunityGroupFilterGroups {
  communityGroupsAll(active: true) {
    edges {
      node {
        ...CommunityGroupFilterGroup
      }
    }
  }
}
    ${CommunityGroupFilterGroupFragmentDoc}`;

/**
 * __useCommunityGroupFilterGroupsQuery__
 *
 * To run a query within a React component, call `useCommunityGroupFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupFilterGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityGroupFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityGroupFilterGroupsQuery, CommunityGroupFilterGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupFilterGroupsQuery, CommunityGroupFilterGroupsQueryVariables>(CommunityGroupFilterGroupsDocument, options);
      }
export function useCommunityGroupFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupFilterGroupsQuery, CommunityGroupFilterGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupFilterGroupsQuery, CommunityGroupFilterGroupsQueryVariables>(CommunityGroupFilterGroupsDocument, options);
        }
export type CommunityGroupFilterGroupsQueryHookResult = ReturnType<typeof useCommunityGroupFilterGroupsQuery>;
export type CommunityGroupFilterGroupsLazyQueryHookResult = ReturnType<typeof useCommunityGroupFilterGroupsLazyQuery>;
export type CommunityGroupFilterGroupsQueryResult = Apollo.QueryResult<CommunityGroupFilterGroupsQuery, CommunityGroupFilterGroupsQueryVariables>;
export const GetUserTypeDocument = gql`
    query GetUserType {
  getUser {
    id
    email
    name
    mobile
    clientAdmin {
      ...ClientAdminItem
    }
    concierge {
      ...ConciergeItem
    }
    manager {
      ...ManagerItem
    }
    communityManager {
      id
    }
    rmcDirector {
      ...RMCDirectorItem
    }
  }
}
    ${ClientAdminItemFragmentDoc}
${ConciergeItemFragmentDoc}
${ManagerItemFragmentDoc}
${RmcDirectorItemFragmentDoc}`;

/**
 * __useGetUserTypeQuery__
 *
 * To run a query within a React component, call `useGetUserTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetUserTypeQuery, GetUserTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(GetUserTypeDocument, options);
      }
export function useGetUserTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserTypeQuery, GetUserTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserTypeQuery, GetUserTypeQueryVariables>(GetUserTypeDocument, options);
        }
export type GetUserTypeQueryHookResult = ReturnType<typeof useGetUserTypeQuery>;
export type GetUserTypeLazyQueryHookResult = ReturnType<typeof useGetUserTypeLazyQuery>;
export type GetUserTypeQueryResult = Apollo.QueryResult<GetUserTypeQuery, GetUserTypeQueryVariables>;
export const CreateOrUpdateUserSessionDocument = gql`
    mutation CreateOrUpdateUserSession($input: CreateOrUpdateUserSessionInput!) {
  createOrUpdateUserSession(input: $input) {
    userSession {
      id
      sessionTarget
    }
  }
}
    `;
export type CreateOrUpdateUserSessionMutationFn = Apollo.MutationFunction<CreateOrUpdateUserSessionMutation, CreateOrUpdateUserSessionMutationVariables>;

/**
 * __useCreateOrUpdateUserSessionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateUserSessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateUserSessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateUserSessionMutation, { data, loading, error }] = useCreateOrUpdateUserSessionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrUpdateUserSessionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateUserSessionMutation, CreateOrUpdateUserSessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateUserSessionMutation, CreateOrUpdateUserSessionMutationVariables>(CreateOrUpdateUserSessionDocument, options);
      }
export type CreateOrUpdateUserSessionMutationHookResult = ReturnType<typeof useCreateOrUpdateUserSessionMutation>;
export type CreateOrUpdateUserSessionMutationResult = Apollo.MutationResult<CreateOrUpdateUserSessionMutation>;
export type CreateOrUpdateUserSessionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateUserSessionMutation, CreateOrUpdateUserSessionMutationVariables>;
export const CreateDeviceDocument = gql`
    mutation CreateDevice($input: CreateNewDeviceInput!) {
  createNewDevice(input: $input) {
    ok
  }
}
    `;
export type CreateDeviceMutationFn = Apollo.MutationFunction<CreateDeviceMutation, CreateDeviceMutationVariables>;

/**
 * __useCreateDeviceMutation__
 *
 * To run a mutation, you first call `useCreateDeviceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDeviceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDeviceMutation, { data, loading, error }] = useCreateDeviceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDeviceMutation(baseOptions?: Apollo.MutationHookOptions<CreateDeviceMutation, CreateDeviceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDeviceMutation, CreateDeviceMutationVariables>(CreateDeviceDocument, options);
      }
export type CreateDeviceMutationHookResult = ReturnType<typeof useCreateDeviceMutation>;
export type CreateDeviceMutationResult = Apollo.MutationResult<CreateDeviceMutation>;
export type CreateDeviceMutationOptions = Apollo.BaseMutationOptions<CreateDeviceMutation, CreateDeviceMutationVariables>;
export const FindNotificationDocument = gql`
    query FindNotification($id: UUID!) {
  notification(id: $id) {
    ...NotificationHook
  }
}
    ${NotificationHookFragmentDoc}`;

/**
 * __useFindNotificationQuery__
 *
 * To run a query within a React component, call `useFindNotificationQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindNotificationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindNotificationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindNotificationQuery(baseOptions: Apollo.QueryHookOptions<FindNotificationQuery, FindNotificationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindNotificationQuery, FindNotificationQueryVariables>(FindNotificationDocument, options);
      }
export function useFindNotificationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindNotificationQuery, FindNotificationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindNotificationQuery, FindNotificationQueryVariables>(FindNotificationDocument, options);
        }
export type FindNotificationQueryHookResult = ReturnType<typeof useFindNotificationQuery>;
export type FindNotificationLazyQueryHookResult = ReturnType<typeof useFindNotificationLazyQuery>;
export type FindNotificationQueryResult = Apollo.QueryResult<FindNotificationQuery, FindNotificationQueryVariables>;
export const LogManagerDashUseDocument = gql`
    mutation LogManagerDashUse {
  logManagerDashUse {
    ok
  }
}
    `;
export type LogManagerDashUseMutationFn = Apollo.MutationFunction<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>;

/**
 * __useLogManagerDashUseMutation__
 *
 * To run a mutation, you first call `useLogManagerDashUseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogManagerDashUseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logManagerDashUseMutation, { data, loading, error }] = useLogManagerDashUseMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogManagerDashUseMutation(baseOptions?: Apollo.MutationHookOptions<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>(LogManagerDashUseDocument, options);
      }
export type LogManagerDashUseMutationHookResult = ReturnType<typeof useLogManagerDashUseMutation>;
export type LogManagerDashUseMutationResult = Apollo.MutationResult<LogManagerDashUseMutation>;
export type LogManagerDashUseMutationOptions = Apollo.BaseMutationOptions<LogManagerDashUseMutation, LogManagerDashUseMutationVariables>;
export const GetClientTypeDocument = gql`
    query GetClientType {
  getClient {
    id
    clientType
  }
}
    `;

/**
 * __useGetClientTypeQuery__
 *
 * To run a query within a React component, call `useGetClientTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientTypeQuery(baseOptions?: Apollo.QueryHookOptions<GetClientTypeQuery, GetClientTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientTypeQuery, GetClientTypeQueryVariables>(GetClientTypeDocument, options);
      }
export function useGetClientTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientTypeQuery, GetClientTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientTypeQuery, GetClientTypeQueryVariables>(GetClientTypeDocument, options);
        }
export type GetClientTypeQueryHookResult = ReturnType<typeof useGetClientTypeQuery>;
export type GetClientTypeLazyQueryHookResult = ReturnType<typeof useGetClientTypeLazyQuery>;
export type GetClientTypeQueryResult = Apollo.QueryResult<GetClientTypeQuery, GetClientTypeQueryVariables>;
export const GetFeaturesDocument = gql`
    query GetFeatures {
  getClient {
    id
    features {
      id
      name
      isBeta
    }
  }
}
    `;

/**
 * __useGetFeaturesQuery__
 *
 * To run a query within a React component, call `useGetFeaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeaturesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
      }
export function useGetFeaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeaturesQuery, GetFeaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeaturesQuery, GetFeaturesQueryVariables>(GetFeaturesDocument, options);
        }
export type GetFeaturesQueryHookResult = ReturnType<typeof useGetFeaturesQuery>;
export type GetFeaturesLazyQueryHookResult = ReturnType<typeof useGetFeaturesLazyQuery>;
export type GetFeaturesQueryResult = Apollo.QueryResult<GetFeaturesQuery, GetFeaturesQueryVariables>;
export const GetClientPaymentsEnabledDocument = gql`
    query GetClientPaymentsEnabled {
  getClient {
    id
    paymentsEnabled
  }
}
    `;

/**
 * __useGetClientPaymentsEnabledQuery__
 *
 * To run a query within a React component, call `useGetClientPaymentsEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientPaymentsEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientPaymentsEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientPaymentsEnabledQuery(baseOptions?: Apollo.QueryHookOptions<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>(GetClientPaymentsEnabledDocument, options);
      }
export function useGetClientPaymentsEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>(GetClientPaymentsEnabledDocument, options);
        }
export type GetClientPaymentsEnabledQueryHookResult = ReturnType<typeof useGetClientPaymentsEnabledQuery>;
export type GetClientPaymentsEnabledLazyQueryHookResult = ReturnType<typeof useGetClientPaymentsEnabledLazyQuery>;
export type GetClientPaymentsEnabledQueryResult = Apollo.QueryResult<GetClientPaymentsEnabledQuery, GetClientPaymentsEnabledQueryVariables>;
export const GetClientStripeLoginLinkDocument = gql`
    query GetClientStripeLoginLink {
  getClient {
    id
    stripeDashboardLink
  }
}
    `;

/**
 * __useGetClientStripeLoginLinkQuery__
 *
 * To run a query within a React component, call `useGetClientStripeLoginLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientStripeLoginLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientStripeLoginLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientStripeLoginLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>(GetClientStripeLoginLinkDocument, options);
      }
export function useGetClientStripeLoginLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>(GetClientStripeLoginLinkDocument, options);
        }
export type GetClientStripeLoginLinkQueryHookResult = ReturnType<typeof useGetClientStripeLoginLinkQuery>;
export type GetClientStripeLoginLinkLazyQueryHookResult = ReturnType<typeof useGetClientStripeLoginLinkLazyQuery>;
export type GetClientStripeLoginLinkQueryResult = Apollo.QueryResult<GetClientStripeLoginLinkQuery, GetClientStripeLoginLinkQueryVariables>;
export const LeanNotificationsDocument = gql`
    query LeanNotifications($after: String, $read: Boolean) {
  leanNotifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: $read
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        createdAt
        verb
        read
        title
        type
        platform
        targetType
        targetObjectId
        actionObjectType
        actionObjectObjectId
        isFeatureAnnouncement
        navigationMeta {
          targetType
          actionObjectType
          routeId
          secondaryId
        }
      }
    }
  }
}
    `;

/**
 * __useLeanNotificationsQuery__
 *
 * To run a query within a React component, call `useLeanNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeanNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeanNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useLeanNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<LeanNotificationsQuery, LeanNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeanNotificationsQuery, LeanNotificationsQueryVariables>(LeanNotificationsDocument, options);
      }
export function useLeanNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeanNotificationsQuery, LeanNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeanNotificationsQuery, LeanNotificationsQueryVariables>(LeanNotificationsDocument, options);
        }
export type LeanNotificationsQueryHookResult = ReturnType<typeof useLeanNotificationsQuery>;
export type LeanNotificationsLazyQueryHookResult = ReturnType<typeof useLeanNotificationsLazyQuery>;
export type LeanNotificationsQueryResult = Apollo.QueryResult<LeanNotificationsQuery, LeanNotificationsQueryVariables>;
export const NotificationsDocument = gql`
    query Notifications($after: String, $read: Boolean) {
  notifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: $read
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...NotificationsMenuNotification
      }
    }
  }
}
    ${NotificationsMenuNotificationFragmentDoc}`;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsQueryResult = Apollo.QueryResult<NotificationsQuery, NotificationsQueryVariables>;
export const ReadAllNotificationsDocument = gql`
    mutation ReadAllNotifications {
  readAllNotifications(input: {type: "NOTIFICATION"}) {
    clientMutationId
  }
}
    `;
export type ReadAllNotificationsMutationFn = Apollo.MutationFunction<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;

/**
 * __useReadAllNotificationsMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsMutation, { data, loading, error }] = useReadAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>(ReadAllNotificationsDocument, options);
      }
export type ReadAllNotificationsMutationHookResult = ReturnType<typeof useReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationResult = Apollo.MutationResult<ReadAllNotificationsMutation>;
export type ReadAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsMutation, ReadAllNotificationsMutationVariables>;
export const ReadAllNotificationsOnTargetDocument = gql`
    mutation ReadAllNotificationsOnTarget($input: ReadAllNotificationsOnTargetInput!) {
  readAllNotificationsOnTarget(input: $input) {
    clientMutationId
  }
}
    `;
export type ReadAllNotificationsOnTargetMutationFn = Apollo.MutationFunction<ReadAllNotificationsOnTargetMutation, ReadAllNotificationsOnTargetMutationVariables>;

/**
 * __useReadAllNotificationsOnTargetMutation__
 *
 * To run a mutation, you first call `useReadAllNotificationsOnTargetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllNotificationsOnTargetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllNotificationsOnTargetMutation, { data, loading, error }] = useReadAllNotificationsOnTargetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadAllNotificationsOnTargetMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllNotificationsOnTargetMutation, ReadAllNotificationsOnTargetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllNotificationsOnTargetMutation, ReadAllNotificationsOnTargetMutationVariables>(ReadAllNotificationsOnTargetDocument, options);
      }
export type ReadAllNotificationsOnTargetMutationHookResult = ReturnType<typeof useReadAllNotificationsOnTargetMutation>;
export type ReadAllNotificationsOnTargetMutationResult = Apollo.MutationResult<ReadAllNotificationsOnTargetMutation>;
export type ReadAllNotificationsOnTargetMutationOptions = Apollo.BaseMutationOptions<ReadAllNotificationsOnTargetMutation, ReadAllNotificationsOnTargetMutationVariables>;
export const ReadNotificationDocument = gql`
    mutation ReadNotification($input: ReadNotificationInput!) {
  readNotification(input: $input) {
    notification {
      id
      read
    }
  }
}
    `;
export type ReadNotificationMutationFn = Apollo.MutationFunction<ReadNotificationMutation, ReadNotificationMutationVariables>;

/**
 * __useReadNotificationMutation__
 *
 * To run a mutation, you first call `useReadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readNotificationMutation, { data, loading, error }] = useReadNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ReadNotificationMutation, ReadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, options);
      }
export type ReadNotificationMutationHookResult = ReturnType<typeof useReadNotificationMutation>;
export type ReadNotificationMutationResult = Apollo.MutationResult<ReadNotificationMutation>;
export type ReadNotificationMutationOptions = Apollo.BaseMutationOptions<ReadNotificationMutation, ReadNotificationMutationVariables>;
export const UnreadNotificationsCountDocument = gql`
    query UnreadNotificationsCount {
  notifications(
    read: false
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    type: "NOTIFICATION"
  ) {
    totalCount
  }
}
    `;

/**
 * __useUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
      }
export function useUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>(UnreadNotificationsCountDocument, options);
        }
export type UnreadNotificationsCountQueryHookResult = ReturnType<typeof useUnreadNotificationsCountQuery>;
export type UnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useUnreadNotificationsCountLazyQuery>;
export type UnreadNotificationsCountQueryResult = Apollo.QueryResult<UnreadNotificationsCountQuery, UnreadNotificationsCountQueryVariables>;
export const GetClientUserDocument = gql`
    query GetClientUser($id: UUID!) {
  clientUserById(id: $id) {
    id
    firstName
    lastName
    email
    dateJoined
    mfaEnabled
    lastActive
    teams {
      edges {
        node {
          ...TeamFilterItem
          communities {
            edges {
              node {
                id
                name
                status
              }
            }
          }
        }
      }
    }
    clientAdmin {
      id
    }
    communityManager {
      id
      isActive
      communities(includeDeactivated: true) {
        edges {
          node {
            id
            name
            status
          }
        }
      }
    }
    manager {
      id
      isActive
      community(includeDeactivated: true) {
        edges {
          node {
            id
            name
            status
          }
        }
      }
    }
    concierge {
      id
      isActive
      communities(includeDeactivated: true) {
        edges {
          node {
            id
            name
            status
          }
        }
      }
    }
  }
}
    ${TeamFilterItemFragmentDoc}`;

/**
 * __useGetClientUserQuery__
 *
 * To run a query within a React component, call `useGetClientUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientUserQuery(baseOptions: Apollo.QueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientUserQuery, GetClientUserQueryVariables>(GetClientUserDocument, options);
      }
export function useGetClientUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientUserQuery, GetClientUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientUserQuery, GetClientUserQueryVariables>(GetClientUserDocument, options);
        }
export type GetClientUserQueryHookResult = ReturnType<typeof useGetClientUserQuery>;
export type GetClientUserLazyQueryHookResult = ReturnType<typeof useGetClientUserLazyQuery>;
export type GetClientUserQueryResult = Apollo.QueryResult<GetClientUserQuery, GetClientUserQueryVariables>;
export const AddMemberDocument = gql`
    mutation AddMember($input: AddMemberInput!) {
  addMember(input: $input) {
    errors {
      field
      messages
    }
    createdUserId
    clientUser {
      id
    }
  }
}
    `;
export type AddMemberMutationFn = Apollo.MutationFunction<AddMemberMutation, AddMemberMutationVariables>;

/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddMemberMutation, AddMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddMemberMutation, AddMemberMutationVariables>(AddMemberDocument, options);
      }
export type AddMemberMutationHookResult = ReturnType<typeof useAddMemberMutation>;
export type AddMemberMutationResult = Apollo.MutationResult<AddMemberMutation>;
export type AddMemberMutationOptions = Apollo.BaseMutationOptions<AddMemberMutation, AddMemberMutationVariables>;
export const DeactivateClientUserDocument = gql`
    mutation DeactivateClientUser($input: DeactivateClientUserInput!) {
  deactivateClientUser(input: $input) {
    clientUser {
      id
    }
  }
}
    `;
export type DeactivateClientUserMutationFn = Apollo.MutationFunction<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>;

/**
 * __useDeactivateClientUserMutation__
 *
 * To run a mutation, you first call `useDeactivateClientUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateClientUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateClientUserMutation, { data, loading, error }] = useDeactivateClientUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateClientUserMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>(DeactivateClientUserDocument, options);
      }
export type DeactivateClientUserMutationHookResult = ReturnType<typeof useDeactivateClientUserMutation>;
export type DeactivateClientUserMutationResult = Apollo.MutationResult<DeactivateClientUserMutation>;
export type DeactivateClientUserMutationOptions = Apollo.BaseMutationOptions<DeactivateClientUserMutation, DeactivateClientUserMutationVariables>;
export const EditMemberDocument = gql`
    mutation EditMember($input: EditMemberInput!) {
  editMember(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type EditMemberMutationFn = Apollo.MutationFunction<EditMemberMutation, EditMemberMutationVariables>;

/**
 * __useEditMemberMutation__
 *
 * To run a mutation, you first call `useEditMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editMemberMutation, { data, loading, error }] = useEditMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditMemberMutation(baseOptions?: Apollo.MutationHookOptions<EditMemberMutation, EditMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditMemberMutation, EditMemberMutationVariables>(EditMemberDocument, options);
      }
export type EditMemberMutationHookResult = ReturnType<typeof useEditMemberMutation>;
export type EditMemberMutationResult = Apollo.MutationResult<EditMemberMutation>;
export type EditMemberMutationOptions = Apollo.BaseMutationOptions<EditMemberMutation, EditMemberMutationVariables>;
export const ResendMemberInviteEmailDocument = gql`
    mutation ResendMemberInviteEmail($input: ResendMemberInviteEmailInput!) {
  resendMemberInviteEmail(input: $input) {
    clientUser {
      id
    }
  }
}
    `;
export type ResendMemberInviteEmailMutationFn = Apollo.MutationFunction<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>;

/**
 * __useResendMemberInviteEmailMutation__
 *
 * To run a mutation, you first call `useResendMemberInviteEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendMemberInviteEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendMemberInviteEmailMutation, { data, loading, error }] = useResendMemberInviteEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResendMemberInviteEmailMutation(baseOptions?: Apollo.MutationHookOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>(ResendMemberInviteEmailDocument, options);
      }
export type ResendMemberInviteEmailMutationHookResult = ReturnType<typeof useResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationResult = Apollo.MutationResult<ResendMemberInviteEmailMutation>;
export type ResendMemberInviteEmailMutationOptions = Apollo.BaseMutationOptions<ResendMemberInviteEmailMutation, ResendMemberInviteEmailMutationVariables>;
export const ClientStaffMembersDocument = gql`
    query ClientStaffMembers($communities: [ID!]) {
  clientStaffMembers(communities: $communities) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        id
        firstName
        lastName
        email
        mfaEnabled
        lastActive
        role
        isRoleActive
        roleCommunityCount
        communityIds
        teamIds
        roleCommunitiesPreview {
          id
          name
        }
        profile {
          displayPicture
        }
        teams {
          id
          name
          icon
        }
      }
    }
  }
}
    `;

/**
 * __useClientStaffMembersQuery__
 *
 * To run a query within a React component, call `useClientStaffMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientStaffMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientStaffMembersQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useClientStaffMembersQuery(baseOptions?: Apollo.QueryHookOptions<ClientStaffMembersQuery, ClientStaffMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientStaffMembersQuery, ClientStaffMembersQueryVariables>(ClientStaffMembersDocument, options);
      }
export function useClientStaffMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientStaffMembersQuery, ClientStaffMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientStaffMembersQuery, ClientStaffMembersQueryVariables>(ClientStaffMembersDocument, options);
        }
export type ClientStaffMembersQueryHookResult = ReturnType<typeof useClientStaffMembersQuery>;
export type ClientStaffMembersLazyQueryHookResult = ReturnType<typeof useClientStaffMembersLazyQuery>;
export type ClientStaffMembersQueryResult = Apollo.QueryResult<ClientStaffMembersQuery, ClientStaffMembersQueryVariables>;
export const BulkDeactivationJobDocument = gql`
    query BulkDeactivationJob($id: UUID!) {
  bulkDeactivationJob(id: $id) {
    id
    status
    total
    processed
    succeeded
    failed
    startedAt
    finishedAt
  }
}
    `;

/**
 * __useBulkDeactivationJobQuery__
 *
 * To run a query within a React component, call `useBulkDeactivationJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDeactivationJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDeactivationJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkDeactivationJobQuery(baseOptions: Apollo.QueryHookOptions<BulkDeactivationJobQuery, BulkDeactivationJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkDeactivationJobQuery, BulkDeactivationJobQueryVariables>(BulkDeactivationJobDocument, options);
      }
export function useBulkDeactivationJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkDeactivationJobQuery, BulkDeactivationJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkDeactivationJobQuery, BulkDeactivationJobQueryVariables>(BulkDeactivationJobDocument, options);
        }
export type BulkDeactivationJobQueryHookResult = ReturnType<typeof useBulkDeactivationJobQuery>;
export type BulkDeactivationJobLazyQueryHookResult = ReturnType<typeof useBulkDeactivationJobLazyQuery>;
export type BulkDeactivationJobQueryResult = Apollo.QueryResult<BulkDeactivationJobQuery, BulkDeactivationJobQueryVariables>;
export const StartBulkDeactivationDocument = gql`
    mutation StartBulkDeactivation($ids: [ID]!) {
  startBulkDeactivation(input: {ids: $ids}) {
    job {
      id
      status
      total
      processed
      succeeded
      failed
      startedAt
      finishedAt
    }
  }
}
    `;
export type StartBulkDeactivationMutationFn = Apollo.MutationFunction<StartBulkDeactivationMutation, StartBulkDeactivationMutationVariables>;

/**
 * __useStartBulkDeactivationMutation__
 *
 * To run a mutation, you first call `useStartBulkDeactivationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBulkDeactivationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBulkDeactivationMutation, { data, loading, error }] = useStartBulkDeactivationMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useStartBulkDeactivationMutation(baseOptions?: Apollo.MutationHookOptions<StartBulkDeactivationMutation, StartBulkDeactivationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBulkDeactivationMutation, StartBulkDeactivationMutationVariables>(StartBulkDeactivationDocument, options);
      }
export type StartBulkDeactivationMutationHookResult = ReturnType<typeof useStartBulkDeactivationMutation>;
export type StartBulkDeactivationMutationResult = Apollo.MutationResult<StartBulkDeactivationMutation>;
export type StartBulkDeactivationMutationOptions = Apollo.BaseMutationOptions<StartBulkDeactivationMutation, StartBulkDeactivationMutationVariables>;
export const GetClientAdminDocument = gql`
    query GetClientAdmin {
  getClientAdmin {
    id
    client {
      id
      clientType
      paymentsEnabled
    }
    user {
      id
      email
      mobile
    }
    communities {
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useGetClientAdminQuery__
 *
 * To run a query within a React component, call `useGetClientAdminQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientAdminQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientAdminQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientAdminQuery(baseOptions?: Apollo.QueryHookOptions<GetClientAdminQuery, GetClientAdminQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientAdminQuery, GetClientAdminQueryVariables>(GetClientAdminDocument, options);
      }
export function useGetClientAdminLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientAdminQuery, GetClientAdminQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientAdminQuery, GetClientAdminQueryVariables>(GetClientAdminDocument, options);
        }
export type GetClientAdminQueryHookResult = ReturnType<typeof useGetClientAdminQuery>;
export type GetClientAdminLazyQueryHookResult = ReturnType<typeof useGetClientAdminLazyQuery>;
export type GetClientAdminQueryResult = Apollo.QueryResult<GetClientAdminQuery, GetClientAdminQueryVariables>;
export const UpdateClientAdminDocument = gql`
    mutation UpdateClientAdmin($input: UpdateClientAdminInput!) {
  updateClientAdmin(input: $input) {
    clientAdmin {
      id
    }
  }
}
    `;
export type UpdateClientAdminMutationFn = Apollo.MutationFunction<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>;

/**
 * __useUpdateClientAdminMutation__
 *
 * To run a mutation, you first call `useUpdateClientAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientAdminMutation, { data, loading, error }] = useUpdateClientAdminMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>(UpdateClientAdminDocument, options);
      }
export type UpdateClientAdminMutationHookResult = ReturnType<typeof useUpdateClientAdminMutation>;
export type UpdateClientAdminMutationResult = Apollo.MutationResult<UpdateClientAdminMutation>;
export type UpdateClientAdminMutationOptions = Apollo.BaseMutationOptions<UpdateClientAdminMutation, UpdateClientAdminMutationVariables>;
export const ConversationTagDocument = gql`
    query ConversationTag($id: UUID!) {
  conversationTag(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useConversationTagQuery__
 *
 * To run a query within a React component, call `useConversationTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useConversationTagQuery(baseOptions: Apollo.QueryHookOptions<ConversationTagQuery, ConversationTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationTagQuery, ConversationTagQueryVariables>(ConversationTagDocument, options);
      }
export function useConversationTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationTagQuery, ConversationTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationTagQuery, ConversationTagQueryVariables>(ConversationTagDocument, options);
        }
export type ConversationTagQueryHookResult = ReturnType<typeof useConversationTagQuery>;
export type ConversationTagLazyQueryHookResult = ReturnType<typeof useConversationTagLazyQuery>;
export type ConversationTagQueryResult = Apollo.QueryResult<ConversationTagQuery, ConversationTagQueryVariables>;
export const ConversationTagsDocument = gql`
    query ConversationTags {
  conversationTags(deleted: false) {
    edges {
      node {
        id
        name
        client {
          name
        }
      }
    }
  }
}
    `;

/**
 * __useConversationTagsQuery__
 *
 * To run a query within a React component, call `useConversationTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConversationTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConversationTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConversationTagsQuery(baseOptions?: Apollo.QueryHookOptions<ConversationTagsQuery, ConversationTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConversationTagsQuery, ConversationTagsQueryVariables>(ConversationTagsDocument, options);
      }
export function useConversationTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConversationTagsQuery, ConversationTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConversationTagsQuery, ConversationTagsQueryVariables>(ConversationTagsDocument, options);
        }
export type ConversationTagsQueryHookResult = ReturnType<typeof useConversationTagsQuery>;
export type ConversationTagsLazyQueryHookResult = ReturnType<typeof useConversationTagsLazyQuery>;
export type ConversationTagsQueryResult = Apollo.QueryResult<ConversationTagsQuery, ConversationTagsQueryVariables>;
export const CreateConversationTagDocument = gql`
    mutation CreateConversationTag($input: CreateConversationTagInput!) {
  createConversationTag(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateConversationTagMutationFn = Apollo.MutationFunction<CreateConversationTagMutation, CreateConversationTagMutationVariables>;

/**
 * __useCreateConversationTagMutation__
 *
 * To run a mutation, you first call `useCreateConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createConversationTagMutation, { data, loading, error }] = useCreateConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateConversationTagMutation, CreateConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateConversationTagMutation, CreateConversationTagMutationVariables>(CreateConversationTagDocument, options);
      }
export type CreateConversationTagMutationHookResult = ReturnType<typeof useCreateConversationTagMutation>;
export type CreateConversationTagMutationResult = Apollo.MutationResult<CreateConversationTagMutation>;
export type CreateConversationTagMutationOptions = Apollo.BaseMutationOptions<CreateConversationTagMutation, CreateConversationTagMutationVariables>;
export const DeleteConversationTagDocument = gql`
    mutation DeleteConversationTag($input: DeleteConversationTagInput!) {
  deleteConversationTag(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type DeleteConversationTagMutationFn = Apollo.MutationFunction<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>;

/**
 * __useDeleteConversationTagMutation__
 *
 * To run a mutation, you first call `useDeleteConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteConversationTagMutation, { data, loading, error }] = useDeleteConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>(DeleteConversationTagDocument, options);
      }
export type DeleteConversationTagMutationHookResult = ReturnType<typeof useDeleteConversationTagMutation>;
export type DeleteConversationTagMutationResult = Apollo.MutationResult<DeleteConversationTagMutation>;
export type DeleteConversationTagMutationOptions = Apollo.BaseMutationOptions<DeleteConversationTagMutation, DeleteConversationTagMutationVariables>;
export const RemoveConversationTagDocument = gql`
    mutation RemoveConversationTag($input: RemoveConversationTagInput!) {
  removeConversationTag(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type RemoveConversationTagMutationFn = Apollo.MutationFunction<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>;

/**
 * __useRemoveConversationTagMutation__
 *
 * To run a mutation, you first call `useRemoveConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeConversationTagMutation, { data, loading, error }] = useRemoveConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>(RemoveConversationTagDocument, options);
      }
export type RemoveConversationTagMutationHookResult = ReturnType<typeof useRemoveConversationTagMutation>;
export type RemoveConversationTagMutationResult = Apollo.MutationResult<RemoveConversationTagMutation>;
export type RemoveConversationTagMutationOptions = Apollo.BaseMutationOptions<RemoveConversationTagMutation, RemoveConversationTagMutationVariables>;
export const TagConversationDocument = gql`
    mutation TagConversation($input: TagConversationInput!) {
  tagConversation(input: $input) {
    conversationTag {
      id
    }
  }
}
    `;
export type TagConversationMutationFn = Apollo.MutationFunction<TagConversationMutation, TagConversationMutationVariables>;

/**
 * __useTagConversationMutation__
 *
 * To run a mutation, you first call `useTagConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTagConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [tagConversationMutation, { data, loading, error }] = useTagConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTagConversationMutation(baseOptions?: Apollo.MutationHookOptions<TagConversationMutation, TagConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TagConversationMutation, TagConversationMutationVariables>(TagConversationDocument, options);
      }
export type TagConversationMutationHookResult = ReturnType<typeof useTagConversationMutation>;
export type TagConversationMutationResult = Apollo.MutationResult<TagConversationMutation>;
export type TagConversationMutationOptions = Apollo.BaseMutationOptions<TagConversationMutation, TagConversationMutationVariables>;
export const UpdateConversationTagDocument = gql`
    mutation UpdateConversationTag($input: UpdateConversationTagInput!) {
  updateConversationTag(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateConversationTagMutationFn = Apollo.MutationFunction<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>;

/**
 * __useUpdateConversationTagMutation__
 *
 * To run a mutation, you first call `useUpdateConversationTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationTagMutation, { data, loading, error }] = useUpdateConversationTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>(UpdateConversationTagDocument, options);
      }
export type UpdateConversationTagMutationHookResult = ReturnType<typeof useUpdateConversationTagMutation>;
export type UpdateConversationTagMutationResult = Apollo.MutationResult<UpdateConversationTagMutation>;
export type UpdateConversationTagMutationOptions = Apollo.BaseMutationOptions<UpdateConversationTagMutation, UpdateConversationTagMutationVariables>;
export const ClientTagsDocument = gql`
    query ClientTags($after: String, $search: String, $first: Int, $status: [String]) {
  clientTags(after: $after, search: $search, first: $first, status: $status) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ClientTagMinimal
        description
        archivedAt
        createdBy {
          id
          name
          email
        }
        client {
          id
          name
        }
      }
    }
  }
}
    ${ClientTagMinimalFragmentDoc}`;

/**
 * __useClientTagsQuery__
 *
 * To run a query within a React component, call `useClientTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTagsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useClientTagsQuery(baseOptions?: Apollo.QueryHookOptions<ClientTagsQuery, ClientTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTagsQuery, ClientTagsQueryVariables>(ClientTagsDocument, options);
      }
export function useClientTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTagsQuery, ClientTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTagsQuery, ClientTagsQueryVariables>(ClientTagsDocument, options);
        }
export type ClientTagsQueryHookResult = ReturnType<typeof useClientTagsQuery>;
export type ClientTagsLazyQueryHookResult = ReturnType<typeof useClientTagsLazyQuery>;
export type ClientTagsQueryResult = Apollo.QueryResult<ClientTagsQuery, ClientTagsQueryVariables>;
export const ClientTagDocument = gql`
    query ClientTag($id: UUID!) {
  clientTag(id: $id) {
    ...ClientTagItem
  }
}
    ${ClientTagItemFragmentDoc}`;

/**
 * __useClientTagQuery__
 *
 * To run a query within a React component, call `useClientTagQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientTagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientTagQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientTagQuery(baseOptions: Apollo.QueryHookOptions<ClientTagQuery, ClientTagQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientTagQuery, ClientTagQueryVariables>(ClientTagDocument, options);
      }
export function useClientTagLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientTagQuery, ClientTagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientTagQuery, ClientTagQueryVariables>(ClientTagDocument, options);
        }
export type ClientTagQueryHookResult = ReturnType<typeof useClientTagQuery>;
export type ClientTagLazyQueryHookResult = ReturnType<typeof useClientTagLazyQuery>;
export type ClientTagQueryResult = Apollo.QueryResult<ClientTagQuery, ClientTagQueryVariables>;
export const TagConversationsDocument = gql`
    query TagConversations($tagId: UUID!) {
  clientTag(id: $tagId) {
    id
    assignments {
      edges {
        node {
          id
          contentObject {
            ...TaggedConversationItem
          }
        }
      }
    }
  }
}
    ${TaggedConversationItemFragmentDoc}`;

/**
 * __useTagConversationsQuery__
 *
 * To run a query within a React component, call `useTagConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagConversationsQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useTagConversationsQuery(baseOptions: Apollo.QueryHookOptions<TagConversationsQuery, TagConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagConversationsQuery, TagConversationsQueryVariables>(TagConversationsDocument, options);
      }
export function useTagConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagConversationsQuery, TagConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagConversationsQuery, TagConversationsQueryVariables>(TagConversationsDocument, options);
        }
export type TagConversationsQueryHookResult = ReturnType<typeof useTagConversationsQuery>;
export type TagConversationsLazyQueryHookResult = ReturnType<typeof useTagConversationsLazyQuery>;
export type TagConversationsQueryResult = Apollo.QueryResult<TagConversationsQuery, TagConversationsQueryVariables>;
export const TagDocumentsDocument = gql`
    query TagDocuments($tagId: UUID!) {
  clientTag(id: $tagId) {
    id
    assignments {
      edges {
        node {
          id
          contentObject {
            ...TaggedCommunityDocumentItem
            ...TaggedUserDocumentItem
          }
        }
      }
    }
  }
}
    ${TaggedCommunityDocumentItemFragmentDoc}
${TaggedUserDocumentItemFragmentDoc}`;

/**
 * __useTagDocumentsQuery__
 *
 * To run a query within a React component, call `useTagDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagDocumentsQuery({
 *   variables: {
 *      tagId: // value for 'tagId'
 *   },
 * });
 */
export function useTagDocumentsQuery(baseOptions: Apollo.QueryHookOptions<TagDocumentsQuery, TagDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagDocumentsQuery, TagDocumentsQueryVariables>(TagDocumentsDocument, options);
      }
export function useTagDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagDocumentsQuery, TagDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagDocumentsQuery, TagDocumentsQueryVariables>(TagDocumentsDocument, options);
        }
export type TagDocumentsQueryHookResult = ReturnType<typeof useTagDocumentsQuery>;
export type TagDocumentsLazyQueryHookResult = ReturnType<typeof useTagDocumentsLazyQuery>;
export type TagDocumentsQueryResult = Apollo.QueryResult<TagDocumentsQuery, TagDocumentsQueryVariables>;
export const ToggleClientTagArchivedAtDocument = gql`
    mutation ToggleClientTagArchivedAt($input: ToggleClientTagArchivedAtInput!) {
  toggleClientTagArchivedAt(input: $input) {
    clientTag {
      id
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ToggleClientTagArchivedAtMutationFn = Apollo.MutationFunction<ToggleClientTagArchivedAtMutation, ToggleClientTagArchivedAtMutationVariables>;

/**
 * __useToggleClientTagArchivedAtMutation__
 *
 * To run a mutation, you first call `useToggleClientTagArchivedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleClientTagArchivedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleClientTagArchivedAtMutation, { data, loading, error }] = useToggleClientTagArchivedAtMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleClientTagArchivedAtMutation(baseOptions?: Apollo.MutationHookOptions<ToggleClientTagArchivedAtMutation, ToggleClientTagArchivedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleClientTagArchivedAtMutation, ToggleClientTagArchivedAtMutationVariables>(ToggleClientTagArchivedAtDocument, options);
      }
export type ToggleClientTagArchivedAtMutationHookResult = ReturnType<typeof useToggleClientTagArchivedAtMutation>;
export type ToggleClientTagArchivedAtMutationResult = Apollo.MutationResult<ToggleClientTagArchivedAtMutation>;
export type ToggleClientTagArchivedAtMutationOptions = Apollo.BaseMutationOptions<ToggleClientTagArchivedAtMutation, ToggleClientTagArchivedAtMutationVariables>;
export const UpdateClientTagDocument = gql`
    mutation UpdateClientTag($input: UpdateClientTagInput!) {
  updateClientTag(input: $input) {
    clientTag {
      id
      name
      description
      color
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateClientTagMutationFn = Apollo.MutationFunction<UpdateClientTagMutation, UpdateClientTagMutationVariables>;

/**
 * __useUpdateClientTagMutation__
 *
 * To run a mutation, you first call `useUpdateClientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientTagMutation, { data, loading, error }] = useUpdateClientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientTagMutation, UpdateClientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientTagMutation, UpdateClientTagMutationVariables>(UpdateClientTagDocument, options);
      }
export type UpdateClientTagMutationHookResult = ReturnType<typeof useUpdateClientTagMutation>;
export type UpdateClientTagMutationResult = Apollo.MutationResult<UpdateClientTagMutation>;
export type UpdateClientTagMutationOptions = Apollo.BaseMutationOptions<UpdateClientTagMutation, UpdateClientTagMutationVariables>;
export const CreateClientTagDocument = gql`
    mutation CreateClientTag($input: CreateClientTagInput!) {
  createClientTag(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateClientTagMutationFn = Apollo.MutationFunction<CreateClientTagMutation, CreateClientTagMutationVariables>;

/**
 * __useCreateClientTagMutation__
 *
 * To run a mutation, you first call `useCreateClientTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientTagMutation, { data, loading, error }] = useCreateClientTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientTagMutation, CreateClientTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientTagMutation, CreateClientTagMutationVariables>(CreateClientTagDocument, options);
      }
export type CreateClientTagMutationHookResult = ReturnType<typeof useCreateClientTagMutation>;
export type CreateClientTagMutationResult = Apollo.MutationResult<CreateClientTagMutation>;
export type CreateClientTagMutationOptions = Apollo.BaseMutationOptions<CreateClientTagMutation, CreateClientTagMutationVariables>;
export const UpdateClientTagColorDocument = gql`
    mutation UpdateClientTagColor($input: UpdateClientTagColorInput!) {
  updateClientTagColor(input: $input) {
    clientTag {
      id
      color
    }
  }
}
    `;
export type UpdateClientTagColorMutationFn = Apollo.MutationFunction<UpdateClientTagColorMutation, UpdateClientTagColorMutationVariables>;

/**
 * __useUpdateClientTagColorMutation__
 *
 * To run a mutation, you first call `useUpdateClientTagColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientTagColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientTagColorMutation, { data, loading, error }] = useUpdateClientTagColorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientTagColorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientTagColorMutation, UpdateClientTagColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientTagColorMutation, UpdateClientTagColorMutationVariables>(UpdateClientTagColorDocument, options);
      }
export type UpdateClientTagColorMutationHookResult = ReturnType<typeof useUpdateClientTagColorMutation>;
export type UpdateClientTagColorMutationResult = Apollo.MutationResult<UpdateClientTagColorMutation>;
export type UpdateClientTagColorMutationOptions = Apollo.BaseMutationOptions<UpdateClientTagColorMutation, UpdateClientTagColorMutationVariables>;
export const TeamsDocument = gql`
    query Teams($after: String, $first: Int = 15, $status: [String], $communities: [ID!], $search: String, $orderBy: String) {
  teams(
    after: $after
    first: $first
    status: $status
    communities: $communities
    search: $search
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        description
        icon
        communities {
          edges {
            node {
              id
              name
            }
          }
        }
        userCount
        activatedAt
        deactivatedAt
      }
    }
  }
}
    `;

/**
 * __useTeamsQuery__
 *
 * To run a query within a React component, call `useTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      status: // value for 'status'
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTeamsQuery(baseOptions?: Apollo.QueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
      }
export function useTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsQuery, TeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsQuery, TeamsQueryVariables>(TeamsDocument, options);
        }
export type TeamsQueryHookResult = ReturnType<typeof useTeamsQuery>;
export type TeamsLazyQueryHookResult = ReturnType<typeof useTeamsLazyQuery>;
export type TeamsQueryResult = Apollo.QueryResult<TeamsQuery, TeamsQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    team {
      id
      name
      description
      activatedAt
      users {
        id
      }
      communities {
        edges {
          node {
            id
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const CommunitiesTabDocument = gql`
    query CommunitiesTab($orderBy: String, $isManager: Boolean) {
  communities(orderBy: $orderBy, isManager: $isManager, includeDeactivated: true) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        status
        avatar
        homeCount
        residentCount
      }
    }
  }
}
    `;

/**
 * __useCommunitiesTabQuery__
 *
 * To run a query within a React component, call `useCommunitiesTabQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesTabQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesTabQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      isManager: // value for 'isManager'
 *   },
 * });
 */
export function useCommunitiesTabQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesTabQuery, CommunitiesTabQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesTabQuery, CommunitiesTabQueryVariables>(CommunitiesTabDocument, options);
      }
export function useCommunitiesTabLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesTabQuery, CommunitiesTabQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesTabQuery, CommunitiesTabQueryVariables>(CommunitiesTabDocument, options);
        }
export type CommunitiesTabQueryHookResult = ReturnType<typeof useCommunitiesTabQuery>;
export type CommunitiesTabLazyQueryHookResult = ReturnType<typeof useCommunitiesTabLazyQuery>;
export type CommunitiesTabQueryResult = Apollo.QueryResult<CommunitiesTabQuery, CommunitiesTabQueryVariables>;
export const UpdateTeamCommunitiesDocument = gql`
    mutation UpdateTeamCommunities($input: UpdateTeamCommunitiesInput!) {
  updateTeamCommunities(input: $input) {
    team {
      id
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateTeamCommunitiesMutationFn = Apollo.MutationFunction<UpdateTeamCommunitiesMutation, UpdateTeamCommunitiesMutationVariables>;

/**
 * __useUpdateTeamCommunitiesMutation__
 *
 * To run a mutation, you first call `useUpdateTeamCommunitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamCommunitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamCommunitiesMutation, { data, loading, error }] = useUpdateTeamCommunitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamCommunitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamCommunitiesMutation, UpdateTeamCommunitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamCommunitiesMutation, UpdateTeamCommunitiesMutationVariables>(UpdateTeamCommunitiesDocument, options);
      }
export type UpdateTeamCommunitiesMutationHookResult = ReturnType<typeof useUpdateTeamCommunitiesMutation>;
export type UpdateTeamCommunitiesMutationResult = Apollo.MutationResult<UpdateTeamCommunitiesMutation>;
export type UpdateTeamCommunitiesMutationOptions = Apollo.BaseMutationOptions<UpdateTeamCommunitiesMutation, UpdateTeamCommunitiesMutationVariables>;
export const AddOtherMembersModalDocument = gql`
    query AddOtherMembersModal {
  clientStaffMembers {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...MemberItem
      }
    }
  }
}
    ${MemberItemFragmentDoc}`;

/**
 * __useAddOtherMembersModalQuery__
 *
 * To run a query within a React component, call `useAddOtherMembersModalQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddOtherMembersModalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddOtherMembersModalQuery({
 *   variables: {
 *   },
 * });
 */
export function useAddOtherMembersModalQuery(baseOptions?: Apollo.QueryHookOptions<AddOtherMembersModalQuery, AddOtherMembersModalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddOtherMembersModalQuery, AddOtherMembersModalQueryVariables>(AddOtherMembersModalDocument, options);
      }
export function useAddOtherMembersModalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddOtherMembersModalQuery, AddOtherMembersModalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddOtherMembersModalQuery, AddOtherMembersModalQueryVariables>(AddOtherMembersModalDocument, options);
        }
export type AddOtherMembersModalQueryHookResult = ReturnType<typeof useAddOtherMembersModalQuery>;
export type AddOtherMembersModalLazyQueryHookResult = ReturnType<typeof useAddOtherMembersModalLazyQuery>;
export type AddOtherMembersModalQueryResult = Apollo.QueryResult<AddOtherMembersModalQuery, AddOtherMembersModalQueryVariables>;
export const AddTeamMembersDocument = gql`
    mutation AddTeamMembers($input: AddTeamMembersInput!) {
  addTeamMembers(input: $input) {
    team {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type AddTeamMembersMutationFn = Apollo.MutationFunction<AddTeamMembersMutation, AddTeamMembersMutationVariables>;

/**
 * __useAddTeamMembersMutation__
 *
 * To run a mutation, you first call `useAddTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMembersMutation, { data, loading, error }] = useAddTeamMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMembersMutation, AddTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMembersMutation, AddTeamMembersMutationVariables>(AddTeamMembersDocument, options);
      }
export type AddTeamMembersMutationHookResult = ReturnType<typeof useAddTeamMembersMutation>;
export type AddTeamMembersMutationResult = Apollo.MutationResult<AddTeamMembersMutation>;
export type AddTeamMembersMutationOptions = Apollo.BaseMutationOptions<AddTeamMembersMutation, AddTeamMembersMutationVariables>;
export const TeamMemberCandidatesDocument = gql`
    query TeamMemberCandidates {
  clientStaffMembers {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...MemberItem
      }
    }
  }
}
    ${MemberItemFragmentDoc}`;

/**
 * __useTeamMemberCandidatesQuery__
 *
 * To run a query within a React component, call `useTeamMemberCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamMemberCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<TeamMemberCandidatesQuery, TeamMemberCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMemberCandidatesQuery, TeamMemberCandidatesQueryVariables>(TeamMemberCandidatesDocument, options);
      }
export function useTeamMemberCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMemberCandidatesQuery, TeamMemberCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMemberCandidatesQuery, TeamMemberCandidatesQueryVariables>(TeamMemberCandidatesDocument, options);
        }
export type TeamMemberCandidatesQueryHookResult = ReturnType<typeof useTeamMemberCandidatesQuery>;
export type TeamMemberCandidatesLazyQueryHookResult = ReturnType<typeof useTeamMemberCandidatesLazyQuery>;
export type TeamMemberCandidatesQueryResult = Apollo.QueryResult<TeamMemberCandidatesQuery, TeamMemberCandidatesQueryVariables>;
export const RemoveTeamMemberDocument = gql`
    mutation RemoveTeamMember($input: RemoveTeamMemberInput!) {
  removeTeamMember(input: $input) {
    team {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type RemoveTeamMemberMutationFn = Apollo.MutationFunction<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;

/**
 * __useRemoveTeamMemberMutation__
 *
 * To run a mutation, you first call `useRemoveTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTeamMemberMutation, { data, loading, error }] = useRemoveTeamMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>(RemoveTeamMemberDocument, options);
      }
export type RemoveTeamMemberMutationHookResult = ReturnType<typeof useRemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationResult = Apollo.MutationResult<RemoveTeamMemberMutation>;
export type RemoveTeamMemberMutationOptions = Apollo.BaseMutationOptions<RemoveTeamMemberMutation, RemoveTeamMemberMutationVariables>;
export const TeamMembersDocument = gql`
    query TeamMembers {
  clientStaffMembers {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...MemberItem
      }
    }
  }
}
    ${MemberItemFragmentDoc}`;

/**
 * __useTeamMembersQuery__
 *
 * To run a query within a React component, call `useTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
      }
export function useTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMembersQuery, TeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMembersQuery, TeamMembersQueryVariables>(TeamMembersDocument, options);
        }
export type TeamMembersQueryHookResult = ReturnType<typeof useTeamMembersQuery>;
export type TeamMembersLazyQueryHookResult = ReturnType<typeof useTeamMembersLazyQuery>;
export type TeamMembersQueryResult = Apollo.QueryResult<TeamMembersQuery, TeamMembersQueryVariables>;
export const UpdateTeamMembersDocument = gql`
    mutation UpdateTeamMembers($input: UpdateTeamMembersInput!) {
  updateTeamMembers(input: $input) {
    team {
      id
      users {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateTeamMembersMutationFn = Apollo.MutationFunction<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>;

/**
 * __useUpdateTeamMembersMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMembersMutation, { data, loading, error }] = useUpdateTeamMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMembersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>(UpdateTeamMembersDocument, options);
      }
export type UpdateTeamMembersMutationHookResult = ReturnType<typeof useUpdateTeamMembersMutation>;
export type UpdateTeamMembersMutationResult = Apollo.MutationResult<UpdateTeamMembersMutation>;
export type UpdateTeamMembersMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMembersMutation, UpdateTeamMembersMutationVariables>;
export const TeamDocument = gql`
    query Team($id: UUID!) {
  team(id: $id) {
    ...TeamItem
  }
}
    ${TeamItemFragmentDoc}`;

/**
 * __useTeamQuery__
 *
 * To run a query within a React component, call `useTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTeamQuery(baseOptions: Apollo.QueryHookOptions<TeamQuery, TeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
      }
export function useTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamQuery, TeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamQuery, TeamQueryVariables>(TeamDocument, options);
        }
export type TeamQueryHookResult = ReturnType<typeof useTeamQuery>;
export type TeamLazyQueryHookResult = ReturnType<typeof useTeamLazyQuery>;
export type TeamQueryResult = Apollo.QueryResult<TeamQuery, TeamQueryVariables>;
export const ToggleTeamActivatedDocument = gql`
    mutation ToggleTeamActivated($input: ToggleTeamActivatedInput!) {
  toggleTeamActivated(input: $input) {
    team {
      id
      activatedAt
      deactivatedAt
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ToggleTeamActivatedMutationFn = Apollo.MutationFunction<ToggleTeamActivatedMutation, ToggleTeamActivatedMutationVariables>;

/**
 * __useToggleTeamActivatedMutation__
 *
 * To run a mutation, you first call `useToggleTeamActivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleTeamActivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleTeamActivatedMutation, { data, loading, error }] = useToggleTeamActivatedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleTeamActivatedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleTeamActivatedMutation, ToggleTeamActivatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleTeamActivatedMutation, ToggleTeamActivatedMutationVariables>(ToggleTeamActivatedDocument, options);
      }
export type ToggleTeamActivatedMutationHookResult = ReturnType<typeof useToggleTeamActivatedMutation>;
export type ToggleTeamActivatedMutationResult = Apollo.MutationResult<ToggleTeamActivatedMutation>;
export type ToggleTeamActivatedMutationOptions = Apollo.BaseMutationOptions<ToggleTeamActivatedMutation, ToggleTeamActivatedMutationVariables>;
export const UpdateTeamDetailsDocument = gql`
    mutation UpdateTeamDetails($input: UpdateTeamDetailsInput!) {
  updateTeamDetails(input: $input) {
    team {
      id
      name
      description
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateTeamDetailsMutationFn = Apollo.MutationFunction<UpdateTeamDetailsMutation, UpdateTeamDetailsMutationVariables>;

/**
 * __useUpdateTeamDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateTeamDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamDetailsMutation, { data, loading, error }] = useUpdateTeamDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamDetailsMutation, UpdateTeamDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamDetailsMutation, UpdateTeamDetailsMutationVariables>(UpdateTeamDetailsDocument, options);
      }
export type UpdateTeamDetailsMutationHookResult = ReturnType<typeof useUpdateTeamDetailsMutation>;
export type UpdateTeamDetailsMutationResult = Apollo.MutationResult<UpdateTeamDetailsMutation>;
export type UpdateTeamDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateTeamDetailsMutation, UpdateTeamDetailsMutationVariables>;
export const UpdateTeamIconDocument = gql`
    mutation UpdateTeamIcon($input: UpdateTeamIconInput!) {
  updateTeamIcon(input: $input) {
    team {
      id
      icon
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateTeamIconMutationFn = Apollo.MutationFunction<UpdateTeamIconMutation, UpdateTeamIconMutationVariables>;

/**
 * __useUpdateTeamIconMutation__
 *
 * To run a mutation, you first call `useUpdateTeamIconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamIconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamIconMutation, { data, loading, error }] = useUpdateTeamIconMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamIconMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamIconMutation, UpdateTeamIconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamIconMutation, UpdateTeamIconMutationVariables>(UpdateTeamIconDocument, options);
      }
export type UpdateTeamIconMutationHookResult = ReturnType<typeof useUpdateTeamIconMutation>;
export type UpdateTeamIconMutationResult = Apollo.MutationResult<UpdateTeamIconMutation>;
export type UpdateTeamIconMutationOptions = Apollo.BaseMutationOptions<UpdateTeamIconMutation, UpdateTeamIconMutationVariables>;
export const AmenityGroupCommunitiesDocument = gql`
    query AmenityGroupCommunities($ids: [UUID]) {
  communityGroups(ids: $ids) {
    edges {
      node {
        id
        community {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useAmenityGroupCommunitiesQuery__
 *
 * To run a query within a React component, call `useAmenityGroupCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityGroupCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityGroupCommunitiesQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAmenityGroupCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<AmenityGroupCommunitiesQuery, AmenityGroupCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityGroupCommunitiesQuery, AmenityGroupCommunitiesQueryVariables>(AmenityGroupCommunitiesDocument, options);
      }
export function useAmenityGroupCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityGroupCommunitiesQuery, AmenityGroupCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityGroupCommunitiesQuery, AmenityGroupCommunitiesQueryVariables>(AmenityGroupCommunitiesDocument, options);
        }
export type AmenityGroupCommunitiesQueryHookResult = ReturnType<typeof useAmenityGroupCommunitiesQuery>;
export type AmenityGroupCommunitiesLazyQueryHookResult = ReturnType<typeof useAmenityGroupCommunitiesLazyQuery>;
export type AmenityGroupCommunitiesQueryResult = Apollo.QueryResult<AmenityGroupCommunitiesQuery, AmenityGroupCommunitiesQueryVariables>;
export const UpdateAmenityTypeDocument = gql`
    mutation UpdateAmenityType($input: UpdateAmenityTypeInput!) {
  updateAmenityType(input: $input) {
    amenity {
      id
      type
    }
  }
}
    `;
export type UpdateAmenityTypeMutationFn = Apollo.MutationFunction<UpdateAmenityTypeMutation, UpdateAmenityTypeMutationVariables>;

/**
 * __useUpdateAmenityTypeMutation__
 *
 * To run a mutation, you first call `useUpdateAmenityTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmenityTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmenityTypeMutation, { data, loading, error }] = useUpdateAmenityTypeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmenityTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmenityTypeMutation, UpdateAmenityTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmenityTypeMutation, UpdateAmenityTypeMutationVariables>(UpdateAmenityTypeDocument, options);
      }
export type UpdateAmenityTypeMutationHookResult = ReturnType<typeof useUpdateAmenityTypeMutation>;
export type UpdateAmenityTypeMutationResult = Apollo.MutationResult<UpdateAmenityTypeMutation>;
export type UpdateAmenityTypeMutationOptions = Apollo.BaseMutationOptions<UpdateAmenityTypeMutation, UpdateAmenityTypeMutationVariables>;
export const DeleteAmenityDocument = gql`
    mutation DeleteAmenity($input: DeleteAmenityInput!) {
  deleteAmenity(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteAmenityMutationFn = Apollo.MutationFunction<DeleteAmenityMutation, DeleteAmenityMutationVariables>;

/**
 * __useDeleteAmenityMutation__
 *
 * To run a mutation, you first call `useDeleteAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteAmenityMutation, { data, loading, error }] = useDeleteAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteAmenityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteAmenityMutation, DeleteAmenityMutationVariables>(DeleteAmenityDocument, options);
      }
export type DeleteAmenityMutationHookResult = ReturnType<typeof useDeleteAmenityMutation>;
export type DeleteAmenityMutationResult = Apollo.MutationResult<DeleteAmenityMutation>;
export type DeleteAmenityMutationOptions = Apollo.BaseMutationOptions<DeleteAmenityMutation, DeleteAmenityMutationVariables>;
export const AmenityAvailabilityDocument = gql`
    query AmenityAvailability($id: UUID!, $date: Date) {
  amenity(id: $id) {
    id
    daysAvailable
    startTime
    endTime
    reservations(date: $date, cancelled: false) {
      edges {
        node {
          id
          start
          end
        }
      }
    }
    operatingTimes {
      edges {
        node {
          id
          weekDay
          startTime
          endTime
          isActivated
        }
      }
    }
  }
}
    `;

/**
 * __useAmenityAvailabilityQuery__
 *
 * To run a query within a React component, call `useAmenityAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityAvailabilityQuery({
 *   variables: {
 *      id: // value for 'id'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useAmenityAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>(AmenityAvailabilityDocument, options);
      }
export function useAmenityAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>(AmenityAvailabilityDocument, options);
        }
export type AmenityAvailabilityQueryHookResult = ReturnType<typeof useAmenityAvailabilityQuery>;
export type AmenityAvailabilityLazyQueryHookResult = ReturnType<typeof useAmenityAvailabilityLazyQuery>;
export type AmenityAvailabilityQueryResult = Apollo.QueryResult<AmenityAvailabilityQuery, AmenityAvailabilityQueryVariables>;
export const ManagerReserveAmenityDocument = gql`
    mutation ManagerReserveAmenity($input: ManagerReserveAmenityInput!) {
  managerReserveAmenity(input: $input) {
    amenityReservation {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ManagerReserveAmenityMutationFn = Apollo.MutationFunction<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>;

/**
 * __useManagerReserveAmenityMutation__
 *
 * To run a mutation, you first call `useManagerReserveAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerReserveAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerReserveAmenityMutation, { data, loading, error }] = useManagerReserveAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerReserveAmenityMutation(baseOptions?: Apollo.MutationHookOptions<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>(ManagerReserveAmenityDocument, options);
      }
export type ManagerReserveAmenityMutationHookResult = ReturnType<typeof useManagerReserveAmenityMutation>;
export type ManagerReserveAmenityMutationResult = Apollo.MutationResult<ManagerReserveAmenityMutation>;
export type ManagerReserveAmenityMutationOptions = Apollo.BaseMutationOptions<ManagerReserveAmenityMutation, ManagerReserveAmenityMutationVariables>;
export const SaveAmenityDocument = gql`
    mutation SaveAmenity($input: SaveAmenityInput!) {
  saveAmenity(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveAmenityMutationFn = Apollo.MutationFunction<SaveAmenityMutation, SaveAmenityMutationVariables>;

/**
 * __useSaveAmenityMutation__
 *
 * To run a mutation, you first call `useSaveAmenityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAmenityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAmenityMutation, { data, loading, error }] = useSaveAmenityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAmenityMutation(baseOptions?: Apollo.MutationHookOptions<SaveAmenityMutation, SaveAmenityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAmenityMutation, SaveAmenityMutationVariables>(SaveAmenityDocument, options);
      }
export type SaveAmenityMutationHookResult = ReturnType<typeof useSaveAmenityMutation>;
export type SaveAmenityMutationResult = Apollo.MutationResult<SaveAmenityMutation>;
export type SaveAmenityMutationOptions = Apollo.BaseMutationOptions<SaveAmenityMutation, SaveAmenityMutationVariables>;
export const SaveAmenityOperatingTimesDocument = gql`
    mutation SaveAmenityOperatingTimes($input: SaveAmenityOperatingTimesInput!) {
  saveAmenityOperatingTimes(input: $input) {
    amenityOperatingTimes {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveAmenityOperatingTimesMutationFn = Apollo.MutationFunction<SaveAmenityOperatingTimesMutation, SaveAmenityOperatingTimesMutationVariables>;

/**
 * __useSaveAmenityOperatingTimesMutation__
 *
 * To run a mutation, you first call `useSaveAmenityOperatingTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAmenityOperatingTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAmenityOperatingTimesMutation, { data, loading, error }] = useSaveAmenityOperatingTimesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveAmenityOperatingTimesMutation(baseOptions?: Apollo.MutationHookOptions<SaveAmenityOperatingTimesMutation, SaveAmenityOperatingTimesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAmenityOperatingTimesMutation, SaveAmenityOperatingTimesMutationVariables>(SaveAmenityOperatingTimesDocument, options);
      }
export type SaveAmenityOperatingTimesMutationHookResult = ReturnType<typeof useSaveAmenityOperatingTimesMutation>;
export type SaveAmenityOperatingTimesMutationResult = Apollo.MutationResult<SaveAmenityOperatingTimesMutation>;
export type SaveAmenityOperatingTimesMutationOptions = Apollo.BaseMutationOptions<SaveAmenityOperatingTimesMutation, SaveAmenityOperatingTimesMutationVariables>;
export const UpdateAmenityOperatingScheduleDocument = gql`
    mutation UpdateAmenityOperatingSchedule($input: UpdateAmenityOperatingScheduleInput!) {
  updateAmenityOperatingSchedule(input: $input) {
    success
    errors
  }
}
    `;
export type UpdateAmenityOperatingScheduleMutationFn = Apollo.MutationFunction<UpdateAmenityOperatingScheduleMutation, UpdateAmenityOperatingScheduleMutationVariables>;

/**
 * __useUpdateAmenityOperatingScheduleMutation__
 *
 * To run a mutation, you first call `useUpdateAmenityOperatingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAmenityOperatingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAmenityOperatingScheduleMutation, { data, loading, error }] = useUpdateAmenityOperatingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAmenityOperatingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAmenityOperatingScheduleMutation, UpdateAmenityOperatingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAmenityOperatingScheduleMutation, UpdateAmenityOperatingScheduleMutationVariables>(UpdateAmenityOperatingScheduleDocument, options);
      }
export type UpdateAmenityOperatingScheduleMutationHookResult = ReturnType<typeof useUpdateAmenityOperatingScheduleMutation>;
export type UpdateAmenityOperatingScheduleMutationResult = Apollo.MutationResult<UpdateAmenityOperatingScheduleMutation>;
export type UpdateAmenityOperatingScheduleMutationOptions = Apollo.BaseMutationOptions<UpdateAmenityOperatingScheduleMutation, UpdateAmenityOperatingScheduleMutationVariables>;
export const AmenityDocument = gql`
    query Amenity($id: UUID!) {
  amenity(id: $id) {
    id
    name
    startTime
    endTime
    daysAvailable
    description
    image
    reservable
    status
    live
    maxHours
    maxCapacity
    maxAdvanceReservationDays
    minBookingNotice
    maxReservations
    todaysBookingCount
    archivedAt
    startDate
    maxTime
    minTime
    minReservationDuration
    maxReservationDuration
    type
    exclusive
    links
    operatingTimes {
      edges {
        node {
          id
          weekDay
          startTime
          endTime
          isActivated
        }
      }
    }
    groups {
      edges {
        node {
          id
          name
          community {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAmenityQuery__
 *
 * To run a query within a React component, call `useAmenityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmenityQuery(baseOptions: Apollo.QueryHookOptions<AmenityQuery, AmenityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityQuery, AmenityQueryVariables>(AmenityDocument, options);
      }
export function useAmenityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityQuery, AmenityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityQuery, AmenityQueryVariables>(AmenityDocument, options);
        }
export type AmenityQueryHookResult = ReturnType<typeof useAmenityQuery>;
export type AmenityLazyQueryHookResult = ReturnType<typeof useAmenityLazyQuery>;
export type AmenityQueryResult = Apollo.QueryResult<AmenityQuery, AmenityQueryVariables>;
export const AmenityReservationsDocument = gql`
    query AmenityReservations($amenity: UUID!, $fromDate: Date, $toDate: Date, $after: String) {
  amenityReservations(
    amenity: $amenity
    fromDate: $fromDate
    toDate: $toDate
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...AmenityReservationItem
      }
    }
  }
}
    ${AmenityReservationItemFragmentDoc}`;

/**
 * __useAmenityReservationsQuery__
 *
 * To run a query within a React component, call `useAmenityReservationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityReservationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityReservationsQuery({
 *   variables: {
 *      amenity: // value for 'amenity'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAmenityReservationsQuery(baseOptions: Apollo.QueryHookOptions<AmenityReservationsQuery, AmenityReservationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityReservationsQuery, AmenityReservationsQueryVariables>(AmenityReservationsDocument, options);
      }
export function useAmenityReservationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityReservationsQuery, AmenityReservationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityReservationsQuery, AmenityReservationsQueryVariables>(AmenityReservationsDocument, options);
        }
export type AmenityReservationsQueryHookResult = ReturnType<typeof useAmenityReservationsQuery>;
export type AmenityReservationsLazyQueryHookResult = ReturnType<typeof useAmenityReservationsLazyQuery>;
export type AmenityReservationsQueryResult = Apollo.QueryResult<AmenityReservationsQuery, AmenityReservationsQueryVariables>;
export const AmenityReservationDocument = gql`
    query AmenityReservation($id: UUID!) {
  amenityReservation(id: $id) {
    id
    start
    end
    cancellationMessage
    user {
      id
      name
    }
  }
}
    `;

/**
 * __useAmenityReservationQuery__
 *
 * To run a query within a React component, call `useAmenityReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenityReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenityReservationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAmenityReservationQuery(baseOptions: Apollo.QueryHookOptions<AmenityReservationQuery, AmenityReservationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenityReservationQuery, AmenityReservationQueryVariables>(AmenityReservationDocument, options);
      }
export function useAmenityReservationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenityReservationQuery, AmenityReservationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenityReservationQuery, AmenityReservationQueryVariables>(AmenityReservationDocument, options);
        }
export type AmenityReservationQueryHookResult = ReturnType<typeof useAmenityReservationQuery>;
export type AmenityReservationLazyQueryHookResult = ReturnType<typeof useAmenityReservationLazyQuery>;
export type AmenityReservationQueryResult = Apollo.QueryResult<AmenityReservationQuery, AmenityReservationQueryVariables>;
export const ManagerCancelAmenityReservationDocument = gql`
    mutation ManagerCancelAmenityReservation($input: ManagerCancelAmenityReservationInput!) {
  managerCancelAmenityReservation(input: $input) {
    amenityReservation {
      id
      cancellationMessage
    }
  }
}
    `;
export type ManagerCancelAmenityReservationMutationFn = Apollo.MutationFunction<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>;

/**
 * __useManagerCancelAmenityReservationMutation__
 *
 * To run a mutation, you first call `useManagerCancelAmenityReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerCancelAmenityReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerCancelAmenityReservationMutation, { data, loading, error }] = useManagerCancelAmenityReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerCancelAmenityReservationMutation(baseOptions?: Apollo.MutationHookOptions<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>(ManagerCancelAmenityReservationDocument, options);
      }
export type ManagerCancelAmenityReservationMutationHookResult = ReturnType<typeof useManagerCancelAmenityReservationMutation>;
export type ManagerCancelAmenityReservationMutationResult = Apollo.MutationResult<ManagerCancelAmenityReservationMutation>;
export type ManagerCancelAmenityReservationMutationOptions = Apollo.BaseMutationOptions<ManagerCancelAmenityReservationMutation, ManagerCancelAmenityReservationMutationVariables>;
export const AmenitiesDocument = gql`
    query Amenities($communities: [ID!], $after: String, $search: String, $orderBy: String, $status: [String]) {
  amenities(
    communities: $communities
    after: $after
    type: ["FACILITY"]
    search: $search
    orderBy: $orderBy
    status: $status
  ) {
    edges {
      node {
        ...AmenityItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${AmenityItemFragmentDoc}`;

/**
 * __useAmenitiesQuery__
 *
 * To run a query within a React component, call `useAmenitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmenitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmenitiesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAmenitiesQuery(baseOptions?: Apollo.QueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
      }
export function useAmenitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmenitiesQuery, AmenitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmenitiesQuery, AmenitiesQueryVariables>(AmenitiesDocument, options);
        }
export type AmenitiesQueryHookResult = ReturnType<typeof useAmenitiesQuery>;
export type AmenitiesLazyQueryHookResult = ReturnType<typeof useAmenitiesLazyQuery>;
export type AmenitiesQueryResult = Apollo.QueryResult<AmenitiesQuery, AmenitiesQueryVariables>;
export const AcceptApplicationDocument = gql`
    mutation AcceptApplication($application: UUID!, $home: UUID) {
  acceptApplication(application: $application, home: $home) {
    application {
      id
      status
      approvedAt
    }
  }
}
    `;
export type AcceptApplicationMutationFn = Apollo.MutationFunction<AcceptApplicationMutation, AcceptApplicationMutationVariables>;

/**
 * __useAcceptApplicationMutation__
 *
 * To run a mutation, you first call `useAcceptApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptApplicationMutation, { data, loading, error }] = useAcceptApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *      home: // value for 'home'
 *   },
 * });
 */
export function useAcceptApplicationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptApplicationMutation, AcceptApplicationMutationVariables>(AcceptApplicationDocument, options);
      }
export type AcceptApplicationMutationHookResult = ReturnType<typeof useAcceptApplicationMutation>;
export type AcceptApplicationMutationResult = Apollo.MutationResult<AcceptApplicationMutation>;
export type AcceptApplicationMutationOptions = Apollo.BaseMutationOptions<AcceptApplicationMutation, AcceptApplicationMutationVariables>;
export const RejectApplicationDocument = gql`
    mutation RejectApplication($application: UUID!, $rejectionReason: String!) {
  rejectApplication(application: $application, rejectionReason: $rejectionReason) {
    application {
      id
      status
      lastRejectionReason
    }
  }
}
    `;
export type RejectApplicationMutationFn = Apollo.MutationFunction<RejectApplicationMutation, RejectApplicationMutationVariables>;

/**
 * __useRejectApplicationMutation__
 *
 * To run a mutation, you first call `useRejectApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectApplicationMutation, { data, loading, error }] = useRejectApplicationMutation({
 *   variables: {
 *      application: // value for 'application'
 *      rejectionReason: // value for 'rejectionReason'
 *   },
 * });
 */
export function useRejectApplicationMutation(baseOptions?: Apollo.MutationHookOptions<RejectApplicationMutation, RejectApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectApplicationMutation, RejectApplicationMutationVariables>(RejectApplicationDocument, options);
      }
export type RejectApplicationMutationHookResult = ReturnType<typeof useRejectApplicationMutation>;
export type RejectApplicationMutationResult = Apollo.MutationResult<RejectApplicationMutation>;
export type RejectApplicationMutationOptions = Apollo.BaseMutationOptions<RejectApplicationMutation, RejectApplicationMutationVariables>;
export const RemindApplicantDocument = gql`
    mutation RemindApplicant($application: UUID!) {
  remindApplicant(application: $application) {
    application {
      id
    }
  }
}
    `;
export type RemindApplicantMutationFn = Apollo.MutationFunction<RemindApplicantMutation, RemindApplicantMutationVariables>;

/**
 * __useRemindApplicantMutation__
 *
 * To run a mutation, you first call `useRemindApplicantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindApplicantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindApplicantMutation, { data, loading, error }] = useRemindApplicantMutation({
 *   variables: {
 *      application: // value for 'application'
 *   },
 * });
 */
export function useRemindApplicantMutation(baseOptions?: Apollo.MutationHookOptions<RemindApplicantMutation, RemindApplicantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindApplicantMutation, RemindApplicantMutationVariables>(RemindApplicantDocument, options);
      }
export type RemindApplicantMutationHookResult = ReturnType<typeof useRemindApplicantMutation>;
export type RemindApplicantMutationResult = Apollo.MutationResult<RemindApplicantMutation>;
export type RemindApplicantMutationOptions = Apollo.BaseMutationOptions<RemindApplicantMutation, RemindApplicantMutationVariables>;
export const ManagerAddApplicationHomeDocument = gql`
    mutation ManagerAddApplicationHome($input: ManagerAddApplicationHomeInput!) {
  managerAddApplicationHome(input: $input) {
    application {
      id
      status
      home {
        id
        name
        postcode
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ManagerAddApplicationHomeMutationFn = Apollo.MutationFunction<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>;

/**
 * __useManagerAddApplicationHomeMutation__
 *
 * To run a mutation, you first call `useManagerAddApplicationHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useManagerAddApplicationHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [managerAddApplicationHomeMutation, { data, loading, error }] = useManagerAddApplicationHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useManagerAddApplicationHomeMutation(baseOptions?: Apollo.MutationHookOptions<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>(ManagerAddApplicationHomeDocument, options);
      }
export type ManagerAddApplicationHomeMutationHookResult = ReturnType<typeof useManagerAddApplicationHomeMutation>;
export type ManagerAddApplicationHomeMutationResult = Apollo.MutationResult<ManagerAddApplicationHomeMutation>;
export type ManagerAddApplicationHomeMutationOptions = Apollo.BaseMutationOptions<ManagerAddApplicationHomeMutation, ManagerAddApplicationHomeMutationVariables>;
export const SearchHomesDocument = gql`
    query SearchHomes($communityId: UUID, $search: String) {
  listHomes(communityId: $communityId, search: $search) {
    id
    name
    addressLine1
  }
}
    `;

/**
 * __useSearchHomesQuery__
 *
 * To run a query within a React component, call `useSearchHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchHomesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchHomesQuery(baseOptions?: Apollo.QueryHookOptions<SearchHomesQuery, SearchHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchHomesQuery, SearchHomesQueryVariables>(SearchHomesDocument, options);
      }
export function useSearchHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchHomesQuery, SearchHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchHomesQuery, SearchHomesQueryVariables>(SearchHomesDocument, options);
        }
export type SearchHomesQueryHookResult = ReturnType<typeof useSearchHomesQuery>;
export type SearchHomesLazyQueryHookResult = ReturnType<typeof useSearchHomesLazyQuery>;
export type SearchHomesQueryResult = Apollo.QueryResult<SearchHomesQuery, SearchHomesQueryVariables>;
export const RemindAllApplicantsDocument = gql`
    mutation RemindAllApplicants($communities: [UUID]!) {
  remindAllApplicants(communities: $communities) {
    ok
  }
}
    `;
export type RemindAllApplicantsMutationFn = Apollo.MutationFunction<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>;

/**
 * __useRemindAllApplicantsMutation__
 *
 * To run a mutation, you first call `useRemindAllApplicantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindAllApplicantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindAllApplicantsMutation, { data, loading, error }] = useRemindAllApplicantsMutation({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useRemindAllApplicantsMutation(baseOptions?: Apollo.MutationHookOptions<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>(RemindAllApplicantsDocument, options);
      }
export type RemindAllApplicantsMutationHookResult = ReturnType<typeof useRemindAllApplicantsMutation>;
export type RemindAllApplicantsMutationResult = Apollo.MutationResult<RemindAllApplicantsMutation>;
export type RemindAllApplicantsMutationOptions = Apollo.BaseMutationOptions<RemindAllApplicantsMutation, RemindAllApplicantsMutationVariables>;
export const ApplicationsDocument = gql`
    query Applications($after: String, $communities: [ID], $search: String, $orderBy: String, $status: [String], $dateFrom: Date, $dateTo: Date) {
  applications(
    after: $after
    communities: $communities
    search: $search
    orderBy: $orderBy
    status: $status
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ApplicationItem
      }
    }
  }
}
    ${ApplicationItemFragmentDoc}`;

/**
 * __useApplicationsQuery__
 *
 * To run a query within a React component, call `useApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
      }
export function useApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationsQuery, ApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationsQuery, ApplicationsQueryVariables>(ApplicationsDocument, options);
        }
export type ApplicationsQueryHookResult = ReturnType<typeof useApplicationsQuery>;
export type ApplicationsLazyQueryHookResult = ReturnType<typeof useApplicationsLazyQuery>;
export type ApplicationsQueryResult = Apollo.QueryResult<ApplicationsQuery, ApplicationsQueryVariables>;
export const ApplicantDocumentsDocument = gql`
    query ApplicantDocuments($id: UUID!) {
  applicant(id: $id) {
    ...ApplicantDocuments
  }
}
    ${ApplicantDocumentsFragmentDoc}`;

/**
 * __useApplicantDocumentsQuery__
 *
 * To run a query within a React component, call `useApplicantDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicantDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicantDocumentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicantDocumentsQuery(baseOptions: Apollo.QueryHookOptions<ApplicantDocumentsQuery, ApplicantDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicantDocumentsQuery, ApplicantDocumentsQueryVariables>(ApplicantDocumentsDocument, options);
      }
export function useApplicantDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicantDocumentsQuery, ApplicantDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicantDocumentsQuery, ApplicantDocumentsQueryVariables>(ApplicantDocumentsDocument, options);
        }
export type ApplicantDocumentsQueryHookResult = ReturnType<typeof useApplicantDocumentsQuery>;
export type ApplicantDocumentsLazyQueryHookResult = ReturnType<typeof useApplicantDocumentsLazyQuery>;
export type ApplicantDocumentsQueryResult = Apollo.QueryResult<ApplicantDocumentsQuery, ApplicantDocumentsQueryVariables>;
export const ApplicationDocument = gql`
    query Application($id: UUID!, $after: String) {
  application(id: $id) {
    ...Application
  }
}
    ${ApplicationFragmentDoc}`;

/**
 * __useApplicationQuery__
 *
 * To run a query within a React component, call `useApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useApplicationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationQuery, ApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options);
      }
export function useApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationQuery, ApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationQuery, ApplicationQueryVariables>(ApplicationDocument, options);
        }
export type ApplicationQueryHookResult = ReturnType<typeof useApplicationQuery>;
export type ApplicationLazyQueryHookResult = ReturnType<typeof useApplicationLazyQuery>;
export type ApplicationQueryResult = Apollo.QueryResult<ApplicationQuery, ApplicationQueryVariables>;
export const ApplicationAuditLogsDocument = gql`
    query ApplicationAuditLogs($id: UUID!) {
  application(id: $id) {
    id
    auditLogs(orderBy: "created_at") {
      edges {
        node {
          ...ApplicationAuditLogEntry
        }
      }
    }
  }
}
    ${ApplicationAuditLogEntryFragmentDoc}`;

/**
 * __useApplicationAuditLogsQuery__
 *
 * To run a query within a React component, call `useApplicationAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationAuditLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationAuditLogsQuery, ApplicationAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationAuditLogsQuery, ApplicationAuditLogsQueryVariables>(ApplicationAuditLogsDocument, options);
      }
export function useApplicationAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationAuditLogsQuery, ApplicationAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationAuditLogsQuery, ApplicationAuditLogsQueryVariables>(ApplicationAuditLogsDocument, options);
        }
export type ApplicationAuditLogsQueryHookResult = ReturnType<typeof useApplicationAuditLogsQuery>;
export type ApplicationAuditLogsLazyQueryHookResult = ReturnType<typeof useApplicationAuditLogsLazyQuery>;
export type ApplicationAuditLogsQueryResult = Apollo.QueryResult<ApplicationAuditLogsQuery, ApplicationAuditLogsQueryVariables>;
export const ApplicationThreadByApplicationDocument = gql`
    query ApplicationThreadByApplication($applicationId: UUID!, $first: Int, $after: String, $mediaAfter: String) {
  applicationThreadByApplication(applicationId: $applicationId) {
    id
    createdAt
    closedAt
    messages(first: $first, after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...ApplicationThreadMessage
        }
      }
    }
    media(after: $mediaAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...ApplicationThreadMedia
        }
      }
    }
  }
}
    ${ApplicationThreadMessageFragmentDoc}
${ApplicationThreadMediaFragmentDoc}`;

/**
 * __useApplicationThreadByApplicationQuery__
 *
 * To run a query within a React component, call `useApplicationThreadByApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationThreadByApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationThreadByApplicationQuery({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      mediaAfter: // value for 'mediaAfter'
 *   },
 * });
 */
export function useApplicationThreadByApplicationQuery(baseOptions: Apollo.QueryHookOptions<ApplicationThreadByApplicationQuery, ApplicationThreadByApplicationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationThreadByApplicationQuery, ApplicationThreadByApplicationQueryVariables>(ApplicationThreadByApplicationDocument, options);
      }
export function useApplicationThreadByApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationThreadByApplicationQuery, ApplicationThreadByApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationThreadByApplicationQuery, ApplicationThreadByApplicationQueryVariables>(ApplicationThreadByApplicationDocument, options);
        }
export type ApplicationThreadByApplicationQueryHookResult = ReturnType<typeof useApplicationThreadByApplicationQuery>;
export type ApplicationThreadByApplicationLazyQueryHookResult = ReturnType<typeof useApplicationThreadByApplicationLazyQuery>;
export type ApplicationThreadByApplicationQueryResult = Apollo.QueryResult<ApplicationThreadByApplicationQuery, ApplicationThreadByApplicationQueryVariables>;
export const ArchiveApplicationDocument = gql`
    mutation ArchiveApplication($input: ArchiveApplicationInput!) {
  archiveApplication(input: $input) {
    application {
      id
      status
      archivedAt
    }
  }
}
    `;
export type ArchiveApplicationMutationFn = Apollo.MutationFunction<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>;

/**
 * __useArchiveApplicationMutation__
 *
 * To run a mutation, you first call `useArchiveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveApplicationMutation, { data, loading, error }] = useArchiveApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>(ArchiveApplicationDocument, options);
      }
export type ArchiveApplicationMutationHookResult = ReturnType<typeof useArchiveApplicationMutation>;
export type ArchiveApplicationMutationResult = Apollo.MutationResult<ArchiveApplicationMutation>;
export type ArchiveApplicationMutationOptions = Apollo.BaseMutationOptions<ArchiveApplicationMutation, ArchiveApplicationMutationVariables>;
export const CreateApplicationThreadDocument = gql`
    mutation CreateApplicationThread($input: CreateApplicationThreadMutationInput!) {
  createApplicationThread(input: $input) {
    applicationThread {
      id
      createdAt
      messages {
        edges {
          node {
            id
            body
            sender
            createdAt
          }
        }
      }
    }
  }
}
    `;
export type CreateApplicationThreadMutationFn = Apollo.MutationFunction<CreateApplicationThreadMutation, CreateApplicationThreadMutationVariables>;

/**
 * __useCreateApplicationThreadMutation__
 *
 * To run a mutation, you first call `useCreateApplicationThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicationThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicationThreadMutation, { data, loading, error }] = useCreateApplicationThreadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicationThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicationThreadMutation, CreateApplicationThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicationThreadMutation, CreateApplicationThreadMutationVariables>(CreateApplicationThreadDocument, options);
      }
export type CreateApplicationThreadMutationHookResult = ReturnType<typeof useCreateApplicationThreadMutation>;
export type CreateApplicationThreadMutationResult = Apollo.MutationResult<CreateApplicationThreadMutation>;
export type CreateApplicationThreadMutationOptions = Apollo.BaseMutationOptions<CreateApplicationThreadMutation, CreateApplicationThreadMutationVariables>;
export const MarkApplicationThreadAsReadDocument = gql`
    mutation MarkApplicationThreadAsRead($input: MarkApplicationThreadAsReadInput!) {
  markApplicationThreadAsRead(input: $input) {
    applicationThread {
      id
      unreadCount
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MarkApplicationThreadAsReadMutationFn = Apollo.MutationFunction<MarkApplicationThreadAsReadMutation, MarkApplicationThreadAsReadMutationVariables>;

/**
 * __useMarkApplicationThreadAsReadMutation__
 *
 * To run a mutation, you first call `useMarkApplicationThreadAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkApplicationThreadAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markApplicationThreadAsReadMutation, { data, loading, error }] = useMarkApplicationThreadAsReadMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkApplicationThreadAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkApplicationThreadAsReadMutation, MarkApplicationThreadAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkApplicationThreadAsReadMutation, MarkApplicationThreadAsReadMutationVariables>(MarkApplicationThreadAsReadDocument, options);
      }
export type MarkApplicationThreadAsReadMutationHookResult = ReturnType<typeof useMarkApplicationThreadAsReadMutation>;
export type MarkApplicationThreadAsReadMutationResult = Apollo.MutationResult<MarkApplicationThreadAsReadMutation>;
export type MarkApplicationThreadAsReadMutationOptions = Apollo.BaseMutationOptions<MarkApplicationThreadAsReadMutation, MarkApplicationThreadAsReadMutationVariables>;
export const SendApplicationThreadMessageDocument = gql`
    mutation SendApplicationThreadMessage($input: SendApplicationThreadMessageInput!) {
  sendApplicationThreadMessage(input: $input) {
    applicationThreadMessage {
      id
      body
      sender
      createdAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SendApplicationThreadMessageMutationFn = Apollo.MutationFunction<SendApplicationThreadMessageMutation, SendApplicationThreadMessageMutationVariables>;

/**
 * __useSendApplicationThreadMessageMutation__
 *
 * To run a mutation, you first call `useSendApplicationThreadMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendApplicationThreadMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendApplicationThreadMessageMutation, { data, loading, error }] = useSendApplicationThreadMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendApplicationThreadMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendApplicationThreadMessageMutation, SendApplicationThreadMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendApplicationThreadMessageMutation, SendApplicationThreadMessageMutationVariables>(SendApplicationThreadMessageDocument, options);
      }
export type SendApplicationThreadMessageMutationHookResult = ReturnType<typeof useSendApplicationThreadMessageMutation>;
export type SendApplicationThreadMessageMutationResult = Apollo.MutationResult<SendApplicationThreadMessageMutation>;
export type SendApplicationThreadMessageMutationOptions = Apollo.BaseMutationOptions<SendApplicationThreadMessageMutation, SendApplicationThreadMessageMutationVariables>;
export const UnarchiveApplicationDocument = gql`
    mutation UnarchiveApplication($input: UnarchiveApplicationInput!) {
  unarchiveApplication(input: $input) {
    application {
      id
      status
      archivedAt
    }
  }
}
    `;
export type UnarchiveApplicationMutationFn = Apollo.MutationFunction<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>;

/**
 * __useUnarchiveApplicationMutation__
 *
 * To run a mutation, you first call `useUnarchiveApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveApplicationMutation, { data, loading, error }] = useUnarchiveApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveApplicationMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>(UnarchiveApplicationDocument, options);
      }
export type UnarchiveApplicationMutationHookResult = ReturnType<typeof useUnarchiveApplicationMutation>;
export type UnarchiveApplicationMutationResult = Apollo.MutationResult<UnarchiveApplicationMutation>;
export type UnarchiveApplicationMutationOptions = Apollo.BaseMutationOptions<UnarchiveApplicationMutation, UnarchiveApplicationMutationVariables>;
export const AppointmentsDocument = gql`
    query Appointments($communities: [ID!], $after: String, $search: String, $orderBy: String, $status: [String]) {
  amenities(
    communities: $communities
    after: $after
    type: ["APPOINTMENT"]
    search: $search
    orderBy: $orderBy
    status: $status
  ) {
    edges {
      node {
        ...AmenityItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${AmenityItemFragmentDoc}`;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
      }
export function useAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
        }
export type AppointmentsQueryHookResult = ReturnType<typeof useAppointmentsQuery>;
export type AppointmentsLazyQueryHookResult = ReturnType<typeof useAppointmentsLazyQuery>;
export type AppointmentsQueryResult = Apollo.QueryResult<AppointmentsQuery, AppointmentsQueryVariables>;
export const CreateBlocksDocument = gql`
    mutation CreateBlocks($communityId: UUID!, $blockNames: [String]!) {
  createBlocks(communityId: $communityId, blockNames: $blockNames) {
    blocks {
      id
      name
    }
  }
}
    `;
export type CreateBlocksMutationFn = Apollo.MutationFunction<CreateBlocksMutation, CreateBlocksMutationVariables>;

/**
 * __useCreateBlocksMutation__
 *
 * To run a mutation, you first call `useCreateBlocksMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocksMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocksMutation, { data, loading, error }] = useCreateBlocksMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      blockNames: // value for 'blockNames'
 *   },
 * });
 */
export function useCreateBlocksMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlocksMutation, CreateBlocksMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlocksMutation, CreateBlocksMutationVariables>(CreateBlocksDocument, options);
      }
export type CreateBlocksMutationHookResult = ReturnType<typeof useCreateBlocksMutation>;
export type CreateBlocksMutationResult = Apollo.MutationResult<CreateBlocksMutation>;
export type CreateBlocksMutationOptions = Apollo.BaseMutationOptions<CreateBlocksMutation, CreateBlocksMutationVariables>;
export const BlockListDocument = gql`
    query BlockList($communities: [ID!], $after: String, $search: String, $orderBy: String) {
  blocks(
    first: 20
    communities: $communities
    after: $after
    search: $search
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...BlockListItem
      }
    }
  }
}
    ${BlockListItemFragmentDoc}`;

/**
 * __useBlockListQuery__
 *
 * To run a query within a React component, call `useBlockListQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockListQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useBlockListQuery(baseOptions?: Apollo.QueryHookOptions<BlockListQuery, BlockListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockListQuery, BlockListQueryVariables>(BlockListDocument, options);
      }
export function useBlockListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockListQuery, BlockListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockListQuery, BlockListQueryVariables>(BlockListDocument, options);
        }
export type BlockListQueryHookResult = ReturnType<typeof useBlockListQuery>;
export type BlockListLazyQueryHookResult = ReturnType<typeof useBlockListLazyQuery>;
export type BlockListQueryResult = Apollo.QueryResult<BlockListQuery, BlockListQueryVariables>;
export const BlocksDocument = gql`
    query Blocks($communities: [ID!], $after: String, $search: String, $orderBy: String, $first: Int) {
  blocks(
    communities: $communities
    after: $after
    search: $search
    orderBy: $orderBy
    first: $first
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...BlockItem
      }
    }
  }
}
    ${BlockItemFragmentDoc}`;

/**
 * __useBlocksQuery__
 *
 * To run a query within a React component, call `useBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlocksQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useBlocksQuery(baseOptions?: Apollo.QueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
      }
export function useBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlocksQuery, BlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlocksQuery, BlocksQueryVariables>(BlocksDocument, options);
        }
export type BlocksQueryHookResult = ReturnType<typeof useBlocksQuery>;
export type BlocksLazyQueryHookResult = ReturnType<typeof useBlocksLazyQuery>;
export type BlocksQueryResult = Apollo.QueryResult<BlocksQuery, BlocksQueryVariables>;
export const ConfirmBlockSetupDocument = gql`
    mutation ConfirmBlockSetup($communityId: ID!, $runId: ID!) {
  confirmBlockSetup(communityId: $communityId, runId: $runId) {
    community {
      ...PendingBlockSetupCommunity
    }
    errors {
      field
      messages
    }
  }
}
    ${PendingBlockSetupCommunityFragmentDoc}`;
export type ConfirmBlockSetupMutationFn = Apollo.MutationFunction<ConfirmBlockSetupMutation, ConfirmBlockSetupMutationVariables>;

/**
 * __useConfirmBlockSetupMutation__
 *
 * To run a mutation, you first call `useConfirmBlockSetupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBlockSetupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBlockSetupMutation, { data, loading, error }] = useConfirmBlockSetupMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      runId: // value for 'runId'
 *   },
 * });
 */
export function useConfirmBlockSetupMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmBlockSetupMutation, ConfirmBlockSetupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmBlockSetupMutation, ConfirmBlockSetupMutationVariables>(ConfirmBlockSetupDocument, options);
      }
export type ConfirmBlockSetupMutationHookResult = ReturnType<typeof useConfirmBlockSetupMutation>;
export type ConfirmBlockSetupMutationResult = Apollo.MutationResult<ConfirmBlockSetupMutation>;
export type ConfirmBlockSetupMutationOptions = Apollo.BaseMutationOptions<ConfirmBlockSetupMutation, ConfirmBlockSetupMutationVariables>;
export const PendingBlockSetupsDocument = gql`
    query PendingBlockSetups($communities: [ID!]) {
  communities(ids: $communities, orderBy: "name") {
    edges {
      node {
        ...PendingBlockSetupCommunity
      }
    }
  }
}
    ${PendingBlockSetupCommunityFragmentDoc}`;

/**
 * __usePendingBlockSetupsQuery__
 *
 * To run a query within a React component, call `usePendingBlockSetupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePendingBlockSetupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePendingBlockSetupsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function usePendingBlockSetupsQuery(baseOptions?: Apollo.QueryHookOptions<PendingBlockSetupsQuery, PendingBlockSetupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PendingBlockSetupsQuery, PendingBlockSetupsQueryVariables>(PendingBlockSetupsDocument, options);
      }
export function usePendingBlockSetupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PendingBlockSetupsQuery, PendingBlockSetupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PendingBlockSetupsQuery, PendingBlockSetupsQueryVariables>(PendingBlockSetupsDocument, options);
        }
export type PendingBlockSetupsQueryHookResult = ReturnType<typeof usePendingBlockSetupsQuery>;
export type PendingBlockSetupsLazyQueryHookResult = ReturnType<typeof usePendingBlockSetupsLazyQuery>;
export type PendingBlockSetupsQueryResult = Apollo.QueryResult<PendingBlockSetupsQuery, PendingBlockSetupsQueryVariables>;
export const BlockDocument = gql`
    query Block($id: UUID!) {
  block(id: $id) {
    ...BlockDetail
  }
}
    ${BlockDetailFragmentDoc}`;

/**
 * __useBlockQuery__
 *
 * To run a query within a React component, call `useBlockQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockQuery(baseOptions: Apollo.QueryHookOptions<BlockQuery, BlockQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
      }
export function useBlockLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockQuery, BlockQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockQuery, BlockQueryVariables>(BlockDocument, options);
        }
export type BlockQueryHookResult = ReturnType<typeof useBlockQuery>;
export type BlockLazyQueryHookResult = ReturnType<typeof useBlockLazyQuery>;
export type BlockQueryResult = Apollo.QueryResult<BlockQuery, BlockQueryVariables>;
export const BlockAssignSourcesDocument = gql`
    query BlockAssignSources($communities: [ID], $after: String) {
  blocks(communities: $communities, after: $after, orderBy: "name") {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        isDefault
        homesCount
      }
    }
  }
}
    `;

/**
 * __useBlockAssignSourcesQuery__
 *
 * To run a query within a React component, call `useBlockAssignSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockAssignSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockAssignSourcesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlockAssignSourcesQuery(baseOptions?: Apollo.QueryHookOptions<BlockAssignSourcesQuery, BlockAssignSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockAssignSourcesQuery, BlockAssignSourcesQueryVariables>(BlockAssignSourcesDocument, options);
      }
export function useBlockAssignSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockAssignSourcesQuery, BlockAssignSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockAssignSourcesQuery, BlockAssignSourcesQueryVariables>(BlockAssignSourcesDocument, options);
        }
export type BlockAssignSourcesQueryHookResult = ReturnType<typeof useBlockAssignSourcesQuery>;
export type BlockAssignSourcesLazyQueryHookResult = ReturnType<typeof useBlockAssignSourcesLazyQuery>;
export type BlockAssignSourcesQueryResult = Apollo.QueryResult<BlockAssignSourcesQuery, BlockAssignSourcesQueryVariables>;
export const BlockHomesDocument = gql`
    query BlockHomes($after: String, $communities: [ID], $block: UUID, $hasBlock: Boolean, $icontainsSearch: String) {
  homes(
    after: $after
    communities: $communities
    block: $block
    hasBlock: $hasBlock
    icontainsSearch: $icontainsSearch
    includeDemoHomes: false
    orderBy: "number_in_address"
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...BlockHomeRow
      }
    }
  }
}
    ${BlockHomeRowFragmentDoc}`;

/**
 * __useBlockHomesQuery__
 *
 * To run a query within a React component, call `useBlockHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockHomesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      block: // value for 'block'
 *      hasBlock: // value for 'hasBlock'
 *      icontainsSearch: // value for 'icontainsSearch'
 *   },
 * });
 */
export function useBlockHomesQuery(baseOptions?: Apollo.QueryHookOptions<BlockHomesQuery, BlockHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockHomesQuery, BlockHomesQueryVariables>(BlockHomesDocument, options);
      }
export function useBlockHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockHomesQuery, BlockHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockHomesQuery, BlockHomesQueryVariables>(BlockHomesDocument, options);
        }
export type BlockHomesQueryHookResult = ReturnType<typeof useBlockHomesQuery>;
export type BlockHomesLazyQueryHookResult = ReturnType<typeof useBlockHomesLazyQuery>;
export type BlockHomesQueryResult = Apollo.QueryResult<BlockHomesQuery, BlockHomesQueryVariables>;
export const DeleteBlockDocument = gql`
    mutation DeleteBlock($input: DeleteBlockInput!) {
  deleteBlock(input: $input) {
    block {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteBlockMutationFn = Apollo.MutationFunction<DeleteBlockMutation, DeleteBlockMutationVariables>;

/**
 * __useDeleteBlockMutation__
 *
 * To run a mutation, you first call `useDeleteBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBlockMutation, { data, loading, error }] = useDeleteBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteBlockMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBlockMutation, DeleteBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBlockMutation, DeleteBlockMutationVariables>(DeleteBlockDocument, options);
      }
export type DeleteBlockMutationHookResult = ReturnType<typeof useDeleteBlockMutation>;
export type DeleteBlockMutationResult = Apollo.MutationResult<DeleteBlockMutation>;
export type DeleteBlockMutationOptions = Apollo.BaseMutationOptions<DeleteBlockMutation, DeleteBlockMutationVariables>;
export const BlockDocumentsDocument = gql`
    query BlockDocuments($communityGroups: [ID], $after: String) {
  documents(
    communityGroups: $communityGroups
    type: ["COMMUNITY"]
    includeArchived: false
    orderBy: "-created_at"
    after: $after
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        contentObject {
          ... on CommunityDocumentNode {
            id
            title
            createdAt
            activatedOn
            archivedAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useBlockDocumentsQuery__
 *
 * To run a query within a React component, call `useBlockDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockDocumentsQuery({
 *   variables: {
 *      communityGroups: // value for 'communityGroups'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlockDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<BlockDocumentsQuery, BlockDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockDocumentsQuery, BlockDocumentsQueryVariables>(BlockDocumentsDocument, options);
      }
export function useBlockDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockDocumentsQuery, BlockDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockDocumentsQuery, BlockDocumentsQueryVariables>(BlockDocumentsDocument, options);
        }
export type BlockDocumentsQueryHookResult = ReturnType<typeof useBlockDocumentsQuery>;
export type BlockDocumentsLazyQueryHookResult = ReturnType<typeof useBlockDocumentsLazyQuery>;
export type BlockDocumentsQueryResult = Apollo.QueryResult<BlockDocumentsQuery, BlockDocumentsQueryVariables>;
export const BlockGroupsDocument = gql`
    query BlockGroups($id: UUID!) {
  block(id: $id) {
    id
    groups {
      ...BlockGroupCard
    }
  }
}
    ${BlockGroupCardFragmentDoc}`;

/**
 * __useBlockGroupsQuery__
 *
 * To run a query within a React component, call `useBlockGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockGroupsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockGroupsQuery(baseOptions: Apollo.QueryHookOptions<BlockGroupsQuery, BlockGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockGroupsQuery, BlockGroupsQueryVariables>(BlockGroupsDocument, options);
      }
export function useBlockGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockGroupsQuery, BlockGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockGroupsQuery, BlockGroupsQueryVariables>(BlockGroupsDocument, options);
        }
export type BlockGroupsQueryHookResult = ReturnType<typeof useBlockGroupsQuery>;
export type BlockGroupsLazyQueryHookResult = ReturnType<typeof useBlockGroupsLazyQuery>;
export type BlockGroupsQueryResult = Apollo.QueryResult<BlockGroupsQuery, BlockGroupsQueryVariables>;
export const BlockPinHomesDocument = gql`
    query BlockPinHomes($after: String, $communities: [ID], $icontainsSearch: String) {
  homes(
    after: $after
    communities: $communities
    icontainsSearch: $icontainsSearch
    orderBy: "number_in_address"
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        block {
          id
          name
          isDefault
        }
      }
    }
  }
}
    `;

/**
 * __useBlockPinHomesQuery__
 *
 * To run a query within a React component, call `useBlockPinHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPinHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPinHomesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      icontainsSearch: // value for 'icontainsSearch'
 *   },
 * });
 */
export function useBlockPinHomesQuery(baseOptions?: Apollo.QueryHookOptions<BlockPinHomesQuery, BlockPinHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPinHomesQuery, BlockPinHomesQueryVariables>(BlockPinHomesDocument, options);
      }
export function useBlockPinHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPinHomesQuery, BlockPinHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPinHomesQuery, BlockPinHomesQueryVariables>(BlockPinHomesDocument, options);
        }
export type BlockPinHomesQueryHookResult = ReturnType<typeof useBlockPinHomesQuery>;
export type BlockPinHomesLazyQueryHookResult = ReturnType<typeof useBlockPinHomesLazyQuery>;
export type BlockPinHomesQueryResult = Apollo.QueryResult<BlockPinHomesQuery, BlockPinHomesQueryVariables>;
export const CommunityWideGroupsDocument = gql`
    query CommunityWideGroups($community: UUID!) {
  communityGroups(community: $community, isAutomatic: true, active: true) {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCommunityWideGroupsQuery__
 *
 * To run a query within a React component, call `useCommunityWideGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityWideGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityWideGroupsQuery({
 *   variables: {
 *      community: // value for 'community'
 *   },
 * });
 */
export function useCommunityWideGroupsQuery(baseOptions: Apollo.QueryHookOptions<CommunityWideGroupsQuery, CommunityWideGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityWideGroupsQuery, CommunityWideGroupsQueryVariables>(CommunityWideGroupsDocument, options);
      }
export function useCommunityWideGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityWideGroupsQuery, CommunityWideGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityWideGroupsQuery, CommunityWideGroupsQueryVariables>(CommunityWideGroupsDocument, options);
        }
export type CommunityWideGroupsQueryHookResult = ReturnType<typeof useCommunityWideGroupsQuery>;
export type CommunityWideGroupsLazyQueryHookResult = ReturnType<typeof useCommunityWideGroupsLazyQuery>;
export type CommunityWideGroupsQueryResult = Apollo.QueryResult<CommunityWideGroupsQuery, CommunityWideGroupsQueryVariables>;
export const SyncBlockGroupsDocument = gql`
    mutation SyncBlockGroups($input: SyncBlockGroupsInput!) {
  syncBlockGroups(input: $input) {
    results {
      group {
        ...BlockGroupCard
      }
      membersAdded
      membersRemoved
    }
  }
}
    ${BlockGroupCardFragmentDoc}`;
export type SyncBlockGroupsMutationFn = Apollo.MutationFunction<SyncBlockGroupsMutation, SyncBlockGroupsMutationVariables>;

/**
 * __useSyncBlockGroupsMutation__
 *
 * To run a mutation, you first call `useSyncBlockGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncBlockGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncBlockGroupsMutation, { data, loading, error }] = useSyncBlockGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncBlockGroupsMutation(baseOptions?: Apollo.MutationHookOptions<SyncBlockGroupsMutation, SyncBlockGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncBlockGroupsMutation, SyncBlockGroupsMutationVariables>(SyncBlockGroupsDocument, options);
      }
export type SyncBlockGroupsMutationHookResult = ReturnType<typeof useSyncBlockGroupsMutation>;
export type SyncBlockGroupsMutationResult = Apollo.MutationResult<SyncBlockGroupsMutation>;
export type SyncBlockGroupsMutationOptions = Apollo.BaseMutationOptions<SyncBlockGroupsMutation, SyncBlockGroupsMutationVariables>;
export const UpdateBlockGroupPinnedHomesDocument = gql`
    mutation UpdateBlockGroupPinnedHomes($input: UpdateBlockGroupPinnedHomesInput!) {
  updateBlockGroupPinnedHomes(input: $input) {
    group {
      ...BlockGroupCard
    }
    errors {
      field
      messages
    }
  }
}
    ${BlockGroupCardFragmentDoc}`;
export type UpdateBlockGroupPinnedHomesMutationFn = Apollo.MutationFunction<UpdateBlockGroupPinnedHomesMutation, UpdateBlockGroupPinnedHomesMutationVariables>;

/**
 * __useUpdateBlockGroupPinnedHomesMutation__
 *
 * To run a mutation, you first call `useUpdateBlockGroupPinnedHomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockGroupPinnedHomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockGroupPinnedHomesMutation, { data, loading, error }] = useUpdateBlockGroupPinnedHomesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockGroupPinnedHomesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockGroupPinnedHomesMutation, UpdateBlockGroupPinnedHomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockGroupPinnedHomesMutation, UpdateBlockGroupPinnedHomesMutationVariables>(UpdateBlockGroupPinnedHomesDocument, options);
      }
export type UpdateBlockGroupPinnedHomesMutationHookResult = ReturnType<typeof useUpdateBlockGroupPinnedHomesMutation>;
export type UpdateBlockGroupPinnedHomesMutationResult = Apollo.MutationResult<UpdateBlockGroupPinnedHomesMutation>;
export type UpdateBlockGroupPinnedHomesMutationOptions = Apollo.BaseMutationOptions<UpdateBlockGroupPinnedHomesMutation, UpdateBlockGroupPinnedHomesMutationVariables>;
export const BlockPlacementsDocument = gql`
    query BlockPlacements($id: UUID!) {
  block(id: $id) {
    id
    unconfirmedPlacements {
      ...BlockPlacementRow
    }
  }
}
    ${BlockPlacementRowFragmentDoc}`;

/**
 * __useBlockPlacementsQuery__
 *
 * To run a query within a React component, call `useBlockPlacementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockPlacementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockPlacementsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockPlacementsQuery(baseOptions: Apollo.QueryHookOptions<BlockPlacementsQuery, BlockPlacementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockPlacementsQuery, BlockPlacementsQueryVariables>(BlockPlacementsDocument, options);
      }
export function useBlockPlacementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockPlacementsQuery, BlockPlacementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockPlacementsQuery, BlockPlacementsQueryVariables>(BlockPlacementsDocument, options);
        }
export type BlockPlacementsQueryHookResult = ReturnType<typeof useBlockPlacementsQuery>;
export type BlockPlacementsLazyQueryHookResult = ReturnType<typeof useBlockPlacementsLazyQuery>;
export type BlockPlacementsQueryResult = Apollo.QueryResult<BlockPlacementsQuery, BlockPlacementsQueryVariables>;
export const ConfirmBlockPlacementsDocument = gql`
    mutation ConfirmBlockPlacements($blockId: ID!) {
  confirmBlockPlacements(blockId: $blockId) {
    block {
      ...BlockDetail
    }
  }
}
    ${BlockDetailFragmentDoc}`;
export type ConfirmBlockPlacementsMutationFn = Apollo.MutationFunction<ConfirmBlockPlacementsMutation, ConfirmBlockPlacementsMutationVariables>;

/**
 * __useConfirmBlockPlacementsMutation__
 *
 * To run a mutation, you first call `useConfirmBlockPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmBlockPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmBlockPlacementsMutation, { data, loading, error }] = useConfirmBlockPlacementsMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useConfirmBlockPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmBlockPlacementsMutation, ConfirmBlockPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmBlockPlacementsMutation, ConfirmBlockPlacementsMutationVariables>(ConfirmBlockPlacementsDocument, options);
      }
export type ConfirmBlockPlacementsMutationHookResult = ReturnType<typeof useConfirmBlockPlacementsMutation>;
export type ConfirmBlockPlacementsMutationResult = Apollo.MutationResult<ConfirmBlockPlacementsMutation>;
export type ConfirmBlockPlacementsMutationOptions = Apollo.BaseMutationOptions<ConfirmBlockPlacementsMutation, ConfirmBlockPlacementsMutationVariables>;
export const RemoveBlockPlacementsDocument = gql`
    mutation RemoveBlockPlacements($blockId: ID!, $homeIds: [ID!]!) {
  removeBlockPlacements(blockId: $blockId, homeIds: $homeIds) {
    block {
      ...BlockDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${BlockDetailFragmentDoc}`;
export type RemoveBlockPlacementsMutationFn = Apollo.MutationFunction<RemoveBlockPlacementsMutation, RemoveBlockPlacementsMutationVariables>;

/**
 * __useRemoveBlockPlacementsMutation__
 *
 * To run a mutation, you first call `useRemoveBlockPlacementsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveBlockPlacementsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeBlockPlacementsMutation, { data, loading, error }] = useRemoveBlockPlacementsMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *      homeIds: // value for 'homeIds'
 *   },
 * });
 */
export function useRemoveBlockPlacementsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveBlockPlacementsMutation, RemoveBlockPlacementsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveBlockPlacementsMutation, RemoveBlockPlacementsMutationVariables>(RemoveBlockPlacementsDocument, options);
      }
export type RemoveBlockPlacementsMutationHookResult = ReturnType<typeof useRemoveBlockPlacementsMutation>;
export type RemoveBlockPlacementsMutationResult = Apollo.MutationResult<RemoveBlockPlacementsMutation>;
export type RemoveBlockPlacementsMutationOptions = Apollo.BaseMutationOptions<RemoveBlockPlacementsMutation, RemoveBlockPlacementsMutationVariables>;
export const UpdateBlockDocument = gql`
    mutation UpdateBlock($input: UpdateBlockInput!) {
  updateBlock(input: $input) {
    block {
      ...BlockDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${BlockDetailFragmentDoc}`;
export type UpdateBlockMutationFn = Apollo.MutationFunction<UpdateBlockMutation, UpdateBlockMutationVariables>;

/**
 * __useUpdateBlockMutation__
 *
 * To run a mutation, you first call `useUpdateBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockMutation, { data, loading, error }] = useUpdateBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockMutation, UpdateBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockMutation, UpdateBlockMutationVariables>(UpdateBlockDocument, options);
      }
export type UpdateBlockMutationHookResult = ReturnType<typeof useUpdateBlockMutation>;
export type UpdateBlockMutationResult = Apollo.MutationResult<UpdateBlockMutation>;
export type UpdateBlockMutationOptions = Apollo.BaseMutationOptions<UpdateBlockMutation, UpdateBlockMutationVariables>;
export const UpdateBlockHomesDocument = gql`
    mutation UpdateBlockHomes($input: UpdateBlockHomesInput!) {
  updateBlockHomes(input: $input) {
    block {
      ...BlockDetail
    }
    errors {
      field
      messages
    }
  }
}
    ${BlockDetailFragmentDoc}`;
export type UpdateBlockHomesMutationFn = Apollo.MutationFunction<UpdateBlockHomesMutation, UpdateBlockHomesMutationVariables>;

/**
 * __useUpdateBlockHomesMutation__
 *
 * To run a mutation, you first call `useUpdateBlockHomesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockHomesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockHomesMutation, { data, loading, error }] = useUpdateBlockHomesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockHomesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockHomesMutation, UpdateBlockHomesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockHomesMutation, UpdateBlockHomesMutationVariables>(UpdateBlockHomesDocument, options);
      }
export type UpdateBlockHomesMutationHookResult = ReturnType<typeof useUpdateBlockHomesMutation>;
export type UpdateBlockHomesMutationResult = Apollo.MutationResult<UpdateBlockHomesMutation>;
export type UpdateBlockHomesMutationOptions = Apollo.BaseMutationOptions<UpdateBlockHomesMutation, UpdateBlockHomesMutationVariables>;
export const UpdateCommunityGroupDescriptionDocument = gql`
    mutation UpdateCommunityGroupDescription($input: UpdateGroupDescriptionInput!) {
  updateGroupDescription(input: $input) {
    communityGroup {
      id
      description
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunityGroupDescriptionMutationFn = Apollo.MutationFunction<UpdateCommunityGroupDescriptionMutation, UpdateCommunityGroupDescriptionMutationVariables>;

/**
 * __useUpdateCommunityGroupDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityGroupDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityGroupDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityGroupDescriptionMutation, { data, loading, error }] = useUpdateCommunityGroupDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityGroupDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityGroupDescriptionMutation, UpdateCommunityGroupDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityGroupDescriptionMutation, UpdateCommunityGroupDescriptionMutationVariables>(UpdateCommunityGroupDescriptionDocument, options);
      }
export type UpdateCommunityGroupDescriptionMutationHookResult = ReturnType<typeof useUpdateCommunityGroupDescriptionMutation>;
export type UpdateCommunityGroupDescriptionMutationResult = Apollo.MutationResult<UpdateCommunityGroupDescriptionMutation>;
export type UpdateCommunityGroupDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityGroupDescriptionMutation, UpdateCommunityGroupDescriptionMutationVariables>;
export const BlockGroupRefsDocument = gql`
    query BlockGroupRefs($id: UUID!) {
  block(id: $id) {
    id
    groups {
      id
      name
    }
  }
}
    `;

/**
 * __useBlockGroupRefsQuery__
 *
 * To run a query within a React component, call `useBlockGroupRefsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockGroupRefsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockGroupRefsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockGroupRefsQuery(baseOptions: Apollo.QueryHookOptions<BlockGroupRefsQuery, BlockGroupRefsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockGroupRefsQuery, BlockGroupRefsQueryVariables>(BlockGroupRefsDocument, options);
      }
export function useBlockGroupRefsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockGroupRefsQuery, BlockGroupRefsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockGroupRefsQuery, BlockGroupRefsQueryVariables>(BlockGroupRefsDocument, options);
        }
export type BlockGroupRefsQueryHookResult = ReturnType<typeof useBlockGroupRefsQuery>;
export type BlockGroupRefsLazyQueryHookResult = ReturnType<typeof useBlockGroupRefsLazyQuery>;
export type BlockGroupRefsQueryResult = Apollo.QueryResult<BlockGroupRefsQuery, BlockGroupRefsQueryVariables>;
export const BlockUpdatesDocument = gql`
    query BlockUpdates($communityGroups: [ID], $status: [String], $after: String) {
  communityUpdates(
    communityGroups: $communityGroups
    status: $status
    after: $after
    orderBy: "-published_at"
    hasLinkedFeature: false
  ) {
    edges {
      node {
        id
        title
        status
        publishedAt
        groups {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useBlockUpdatesQuery__
 *
 * To run a query within a React component, call `useBlockUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockUpdatesQuery({
 *   variables: {
 *      communityGroups: // value for 'communityGroups'
 *      status: // value for 'status'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useBlockUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<BlockUpdatesQuery, BlockUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockUpdatesQuery, BlockUpdatesQueryVariables>(BlockUpdatesDocument, options);
      }
export function useBlockUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockUpdatesQuery, BlockUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockUpdatesQuery, BlockUpdatesQueryVariables>(BlockUpdatesDocument, options);
        }
export type BlockUpdatesQueryHookResult = ReturnType<typeof useBlockUpdatesQuery>;
export type BlockUpdatesLazyQueryHookResult = ReturnType<typeof useBlockUpdatesLazyQuery>;
export type BlockUpdatesQueryResult = Apollo.QueryResult<BlockUpdatesQuery, BlockUpdatesQueryVariables>;
export const CommunitySettingsDialogDocument = gql`
    query CommunitySettingsDialog($id: UUID!) {
  community(id: $id) {
    id
    name
    status
    deactivatedOn
    avatar
    commentsEnabled
    communityChatEnabled
    marketplaceEnabled
    paymentsEnabled
    officeHoursEnabled
    outOfOfficeMessage
    openPeriods {
      ...CommunityOpenPeriod
    }
  }
}
    ${CommunityOpenPeriodFragmentDoc}`;

/**
 * __useCommunitySettingsDialogQuery__
 *
 * To run a query within a React component, call `useCommunitySettingsDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySettingsDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySettingsDialogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunitySettingsDialogQuery(baseOptions: Apollo.QueryHookOptions<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>(CommunitySettingsDialogDocument, options);
      }
export function useCommunitySettingsDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>(CommunitySettingsDialogDocument, options);
        }
export type CommunitySettingsDialogQueryHookResult = ReturnType<typeof useCommunitySettingsDialogQuery>;
export type CommunitySettingsDialogLazyQueryHookResult = ReturnType<typeof useCommunitySettingsDialogLazyQuery>;
export type CommunitySettingsDialogQueryResult = Apollo.QueryResult<CommunitySettingsDialogQuery, CommunitySettingsDialogQueryVariables>;
export const UpdateCommunitySettingsDocument = gql`
    mutation UpdateCommunitySettings($input: UpdateCommunitySettingsInput!) {
  updateCommunitySettings(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunitySettingsMutationFn = Apollo.MutationFunction<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>;

/**
 * __useUpdateCommunitySettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCommunitySettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunitySettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunitySettingsMutation, { data, loading, error }] = useUpdateCommunitySettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunitySettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>(UpdateCommunitySettingsDocument, options);
      }
export type UpdateCommunitySettingsMutationHookResult = ReturnType<typeof useUpdateCommunitySettingsMutation>;
export type UpdateCommunitySettingsMutationResult = Apollo.MutationResult<UpdateCommunitySettingsMutation>;
export type UpdateCommunitySettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCommunitySettingsMutation, UpdateCommunitySettingsMutationVariables>;
export const CommunityTeamDocument = gql`
    query CommunityTeam($id: UUID!, $after: String) {
  community(id: $id) {
    id
    name
    team(after: $after) {
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      edges {
        node {
          ...TeamMemberItem
        }
      }
    }
  }
}
    ${TeamMemberItemFragmentDoc}`;

/**
 * __useCommunityTeamQuery__
 *
 * To run a query within a React component, call `useCommunityTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityTeamQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityTeamQuery(baseOptions: Apollo.QueryHookOptions<CommunityTeamQuery, CommunityTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityTeamQuery, CommunityTeamQueryVariables>(CommunityTeamDocument, options);
      }
export function useCommunityTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityTeamQuery, CommunityTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityTeamQuery, CommunityTeamQueryVariables>(CommunityTeamDocument, options);
        }
export type CommunityTeamQueryHookResult = ReturnType<typeof useCommunityTeamQuery>;
export type CommunityTeamLazyQueryHookResult = ReturnType<typeof useCommunityTeamLazyQuery>;
export type CommunityTeamQueryResult = Apollo.QueryResult<CommunityTeamQuery, CommunityTeamQueryVariables>;
export const CommunitiesDocument = gql`
    query Communities($after: String, $search: String, $orderBy: String, $isManager: Boolean) {
  communities(
    after: $after
    search: $search
    orderBy: $orderBy
    isManager: $isManager
    includeDeactivated: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        postcode
        avatar
        homeCount
        residentCount
        engagementScore
        openConversationsCount
        status
        downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
          id
          value
        }
        settings {
          ...CommunitySettings
        }
      }
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitiesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      isManager: // value for 'isManager'
 *   },
 * });
 */
export function useCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
      }
export function useCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitiesQuery, CommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitiesQuery, CommunitiesQueryVariables>(CommunitiesDocument, options);
        }
export type CommunitiesQueryHookResult = ReturnType<typeof useCommunitiesQuery>;
export type CommunitiesLazyQueryHookResult = ReturnType<typeof useCommunitiesLazyQuery>;
export type CommunitiesQueryResult = Apollo.QueryResult<CommunitiesQuery, CommunitiesQueryVariables>;
export const CommunityDetailsDocument = gql`
    query CommunityDetails($id: ID!, $uuid: UUID!) {
  community(id: $uuid) {
    id
    name
    postcode
    requisiteDate
    engagementScore
    openConversationsCount
    downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
      id
      value
    }
    satisfactionScore
    homeCount
    residentCount
    communityGroups {
      totalCount
    }
    communityEvents {
      totalCount
    }
    team {
      totalCount
    }
  }
  contacts(communities: [$id]) {
    totalCount
  }
  communityUpdates(communities: [$id]) {
    totalCount
  }
  communityDocuments(communities: [$id]) {
    totalCount
  }
  amenities(communities: [$id]) {
    totalCount
  }
  surveys(communities: [$id]) {
    totalCount
  }
  applications(communities: [$id]) {
    totalCount
  }
  communityProducts(communities: [$id]) {
    totalCount
  }
  packages(communities: [$id]) {
    totalCount
  }
  keys(communities: [$id]) {
    totalCount
  }
  communityVisitors(communities: [$id]) {
    totalCount
  }
}
    `;

/**
 * __useCommunityDetailsQuery__
 *
 * To run a query within a React component, call `useCommunityDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useCommunityDetailsQuery(baseOptions: Apollo.QueryHookOptions<CommunityDetailsQuery, CommunityDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityDetailsQuery, CommunityDetailsQueryVariables>(CommunityDetailsDocument, options);
      }
export function useCommunityDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityDetailsQuery, CommunityDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityDetailsQuery, CommunityDetailsQueryVariables>(CommunityDetailsDocument, options);
        }
export type CommunityDetailsQueryHookResult = ReturnType<typeof useCommunityDetailsQuery>;
export type CommunityDetailsLazyQueryHookResult = ReturnType<typeof useCommunityDetailsLazyQuery>;
export type CommunityDetailsQueryResult = Apollo.QueryResult<CommunityDetailsQuery, CommunityDetailsQueryVariables>;
export const CommunityHeaderDocument = gql`
    query CommunityHeader($id: UUID!) {
  community(id: $id) {
    id
    avatar
    name
    status
    postcode
  }
}
    `;

/**
 * __useCommunityHeaderQuery__
 *
 * To run a query within a React component, call `useCommunityHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityHeaderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityHeaderQuery(baseOptions: Apollo.QueryHookOptions<CommunityHeaderQuery, CommunityHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityHeaderQuery, CommunityHeaderQueryVariables>(CommunityHeaderDocument, options);
      }
export function useCommunityHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityHeaderQuery, CommunityHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityHeaderQuery, CommunityHeaderQueryVariables>(CommunityHeaderDocument, options);
        }
export type CommunityHeaderQueryHookResult = ReturnType<typeof useCommunityHeaderQuery>;
export type CommunityHeaderLazyQueryHookResult = ReturnType<typeof useCommunityHeaderLazyQuery>;
export type CommunityHeaderQueryResult = Apollo.QueryResult<CommunityHeaderQuery, CommunityHeaderQueryVariables>;
export const CommunityNameDocument = gql`
    query CommunityName($id: UUID!) {
  community(id: $id) {
    id
    name
    postcode
  }
}
    `;

/**
 * __useCommunityNameQuery__
 *
 * To run a query within a React component, call `useCommunityNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityNameQuery(baseOptions: Apollo.QueryHookOptions<CommunityNameQuery, CommunityNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityNameQuery, CommunityNameQueryVariables>(CommunityNameDocument, options);
      }
export function useCommunityNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityNameQuery, CommunityNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityNameQuery, CommunityNameQueryVariables>(CommunityNameDocument, options);
        }
export type CommunityNameQueryHookResult = ReturnType<typeof useCommunityNameQuery>;
export type CommunityNameLazyQueryHookResult = ReturnType<typeof useCommunityNameLazyQuery>;
export type CommunityNameQueryResult = Apollo.QueryResult<CommunityNameQuery, CommunityNameQueryVariables>;
export const CommunitySettingsDocument = gql`
    query CommunitySettings($id: UUID!) {
  community(id: $id) {
    id
    settings {
      ...CommunitySettings
    }
  }
}
    ${CommunitySettingsFragmentDoc}`;

/**
 * __useCommunitySettingsQuery__
 *
 * To run a query within a React component, call `useCommunitySettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySettingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunitySettingsQuery(baseOptions: Apollo.QueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
      }
export function useCommunitySettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySettingsQuery, CommunitySettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySettingsQuery, CommunitySettingsQueryVariables>(CommunitySettingsDocument, options);
        }
export type CommunitySettingsQueryHookResult = ReturnType<typeof useCommunitySettingsQuery>;
export type CommunitySettingsLazyQueryHookResult = ReturnType<typeof useCommunitySettingsLazyQuery>;
export type CommunitySettingsQueryResult = Apollo.QueryResult<CommunitySettingsQuery, CommunitySettingsQueryVariables>;
export const CommunityStatsDocument = gql`
    query CommunityStats($id: UUID!) {
  community(id: $id) {
    id
    engagementScore
    satisfactionScore
    downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
      id
      value
    }
    downloadRateDifference: statisticDifference(
      statisticType: DOWNLOAD_RATE_PERCENTAGE
    )
    engagementScoreDifference
  }
}
    `;

/**
 * __useCommunityStatsQuery__
 *
 * To run a query within a React component, call `useCommunityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityStatsQuery(baseOptions: Apollo.QueryHookOptions<CommunityStatsQuery, CommunityStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityStatsQuery, CommunityStatsQueryVariables>(CommunityStatsDocument, options);
      }
export function useCommunityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityStatsQuery, CommunityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityStatsQuery, CommunityStatsQueryVariables>(CommunityStatsDocument, options);
        }
export type CommunityStatsQueryHookResult = ReturnType<typeof useCommunityStatsQuery>;
export type CommunityStatsLazyQueryHookResult = ReturnType<typeof useCommunityStatsLazyQuery>;
export type CommunityStatsQueryResult = Apollo.QueryResult<CommunityStatsQuery, CommunityStatsQueryVariables>;
export const CreateCommunityProductDocument = gql`
    mutation CreateCommunityProduct($input: CreateCommunityProductInput!) {
  createCommunityProduct(input: $input) {
    communityProduct {
      id
      name
      description
      active
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
      price
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityProductMutationFn = Apollo.MutationFunction<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>;

/**
 * __useCreateCommunityProductMutation__
 *
 * To run a mutation, you first call `useCreateCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityProductMutation, { data, loading, error }] = useCreateCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>(CreateCommunityProductDocument, options);
      }
export type CreateCommunityProductMutationHookResult = ReturnType<typeof useCreateCommunityProductMutation>;
export type CreateCommunityProductMutationResult = Apollo.MutationResult<CreateCommunityProductMutation>;
export type CreateCommunityProductMutationOptions = Apollo.BaseMutationOptions<CreateCommunityProductMutation, CreateCommunityProductMutationVariables>;
export const DeleteCommunityProductDocument = gql`
    mutation DeleteCommunityProduct($input: DeleteCommunityProductInput!) {
  deleteCommunityProduct(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteCommunityProductMutationFn = Apollo.MutationFunction<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>;

/**
 * __useDeleteCommunityProductMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityProductMutation, { data, loading, error }] = useDeleteCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>(DeleteCommunityProductDocument, options);
      }
export type DeleteCommunityProductMutationHookResult = ReturnType<typeof useDeleteCommunityProductMutation>;
export type DeleteCommunityProductMutationResult = Apollo.MutationResult<DeleteCommunityProductMutation>;
export type DeleteCommunityProductMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityProductMutation, DeleteCommunityProductMutationVariables>;
export const CommunityProductsDocument = gql`
    query CommunityProducts($active: Boolean, $communities: [ID], $after: String, $search: String, $orderBy: String) {
  communityProducts(
    active: $active
    communities: $communities
    after: $after
    search: $search
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...CommunityProduct
      }
    }
  }
}
    ${CommunityProductFragmentDoc}`;

/**
 * __useCommunityProductsQuery__
 *
 * To run a query within a React component, call `useCommunityProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityProductsQuery({
 *   variables: {
 *      active: // value for 'active'
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCommunityProductsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityProductsQuery, CommunityProductsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityProductsQuery, CommunityProductsQueryVariables>(CommunityProductsDocument, options);
      }
export function useCommunityProductsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityProductsQuery, CommunityProductsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityProductsQuery, CommunityProductsQueryVariables>(CommunityProductsDocument, options);
        }
export type CommunityProductsQueryHookResult = ReturnType<typeof useCommunityProductsQuery>;
export type CommunityProductsLazyQueryHookResult = ReturnType<typeof useCommunityProductsLazyQuery>;
export type CommunityProductsQueryResult = Apollo.QueryResult<CommunityProductsQuery, CommunityProductsQueryVariables>;
export const FindCommunityProductDetailsDocument = gql`
    query FindCommunityProductDetails($id: UUID!) {
  communityProduct(id: $id) {
    id
    name
    description
    active
    communities {
      edges {
        node {
          id
          name
        }
      }
    }
    price
  }
}
    `;

/**
 * __useFindCommunityProductDetailsQuery__
 *
 * To run a query within a React component, call `useFindCommunityProductDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommunityProductDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommunityProductDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindCommunityProductDetailsQuery(baseOptions: Apollo.QueryHookOptions<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>(FindCommunityProductDetailsDocument, options);
      }
export function useFindCommunityProductDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>(FindCommunityProductDetailsDocument, options);
        }
export type FindCommunityProductDetailsQueryHookResult = ReturnType<typeof useFindCommunityProductDetailsQuery>;
export type FindCommunityProductDetailsLazyQueryHookResult = ReturnType<typeof useFindCommunityProductDetailsLazyQuery>;
export type FindCommunityProductDetailsQueryResult = Apollo.QueryResult<FindCommunityProductDetailsQuery, FindCommunityProductDetailsQueryVariables>;
export const FindCommunityProductPurchasesDocument = gql`
    query FindCommunityProductPurchases($id: UUID!, $after: String) {
  communityProduct(id: $id) {
    purchases(after: $after, status: "SU") {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          createdAt
          user {
            firstName
            lastName
            email
          }
          address
        }
      }
    }
  }
}
    `;

/**
 * __useFindCommunityProductPurchasesQuery__
 *
 * To run a query within a React component, call `useFindCommunityProductPurchasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindCommunityProductPurchasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindCommunityProductPurchasesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useFindCommunityProductPurchasesQuery(baseOptions: Apollo.QueryHookOptions<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>(FindCommunityProductPurchasesDocument, options);
      }
export function useFindCommunityProductPurchasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>(FindCommunityProductPurchasesDocument, options);
        }
export type FindCommunityProductPurchasesQueryHookResult = ReturnType<typeof useFindCommunityProductPurchasesQuery>;
export type FindCommunityProductPurchasesLazyQueryHookResult = ReturnType<typeof useFindCommunityProductPurchasesLazyQuery>;
export type FindCommunityProductPurchasesQueryResult = Apollo.QueryResult<FindCommunityProductPurchasesQuery, FindCommunityProductPurchasesQueryVariables>;
export const UpdateCommunityProductDocument = gql`
    mutation UpdateCommunityProduct($input: UpdateCommunityProductInput!) {
  updateCommunityProduct(input: $input) {
    communityProduct {
      id
      name
      description
      active
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
      price
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunityProductMutationFn = Apollo.MutationFunction<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>;

/**
 * __useUpdateCommunityProductMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityProductMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityProductMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityProductMutation, { data, loading, error }] = useUpdateCommunityProductMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityProductMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>(UpdateCommunityProductDocument, options);
      }
export type UpdateCommunityProductMutationHookResult = ReturnType<typeof useUpdateCommunityProductMutation>;
export type UpdateCommunityProductMutationResult = Apollo.MutationResult<UpdateCommunityProductMutation>;
export type UpdateCommunityProductMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityProductMutation, UpdateCommunityProductMutationVariables>;
export const ComplianceBlocksDocument = gql`
    query ComplianceBlocks($communities: [ID!], $after: String, $search: String, $orderBy: String) {
  blocks(
    communities: $communities
    after: $after
    search: $search
    orderBy: $orderBy
    hasRequirements: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ComplianceBlockItem
      }
    }
  }
}
    ${ComplianceBlockItemFragmentDoc}`;

/**
 * __useComplianceBlocksQuery__
 *
 * To run a query within a React component, call `useComplianceBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useComplianceBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useComplianceBlocksQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useComplianceBlocksQuery(baseOptions?: Apollo.QueryHookOptions<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>(ComplianceBlocksDocument, options);
      }
export function useComplianceBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>(ComplianceBlocksDocument, options);
        }
export type ComplianceBlocksQueryHookResult = ReturnType<typeof useComplianceBlocksQuery>;
export type ComplianceBlocksLazyQueryHookResult = ReturnType<typeof useComplianceBlocksLazyQuery>;
export type ComplianceBlocksQueryResult = Apollo.QueryResult<ComplianceBlocksQuery, ComplianceBlocksQueryVariables>;
export const CreateBlocksComplianceRequirementDocument = gql`
    mutation CreateBlocksComplianceRequirement($input: CreateBlocksComplianceRequirementInput!) {
  createBlocksComplianceRequirement(input: $input) {
    blocksComplianceRequirement {
      id
      name
      description
      blocks {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;
export type CreateBlocksComplianceRequirementMutationFn = Apollo.MutationFunction<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>;

/**
 * __useCreateBlocksComplianceRequirementMutation__
 *
 * To run a mutation, you first call `useCreateBlocksComplianceRequirementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocksComplianceRequirementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocksComplianceRequirementMutation, { data, loading, error }] = useCreateBlocksComplianceRequirementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlocksComplianceRequirementMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>(CreateBlocksComplianceRequirementDocument, options);
      }
export type CreateBlocksComplianceRequirementMutationHookResult = ReturnType<typeof useCreateBlocksComplianceRequirementMutation>;
export type CreateBlocksComplianceRequirementMutationResult = Apollo.MutationResult<CreateBlocksComplianceRequirementMutation>;
export type CreateBlocksComplianceRequirementMutationOptions = Apollo.BaseMutationOptions<CreateBlocksComplianceRequirementMutation, CreateBlocksComplianceRequirementMutationVariables>;
export const BlockComplianceRequirementsDocument = gql`
    query BlockComplianceRequirements($blocks: [ID], $search: String, $after: String, $status: [String]) {
  blockComplianceRequirements(
    blocks: $blocks
    search: $search
    orderBy: "action_date"
    after: $after
    status: $status
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...BlockComplianceRequirement
      }
    }
  }
}
    ${BlockComplianceRequirementFragmentDoc}`;

/**
 * __useBlockComplianceRequirementsQuery__
 *
 * To run a query within a React component, call `useBlockComplianceRequirementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockComplianceRequirementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockComplianceRequirementsQuery({
 *   variables: {
 *      blocks: // value for 'blocks'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useBlockComplianceRequirementsQuery(baseOptions?: Apollo.QueryHookOptions<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>(BlockComplianceRequirementsDocument, options);
      }
export function useBlockComplianceRequirementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>(BlockComplianceRequirementsDocument, options);
        }
export type BlockComplianceRequirementsQueryHookResult = ReturnType<typeof useBlockComplianceRequirementsQuery>;
export type BlockComplianceRequirementsLazyQueryHookResult = ReturnType<typeof useBlockComplianceRequirementsLazyQuery>;
export type BlockComplianceRequirementsQueryResult = Apollo.QueryResult<BlockComplianceRequirementsQuery, BlockComplianceRequirementsQueryVariables>;
export const CreateBlockComplianceRequirementItemDocument = gql`
    mutation CreateBlockComplianceRequirementItem($input: CreateBlockComplianceRequirementItemInput!) {
  createBlockComplianceRequirementItem(input: $input) {
    blockComplianceRequirementItem {
      id
      blockComplianceRequirements {
        edges {
          node {
            id
            status
            item {
              id
              expiryDate
              createdAt
              attachments {
                edges {
                  node {
                    id
                    file
                    url
                    createdAt
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export type CreateBlockComplianceRequirementItemMutationFn = Apollo.MutationFunction<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>;

/**
 * __useCreateBlockComplianceRequirementItemMutation__
 *
 * To run a mutation, you first call `useCreateBlockComplianceRequirementItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlockComplianceRequirementItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlockComplianceRequirementItemMutation, { data, loading, error }] = useCreateBlockComplianceRequirementItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBlockComplianceRequirementItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>(CreateBlockComplianceRequirementItemDocument, options);
      }
export type CreateBlockComplianceRequirementItemMutationHookResult = ReturnType<typeof useCreateBlockComplianceRequirementItemMutation>;
export type CreateBlockComplianceRequirementItemMutationResult = Apollo.MutationResult<CreateBlockComplianceRequirementItemMutation>;
export type CreateBlockComplianceRequirementItemMutationOptions = Apollo.BaseMutationOptions<CreateBlockComplianceRequirementItemMutation, CreateBlockComplianceRequirementItemMutationVariables>;
export const RequirementItemBlocksDocument = gql`
    query RequirementItemBlocks($requirementId: UUID!) {
  blockComplianceRequirement(id: $requirementId) {
    id
    block {
      id
      name
    }
    requirement {
      id
      blockComplianceRequirements {
        edges {
          node {
            id
            block {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useRequirementItemBlocksQuery__
 *
 * To run a query within a React component, call `useRequirementItemBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useRequirementItemBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRequirementItemBlocksQuery({
 *   variables: {
 *      requirementId: // value for 'requirementId'
 *   },
 * });
 */
export function useRequirementItemBlocksQuery(baseOptions: Apollo.QueryHookOptions<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>(RequirementItemBlocksDocument, options);
      }
export function useRequirementItemBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>(RequirementItemBlocksDocument, options);
        }
export type RequirementItemBlocksQueryHookResult = ReturnType<typeof useRequirementItemBlocksQuery>;
export type RequirementItemBlocksLazyQueryHookResult = ReturnType<typeof useRequirementItemBlocksLazyQuery>;
export type RequirementItemBlocksQueryResult = Apollo.QueryResult<RequirementItemBlocksQuery, RequirementItemBlocksQueryVariables>;
export const BlockComplianceRequirementDocument = gql`
    query BlockComplianceRequirement($id: UUID!) {
  blockComplianceRequirement(id: $id) {
    ...BlockComplianceRequirement
  }
}
    ${BlockComplianceRequirementFragmentDoc}`;

/**
 * __useBlockComplianceRequirementQuery__
 *
 * To run a query within a React component, call `useBlockComplianceRequirementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlockComplianceRequirementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlockComplianceRequirementQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBlockComplianceRequirementQuery(baseOptions: Apollo.QueryHookOptions<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>(BlockComplianceRequirementDocument, options);
      }
export function useBlockComplianceRequirementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>(BlockComplianceRequirementDocument, options);
        }
export type BlockComplianceRequirementQueryHookResult = ReturnType<typeof useBlockComplianceRequirementQuery>;
export type BlockComplianceRequirementLazyQueryHookResult = ReturnType<typeof useBlockComplianceRequirementLazyQuery>;
export type BlockComplianceRequirementQueryResult = Apollo.QueryResult<BlockComplianceRequirementQuery, BlockComplianceRequirementQueryVariables>;
export const ContactBasicInfoDocument = gql`
    query ContactBasicInfo($id: UUID!) {
  contact(id: $id) {
    id
    email
    name
  }
}
    `;

/**
 * __useContactBasicInfoQuery__
 *
 * To run a query within a React component, call `useContactBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactBasicInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactBasicInfoQuery(baseOptions: Apollo.QueryHookOptions<ContactBasicInfoQuery, ContactBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactBasicInfoQuery, ContactBasicInfoQueryVariables>(ContactBasicInfoDocument, options);
      }
export function useContactBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactBasicInfoQuery, ContactBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactBasicInfoQuery, ContactBasicInfoQueryVariables>(ContactBasicInfoDocument, options);
        }
export type ContactBasicInfoQueryHookResult = ReturnType<typeof useContactBasicInfoQuery>;
export type ContactBasicInfoLazyQueryHookResult = ReturnType<typeof useContactBasicInfoLazyQuery>;
export type ContactBasicInfoQueryResult = Apollo.QueryResult<ContactBasicInfoQuery, ContactBasicInfoQueryVariables>;
export const ContactDownloadCountsDocument = gql`
    query ContactDownloadCounts($communities: [ID], $search: String, $userType: [String]) {
  downloaded: contacts(
    communities: $communities
    search: $search
    downloaded: true
    userType: $userType
    first: 1
  ) {
    totalCount
  }
  notDownloaded: contacts(
    communities: $communities
    search: $search
    downloaded: false
    userType: $userType
    first: 1
  ) {
    totalCount
  }
}
    `;

/**
 * __useContactDownloadCountsQuery__
 *
 * To run a query within a React component, call `useContactDownloadCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactDownloadCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactDownloadCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      userType: // value for 'userType'
 *   },
 * });
 */
export function useContactDownloadCountsQuery(baseOptions?: Apollo.QueryHookOptions<ContactDownloadCountsQuery, ContactDownloadCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactDownloadCountsQuery, ContactDownloadCountsQueryVariables>(ContactDownloadCountsDocument, options);
      }
export function useContactDownloadCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactDownloadCountsQuery, ContactDownloadCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactDownloadCountsQuery, ContactDownloadCountsQueryVariables>(ContactDownloadCountsDocument, options);
        }
export type ContactDownloadCountsQueryHookResult = ReturnType<typeof useContactDownloadCountsQuery>;
export type ContactDownloadCountsLazyQueryHookResult = ReturnType<typeof useContactDownloadCountsLazyQuery>;
export type ContactDownloadCountsQueryResult = Apollo.QueryResult<ContactDownloadCountsQuery, ContactDownloadCountsQueryVariables>;
export const ListContactProfilesDocument = gql`
    query ListContactProfiles($communities: [ID], $after: String, $search: String, $downloaded: Boolean, $userType: [String], $orderBy: String) {
  contacts(
    communities: $communities
    after: $after
    search: $search
    downloaded: $downloaded
    userType: $userType
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...ContactsListItemFields
      }
    }
  }
}
    ${ContactsListItemFieldsFragmentDoc}`;

/**
 * __useListContactProfilesQuery__
 *
 * To run a query within a React component, call `useListContactProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListContactProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListContactProfilesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      downloaded: // value for 'downloaded'
 *      userType: // value for 'userType'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListContactProfilesQuery(baseOptions?: Apollo.QueryHookOptions<ListContactProfilesQuery, ListContactProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListContactProfilesQuery, ListContactProfilesQueryVariables>(ListContactProfilesDocument, options);
      }
export function useListContactProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListContactProfilesQuery, ListContactProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListContactProfilesQuery, ListContactProfilesQueryVariables>(ListContactProfilesDocument, options);
        }
export type ListContactProfilesQueryHookResult = ReturnType<typeof useListContactProfilesQuery>;
export type ListContactProfilesLazyQueryHookResult = ReturnType<typeof useListContactProfilesLazyQuery>;
export type ListContactProfilesQueryResult = Apollo.QueryResult<ListContactProfilesQuery, ListContactProfilesQueryVariables>;
export const ContactAmenityBookingsDocument = gql`
    query ContactAmenityBookings($id: UUID!, $fromDate: Date) {
  contact(id: $id) {
    amenityReservations(fromDate: $fromDate, orderBy: "start") {
      edges {
        node {
          ...ContactAmenityReservation
        }
      }
    }
  }
}
    ${ContactAmenityReservationFragmentDoc}`;

/**
 * __useContactAmenityBookingsQuery__
 *
 * To run a query within a React component, call `useContactAmenityBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactAmenityBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactAmenityBookingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useContactAmenityBookingsQuery(baseOptions: Apollo.QueryHookOptions<ContactAmenityBookingsQuery, ContactAmenityBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactAmenityBookingsQuery, ContactAmenityBookingsQueryVariables>(ContactAmenityBookingsDocument, options);
      }
export function useContactAmenityBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactAmenityBookingsQuery, ContactAmenityBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactAmenityBookingsQuery, ContactAmenityBookingsQueryVariables>(ContactAmenityBookingsDocument, options);
        }
export type ContactAmenityBookingsQueryHookResult = ReturnType<typeof useContactAmenityBookingsQuery>;
export type ContactAmenityBookingsLazyQueryHookResult = ReturnType<typeof useContactAmenityBookingsLazyQuery>;
export type ContactAmenityBookingsQueryResult = Apollo.QueryResult<ContactAmenityBookingsQuery, ContactAmenityBookingsQueryVariables>;
export const ContactEventBookingsDocument = gql`
    query ContactEventBookings($id: UUID!, $eventEndDateAfter: Date) {
  contact(id: $id) {
    id
    eventParties(eventEndDateAfter: $eventEndDateAfter, orderBy: "event__start") {
      edges {
        node {
          id
          event {
            id
            name
            start
            end
          }
          additionalAttendance
        }
      }
    }
  }
}
    `;

/**
 * __useContactEventBookingsQuery__
 *
 * To run a query within a React component, call `useContactEventBookingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactEventBookingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactEventBookingsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      eventEndDateAfter: // value for 'eventEndDateAfter'
 *   },
 * });
 */
export function useContactEventBookingsQuery(baseOptions: Apollo.QueryHookOptions<ContactEventBookingsQuery, ContactEventBookingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactEventBookingsQuery, ContactEventBookingsQueryVariables>(ContactEventBookingsDocument, options);
      }
export function useContactEventBookingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactEventBookingsQuery, ContactEventBookingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactEventBookingsQuery, ContactEventBookingsQueryVariables>(ContactEventBookingsDocument, options);
        }
export type ContactEventBookingsQueryHookResult = ReturnType<typeof useContactEventBookingsQuery>;
export type ContactEventBookingsLazyQueryHookResult = ReturnType<typeof useContactEventBookingsLazyQuery>;
export type ContactEventBookingsQueryResult = Apollo.QueryResult<ContactEventBookingsQuery, ContactEventBookingsQueryVariables>;
export const ContactConversationsDocument = gql`
    query ContactConversations($contact: UUID!, $after: String) {
  conversations(contact: $contact, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        subject
        latestEvent {
          ... on ConversationMessageType {
            id
            createdAt
          }
          ... on ConversationMediaType {
            id
            createdAt
          }
          ... on ConversationActionModelType {
            id
            createdAt
          }
        }
        closedAt
        snoozedUntil
      }
    }
  }
}
    `;

/**
 * __useContactConversationsQuery__
 *
 * To run a query within a React component, call `useContactConversationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactConversationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactConversationsQuery({
 *   variables: {
 *      contact: // value for 'contact'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useContactConversationsQuery(baseOptions: Apollo.QueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
      }
export function useContactConversationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactConversationsQuery, ContactConversationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactConversationsQuery, ContactConversationsQueryVariables>(ContactConversationsDocument, options);
        }
export type ContactConversationsQueryHookResult = ReturnType<typeof useContactConversationsQuery>;
export type ContactConversationsLazyQueryHookResult = ReturnType<typeof useContactConversationsLazyQuery>;
export type ContactConversationsQueryResult = Apollo.QueryResult<ContactConversationsQuery, ContactConversationsQueryVariables>;
export const ArchiveContactNoteDocument = gql`
    mutation ArchiveContactNote($input: ArchiveContactNoteInput!) {
  archiveContactNote(input: $input) {
    contactNote {
      id
    }
  }
}
    `;
export type ArchiveContactNoteMutationFn = Apollo.MutationFunction<ArchiveContactNoteMutation, ArchiveContactNoteMutationVariables>;

/**
 * __useArchiveContactNoteMutation__
 *
 * To run a mutation, you first call `useArchiveContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveContactNoteMutation, { data, loading, error }] = useArchiveContactNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveContactNoteMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveContactNoteMutation, ArchiveContactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveContactNoteMutation, ArchiveContactNoteMutationVariables>(ArchiveContactNoteDocument, options);
      }
export type ArchiveContactNoteMutationHookResult = ReturnType<typeof useArchiveContactNoteMutation>;
export type ArchiveContactNoteMutationResult = Apollo.MutationResult<ArchiveContactNoteMutation>;
export type ArchiveContactNoteMutationOptions = Apollo.BaseMutationOptions<ArchiveContactNoteMutation, ArchiveContactNoteMutationVariables>;
export const SaveContactNoteDocument = gql`
    mutation SaveContactNote($input: SaveContactNoteInput!) {
  saveContactNote(input: $input) {
    contactNote {
      id
      text
      author {
        id
        name
      }
      community {
        id
        name
      }
      createdAt
    }
  }
}
    `;
export type SaveContactNoteMutationFn = Apollo.MutationFunction<SaveContactNoteMutation, SaveContactNoteMutationVariables>;

/**
 * __useSaveContactNoteMutation__
 *
 * To run a mutation, you first call `useSaveContactNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveContactNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveContactNoteMutation, { data, loading, error }] = useSaveContactNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveContactNoteMutation(baseOptions?: Apollo.MutationHookOptions<SaveContactNoteMutation, SaveContactNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveContactNoteMutation, SaveContactNoteMutationVariables>(SaveContactNoteDocument, options);
      }
export type SaveContactNoteMutationHookResult = ReturnType<typeof useSaveContactNoteMutation>;
export type SaveContactNoteMutationResult = Apollo.MutationResult<SaveContactNoteMutation>;
export type SaveContactNoteMutationOptions = Apollo.BaseMutationOptions<SaveContactNoteMutation, SaveContactNoteMutationVariables>;
export const ContactProfileHeaderDetailsDocument = gql`
    query ContactProfileHeaderDetails($id: UUID!) {
  contact(id: $id) {
    id
    firstName
    lastName
    email
    name
    mobile
    lastAppUse
    resident {
      id
      avatar
      averageScore
      currentResidencies {
        id
        startDate
        home {
          id
          address
          community {
            id
            name
          }
        }
      }
    }
    leaseholder {
      id
      leaseholds {
        edges {
          node {
            id
            createdAt
            home {
              id
              address
              community {
                id
                name
              }
            }
          }
        }
      }
    }
    applicant {
      id
      applications {
        edges {
          node {
            ...ContactApplicationItem
          }
        }
      }
    }
    contactNotes(archivedAt: false) {
      totalCount
      edges {
        node {
          ...ContactNoteItem
        }
      }
    }
    communityGroups {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...CommunityGroupItem
        }
      }
    }
  }
}
    ${ContactApplicationItemFragmentDoc}
${ContactNoteItemFragmentDoc}
${CommunityGroupItemFragmentDoc}`;

/**
 * __useContactProfileHeaderDetailsQuery__
 *
 * To run a query within a React component, call `useContactProfileHeaderDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactProfileHeaderDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactProfileHeaderDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactProfileHeaderDetailsQuery(baseOptions: Apollo.QueryHookOptions<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>(ContactProfileHeaderDetailsDocument, options);
      }
export function useContactProfileHeaderDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>(ContactProfileHeaderDetailsDocument, options);
        }
export type ContactProfileHeaderDetailsQueryHookResult = ReturnType<typeof useContactProfileHeaderDetailsQuery>;
export type ContactProfileHeaderDetailsLazyQueryHookResult = ReturnType<typeof useContactProfileHeaderDetailsLazyQuery>;
export type ContactProfileHeaderDetailsQueryResult = Apollo.QueryResult<ContactProfileHeaderDetailsQuery, ContactProfileHeaderDetailsQueryVariables>;
export const UpdateContactGroupsDocument = gql`
    mutation UpdateContactGroups($input: UpdateContactGroupsInput!) {
  updateContactGroups(input: $input) {
    contact {
      id
    }
  }
}
    `;
export type UpdateContactGroupsMutationFn = Apollo.MutationFunction<UpdateContactGroupsMutation, UpdateContactGroupsMutationVariables>;

/**
 * __useUpdateContactGroupsMutation__
 *
 * To run a mutation, you first call `useUpdateContactGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContactGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContactGroupsMutation, { data, loading, error }] = useUpdateContactGroupsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContactGroupsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContactGroupsMutation, UpdateContactGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContactGroupsMutation, UpdateContactGroupsMutationVariables>(UpdateContactGroupsDocument, options);
      }
export type UpdateContactGroupsMutationHookResult = ReturnType<typeof useUpdateContactGroupsMutation>;
export type UpdateContactGroupsMutationResult = Apollo.MutationResult<UpdateContactGroupsMutation>;
export type UpdateContactGroupsMutationOptions = Apollo.BaseMutationOptions<UpdateContactGroupsMutation, UpdateContactGroupsMutationVariables>;
export const ContactFormsDocument = gql`
    query ContactForms($id: UUID!) {
  contact(id: $id) {
    id
    waivers {
      edges {
        node {
          id
          type
          createdAt
        }
      }
    }
    forms {
      ...ContactFormItem
    }
  }
}
    ${ContactFormItemFragmentDoc}`;

/**
 * __useContactFormsQuery__
 *
 * To run a query within a React component, call `useContactFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactFormsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactFormsQuery(baseOptions: Apollo.QueryHookOptions<ContactFormsQuery, ContactFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactFormsQuery, ContactFormsQueryVariables>(ContactFormsDocument, options);
      }
export function useContactFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactFormsQuery, ContactFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactFormsQuery, ContactFormsQueryVariables>(ContactFormsDocument, options);
        }
export type ContactFormsQueryHookResult = ReturnType<typeof useContactFormsQuery>;
export type ContactFormsLazyQueryHookResult = ReturnType<typeof useContactFormsLazyQuery>;
export type ContactFormsQueryResult = Apollo.QueryResult<ContactFormsQuery, ContactFormsQueryVariables>;
export const ContactPackagesDocument = gql`
    query ContactPackages($id: UUID!) {
  contact(id: $id) {
    id
    packages(status: "DE") {
      totalCount
      edges {
        node {
          id
          user {
            id
          }
          lastAction
          location
          pickupLocation
          home {
            id
            name
            postcode
          }
        }
      }
    }
  }
}
    `;

/**
 * __useContactPackagesQuery__
 *
 * To run a query within a React component, call `useContactPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactPackagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContactPackagesQuery(baseOptions: Apollo.QueryHookOptions<ContactPackagesQuery, ContactPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactPackagesQuery, ContactPackagesQueryVariables>(ContactPackagesDocument, options);
      }
export function useContactPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactPackagesQuery, ContactPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactPackagesQuery, ContactPackagesQueryVariables>(ContactPackagesDocument, options);
        }
export type ContactPackagesQueryHookResult = ReturnType<typeof useContactPackagesQuery>;
export type ContactPackagesLazyQueryHookResult = ReturnType<typeof useContactPackagesLazyQuery>;
export type ContactPackagesQueryResult = Apollo.QueryResult<ContactPackagesQuery, ContactPackagesQueryVariables>;
export const ContactPackagesReminderDocument = gql`
    mutation ContactPackagesReminder($input: ContactPackagesReminderInput!) {
  contactPackagesReminder(input: $input) {
    ok
  }
}
    `;
export type ContactPackagesReminderMutationFn = Apollo.MutationFunction<ContactPackagesReminderMutation, ContactPackagesReminderMutationVariables>;

/**
 * __useContactPackagesReminderMutation__
 *
 * To run a mutation, you first call `useContactPackagesReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useContactPackagesReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [contactPackagesReminderMutation, { data, loading, error }] = useContactPackagesReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useContactPackagesReminderMutation(baseOptions?: Apollo.MutationHookOptions<ContactPackagesReminderMutation, ContactPackagesReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ContactPackagesReminderMutation, ContactPackagesReminderMutationVariables>(ContactPackagesReminderDocument, options);
      }
export type ContactPackagesReminderMutationHookResult = ReturnType<typeof useContactPackagesReminderMutation>;
export type ContactPackagesReminderMutationResult = Apollo.MutationResult<ContactPackagesReminderMutation>;
export type ContactPackagesReminderMutationOptions = Apollo.BaseMutationOptions<ContactPackagesReminderMutation, ContactPackagesReminderMutationVariables>;
export const ContactSafetyRecordsDocument = gql`
    query ContactSafetyRecords($contactId: UUID!) {
  residentSafetyRecords(
    user: $contactId
    includeArchived: true
    orderBy: "-created_at"
  ) {
    edges {
      node {
        ...ContactSafetyRecordItem
      }
    }
  }
}
    ${ContactSafetyRecordItemFragmentDoc}`;

/**
 * __useContactSafetyRecordsQuery__
 *
 * To run a query within a React component, call `useContactSafetyRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContactSafetyRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContactSafetyRecordsQuery({
 *   variables: {
 *      contactId: // value for 'contactId'
 *   },
 * });
 */
export function useContactSafetyRecordsQuery(baseOptions: Apollo.QueryHookOptions<ContactSafetyRecordsQuery, ContactSafetyRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContactSafetyRecordsQuery, ContactSafetyRecordsQueryVariables>(ContactSafetyRecordsDocument, options);
      }
export function useContactSafetyRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContactSafetyRecordsQuery, ContactSafetyRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContactSafetyRecordsQuery, ContactSafetyRecordsQueryVariables>(ContactSafetyRecordsDocument, options);
        }
export type ContactSafetyRecordsQueryHookResult = ReturnType<typeof useContactSafetyRecordsQuery>;
export type ContactSafetyRecordsLazyQueryHookResult = ReturnType<typeof useContactSafetyRecordsLazyQuery>;
export type ContactSafetyRecordsQueryResult = Apollo.QueryResult<ContactSafetyRecordsQuery, ContactSafetyRecordsQueryVariables>;
export const ClientContractorCompanyDocument = gql`
    query ClientContractorCompany($id: UUID!) {
  clientContractorCompany(id: $id) {
    ...ContractorCompanyItem
  }
}
    ${ContractorCompanyItemFragmentDoc}`;

/**
 * __useClientContractorCompanyQuery__
 *
 * To run a query within a React component, call `useClientContractorCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractorCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractorCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientContractorCompanyQuery(baseOptions: Apollo.QueryHookOptions<ClientContractorCompanyQuery, ClientContractorCompanyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientContractorCompanyQuery, ClientContractorCompanyQueryVariables>(ClientContractorCompanyDocument, options);
      }
export function useClientContractorCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientContractorCompanyQuery, ClientContractorCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientContractorCompanyQuery, ClientContractorCompanyQueryVariables>(ClientContractorCompanyDocument, options);
        }
export type ClientContractorCompanyQueryHookResult = ReturnType<typeof useClientContractorCompanyQuery>;
export type ClientContractorCompanyLazyQueryHookResult = ReturnType<typeof useClientContractorCompanyLazyQuery>;
export type ClientContractorCompanyQueryResult = Apollo.QueryResult<ClientContractorCompanyQuery, ClientContractorCompanyQueryVariables>;
export const CreateClientContractorCompanyDocument = gql`
    mutation CreateClientContractorCompany($input: CreateClientContractorCompanyInput!) {
  createClientContractorCompany(input: $input) {
    clientContractorCompany {
      id
      name
      companyType
      email
      phone
      address
      website
      notes
      isActive
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
      contractors {
        edges {
          node {
            id
            name
            email
            phone
            jobTitle
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateClientContractorCompanyMutationFn = Apollo.MutationFunction<CreateClientContractorCompanyMutation, CreateClientContractorCompanyMutationVariables>;

/**
 * __useCreateClientContractorCompanyMutation__
 *
 * To run a mutation, you first call `useCreateClientContractorCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientContractorCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientContractorCompanyMutation, { data, loading, error }] = useCreateClientContractorCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientContractorCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientContractorCompanyMutation, CreateClientContractorCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientContractorCompanyMutation, CreateClientContractorCompanyMutationVariables>(CreateClientContractorCompanyDocument, options);
      }
export type CreateClientContractorCompanyMutationHookResult = ReturnType<typeof useCreateClientContractorCompanyMutation>;
export type CreateClientContractorCompanyMutationResult = Apollo.MutationResult<CreateClientContractorCompanyMutation>;
export type CreateClientContractorCompanyMutationOptions = Apollo.BaseMutationOptions<CreateClientContractorCompanyMutation, CreateClientContractorCompanyMutationVariables>;
export const CreateContractorDocument = gql`
    mutation CreateContractor($input: CreateContractorInput!) {
  createContractor(input: $input) {
    clientContractorCompany {
      id
      contractors {
        edges {
          node {
            id
            name
            email
            phone
            jobTitle
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateContractorMutationFn = Apollo.MutationFunction<CreateContractorMutation, CreateContractorMutationVariables>;

/**
 * __useCreateContractorMutation__
 *
 * To run a mutation, you first call `useCreateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContractorMutation, { data, loading, error }] = useCreateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContractorMutation(baseOptions?: Apollo.MutationHookOptions<CreateContractorMutation, CreateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContractorMutation, CreateContractorMutationVariables>(CreateContractorDocument, options);
      }
export type CreateContractorMutationHookResult = ReturnType<typeof useCreateContractorMutation>;
export type CreateContractorMutationResult = Apollo.MutationResult<CreateContractorMutation>;
export type CreateContractorMutationOptions = Apollo.BaseMutationOptions<CreateContractorMutation, CreateContractorMutationVariables>;
export const SearchContractorCompaniesDocument = gql`
    query SearchContractorCompanies($search: String!, $first: Int) {
  clientContractorCompanies(search: $search, first: $first) {
    edges {
      node {
        id
        name
        communities {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchContractorCompaniesQuery__
 *
 * To run a query within a React component, call `useSearchContractorCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContractorCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContractorCompaniesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchContractorCompaniesQuery(baseOptions: Apollo.QueryHookOptions<SearchContractorCompaniesQuery, SearchContractorCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContractorCompaniesQuery, SearchContractorCompaniesQueryVariables>(SearchContractorCompaniesDocument, options);
      }
export function useSearchContractorCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContractorCompaniesQuery, SearchContractorCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContractorCompaniesQuery, SearchContractorCompaniesQueryVariables>(SearchContractorCompaniesDocument, options);
        }
export type SearchContractorCompaniesQueryHookResult = ReturnType<typeof useSearchContractorCompaniesQuery>;
export type SearchContractorCompaniesLazyQueryHookResult = ReturnType<typeof useSearchContractorCompaniesLazyQuery>;
export type SearchContractorCompaniesQueryResult = Apollo.QueryResult<SearchContractorCompaniesQuery, SearchContractorCompaniesQueryVariables>;
export const UpdateClientContractorCompanyDocument = gql`
    mutation UpdateClientContractorCompany($input: UpdateClientContractorCompanyInput!) {
  updateClientContractorCompany(input: $input) {
    clientContractorCompany {
      id
      name
      companyType
      email
      phone
      address
      website
      notes
      isActive
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateClientContractorCompanyMutationFn = Apollo.MutationFunction<UpdateClientContractorCompanyMutation, UpdateClientContractorCompanyMutationVariables>;

/**
 * __useUpdateClientContractorCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateClientContractorCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientContractorCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientContractorCompanyMutation, { data, loading, error }] = useUpdateClientContractorCompanyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientContractorCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientContractorCompanyMutation, UpdateClientContractorCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientContractorCompanyMutation, UpdateClientContractorCompanyMutationVariables>(UpdateClientContractorCompanyDocument, options);
      }
export type UpdateClientContractorCompanyMutationHookResult = ReturnType<typeof useUpdateClientContractorCompanyMutation>;
export type UpdateClientContractorCompanyMutationResult = Apollo.MutationResult<UpdateClientContractorCompanyMutation>;
export type UpdateClientContractorCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateClientContractorCompanyMutation, UpdateClientContractorCompanyMutationVariables>;
export const UpdateClientContractorCompanyCommunitiesDocument = gql`
    mutation UpdateClientContractorCompanyCommunities($input: UpdateClientContractorCompanyCommunitiesInput!) {
  updateClientContractorCompanyCommunities(input: $input) {
    clientContractorCompany {
      id
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateClientContractorCompanyCommunitiesMutationFn = Apollo.MutationFunction<UpdateClientContractorCompanyCommunitiesMutation, UpdateClientContractorCompanyCommunitiesMutationVariables>;

/**
 * __useUpdateClientContractorCompanyCommunitiesMutation__
 *
 * To run a mutation, you first call `useUpdateClientContractorCompanyCommunitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientContractorCompanyCommunitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientContractorCompanyCommunitiesMutation, { data, loading, error }] = useUpdateClientContractorCompanyCommunitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientContractorCompanyCommunitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientContractorCompanyCommunitiesMutation, UpdateClientContractorCompanyCommunitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientContractorCompanyCommunitiesMutation, UpdateClientContractorCompanyCommunitiesMutationVariables>(UpdateClientContractorCompanyCommunitiesDocument, options);
      }
export type UpdateClientContractorCompanyCommunitiesMutationHookResult = ReturnType<typeof useUpdateClientContractorCompanyCommunitiesMutation>;
export type UpdateClientContractorCompanyCommunitiesMutationResult = Apollo.MutationResult<UpdateClientContractorCompanyCommunitiesMutation>;
export type UpdateClientContractorCompanyCommunitiesMutationOptions = Apollo.BaseMutationOptions<UpdateClientContractorCompanyCommunitiesMutation, UpdateClientContractorCompanyCommunitiesMutationVariables>;
export const UpdateContractorDocument = gql`
    mutation UpdateContractor($input: UpdateContractorInput!) {
  updateContractor(input: $input) {
    contractor {
      id
      name
      email
      phone
      jobTitle
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateContractorMutationFn = Apollo.MutationFunction<UpdateContractorMutation, UpdateContractorMutationVariables>;

/**
 * __useUpdateContractorMutation__
 *
 * To run a mutation, you first call `useUpdateContractorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractorMutation, { data, loading, error }] = useUpdateContractorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContractorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractorMutation, UpdateContractorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractorMutation, UpdateContractorMutationVariables>(UpdateContractorDocument, options);
      }
export type UpdateContractorMutationHookResult = ReturnType<typeof useUpdateContractorMutation>;
export type UpdateContractorMutationResult = Apollo.MutationResult<UpdateContractorMutation>;
export type UpdateContractorMutationOptions = Apollo.BaseMutationOptions<UpdateContractorMutation, UpdateContractorMutationVariables>;
export const ClientContractorCompaniesDocument = gql`
    query ClientContractorCompanies($after: String, $first: Int, $search: String, $communities: [ID!], $isActive: Boolean, $orderBy: String) {
  clientContractorCompanies(
    after: $after
    first: $first
    search: $search
    communities: $communities
    isActive: $isActive
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ContractorCompanyItem
      }
    }
  }
}
    ${ContractorCompanyItemFragmentDoc}`;

/**
 * __useClientContractorCompaniesQuery__
 *
 * To run a query within a React component, call `useClientContractorCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientContractorCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientContractorCompaniesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      isActive: // value for 'isActive'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useClientContractorCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<ClientContractorCompaniesQuery, ClientContractorCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientContractorCompaniesQuery, ClientContractorCompaniesQueryVariables>(ClientContractorCompaniesDocument, options);
      }
export function useClientContractorCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientContractorCompaniesQuery, ClientContractorCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientContractorCompaniesQuery, ClientContractorCompaniesQueryVariables>(ClientContractorCompaniesDocument, options);
        }
export type ClientContractorCompaniesQueryHookResult = ReturnType<typeof useClientContractorCompaniesQuery>;
export type ClientContractorCompaniesLazyQueryHookResult = ReturnType<typeof useClientContractorCompaniesLazyQuery>;
export type ClientContractorCompaniesQueryResult = Apollo.QueryResult<ClientContractorCompaniesQuery, ClientContractorCompaniesQueryVariables>;
export const CommunityStatusDocument = gql`
    query CommunityStatus($id: UUID!) {
  community(id: $id) {
    id
    status
  }
}
    `;

/**
 * __useCommunityStatusQuery__
 *
 * To run a query within a React component, call `useCommunityStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityStatusQuery(baseOptions: Apollo.QueryHookOptions<CommunityStatusQuery, CommunityStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityStatusQuery, CommunityStatusQueryVariables>(CommunityStatusDocument, options);
      }
export function useCommunityStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityStatusQuery, CommunityStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityStatusQuery, CommunityStatusQueryVariables>(CommunityStatusDocument, options);
        }
export type CommunityStatusQueryHookResult = ReturnType<typeof useCommunityStatusQuery>;
export type CommunityStatusLazyQueryHookResult = ReturnType<typeof useCommunityStatusLazyQuery>;
export type CommunityStatusQueryResult = Apollo.QueryResult<CommunityStatusQuery, CommunityStatusQueryVariables>;
export const ListConversationsLightDocument = gql`
    query listConversationsLight($communities: [ID], $home: UUID, $status: [String], $first: Int, $after: String, $search: String, $orderBy: String, $isUrgent: String, $date: Date, $dateFrom: Date, $dateTo: Date, $contactId: UUID, $clientId: UUID, $residencyId: UUID, $assignedTo: String, $unanswered: [String], $assignedUsers: [String], $teams: [String], $source: [String], $participantType: [String], $clientTags: [String], $inactive: Boolean, $block: UUID) {
  conversations(
    communities: $communities
    home: $home
    status: $status
    first: $first
    after: $after
    search: $search
    orderBy: $orderBy
    isUrgent: $isUrgent
    date: $date
    dateFrom: $dateFrom
    dateTo: $dateTo
    contact: $contactId
    client: $clientId
    residency: $residencyId
    assignedTo: $assignedTo
    unanswered: $unanswered
    assignedUsers: $assignedUsers
    teams: $teams
    source: $source
    participantType: $participantType
    clientTags: $clientTags
    inactive: $inactive
    block: $block
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ConversationListItemLight
      }
    }
  }
}
    ${ConversationListItemLightFragmentDoc}`;

/**
 * __useListConversationsLightQuery__
 *
 * To run a query within a React component, call `useListConversationsLightQuery` and pass it any options that fit your needs.
 * When your component renders, `useListConversationsLightQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListConversationsLightQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      home: // value for 'home'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      isUrgent: // value for 'isUrgent'
 *      date: // value for 'date'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      contactId: // value for 'contactId'
 *      clientId: // value for 'clientId'
 *      residencyId: // value for 'residencyId'
 *      assignedTo: // value for 'assignedTo'
 *      unanswered: // value for 'unanswered'
 *      assignedUsers: // value for 'assignedUsers'
 *      teams: // value for 'teams'
 *      source: // value for 'source'
 *      participantType: // value for 'participantType'
 *      clientTags: // value for 'clientTags'
 *      inactive: // value for 'inactive'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useListConversationsLightQuery(baseOptions?: Apollo.QueryHookOptions<ListConversationsLightQuery, ListConversationsLightQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListConversationsLightQuery, ListConversationsLightQueryVariables>(ListConversationsLightDocument, options);
      }
export function useListConversationsLightLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListConversationsLightQuery, ListConversationsLightQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListConversationsLightQuery, ListConversationsLightQueryVariables>(ListConversationsLightDocument, options);
        }
export type ListConversationsLightQueryHookResult = ReturnType<typeof useListConversationsLightQuery>;
export type ListConversationsLightLazyQueryHookResult = ReturnType<typeof useListConversationsLightLazyQuery>;
export type ListConversationsLightQueryResult = Apollo.QueryResult<ListConversationsLightQuery, ListConversationsLightQueryVariables>;
export const ListHomesToMessageDocument = gql`
    query ListHomesToMessage($communityId: UUID) {
  listHomes(communityId: $communityId) {
    id
    name
  }
}
    `;

/**
 * __useListHomesToMessageQuery__
 *
 * To run a query within a React component, call `useListHomesToMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomesToMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomesToMessageQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useListHomesToMessageQuery(baseOptions?: Apollo.QueryHookOptions<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>(ListHomesToMessageDocument, options);
      }
export function useListHomesToMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>(ListHomesToMessageDocument, options);
        }
export type ListHomesToMessageQueryHookResult = ReturnType<typeof useListHomesToMessageQuery>;
export type ListHomesToMessageLazyQueryHookResult = ReturnType<typeof useListHomesToMessageLazyQuery>;
export type ListHomesToMessageQueryResult = Apollo.QueryResult<ListHomesToMessageQuery, ListHomesToMessageQueryVariables>;
export const UpdateConversationNoteDocument = gql`
    mutation UpdateConversationNote($input: UpdateConversationNoteInput!) {
  updateConversationNote(input: $input) {
    conversationNote {
      id
      text
      updatedAt
      user {
        id
        name
      }
    }
  }
}
    `;
export type UpdateConversationNoteMutationFn = Apollo.MutationFunction<UpdateConversationNoteMutation, UpdateConversationNoteMutationVariables>;

/**
 * __useUpdateConversationNoteMutation__
 *
 * To run a mutation, you first call `useUpdateConversationNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateConversationNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateConversationNoteMutation, { data, loading, error }] = useUpdateConversationNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateConversationNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateConversationNoteMutation, UpdateConversationNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateConversationNoteMutation, UpdateConversationNoteMutationVariables>(UpdateConversationNoteDocument, options);
      }
export type UpdateConversationNoteMutationHookResult = ReturnType<typeof useUpdateConversationNoteMutation>;
export type UpdateConversationNoteMutationResult = Apollo.MutationResult<UpdateConversationNoteMutation>;
export type UpdateConversationNoteMutationOptions = Apollo.BaseMutationOptions<UpdateConversationNoteMutation, UpdateConversationNoteMutationVariables>;
export const AssignTeamDocument = gql`
    mutation AssignTeam($input: AssignTeamInput!) {
  assignTeam(input: $input) {
    conversation {
      id
      teamAssignment {
        id
        team {
          id
          name
          icon
        }
      }
    }
  }
}
    `;
export type AssignTeamMutationFn = Apollo.MutationFunction<AssignTeamMutation, AssignTeamMutationVariables>;

/**
 * __useAssignTeamMutation__
 *
 * To run a mutation, you first call `useAssignTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTeamMutation, { data, loading, error }] = useAssignTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTeamMutation(baseOptions?: Apollo.MutationHookOptions<AssignTeamMutation, AssignTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTeamMutation, AssignTeamMutationVariables>(AssignTeamDocument, options);
      }
export type AssignTeamMutationHookResult = ReturnType<typeof useAssignTeamMutation>;
export type AssignTeamMutationResult = Apollo.MutationResult<AssignTeamMutation>;
export type AssignTeamMutationOptions = Apollo.BaseMutationOptions<AssignTeamMutation, AssignTeamMutationVariables>;
export const TeamsForAssignmentDocument = gql`
    query TeamsForAssignment($communities: [ID!], $search: String) {
  teams(communities: $communities, search: $search, status: ["ACTIVATED"]) {
    edges {
      node {
        id
        name
        icon
      }
    }
  }
}
    `;

/**
 * __useTeamsForAssignmentQuery__
 *
 * To run a query within a React component, call `useTeamsForAssignmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamsForAssignmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamsForAssignmentQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTeamsForAssignmentQuery(baseOptions?: Apollo.QueryHookOptions<TeamsForAssignmentQuery, TeamsForAssignmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamsForAssignmentQuery, TeamsForAssignmentQueryVariables>(TeamsForAssignmentDocument, options);
      }
export function useTeamsForAssignmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamsForAssignmentQuery, TeamsForAssignmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamsForAssignmentQuery, TeamsForAssignmentQueryVariables>(TeamsForAssignmentDocument, options);
        }
export type TeamsForAssignmentQueryHookResult = ReturnType<typeof useTeamsForAssignmentQuery>;
export type TeamsForAssignmentLazyQueryHookResult = ReturnType<typeof useTeamsForAssignmentLazyQuery>;
export type TeamsForAssignmentQueryResult = Apollo.QueryResult<TeamsForAssignmentQuery, TeamsForAssignmentQueryVariables>;
export const UnassignTeamDocument = gql`
    mutation UnassignTeam($input: UnassignTeamInput!) {
  unassignTeam(input: $input) {
    conversation {
      id
      teamAssignment {
        id
        team {
          id
          name
          icon
        }
      }
    }
  }
}
    `;
export type UnassignTeamMutationFn = Apollo.MutationFunction<UnassignTeamMutation, UnassignTeamMutationVariables>;

/**
 * __useUnassignTeamMutation__
 *
 * To run a mutation, you first call `useUnassignTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignTeamMutation, { data, loading, error }] = useUnassignTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignTeamMutation(baseOptions?: Apollo.MutationHookOptions<UnassignTeamMutation, UnassignTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignTeamMutation, UnassignTeamMutationVariables>(UnassignTeamDocument, options);
      }
export type UnassignTeamMutationHookResult = ReturnType<typeof useUnassignTeamMutation>;
export type UnassignTeamMutationResult = Apollo.MutationResult<UnassignTeamMutation>;
export type UnassignTeamMutationOptions = Apollo.BaseMutationOptions<UnassignTeamMutation, UnassignTeamMutationVariables>;
export const BulkConversationActionJobDocument = gql`
    query BulkConversationActionJob($id: UUID!) {
  bulkConversationActionJob(id: $id) {
    id
    status
    total
    processed
    succeeded
    skipped
    failed
    startedAt
    finishedAt
  }
}
    `;

/**
 * __useBulkConversationActionJobQuery__
 *
 * To run a query within a React component, call `useBulkConversationActionJobQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkConversationActionJobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkConversationActionJobQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBulkConversationActionJobQuery(baseOptions: Apollo.QueryHookOptions<BulkConversationActionJobQuery, BulkConversationActionJobQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkConversationActionJobQuery, BulkConversationActionJobQueryVariables>(BulkConversationActionJobDocument, options);
      }
export function useBulkConversationActionJobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkConversationActionJobQuery, BulkConversationActionJobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkConversationActionJobQuery, BulkConversationActionJobQueryVariables>(BulkConversationActionJobDocument, options);
        }
export type BulkConversationActionJobQueryHookResult = ReturnType<typeof useBulkConversationActionJobQuery>;
export type BulkConversationActionJobLazyQueryHookResult = ReturnType<typeof useBulkConversationActionJobLazyQuery>;
export type BulkConversationActionJobQueryResult = Apollo.QueryResult<BulkConversationActionJobQuery, BulkConversationActionJobQueryVariables>;
export const InactiveOwedBreakdownDocument = gql`
    query InactiveOwedBreakdown($communities: [ID], $status: [String], $search: String, $assignedTo: String, $assignedUsers: [String], $teams: [String], $source: [String], $participantType: [String], $clientTags: [String], $dateFrom: Date, $dateTo: Date) {
  owed: conversations(
    communities: $communities
    status: $status
    search: $search
    assignedTo: $assignedTo
    assignedUsers: $assignedUsers
    teams: $teams
    source: $source
    participantType: $participantType
    clientTags: $clientTags
    dateFrom: $dateFrom
    dateTo: $dateTo
    inactive: true
    direction: "resident_waiting"
  ) {
    totalCount
  }
}
    `;

/**
 * __useInactiveOwedBreakdownQuery__
 *
 * To run a query within a React component, call `useInactiveOwedBreakdownQuery` and pass it any options that fit your needs.
 * When your component renders, `useInactiveOwedBreakdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInactiveOwedBreakdownQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      status: // value for 'status'
 *      search: // value for 'search'
 *      assignedTo: // value for 'assignedTo'
 *      assignedUsers: // value for 'assignedUsers'
 *      teams: // value for 'teams'
 *      source: // value for 'source'
 *      participantType: // value for 'participantType'
 *      clientTags: // value for 'clientTags'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function useInactiveOwedBreakdownQuery(baseOptions?: Apollo.QueryHookOptions<InactiveOwedBreakdownQuery, InactiveOwedBreakdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InactiveOwedBreakdownQuery, InactiveOwedBreakdownQueryVariables>(InactiveOwedBreakdownDocument, options);
      }
export function useInactiveOwedBreakdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InactiveOwedBreakdownQuery, InactiveOwedBreakdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InactiveOwedBreakdownQuery, InactiveOwedBreakdownQueryVariables>(InactiveOwedBreakdownDocument, options);
        }
export type InactiveOwedBreakdownQueryHookResult = ReturnType<typeof useInactiveOwedBreakdownQuery>;
export type InactiveOwedBreakdownLazyQueryHookResult = ReturnType<typeof useInactiveOwedBreakdownLazyQuery>;
export type InactiveOwedBreakdownQueryResult = Apollo.QueryResult<InactiveOwedBreakdownQuery, InactiveOwedBreakdownQueryVariables>;
export const StartBulkConversationCloseDocument = gql`
    mutation StartBulkConversationClose($conversationIds: [UUID], $filters: BulkConversationCloseFilterInput, $closedReason: String, $consent: Boolean, $action: String, $message: String, $notify: Boolean) {
  startBulkConversationClose(
    conversationIds: $conversationIds
    filters: $filters
    closedReason: $closedReason
    consent: $consent
    action: $action
    message: $message
    notify: $notify
  ) {
    job {
      id
      status
      total
      processed
      succeeded
      skipped
      failed
      startedAt
      finishedAt
    }
  }
}
    `;
export type StartBulkConversationCloseMutationFn = Apollo.MutationFunction<StartBulkConversationCloseMutation, StartBulkConversationCloseMutationVariables>;

/**
 * __useStartBulkConversationCloseMutation__
 *
 * To run a mutation, you first call `useStartBulkConversationCloseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartBulkConversationCloseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startBulkConversationCloseMutation, { data, loading, error }] = useStartBulkConversationCloseMutation({
 *   variables: {
 *      conversationIds: // value for 'conversationIds'
 *      filters: // value for 'filters'
 *      closedReason: // value for 'closedReason'
 *      consent: // value for 'consent'
 *      action: // value for 'action'
 *      message: // value for 'message'
 *      notify: // value for 'notify'
 *   },
 * });
 */
export function useStartBulkConversationCloseMutation(baseOptions?: Apollo.MutationHookOptions<StartBulkConversationCloseMutation, StartBulkConversationCloseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartBulkConversationCloseMutation, StartBulkConversationCloseMutationVariables>(StartBulkConversationCloseDocument, options);
      }
export type StartBulkConversationCloseMutationHookResult = ReturnType<typeof useStartBulkConversationCloseMutation>;
export type StartBulkConversationCloseMutationResult = Apollo.MutationResult<StartBulkConversationCloseMutation>;
export type StartBulkConversationCloseMutationOptions = Apollo.BaseMutationOptions<StartBulkConversationCloseMutation, StartBulkConversationCloseMutationVariables>;
export const NewContactConversationDocument = gql`
    query NewContactConversation($id: UUID!, $contact: UUID!) {
  contact(id: $id) {
    id
    email
    name
  }
  homes(contact: $contact) {
    edges {
      node {
        id
        name
        addressLine1
        community {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useNewContactConversationQuery__
 *
 * To run a query within a React component, call `useNewContactConversationQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewContactConversationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewContactConversationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      contact: // value for 'contact'
 *   },
 * });
 */
export function useNewContactConversationQuery(baseOptions: Apollo.QueryHookOptions<NewContactConversationQuery, NewContactConversationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewContactConversationQuery, NewContactConversationQueryVariables>(NewContactConversationDocument, options);
      }
export function useNewContactConversationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewContactConversationQuery, NewContactConversationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewContactConversationQuery, NewContactConversationQueryVariables>(NewContactConversationDocument, options);
        }
export type NewContactConversationQueryHookResult = ReturnType<typeof useNewContactConversationQuery>;
export type NewContactConversationLazyQueryHookResult = ReturnType<typeof useNewContactConversationLazyQuery>;
export type NewContactConversationQueryResult = Apollo.QueryResult<NewContactConversationQuery, NewContactConversationQueryVariables>;
export const ListResidenciesWithResidentsDocument = gql`
    query ListResidenciesWithResidents($communityId: UUID) {
  listResidencies(communityId: $communityId) {
    id
    startDate
    home {
      id
      name
    }
    residents {
      id
      name
      email
      user {
        id
        hasUsedApp
      }
    }
  }
}
    `;

/**
 * __useListResidenciesWithResidentsQuery__
 *
 * To run a query within a React component, call `useListResidenciesWithResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResidenciesWithResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResidenciesWithResidentsQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useListResidenciesWithResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>(ListResidenciesWithResidentsDocument, options);
      }
export function useListResidenciesWithResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>(ListResidenciesWithResidentsDocument, options);
        }
export type ListResidenciesWithResidentsQueryHookResult = ReturnType<typeof useListResidenciesWithResidentsQuery>;
export type ListResidenciesWithResidentsLazyQueryHookResult = ReturnType<typeof useListResidenciesWithResidentsLazyQuery>;
export type ListResidenciesWithResidentsQueryResult = Apollo.QueryResult<ListResidenciesWithResidentsQuery, ListResidenciesWithResidentsQueryVariables>;
export const ActiveResidentCountDocument = gql`
    query ActiveResidentCount($communities: [ID]) {
  communities(ids: $communities) {
    edges {
      node {
        id
        activeResidentCount: statisticDataPoint(statisticType: ACTIVE_RESIDENT_COUNT) {
          id
          value
        }
        activeResidentCountDifference: statisticDifference(
          statisticType: ACTIVE_RESIDENT_COUNT
        )
      }
    }
  }
}
    `;

/**
 * __useActiveResidentCountQuery__
 *
 * To run a query within a React component, call `useActiveResidentCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveResidentCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveResidentCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useActiveResidentCountQuery(baseOptions?: Apollo.QueryHookOptions<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>(ActiveResidentCountDocument, options);
      }
export function useActiveResidentCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>(ActiveResidentCountDocument, options);
        }
export type ActiveResidentCountQueryHookResult = ReturnType<typeof useActiveResidentCountQuery>;
export type ActiveResidentCountLazyQueryHookResult = ReturnType<typeof useActiveResidentCountLazyQuery>;
export type ActiveResidentCountQueryResult = Apollo.QueryResult<ActiveResidentCountQuery, ActiveResidentCountQueryVariables>;
export const ActiveResidentsHistoricalDataDocument = gql`
    query ActiveResidentsHistoricalData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: ACTIVE_RESIDENT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useActiveResidentsHistoricalDataQuery__
 *
 * To run a query within a React component, call `useActiveResidentsHistoricalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveResidentsHistoricalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveResidentsHistoricalDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useActiveResidentsHistoricalDataQuery(baseOptions?: Apollo.QueryHookOptions<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>(ActiveResidentsHistoricalDataDocument, options);
      }
export function useActiveResidentsHistoricalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>(ActiveResidentsHistoricalDataDocument, options);
        }
export type ActiveResidentsHistoricalDataQueryHookResult = ReturnType<typeof useActiveResidentsHistoricalDataQuery>;
export type ActiveResidentsHistoricalDataLazyQueryHookResult = ReturnType<typeof useActiveResidentsHistoricalDataLazyQuery>;
export type ActiveResidentsHistoricalDataQueryResult = Apollo.QueryResult<ActiveResidentsHistoricalDataQuery, ActiveResidentsHistoricalDataQueryVariables>;
export const AverageDownloadRateDocument = gql`
    query AverageDownloadRate($communities: [ID]) {
  communities(ids: $communities) {
    edges {
      node {
        id
        downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
          id
          value
        }
        downloadRateDifference: statisticDifference(
          statisticType: DOWNLOAD_RATE_PERCENTAGE
        )
      }
    }
  }
}
    `;

/**
 * __useAverageDownloadRateQuery__
 *
 * To run a query within a React component, call `useAverageDownloadRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useAverageDownloadRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAverageDownloadRateQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useAverageDownloadRateQuery(baseOptions?: Apollo.QueryHookOptions<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>(AverageDownloadRateDocument, options);
      }
export function useAverageDownloadRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>(AverageDownloadRateDocument, options);
        }
export type AverageDownloadRateQueryHookResult = ReturnType<typeof useAverageDownloadRateQuery>;
export type AverageDownloadRateLazyQueryHookResult = ReturnType<typeof useAverageDownloadRateLazyQuery>;
export type AverageDownloadRateQueryResult = Apollo.QueryResult<AverageDownloadRateQuery, AverageDownloadRateQueryVariables>;
export const AveragePackageCollectionTimeDataDocument = gql`
    query AveragePackageCollectionTimeData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: AVERAGE_PACKAGE_COLLECTION_TIME
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useAveragePackageCollectionTimeDataQuery__
 *
 * To run a query within a React component, call `useAveragePackageCollectionTimeDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useAveragePackageCollectionTimeDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAveragePackageCollectionTimeDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useAveragePackageCollectionTimeDataQuery(baseOptions?: Apollo.QueryHookOptions<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>(AveragePackageCollectionTimeDataDocument, options);
      }
export function useAveragePackageCollectionTimeDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>(AveragePackageCollectionTimeDataDocument, options);
        }
export type AveragePackageCollectionTimeDataQueryHookResult = ReturnType<typeof useAveragePackageCollectionTimeDataQuery>;
export type AveragePackageCollectionTimeDataLazyQueryHookResult = ReturnType<typeof useAveragePackageCollectionTimeDataLazyQuery>;
export type AveragePackageCollectionTimeDataQueryResult = Apollo.QueryResult<AveragePackageCollectionTimeDataQuery, AveragePackageCollectionTimeDataQueryVariables>;
export const DashboardPageDocument = gql`
    query DashboardPage($communities: [UUID]) {
  dashboard(communities: $communities) {
    openCount
    averageResponseTime
    responseTimeDifference
    allTimeSatisfaction
  }
}
    `;

/**
 * __useDashboardPageQuery__
 *
 * To run a query within a React component, call `useDashboardPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardPageQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useDashboardPageQuery(baseOptions?: Apollo.QueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
      }
export function useDashboardPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardPageQuery, DashboardPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardPageQuery, DashboardPageQueryVariables>(DashboardPageDocument, options);
        }
export type DashboardPageQueryHookResult = ReturnType<typeof useDashboardPageQuery>;
export type DashboardPageLazyQueryHookResult = ReturnType<typeof useDashboardPageLazyQuery>;
export type DashboardPageQueryResult = Apollo.QueryResult<DashboardPageQuery, DashboardPageQueryVariables>;
export const DeliveredPackagesCountsDocument = gql`
    query DeliveredPackagesCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_DELIVERED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useDeliveredPackagesCountsQuery__
 *
 * To run a query within a React component, call `useDeliveredPackagesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDeliveredPackagesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDeliveredPackagesCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useDeliveredPackagesCountsQuery(baseOptions?: Apollo.QueryHookOptions<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>(DeliveredPackagesCountsDocument, options);
      }
export function useDeliveredPackagesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>(DeliveredPackagesCountsDocument, options);
        }
export type DeliveredPackagesCountsQueryHookResult = ReturnType<typeof useDeliveredPackagesCountsQuery>;
export type DeliveredPackagesCountsLazyQueryHookResult = ReturnType<typeof useDeliveredPackagesCountsLazyQuery>;
export type DeliveredPackagesCountsQueryResult = Apollo.QueryResult<DeliveredPackagesCountsQuery, DeliveredPackagesCountsQueryVariables>;
export const GetDownloadRatePerCommunityDocument = gql`
    query GetDownloadRatePerCommunity($communities: [ID]) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        downloadRate: statisticDataPoint(statisticType: DOWNLOAD_RATE_PERCENTAGE) {
          id
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetDownloadRatePerCommunityQuery__
 *
 * To run a query within a React component, call `useGetDownloadRatePerCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadRatePerCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadRatePerCommunityQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetDownloadRatePerCommunityQuery(baseOptions?: Apollo.QueryHookOptions<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>(GetDownloadRatePerCommunityDocument, options);
      }
export function useGetDownloadRatePerCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>(GetDownloadRatePerCommunityDocument, options);
        }
export type GetDownloadRatePerCommunityQueryHookResult = ReturnType<typeof useGetDownloadRatePerCommunityQuery>;
export type GetDownloadRatePerCommunityLazyQueryHookResult = ReturnType<typeof useGetDownloadRatePerCommunityLazyQuery>;
export type GetDownloadRatePerCommunityQueryResult = Apollo.QueryResult<GetDownloadRatePerCommunityQuery, GetDownloadRatePerCommunityQueryVariables>;
export const FacilityBookingsCountDocument = gql`
    query FacilityBookingsCount($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: FACILITY_BOOKINGS_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useFacilityBookingsCountQuery__
 *
 * To run a query within a React component, call `useFacilityBookingsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useFacilityBookingsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFacilityBookingsCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useFacilityBookingsCountQuery(baseOptions?: Apollo.QueryHookOptions<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>(FacilityBookingsCountDocument, options);
      }
export function useFacilityBookingsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>(FacilityBookingsCountDocument, options);
        }
export type FacilityBookingsCountQueryHookResult = ReturnType<typeof useFacilityBookingsCountQuery>;
export type FacilityBookingsCountLazyQueryHookResult = ReturnType<typeof useFacilityBookingsCountLazyQuery>;
export type FacilityBookingsCountQueryResult = Apollo.QueryResult<FacilityBookingsCountQuery, FacilityBookingsCountQueryVariables>;
export const IncomingMessagesCountsDocument = gql`
    query IncomingMessagesCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: INCOMING_MESSAGES_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useIncomingMessagesCountsQuery__
 *
 * To run a query within a React component, call `useIncomingMessagesCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingMessagesCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingMessagesCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useIncomingMessagesCountsQuery(baseOptions?: Apollo.QueryHookOptions<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>(IncomingMessagesCountsDocument, options);
      }
export function useIncomingMessagesCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>(IncomingMessagesCountsDocument, options);
        }
export type IncomingMessagesCountsQueryHookResult = ReturnType<typeof useIncomingMessagesCountsQuery>;
export type IncomingMessagesCountsLazyQueryHookResult = ReturnType<typeof useIncomingMessagesCountsLazyQuery>;
export type IncomingMessagesCountsQueryResult = Apollo.QueryResult<IncomingMessagesCountsQuery, IncomingMessagesCountsQueryVariables>;
export const IncomingMessagesHistoricalDataDocument = gql`
    query IncomingMessagesHistoricalData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: INCOMING_MESSAGES_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useIncomingMessagesHistoricalDataQuery__
 *
 * To run a query within a React component, call `useIncomingMessagesHistoricalDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingMessagesHistoricalDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingMessagesHistoricalDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useIncomingMessagesHistoricalDataQuery(baseOptions?: Apollo.QueryHookOptions<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>(IncomingMessagesHistoricalDataDocument, options);
      }
export function useIncomingMessagesHistoricalDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>(IncomingMessagesHistoricalDataDocument, options);
        }
export type IncomingMessagesHistoricalDataQueryHookResult = ReturnType<typeof useIncomingMessagesHistoricalDataQuery>;
export type IncomingMessagesHistoricalDataLazyQueryHookResult = ReturnType<typeof useIncomingMessagesHistoricalDataLazyQuery>;
export type IncomingMessagesHistoricalDataQueryResult = Apollo.QueryResult<IncomingMessagesHistoricalDataQuery, IncomingMessagesHistoricalDataQueryVariables>;
export const KeyOutCountsDocument = gql`
    query KeyOutCounts($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_OUT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKeyOutCountsQuery__
 *
 * To run a query within a React component, call `useKeyOutCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyOutCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyOutCountsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useKeyOutCountsQuery(baseOptions?: Apollo.QueryHookOptions<KeyOutCountsQuery, KeyOutCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyOutCountsQuery, KeyOutCountsQueryVariables>(KeyOutCountsDocument, options);
      }
export function useKeyOutCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyOutCountsQuery, KeyOutCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyOutCountsQuery, KeyOutCountsQueryVariables>(KeyOutCountsDocument, options);
        }
export type KeyOutCountsQueryHookResult = ReturnType<typeof useKeyOutCountsQuery>;
export type KeyOutCountsLazyQueryHookResult = ReturnType<typeof useKeyOutCountsLazyQuery>;
export type KeyOutCountsQueryResult = Apollo.QueryResult<KeyOutCountsQuery, KeyOutCountsQueryVariables>;
export const KeysGraphDataDocument = gql`
    query KeysGraphData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        keyInStats: statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_IN_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
        keyOutStats: statisticDataPoints(
          frequency: DAILY
          statisticType: KEY_OUT_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __useKeysGraphDataQuery__
 *
 * To run a query within a React component, call `useKeysGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysGraphDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function useKeysGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<KeysGraphDataQuery, KeysGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysGraphDataQuery, KeysGraphDataQueryVariables>(KeysGraphDataDocument, options);
      }
export function useKeysGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysGraphDataQuery, KeysGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysGraphDataQuery, KeysGraphDataQueryVariables>(KeysGraphDataDocument, options);
        }
export type KeysGraphDataQueryHookResult = ReturnType<typeof useKeysGraphDataQuery>;
export type KeysGraphDataLazyQueryHookResult = ReturnType<typeof useKeysGraphDataLazyQuery>;
export type KeysGraphDataQueryResult = Apollo.QueryResult<KeysGraphDataQuery, KeysGraphDataQueryVariables>;
export const KeysOutLiveCountDocument = gql`
    query KeysOutLiveCount($communities: [ID]) {
  keys(communities: $communities, status: "Out", type: "Amenity") {
    totalCount
  }
}
    `;

/**
 * __useKeysOutLiveCountQuery__
 *
 * To run a query within a React component, call `useKeysOutLiveCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysOutLiveCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysOutLiveCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useKeysOutLiveCountQuery(baseOptions?: Apollo.QueryHookOptions<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>(KeysOutLiveCountDocument, options);
      }
export function useKeysOutLiveCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>(KeysOutLiveCountDocument, options);
        }
export type KeysOutLiveCountQueryHookResult = ReturnType<typeof useKeysOutLiveCountQuery>;
export type KeysOutLiveCountLazyQueryHookResult = ReturnType<typeof useKeysOutLiveCountLazyQuery>;
export type KeysOutLiveCountQueryResult = Apollo.QueryResult<KeysOutLiveCountQuery, KeysOutLiveCountQueryVariables>;
export const PackagesGraphDataDocument = gql`
    query PackagesGraphData($communities: [ID], $fromDate: Date) {
  communities(ids: $communities) {
    totalCount
    edges {
      node {
        id
        name
        delivered: statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_DELIVERED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
        collected: statisticDataPoints(
          frequency: DAILY
          statisticType: PACKAGE_COLLECTED_COUNT
          fromDate: $fromDate
        ) {
          id
          date
          value
        }
      }
    }
  }
}
    `;

/**
 * __usePackagesGraphDataQuery__
 *
 * To run a query within a React component, call `usePackagesGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesGraphDataQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      fromDate: // value for 'fromDate'
 *   },
 * });
 */
export function usePackagesGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>(PackagesGraphDataDocument, options);
      }
export function usePackagesGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>(PackagesGraphDataDocument, options);
        }
export type PackagesGraphDataQueryHookResult = ReturnType<typeof usePackagesGraphDataQuery>;
export type PackagesGraphDataLazyQueryHookResult = ReturnType<typeof usePackagesGraphDataLazyQuery>;
export type PackagesGraphDataQueryResult = Apollo.QueryResult<PackagesGraphDataQuery, PackagesGraphDataQueryVariables>;
export const PackagesHeldCountDocument = gql`
    query PackagesHeldCount($communities: [ID]) {
  packages(status: "DE", communities: $communities) {
    totalCount
  }
}
    `;

/**
 * __usePackagesHeldCountQuery__
 *
 * To run a query within a React component, call `usePackagesHeldCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesHeldCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesHeldCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function usePackagesHeldCountQuery(baseOptions?: Apollo.QueryHookOptions<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>(PackagesHeldCountDocument, options);
      }
export function usePackagesHeldCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>(PackagesHeldCountDocument, options);
        }
export type PackagesHeldCountQueryHookResult = ReturnType<typeof usePackagesHeldCountQuery>;
export type PackagesHeldCountLazyQueryHookResult = ReturnType<typeof usePackagesHeldCountLazyQuery>;
export type PackagesHeldCountQueryResult = Apollo.QueryResult<PackagesHeldCountQuery, PackagesHeldCountQueryVariables>;
export const VisitorsOnsiteCountDocument = gql`
    query VisitorsOnsiteCount($communities: [ID]) {
  communityVisitors(communities: $communities, onSite: true) {
    totalCount
  }
}
    `;

/**
 * __useVisitorsOnsiteCountQuery__
 *
 * To run a query within a React component, call `useVisitorsOnsiteCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorsOnsiteCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorsOnsiteCountQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useVisitorsOnsiteCountQuery(baseOptions?: Apollo.QueryHookOptions<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>(VisitorsOnsiteCountDocument, options);
      }
export function useVisitorsOnsiteCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>(VisitorsOnsiteCountDocument, options);
        }
export type VisitorsOnsiteCountQueryHookResult = ReturnType<typeof useVisitorsOnsiteCountQuery>;
export type VisitorsOnsiteCountLazyQueryHookResult = ReturnType<typeof useVisitorsOnsiteCountLazyQuery>;
export type VisitorsOnsiteCountQueryResult = Apollo.QueryResult<VisitorsOnsiteCountQuery, VisitorsOnsiteCountQueryVariables>;
export const ResponseTimeDashboardDocument = gql`
    query ResponseTimeDashboard($communities: [ID], $after: String, $orderBy: String, $hasResponseTime: Boolean) {
  conversations(
    communities: $communities
    after: $after
    orderBy: $orderBy
    hasResponseTime: $hasResponseTime
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        subject
        responseTime
        closedAt
        snoozedUntil
        user {
          id
          firstName
          lastName
        }
        home {
          name
        }
        hasUnread
        latestEvent {
          ... on ConversationMessageType {
            id
            body
            createdAt
          }
          ... on ConversationMediaType {
            id
            createdAt
          }
          ... on ConversationActionModelType {
            id
            createdAt
          }
        }
      }
    }
  }
}
    `;

/**
 * __useResponseTimeDashboardQuery__
 *
 * To run a query within a React component, call `useResponseTimeDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useResponseTimeDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResponseTimeDashboardQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      hasResponseTime: // value for 'hasResponseTime'
 *   },
 * });
 */
export function useResponseTimeDashboardQuery(baseOptions?: Apollo.QueryHookOptions<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>(ResponseTimeDashboardDocument, options);
      }
export function useResponseTimeDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>(ResponseTimeDashboardDocument, options);
        }
export type ResponseTimeDashboardQueryHookResult = ReturnType<typeof useResponseTimeDashboardQuery>;
export type ResponseTimeDashboardLazyQueryHookResult = ReturnType<typeof useResponseTimeDashboardLazyQuery>;
export type ResponseTimeDashboardQueryResult = Apollo.QueryResult<ResponseTimeDashboardQuery, ResponseTimeDashboardQueryVariables>;
export const GetAverageResponseTimeDocument = gql`
    query GetAverageResponseTime($communities: [UUID]) {
  dashboard(communities: $communities) {
    responseTimeOverTime {
      date
      averageResponseTime
    }
  }
}
    `;

/**
 * __useGetAverageResponseTimeQuery__
 *
 * To run a query within a React component, call `useGetAverageResponseTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageResponseTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageResponseTimeQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetAverageResponseTimeQuery(baseOptions?: Apollo.QueryHookOptions<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>(GetAverageResponseTimeDocument, options);
      }
export function useGetAverageResponseTimeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>(GetAverageResponseTimeDocument, options);
        }
export type GetAverageResponseTimeQueryHookResult = ReturnType<typeof useGetAverageResponseTimeQuery>;
export type GetAverageResponseTimeLazyQueryHookResult = ReturnType<typeof useGetAverageResponseTimeLazyQuery>;
export type GetAverageResponseTimeQueryResult = Apollo.QueryResult<GetAverageResponseTimeQuery, GetAverageResponseTimeQueryVariables>;
export const GetAverageSatisfactionScoresDocument = gql`
    query GetAverageSatisfactionScores($communities: [UUID]) {
  dashboard(communities: $communities) {
    ratingsOverTime {
      date
      averageRating
    }
  }
}
    `;

/**
 * __useGetAverageSatisfactionScoresQuery__
 *
 * To run a query within a React component, call `useGetAverageSatisfactionScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageSatisfactionScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageSatisfactionScoresQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetAverageSatisfactionScoresQuery(baseOptions?: Apollo.QueryHookOptions<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>(GetAverageSatisfactionScoresDocument, options);
      }
export function useGetAverageSatisfactionScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>(GetAverageSatisfactionScoresDocument, options);
        }
export type GetAverageSatisfactionScoresQueryHookResult = ReturnType<typeof useGetAverageSatisfactionScoresQuery>;
export type GetAverageSatisfactionScoresLazyQueryHookResult = ReturnType<typeof useGetAverageSatisfactionScoresLazyQuery>;
export type GetAverageSatisfactionScoresQueryResult = Apollo.QueryResult<GetAverageSatisfactionScoresQuery, GetAverageSatisfactionScoresQueryVariables>;
export const GetDownloadRateDocument = gql`
    query GetDownloadRate($communities: [UUID]) {
  dashboard(communities: $communities) {
    downloadRateOverTime {
      date
      downloadRate
    }
  }
}
    `;

/**
 * __useGetDownloadRateQuery__
 *
 * To run a query within a React component, call `useGetDownloadRateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDownloadRateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDownloadRateQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useGetDownloadRateQuery(baseOptions?: Apollo.QueryHookOptions<GetDownloadRateQuery, GetDownloadRateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDownloadRateQuery, GetDownloadRateQueryVariables>(GetDownloadRateDocument, options);
      }
export function useGetDownloadRateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDownloadRateQuery, GetDownloadRateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDownloadRateQuery, GetDownloadRateQueryVariables>(GetDownloadRateDocument, options);
        }
export type GetDownloadRateQueryHookResult = ReturnType<typeof useGetDownloadRateQuery>;
export type GetDownloadRateLazyQueryHookResult = ReturnType<typeof useGetDownloadRateLazyQuery>;
export type GetDownloadRateQueryResult = Apollo.QueryResult<GetDownloadRateQuery, GetDownloadRateQueryVariables>;
export const ListDashboardResidentsDocument = gql`
    query ListDashboardResidents($communities: [ID], $after: String, $downloaded: Boolean, $orderBy: String) {
  residents(
    communities: $communities
    after: $after
    downloaded: $downloaded
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        user {
          id
          lastAppUse
        }
        id
        name
        averageScore
        email
        currentResidencies {
          home {
            id
            name
            city
          }
        }
      }
    }
  }
}
    `;

/**
 * __useListDashboardResidentsQuery__
 *
 * To run a query within a React component, call `useListDashboardResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListDashboardResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListDashboardResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      downloaded: // value for 'downloaded'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListDashboardResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>(ListDashboardResidentsDocument, options);
      }
export function useListDashboardResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>(ListDashboardResidentsDocument, options);
        }
export type ListDashboardResidentsQueryHookResult = ReturnType<typeof useListDashboardResidentsQuery>;
export type ListDashboardResidentsLazyQueryHookResult = ReturnType<typeof useListDashboardResidentsLazyQuery>;
export type ListDashboardResidentsQueryResult = Apollo.QueryResult<ListDashboardResidentsQuery, ListDashboardResidentsQueryVariables>;
export const ListEngagementResidentsDocument = gql`
    query ListEngagementResidents($communities: [ID], $after: String, $downloaded: Boolean, $orderBy: String) {
  residents(
    communities: $communities
    after: $after
    downloaded: $downloaded
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ResidentItem
      }
    }
  }
}
    ${ResidentItemFragmentDoc}`;

/**
 * __useListEngagementResidentsQuery__
 *
 * To run a query within a React component, call `useListEngagementResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEngagementResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEngagementResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      downloaded: // value for 'downloaded'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useListEngagementResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>(ListEngagementResidentsDocument, options);
      }
export function useListEngagementResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>(ListEngagementResidentsDocument, options);
        }
export type ListEngagementResidentsQueryHookResult = ReturnType<typeof useListEngagementResidentsQuery>;
export type ListEngagementResidentsLazyQueryHookResult = ReturnType<typeof useListEngagementResidentsLazyQuery>;
export type ListEngagementResidentsQueryResult = Apollo.QueryResult<ListEngagementResidentsQuery, ListEngagementResidentsQueryVariables>;
export const ListEngagementScoresDocument = gql`
    query ListEngagementScores($communities: [UUID]) {
  dashboard(communities: $communities) {
    listEngagementScores {
      score
      createdAt
    }
  }
}
    `;

/**
 * __useListEngagementScoresQuery__
 *
 * To run a query within a React component, call `useListEngagementScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEngagementScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEngagementScoresQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useListEngagementScoresQuery(baseOptions?: Apollo.QueryHookOptions<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>(ListEngagementScoresDocument, options);
      }
export function useListEngagementScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>(ListEngagementScoresDocument, options);
        }
export type ListEngagementScoresQueryHookResult = ReturnType<typeof useListEngagementScoresQuery>;
export type ListEngagementScoresLazyQueryHookResult = ReturnType<typeof useListEngagementScoresLazyQuery>;
export type ListEngagementScoresQueryResult = Apollo.QueryResult<ListEngagementScoresQuery, ListEngagementScoresQueryVariables>;
export const ListSatisfactionScoreResidentsDocument = gql`
    query ListSatisfactionScoreResidents($communities: [ID], $after: String, $orderBy: String, $withRating: Boolean) {
  residents(
    communities: $communities
    after: $after
    withRating: $withRating
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...ResidentItem
      }
    }
  }
}
    ${ResidentItemFragmentDoc}`;

/**
 * __useListSatisfactionScoreResidentsQuery__
 *
 * To run a query within a React component, call `useListSatisfactionScoreResidentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListSatisfactionScoreResidentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListSatisfactionScoreResidentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      withRating: // value for 'withRating'
 *   },
 * });
 */
export function useListSatisfactionScoreResidentsQuery(baseOptions?: Apollo.QueryHookOptions<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>(ListSatisfactionScoreResidentsDocument, options);
      }
export function useListSatisfactionScoreResidentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>(ListSatisfactionScoreResidentsDocument, options);
        }
export type ListSatisfactionScoreResidentsQueryHookResult = ReturnType<typeof useListSatisfactionScoreResidentsQuery>;
export type ListSatisfactionScoreResidentsLazyQueryHookResult = ReturnType<typeof useListSatisfactionScoreResidentsLazyQuery>;
export type ListSatisfactionScoreResidentsQueryResult = Apollo.QueryResult<ListSatisfactionScoreResidentsQuery, ListSatisfactionScoreResidentsQueryVariables>;
export const CreateCommunityDocumentReminderDocument = gql`
    mutation CreateCommunityDocumentReminder($input: CreateCommunityDocumentReminderInput!) {
  createCommunityDocumentReminder(input: $input) {
    communityDocumentReminder {
      id
      document {
        id
        title
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityDocumentReminderMutationFn = Apollo.MutationFunction<CreateCommunityDocumentReminderMutation, CreateCommunityDocumentReminderMutationVariables>;

/**
 * __useCreateCommunityDocumentReminderMutation__
 *
 * To run a mutation, you first call `useCreateCommunityDocumentReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityDocumentReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityDocumentReminderMutation, { data, loading, error }] = useCreateCommunityDocumentReminderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityDocumentReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityDocumentReminderMutation, CreateCommunityDocumentReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityDocumentReminderMutation, CreateCommunityDocumentReminderMutationVariables>(CreateCommunityDocumentReminderDocument, options);
      }
export type CreateCommunityDocumentReminderMutationHookResult = ReturnType<typeof useCreateCommunityDocumentReminderMutation>;
export type CreateCommunityDocumentReminderMutationResult = Apollo.MutationResult<CreateCommunityDocumentReminderMutation>;
export type CreateCommunityDocumentReminderMutationOptions = Apollo.BaseMutationOptions<CreateCommunityDocumentReminderMutation, CreateCommunityDocumentReminderMutationVariables>;
export const CreateCommunityDocumentDocument = gql`
    mutation CreateCommunityDocument($input: CreateCommunityDocumentInput!) {
  createCommunityDocument(input: $input) {
    communityDocument {
      id
      title
      document {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityDocumentMutationFn = Apollo.MutationFunction<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>;

/**
 * __useCreateCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useCreateCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityDocumentMutation, { data, loading, error }] = useCreateCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>(CreateCommunityDocumentDocument, options);
      }
export type CreateCommunityDocumentMutationHookResult = ReturnType<typeof useCreateCommunityDocumentMutation>;
export type CreateCommunityDocumentMutationResult = Apollo.MutationResult<CreateCommunityDocumentMutation>;
export type CreateCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<CreateCommunityDocumentMutation, CreateCommunityDocumentMutationVariables>;
export const CreateResidencyDocumentDocument = gql`
    mutation CreateResidencyDocument($input: CreateResidencyDocumentInput!) {
  createResidencyDocument(input: $input) {
    residencyDocument {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateResidencyDocumentMutationFn = Apollo.MutationFunction<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>;

/**
 * __useCreateResidencyDocumentMutation__
 *
 * To run a mutation, you first call `useCreateResidencyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateResidencyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createResidencyDocumentMutation, { data, loading, error }] = useCreateResidencyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateResidencyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>(CreateResidencyDocumentDocument, options);
      }
export type CreateResidencyDocumentMutationHookResult = ReturnType<typeof useCreateResidencyDocumentMutation>;
export type CreateResidencyDocumentMutationResult = Apollo.MutationResult<CreateResidencyDocumentMutation>;
export type CreateResidencyDocumentMutationOptions = Apollo.BaseMutationOptions<CreateResidencyDocumentMutation, CreateResidencyDocumentMutationVariables>;
export const CreateUserDocumentDocument = gql`
    mutation CreateUserDocument($input: CreateUserDocumentInput!) {
  createUserDocument(input: $input) {
    userDocument {
      id
      title
      document {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateUserDocumentMutationFn = Apollo.MutationFunction<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>;

/**
 * __useCreateUserDocumentMutation__
 *
 * To run a mutation, you first call `useCreateUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDocumentMutation, { data, loading, error }] = useCreateUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>(CreateUserDocumentDocument, options);
      }
export type CreateUserDocumentMutationHookResult = ReturnType<typeof useCreateUserDocumentMutation>;
export type CreateUserDocumentMutationResult = Apollo.MutationResult<CreateUserDocumentMutation>;
export type CreateUserDocumentMutationOptions = Apollo.BaseMutationOptions<CreateUserDocumentMutation, CreateUserDocumentMutationVariables>;
export const UpdateCommunityDocumentDocument = gql`
    mutation UpdateCommunityDocument($input: UpdateCommunityDocumentInput!) {
  updateCommunityDocument(input: $input) {
    communityDocument {
      id
      title
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateCommunityDocumentMutationFn = Apollo.MutationFunction<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>;

/**
 * __useUpdateCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunityDocumentMutation, { data, loading, error }] = useUpdateCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>(UpdateCommunityDocumentDocument, options);
      }
export type UpdateCommunityDocumentMutationHookResult = ReturnType<typeof useUpdateCommunityDocumentMutation>;
export type UpdateCommunityDocumentMutationResult = Apollo.MutationResult<UpdateCommunityDocumentMutation>;
export type UpdateCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateCommunityDocumentMutation, UpdateCommunityDocumentMutationVariables>;
export const UpdateResidencyDocumentDocument = gql`
    mutation UpdateResidencyDocument($input: UpdateResidencyDocumentInput!) {
  updateResidencyDocument(input: $input) {
    residencyDocument {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateResidencyDocumentMutationFn = Apollo.MutationFunction<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>;

/**
 * __useUpdateResidencyDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateResidencyDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateResidencyDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateResidencyDocumentMutation, { data, loading, error }] = useUpdateResidencyDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateResidencyDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>(UpdateResidencyDocumentDocument, options);
      }
export type UpdateResidencyDocumentMutationHookResult = ReturnType<typeof useUpdateResidencyDocumentMutation>;
export type UpdateResidencyDocumentMutationResult = Apollo.MutationResult<UpdateResidencyDocumentMutation>;
export type UpdateResidencyDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateResidencyDocumentMutation, UpdateResidencyDocumentMutationVariables>;
export const UpdateUserDocumentDocument = gql`
    mutation UpdateUserDocument($input: UpdateUserDocumentInput!) {
  updateUserDocument(input: $input) {
    userDocument {
      id
      title
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateUserDocumentMutationFn = Apollo.MutationFunction<UpdateUserDocumentMutation, UpdateUserDocumentMutationVariables>;

/**
 * __useUpdateUserDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDocumentMutation, { data, loading, error }] = useUpdateUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDocumentMutation, UpdateUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDocumentMutation, UpdateUserDocumentMutationVariables>(UpdateUserDocumentDocument, options);
      }
export type UpdateUserDocumentMutationHookResult = ReturnType<typeof useUpdateUserDocumentMutation>;
export type UpdateUserDocumentMutationResult = Apollo.MutationResult<UpdateUserDocumentMutation>;
export type UpdateUserDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateUserDocumentMutation, UpdateUserDocumentMutationVariables>;
export const CommunityDocumentRemindersDocument = gql`
    query CommunityDocumentReminders($documentId: UUID) {
  communityDocumentReminders(documentId: $documentId) {
    edges {
      node {
        id
        createdBy {
          id
          name
        }
        createdAt
        document {
          id
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityDocumentRemindersQuery__
 *
 * To run a query within a React component, call `useCommunityDocumentRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityDocumentRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityDocumentRemindersQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useCommunityDocumentRemindersQuery(baseOptions?: Apollo.QueryHookOptions<CommunityDocumentRemindersQuery, CommunityDocumentRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityDocumentRemindersQuery, CommunityDocumentRemindersQueryVariables>(CommunityDocumentRemindersDocument, options);
      }
export function useCommunityDocumentRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityDocumentRemindersQuery, CommunityDocumentRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityDocumentRemindersQuery, CommunityDocumentRemindersQueryVariables>(CommunityDocumentRemindersDocument, options);
        }
export type CommunityDocumentRemindersQueryHookResult = ReturnType<typeof useCommunityDocumentRemindersQuery>;
export type CommunityDocumentRemindersLazyQueryHookResult = ReturnType<typeof useCommunityDocumentRemindersLazyQuery>;
export type CommunityDocumentRemindersQueryResult = Apollo.QueryResult<CommunityDocumentRemindersQuery, CommunityDocumentRemindersQueryVariables>;
export const DocumentDocument = gql`
    query Document($id: UUID!, $after: String) {
  document(id: $id) {
    id
    contentObject {
      ...ResidencyDocument
      ...CommunityDocument
      ...UserDocument
    }
  }
}
    ${ResidencyDocumentFragmentDoc}
${CommunityDocumentFragmentDoc}
${UserDocumentFragmentDoc}`;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const AssignClientTagToCommunityDocumentDocument = gql`
    mutation AssignClientTagToCommunityDocument($input: AssignClientTagToCommunityDocumentInput!) {
  assignClientTagToCommunityDocument(input: $input) {
    tagAssignment {
      id
      contentObject {
        ...CommunityDocumentListItem
      }
      tag {
        id
      }
    }
  }
}
    ${CommunityDocumentListItemFragmentDoc}`;
export type AssignClientTagToCommunityDocumentMutationFn = Apollo.MutationFunction<AssignClientTagToCommunityDocumentMutation, AssignClientTagToCommunityDocumentMutationVariables>;

/**
 * __useAssignClientTagToCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useAssignClientTagToCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientTagToCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientTagToCommunityDocumentMutation, { data, loading, error }] = useAssignClientTagToCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignClientTagToCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientTagToCommunityDocumentMutation, AssignClientTagToCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientTagToCommunityDocumentMutation, AssignClientTagToCommunityDocumentMutationVariables>(AssignClientTagToCommunityDocumentDocument, options);
      }
export type AssignClientTagToCommunityDocumentMutationHookResult = ReturnType<typeof useAssignClientTagToCommunityDocumentMutation>;
export type AssignClientTagToCommunityDocumentMutationResult = Apollo.MutationResult<AssignClientTagToCommunityDocumentMutation>;
export type AssignClientTagToCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<AssignClientTagToCommunityDocumentMutation, AssignClientTagToCommunityDocumentMutationVariables>;
export const AssignClientTagToUserDocumentDocument = gql`
    mutation AssignClientTagToUserDocument($input: AssignClientTagToUserDocumentInput!) {
  assignClientTagToUserDocument(input: $input) {
    tagAssignment {
      id
      contentObject {
        ...UserDocumentListItem
      }
      tag {
        id
      }
    }
  }
}
    ${UserDocumentListItemFragmentDoc}`;
export type AssignClientTagToUserDocumentMutationFn = Apollo.MutationFunction<AssignClientTagToUserDocumentMutation, AssignClientTagToUserDocumentMutationVariables>;

/**
 * __useAssignClientTagToUserDocumentMutation__
 *
 * To run a mutation, you first call `useAssignClientTagToUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientTagToUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientTagToUserDocumentMutation, { data, loading, error }] = useAssignClientTagToUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignClientTagToUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientTagToUserDocumentMutation, AssignClientTagToUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientTagToUserDocumentMutation, AssignClientTagToUserDocumentMutationVariables>(AssignClientTagToUserDocumentDocument, options);
      }
export type AssignClientTagToUserDocumentMutationHookResult = ReturnType<typeof useAssignClientTagToUserDocumentMutation>;
export type AssignClientTagToUserDocumentMutationResult = Apollo.MutationResult<AssignClientTagToUserDocumentMutation>;
export type AssignClientTagToUserDocumentMutationOptions = Apollo.BaseMutationOptions<AssignClientTagToUserDocumentMutation, AssignClientTagToUserDocumentMutationVariables>;
export const DocumentClientTagsDocument = gql`
    query DocumentClientTags($id: UUID!) {
  document(id: $id) {
    id
    contentObject {
      ... on CommunityDocumentNode {
        ...CommunityDocumentListItem
      }
      ... on UserDocumentNode {
        ...UserDocumentListItem
      }
    }
  }
}
    ${CommunityDocumentListItemFragmentDoc}
${UserDocumentListItemFragmentDoc}`;

/**
 * __useDocumentClientTagsQuery__
 *
 * To run a query within a React component, call `useDocumentClientTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentClientTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentClientTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentClientTagsQuery(baseOptions: Apollo.QueryHookOptions<DocumentClientTagsQuery, DocumentClientTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentClientTagsQuery, DocumentClientTagsQueryVariables>(DocumentClientTagsDocument, options);
      }
export function useDocumentClientTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentClientTagsQuery, DocumentClientTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentClientTagsQuery, DocumentClientTagsQueryVariables>(DocumentClientTagsDocument, options);
        }
export type DocumentClientTagsQueryHookResult = ReturnType<typeof useDocumentClientTagsQuery>;
export type DocumentClientTagsLazyQueryHookResult = ReturnType<typeof useDocumentClientTagsLazyQuery>;
export type DocumentClientTagsQueryResult = Apollo.QueryResult<DocumentClientTagsQuery, DocumentClientTagsQueryVariables>;
export const UnassignClientTagFromCommunityDocumentDocument = gql`
    mutation UnassignClientTagFromCommunityDocument($input: UnassignClientTagFromCommunityDocumentInput!) {
  unassignClientTagFromCommunityDocument(input: $input) {
    tagAssignment {
      id
    }
  }
}
    `;
export type UnassignClientTagFromCommunityDocumentMutationFn = Apollo.MutationFunction<UnassignClientTagFromCommunityDocumentMutation, UnassignClientTagFromCommunityDocumentMutationVariables>;

/**
 * __useUnassignClientTagFromCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useUnassignClientTagFromCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignClientTagFromCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignClientTagFromCommunityDocumentMutation, { data, loading, error }] = useUnassignClientTagFromCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignClientTagFromCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UnassignClientTagFromCommunityDocumentMutation, UnassignClientTagFromCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignClientTagFromCommunityDocumentMutation, UnassignClientTagFromCommunityDocumentMutationVariables>(UnassignClientTagFromCommunityDocumentDocument, options);
      }
export type UnassignClientTagFromCommunityDocumentMutationHookResult = ReturnType<typeof useUnassignClientTagFromCommunityDocumentMutation>;
export type UnassignClientTagFromCommunityDocumentMutationResult = Apollo.MutationResult<UnassignClientTagFromCommunityDocumentMutation>;
export type UnassignClientTagFromCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<UnassignClientTagFromCommunityDocumentMutation, UnassignClientTagFromCommunityDocumentMutationVariables>;
export const UnassignClientTagFromUserDocumentDocument = gql`
    mutation UnassignClientTagFromUserDocument($input: UnassignClientTagFromUserDocumentInput!) {
  unassignClientTagFromUserDocument(input: $input) {
    tagAssignment {
      id
    }
  }
}
    `;
export type UnassignClientTagFromUserDocumentMutationFn = Apollo.MutationFunction<UnassignClientTagFromUserDocumentMutation, UnassignClientTagFromUserDocumentMutationVariables>;

/**
 * __useUnassignClientTagFromUserDocumentMutation__
 *
 * To run a mutation, you first call `useUnassignClientTagFromUserDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignClientTagFromUserDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignClientTagFromUserDocumentMutation, { data, loading, error }] = useUnassignClientTagFromUserDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignClientTagFromUserDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UnassignClientTagFromUserDocumentMutation, UnassignClientTagFromUserDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignClientTagFromUserDocumentMutation, UnassignClientTagFromUserDocumentMutationVariables>(UnassignClientTagFromUserDocumentDocument, options);
      }
export type UnassignClientTagFromUserDocumentMutationHookResult = ReturnType<typeof useUnassignClientTagFromUserDocumentMutation>;
export type UnassignClientTagFromUserDocumentMutationResult = Apollo.MutationResult<UnassignClientTagFromUserDocumentMutation>;
export type UnassignClientTagFromUserDocumentMutationOptions = Apollo.BaseMutationOptions<UnassignClientTagFromUserDocumentMutation, UnassignClientTagFromUserDocumentMutationVariables>;
export const ArchiveTagDocument = gql`
    mutation ArchiveTag($input: ArchiveTagInput!) {
  archiveTag(input: $input) {
    tag {
      id
      name
      color
      archivedAt
      confidenceScore
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveTagMutationFn = Apollo.MutationFunction<ArchiveTagMutation, ArchiveTagMutationVariables>;

/**
 * __useArchiveTagMutation__
 *
 * To run a mutation, you first call `useArchiveTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTagMutation, { data, loading, error }] = useArchiveTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTagMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTagMutation, ArchiveTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTagMutation, ArchiveTagMutationVariables>(ArchiveTagDocument, options);
      }
export type ArchiveTagMutationHookResult = ReturnType<typeof useArchiveTagMutation>;
export type ArchiveTagMutationResult = Apollo.MutationResult<ArchiveTagMutation>;
export type ArchiveTagMutationOptions = Apollo.BaseMutationOptions<ArchiveTagMutation, ArchiveTagMutationVariables>;
export const CreateCommunityDocumentTagDocument = gql`
    mutation CreateCommunityDocumentTag($input: CreateCommunityDocumentTagInput!) {
  createCommunityDocumentTag(input: $input) {
    tag {
      id
      name
      color
      archivedAt
      confidenceScore
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCommunityDocumentTagMutationFn = Apollo.MutationFunction<CreateCommunityDocumentTagMutation, CreateCommunityDocumentTagMutationVariables>;

/**
 * __useCreateCommunityDocumentTagMutation__
 *
 * To run a mutation, you first call `useCreateCommunityDocumentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommunityDocumentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommunityDocumentTagMutation, { data, loading, error }] = useCreateCommunityDocumentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommunityDocumentTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommunityDocumentTagMutation, CreateCommunityDocumentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommunityDocumentTagMutation, CreateCommunityDocumentTagMutationVariables>(CreateCommunityDocumentTagDocument, options);
      }
export type CreateCommunityDocumentTagMutationHookResult = ReturnType<typeof useCreateCommunityDocumentTagMutation>;
export type CreateCommunityDocumentTagMutationResult = Apollo.MutationResult<CreateCommunityDocumentTagMutation>;
export type CreateCommunityDocumentTagMutationOptions = Apollo.BaseMutationOptions<CreateCommunityDocumentTagMutation, CreateCommunityDocumentTagMutationVariables>;
export const CreateUserDocumentTagDocument = gql`
    mutation CreateUserDocumentTag($input: CreateUserDocumentTagInput!) {
  createUserDocumentTag(input: $input) {
    tag {
      id
      name
      color
      archivedAt
      confidenceScore
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateUserDocumentTagMutationFn = Apollo.MutationFunction<CreateUserDocumentTagMutation, CreateUserDocumentTagMutationVariables>;

/**
 * __useCreateUserDocumentTagMutation__
 *
 * To run a mutation, you first call `useCreateUserDocumentTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserDocumentTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserDocumentTagMutation, { data, loading, error }] = useCreateUserDocumentTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserDocumentTagMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserDocumentTagMutation, CreateUserDocumentTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserDocumentTagMutation, CreateUserDocumentTagMutationVariables>(CreateUserDocumentTagDocument, options);
      }
export type CreateUserDocumentTagMutationHookResult = ReturnType<typeof useCreateUserDocumentTagMutation>;
export type CreateUserDocumentTagMutationResult = Apollo.MutationResult<CreateUserDocumentTagMutation>;
export type CreateUserDocumentTagMutationOptions = Apollo.BaseMutationOptions<CreateUserDocumentTagMutation, CreateUserDocumentTagMutationVariables>;
export const DocumentTagsDocument = gql`
    query DocumentTags($id: UUID!) {
  document(id: $id) {
    id
    contentObject {
      ... on CommunityDocumentNode {
        ...CommunityDocumentListItem
      }
      ... on UserDocumentNode {
        ...UserDocumentListItem
      }
    }
  }
}
    ${CommunityDocumentListItemFragmentDoc}
${UserDocumentListItemFragmentDoc}`;

/**
 * __useDocumentTagsQuery__
 *
 * To run a query within a React component, call `useDocumentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentTagsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentTagsQuery(baseOptions: Apollo.QueryHookOptions<DocumentTagsQuery, DocumentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentTagsQuery, DocumentTagsQueryVariables>(DocumentTagsDocument, options);
      }
export function useDocumentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentTagsQuery, DocumentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentTagsQuery, DocumentTagsQueryVariables>(DocumentTagsDocument, options);
        }
export type DocumentTagsQueryHookResult = ReturnType<typeof useDocumentTagsQuery>;
export type DocumentTagsLazyQueryHookResult = ReturnType<typeof useDocumentTagsLazyQuery>;
export type DocumentTagsQueryResult = Apollo.QueryResult<DocumentTagsQuery, DocumentTagsQueryVariables>;
export const ToggleArchivedAtCommunityDocumentDocument = gql`
    mutation ToggleArchivedAtCommunityDocument($input: ToggleArchivedAtCommunityDocumentInput!) {
  toggleArchivedAtCommunityDocument(input: $input) {
    communityDocument {
      id
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ToggleArchivedAtCommunityDocumentMutationFn = Apollo.MutationFunction<ToggleArchivedAtCommunityDocumentMutation, ToggleArchivedAtCommunityDocumentMutationVariables>;

/**
 * __useToggleArchivedAtCommunityDocumentMutation__
 *
 * To run a mutation, you first call `useToggleArchivedAtCommunityDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchivedAtCommunityDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchivedAtCommunityDocumentMutation, { data, loading, error }] = useToggleArchivedAtCommunityDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleArchivedAtCommunityDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArchivedAtCommunityDocumentMutation, ToggleArchivedAtCommunityDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArchivedAtCommunityDocumentMutation, ToggleArchivedAtCommunityDocumentMutationVariables>(ToggleArchivedAtCommunityDocumentDocument, options);
      }
export type ToggleArchivedAtCommunityDocumentMutationHookResult = ReturnType<typeof useToggleArchivedAtCommunityDocumentMutation>;
export type ToggleArchivedAtCommunityDocumentMutationResult = Apollo.MutationResult<ToggleArchivedAtCommunityDocumentMutation>;
export type ToggleArchivedAtCommunityDocumentMutationOptions = Apollo.BaseMutationOptions<ToggleArchivedAtCommunityDocumentMutation, ToggleArchivedAtCommunityDocumentMutationVariables>;
export const DocumentsDocument = gql`
    query Documents($communities: [ID!], $communityGroups: [ID], $search: String, $home: UUID, $after: String, $type: [String!], $tags: [String!], $tags2: [String!], $orderBy: String) {
  documents(
    communities: $communities
    communityGroups: $communityGroups
    search: $search
    home: $home
    after: $after
    type: $type
    tags: $tags
    tags2: $tags2
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        contentObject {
          ...ResidencyDocumentListItem
          ...UserDocumentListItem
          ...CommunityDocumentListItem
        }
      }
    }
  }
}
    ${ResidencyDocumentListItemFragmentDoc}
${UserDocumentListItemFragmentDoc}
${CommunityDocumentListItemFragmentDoc}`;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      communityGroups: // value for 'communityGroups'
 *      search: // value for 'search'
 *      home: // value for 'home'
 *      after: // value for 'after'
 *      type: // value for 'type'
 *      tags: // value for 'tags'
 *      tags2: // value for 'tags2'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const CommunityEventDocument = gql`
    query communityEvent($id: UUID!, $after: String, $partiesAfter: String, $usersAfter: String) {
  communityEvent(id: $id) {
    ...CommunityEventItem
    description
    attendanceFee
    guests(after: $after) {
      totalCount
      edges {
        node {
          id
          name
          email
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    parties(after: $partiesAfter) {
      edges {
        node {
          id
          additionalAttendance
          users(after: $usersAfter) {
            totalCount
            edges {
              node {
                ...CommunityEventPartyUser
              }
            }
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${CommunityEventItemFragmentDoc}
${CommunityEventPartyUserFragmentDoc}`;

/**
 * __useCommunityEventQuery__
 *
 * To run a query within a React component, call `useCommunityEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      partiesAfter: // value for 'partiesAfter'
 *      usersAfter: // value for 'usersAfter'
 *   },
 * });
 */
export function useCommunityEventQuery(baseOptions: Apollo.QueryHookOptions<CommunityEventQuery, CommunityEventQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityEventQuery, CommunityEventQueryVariables>(CommunityEventDocument, options);
      }
export function useCommunityEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityEventQuery, CommunityEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityEventQuery, CommunityEventQueryVariables>(CommunityEventDocument, options);
        }
export type CommunityEventQueryHookResult = ReturnType<typeof useCommunityEventQuery>;
export type CommunityEventLazyQueryHookResult = ReturnType<typeof useCommunityEventLazyQuery>;
export type CommunityEventQueryResult = Apollo.QueryResult<CommunityEventQuery, CommunityEventQueryVariables>;
export const ArchiveCommunityEventDocument = gql`
    mutation ArchiveCommunityEvent($input: ArchiveCommunityEventInput!) {
  archiveCommunityEvent(input: $input) {
    communityEvent {
      id
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveCommunityEventMutationFn = Apollo.MutationFunction<ArchiveCommunityEventMutation, ArchiveCommunityEventMutationVariables>;

/**
 * __useArchiveCommunityEventMutation__
 *
 * To run a mutation, you first call `useArchiveCommunityEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCommunityEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCommunityEventMutation, { data, loading, error }] = useArchiveCommunityEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveCommunityEventMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCommunityEventMutation, ArchiveCommunityEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCommunityEventMutation, ArchiveCommunityEventMutationVariables>(ArchiveCommunityEventDocument, options);
      }
export type ArchiveCommunityEventMutationHookResult = ReturnType<typeof useArchiveCommunityEventMutation>;
export type ArchiveCommunityEventMutationResult = Apollo.MutationResult<ArchiveCommunityEventMutation>;
export type ArchiveCommunityEventMutationOptions = Apollo.BaseMutationOptions<ArchiveCommunityEventMutation, ArchiveCommunityEventMutationVariables>;
export const SaveCommunityEventDocument = gql`
    mutation SaveCommunityEvent($input: SaveCommunityEventInput!) {
  saveCommunityEvent(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveCommunityEventMutationFn = Apollo.MutationFunction<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>;

/**
 * __useSaveCommunityEventMutation__
 *
 * To run a mutation, you first call `useSaveCommunityEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunityEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunityEventMutation, { data, loading, error }] = useSaveCommunityEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunityEventMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>(SaveCommunityEventDocument, options);
      }
export type SaveCommunityEventMutationHookResult = ReturnType<typeof useSaveCommunityEventMutation>;
export type SaveCommunityEventMutationResult = Apollo.MutationResult<SaveCommunityEventMutation>;
export type SaveCommunityEventMutationOptions = Apollo.BaseMutationOptions<SaveCommunityEventMutation, SaveCommunityEventMutationVariables>;
export const CommunityEventsDocument = gql`
    query communityEvents($communities: [ID!], $after: String, $search: String, $status: [String], $orderBy: String) {
  communityEvents(
    communities: $communities
    after: $after
    search: $search
    status: $status
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...CommunityEventItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${CommunityEventItemFragmentDoc}`;

/**
 * __useCommunityEventsQuery__
 *
 * To run a query within a React component, call `useCommunityEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityEventsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCommunityEventsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
      }
export function useCommunityEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityEventsQuery, CommunityEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityEventsQuery, CommunityEventsQueryVariables>(CommunityEventsDocument, options);
        }
export type CommunityEventsQueryHookResult = ReturnType<typeof useCommunityEventsQuery>;
export type CommunityEventsLazyQueryHookResult = ReturnType<typeof useCommunityEventsLazyQuery>;
export type CommunityEventsQueryResult = Apollo.QueryResult<CommunityEventsQuery, CommunityEventsQueryVariables>;
export const AcceptFeatureAnnouncementDocument = gql`
    mutation AcceptFeatureAnnouncement($featureAnnouncementId: UUID!) {
  acceptFeatureAnnouncement(
    input: {featureAnnouncementId: $featureAnnouncementId}
  ) {
    featureAnnouncementView {
      id
      viewedAt
      acceptedAt
      dismissedAt
    }
  }
}
    `;
export type AcceptFeatureAnnouncementMutationFn = Apollo.MutationFunction<AcceptFeatureAnnouncementMutation, AcceptFeatureAnnouncementMutationVariables>;

/**
 * __useAcceptFeatureAnnouncementMutation__
 *
 * To run a mutation, you first call `useAcceptFeatureAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFeatureAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFeatureAnnouncementMutation, { data, loading, error }] = useAcceptFeatureAnnouncementMutation({
 *   variables: {
 *      featureAnnouncementId: // value for 'featureAnnouncementId'
 *   },
 * });
 */
export function useAcceptFeatureAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFeatureAnnouncementMutation, AcceptFeatureAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFeatureAnnouncementMutation, AcceptFeatureAnnouncementMutationVariables>(AcceptFeatureAnnouncementDocument, options);
      }
export type AcceptFeatureAnnouncementMutationHookResult = ReturnType<typeof useAcceptFeatureAnnouncementMutation>;
export type AcceptFeatureAnnouncementMutationResult = Apollo.MutationResult<AcceptFeatureAnnouncementMutation>;
export type AcceptFeatureAnnouncementMutationOptions = Apollo.BaseMutationOptions<AcceptFeatureAnnouncementMutation, AcceptFeatureAnnouncementMutationVariables>;
export const DismissFeatureAnnouncementDocument = gql`
    mutation DismissFeatureAnnouncement($featureAnnouncementId: UUID!) {
  dismissFeatureAnnouncement(
    input: {featureAnnouncementId: $featureAnnouncementId}
  ) {
    featureAnnouncementView {
      id
      viewedAt
      acceptedAt
      dismissedAt
    }
  }
}
    `;
export type DismissFeatureAnnouncementMutationFn = Apollo.MutationFunction<DismissFeatureAnnouncementMutation, DismissFeatureAnnouncementMutationVariables>;

/**
 * __useDismissFeatureAnnouncementMutation__
 *
 * To run a mutation, you first call `useDismissFeatureAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissFeatureAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissFeatureAnnouncementMutation, { data, loading, error }] = useDismissFeatureAnnouncementMutation({
 *   variables: {
 *      featureAnnouncementId: // value for 'featureAnnouncementId'
 *   },
 * });
 */
export function useDismissFeatureAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<DismissFeatureAnnouncementMutation, DismissFeatureAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissFeatureAnnouncementMutation, DismissFeatureAnnouncementMutationVariables>(DismissFeatureAnnouncementDocument, options);
      }
export type DismissFeatureAnnouncementMutationHookResult = ReturnType<typeof useDismissFeatureAnnouncementMutation>;
export type DismissFeatureAnnouncementMutationResult = Apollo.MutationResult<DismissFeatureAnnouncementMutation>;
export type DismissFeatureAnnouncementMutationOptions = Apollo.BaseMutationOptions<DismissFeatureAnnouncementMutation, DismissFeatureAnnouncementMutationVariables>;
export const GetFeatureAnnouncementBySlugDocument = gql`
    query GetFeatureAnnouncementBySlug($slug: String!) {
  featureAnnouncementBySlug(slug: $slug) {
    id
    title
    slug
    subtitle
    body
    image
    createdAt
    currentUserView {
      id
      viewedAt
      acceptedAt
      dismissedAt
    }
    stats {
      viewCount
      acceptanceCount
      dismissalCount
      acceptanceRate
    }
  }
}
    `;

/**
 * __useGetFeatureAnnouncementBySlugQuery__
 *
 * To run a query within a React component, call `useGetFeatureAnnouncementBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureAnnouncementBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureAnnouncementBySlugQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetFeatureAnnouncementBySlugQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureAnnouncementBySlugQuery, GetFeatureAnnouncementBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureAnnouncementBySlugQuery, GetFeatureAnnouncementBySlugQueryVariables>(GetFeatureAnnouncementBySlugDocument, options);
      }
export function useGetFeatureAnnouncementBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureAnnouncementBySlugQuery, GetFeatureAnnouncementBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureAnnouncementBySlugQuery, GetFeatureAnnouncementBySlugQueryVariables>(GetFeatureAnnouncementBySlugDocument, options);
        }
export type GetFeatureAnnouncementBySlugQueryHookResult = ReturnType<typeof useGetFeatureAnnouncementBySlugQuery>;
export type GetFeatureAnnouncementBySlugLazyQueryHookResult = ReturnType<typeof useGetFeatureAnnouncementBySlugLazyQuery>;
export type GetFeatureAnnouncementBySlugQueryResult = Apollo.QueryResult<GetFeatureAnnouncementBySlugQuery, GetFeatureAnnouncementBySlugQueryVariables>;
export const ListFeatureAnnouncementsDocument = gql`
    query ListFeatureAnnouncements($after: String, $first: Int) {
  featureAnnouncements(first: $first, after: $after) {
    edges {
      node {
        id
        title
        slug
        subtitle
        image
        createdAt
        currentUserView {
          id
          viewedAt
          acceptedAt
          dismissedAt
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `;

/**
 * __useListFeatureAnnouncementsQuery__
 *
 * To run a query within a React component, call `useListFeatureAnnouncementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListFeatureAnnouncementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListFeatureAnnouncementsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useListFeatureAnnouncementsQuery(baseOptions?: Apollo.QueryHookOptions<ListFeatureAnnouncementsQuery, ListFeatureAnnouncementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListFeatureAnnouncementsQuery, ListFeatureAnnouncementsQueryVariables>(ListFeatureAnnouncementsDocument, options);
      }
export function useListFeatureAnnouncementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListFeatureAnnouncementsQuery, ListFeatureAnnouncementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListFeatureAnnouncementsQuery, ListFeatureAnnouncementsQueryVariables>(ListFeatureAnnouncementsDocument, options);
        }
export type ListFeatureAnnouncementsQueryHookResult = ReturnType<typeof useListFeatureAnnouncementsQuery>;
export type ListFeatureAnnouncementsLazyQueryHookResult = ReturnType<typeof useListFeatureAnnouncementsLazyQuery>;
export type ListFeatureAnnouncementsQueryResult = Apollo.QueryResult<ListFeatureAnnouncementsQuery, ListFeatureAnnouncementsQueryVariables>;
export const ViewFeatureAnnouncementDocument = gql`
    mutation ViewFeatureAnnouncement($featureAnnouncementId: UUID!) {
  viewFeatureAnnouncement(input: {featureAnnouncementId: $featureAnnouncementId}) {
    featureAnnouncementView {
      id
      viewedAt
      acceptedAt
      dismissedAt
    }
  }
}
    `;
export type ViewFeatureAnnouncementMutationFn = Apollo.MutationFunction<ViewFeatureAnnouncementMutation, ViewFeatureAnnouncementMutationVariables>;

/**
 * __useViewFeatureAnnouncementMutation__
 *
 * To run a mutation, you first call `useViewFeatureAnnouncementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewFeatureAnnouncementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewFeatureAnnouncementMutation, { data, loading, error }] = useViewFeatureAnnouncementMutation({
 *   variables: {
 *      featureAnnouncementId: // value for 'featureAnnouncementId'
 *   },
 * });
 */
export function useViewFeatureAnnouncementMutation(baseOptions?: Apollo.MutationHookOptions<ViewFeatureAnnouncementMutation, ViewFeatureAnnouncementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewFeatureAnnouncementMutation, ViewFeatureAnnouncementMutationVariables>(ViewFeatureAnnouncementDocument, options);
      }
export type ViewFeatureAnnouncementMutationHookResult = ReturnType<typeof useViewFeatureAnnouncementMutation>;
export type ViewFeatureAnnouncementMutationResult = Apollo.MutationResult<ViewFeatureAnnouncementMutation>;
export type ViewFeatureAnnouncementMutationOptions = Apollo.BaseMutationOptions<ViewFeatureAnnouncementMutation, ViewFeatureAnnouncementMutationVariables>;
export const FormDocument = gql`
    query Form($id: UUID!) {
  communityForm(id: $id) {
    ...FormItem
    questions {
      edges {
        node {
          id
          ref
          title
          type
          properties
        }
      }
    }
  }
}
    ${FormItemFragmentDoc}`;

/**
 * __useFormQuery__
 *
 * To run a query within a React component, call `useFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFormQuery(baseOptions: Apollo.QueryHookOptions<FormQuery, FormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormQuery, FormQueryVariables>(FormDocument, options);
      }
export function useFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormQuery, FormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormQuery, FormQueryVariables>(FormDocument, options);
        }
export type FormQueryHookResult = ReturnType<typeof useFormQuery>;
export type FormLazyQueryHookResult = ReturnType<typeof useFormLazyQuery>;
export type FormQueryResult = Apollo.QueryResult<FormQuery, FormQueryVariables>;
export const FormsDocument = gql`
    query Forms($communities: [ID], $communityGroups: [ID], $after: String, $status: [String], $orderBy: String) {
  communityForms(
    communities: $communities
    communityGroups: $communityGroups
    after: $after
    status: $status
    orderBy: $orderBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        ...FormItem
      }
    }
  }
}
    ${FormItemFragmentDoc}`;

/**
 * __useFormsQuery__
 *
 * To run a query within a React component, call `useFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFormsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      communityGroups: // value for 'communityGroups'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useFormsQuery(baseOptions?: Apollo.QueryHookOptions<FormsQuery, FormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
      }
export function useFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FormsQuery, FormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FormsQuery, FormsQueryVariables>(FormsDocument, options);
        }
export type FormsQueryHookResult = ReturnType<typeof useFormsQuery>;
export type FormsLazyQueryHookResult = ReturnType<typeof useFormsLazyQuery>;
export type FormsQueryResult = Apollo.QueryResult<FormsQuery, FormsQueryVariables>;
export const ActivateGroupDocument = gql`
    mutation ActivateGroup($input: ActivateGroupInput!) {
  activateGroup(input: $input) {
    communityGroup {
      id
      name
      deactivatedOn
    }
  }
}
    `;
export type ActivateGroupMutationFn = Apollo.MutationFunction<ActivateGroupMutation, ActivateGroupMutationVariables>;

/**
 * __useActivateGroupMutation__
 *
 * To run a mutation, you first call `useActivateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateGroupMutation, { data, loading, error }] = useActivateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useActivateGroupMutation(baseOptions?: Apollo.MutationHookOptions<ActivateGroupMutation, ActivateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateGroupMutation, ActivateGroupMutationVariables>(ActivateGroupDocument, options);
      }
export type ActivateGroupMutationHookResult = ReturnType<typeof useActivateGroupMutation>;
export type ActivateGroupMutationResult = Apollo.MutationResult<ActivateGroupMutation>;
export type ActivateGroupMutationOptions = Apollo.BaseMutationOptions<ActivateGroupMutation, ActivateGroupMutationVariables>;
export const CommunityGroupDocument = gql`
    query CommunityGroup($id: UUID!, $homesAfter: String, $contactsAfter: String) {
  communityGroup(id: $id) {
    id
    name
    description
    deactivatedOn
    isAutomatic
    isSystemManaged
    isCommunityManager
    numUsers
    block {
      id
      name
    }
    community {
      id
      name
    }
    homes(after: $homesAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          name
        }
      }
    }
    users(after: $contactsAfter) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...ContactItem
        }
      }
    }
  }
}
    ${ContactItemFragmentDoc}`;

/**
 * __useCommunityGroupQuery__
 *
 * To run a query within a React component, call `useCommunityGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *      homesAfter: // value for 'homesAfter'
 *      contactsAfter: // value for 'contactsAfter'
 *   },
 * });
 */
export function useCommunityGroupQuery(baseOptions: Apollo.QueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
      }
export function useCommunityGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupQuery, CommunityGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupQuery, CommunityGroupQueryVariables>(CommunityGroupDocument, options);
        }
export type CommunityGroupQueryHookResult = ReturnType<typeof useCommunityGroupQuery>;
export type CommunityGroupLazyQueryHookResult = ReturnType<typeof useCommunityGroupLazyQuery>;
export type CommunityGroupQueryResult = Apollo.QueryResult<CommunityGroupQuery, CommunityGroupQueryVariables>;
export const CommunityManagerCommunitiesDocument = gql`
    query CommunityManagerCommunities {
  getUser {
    id
    manager {
      id
      community {
        edges {
          node {
            id
          }
        }
      }
    }
    communityManager {
      id
      communities {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityManagerCommunitiesQuery__
 *
 * To run a query within a React component, call `useCommunityManagerCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityManagerCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityManagerCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCommunityManagerCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>(CommunityManagerCommunitiesDocument, options);
      }
export function useCommunityManagerCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>(CommunityManagerCommunitiesDocument, options);
        }
export type CommunityManagerCommunitiesQueryHookResult = ReturnType<typeof useCommunityManagerCommunitiesQuery>;
export type CommunityManagerCommunitiesLazyQueryHookResult = ReturnType<typeof useCommunityManagerCommunitiesLazyQuery>;
export type CommunityManagerCommunitiesQueryResult = Apollo.QueryResult<CommunityManagerCommunitiesQuery, CommunityManagerCommunitiesQueryVariables>;
export const CreateGroupDocument = gql`
    mutation CreateGroup($input: CreateGroupInput!) {
  createGroup(input: $input) {
    id
    name
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const DeactivateGroupDocument = gql`
    mutation DeactivateGroup($input: DeactivateGroupInput!) {
  deactivateGroup(input: $input) {
    communityGroup {
      id
      name
      deactivatedOn
    }
  }
}
    `;
export type DeactivateGroupMutationFn = Apollo.MutationFunction<DeactivateGroupMutation, DeactivateGroupMutationVariables>;

/**
 * __useDeactivateGroupMutation__
 *
 * To run a mutation, you first call `useDeactivateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateGroupMutation, { data, loading, error }] = useDeactivateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeactivateGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateGroupMutation, DeactivateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateGroupMutation, DeactivateGroupMutationVariables>(DeactivateGroupDocument, options);
      }
export type DeactivateGroupMutationHookResult = ReturnType<typeof useDeactivateGroupMutation>;
export type DeactivateGroupMutationResult = Apollo.MutationResult<DeactivateGroupMutation>;
export type DeactivateGroupMutationOptions = Apollo.BaseMutationOptions<DeactivateGroupMutation, DeactivateGroupMutationVariables>;
export const UpdateGroupDocument = gql`
    mutation UpdateGroup($input: UpdateGroupInput!) {
  updateGroup(input: $input) {
    id
    name
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;
export const CommunityGroupsDocument = gql`
    query CommunityGroups($communities: [ID!], $after: String, $search: String, $status: [String], $orderBy: String, $isAutomatic: Boolean, $groupType: [String]) {
  communityGroups(
    communities: $communities
    after: $after
    orderBy: $orderBy
    search: $search
    status: $status
    isAutomatic: $isAutomatic
    groupType: $groupType
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...CommunityGroupItem
      }
    }
  }
}
    ${CommunityGroupItemFragmentDoc}`;

/**
 * __useCommunityGroupsQuery__
 *
 * To run a query within a React component, call `useCommunityGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityGroupsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *      isAutomatic: // value for 'isAutomatic'
 *      groupType: // value for 'groupType'
 *   },
 * });
 */
export function useCommunityGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CommunityGroupsQuery, CommunityGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityGroupsQuery, CommunityGroupsQueryVariables>(CommunityGroupsDocument, options);
      }
export function useCommunityGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityGroupsQuery, CommunityGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityGroupsQuery, CommunityGroupsQueryVariables>(CommunityGroupsDocument, options);
        }
export type CommunityGroupsQueryHookResult = ReturnType<typeof useCommunityGroupsQuery>;
export type CommunityGroupsLazyQueryHookResult = ReturnType<typeof useCommunityGroupsLazyQuery>;
export type CommunityGroupsQueryResult = Apollo.QueryResult<CommunityGroupsQuery, CommunityGroupsQueryVariables>;
export const HomeGroupsDocument = gql`
    query HomeGroups($homeId: UUID!) {
  home(id: $homeId) {
    communityGroups {
      edges {
        node {
          id
          name
          description
        }
      }
    }
  }
}
    `;

/**
 * __useHomeGroupsQuery__
 *
 * To run a query within a React component, call `useHomeGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeGroupsQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function useHomeGroupsQuery(baseOptions: Apollo.QueryHookOptions<HomeGroupsQuery, HomeGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeGroupsQuery, HomeGroupsQueryVariables>(HomeGroupsDocument, options);
      }
export function useHomeGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeGroupsQuery, HomeGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeGroupsQuery, HomeGroupsQueryVariables>(HomeGroupsDocument, options);
        }
export type HomeGroupsQueryHookResult = ReturnType<typeof useHomeGroupsQuery>;
export type HomeGroupsLazyQueryHookResult = ReturnType<typeof useHomeGroupsLazyQuery>;
export type HomeGroupsQueryResult = Apollo.QueryResult<HomeGroupsQuery, HomeGroupsQueryVariables>;
export const UpdateHomeFloorNumberDocument = gql`
    mutation UpdateHomeFloorNumber($input: UpdateHomeFloorNumberInput!) {
  updateHomeFloorNumber(input: $input) {
    home {
      id
      floorNumber
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateHomeFloorNumberMutationFn = Apollo.MutationFunction<UpdateHomeFloorNumberMutation, UpdateHomeFloorNumberMutationVariables>;

/**
 * __useUpdateHomeFloorNumberMutation__
 *
 * To run a mutation, you first call `useUpdateHomeFloorNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHomeFloorNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHomeFloorNumberMutation, { data, loading, error }] = useUpdateHomeFloorNumberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHomeFloorNumberMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHomeFloorNumberMutation, UpdateHomeFloorNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHomeFloorNumberMutation, UpdateHomeFloorNumberMutationVariables>(UpdateHomeFloorNumberDocument, options);
      }
export type UpdateHomeFloorNumberMutationHookResult = ReturnType<typeof useUpdateHomeFloorNumberMutation>;
export type UpdateHomeFloorNumberMutationResult = Apollo.MutationResult<UpdateHomeFloorNumberMutation>;
export type UpdateHomeFloorNumberMutationOptions = Apollo.BaseMutationOptions<UpdateHomeFloorNumberMutation, UpdateHomeFloorNumberMutationVariables>;
export const HomeDetailsDocument = gql`
    query HomeDetails($id: UUID!) {
  home(id: $id) {
    ...HomeItem
    community {
      id
      settings {
        safetyCenter
      }
    }
    activeResidency {
      id
      pastResidents {
        edges {
          node {
            id
            name
            email
            removalDate
          }
        }
      }
      residents {
        id
        averageScore
        user {
          id
          name
          email
          lastAppUse
        }
      }
      residentSafetyRecords(hasNeeds: true, orderBy: "-created_at") {
        edges {
          node {
            id
            mobilityNeeds
            communicationNeeds
            language
            largePrint
            braille
            textToSpeech
            latestDeclaration {
              ...LatestDeclaration
            }
            user {
              id
            }
          }
        }
      }
      occupancySurveys {
        edges {
          node {
            id
            user {
              id
            }
            isOccupant
            occupants {
              edges {
                node {
                  id
                  user {
                    id
                  }
                  first
                  last
                  mobilityNeeds
                  communicationNeeds
                }
              }
            }
          }
        }
      }
    }
    leasehold {
      id
      leaseholder {
        edges {
          node {
            id
            user {
              id
              name
              email
              lastAppUse
            }
          }
        }
      }
      pastLeaseholders {
        edges {
          node {
            id
            name
            email
            removalDate
          }
        }
      }
    }
    applications {
      edges {
        node {
          ...ApplicationItem
        }
      }
    }
  }
}
    ${HomeItemFragmentDoc}
${LatestDeclarationFragmentDoc}
${ApplicationItemFragmentDoc}`;

/**
 * __useHomeDetailsQuery__
 *
 * To run a query within a React component, call `useHomeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHomeDetailsQuery(baseOptions: Apollo.QueryHookOptions<HomeDetailsQuery, HomeDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeDetailsQuery, HomeDetailsQueryVariables>(HomeDetailsDocument, options);
      }
export function useHomeDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeDetailsQuery, HomeDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeDetailsQuery, HomeDetailsQueryVariables>(HomeDetailsDocument, options);
        }
export type HomeDetailsQueryHookResult = ReturnType<typeof useHomeDetailsQuery>;
export type HomeDetailsLazyQueryHookResult = ReturnType<typeof useHomeDetailsLazyQuery>;
export type HomeDetailsQueryResult = Apollo.QueryResult<HomeDetailsQuery, HomeDetailsQueryVariables>;
export const ListEntHomesDocument = gql`
    query ListEntHomes($after: String, $communities: [ID!], $icontainsSearch: String, $orderBy: String, $hasBlock: Boolean) {
  homes(
    after: $after
    communities: $communities
    icontainsSearch: $icontainsSearch
    orderBy: $orderBy
    hasBlock: $hasBlock
    includeDemoHomes: false
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
    edges {
      node {
        ...HomeItem
      }
    }
  }
}
    ${HomeItemFragmentDoc}`;

/**
 * __useListEntHomesQuery__
 *
 * To run a query within a React component, call `useListEntHomesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEntHomesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEntHomesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *      icontainsSearch: // value for 'icontainsSearch'
 *      orderBy: // value for 'orderBy'
 *      hasBlock: // value for 'hasBlock'
 *   },
 * });
 */
export function useListEntHomesQuery(baseOptions?: Apollo.QueryHookOptions<ListEntHomesQuery, ListEntHomesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListEntHomesQuery, ListEntHomesQueryVariables>(ListEntHomesDocument, options);
      }
export function useListEntHomesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListEntHomesQuery, ListEntHomesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListEntHomesQuery, ListEntHomesQueryVariables>(ListEntHomesDocument, options);
        }
export type ListEntHomesQueryHookResult = ReturnType<typeof useListEntHomesQuery>;
export type ListEntHomesLazyQueryHookResult = ReturnType<typeof useListEntHomesLazyQuery>;
export type ListEntHomesQueryResult = Apollo.QueryResult<ListEntHomesQuery, ListEntHomesQueryVariables>;
export const CreateKeyholderV2Document = gql`
    mutation CreateKeyholderV2($input: CreateKeyholderV2Input!) {
  createKeyholderV2(input: $input) {
    keyholder {
      id
      key {
        id
        keyholders(type: ["Pending", "Rolling", "Single Use"]) {
          pageInfo {
            endCursor
            hasNextPage
          }
          totalCount
          edges {
            node {
              ...KeyholderItem
            }
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CreateKeyholderV2MutationFn = Apollo.MutationFunction<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>;

/**
 * __useCreateKeyholderV2Mutation__
 *
 * To run a mutation, you first call `useCreateKeyholderV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyholderV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyholderV2Mutation, { data, loading, error }] = useCreateKeyholderV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKeyholderV2Mutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>(CreateKeyholderV2Document, options);
      }
export type CreateKeyholderV2MutationHookResult = ReturnType<typeof useCreateKeyholderV2Mutation>;
export type CreateKeyholderV2MutationResult = Apollo.MutationResult<CreateKeyholderV2Mutation>;
export type CreateKeyholderV2MutationOptions = Apollo.BaseMutationOptions<CreateKeyholderV2Mutation, CreateKeyholderV2MutationVariables>;
export const KeyCommunityDocument = gql`
    query KeyCommunity($keyId: UUID!) {
  key(id: $keyId) {
    id
    community {
      id
    }
  }
}
    `;

/**
 * __useKeyCommunityQuery__
 *
 * To run a query within a React component, call `useKeyCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyCommunityQuery({
 *   variables: {
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useKeyCommunityQuery(baseOptions: Apollo.QueryHookOptions<KeyCommunityQuery, KeyCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyCommunityQuery, KeyCommunityQueryVariables>(KeyCommunityDocument, options);
      }
export function useKeyCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyCommunityQuery, KeyCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyCommunityQuery, KeyCommunityQueryVariables>(KeyCommunityDocument, options);
        }
export type KeyCommunityQueryHookResult = ReturnType<typeof useKeyCommunityQuery>;
export type KeyCommunityLazyQueryHookResult = ReturnType<typeof useKeyCommunityLazyQuery>;
export type KeyCommunityQueryResult = Apollo.QueryResult<KeyCommunityQuery, KeyCommunityQueryVariables>;
export const OnSiteVisitorsDocument = gql`
    query OnSiteVisitors($after: String, $communities: [ID!]) {
  communityVisitors(after: $after, communities: $communities, onSite: true) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...OnSiteVisitorItem
      }
    }
  }
}
    ${OnSiteVisitorItemFragmentDoc}`;

/**
 * __useOnSiteVisitorsQuery__
 *
 * To run a query within a React component, call `useOnSiteVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnSiteVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnSiteVisitorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useOnSiteVisitorsQuery(baseOptions?: Apollo.QueryHookOptions<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>(OnSiteVisitorsDocument, options);
      }
export function useOnSiteVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>(OnSiteVisitorsDocument, options);
        }
export type OnSiteVisitorsQueryHookResult = ReturnType<typeof useOnSiteVisitorsQuery>;
export type OnSiteVisitorsLazyQueryHookResult = ReturnType<typeof useOnSiteVisitorsLazyQuery>;
export type OnSiteVisitorsQueryResult = Apollo.QueryResult<OnSiteVisitorsQuery, OnSiteVisitorsQueryVariables>;
export const ArchiveKeyDocument = gql`
    mutation ArchiveKey($input: ArchiveKeyInput!) {
  archiveKey(input: $input) {
    key {
      id
      status
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveKeyMutationFn = Apollo.MutationFunction<ArchiveKeyMutation, ArchiveKeyMutationVariables>;

/**
 * __useArchiveKeyMutation__
 *
 * To run a mutation, you first call `useArchiveKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveKeyMutation, { data, loading, error }] = useArchiveKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveKeyMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveKeyMutation, ArchiveKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveKeyMutation, ArchiveKeyMutationVariables>(ArchiveKeyDocument, options);
      }
export type ArchiveKeyMutationHookResult = ReturnType<typeof useArchiveKeyMutation>;
export type ArchiveKeyMutationResult = Apollo.MutationResult<ArchiveKeyMutation>;
export type ArchiveKeyMutationOptions = Apollo.BaseMutationOptions<ArchiveKeyMutation, ArchiveKeyMutationVariables>;
export const ArchiveKeyholderDocument = gql`
    mutation ArchiveKeyholder($input: ArchiveKeyholderInput!) {
  archiveKeyholder(input: $input) {
    keyholder {
      id
      archivedAt
      type
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveKeyholderMutationFn = Apollo.MutationFunction<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>;

/**
 * __useArchiveKeyholderMutation__
 *
 * To run a mutation, you first call `useArchiveKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveKeyholderMutation, { data, loading, error }] = useArchiveKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>(ArchiveKeyholderDocument, options);
      }
export type ArchiveKeyholderMutationHookResult = ReturnType<typeof useArchiveKeyholderMutation>;
export type ArchiveKeyholderMutationResult = Apollo.MutationResult<ArchiveKeyholderMutation>;
export type ArchiveKeyholderMutationOptions = Apollo.BaseMutationOptions<ArchiveKeyholderMutation, ArchiveKeyholderMutationVariables>;
export const AuthorisedKeyholdersDocument = gql`
    query AuthorisedKeyholders($id: UUID!, $after: String) {
  key(id: $id) {
    id
    keyholders(isActive: true, after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useAuthorisedKeyholdersQuery__
 *
 * To run a query within a React component, call `useAuthorisedKeyholdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAuthorisedKeyholdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAuthorisedKeyholdersQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAuthorisedKeyholdersQuery(baseOptions: Apollo.QueryHookOptions<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>(AuthorisedKeyholdersDocument, options);
      }
export function useAuthorisedKeyholdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>(AuthorisedKeyholdersDocument, options);
        }
export type AuthorisedKeyholdersQueryHookResult = ReturnType<typeof useAuthorisedKeyholdersQuery>;
export type AuthorisedKeyholdersLazyQueryHookResult = ReturnType<typeof useAuthorisedKeyholdersLazyQuery>;
export type AuthorisedKeyholdersQueryResult = Apollo.QueryResult<AuthorisedKeyholdersQuery, AuthorisedKeyholdersQueryVariables>;
export const CheckInKeyV2Document = gql`
    mutation CheckInKeyV2($input: CheckInKeyV2Input!) {
  checkInKeyV2(input: $input) {
    key {
      id
      checkoutDate
      status
      currentKeyholder {
        ...KeyholderItem
      }
    }
    errors {
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CheckInKeyV2MutationFn = Apollo.MutationFunction<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>;

/**
 * __useCheckInKeyV2Mutation__
 *
 * To run a mutation, you first call `useCheckInKeyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckInKeyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkInKeyV2Mutation, { data, loading, error }] = useCheckInKeyV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckInKeyV2Mutation(baseOptions?: Apollo.MutationHookOptions<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>(CheckInKeyV2Document, options);
      }
export type CheckInKeyV2MutationHookResult = ReturnType<typeof useCheckInKeyV2Mutation>;
export type CheckInKeyV2MutationResult = Apollo.MutationResult<CheckInKeyV2Mutation>;
export type CheckInKeyV2MutationOptions = Apollo.BaseMutationOptions<CheckInKeyV2Mutation, CheckInKeyV2MutationVariables>;
export const CheckOutKeyV2Document = gql`
    mutation CheckOutKeyV2($input: CheckOutKeyV2Input!) {
  checkOutKeyV2(input: $input) {
    key {
      id
      checkoutDate
      status
      currentKeyholder {
        ...KeyholderItem
      }
    }
    errors {
      field
      messages
    }
  }
}
    ${KeyholderItemFragmentDoc}`;
export type CheckOutKeyV2MutationFn = Apollo.MutationFunction<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>;

/**
 * __useCheckOutKeyV2Mutation__
 *
 * To run a mutation, you first call `useCheckOutKeyV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCheckOutKeyV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [checkOutKeyV2Mutation, { data, loading, error }] = useCheckOutKeyV2Mutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCheckOutKeyV2Mutation(baseOptions?: Apollo.MutationHookOptions<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>(CheckOutKeyV2Document, options);
      }
export type CheckOutKeyV2MutationHookResult = ReturnType<typeof useCheckOutKeyV2Mutation>;
export type CheckOutKeyV2MutationResult = Apollo.MutationResult<CheckOutKeyV2Mutation>;
export type CheckOutKeyV2MutationOptions = Apollo.BaseMutationOptions<CheckOutKeyV2Mutation, CheckOutKeyV2MutationVariables>;
export const CreateKeyDocument = gql`
    mutation CreateKey($input: CreateKeyV2Input!) {
  createKeyV2(input: $input) {
    key {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateKeyMutationFn = Apollo.MutationFunction<CreateKeyMutation, CreateKeyMutationVariables>;

/**
 * __useCreateKeyMutation__
 *
 * To run a mutation, you first call `useCreateKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKeyMutation, { data, loading, error }] = useCreateKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateKeyMutation, CreateKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKeyMutation, CreateKeyMutationVariables>(CreateKeyDocument, options);
      }
export type CreateKeyMutationHookResult = ReturnType<typeof useCreateKeyMutation>;
export type CreateKeyMutationResult = Apollo.MutationResult<CreateKeyMutation>;
export type CreateKeyMutationOptions = Apollo.BaseMutationOptions<CreateKeyMutation, CreateKeyMutationVariables>;
export const EditKeyDocument = gql`
    mutation EditKey($input: EditKeyInput!) {
  editKey(input: $input) {
    key {
      id
      name
      reference
      notes
      community {
        id
        name
      }
      home {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type EditKeyMutationFn = Apollo.MutationFunction<EditKeyMutation, EditKeyMutationVariables>;

/**
 * __useEditKeyMutation__
 *
 * To run a mutation, you first call `useEditKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editKeyMutation, { data, loading, error }] = useEditKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditKeyMutation(baseOptions?: Apollo.MutationHookOptions<EditKeyMutation, EditKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditKeyMutation, EditKeyMutationVariables>(EditKeyDocument, options);
      }
export type EditKeyMutationHookResult = ReturnType<typeof useEditKeyMutation>;
export type EditKeyMutationResult = Apollo.MutationResult<EditKeyMutation>;
export type EditKeyMutationOptions = Apollo.BaseMutationOptions<EditKeyMutation, EditKeyMutationVariables>;
export const UpdateKeyholderDocument = gql`
    mutation UpdateKeyholder($input: UpdateKeyholderInput!) {
  updateKeyholder(input: $input) {
    id
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateKeyholderMutationFn = Apollo.MutationFunction<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>;

/**
 * __useUpdateKeyholderMutation__
 *
 * To run a mutation, you first call `useUpdateKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKeyholderMutation, { data, loading, error }] = useUpdateKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>(UpdateKeyholderDocument, options);
      }
export type UpdateKeyholderMutationHookResult = ReturnType<typeof useUpdateKeyholderMutation>;
export type UpdateKeyholderMutationResult = Apollo.MutationResult<UpdateKeyholderMutation>;
export type UpdateKeyholderMutationOptions = Apollo.BaseMutationOptions<UpdateKeyholderMutation, UpdateKeyholderMutationVariables>;
export const KeyDetailsDocument = gql`
    query KeyDetails($id: UUID!, $keyholdersAfter: String, $eventsAfter: String) {
  key(id: $id) {
    id
    name
    reference
    checkoutDate
    notes
    status
    archivedAt
    community {
      id
      name
    }
    image
    home {
      ...KeyHomeItem
    }
    currentKeyholder {
      ...KeyholderItem
    }
    keyholders(after: $keyholdersAfter, type: ["Pending", "Rolling", "Single Use"]) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...KeyholderItem
        }
      }
    }
    events(after: $eventsAfter) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...KeyEventItem
        }
      }
    }
  }
}
    ${KeyHomeItemFragmentDoc}
${KeyholderItemFragmentDoc}
${KeyEventItemFragmentDoc}`;

/**
 * __useKeyDetailsQuery__
 *
 * To run a query within a React component, call `useKeyDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      keyholdersAfter: // value for 'keyholdersAfter'
 *      eventsAfter: // value for 'eventsAfter'
 *   },
 * });
 */
export function useKeyDetailsQuery(baseOptions: Apollo.QueryHookOptions<KeyDetailsQuery, KeyDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyDetailsQuery, KeyDetailsQueryVariables>(KeyDetailsDocument, options);
      }
export function useKeyDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyDetailsQuery, KeyDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyDetailsQuery, KeyDetailsQueryVariables>(KeyDetailsDocument, options);
        }
export type KeyDetailsQueryHookResult = ReturnType<typeof useKeyDetailsQuery>;
export type KeyDetailsLazyQueryHookResult = ReturnType<typeof useKeyDetailsLazyQuery>;
export type KeyDetailsQueryResult = Apollo.QueryResult<KeyDetailsQuery, KeyDetailsQueryVariables>;
export const KeyholderDocument = gql`
    query Keyholder($keyholderId: UUID!, $keyId: UUID!) {
  keyholder(id: $keyholderId) {
    id
    name
    startDate
    endDate
    phoneNumber
    type
    notes
    email
    company
    archivedAt
  }
  key(id: $keyId) {
    checkoutDate
    name
    home {
      id
      name
    }
    community {
      id
      name
    }
    currentKeyholder {
      id
    }
  }
}
    `;

/**
 * __useKeyholderQuery__
 *
 * To run a query within a React component, call `useKeyholderQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeyholderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeyholderQuery({
 *   variables: {
 *      keyholderId: // value for 'keyholderId'
 *      keyId: // value for 'keyId'
 *   },
 * });
 */
export function useKeyholderQuery(baseOptions: Apollo.QueryHookOptions<KeyholderQuery, KeyholderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeyholderQuery, KeyholderQueryVariables>(KeyholderDocument, options);
      }
export function useKeyholderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeyholderQuery, KeyholderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeyholderQuery, KeyholderQueryVariables>(KeyholderDocument, options);
        }
export type KeyholderQueryHookResult = ReturnType<typeof useKeyholderQuery>;
export type KeyholderLazyQueryHookResult = ReturnType<typeof useKeyholderLazyQuery>;
export type KeyholderQueryResult = Apollo.QueryResult<KeyholderQuery, KeyholderQueryVariables>;
export const UnarchiveKeyDocument = gql`
    mutation UnarchiveKey($input: UnarchiveKeyInput!) {
  unarchiveKey(input: $input) {
    key {
      id
      status
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UnarchiveKeyMutationFn = Apollo.MutationFunction<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>;

/**
 * __useUnarchiveKeyMutation__
 *
 * To run a mutation, you first call `useUnarchiveKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveKeyMutation, { data, loading, error }] = useUnarchiveKeyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveKeyMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>(UnarchiveKeyDocument, options);
      }
export type UnarchiveKeyMutationHookResult = ReturnType<typeof useUnarchiveKeyMutation>;
export type UnarchiveKeyMutationResult = Apollo.MutationResult<UnarchiveKeyMutation>;
export type UnarchiveKeyMutationOptions = Apollo.BaseMutationOptions<UnarchiveKeyMutation, UnarchiveKeyMutationVariables>;
export const UnarchiveKeyholderDocument = gql`
    mutation UnarchiveKeyholder($input: UnarchiveKeyholderInput!) {
  unarchiveKeyholder(input: $input) {
    keyholder {
      id
      archivedAt
      type
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UnarchiveKeyholderMutationFn = Apollo.MutationFunction<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>;

/**
 * __useUnarchiveKeyholderMutation__
 *
 * To run a mutation, you first call `useUnarchiveKeyholderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveKeyholderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveKeyholderMutation, { data, loading, error }] = useUnarchiveKeyholderMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveKeyholderMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>(UnarchiveKeyholderDocument, options);
      }
export type UnarchiveKeyholderMutationHookResult = ReturnType<typeof useUnarchiveKeyholderMutation>;
export type UnarchiveKeyholderMutationResult = Apollo.MutationResult<UnarchiveKeyholderMutation>;
export type UnarchiveKeyholderMutationOptions = Apollo.BaseMutationOptions<UnarchiveKeyholderMutation, UnarchiveKeyholderMutationVariables>;
export const KeysDocument = gql`
    query Keys($communities: [ID!], $after: String, $search2: String, $hasCurrentKeyholder: Boolean, $status: [String], $type: [String], $orderBy: String, $dateFrom: Date, $dateTo: Date, $block: UUID) {
  keys(
    communities: $communities
    block: $block
    after: $after
    search2: $search2
    hasCurrentKeyholder: $hasCurrentKeyholder
    status: $status
    orderBy: $orderBy
    type: $type
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...KeyItem
      }
    }
  }
}
    ${KeyItemFragmentDoc}`;

/**
 * __useKeysQuery__
 *
 * To run a query within a React component, call `useKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useKeysQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      after: // value for 'after'
 *      search2: // value for 'search2'
 *      hasCurrentKeyholder: // value for 'hasCurrentKeyholder'
 *      status: // value for 'status'
 *      type: // value for 'type'
 *      orderBy: // value for 'orderBy'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useKeysQuery(baseOptions?: Apollo.QueryHookOptions<KeysQuery, KeysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<KeysQuery, KeysQueryVariables>(KeysDocument, options);
      }
export function useKeysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<KeysQuery, KeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<KeysQuery, KeysQueryVariables>(KeysDocument, options);
        }
export type KeysQueryHookResult = ReturnType<typeof useKeysQuery>;
export type KeysLazyQueryHookResult = ReturnType<typeof useKeysLazyQuery>;
export type KeysQueryResult = Apollo.QueryResult<KeysQuery, KeysQueryVariables>;
export const ArchiveMarketplaceItemDocument = gql`
    mutation ArchiveMarketplaceItem($input: ArchiveMarketplaceItemInput!) {
  archiveMarketplaceItem(input: $input) {
    marketplaceItem {
      id
      archivedBy {
        id
        name
      }
      archivedOn
      archivedReason
    }
    errors {
      messages
    }
  }
}
    `;
export type ArchiveMarketplaceItemMutationFn = Apollo.MutationFunction<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>;

/**
 * __useArchiveMarketplaceItemMutation__
 *
 * To run a mutation, you first call `useArchiveMarketplaceItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveMarketplaceItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveMarketplaceItemMutation, { data, loading, error }] = useArchiveMarketplaceItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveMarketplaceItemMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>(ArchiveMarketplaceItemDocument, options);
      }
export type ArchiveMarketplaceItemMutationHookResult = ReturnType<typeof useArchiveMarketplaceItemMutation>;
export type ArchiveMarketplaceItemMutationResult = Apollo.MutationResult<ArchiveMarketplaceItemMutation>;
export type ArchiveMarketplaceItemMutationOptions = Apollo.BaseMutationOptions<ArchiveMarketplaceItemMutation, ArchiveMarketplaceItemMutationVariables>;
export const MarketplaceItemDocument = gql`
    query MarketplaceItem($id: UUID!) {
  marketplaceItem(id: $id) {
    ...MarketplaceItem
  }
}
    ${MarketplaceItemFragmentDoc}`;

/**
 * __useMarketplaceItemQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarketplaceItemQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceItemQuery, MarketplaceItemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemQuery, MarketplaceItemQueryVariables>(MarketplaceItemDocument, options);
      }
export function useMarketplaceItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemQuery, MarketplaceItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemQuery, MarketplaceItemQueryVariables>(MarketplaceItemDocument, options);
        }
export type MarketplaceItemQueryHookResult = ReturnType<typeof useMarketplaceItemQuery>;
export type MarketplaceItemLazyQueryHookResult = ReturnType<typeof useMarketplaceItemLazyQuery>;
export type MarketplaceItemQueryResult = Apollo.QueryResult<MarketplaceItemQuery, MarketplaceItemQueryVariables>;
export const MarketplaceItemCommentsDocument = gql`
    query MarketplaceItemComments($id: UUID!, $after: String) {
  marketplaceItem(id: $id) {
    id
    comments(after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          comment
          author {
            id
          }
          name
          createdAt
        }
      }
    }
  }
}
    `;

/**
 * __useMarketplaceItemCommentsQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useMarketplaceItemCommentsQuery(baseOptions: Apollo.QueryHookOptions<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>(MarketplaceItemCommentsDocument, options);
      }
export function useMarketplaceItemCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>(MarketplaceItemCommentsDocument, options);
        }
export type MarketplaceItemCommentsQueryHookResult = ReturnType<typeof useMarketplaceItemCommentsQuery>;
export type MarketplaceItemCommentsLazyQueryHookResult = ReturnType<typeof useMarketplaceItemCommentsLazyQuery>;
export type MarketplaceItemCommentsQueryResult = Apollo.QueryResult<MarketplaceItemCommentsQuery, MarketplaceItemCommentsQueryVariables>;
export const MarketplaceItemsDocument = gql`
    query MarketplaceItems($after: String, $search: String, $communities: [ID!], $status: [String], $orderBy: String) {
  marketplaceItems(
    after: $after
    search: $search
    communities: $communities
    status: $status
    orderBy: $orderBy
  ) {
    edges {
      node {
        ...MarketplaceItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${MarketplaceItemFragmentDoc}`;

/**
 * __useMarketplaceItemsQuery__
 *
 * To run a query within a React component, call `useMarketplaceItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceItemsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      status: // value for 'status'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMarketplaceItemsQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>(MarketplaceItemsDocument, options);
      }
export function useMarketplaceItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>(MarketplaceItemsDocument, options);
        }
export type MarketplaceItemsQueryHookResult = ReturnType<typeof useMarketplaceItemsQuery>;
export type MarketplaceItemsLazyQueryHookResult = ReturnType<typeof useMarketplaceItemsLazyQuery>;
export type MarketplaceItemsQueryResult = Apollo.QueryResult<MarketplaceItemsQuery, MarketplaceItemsQueryVariables>;
export const LeanNotificationCenterNotificationsDocument = gql`
    query LeanNotificationCenterNotifications($after: String, $read: Boolean) {
  leanNotifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: $read
    type: "NOTIFICATION"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...LeanNotificationCenterNotification
      }
    }
  }
}
    ${LeanNotificationCenterNotificationFragmentDoc}`;

/**
 * __useLeanNotificationCenterNotificationsQuery__
 *
 * To run a query within a React component, call `useLeanNotificationCenterNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeanNotificationCenterNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeanNotificationCenterNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useLeanNotificationCenterNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<LeanNotificationCenterNotificationsQuery, LeanNotificationCenterNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeanNotificationCenterNotificationsQuery, LeanNotificationCenterNotificationsQueryVariables>(LeanNotificationCenterNotificationsDocument, options);
      }
export function useLeanNotificationCenterNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeanNotificationCenterNotificationsQuery, LeanNotificationCenterNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeanNotificationCenterNotificationsQuery, LeanNotificationCenterNotificationsQueryVariables>(LeanNotificationCenterNotificationsDocument, options);
        }
export type LeanNotificationCenterNotificationsQueryHookResult = ReturnType<typeof useLeanNotificationCenterNotificationsQuery>;
export type LeanNotificationCenterNotificationsLazyQueryHookResult = ReturnType<typeof useLeanNotificationCenterNotificationsLazyQuery>;
export type LeanNotificationCenterNotificationsQueryResult = Apollo.QueryResult<LeanNotificationCenterNotificationsQuery, LeanNotificationCenterNotificationsQueryVariables>;
export const LeanUnreadNotificationsCountDocument = gql`
    query LeanUnreadNotificationsCount {
  leanNotifications(
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: false
    type: "NOTIFICATION"
  ) {
    totalCount
  }
}
    `;

/**
 * __useLeanUnreadNotificationsCountQuery__
 *
 * To run a query within a React component, call `useLeanUnreadNotificationsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeanUnreadNotificationsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeanUnreadNotificationsCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeanUnreadNotificationsCountQuery(baseOptions?: Apollo.QueryHookOptions<LeanUnreadNotificationsCountQuery, LeanUnreadNotificationsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeanUnreadNotificationsCountQuery, LeanUnreadNotificationsCountQueryVariables>(LeanUnreadNotificationsCountDocument, options);
      }
export function useLeanUnreadNotificationsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeanUnreadNotificationsCountQuery, LeanUnreadNotificationsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeanUnreadNotificationsCountQuery, LeanUnreadNotificationsCountQueryVariables>(LeanUnreadNotificationsCountDocument, options);
        }
export type LeanUnreadNotificationsCountQueryHookResult = ReturnType<typeof useLeanUnreadNotificationsCountQuery>;
export type LeanUnreadNotificationsCountLazyQueryHookResult = ReturnType<typeof useLeanUnreadNotificationsCountLazyQuery>;
export type LeanUnreadNotificationsCountQueryResult = Apollo.QueryResult<LeanUnreadNotificationsCountQuery, LeanUnreadNotificationsCountQueryVariables>;
export const NotificationCenterNotificationsDocument = gql`
    query NotificationCenterNotifications($after: String, $read: Boolean) {
  notifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: $read
    type: "NOTIFICATION"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...NotificationCenterNotification
      }
    }
  }
  unreadNotifications: notifications(
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: false
    type: "NOTIFICATION"
  ) {
    totalCount
  }
}
    ${NotificationCenterNotificationFragmentDoc}`;

/**
 * __useNotificationCenterNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationCenterNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationCenterNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationCenterNotificationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      read: // value for 'read'
 *   },
 * });
 */
export function useNotificationCenterNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<NotificationCenterNotificationsQuery, NotificationCenterNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotificationCenterNotificationsQuery, NotificationCenterNotificationsQueryVariables>(NotificationCenterNotificationsDocument, options);
      }
export function useNotificationCenterNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotificationCenterNotificationsQuery, NotificationCenterNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotificationCenterNotificationsQuery, NotificationCenterNotificationsQueryVariables>(NotificationCenterNotificationsDocument, options);
        }
export type NotificationCenterNotificationsQueryHookResult = ReturnType<typeof useNotificationCenterNotificationsQuery>;
export type NotificationCenterNotificationsLazyQueryHookResult = ReturnType<typeof useNotificationCenterNotificationsLazyQuery>;
export type NotificationCenterNotificationsQueryResult = Apollo.QueryResult<NotificationCenterNotificationsQuery, NotificationCenterNotificationsQueryVariables>;
export const UnreadNotificationDocument = gql`
    mutation UnreadNotification($input: UnreadNotificationInput!) {
  unreadNotification(input: $input) {
    notification {
      id
      read
    }
  }
}
    `;
export type UnreadNotificationMutationFn = Apollo.MutationFunction<UnreadNotificationMutation, UnreadNotificationMutationVariables>;

/**
 * __useUnreadNotificationMutation__
 *
 * To run a mutation, you first call `useUnreadNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnreadNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unreadNotificationMutation, { data, loading, error }] = useUnreadNotificationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnreadNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnreadNotificationMutation, UnreadNotificationMutationVariables>(UnreadNotificationDocument, options);
      }
export type UnreadNotificationMutationHookResult = ReturnType<typeof useUnreadNotificationMutation>;
export type UnreadNotificationMutationResult = Apollo.MutationResult<UnreadNotificationMutation>;
export type UnreadNotificationMutationOptions = Apollo.BaseMutationOptions<UnreadNotificationMutation, UnreadNotificationMutationVariables>;
export const CollectPackagesForHomeDocument = gql`
    mutation CollectPackagesForHome($input: CollectPackagesForHomeInput!) {
  collectPackagesForHome(input: $input) {
    home {
      id
      uncollectedPackageCount
      uncollectedPackages: packages(status: "DE") {
        totalCount
        edges {
          node {
            id
            addressee
            createdAt
          }
        }
      }
      collectedPackages: packages(status: "CO") {
        edges {
          node {
            id
            addressee
            collectedOn
          }
        }
      }
    }
  }
}
    `;
export type CollectPackagesForHomeMutationFn = Apollo.MutationFunction<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>;

/**
 * __useCollectPackagesForHomeMutation__
 *
 * To run a mutation, you first call `useCollectPackagesForHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPackagesForHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPackagesForHomeMutation, { data, loading, error }] = useCollectPackagesForHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectPackagesForHomeMutation(baseOptions?: Apollo.MutationHookOptions<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>(CollectPackagesForHomeDocument, options);
      }
export type CollectPackagesForHomeMutationHookResult = ReturnType<typeof useCollectPackagesForHomeMutation>;
export type CollectPackagesForHomeMutationResult = Apollo.MutationResult<CollectPackagesForHomeMutation>;
export type CollectPackagesForHomeMutationOptions = Apollo.BaseMutationOptions<CollectPackagesForHomeMutation, CollectPackagesForHomeMutationVariables>;
export const HomePackagesDocument = gql`
    query HomePackages($id: UUID!, $after: String, $statuses: [String!]) {
  home(id: $id) {
    id
    address
    packages(after: $after, orderBy: "-last_action", statuses: $statuses) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          addressee
          lastAction
          location
          pickupLocation
          status
        }
      }
    }
    uncollectedPackages: packages(statuses: ["DE"]) {
      totalCount
    }
  }
}
    `;

/**
 * __useHomePackagesQuery__
 *
 * To run a query within a React component, call `useHomePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePackagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useHomePackagesQuery(baseOptions: Apollo.QueryHookOptions<HomePackagesQuery, HomePackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePackagesQuery, HomePackagesQueryVariables>(HomePackagesDocument, options);
      }
export function useHomePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePackagesQuery, HomePackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePackagesQuery, HomePackagesQueryVariables>(HomePackagesDocument, options);
        }
export type HomePackagesQueryHookResult = ReturnType<typeof useHomePackagesQuery>;
export type HomePackagesLazyQueryHookResult = ReturnType<typeof useHomePackagesLazyQuery>;
export type HomePackagesQueryResult = Apollo.QueryResult<HomePackagesQuery, HomePackagesQueryVariables>;
export const PackageReminderToHomeDocument = gql`
    mutation PackageReminderToHome($input: PackageReminderToHomeInput!) {
  packageReminderToHome(input: $input) {
    home {
      id
    }
  }
}
    `;
export type PackageReminderToHomeMutationFn = Apollo.MutationFunction<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>;

/**
 * __usePackageReminderToHomeMutation__
 *
 * To run a mutation, you first call `usePackageReminderToHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReminderToHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReminderToHomeMutation, { data, loading, error }] = usePackageReminderToHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePackageReminderToHomeMutation(baseOptions?: Apollo.MutationHookOptions<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>(PackageReminderToHomeDocument, options);
      }
export type PackageReminderToHomeMutationHookResult = ReturnType<typeof usePackageReminderToHomeMutation>;
export type PackageReminderToHomeMutationResult = Apollo.MutationResult<PackageReminderToHomeMutation>;
export type PackageReminderToHomeMutationOptions = Apollo.BaseMutationOptions<PackageReminderToHomeMutation, PackageReminderToHomeMutationVariables>;
export const AddPackageToHomeDocument = gql`
    mutation AddPackageToHome($input: AddPackageToHomeInput!) {
  addPackageToHome(input: $input) {
    package {
      id
    }
  }
}
    `;
export type AddPackageToHomeMutationFn = Apollo.MutationFunction<AddPackageToHomeMutation, AddPackageToHomeMutationVariables>;

/**
 * __useAddPackageToHomeMutation__
 *
 * To run a mutation, you first call `useAddPackageToHomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPackageToHomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPackageToHomeMutation, { data, loading, error }] = useAddPackageToHomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddPackageToHomeMutation(baseOptions?: Apollo.MutationHookOptions<AddPackageToHomeMutation, AddPackageToHomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPackageToHomeMutation, AddPackageToHomeMutationVariables>(AddPackageToHomeDocument, options);
      }
export type AddPackageToHomeMutationHookResult = ReturnType<typeof useAddPackageToHomeMutation>;
export type AddPackageToHomeMutationResult = Apollo.MutationResult<AddPackageToHomeMutation>;
export type AddPackageToHomeMutationOptions = Apollo.BaseMutationOptions<AddPackageToHomeMutation, AddPackageToHomeMutationVariables>;
export const CreateApplicantAndApplicationDocument = gql`
    mutation CreateApplicantAndApplication($input: CreateApplicantAndApplicationInput!) {
  createApplicantAndApplication(input: $input) {
    applicant {
      id
      user {
        id
      }
    }
  }
}
    `;
export type CreateApplicantAndApplicationMutationFn = Apollo.MutationFunction<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>;

/**
 * __useCreateApplicantAndApplicationMutation__
 *
 * To run a mutation, you first call `useCreateApplicantAndApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApplicantAndApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApplicantAndApplicationMutation, { data, loading, error }] = useCreateApplicantAndApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateApplicantAndApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>(CreateApplicantAndApplicationDocument, options);
      }
export type CreateApplicantAndApplicationMutationHookResult = ReturnType<typeof useCreateApplicantAndApplicationMutation>;
export type CreateApplicantAndApplicationMutationResult = Apollo.MutationResult<CreateApplicantAndApplicationMutation>;
export type CreateApplicantAndApplicationMutationOptions = Apollo.BaseMutationOptions<CreateApplicantAndApplicationMutation, CreateApplicantAndApplicationMutationVariables>;
export const CollectPackagesDocument = gql`
    mutation CollectPackages($input: CollectPackagesInput!) {
  collectPackages(input: $input) {
    packages {
      id
      status
      collectedOn
      collectedBy {
        id
        name
      }
      home {
        id
        uncollectedPackageCount
      }
    }
  }
}
    `;
export type CollectPackagesMutationFn = Apollo.MutationFunction<CollectPackagesMutation, CollectPackagesMutationVariables>;

/**
 * __useCollectPackagesMutation__
 *
 * To run a mutation, you first call `useCollectPackagesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectPackagesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectPackagesMutation, { data, loading, error }] = useCollectPackagesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectPackagesMutation(baseOptions?: Apollo.MutationHookOptions<CollectPackagesMutation, CollectPackagesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CollectPackagesMutation, CollectPackagesMutationVariables>(CollectPackagesDocument, options);
      }
export type CollectPackagesMutationHookResult = ReturnType<typeof useCollectPackagesMutation>;
export type CollectPackagesMutationResult = Apollo.MutationResult<CollectPackagesMutation>;
export type CollectPackagesMutationOptions = Apollo.BaseMutationOptions<CollectPackagesMutation, CollectPackagesMutationVariables>;
export const PackageDocument = gql`
    query Package($id: UUID!) {
  package(id: $id) {
    id
    createdAt
    status
    image
    home {
      id
      name
      addressLine1
      postcode
      community {
        id
        name
      }
    }
    addressee
    collectedOn
    collectedBy {
      id
      name
    }
    scannedInBy {
      id
      name
    }
    reminders {
      id
      createdAt
      user {
        id
        name
      }
    }
    location
    events {
      ...PackageEvent
    }
  }
}
    ${PackageEventFragmentDoc}`;

/**
 * __usePackageQuery__
 *
 * To run a query within a React component, call `usePackageQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePackageQuery(baseOptions: Apollo.QueryHookOptions<PackageQuery, PackageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
      }
export function usePackageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackageQuery, PackageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackageQuery, PackageQueryVariables>(PackageDocument, options);
        }
export type PackageQueryHookResult = ReturnType<typeof usePackageQuery>;
export type PackageLazyQueryHookResult = ReturnType<typeof usePackageLazyQuery>;
export type PackageQueryResult = Apollo.QueryResult<PackageQuery, PackageQueryVariables>;
export const RemindResidentDocument = gql`
    mutation RemindResident($input: RemindResidentInput!) {
  remindResident(input: $input) {
    id
  }
}
    `;
export type RemindResidentMutationFn = Apollo.MutationFunction<RemindResidentMutation, RemindResidentMutationVariables>;

/**
 * __useRemindResidentMutation__
 *
 * To run a mutation, you first call `useRemindResidentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindResidentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindResidentMutation, { data, loading, error }] = useRemindResidentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemindResidentMutation(baseOptions?: Apollo.MutationHookOptions<RemindResidentMutation, RemindResidentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindResidentMutation, RemindResidentMutationVariables>(RemindResidentDocument, options);
      }
export type RemindResidentMutationHookResult = ReturnType<typeof useRemindResidentMutation>;
export type RemindResidentMutationResult = Apollo.MutationResult<RemindResidentMutation>;
export type RemindResidentMutationOptions = Apollo.BaseMutationOptions<RemindResidentMutation, RemindResidentMutationVariables>;
export const UpdatePackageStatusDocument = gql`
    mutation UpdatePackageStatus($input: UpdatePackageStatusInput!) {
  updatePackageStatus(input: $input) {
    package {
      id
      status
      collectedOn
      collectedBy {
        id
        name
      }
    }
  }
}
    `;
export type UpdatePackageStatusMutationFn = Apollo.MutationFunction<UpdatePackageStatusMutation, UpdatePackageStatusMutationVariables>;

/**
 * __useUpdatePackageStatusMutation__
 *
 * To run a mutation, you first call `useUpdatePackageStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePackageStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePackageStatusMutation, { data, loading, error }] = useUpdatePackageStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePackageStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePackageStatusMutation, UpdatePackageStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePackageStatusMutation, UpdatePackageStatusMutationVariables>(UpdatePackageStatusDocument, options);
      }
export type UpdatePackageStatusMutationHookResult = ReturnType<typeof useUpdatePackageStatusMutation>;
export type UpdatePackageStatusMutationResult = Apollo.MutationResult<UpdatePackageStatusMutation>;
export type UpdatePackageStatusMutationOptions = Apollo.BaseMutationOptions<UpdatePackageStatusMutation, UpdatePackageStatusMutationVariables>;
export const PackageReminderToAllDocument = gql`
    mutation PackageReminderToAll($communities: [UUID]!) {
  packageReminderToAll(communities: $communities) {
    packages {
      id
      reminders {
        id
        createdAt
        user {
          id
          firstName
          lastName
          email
        }
      }
    }
  }
}
    `;
export type PackageReminderToAllMutationFn = Apollo.MutationFunction<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>;

/**
 * __usePackageReminderToAllMutation__
 *
 * To run a mutation, you first call `usePackageReminderToAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePackageReminderToAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [packageReminderToAllMutation, { data, loading, error }] = usePackageReminderToAllMutation({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function usePackageReminderToAllMutation(baseOptions?: Apollo.MutationHookOptions<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>(PackageReminderToAllDocument, options);
      }
export type PackageReminderToAllMutationHookResult = ReturnType<typeof usePackageReminderToAllMutation>;
export type PackageReminderToAllMutationResult = Apollo.MutationResult<PackageReminderToAllMutation>;
export type PackageReminderToAllMutationOptions = Apollo.BaseMutationOptions<PackageReminderToAllMutation, PackageReminderToAllMutationVariables>;
export const ExportPackagesDocument = gql`
    query ExportPackages($communities: [UUID!], $statuses: [String!], $search: String, $dateFrom: Date, $dateTo: Date, $block: UUID) {
  packagesExport(
    communities: $communities
    statuses: $statuses
    search: $search
    dateFrom: $dateFrom
    dateTo: $dateTo
    block: $block
  )
}
    `;

/**
 * __useExportPackagesQuery__
 *
 * To run a query within a React component, call `useExportPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportPackagesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      statuses: // value for 'statuses'
 *      search: // value for 'search'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useExportPackagesQuery(baseOptions?: Apollo.QueryHookOptions<ExportPackagesQuery, ExportPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportPackagesQuery, ExportPackagesQueryVariables>(ExportPackagesDocument, options);
      }
export function useExportPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportPackagesQuery, ExportPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportPackagesQuery, ExportPackagesQueryVariables>(ExportPackagesDocument, options);
        }
export type ExportPackagesQueryHookResult = ReturnType<typeof useExportPackagesQuery>;
export type ExportPackagesLazyQueryHookResult = ReturnType<typeof useExportPackagesLazyQuery>;
export type ExportPackagesQueryResult = Apollo.QueryResult<ExportPackagesQuery, ExportPackagesQueryVariables>;
export const HomesWithPackagesDocument = gql`
    query HomesWithPackages($first: Int, $after: String, $icontainsSearch: String, $communities: [ID!], $orderBy: String, $hasUncollected: Boolean, $block: UUID) {
  homes(
    first: $first
    after: $after
    icontainsSearch: $icontainsSearch
    communities: $communities
    orderBy: $orderBy
    hasUncollected: $hasUncollected
    block: $block
    includeDemoHomes: false
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        name
        addressLine1
        city
        postcode
        block {
          id
          name
        }
        community {
          id
          name
        }
        uncollectedPackageCount
      }
    }
  }
}
    `;

/**
 * __useHomesWithPackagesQuery__
 *
 * To run a query within a React component, call `useHomesWithPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomesWithPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomesWithPackagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      icontainsSearch: // value for 'icontainsSearch'
 *      communities: // value for 'communities'
 *      orderBy: // value for 'orderBy'
 *      hasUncollected: // value for 'hasUncollected'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useHomesWithPackagesQuery(baseOptions?: Apollo.QueryHookOptions<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>(HomesWithPackagesDocument, options);
      }
export function useHomesWithPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>(HomesWithPackagesDocument, options);
        }
export type HomesWithPackagesQueryHookResult = ReturnType<typeof useHomesWithPackagesQuery>;
export type HomesWithPackagesLazyQueryHookResult = ReturnType<typeof useHomesWithPackagesLazyQuery>;
export type HomesWithPackagesQueryResult = Apollo.QueryResult<HomesWithPackagesQuery, HomesWithPackagesQueryVariables>;
export const PackagesDocument = gql`
    query Packages($first: Int, $after: String, $search: String, $status: String, $statuses: [String!], $locations: [String!], $communities: [ID!], $block: UUID, $orderBy: String, $dateFrom: Date, $dateTo: Date) {
  packages(
    first: $first
    after: $after
    search: $search
    status: $status
    statuses: $statuses
    locations: $locations
    communities: $communities
    block: $block
    orderBy: $orderBy
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        status
        lastAction
        collectedOn
        addressee
        home {
          name
          addressLine1
          postcode
          block {
            id
            name
          }
          community {
            id
            name
          }
        }
        location
      }
    }
  }
}
    `;

/**
 * __usePackagesQuery__
 *
 * To run a query within a React component, call `usePackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePackagesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      statuses: // value for 'statuses'
 *      locations: // value for 'locations'
 *      communities: // value for 'communities'
 *      block: // value for 'block'
 *      orderBy: // value for 'orderBy'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *   },
 * });
 */
export function usePackagesQuery(baseOptions?: Apollo.QueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
      }
export function usePackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PackagesQuery, PackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PackagesQuery, PackagesQueryVariables>(PackagesDocument, options);
        }
export type PackagesQueryHookResult = ReturnType<typeof usePackagesQuery>;
export type PackagesLazyQueryHookResult = ReturnType<typeof usePackagesLazyQuery>;
export type PackagesQueryResult = Apollo.QueryResult<PackagesQuery, PackagesQueryVariables>;
export const AccountTransactionsDocument = gql`
    query AccountTransactions($after: String, $search: String, $communities: [ID!], $orderBy: String) {
  accountTransactions(
    after: $after
    search: $search
    orderBy: $orderBy
    communities: $communities
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...AccountTransactionItem
      }
    }
  }
}
    ${AccountTransactionItemFragmentDoc}`;

/**
 * __useAccountTransactionsQuery__
 *
 * To run a query within a React component, call `useAccountTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountTransactionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useAccountTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<AccountTransactionsQuery, AccountTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountTransactionsQuery, AccountTransactionsQueryVariables>(AccountTransactionsDocument, options);
      }
export function useAccountTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountTransactionsQuery, AccountTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountTransactionsQuery, AccountTransactionsQueryVariables>(AccountTransactionsDocument, options);
        }
export type AccountTransactionsQueryHookResult = ReturnType<typeof useAccountTransactionsQuery>;
export type AccountTransactionsLazyQueryHookResult = ReturnType<typeof useAccountTransactionsLazyQuery>;
export type AccountTransactionsQueryResult = Apollo.QueryResult<AccountTransactionsQuery, AccountTransactionsQueryVariables>;
export const ProfileNotificationSettingsDocument = gql`
    query ProfileNotificationSettings {
  getManager {
    id
    emailPreferences
  }
}
    `;

/**
 * __useProfileNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useProfileNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProfileNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProfileNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProfileNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>(ProfileNotificationSettingsDocument, options);
      }
export function useProfileNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>(ProfileNotificationSettingsDocument, options);
        }
export type ProfileNotificationSettingsQueryHookResult = ReturnType<typeof useProfileNotificationSettingsQuery>;
export type ProfileNotificationSettingsLazyQueryHookResult = ReturnType<typeof useProfileNotificationSettingsLazyQuery>;
export type ProfileNotificationSettingsQueryResult = Apollo.QueryResult<ProfileNotificationSettingsQuery, ProfileNotificationSettingsQueryVariables>;
export const UpdateManagerDocument = gql`
    mutation updateManager($input: UpdateManagerInput!) {
  updateManager(input: $input) {
    manager {
      id
    }
  }
}
    `;
export type UpdateManagerMutationFn = Apollo.MutationFunction<UpdateManagerMutation, UpdateManagerMutationVariables>;

/**
 * __useUpdateManagerMutation__
 *
 * To run a mutation, you first call `useUpdateManagerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerMutation, { data, loading, error }] = useUpdateManagerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManagerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerMutation, UpdateManagerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagerMutation, UpdateManagerMutationVariables>(UpdateManagerDocument, options);
      }
export type UpdateManagerMutationHookResult = ReturnType<typeof useUpdateManagerMutation>;
export type UpdateManagerMutationResult = Apollo.MutationResult<UpdateManagerMutation>;
export type UpdateManagerMutationOptions = Apollo.BaseMutationOptions<UpdateManagerMutation, UpdateManagerMutationVariables>;
export const UpdateManagerNotificationSettingsDocument = gql`
    mutation updateManagerNotificationSettings($input: UpdateManagerNotificationSettingsInput!) {
  updateManagerNotificationSettings(input: $input) {
    manager {
      id
      emailPreferences
    }
  }
}
    `;
export type UpdateManagerNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>;

/**
 * __useUpdateManagerNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateManagerNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateManagerNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateManagerNotificationSettingsMutation, { data, loading, error }] = useUpdateManagerNotificationSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateManagerNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>(UpdateManagerNotificationSettingsDocument, options);
      }
export type UpdateManagerNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateManagerNotificationSettingsMutation>;
export type UpdateManagerNotificationSettingsMutationResult = Apollo.MutationResult<UpdateManagerNotificationSettingsMutation>;
export type UpdateManagerNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateManagerNotificationSettingsMutation, UpdateManagerNotificationSettingsMutationVariables>;
export const UpdateMobileDocument = gql`
    mutation UpdateMobile($input: UpdateUserMobileNumberInput!) {
  updateMobileNumber(input: $input) {
    error
    user {
      id
      email
      mobile
    }
  }
}
    `;
export type UpdateMobileMutationFn = Apollo.MutationFunction<UpdateMobileMutation, UpdateMobileMutationVariables>;

/**
 * __useUpdateMobileMutation__
 *
 * To run a mutation, you first call `useUpdateMobileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMobileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMobileMutation, { data, loading, error }] = useUpdateMobileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMobileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMobileMutation, UpdateMobileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMobileMutation, UpdateMobileMutationVariables>(UpdateMobileDocument, options);
      }
export type UpdateMobileMutationHookResult = ReturnType<typeof useUpdateMobileMutation>;
export type UpdateMobileMutationResult = Apollo.MutationResult<UpdateMobileMutation>;
export type UpdateMobileMutationOptions = Apollo.BaseMutationOptions<UpdateMobileMutation, UpdateMobileMutationVariables>;
export const ResidentAppNotificationPreferencesDocument = gql`
    query ResidentAppNotificationPreferences {
  residentAppNotificationPreferences {
    id
    isMuted
  }
}
    `;

/**
 * __useResidentAppNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useResidentAppNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResidentAppNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResidentAppNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useResidentAppNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<ResidentAppNotificationPreferencesQuery, ResidentAppNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResidentAppNotificationPreferencesQuery, ResidentAppNotificationPreferencesQueryVariables>(ResidentAppNotificationPreferencesDocument, options);
      }
export function useResidentAppNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResidentAppNotificationPreferencesQuery, ResidentAppNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResidentAppNotificationPreferencesQuery, ResidentAppNotificationPreferencesQueryVariables>(ResidentAppNotificationPreferencesDocument, options);
        }
export type ResidentAppNotificationPreferencesQueryHookResult = ReturnType<typeof useResidentAppNotificationPreferencesQuery>;
export type ResidentAppNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useResidentAppNotificationPreferencesLazyQuery>;
export type ResidentAppNotificationPreferencesQueryResult = Apollo.QueryResult<ResidentAppNotificationPreferencesQuery, ResidentAppNotificationPreferencesQueryVariables>;
export const ToggleAllResidentAppNotificationPreferencesDocument = gql`
    mutation ToggleAllResidentAppNotificationPreferences($input: ToggleAllResidentAppNotificationPreferencesInput!) {
  toggleAllResidentAppNotificationPreferences(input: $input) {
    residentAppNotificationPreferences {
      id
      isMuted
    }
  }
}
    `;
export type ToggleAllResidentAppNotificationPreferencesMutationFn = Apollo.MutationFunction<ToggleAllResidentAppNotificationPreferencesMutation, ToggleAllResidentAppNotificationPreferencesMutationVariables>;

/**
 * __useToggleAllResidentAppNotificationPreferencesMutation__
 *
 * To run a mutation, you first call `useToggleAllResidentAppNotificationPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleAllResidentAppNotificationPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleAllResidentAppNotificationPreferencesMutation, { data, loading, error }] = useToggleAllResidentAppNotificationPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleAllResidentAppNotificationPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<ToggleAllResidentAppNotificationPreferencesMutation, ToggleAllResidentAppNotificationPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleAllResidentAppNotificationPreferencesMutation, ToggleAllResidentAppNotificationPreferencesMutationVariables>(ToggleAllResidentAppNotificationPreferencesDocument, options);
      }
export type ToggleAllResidentAppNotificationPreferencesMutationHookResult = ReturnType<typeof useToggleAllResidentAppNotificationPreferencesMutation>;
export type ToggleAllResidentAppNotificationPreferencesMutationResult = Apollo.MutationResult<ToggleAllResidentAppNotificationPreferencesMutation>;
export type ToggleAllResidentAppNotificationPreferencesMutationOptions = Apollo.BaseMutationOptions<ToggleAllResidentAppNotificationPreferencesMutation, ToggleAllResidentAppNotificationPreferencesMutationVariables>;
export const UpdateNotificationPreferenceDocument = gql`
    mutation UpdateNotificationPreference($input: UpdateNotificationPreferenceInput!) {
  updateNotificationPreference(input: $input) {
    userNotificationPreference {
      id
      managerAmenityPushEnabled
      managerAmenityEmailEnabled
      managerApplicationPushEnabled
      managerApplicationEmailEnabled
      managerApplicationMessagePushEnabled
      managerApplicationMessageEmailEnabled
      managerCommunityEventPushEnabled
      managerCommunityEventEmailEnabled
      managerCommunityProductPushEnabled
      managerCommunityProductEmailEnabled
      managerCommunityUpdatePushEnabled
      managerCommunityUpdateEmailEnabled
      managerConversationAssignmentPushEnabled
      managerConversationAssignmentEmailEnabled
      managerTeamAssignmentPushEnabled
      managerTeamAssignmentEmailEnabled
      managerConversationPushEnabled
      managerConversationEmailEnabled
      managerSurveysPushEnabled
      managerSurveysEmailEnabled
      managerTaskAssignmentPushEnabled
      managerTaskUpdatePushEnabled
      managerTaskCommentPushEnabled
    }
  }
}
    `;
export type UpdateNotificationPreferenceMutationFn = Apollo.MutationFunction<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;

/**
 * __useUpdateNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationPreferenceMutation, { data, loading, error }] = useUpdateNotificationPreferenceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>(UpdateNotificationPreferenceDocument, options);
      }
export type UpdateNotificationPreferenceMutationHookResult = ReturnType<typeof useUpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationResult = Apollo.MutationResult<UpdateNotificationPreferenceMutation>;
export type UpdateNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationPreferenceMutation, UpdateNotificationPreferenceMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
  updateUserProfile(input: $input) {
    userProfile {
      id
      biography
      residentAppVisibility
      displayRole
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UserNotificationPreferencesDocument = gql`
    query UserNotificationPreferences {
  userNotificationPreferences {
    edges {
      node {
        id
        managerAmenityPushEnabled
        managerAmenityEmailEnabled
        managerApplicationPushEnabled
        managerApplicationEmailEnabled
        managerApplicationMessagePushEnabled
        managerApplicationMessageEmailEnabled
        managerCommunityEventPushEnabled
        managerCommunityEventEmailEnabled
        managerCommunityProductPushEnabled
        managerCommunityProductEmailEnabled
        managerCommunityUpdatePushEnabled
        managerCommunityUpdateEmailEnabled
        managerConversationAssignmentPushEnabled
        managerConversationAssignmentEmailEnabled
        managerTeamAssignmentPushEnabled
        managerTeamAssignmentEmailEnabled
        managerConversationPushEnabled
        managerConversationEmailEnabled
        managerSurveysPushEnabled
        managerSurveysEmailEnabled
        managerTaskAssignmentPushEnabled
        managerTaskUpdatePushEnabled
        managerTaskCommentPushEnabled
      }
    }
  }
}
    `;

/**
 * __useUserNotificationPreferencesQuery__
 *
 * To run a query within a React component, call `useUserNotificationPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserNotificationPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserNotificationPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserNotificationPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>(UserNotificationPreferencesDocument, options);
      }
export function useUserNotificationPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>(UserNotificationPreferencesDocument, options);
        }
export type UserNotificationPreferencesQueryHookResult = ReturnType<typeof useUserNotificationPreferencesQuery>;
export type UserNotificationPreferencesLazyQueryHookResult = ReturnType<typeof useUserNotificationPreferencesLazyQuery>;
export type UserNotificationPreferencesQueryResult = Apollo.QueryResult<UserNotificationPreferencesQuery, UserNotificationPreferencesQueryVariables>;
export const LeanPulseDocument = gql`
    query LeanPulse($after: String) {
  leanNotifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    type: "PULSE"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...LeanPulseNotification
      }
    }
  }
  leanUnreadNotifications: leanNotifications(
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: false
    type: "PULSE"
  ) {
    totalCount
  }
}
    ${LeanPulseNotificationFragmentDoc}`;

/**
 * __useLeanPulseQuery__
 *
 * To run a query within a React component, call `useLeanPulseQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeanPulseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeanPulseQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function useLeanPulseQuery(baseOptions?: Apollo.QueryHookOptions<LeanPulseQuery, LeanPulseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeanPulseQuery, LeanPulseQueryVariables>(LeanPulseDocument, options);
      }
export function useLeanPulseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeanPulseQuery, LeanPulseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeanPulseQuery, LeanPulseQueryVariables>(LeanPulseDocument, options);
        }
export type LeanPulseQueryHookResult = ReturnType<typeof useLeanPulseQuery>;
export type LeanPulseLazyQueryHookResult = ReturnType<typeof useLeanPulseLazyQuery>;
export type LeanPulseQueryResult = Apollo.QueryResult<LeanPulseQuery, LeanPulseQueryVariables>;
export const PulseDocument = gql`
    query Pulse($after: String) {
  notifications(
    after: $after
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    type: "PULSE"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...PulseNotification
      }
    }
  }
  unreadNotifications: notifications(
    platform: "manager-dashboard"
    hasTarget: true
    hasActor: true
    read: false
    type: "PULSE"
  ) {
    totalCount
  }
}
    ${PulseNotificationFragmentDoc}`;

/**
 * __usePulseQuery__
 *
 * To run a query within a React component, call `usePulseQuery` and pass it any options that fit your needs.
 * When your component renders, `usePulseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePulseQuery({
 *   variables: {
 *      after: // value for 'after'
 *   },
 * });
 */
export function usePulseQuery(baseOptions?: Apollo.QueryHookOptions<PulseQuery, PulseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PulseQuery, PulseQueryVariables>(PulseDocument, options);
      }
export function usePulseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PulseQuery, PulseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PulseQuery, PulseQueryVariables>(PulseDocument, options);
        }
export type PulseQueryHookResult = ReturnType<typeof usePulseQuery>;
export type PulseLazyQueryHookResult = ReturnType<typeof usePulseLazyQuery>;
export type PulseQueryResult = Apollo.QueryResult<PulseQuery, PulseQueryVariables>;
export const ReadAllPulsesDocument = gql`
    mutation ReadAllPulses {
  readAllNotifications(input: {type: "PULSE"}) {
    clientMutationId
  }
}
    `;
export type ReadAllPulsesMutationFn = Apollo.MutationFunction<ReadAllPulsesMutation, ReadAllPulsesMutationVariables>;

/**
 * __useReadAllPulsesMutation__
 *
 * To run a mutation, you first call `useReadAllPulsesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReadAllPulsesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [readAllPulsesMutation, { data, loading, error }] = useReadAllPulsesMutation({
 *   variables: {
 *   },
 * });
 */
export function useReadAllPulsesMutation(baseOptions?: Apollo.MutationHookOptions<ReadAllPulsesMutation, ReadAllPulsesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReadAllPulsesMutation, ReadAllPulsesMutationVariables>(ReadAllPulsesDocument, options);
      }
export type ReadAllPulsesMutationHookResult = ReturnType<typeof useReadAllPulsesMutation>;
export type ReadAllPulsesMutationResult = Apollo.MutationResult<ReadAllPulsesMutation>;
export type ReadAllPulsesMutationOptions = Apollo.BaseMutationOptions<ReadAllPulsesMutation, ReadAllPulsesMutationVariables>;
export const ApplicationDetailsDocument = gql`
    query ApplicationDetails($id: UUID!) {
  tenancyApplication(id: $id) {
    id
    applicantNames
    combinedAffordability
    affordabilityStatus
    rentAmount
    completedOn
    status
    home {
      id
      address
      community {
        id
        name
      }
    }
    applicants {
      edges {
        node {
          ...TenancyApplicantItem
        }
      }
    }
  }
}
    ${TenancyApplicantItemFragmentDoc}`;

/**
 * __useApplicationDetailsQuery__
 *
 * To run a query within a React component, call `useApplicationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useApplicationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApplicationDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApplicationDetailsQuery(baseOptions: Apollo.QueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
      }
export function useApplicationDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>(ApplicationDetailsDocument, options);
        }
export type ApplicationDetailsQueryHookResult = ReturnType<typeof useApplicationDetailsQuery>;
export type ApplicationDetailsLazyQueryHookResult = ReturnType<typeof useApplicationDetailsLazyQuery>;
export type ApplicationDetailsQueryResult = Apollo.QueryResult<ApplicationDetailsQuery, ApplicationDetailsQueryVariables>;
export const CreateTenancyApplicationDocument = gql`
    mutation CreateTenancyApplication($input: CreateTenancyApplicationInput!) {
  createTenancyApplication(input: $input) {
    tenancyApplication {
      id
    }
  }
}
    `;
export type CreateTenancyApplicationMutationFn = Apollo.MutationFunction<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>;

/**
 * __useCreateTenancyApplicationMutation__
 *
 * To run a mutation, you first call `useCreateTenancyApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTenancyApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTenancyApplicationMutation, { data, loading, error }] = useCreateTenancyApplicationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTenancyApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>(CreateTenancyApplicationDocument, options);
      }
export type CreateTenancyApplicationMutationHookResult = ReturnType<typeof useCreateTenancyApplicationMutation>;
export type CreateTenancyApplicationMutationResult = Apollo.MutationResult<CreateTenancyApplicationMutation>;
export type CreateTenancyApplicationMutationOptions = Apollo.BaseMutationOptions<CreateTenancyApplicationMutation, CreateTenancyApplicationMutationVariables>;
export const ReferencingDisabledCommunitiesDocument = gql`
    query ReferencingDisabledCommunities {
  getUser {
    id
    manager {
      id
      community(referencingEnabled: false) {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useReferencingDisabledCommunitiesQuery__
 *
 * To run a query within a React component, call `useReferencingDisabledCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencingDisabledCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencingDisabledCommunitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencingDisabledCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>(ReferencingDisabledCommunitiesDocument, options);
      }
export function useReferencingDisabledCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>(ReferencingDisabledCommunitiesDocument, options);
        }
export type ReferencingDisabledCommunitiesQueryHookResult = ReturnType<typeof useReferencingDisabledCommunitiesQuery>;
export type ReferencingDisabledCommunitiesLazyQueryHookResult = ReturnType<typeof useReferencingDisabledCommunitiesLazyQuery>;
export type ReferencingDisabledCommunitiesQueryResult = Apollo.QueryResult<ReferencingDisabledCommunitiesQuery, ReferencingDisabledCommunitiesQueryVariables>;
export const TenantReferenceDocument = gql`
    query TenantReference($uuid: UUID!) {
  tenantReference(id: $uuid) {
    id
    firstName
    lastName
    submittedAt
    status
    dateOfBirth
    employmentStatus
    lettingHistoryStatus
    rentAffordability
    applicant {
      id
      tenancyApplication {
        id
        rentAmount
        applicants {
          edges {
            node {
              id
              firstName
              lastName
              reference {
                id
                status
              }
            }
          }
        }
      }
    }
    currentAddress {
      id
      fullAddress
    }
    tenantEmploymentDetails {
      income
    }
    historicalAddresses {
      edges {
        node {
          id
          fullAddress
        }
      }
    }
    creditCheck {
      id
      riskLevel
      score
      aliases
      createdAt
      totalCountyCourtJudgements
      activeCountyCourtJudgements
      totalBankruptcies
      activeBankruptcies
    }
    creditCheckStatus
    identityVerification {
      id
      status
      passport
      passportSelfie
      nationality
      documentType
      documentNumber
      documentExpiryDate
      selfie
      hasRightToRent
    }
    identityVerificationStatus
    rightToRent {
      id
      shareCode
      document
      officialVerificationStatus
      officialExpiryDate
      officialDocument
    }
    rightToRentStatus
    tenantEmploymentDetails {
      id
      employmentType
      jobTitle
      companyName
      fullOrPartTime
      startDate
      income
      paymentFrequency
      employmentEnding
    }
    employerReference {
      id
      submittedAt
      firstName
      lastName
      jobTitle
      mobile
      email
      companyName
      employerEmploymentDetails {
        id
        employmentType
        jobTitle
        fullOrPartTime
        startDate
        income
        paymentFrequency
        employmentEnding
        companyName
      }
    }
    landlordReference {
      id
      firstName
      lastName
      mobile
      email
      submittedAt
      landlordOrAgent
      comments
      tenantMoveInDate
      tenancyType
      monthlyRentAmount
      hasOutstandingRent
      rentPaidOnTime
      treatedPropertyWell
    }
  }
}
    `;

/**
 * __useTenantReferenceQuery__
 *
 * To run a query within a React component, call `useTenantReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantReferenceQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTenantReferenceQuery(baseOptions: Apollo.QueryHookOptions<TenantReferenceQuery, TenantReferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantReferenceQuery, TenantReferenceQueryVariables>(TenantReferenceDocument, options);
      }
export function useTenantReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantReferenceQuery, TenantReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantReferenceQuery, TenantReferenceQueryVariables>(TenantReferenceDocument, options);
        }
export type TenantReferenceQueryHookResult = ReturnType<typeof useTenantReferenceQuery>;
export type TenantReferenceLazyQueryHookResult = ReturnType<typeof useTenantReferenceLazyQuery>;
export type TenantReferenceQueryResult = Apollo.QueryResult<TenantReferenceQuery, TenantReferenceQueryVariables>;
export const TenantDetailsHeaderDocument = gql`
    query TenantDetailsHeader($uuid: UUID!) {
  tenantReference(id: $uuid) {
    id
    applicant {
      id
      name
      email
      mobile
    }
    application {
      id
      home {
        address
      }
    }
  }
}
    `;

/**
 * __useTenantDetailsHeaderQuery__
 *
 * To run a query within a React component, call `useTenantDetailsHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenantDetailsHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenantDetailsHeaderQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useTenantDetailsHeaderQuery(baseOptions: Apollo.QueryHookOptions<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>(TenantDetailsHeaderDocument, options);
      }
export function useTenantDetailsHeaderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>(TenantDetailsHeaderDocument, options);
        }
export type TenantDetailsHeaderQueryHookResult = ReturnType<typeof useTenantDetailsHeaderQuery>;
export type TenantDetailsHeaderLazyQueryHookResult = ReturnType<typeof useTenantDetailsHeaderLazyQuery>;
export type TenantDetailsHeaderQueryResult = Apollo.QueryResult<TenantDetailsHeaderQuery, TenantDetailsHeaderQueryVariables>;
export const TenancyApplicationCountsDocument = gql`
    query TenancyApplicationCounts($search: String, $communities: [ID!]) {
  waitingApplications: tenancyApplications(
    status: ["WAITING"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  issueApplications: tenancyApplications(
    status: ["CAUTION", "FAILED"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  passedApplications: tenancyApplications(
    status: ["COMPLETED"]
    search: $search
    communities: $communities
  ) {
    totalCount
  }
  totalApplications: tenancyApplications(
    search: $search
    communities: $communities
  ) {
    totalCount
  }
}
    `;

/**
 * __useTenancyApplicationCountsQuery__
 *
 * To run a query within a React component, call `useTenancyApplicationCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancyApplicationCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancyApplicationCountsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useTenancyApplicationCountsQuery(baseOptions?: Apollo.QueryHookOptions<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>(TenancyApplicationCountsDocument, options);
      }
export function useTenancyApplicationCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>(TenancyApplicationCountsDocument, options);
        }
export type TenancyApplicationCountsQueryHookResult = ReturnType<typeof useTenancyApplicationCountsQuery>;
export type TenancyApplicationCountsLazyQueryHookResult = ReturnType<typeof useTenancyApplicationCountsLazyQuery>;
export type TenancyApplicationCountsQueryResult = Apollo.QueryResult<TenancyApplicationCountsQuery, TenancyApplicationCountsQueryVariables>;
export const TenancyApplicationsDocument = gql`
    query TenancyApplications($after: String, $search: String, $status: [String], $communities: [ID!]) {
  tenancyApplications(
    after: $after
    status: $status
    search: $search
    communities: $communities
  ) {
    edges {
      node {
        ...TenancyApplicationItem
      }
    }
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${TenancyApplicationItemFragmentDoc}`;

/**
 * __useTenancyApplicationsQuery__
 *
 * To run a query within a React component, call `useTenancyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTenancyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTenancyApplicationsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      status: // value for 'status'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useTenancyApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>(TenancyApplicationsDocument, options);
      }
export function useTenancyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>(TenancyApplicationsDocument, options);
        }
export type TenancyApplicationsQueryHookResult = ReturnType<typeof useTenancyApplicationsQuery>;
export type TenancyApplicationsLazyQueryHookResult = ReturnType<typeof useTenancyApplicationsLazyQuery>;
export type TenancyApplicationsQueryResult = Apollo.QueryResult<TenancyApplicationsQuery, TenancyApplicationsQueryVariables>;
export const PortfolioEngagementReportDocument = gql`
    query PortfolioEngagementReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $withTrend: Boolean!) {
  reportingPortfolioEngagement(communities: $communities, period: $period) {
    rows {
      ...PortfolioEngagementRowFields
    }
    reach {
      ...PortfolioReachRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioEngagementRowFields
      }
    }
    reachTrend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioReachRowFields
      }
    }
    coverage @include(if: $withTrend) {
      ...PortfolioCoverageFields
    }
    bookings @include(if: $withTrend) {
      count
      communitiesWithBookings
      communityCount
    }
    applications @include(if: $withTrend) {
      received
      inApp
      inAppShare
    }
  }
}
    ${PortfolioEngagementRowFieldsFragmentDoc}
${PortfolioReachRowFieldsFragmentDoc}
${PortfolioWindowFieldsFragmentDoc}
${PortfolioCoverageFieldsFragmentDoc}`;

/**
 * __usePortfolioEngagementReportQuery__
 *
 * To run a query within a React component, call `usePortfolioEngagementReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioEngagementReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioEngagementReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      withTrend: // value for 'withTrend'
 *   },
 * });
 */
export function usePortfolioEngagementReportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioEngagementReportQuery, PortfolioEngagementReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioEngagementReportQuery, PortfolioEngagementReportQueryVariables>(PortfolioEngagementReportDocument, options);
      }
export function usePortfolioEngagementReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioEngagementReportQuery, PortfolioEngagementReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioEngagementReportQuery, PortfolioEngagementReportQueryVariables>(PortfolioEngagementReportDocument, options);
        }
export type PortfolioEngagementReportQueryHookResult = ReturnType<typeof usePortfolioEngagementReportQuery>;
export type PortfolioEngagementReportLazyQueryHookResult = ReturnType<typeof usePortfolioEngagementReportLazyQuery>;
export type PortfolioEngagementReportQueryResult = Apollo.QueryResult<PortfolioEngagementReportQuery, PortfolioEngagementReportQueryVariables>;
export const PortfolioMaintenanceReportDocument = gql`
    query PortfolioMaintenanceReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $withTrend: Boolean!) {
  reportingPortfolioMaintenance(communities: $communities, period: $period) {
    closeTargetDays
    rows {
      ...PortfolioMaintenanceRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioMaintenanceRowFields
      }
    }
    types @include(if: $withTrend) {
      ...PortfolioIssueTypeFields
    }
  }
}
    ${PortfolioMaintenanceRowFieldsFragmentDoc}
${PortfolioWindowFieldsFragmentDoc}
${PortfolioIssueTypeFieldsFragmentDoc}`;

/**
 * __usePortfolioMaintenanceReportQuery__
 *
 * To run a query within a React component, call `usePortfolioMaintenanceReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioMaintenanceReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioMaintenanceReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      withTrend: // value for 'withTrend'
 *   },
 * });
 */
export function usePortfolioMaintenanceReportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioMaintenanceReportQuery, PortfolioMaintenanceReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioMaintenanceReportQuery, PortfolioMaintenanceReportQueryVariables>(PortfolioMaintenanceReportDocument, options);
      }
export function usePortfolioMaintenanceReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioMaintenanceReportQuery, PortfolioMaintenanceReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioMaintenanceReportQuery, PortfolioMaintenanceReportQueryVariables>(PortfolioMaintenanceReportDocument, options);
        }
export type PortfolioMaintenanceReportQueryHookResult = ReturnType<typeof usePortfolioMaintenanceReportQuery>;
export type PortfolioMaintenanceReportLazyQueryHookResult = ReturnType<typeof usePortfolioMaintenanceReportLazyQuery>;
export type PortfolioMaintenanceReportQueryResult = Apollo.QueryResult<PortfolioMaintenanceReportQuery, PortfolioMaintenanceReportQueryVariables>;
export const PortfolioOverviewReportDocument = gql`
    query PortfolioOverviewReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $withTrend: Boolean!) {
  reportingPortfolioEngagement(communities: $communities, period: $period) {
    rows {
      ...PortfolioEngagementRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioEngagementRowFields
      }
    }
  }
  reportingPortfolioMaintenance(communities: $communities, period: $period) {
    rows {
      ...PortfolioMaintenanceRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioMaintenanceRowFields
      }
    }
  }
  reportingPortfolioSatisfaction(communities: $communities, period: $period) {
    rows {
      ...PortfolioSatisfactionRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioSatisfactionRowFields
      }
    }
  }
}
    ${PortfolioEngagementRowFieldsFragmentDoc}
${PortfolioWindowFieldsFragmentDoc}
${PortfolioMaintenanceRowFieldsFragmentDoc}
${PortfolioSatisfactionRowFieldsFragmentDoc}`;

/**
 * __usePortfolioOverviewReportQuery__
 *
 * To run a query within a React component, call `usePortfolioOverviewReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioOverviewReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioOverviewReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      withTrend: // value for 'withTrend'
 *   },
 * });
 */
export function usePortfolioOverviewReportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioOverviewReportQuery, PortfolioOverviewReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioOverviewReportQuery, PortfolioOverviewReportQueryVariables>(PortfolioOverviewReportDocument, options);
      }
export function usePortfolioOverviewReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioOverviewReportQuery, PortfolioOverviewReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioOverviewReportQuery, PortfolioOverviewReportQueryVariables>(PortfolioOverviewReportDocument, options);
        }
export type PortfolioOverviewReportQueryHookResult = ReturnType<typeof usePortfolioOverviewReportQuery>;
export type PortfolioOverviewReportLazyQueryHookResult = ReturnType<typeof usePortfolioOverviewReportLazyQuery>;
export type PortfolioOverviewReportQueryResult = Apollo.QueryResult<PortfolioOverviewReportQuery, PortfolioOverviewReportQueryVariables>;
export const PortfolioSatisfactionReportDocument = gql`
    query PortfolioSatisfactionReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $withTrend: Boolean!) {
  reportingPortfolioSatisfaction(communities: $communities, period: $period) {
    rows {
      ...PortfolioSatisfactionRowFields
    }
    trend @include(if: $withTrend) {
      window {
        ...PortfolioWindowFields
      }
      rows {
        ...PortfolioSatisfactionRowFields
      }
    }
    kinds {
      ...PortfolioRatingKindFields
    }
    timings {
      ...PortfolioSatisfactionTimingFields
    }
  }
}
    ${PortfolioSatisfactionRowFieldsFragmentDoc}
${PortfolioWindowFieldsFragmentDoc}
${PortfolioRatingKindFieldsFragmentDoc}
${PortfolioSatisfactionTimingFieldsFragmentDoc}`;

/**
 * __usePortfolioSatisfactionReportQuery__
 *
 * To run a query within a React component, call `usePortfolioSatisfactionReportQuery` and pass it any options that fit your needs.
 * When your component renders, `usePortfolioSatisfactionReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePortfolioSatisfactionReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      withTrend: // value for 'withTrend'
 *   },
 * });
 */
export function usePortfolioSatisfactionReportQuery(baseOptions: Apollo.QueryHookOptions<PortfolioSatisfactionReportQuery, PortfolioSatisfactionReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PortfolioSatisfactionReportQuery, PortfolioSatisfactionReportQueryVariables>(PortfolioSatisfactionReportDocument, options);
      }
export function usePortfolioSatisfactionReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PortfolioSatisfactionReportQuery, PortfolioSatisfactionReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PortfolioSatisfactionReportQuery, PortfolioSatisfactionReportQueryVariables>(PortfolioSatisfactionReportDocument, options);
        }
export type PortfolioSatisfactionReportQueryHookResult = ReturnType<typeof usePortfolioSatisfactionReportQuery>;
export type PortfolioSatisfactionReportLazyQueryHookResult = ReturnType<typeof usePortfolioSatisfactionReportLazyQuery>;
export type PortfolioSatisfactionReportQueryResult = Apollo.QueryResult<PortfolioSatisfactionReportQuery, PortfolioSatisfactionReportQueryVariables>;
export const SiteApplicationReportDocument = gql`
    query SiteApplicationReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!) {
  current: reportingApplications(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...ApplicationReceivedFigure
    ...ApplicationApprovedFigure
    ...ApplicationPendingFigure
    ...ApplicationPendingByWaitFigure
    ...ApplicationTimeToApprovalFigure
    ...ApplicationOutcomesFigure
    ...ApplicationResubmissionsFigure
    ...ApplicationMedianAttemptsFigure
    ...ApplicationMultipleAttemptsFigure
    ...ApplicationFlowFigure
    ...ApplicationRejectionReasonFigure
    ...ApplicationSubmissionSourceFigure
  }
  previous: reportingApplications(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
  ) {
    ...ApplicationComparisonFigures
  }
}
    ${ApplicationReceivedFigureFragmentDoc}
${ApplicationApprovedFigureFragmentDoc}
${ApplicationPendingFigureFragmentDoc}
${ApplicationPendingByWaitFigureFragmentDoc}
${ApplicationTimeToApprovalFigureFragmentDoc}
${ApplicationOutcomesFigureFragmentDoc}
${ApplicationResubmissionsFigureFragmentDoc}
${ApplicationMedianAttemptsFigureFragmentDoc}
${ApplicationMultipleAttemptsFigureFragmentDoc}
${ApplicationFlowFigureFragmentDoc}
${ApplicationRejectionReasonFigureFragmentDoc}
${ApplicationSubmissionSourceFigureFragmentDoc}
${ApplicationComparisonFiguresFragmentDoc}`;

/**
 * __useSiteApplicationReportQuery__
 *
 * To run a query within a React component, call `useSiteApplicationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteApplicationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteApplicationReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *   },
 * });
 */
export function useSiteApplicationReportQuery(baseOptions: Apollo.QueryHookOptions<SiteApplicationReportQuery, SiteApplicationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteApplicationReportQuery, SiteApplicationReportQueryVariables>(SiteApplicationReportDocument, options);
      }
export function useSiteApplicationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteApplicationReportQuery, SiteApplicationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteApplicationReportQuery, SiteApplicationReportQueryVariables>(SiteApplicationReportDocument, options);
        }
export type SiteApplicationReportQueryHookResult = ReturnType<typeof useSiteApplicationReportQuery>;
export type SiteApplicationReportLazyQueryHookResult = ReturnType<typeof useSiteApplicationReportLazyQuery>;
export type SiteApplicationReportQueryResult = Apollo.QueryResult<SiteApplicationReportQuery, SiteApplicationReportQueryVariables>;
export const SiteBookingReportDocument = gql`
    query SiteBookingReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!) {
  current: reportingBookings(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...BookingMadeFigure
    ...BookingFacilityFigure
    ...BookingCancellationFigure
    ...BookingLeadTimeFigure
    ...BookingBookedByFigure
    ...BookingSlotPatternFigure
    ...BookingCapacityFigure
    ...BookingResidentReachFigure
  }
  previous: reportingBookings(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
  ) {
    ...BookingComparisonFigures
  }
}
    ${BookingMadeFigureFragmentDoc}
${BookingFacilityFigureFragmentDoc}
${BookingCancellationFigureFragmentDoc}
${BookingLeadTimeFigureFragmentDoc}
${BookingBookedByFigureFragmentDoc}
${BookingSlotPatternFigureFragmentDoc}
${BookingCapacityFigureFragmentDoc}
${BookingResidentReachFigureFragmentDoc}
${BookingComparisonFiguresFragmentDoc}`;

/**
 * __useSiteBookingReportQuery__
 *
 * To run a query within a React component, call `useSiteBookingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteBookingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteBookingReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *   },
 * });
 */
export function useSiteBookingReportQuery(baseOptions: Apollo.QueryHookOptions<SiteBookingReportQuery, SiteBookingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteBookingReportQuery, SiteBookingReportQueryVariables>(SiteBookingReportDocument, options);
      }
export function useSiteBookingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteBookingReportQuery, SiteBookingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteBookingReportQuery, SiteBookingReportQueryVariables>(SiteBookingReportDocument, options);
        }
export type SiteBookingReportQueryHookResult = ReturnType<typeof useSiteBookingReportQuery>;
export type SiteBookingReportLazyQueryHookResult = ReturnType<typeof useSiteBookingReportLazyQuery>;
export type SiteBookingReportQueryResult = Apollo.QueryResult<SiteBookingReportQuery, SiteBookingReportQueryVariables>;
export const SiteConversationReportDocument = gql`
    query SiteConversationReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!, $tags: [UUID!]!) {
  current: reportingConversations(
    communities: $communities
    period: $period
    blocks: $blocks
    tags: $tags
  ) {
    ...ConversationOpenedFigure
    ...ConversationClosedFigure
    ...ConversationReopenedFigure
    ...ConversationOpenFigure
    ...ConversationFirstResponseFigure
    ...ConversationResponseTimeFigure
    ...ConversationResolutionTimeFigure
    ...ConversationSatisfactionFigure
    ...ConversationSatisfactionByMonthFigure
    ...ConversationRatedShareFigure
    ...ConversationOpenedPatternFigure
    ...ConversationChannelFigure
    ...ConversationSenderCategoryFigure
  }
  previous: reportingConversations(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
    tags: $tags
  ) {
    ...ConversationComparisonFigures
  }
  topics: reportingConversations(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...ConversationTopicComparisonFigure
    ...ConversationTopicSatisfactionFigure
    ...ConversationBlockTagsFigure
    satisfaction {
      meanRating
      ratedCount
    }
  }
}
    ${ConversationOpenedFigureFragmentDoc}
${ConversationClosedFigureFragmentDoc}
${ConversationReopenedFigureFragmentDoc}
${ConversationOpenFigureFragmentDoc}
${ConversationFirstResponseFigureFragmentDoc}
${ConversationResponseTimeFigureFragmentDoc}
${ConversationResolutionTimeFigureFragmentDoc}
${ConversationSatisfactionFigureFragmentDoc}
${ConversationSatisfactionByMonthFigureFragmentDoc}
${ConversationRatedShareFigureFragmentDoc}
${ConversationOpenedPatternFigureFragmentDoc}
${ConversationChannelFigureFragmentDoc}
${ConversationSenderCategoryFigureFragmentDoc}
${ConversationComparisonFiguresFragmentDoc}
${ConversationTopicComparisonFigureFragmentDoc}
${ConversationTopicSatisfactionFigureFragmentDoc}
${ConversationBlockTagsFigureFragmentDoc}`;

/**
 * __useSiteConversationReportQuery__
 *
 * To run a query within a React component, call `useSiteConversationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteConversationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteConversationReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useSiteConversationReportQuery(baseOptions: Apollo.QueryHookOptions<SiteConversationReportQuery, SiteConversationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteConversationReportQuery, SiteConversationReportQueryVariables>(SiteConversationReportDocument, options);
      }
export function useSiteConversationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteConversationReportQuery, SiteConversationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteConversationReportQuery, SiteConversationReportQueryVariables>(SiteConversationReportDocument, options);
        }
export type SiteConversationReportQueryHookResult = ReturnType<typeof useSiteConversationReportQuery>;
export type SiteConversationReportLazyQueryHookResult = ReturnType<typeof useSiteConversationReportLazyQuery>;
export type SiteConversationReportQueryResult = Apollo.QueryResult<SiteConversationReportQuery, SiteConversationReportQueryVariables>;
export const SiteDocumentReportDocument = gql`
    query SiteDocumentReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!, $tags: [UUID!]!) {
  current: reportingDocuments(
    communities: $communities
    period: $period
    blocks: $blocks
    tags: $tags
  ) {
    ...DocumentLiveFigure
    ...DocumentAddedFigure
    ...DocumentViewedFigure
    ...DocumentTagsFigure
    ...DocumentRemindersFigure
    ...DocumentLiveByDayFigure
    ...DocumentAllViewedFigure
    ...DocumentFirstViewsFigure
    ...DocumentReachFigure
  }
  previous: reportingDocuments(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
    tags: $tags
  ) {
    ...DocumentComparisonFigures
  }
}
    ${DocumentLiveFigureFragmentDoc}
${DocumentAddedFigureFragmentDoc}
${DocumentViewedFigureFragmentDoc}
${DocumentTagsFigureFragmentDoc}
${DocumentRemindersFigureFragmentDoc}
${DocumentLiveByDayFigureFragmentDoc}
${DocumentAllViewedFigureFragmentDoc}
${DocumentFirstViewsFigureFragmentDoc}
${DocumentReachFigureFragmentDoc}
${DocumentComparisonFiguresFragmentDoc}`;

/**
 * __useSiteDocumentReportQuery__
 *
 * To run a query within a React component, call `useSiteDocumentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteDocumentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteDocumentReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useSiteDocumentReportQuery(baseOptions: Apollo.QueryHookOptions<SiteDocumentReportQuery, SiteDocumentReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteDocumentReportQuery, SiteDocumentReportQueryVariables>(SiteDocumentReportDocument, options);
      }
export function useSiteDocumentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteDocumentReportQuery, SiteDocumentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteDocumentReportQuery, SiteDocumentReportQueryVariables>(SiteDocumentReportDocument, options);
        }
export type SiteDocumentReportQueryHookResult = ReturnType<typeof useSiteDocumentReportQuery>;
export type SiteDocumentReportLazyQueryHookResult = ReturnType<typeof useSiteDocumentReportLazyQuery>;
export type SiteDocumentReportQueryResult = Apollo.QueryResult<SiteDocumentReportQuery, SiteDocumentReportQueryVariables>;
export const SiteKeyReportDocument = gql`
    query SiteKeyReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!) {
  current: reportingKeys(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...KeyMovementsFigure
    ...KeysOutFigure
    ...KeyTimeHeldFigure
    ...KeyDaysHeldFigure
    ...KeyHolderCompaniesFigure
    ...KeyActiveHoldersFigure
    ...KeyLongestHeldFigure
    ...KeyOverdueAtEndFigure
  }
  previous: reportingKeys(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
  ) {
    ...KeyComparisonFigures
  }
}
    ${KeyMovementsFigureFragmentDoc}
${KeysOutFigureFragmentDoc}
${KeyTimeHeldFigureFragmentDoc}
${KeyDaysHeldFigureFragmentDoc}
${KeyHolderCompaniesFigureFragmentDoc}
${KeyActiveHoldersFigureFragmentDoc}
${KeyLongestHeldFigureFragmentDoc}
${KeyOverdueAtEndFigureFragmentDoc}
${KeyComparisonFiguresFragmentDoc}`;

/**
 * __useSiteKeyReportQuery__
 *
 * To run a query within a React component, call `useSiteKeyReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteKeyReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteKeyReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *   },
 * });
 */
export function useSiteKeyReportQuery(baseOptions: Apollo.QueryHookOptions<SiteKeyReportQuery, SiteKeyReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteKeyReportQuery, SiteKeyReportQueryVariables>(SiteKeyReportDocument, options);
      }
export function useSiteKeyReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteKeyReportQuery, SiteKeyReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteKeyReportQuery, SiteKeyReportQueryVariables>(SiteKeyReportDocument, options);
        }
export type SiteKeyReportQueryHookResult = ReturnType<typeof useSiteKeyReportQuery>;
export type SiteKeyReportLazyQueryHookResult = ReturnType<typeof useSiteKeyReportLazyQuery>;
export type SiteKeyReportQueryResult = Apollo.QueryResult<SiteKeyReportQuery, SiteKeyReportQueryVariables>;
export const SitePackageReportDocument = gql`
    query SitePackageReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!) {
  current: reportingPackages(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...PackageDeliveredFigure
    ...PackageCollectedFigure
    ...PackageUncollectedFigure
    ...PackageTimeToCollectionFigure
    ...PackageAgeingFigure
    ...PackageDeliveryPatternFigure
    ...PackageCollectedAfterReminderFigure
    ...PackageDataQualityFigure
    ...PackageCollectionPatternFigure
    ...PackageWaitingHomesFigure
    ...PackageRemindersPerPackageFigure
    ...PackageLastReminderFigure
    ...PackageLocationFigure
    ...PackageWaitingAtEndFigure
  }
  previous: reportingPackages(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
  ) {
    ...PackageComparisonFigures
  }
}
    ${PackageDeliveredFigureFragmentDoc}
${PackageCollectedFigureFragmentDoc}
${PackageUncollectedFigureFragmentDoc}
${PackageTimeToCollectionFigureFragmentDoc}
${PackageAgeingFigureFragmentDoc}
${PackageDeliveryPatternFigureFragmentDoc}
${PackageCollectedAfterReminderFigureFragmentDoc}
${PackageDataQualityFigureFragmentDoc}
${PackageCollectionPatternFigureFragmentDoc}
${PackageWaitingHomesFigureFragmentDoc}
${PackageRemindersPerPackageFigureFragmentDoc}
${PackageLastReminderFigureFragmentDoc}
${PackageLocationFigureFragmentDoc}
${PackageWaitingAtEndFigureFragmentDoc}
${PackageComparisonFiguresFragmentDoc}`;

/**
 * __useSitePackageReportQuery__
 *
 * To run a query within a React component, call `useSitePackageReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSitePackageReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSitePackageReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *   },
 * });
 */
export function useSitePackageReportQuery(baseOptions: Apollo.QueryHookOptions<SitePackageReportQuery, SitePackageReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SitePackageReportQuery, SitePackageReportQueryVariables>(SitePackageReportDocument, options);
      }
export function useSitePackageReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SitePackageReportQuery, SitePackageReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SitePackageReportQuery, SitePackageReportQueryVariables>(SitePackageReportDocument, options);
        }
export type SitePackageReportQueryHookResult = ReturnType<typeof useSitePackageReportQuery>;
export type SitePackageReportLazyQueryHookResult = ReturnType<typeof useSitePackageReportLazyQuery>;
export type SitePackageReportQueryResult = Apollo.QueryResult<SitePackageReportQuery, SitePackageReportQueryVariables>;
export const SiteUpdateReportDocument = gql`
    query SiteUpdateReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $blocks: [UUID!]!) {
  current: reportingUpdates(
    communities: $communities
    period: $period
    blocks: $blocks
  ) {
    ...UpdatePublishedByWeekFigure
    ...UpdateReadersFigure
    ...UpdateReadRateFigure
    ...UpdateEngagementFigure
    ...UpdateCategoryFigure
    ...UpdateTopUpdatesFigure
    ...UpdateScheduledFigure
    ...UpdateEngagementTableFigure
    ...UpdateContentMixFigure
    ...UpdatePublishedByStaffFigure
  }
  previous: reportingUpdates(
    communities: $communities
    period: $previousPeriod
    blocks: $blocks
  ) {
    ...UpdateComparisonFigures
  }
}
    ${UpdatePublishedByWeekFigureFragmentDoc}
${UpdateReadersFigureFragmentDoc}
${UpdateReadRateFigureFragmentDoc}
${UpdateEngagementFigureFragmentDoc}
${UpdateCategoryFigureFragmentDoc}
${UpdateTopUpdatesFigureFragmentDoc}
${UpdateScheduledFigureFragmentDoc}
${UpdateEngagementTableFigureFragmentDoc}
${UpdateContentMixFigureFragmentDoc}
${UpdatePublishedByStaffFigureFragmentDoc}
${UpdateComparisonFiguresFragmentDoc}`;

/**
 * __useSiteUpdateReportQuery__
 *
 * To run a query within a React component, call `useSiteUpdateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteUpdateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteUpdateReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      blocks: // value for 'blocks'
 *   },
 * });
 */
export function useSiteUpdateReportQuery(baseOptions: Apollo.QueryHookOptions<SiteUpdateReportQuery, SiteUpdateReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteUpdateReportQuery, SiteUpdateReportQueryVariables>(SiteUpdateReportDocument, options);
      }
export function useSiteUpdateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteUpdateReportQuery, SiteUpdateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteUpdateReportQuery, SiteUpdateReportQueryVariables>(SiteUpdateReportDocument, options);
        }
export type SiteUpdateReportQueryHookResult = ReturnType<typeof useSiteUpdateReportQuery>;
export type SiteUpdateReportLazyQueryHookResult = ReturnType<typeof useSiteUpdateReportLazyQuery>;
export type SiteUpdateReportQueryResult = Apollo.QueryResult<SiteUpdateReportQuery, SiteUpdateReportQueryVariables>;
export const SiteVisitReportDocument = gql`
    query SiteVisitReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $previousPeriod: ReportingPeriodInput!, $visitorTypes: [VisitReportingVisitorType!]!) {
  current: reportingVisits(
    communities: $communities
    period: $period
    visitorTypes: $visitorTypes
  ) {
    ...VisitOnSiteFigure
    ...VisitSignInsFigure
    ...VisitSignOutsFigure
    ...VisitorTypesFigure
    ...VisitTimeOnSiteFigure
    ...VisitNotSignedOutFigure
    ...VisitArrivalsFigure
    ...VisitCompaniesFigure
  }
  previous: reportingVisits(
    communities: $communities
    period: $previousPeriod
    visitorTypes: $visitorTypes
  ) {
    ...VisitComparisonFigures
  }
}
    ${VisitOnSiteFigureFragmentDoc}
${VisitSignInsFigureFragmentDoc}
${VisitSignOutsFigureFragmentDoc}
${VisitorTypesFigureFragmentDoc}
${VisitTimeOnSiteFigureFragmentDoc}
${VisitNotSignedOutFigureFragmentDoc}
${VisitArrivalsFigureFragmentDoc}
${VisitCompaniesFigureFragmentDoc}
${VisitComparisonFiguresFragmentDoc}`;

/**
 * __useSiteVisitReportQuery__
 *
 * To run a query within a React component, call `useSiteVisitReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteVisitReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteVisitReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      previousPeriod: // value for 'previousPeriod'
 *      visitorTypes: // value for 'visitorTypes'
 *   },
 * });
 */
export function useSiteVisitReportQuery(baseOptions: Apollo.QueryHookOptions<SiteVisitReportQuery, SiteVisitReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteVisitReportQuery, SiteVisitReportQueryVariables>(SiteVisitReportDocument, options);
      }
export function useSiteVisitReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteVisitReportQuery, SiteVisitReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteVisitReportQuery, SiteVisitReportQueryVariables>(SiteVisitReportDocument, options);
        }
export type SiteVisitReportQueryHookResult = ReturnType<typeof useSiteVisitReportQuery>;
export type SiteVisitReportLazyQueryHookResult = ReturnType<typeof useSiteVisitReportLazyQuery>;
export type SiteVisitReportQueryResult = Apollo.QueryResult<SiteVisitReportQuery, SiteVisitReportQueryVariables>;
export const CreateReportingConfigurationDocument = gql`
    mutation CreateReportingConfiguration($input: CreateReportingConfigurationInput!) {
  createReportingConfiguration(input: $input) {
    configuration {
      ...ReportingConfigurationFields
    }
  }
}
    ${ReportingConfigurationFieldsFragmentDoc}`;
export type CreateReportingConfigurationMutationFn = Apollo.MutationFunction<CreateReportingConfigurationMutation, CreateReportingConfigurationMutationVariables>;

/**
 * __useCreateReportingConfigurationMutation__
 *
 * To run a mutation, you first call `useCreateReportingConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReportingConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReportingConfigurationMutation, { data, loading, error }] = useCreateReportingConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateReportingConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<CreateReportingConfigurationMutation, CreateReportingConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReportingConfigurationMutation, CreateReportingConfigurationMutationVariables>(CreateReportingConfigurationDocument, options);
      }
export type CreateReportingConfigurationMutationHookResult = ReturnType<typeof useCreateReportingConfigurationMutation>;
export type CreateReportingConfigurationMutationResult = Apollo.MutationResult<CreateReportingConfigurationMutation>;
export type CreateReportingConfigurationMutationOptions = Apollo.BaseMutationOptions<CreateReportingConfigurationMutation, CreateReportingConfigurationMutationVariables>;
export const DeleteReportingConfigurationDocument = gql`
    mutation DeleteReportingConfiguration($input: DeleteReportingConfigurationInput!) {
  deleteReportingConfiguration(input: $input) {
    deletedId
  }
}
    `;
export type DeleteReportingConfigurationMutationFn = Apollo.MutationFunction<DeleteReportingConfigurationMutation, DeleteReportingConfigurationMutationVariables>;

/**
 * __useDeleteReportingConfigurationMutation__
 *
 * To run a mutation, you first call `useDeleteReportingConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteReportingConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteReportingConfigurationMutation, { data, loading, error }] = useDeleteReportingConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteReportingConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteReportingConfigurationMutation, DeleteReportingConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteReportingConfigurationMutation, DeleteReportingConfigurationMutationVariables>(DeleteReportingConfigurationDocument, options);
      }
export type DeleteReportingConfigurationMutationHookResult = ReturnType<typeof useDeleteReportingConfigurationMutation>;
export type DeleteReportingConfigurationMutationResult = Apollo.MutationResult<DeleteReportingConfigurationMutation>;
export type DeleteReportingConfigurationMutationOptions = Apollo.BaseMutationOptions<DeleteReportingConfigurationMutation, DeleteReportingConfigurationMutationVariables>;
export const RecordReportingConfigurationOpenedDocument = gql`
    mutation RecordReportingConfigurationOpened($input: RecordReportingConfigurationOpenedInput!) {
  recordReportingConfigurationOpened(input: $input) {
    configuration {
      id
      lastOpenedAt
    }
  }
}
    `;
export type RecordReportingConfigurationOpenedMutationFn = Apollo.MutationFunction<RecordReportingConfigurationOpenedMutation, RecordReportingConfigurationOpenedMutationVariables>;

/**
 * __useRecordReportingConfigurationOpenedMutation__
 *
 * To run a mutation, you first call `useRecordReportingConfigurationOpenedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordReportingConfigurationOpenedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordReportingConfigurationOpenedMutation, { data, loading, error }] = useRecordReportingConfigurationOpenedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRecordReportingConfigurationOpenedMutation(baseOptions?: Apollo.MutationHookOptions<RecordReportingConfigurationOpenedMutation, RecordReportingConfigurationOpenedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordReportingConfigurationOpenedMutation, RecordReportingConfigurationOpenedMutationVariables>(RecordReportingConfigurationOpenedDocument, options);
      }
export type RecordReportingConfigurationOpenedMutationHookResult = ReturnType<typeof useRecordReportingConfigurationOpenedMutation>;
export type RecordReportingConfigurationOpenedMutationResult = Apollo.MutationResult<RecordReportingConfigurationOpenedMutation>;
export type RecordReportingConfigurationOpenedMutationOptions = Apollo.BaseMutationOptions<RecordReportingConfigurationOpenedMutation, RecordReportingConfigurationOpenedMutationVariables>;
export const ReportingConfigurationDocument = gql`
    query ReportingConfiguration($id: UUID!) {
  reportingConfiguration(id: $id) {
    ...ReportingConfigurationFields
    schedules {
      ...ReportingScheduleFields
    }
  }
}
    ${ReportingConfigurationFieldsFragmentDoc}
${ReportingScheduleFieldsFragmentDoc}`;

/**
 * __useReportingConfigurationQuery__
 *
 * To run a query within a React component, call `useReportingConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingConfigurationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReportingConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ReportingConfigurationQuery, ReportingConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingConfigurationQuery, ReportingConfigurationQueryVariables>(ReportingConfigurationDocument, options);
      }
export function useReportingConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingConfigurationQuery, ReportingConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingConfigurationQuery, ReportingConfigurationQueryVariables>(ReportingConfigurationDocument, options);
        }
export type ReportingConfigurationQueryHookResult = ReturnType<typeof useReportingConfigurationQuery>;
export type ReportingConfigurationLazyQueryHookResult = ReturnType<typeof useReportingConfigurationLazyQuery>;
export type ReportingConfigurationQueryResult = Apollo.QueryResult<ReportingConfigurationQuery, ReportingConfigurationQueryVariables>;
export const ReportingConfigurationsDocument = gql`
    query ReportingConfigurations {
  reportingConfigurations {
    ...ReportingConfigurationFields
  }
}
    ${ReportingConfigurationFieldsFragmentDoc}`;

/**
 * __useReportingConfigurationsQuery__
 *
 * To run a query within a React component, call `useReportingConfigurationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingConfigurationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingConfigurationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportingConfigurationsQuery(baseOptions?: Apollo.QueryHookOptions<ReportingConfigurationsQuery, ReportingConfigurationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingConfigurationsQuery, ReportingConfigurationsQueryVariables>(ReportingConfigurationsDocument, options);
      }
export function useReportingConfigurationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingConfigurationsQuery, ReportingConfigurationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingConfigurationsQuery, ReportingConfigurationsQueryVariables>(ReportingConfigurationsDocument, options);
        }
export type ReportingConfigurationsQueryHookResult = ReturnType<typeof useReportingConfigurationsQuery>;
export type ReportingConfigurationsLazyQueryHookResult = ReturnType<typeof useReportingConfigurationsLazyQuery>;
export type ReportingConfigurationsQueryResult = Apollo.QueryResult<ReportingConfigurationsQuery, ReportingConfigurationsQueryVariables>;
export const ReportingTeamMembersDocument = gql`
    query ReportingTeamMembers {
  reportingTeamMembers {
    ...TeamRosterMemberFields
  }
}
    ${TeamRosterMemberFieldsFragmentDoc}`;

/**
 * __useReportingTeamMembersQuery__
 *
 * To run a query within a React component, call `useReportingTeamMembersQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportingTeamMembersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportingTeamMembersQuery({
 *   variables: {
 *   },
 * });
 */
export function useReportingTeamMembersQuery(baseOptions?: Apollo.QueryHookOptions<ReportingTeamMembersQuery, ReportingTeamMembersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportingTeamMembersQuery, ReportingTeamMembersQueryVariables>(ReportingTeamMembersDocument, options);
      }
export function useReportingTeamMembersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportingTeamMembersQuery, ReportingTeamMembersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportingTeamMembersQuery, ReportingTeamMembersQueryVariables>(ReportingTeamMembersDocument, options);
        }
export type ReportingTeamMembersQueryHookResult = ReturnType<typeof useReportingTeamMembersQuery>;
export type ReportingTeamMembersLazyQueryHookResult = ReturnType<typeof useReportingTeamMembersLazyQuery>;
export type ReportingTeamMembersQueryResult = Apollo.QueryResult<ReportingTeamMembersQuery, ReportingTeamMembersQueryVariables>;
export const SetReportingFavouriteDocument = gql`
    mutation SetReportingFavourite($input: SetReportingFavouriteInput!) {
  setReportingFavourite(input: $input) {
    configuration {
      id
      isFavourite
    }
  }
}
    `;
export type SetReportingFavouriteMutationFn = Apollo.MutationFunction<SetReportingFavouriteMutation, SetReportingFavouriteMutationVariables>;

/**
 * __useSetReportingFavouriteMutation__
 *
 * To run a mutation, you first call `useSetReportingFavouriteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportingFavouriteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportingFavouriteMutation, { data, loading, error }] = useSetReportingFavouriteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetReportingFavouriteMutation(baseOptions?: Apollo.MutationHookOptions<SetReportingFavouriteMutation, SetReportingFavouriteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportingFavouriteMutation, SetReportingFavouriteMutationVariables>(SetReportingFavouriteDocument, options);
      }
export type SetReportingFavouriteMutationHookResult = ReturnType<typeof useSetReportingFavouriteMutation>;
export type SetReportingFavouriteMutationResult = Apollo.MutationResult<SetReportingFavouriteMutation>;
export type SetReportingFavouriteMutationOptions = Apollo.BaseMutationOptions<SetReportingFavouriteMutation, SetReportingFavouriteMutationVariables>;
export const SetReportingScheduleDocument = gql`
    mutation SetReportingSchedule($input: SetReportingScheduleInput!) {
  setReportingSchedule(input: $input) {
    configuration {
      id
      schedules {
        ...ReportingScheduleFields
      }
    }
  }
}
    ${ReportingScheduleFieldsFragmentDoc}`;
export type SetReportingScheduleMutationFn = Apollo.MutationFunction<SetReportingScheduleMutation, SetReportingScheduleMutationVariables>;

/**
 * __useSetReportingScheduleMutation__
 *
 * To run a mutation, you first call `useSetReportingScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetReportingScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setReportingScheduleMutation, { data, loading, error }] = useSetReportingScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetReportingScheduleMutation(baseOptions?: Apollo.MutationHookOptions<SetReportingScheduleMutation, SetReportingScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetReportingScheduleMutation, SetReportingScheduleMutationVariables>(SetReportingScheduleDocument, options);
      }
export type SetReportingScheduleMutationHookResult = ReturnType<typeof useSetReportingScheduleMutation>;
export type SetReportingScheduleMutationResult = Apollo.MutationResult<SetReportingScheduleMutation>;
export type SetReportingScheduleMutationOptions = Apollo.BaseMutationOptions<SetReportingScheduleMutation, SetReportingScheduleMutationVariables>;
export const TeamActivityReportDocument = gql`
    query TeamActivityReport($period: ReportingPeriodInput!, $staff: [UUID!]) {
  reportingTeamActivity(period: $period, staff: $staff) {
    ...TeamActivityFigures
  }
}
    ${TeamActivityFiguresFragmentDoc}`;

/**
 * __useTeamActivityReportQuery__
 *
 * To run a query within a React component, call `useTeamActivityReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamActivityReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamActivityReportQuery({
 *   variables: {
 *      period: // value for 'period'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useTeamActivityReportQuery(baseOptions: Apollo.QueryHookOptions<TeamActivityReportQuery, TeamActivityReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamActivityReportQuery, TeamActivityReportQueryVariables>(TeamActivityReportDocument, options);
      }
export function useTeamActivityReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamActivityReportQuery, TeamActivityReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamActivityReportQuery, TeamActivityReportQueryVariables>(TeamActivityReportDocument, options);
        }
export type TeamActivityReportQueryHookResult = ReturnType<typeof useTeamActivityReportQuery>;
export type TeamActivityReportLazyQueryHookResult = ReturnType<typeof useTeamActivityReportLazyQuery>;
export type TeamActivityReportQueryResult = Apollo.QueryResult<TeamActivityReportQuery, TeamActivityReportQueryVariables>;
export const TeamApplicationReportDocument = gql`
    query TeamApplicationReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $staff: [UUID!]) {
  reportingTeamApplications(
    communities: $communities
    period: $period
    staff: $staff
  ) {
    ...TeamApplicationFigures
  }
}
    ${TeamApplicationFiguresFragmentDoc}`;

/**
 * __useTeamApplicationReportQuery__
 *
 * To run a query within a React component, call `useTeamApplicationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamApplicationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamApplicationReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useTeamApplicationReportQuery(baseOptions: Apollo.QueryHookOptions<TeamApplicationReportQuery, TeamApplicationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamApplicationReportQuery, TeamApplicationReportQueryVariables>(TeamApplicationReportDocument, options);
      }
export function useTeamApplicationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamApplicationReportQuery, TeamApplicationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamApplicationReportQuery, TeamApplicationReportQueryVariables>(TeamApplicationReportDocument, options);
        }
export type TeamApplicationReportQueryHookResult = ReturnType<typeof useTeamApplicationReportQuery>;
export type TeamApplicationReportLazyQueryHookResult = ReturnType<typeof useTeamApplicationReportLazyQuery>;
export type TeamApplicationReportQueryResult = Apollo.QueryResult<TeamApplicationReportQuery, TeamApplicationReportQueryVariables>;
export const TeamConversationReportDocument = gql`
    query TeamConversationReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $staff: [UUID!]) {
  reportingTeamConversations(
    communities: $communities
    period: $period
    staff: $staff
  ) {
    ...TeamConversationFigures
  }
}
    ${TeamConversationFiguresFragmentDoc}`;

/**
 * __useTeamConversationReportQuery__
 *
 * To run a query within a React component, call `useTeamConversationReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamConversationReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamConversationReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useTeamConversationReportQuery(baseOptions: Apollo.QueryHookOptions<TeamConversationReportQuery, TeamConversationReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamConversationReportQuery, TeamConversationReportQueryVariables>(TeamConversationReportDocument, options);
      }
export function useTeamConversationReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamConversationReportQuery, TeamConversationReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamConversationReportQuery, TeamConversationReportQueryVariables>(TeamConversationReportDocument, options);
        }
export type TeamConversationReportQueryHookResult = ReturnType<typeof useTeamConversationReportQuery>;
export type TeamConversationReportLazyQueryHookResult = ReturnType<typeof useTeamConversationReportLazyQuery>;
export type TeamConversationReportQueryResult = Apollo.QueryResult<TeamConversationReportQuery, TeamConversationReportQueryVariables>;
export const TeamDocumentReportDocument = gql`
    query TeamDocumentReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $staff: [UUID!]) {
  reportingTeamDocuments(
    communities: $communities
    period: $period
    staff: $staff
  ) {
    ...TeamDocumentFigures
  }
}
    ${TeamDocumentFiguresFragmentDoc}`;

/**
 * __useTeamDocumentReportQuery__
 *
 * To run a query within a React component, call `useTeamDocumentReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamDocumentReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamDocumentReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useTeamDocumentReportQuery(baseOptions: Apollo.QueryHookOptions<TeamDocumentReportQuery, TeamDocumentReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamDocumentReportQuery, TeamDocumentReportQueryVariables>(TeamDocumentReportDocument, options);
      }
export function useTeamDocumentReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamDocumentReportQuery, TeamDocumentReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamDocumentReportQuery, TeamDocumentReportQueryVariables>(TeamDocumentReportDocument, options);
        }
export type TeamDocumentReportQueryHookResult = ReturnType<typeof useTeamDocumentReportQuery>;
export type TeamDocumentReportLazyQueryHookResult = ReturnType<typeof useTeamDocumentReportLazyQuery>;
export type TeamDocumentReportQueryResult = Apollo.QueryResult<TeamDocumentReportQuery, TeamDocumentReportQueryVariables>;
export const TeamMemberRatingsDocument = gql`
    query TeamMemberRatings($communities: [UUID!]!, $period: ReportingPeriodInput!, $userId: UUID!) {
  reportingTeamConversations(communities: $communities, period: $period) {
    memberRatings(userId: $userId) {
      conversationId
      subject
      stars
      ratedAt
    }
  }
}
    `;

/**
 * __useTeamMemberRatingsQuery__
 *
 * To run a query within a React component, call `useTeamMemberRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamMemberRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamMemberRatingsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useTeamMemberRatingsQuery(baseOptions: Apollo.QueryHookOptions<TeamMemberRatingsQuery, TeamMemberRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamMemberRatingsQuery, TeamMemberRatingsQueryVariables>(TeamMemberRatingsDocument, options);
      }
export function useTeamMemberRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamMemberRatingsQuery, TeamMemberRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamMemberRatingsQuery, TeamMemberRatingsQueryVariables>(TeamMemberRatingsDocument, options);
        }
export type TeamMemberRatingsQueryHookResult = ReturnType<typeof useTeamMemberRatingsQuery>;
export type TeamMemberRatingsLazyQueryHookResult = ReturnType<typeof useTeamMemberRatingsLazyQuery>;
export type TeamMemberRatingsQueryResult = Apollo.QueryResult<TeamMemberRatingsQuery, TeamMemberRatingsQueryVariables>;
export const TeamUpdateReportDocument = gql`
    query TeamUpdateReport($communities: [UUID!]!, $period: ReportingPeriodInput!, $staff: [UUID!]) {
  reportingTeamUpdates(communities: $communities, period: $period, staff: $staff) {
    ...TeamUpdateFigures
  }
}
    ${TeamUpdateFiguresFragmentDoc}`;

/**
 * __useTeamUpdateReportQuery__
 *
 * To run a query within a React component, call `useTeamUpdateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamUpdateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamUpdateReportQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      period: // value for 'period'
 *      staff: // value for 'staff'
 *   },
 * });
 */
export function useTeamUpdateReportQuery(baseOptions: Apollo.QueryHookOptions<TeamUpdateReportQuery, TeamUpdateReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamUpdateReportQuery, TeamUpdateReportQueryVariables>(TeamUpdateReportDocument, options);
      }
export function useTeamUpdateReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamUpdateReportQuery, TeamUpdateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamUpdateReportQuery, TeamUpdateReportQueryVariables>(TeamUpdateReportDocument, options);
        }
export type TeamUpdateReportQueryHookResult = ReturnType<typeof useTeamUpdateReportQuery>;
export type TeamUpdateReportLazyQueryHookResult = ReturnType<typeof useTeamUpdateReportLazyQuery>;
export type TeamUpdateReportQueryResult = Apollo.QueryResult<TeamUpdateReportQuery, TeamUpdateReportQueryVariables>;
export const UpdateReportingConfigurationDocument = gql`
    mutation UpdateReportingConfiguration($input: UpdateReportingConfigurationInput!) {
  updateReportingConfiguration(input: $input) {
    conflict
    configuration {
      ...ReportingConfigurationFields
    }
  }
}
    ${ReportingConfigurationFieldsFragmentDoc}`;
export type UpdateReportingConfigurationMutationFn = Apollo.MutationFunction<UpdateReportingConfigurationMutation, UpdateReportingConfigurationMutationVariables>;

/**
 * __useUpdateReportingConfigurationMutation__
 *
 * To run a mutation, you first call `useUpdateReportingConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReportingConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReportingConfigurationMutation, { data, loading, error }] = useUpdateReportingConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateReportingConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReportingConfigurationMutation, UpdateReportingConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReportingConfigurationMutation, UpdateReportingConfigurationMutationVariables>(UpdateReportingConfigurationDocument, options);
      }
export type UpdateReportingConfigurationMutationHookResult = ReturnType<typeof useUpdateReportingConfigurationMutation>;
export type UpdateReportingConfigurationMutationResult = Apollo.MutationResult<UpdateReportingConfigurationMutation>;
export type UpdateReportingConfigurationMutationOptions = Apollo.BaseMutationOptions<UpdateReportingConfigurationMutation, UpdateReportingConfigurationMutationVariables>;
export const GetRulesDocument = gql`
    query GetRules($after: String, $first: Int = 15, $search: String, $orderBy: String, $isActive: Boolean) {
  rules(
    after: $after
    first: $first
    search: $search
    orderBy: $orderBy
    isActive: $isActive
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...Rule
      }
    }
  }
}
    ${RuleFragmentDoc}`;

/**
 * __useGetRulesQuery__
 *
 * To run a query within a React component, call `useGetRulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRulesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      search: // value for 'search'
 *      orderBy: // value for 'orderBy'
 *      isActive: // value for 'isActive'
 *   },
 * });
 */
export function useGetRulesQuery(baseOptions?: Apollo.QueryHookOptions<GetRulesQuery, GetRulesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRulesQuery, GetRulesQueryVariables>(GetRulesDocument, options);
      }
export function useGetRulesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRulesQuery, GetRulesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRulesQuery, GetRulesQueryVariables>(GetRulesDocument, options);
        }
export type GetRulesQueryHookResult = ReturnType<typeof useGetRulesQuery>;
export type GetRulesLazyQueryHookResult = ReturnType<typeof useGetRulesLazyQuery>;
export type GetRulesQueryResult = Apollo.QueryResult<GetRulesQuery, GetRulesQueryVariables>;
export const CreateRuleDocument = gql`
    mutation CreateRule($input: CreateRuleInput!) {
  createRule(input: $input) {
    rule {
      ...Rule
    }
    errors {
      field
      messages
    }
  }
}
    ${RuleFragmentDoc}`;
export type CreateRuleMutationFn = Apollo.MutationFunction<CreateRuleMutation, CreateRuleMutationVariables>;

/**
 * __useCreateRuleMutation__
 *
 * To run a mutation, you first call `useCreateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleMutation, { data, loading, error }] = useCreateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRuleMutation(baseOptions?: Apollo.MutationHookOptions<CreateRuleMutation, CreateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRuleMutation, CreateRuleMutationVariables>(CreateRuleDocument, options);
      }
export type CreateRuleMutationHookResult = ReturnType<typeof useCreateRuleMutation>;
export type CreateRuleMutationResult = Apollo.MutationResult<CreateRuleMutation>;
export type CreateRuleMutationOptions = Apollo.BaseMutationOptions<CreateRuleMutation, CreateRuleMutationVariables>;
export const CreateRuleActionDocument = gql`
    mutation CreateRuleAction($input: CreateRuleActionInput!) {
  createRuleAction(input: $input) {
    ruleAction {
      ...RuleAction
    }
    errors {
      field
      messages
    }
  }
}
    ${RuleActionFragmentDoc}`;
export type CreateRuleActionMutationFn = Apollo.MutationFunction<CreateRuleActionMutation, CreateRuleActionMutationVariables>;

/**
 * __useCreateRuleActionMutation__
 *
 * To run a mutation, you first call `useCreateRuleActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleActionMutation, { data, loading, error }] = useCreateRuleActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRuleActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateRuleActionMutation, CreateRuleActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRuleActionMutation, CreateRuleActionMutationVariables>(CreateRuleActionDocument, options);
      }
export type CreateRuleActionMutationHookResult = ReturnType<typeof useCreateRuleActionMutation>;
export type CreateRuleActionMutationResult = Apollo.MutationResult<CreateRuleActionMutation>;
export type CreateRuleActionMutationOptions = Apollo.BaseMutationOptions<CreateRuleActionMutation, CreateRuleActionMutationVariables>;
export const DeleteRuleActionDocument = gql`
    mutation DeleteRuleAction($input: DeleteRuleActionInput!) {
  deleteRuleAction(input: $input) {
    ruleAction {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteRuleActionMutationFn = Apollo.MutationFunction<DeleteRuleActionMutation, DeleteRuleActionMutationVariables>;

/**
 * __useDeleteRuleActionMutation__
 *
 * To run a mutation, you first call `useDeleteRuleActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleActionMutation, { data, loading, error }] = useDeleteRuleActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRuleActionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRuleActionMutation, DeleteRuleActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRuleActionMutation, DeleteRuleActionMutationVariables>(DeleteRuleActionDocument, options);
      }
export type DeleteRuleActionMutationHookResult = ReturnType<typeof useDeleteRuleActionMutation>;
export type DeleteRuleActionMutationResult = Apollo.MutationResult<DeleteRuleActionMutation>;
export type DeleteRuleActionMutationOptions = Apollo.BaseMutationOptions<DeleteRuleActionMutation, DeleteRuleActionMutationVariables>;
export const CreateRuleConditionsDocument = gql`
    mutation CreateRuleConditions($input: CreateRuleConditionsInput!) {
  createRuleConditions(input: $input) {
    ruleConditions {
      id
      event
      operator
      objectId
      createdAt
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateRuleConditionsMutationFn = Apollo.MutationFunction<CreateRuleConditionsMutation, CreateRuleConditionsMutationVariables>;

/**
 * __useCreateRuleConditionsMutation__
 *
 * To run a mutation, you first call `useCreateRuleConditionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRuleConditionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRuleConditionsMutation, { data, loading, error }] = useCreateRuleConditionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRuleConditionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateRuleConditionsMutation, CreateRuleConditionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRuleConditionsMutation, CreateRuleConditionsMutationVariables>(CreateRuleConditionsDocument, options);
      }
export type CreateRuleConditionsMutationHookResult = ReturnType<typeof useCreateRuleConditionsMutation>;
export type CreateRuleConditionsMutationResult = Apollo.MutationResult<CreateRuleConditionsMutation>;
export type CreateRuleConditionsMutationOptions = Apollo.BaseMutationOptions<CreateRuleConditionsMutation, CreateRuleConditionsMutationVariables>;
export const DeleteRuleConditionDocument = gql`
    mutation DeleteRuleCondition($input: DeleteRuleConditionInput!) {
  deleteRuleCondition(input: $input) {
    ruleCondition {
      id
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteRuleConditionMutationFn = Apollo.MutationFunction<DeleteRuleConditionMutation, DeleteRuleConditionMutationVariables>;

/**
 * __useDeleteRuleConditionMutation__
 *
 * To run a mutation, you first call `useDeleteRuleConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRuleConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRuleConditionMutation, { data, loading, error }] = useDeleteRuleConditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteRuleConditionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRuleConditionMutation, DeleteRuleConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRuleConditionMutation, DeleteRuleConditionMutationVariables>(DeleteRuleConditionDocument, options);
      }
export type DeleteRuleConditionMutationHookResult = ReturnType<typeof useDeleteRuleConditionMutation>;
export type DeleteRuleConditionMutationResult = Apollo.MutationResult<DeleteRuleConditionMutation>;
export type DeleteRuleConditionMutationOptions = Apollo.BaseMutationOptions<DeleteRuleConditionMutation, DeleteRuleConditionMutationVariables>;
export const UpdateRuleConditionDocument = gql`
    mutation UpdateRuleCondition($input: UpdateRuleConditionInput!) {
  updateRuleCondition(input: $input) {
    ruleCondition {
      id
      event
      operator
      objectId
      createdAt
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateRuleConditionMutationFn = Apollo.MutationFunction<UpdateRuleConditionMutation, UpdateRuleConditionMutationVariables>;

/**
 * __useUpdateRuleConditionMutation__
 *
 * To run a mutation, you first call `useUpdateRuleConditionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleConditionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleConditionMutation, { data, loading, error }] = useUpdateRuleConditionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleConditionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleConditionMutation, UpdateRuleConditionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleConditionMutation, UpdateRuleConditionMutationVariables>(UpdateRuleConditionDocument, options);
      }
export type UpdateRuleConditionMutationHookResult = ReturnType<typeof useUpdateRuleConditionMutation>;
export type UpdateRuleConditionMutationResult = Apollo.MutationResult<UpdateRuleConditionMutation>;
export type UpdateRuleConditionMutationOptions = Apollo.BaseMutationOptions<UpdateRuleConditionMutation, UpdateRuleConditionMutationVariables>;
export const RuleCommunitiesDocument = gql`
    query RuleCommunities($orderBy: String, $after: String) {
  communities(orderBy: $orderBy, after: $after, includeDeactivated: true) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...RuleCommunity
      }
    }
  }
}
    ${RuleCommunityFragmentDoc}`;

/**
 * __useRuleCommunitiesQuery__
 *
 * To run a query within a React component, call `useRuleCommunitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleCommunitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleCommunitiesQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useRuleCommunitiesQuery(baseOptions?: Apollo.QueryHookOptions<RuleCommunitiesQuery, RuleCommunitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleCommunitiesQuery, RuleCommunitiesQueryVariables>(RuleCommunitiesDocument, options);
      }
export function useRuleCommunitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleCommunitiesQuery, RuleCommunitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleCommunitiesQuery, RuleCommunitiesQueryVariables>(RuleCommunitiesDocument, options);
        }
export type RuleCommunitiesQueryHookResult = ReturnType<typeof useRuleCommunitiesQuery>;
export type RuleCommunitiesLazyQueryHookResult = ReturnType<typeof useRuleCommunitiesLazyQuery>;
export type RuleCommunitiesQueryResult = Apollo.QueryResult<RuleCommunitiesQuery, RuleCommunitiesQueryVariables>;
export const UpdateRuleCategoryContentTypesDocument = gql`
    mutation UpdateRuleCategoryContentTypes($input: UpdateRuleCategoryContentTypesInput!) {
  updateRuleCategoryContentTypes(input: $input) {
    rule {
      id
      categoryContentTypes
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateRuleCategoryContentTypesMutationFn = Apollo.MutationFunction<UpdateRuleCategoryContentTypesMutation, UpdateRuleCategoryContentTypesMutationVariables>;

/**
 * __useUpdateRuleCategoryContentTypesMutation__
 *
 * To run a mutation, you first call `useUpdateRuleCategoryContentTypesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleCategoryContentTypesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleCategoryContentTypesMutation, { data, loading, error }] = useUpdateRuleCategoryContentTypesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleCategoryContentTypesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleCategoryContentTypesMutation, UpdateRuleCategoryContentTypesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleCategoryContentTypesMutation, UpdateRuleCategoryContentTypesMutationVariables>(UpdateRuleCategoryContentTypesDocument, options);
      }
export type UpdateRuleCategoryContentTypesMutationHookResult = ReturnType<typeof useUpdateRuleCategoryContentTypesMutation>;
export type UpdateRuleCategoryContentTypesMutationResult = Apollo.MutationResult<UpdateRuleCategoryContentTypesMutation>;
export type UpdateRuleCategoryContentTypesMutationOptions = Apollo.BaseMutationOptions<UpdateRuleCategoryContentTypesMutation, UpdateRuleCategoryContentTypesMutationVariables>;
export const UpdateRuleCommunitiesDocument = gql`
    mutation UpdateRuleCommunities($input: UpdateRuleCommunitiesInput!) {
  updateRuleCommunities(input: $input) {
    rule {
      id
      communities {
        edges {
          node {
            id
            name
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateRuleCommunitiesMutationFn = Apollo.MutationFunction<UpdateRuleCommunitiesMutation, UpdateRuleCommunitiesMutationVariables>;

/**
 * __useUpdateRuleCommunitiesMutation__
 *
 * To run a mutation, you first call `useUpdateRuleCommunitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleCommunitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleCommunitiesMutation, { data, loading, error }] = useUpdateRuleCommunitiesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleCommunitiesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleCommunitiesMutation, UpdateRuleCommunitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleCommunitiesMutation, UpdateRuleCommunitiesMutationVariables>(UpdateRuleCommunitiesDocument, options);
      }
export type UpdateRuleCommunitiesMutationHookResult = ReturnType<typeof useUpdateRuleCommunitiesMutation>;
export type UpdateRuleCommunitiesMutationResult = Apollo.MutationResult<UpdateRuleCommunitiesMutation>;
export type UpdateRuleCommunitiesMutationOptions = Apollo.BaseMutationOptions<UpdateRuleCommunitiesMutation, UpdateRuleCommunitiesMutationVariables>;
export const RuleDocument = gql`
    query Rule($id: UUID!) {
  rule(id: $id) {
    ...Rule
  }
}
    ${RuleFragmentDoc}`;

/**
 * __useRuleQuery__
 *
 * To run a query within a React component, call `useRuleQuery` and pass it any options that fit your needs.
 * When your component renders, `useRuleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRuleQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRuleQuery(baseOptions: Apollo.QueryHookOptions<RuleQuery, RuleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RuleQuery, RuleQueryVariables>(RuleDocument, options);
      }
export function useRuleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RuleQuery, RuleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RuleQuery, RuleQueryVariables>(RuleDocument, options);
        }
export type RuleQueryHookResult = ReturnType<typeof useRuleQuery>;
export type RuleLazyQueryHookResult = ReturnType<typeof useRuleLazyQuery>;
export type RuleQueryResult = Apollo.QueryResult<RuleQuery, RuleQueryVariables>;
export const ToggleRuleActivatedDocument = gql`
    mutation ToggleRuleActivated($input: ToggleRuleActivatedInput!) {
  toggleRuleActivated(input: $input) {
    rule {
      id
      activatedAt
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ToggleRuleActivatedMutationFn = Apollo.MutationFunction<ToggleRuleActivatedMutation, ToggleRuleActivatedMutationVariables>;

/**
 * __useToggleRuleActivatedMutation__
 *
 * To run a mutation, you first call `useToggleRuleActivatedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleRuleActivatedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleRuleActivatedMutation, { data, loading, error }] = useToggleRuleActivatedMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleRuleActivatedMutation(baseOptions?: Apollo.MutationHookOptions<ToggleRuleActivatedMutation, ToggleRuleActivatedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleRuleActivatedMutation, ToggleRuleActivatedMutationVariables>(ToggleRuleActivatedDocument, options);
      }
export type ToggleRuleActivatedMutationHookResult = ReturnType<typeof useToggleRuleActivatedMutation>;
export type ToggleRuleActivatedMutationResult = Apollo.MutationResult<ToggleRuleActivatedMutation>;
export type ToggleRuleActivatedMutationOptions = Apollo.BaseMutationOptions<ToggleRuleActivatedMutation, ToggleRuleActivatedMutationVariables>;
export const UpdateRuleDocument = gql`
    mutation UpdateRule($input: UpdateRuleInput!) {
  updateRule(input: $input) {
    rule {
      id
      name
      description
      executionCount
      updatedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateRuleMutationFn = Apollo.MutationFunction<UpdateRuleMutation, UpdateRuleMutationVariables>;

/**
 * __useUpdateRuleMutation__
 *
 * To run a mutation, you first call `useUpdateRuleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRuleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRuleMutation, { data, loading, error }] = useUpdateRuleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRuleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRuleMutation, UpdateRuleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRuleMutation, UpdateRuleMutationVariables>(UpdateRuleDocument, options);
      }
export type UpdateRuleMutationHookResult = ReturnType<typeof useUpdateRuleMutation>;
export type UpdateRuleMutationResult = Apollo.MutationResult<UpdateRuleMutation>;
export type UpdateRuleMutationOptions = Apollo.BaseMutationOptions<UpdateRuleMutation, UpdateRuleMutationVariables>;
export const SafetyComplianceReadinessDocument = gql`
    query SafetyComplianceReadiness($communityId: UUID!) {
  community(id: $communityId) {
    id
    name
    settings {
      safetyComplianceV2ActivatedAt
    }
    safetyComplianceReadiness {
      activatedAt
      eligibleNow
      eligibleAfterActivation
      leavingPackCount
      awaitingExplicitConsentCount
      pcfraOfferedNotCompletedCount
      pcfraStatusChangedCount
    }
  }
}
    `;

/**
 * __useSafetyComplianceReadinessQuery__
 *
 * To run a query within a React component, call `useSafetyComplianceReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyComplianceReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyComplianceReadinessQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useSafetyComplianceReadinessQuery(baseOptions: Apollo.QueryHookOptions<SafetyComplianceReadinessQuery, SafetyComplianceReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyComplianceReadinessQuery, SafetyComplianceReadinessQueryVariables>(SafetyComplianceReadinessDocument, options);
      }
export function useSafetyComplianceReadinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyComplianceReadinessQuery, SafetyComplianceReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyComplianceReadinessQuery, SafetyComplianceReadinessQueryVariables>(SafetyComplianceReadinessDocument, options);
        }
export type SafetyComplianceReadinessQueryHookResult = ReturnType<typeof useSafetyComplianceReadinessQuery>;
export type SafetyComplianceReadinessLazyQueryHookResult = ReturnType<typeof useSafetyComplianceReadinessLazyQuery>;
export type SafetyComplianceReadinessQueryResult = Apollo.QueryResult<SafetyComplianceReadinessQuery, SafetyComplianceReadinessQueryVariables>;
export const ActivateSafetyComplianceV2Document = gql`
    mutation ActivateSafetyComplianceV2($communityId: UUID!, $confirm: Boolean!) {
  activateSafetyComplianceV2(communityId: $communityId, confirm: $confirm) {
    community {
      id
      settings {
        safetyComplianceV2ActivatedAt
      }
    }
    readiness {
      activatedAt
      eligibleNow
      eligibleAfterActivation
      leavingPackCount
      awaitingExplicitConsentCount
      pcfraOfferedNotCompletedCount
      pcfraStatusChangedCount
    }
  }
}
    `;
export type ActivateSafetyComplianceV2MutationFn = Apollo.MutationFunction<ActivateSafetyComplianceV2Mutation, ActivateSafetyComplianceV2MutationVariables>;

/**
 * __useActivateSafetyComplianceV2Mutation__
 *
 * To run a mutation, you first call `useActivateSafetyComplianceV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSafetyComplianceV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSafetyComplianceV2Mutation, { data, loading, error }] = useActivateSafetyComplianceV2Mutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      confirm: // value for 'confirm'
 *   },
 * });
 */
export function useActivateSafetyComplianceV2Mutation(baseOptions?: Apollo.MutationHookOptions<ActivateSafetyComplianceV2Mutation, ActivateSafetyComplianceV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSafetyComplianceV2Mutation, ActivateSafetyComplianceV2MutationVariables>(ActivateSafetyComplianceV2Document, options);
      }
export type ActivateSafetyComplianceV2MutationHookResult = ReturnType<typeof useActivateSafetyComplianceV2Mutation>;
export type ActivateSafetyComplianceV2MutationResult = Apollo.MutationResult<ActivateSafetyComplianceV2Mutation>;
export type ActivateSafetyComplianceV2MutationOptions = Apollo.BaseMutationOptions<ActivateSafetyComplianceV2Mutation, ActivateSafetyComplianceV2MutationVariables>;
export const ActivateSafetyResponderTokenDocument = gql`
    mutation ActivateSafetyResponderToken($packId: UUID!, $installed: Boolean!) {
  activateSafetyResponderToken(
    packId: $packId
    replacementQrsInstalled: $installed
  ) {
    pack {
      ...SafetyResponderPackState
    }
  }
}
    ${SafetyResponderPackStateFragmentDoc}`;
export type ActivateSafetyResponderTokenMutationFn = Apollo.MutationFunction<ActivateSafetyResponderTokenMutation, ActivateSafetyResponderTokenMutationVariables>;

/**
 * __useActivateSafetyResponderTokenMutation__
 *
 * To run a mutation, you first call `useActivateSafetyResponderTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateSafetyResponderTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateSafetyResponderTokenMutation, { data, loading, error }] = useActivateSafetyResponderTokenMutation({
 *   variables: {
 *      packId: // value for 'packId'
 *      installed: // value for 'installed'
 *   },
 * });
 */
export function useActivateSafetyResponderTokenMutation(baseOptions?: Apollo.MutationHookOptions<ActivateSafetyResponderTokenMutation, ActivateSafetyResponderTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateSafetyResponderTokenMutation, ActivateSafetyResponderTokenMutationVariables>(ActivateSafetyResponderTokenDocument, options);
      }
export type ActivateSafetyResponderTokenMutationHookResult = ReturnType<typeof useActivateSafetyResponderTokenMutation>;
export type ActivateSafetyResponderTokenMutationResult = Apollo.MutationResult<ActivateSafetyResponderTokenMutation>;
export type ActivateSafetyResponderTokenMutationOptions = Apollo.BaseMutationOptions<ActivateSafetyResponderTokenMutation, ActivateSafetyResponderTokenMutationVariables>;
export const RotateSafetyResponderTokenDocument = gql`
    mutation RotateSafetyResponderToken($packId: UUID!, $reason: String!) {
  rotateSafetyResponderToken(packId: $packId, reason: $reason) {
    residualWindow
    pack {
      ...SafetyResponderPackState
    }
  }
}
    ${SafetyResponderPackStateFragmentDoc}`;
export type RotateSafetyResponderTokenMutationFn = Apollo.MutationFunction<RotateSafetyResponderTokenMutation, RotateSafetyResponderTokenMutationVariables>;

/**
 * __useRotateSafetyResponderTokenMutation__
 *
 * To run a mutation, you first call `useRotateSafetyResponderTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRotateSafetyResponderTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rotateSafetyResponderTokenMutation, { data, loading, error }] = useRotateSafetyResponderTokenMutation({
 *   variables: {
 *      packId: // value for 'packId'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useRotateSafetyResponderTokenMutation(baseOptions?: Apollo.MutationHookOptions<RotateSafetyResponderTokenMutation, RotateSafetyResponderTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RotateSafetyResponderTokenMutation, RotateSafetyResponderTokenMutationVariables>(RotateSafetyResponderTokenDocument, options);
      }
export type RotateSafetyResponderTokenMutationHookResult = ReturnType<typeof useRotateSafetyResponderTokenMutation>;
export type RotateSafetyResponderTokenMutationResult = Apollo.MutationResult<RotateSafetyResponderTokenMutation>;
export type RotateSafetyResponderTokenMutationOptions = Apollo.BaseMutationOptions<RotateSafetyResponderTokenMutation, RotateSafetyResponderTokenMutationVariables>;
export const SafetyReviewCadenceDocument = gql`
    query SafetyReviewCadence($communityId: UUID!) {
  community(id: $communityId) {
    id
    name
    settings {
      surveyReviewIntervalMonths
    }
  }
}
    `;

/**
 * __useSafetyReviewCadenceQuery__
 *
 * To run a query within a React component, call `useSafetyReviewCadenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyReviewCadenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyReviewCadenceQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useSafetyReviewCadenceQuery(baseOptions: Apollo.QueryHookOptions<SafetyReviewCadenceQuery, SafetyReviewCadenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyReviewCadenceQuery, SafetyReviewCadenceQueryVariables>(SafetyReviewCadenceDocument, options);
      }
export function useSafetyReviewCadenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyReviewCadenceQuery, SafetyReviewCadenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyReviewCadenceQuery, SafetyReviewCadenceQueryVariables>(SafetyReviewCadenceDocument, options);
        }
export type SafetyReviewCadenceQueryHookResult = ReturnType<typeof useSafetyReviewCadenceQuery>;
export type SafetyReviewCadenceLazyQueryHookResult = ReturnType<typeof useSafetyReviewCadenceLazyQuery>;
export type SafetyReviewCadenceQueryResult = Apollo.QueryResult<SafetyReviewCadenceQuery, SafetyReviewCadenceQueryVariables>;
export const UpdateSafetyReviewIntervalDocument = gql`
    mutation UpdateSafetyReviewInterval($communityId: UUID!, $months: Int!) {
  updateSafetyReviewInterval(
    communityId: $communityId
    surveyReviewIntervalMonths: $months
  ) {
    community {
      id
      settings {
        surveyReviewIntervalMonths
      }
    }
  }
}
    `;
export type UpdateSafetyReviewIntervalMutationFn = Apollo.MutationFunction<UpdateSafetyReviewIntervalMutation, UpdateSafetyReviewIntervalMutationVariables>;

/**
 * __useUpdateSafetyReviewIntervalMutation__
 *
 * To run a mutation, you first call `useUpdateSafetyReviewIntervalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafetyReviewIntervalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafetyReviewIntervalMutation, { data, loading, error }] = useUpdateSafetyReviewIntervalMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      months: // value for 'months'
 *   },
 * });
 */
export function useUpdateSafetyReviewIntervalMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSafetyReviewIntervalMutation, UpdateSafetyReviewIntervalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSafetyReviewIntervalMutation, UpdateSafetyReviewIntervalMutationVariables>(UpdateSafetyReviewIntervalDocument, options);
      }
export type UpdateSafetyReviewIntervalMutationHookResult = ReturnType<typeof useUpdateSafetyReviewIntervalMutation>;
export type UpdateSafetyReviewIntervalMutationResult = Apollo.MutationResult<UpdateSafetyReviewIntervalMutation>;
export type UpdateSafetyReviewIntervalMutationOptions = Apollo.BaseMutationOptions<UpdateSafetyReviewIntervalMutation, UpdateSafetyReviewIntervalMutationVariables>;
export const SafetyDocumentsCommunityDocument = gql`
    query SafetyDocumentsCommunity($id: UUID!) {
  community(id: $id) {
    id
    name
    postcode
    homeCount
    residentCount
    sibPackUrl
    sibPackStale
    sibTaggedDocumentCount
    sibResidentNeedCount
    lastSibPackGeneratedAt
    lastSibPackPrintedAt
    settings {
      sibPackReviewRemindersEnabled
      sibPackReviewNudgeMonths
      surveyReviewIntervalMonths
      safetyComplianceV2ActivatedAt
    }
  }
}
    `;

/**
 * __useSafetyDocumentsCommunityQuery__
 *
 * To run a query within a React component, call `useSafetyDocumentsCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyDocumentsCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyDocumentsCommunityQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafetyDocumentsCommunityQuery(baseOptions: Apollo.QueryHookOptions<SafetyDocumentsCommunityQuery, SafetyDocumentsCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyDocumentsCommunityQuery, SafetyDocumentsCommunityQueryVariables>(SafetyDocumentsCommunityDocument, options);
      }
export function useSafetyDocumentsCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyDocumentsCommunityQuery, SafetyDocumentsCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyDocumentsCommunityQuery, SafetyDocumentsCommunityQueryVariables>(SafetyDocumentsCommunityDocument, options);
        }
export type SafetyDocumentsCommunityQueryHookResult = ReturnType<typeof useSafetyDocumentsCommunityQuery>;
export type SafetyDocumentsCommunityLazyQueryHookResult = ReturnType<typeof useSafetyDocumentsCommunityLazyQuery>;
export type SafetyDocumentsCommunityQueryResult = Apollo.QueryResult<SafetyDocumentsCommunityQuery, SafetyDocumentsCommunityQueryVariables>;
export const SafetyDocumentsBlocksDocument = gql`
    query SafetyDocumentsBlocks($communityId: ID!) {
  blocks(communities: [$communityId], orderBy: "name") {
    edges {
      node {
        ...SafetyDocumentBuilding
      }
    }
  }
}
    ${SafetyDocumentBuildingFragmentDoc}`;

/**
 * __useSafetyDocumentsBlocksQuery__
 *
 * To run a query within a React component, call `useSafetyDocumentsBlocksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyDocumentsBlocksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyDocumentsBlocksQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useSafetyDocumentsBlocksQuery(baseOptions: Apollo.QueryHookOptions<SafetyDocumentsBlocksQuery, SafetyDocumentsBlocksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyDocumentsBlocksQuery, SafetyDocumentsBlocksQueryVariables>(SafetyDocumentsBlocksDocument, options);
      }
export function useSafetyDocumentsBlocksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyDocumentsBlocksQuery, SafetyDocumentsBlocksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyDocumentsBlocksQuery, SafetyDocumentsBlocksQueryVariables>(SafetyDocumentsBlocksDocument, options);
        }
export type SafetyDocumentsBlocksQueryHookResult = ReturnType<typeof useSafetyDocumentsBlocksQuery>;
export type SafetyDocumentsBlocksLazyQueryHookResult = ReturnType<typeof useSafetyDocumentsBlocksLazyQuery>;
export type SafetyDocumentsBlocksQueryResult = Apollo.QueryResult<SafetyDocumentsBlocksQuery, SafetyDocumentsBlocksQueryVariables>;
export const SafetyCenterDocumentsForCommunityDocument = gql`
    query SafetyCenterDocumentsForCommunity($communityId: UUID!) {
  safetyCenterDocuments(community: $communityId, archived: false) {
    totalCount
    edges {
      node {
        ...SafetyCenterDocumentItem
      }
    }
  }
}
    ${SafetyCenterDocumentItemFragmentDoc}`;

/**
 * __useSafetyCenterDocumentsForCommunityQuery__
 *
 * To run a query within a React component, call `useSafetyCenterDocumentsForCommunityQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyCenterDocumentsForCommunityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyCenterDocumentsForCommunityQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useSafetyCenterDocumentsForCommunityQuery(baseOptions: Apollo.QueryHookOptions<SafetyCenterDocumentsForCommunityQuery, SafetyCenterDocumentsForCommunityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyCenterDocumentsForCommunityQuery, SafetyCenterDocumentsForCommunityQueryVariables>(SafetyCenterDocumentsForCommunityDocument, options);
      }
export function useSafetyCenterDocumentsForCommunityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyCenterDocumentsForCommunityQuery, SafetyCenterDocumentsForCommunityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyCenterDocumentsForCommunityQuery, SafetyCenterDocumentsForCommunityQueryVariables>(SafetyCenterDocumentsForCommunityDocument, options);
        }
export type SafetyCenterDocumentsForCommunityQueryHookResult = ReturnType<typeof useSafetyCenterDocumentsForCommunityQuery>;
export type SafetyCenterDocumentsForCommunityLazyQueryHookResult = ReturnType<typeof useSafetyCenterDocumentsForCommunityLazyQuery>;
export type SafetyCenterDocumentsForCommunityQueryResult = Apollo.QueryResult<SafetyCenterDocumentsForCommunityQuery, SafetyCenterDocumentsForCommunityQueryVariables>;
export const SafetyDocumentsCandidatesDocument = gql`
    query SafetyDocumentsCandidates($communityId: ID!, $search: String) {
  communityDocuments(
    communities: [$communityId]
    search: $search
    orderBy: "created_at"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        title
        file
        link
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useSafetyDocumentsCandidatesQuery__
 *
 * To run a query within a React component, call `useSafetyDocumentsCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyDocumentsCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyDocumentsCandidatesQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSafetyDocumentsCandidatesQuery(baseOptions: Apollo.QueryHookOptions<SafetyDocumentsCandidatesQuery, SafetyDocumentsCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyDocumentsCandidatesQuery, SafetyDocumentsCandidatesQueryVariables>(SafetyDocumentsCandidatesDocument, options);
      }
export function useSafetyDocumentsCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyDocumentsCandidatesQuery, SafetyDocumentsCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyDocumentsCandidatesQuery, SafetyDocumentsCandidatesQueryVariables>(SafetyDocumentsCandidatesDocument, options);
        }
export type SafetyDocumentsCandidatesQueryHookResult = ReturnType<typeof useSafetyDocumentsCandidatesQuery>;
export type SafetyDocumentsCandidatesLazyQueryHookResult = ReturnType<typeof useSafetyDocumentsCandidatesLazyQuery>;
export type SafetyDocumentsCandidatesQueryResult = Apollo.QueryResult<SafetyDocumentsCandidatesQuery, SafetyDocumentsCandidatesQueryVariables>;
export const InspectionActionPlanDocument = gql`
    query InspectionActionPlan($id: UUID!) {
  task(id: $id) {
    ...ActionPlanTask
  }
}
    ${ActionPlanTaskFragmentDoc}`;

/**
 * __useInspectionActionPlanQuery__
 *
 * To run a query within a React component, call `useInspectionActionPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionActionPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionActionPlanQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInspectionActionPlanQuery(baseOptions: Apollo.QueryHookOptions<InspectionActionPlanQuery, InspectionActionPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionActionPlanQuery, InspectionActionPlanQueryVariables>(InspectionActionPlanDocument, options);
      }
export function useInspectionActionPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionActionPlanQuery, InspectionActionPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionActionPlanQuery, InspectionActionPlanQueryVariables>(InspectionActionPlanDocument, options);
        }
export type InspectionActionPlanQueryHookResult = ReturnType<typeof useInspectionActionPlanQuery>;
export type InspectionActionPlanLazyQueryHookResult = ReturnType<typeof useInspectionActionPlanLazyQuery>;
export type InspectionActionPlanQueryResult = Apollo.QueryResult<InspectionActionPlanQuery, InspectionActionPlanQueryVariables>;
export const ReviewInspectionActionDocument = gql`
    mutation ReviewInspectionAction($input: ReviewInspectionActionInput!) {
  reviewInspectionAction(input: $input) {
    action {
      ...ChecklistAction
    }
  }
}
    ${ChecklistActionFragmentDoc}`;
export type ReviewInspectionActionMutationFn = Apollo.MutationFunction<ReviewInspectionActionMutation, ReviewInspectionActionMutationVariables>;

/**
 * __useReviewInspectionActionMutation__
 *
 * To run a mutation, you first call `useReviewInspectionActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReviewInspectionActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reviewInspectionActionMutation, { data, loading, error }] = useReviewInspectionActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReviewInspectionActionMutation(baseOptions?: Apollo.MutationHookOptions<ReviewInspectionActionMutation, ReviewInspectionActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReviewInspectionActionMutation, ReviewInspectionActionMutationVariables>(ReviewInspectionActionDocument, options);
      }
export type ReviewInspectionActionMutationHookResult = ReturnType<typeof useReviewInspectionActionMutation>;
export type ReviewInspectionActionMutationResult = Apollo.MutationResult<ReviewInspectionActionMutation>;
export type ReviewInspectionActionMutationOptions = Apollo.BaseMutationOptions<ReviewInspectionActionMutation, ReviewInspectionActionMutationVariables>;
export const FlagInspectionActionDocument = gql`
    mutation FlagInspectionAction($input: FlagChecklistItemInput!) {
  flagChecklistItem(input: $input) {
    checklistItem {
      ...ChecklistItem
    }
    action {
      ...ChecklistAction
    }
  }
}
    ${ChecklistItemFragmentDoc}
${ChecklistActionFragmentDoc}`;
export type FlagInspectionActionMutationFn = Apollo.MutationFunction<FlagInspectionActionMutation, FlagInspectionActionMutationVariables>;

/**
 * __useFlagInspectionActionMutation__
 *
 * To run a mutation, you first call `useFlagInspectionActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagInspectionActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagInspectionActionMutation, { data, loading, error }] = useFlagInspectionActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlagInspectionActionMutation(baseOptions?: Apollo.MutationHookOptions<FlagInspectionActionMutation, FlagInspectionActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagInspectionActionMutation, FlagInspectionActionMutationVariables>(FlagInspectionActionDocument, options);
      }
export type FlagInspectionActionMutationHookResult = ReturnType<typeof useFlagInspectionActionMutation>;
export type FlagInspectionActionMutationResult = Apollo.MutationResult<FlagInspectionActionMutation>;
export type FlagInspectionActionMutationOptions = Apollo.BaseMutationOptions<FlagInspectionActionMutation, FlagInspectionActionMutationVariables>;
export const CreateFollowUpTaskFromActionDocument = gql`
    mutation CreateFollowUpTaskFromAction($input: CreateFollowUpTaskFromChecklistItemInput!) {
  createFollowUpTaskFromChecklistItem(input: $input) {
    created
    task {
      ...ChecklistFollowUpTask
    }
    checklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistFollowUpTaskFragmentDoc}
${ChecklistItemFragmentDoc}`;
export type CreateFollowUpTaskFromActionMutationFn = Apollo.MutationFunction<CreateFollowUpTaskFromActionMutation, CreateFollowUpTaskFromActionMutationVariables>;

/**
 * __useCreateFollowUpTaskFromActionMutation__
 *
 * To run a mutation, you first call `useCreateFollowUpTaskFromActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowUpTaskFromActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowUpTaskFromActionMutation, { data, loading, error }] = useCreateFollowUpTaskFromActionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFollowUpTaskFromActionMutation(baseOptions?: Apollo.MutationHookOptions<CreateFollowUpTaskFromActionMutation, CreateFollowUpTaskFromActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFollowUpTaskFromActionMutation, CreateFollowUpTaskFromActionMutationVariables>(CreateFollowUpTaskFromActionDocument, options);
      }
export type CreateFollowUpTaskFromActionMutationHookResult = ReturnType<typeof useCreateFollowUpTaskFromActionMutation>;
export type CreateFollowUpTaskFromActionMutationResult = Apollo.MutationResult<CreateFollowUpTaskFromActionMutation>;
export type CreateFollowUpTaskFromActionMutationOptions = Apollo.BaseMutationOptions<CreateFollowUpTaskFromActionMutation, CreateFollowUpTaskFromActionMutationVariables>;
export const CreateFollowUpTasksFromActionsDocument = gql`
    mutation CreateFollowUpTasksFromActions($input: CreateFollowUpTasksFromChecklistItemsInput!) {
  createFollowUpTasksFromChecklistItems(input: $input) {
    createdCount
    existingCount
    tasks {
      ...ChecklistFollowUpTask
    }
    checklistItems {
      ...ChecklistItem
    }
  }
}
    ${ChecklistFollowUpTaskFragmentDoc}
${ChecklistItemFragmentDoc}`;
export type CreateFollowUpTasksFromActionsMutationFn = Apollo.MutationFunction<CreateFollowUpTasksFromActionsMutation, CreateFollowUpTasksFromActionsMutationVariables>;

/**
 * __useCreateFollowUpTasksFromActionsMutation__
 *
 * To run a mutation, you first call `useCreateFollowUpTasksFromActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowUpTasksFromActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowUpTasksFromActionsMutation, { data, loading, error }] = useCreateFollowUpTasksFromActionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFollowUpTasksFromActionsMutation(baseOptions?: Apollo.MutationHookOptions<CreateFollowUpTasksFromActionsMutation, CreateFollowUpTasksFromActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFollowUpTasksFromActionsMutation, CreateFollowUpTasksFromActionsMutationVariables>(CreateFollowUpTasksFromActionsDocument, options);
      }
export type CreateFollowUpTasksFromActionsMutationHookResult = ReturnType<typeof useCreateFollowUpTasksFromActionsMutation>;
export type CreateFollowUpTasksFromActionsMutationResult = Apollo.MutationResult<CreateFollowUpTasksFromActionsMutation>;
export type CreateFollowUpTasksFromActionsMutationOptions = Apollo.BaseMutationOptions<CreateFollowUpTasksFromActionsMutation, CreateFollowUpTasksFromActionsMutationVariables>;
export const CreateTemplateFromChecklistDocument = gql`
    mutation CreateTemplateFromChecklist($input: CreateTemplateFromChecklistInput!) {
  createTemplateFromChecklist(input: $input) {
    taskTemplate {
      id
    }
  }
}
    `;
export type CreateTemplateFromChecklistMutationFn = Apollo.MutationFunction<CreateTemplateFromChecklistMutation, CreateTemplateFromChecklistMutationVariables>;

/**
 * __useCreateTemplateFromChecklistMutation__
 *
 * To run a mutation, you first call `useCreateTemplateFromChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTemplateFromChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTemplateFromChecklistMutation, { data, loading, error }] = useCreateTemplateFromChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTemplateFromChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateTemplateFromChecklistMutation, CreateTemplateFromChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTemplateFromChecklistMutation, CreateTemplateFromChecklistMutationVariables>(CreateTemplateFromChecklistDocument, options);
      }
export type CreateTemplateFromChecklistMutationHookResult = ReturnType<typeof useCreateTemplateFromChecklistMutation>;
export type CreateTemplateFromChecklistMutationResult = Apollo.MutationResult<CreateTemplateFromChecklistMutation>;
export type CreateTemplateFromChecklistMutationOptions = Apollo.BaseMutationOptions<CreateTemplateFromChecklistMutation, CreateTemplateFromChecklistMutationVariables>;
export const InspectionActionSourceDocument = gql`
    query InspectionActionSource($actionId: UUID!) {
  checklistActionSource(actionId: $actionId) {
    actionId
    isRegionLevel
    page {
      id
      pageNo
      image
      width
      height
    }
    regions {
      ...InspectionSourceRegionEntry
    }
  }
}
    ${InspectionSourceRegionEntryFragmentDoc}`;

/**
 * __useInspectionActionSourceQuery__
 *
 * To run a query within a React component, call `useInspectionActionSourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionActionSourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionActionSourceQuery({
 *   variables: {
 *      actionId: // value for 'actionId'
 *   },
 * });
 */
export function useInspectionActionSourceQuery(baseOptions: Apollo.QueryHookOptions<InspectionActionSourceQuery, InspectionActionSourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionActionSourceQuery, InspectionActionSourceQueryVariables>(InspectionActionSourceDocument, options);
      }
export function useInspectionActionSourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionActionSourceQuery, InspectionActionSourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionActionSourceQuery, InspectionActionSourceQueryVariables>(InspectionActionSourceDocument, options);
        }
export type InspectionActionSourceQueryHookResult = ReturnType<typeof useInspectionActionSourceQuery>;
export type InspectionActionSourceLazyQueryHookResult = ReturnType<typeof useInspectionActionSourceLazyQuery>;
export type InspectionActionSourceQueryResult = Apollo.QueryResult<InspectionActionSourceQuery, InspectionActionSourceQueryVariables>;
export const InspectionReportsDocument = gql`
    query InspectionReports($community: UUID, $communities: [ID], $search: String, $complianceTypes: [String], $first: Int = 50, $after: String) {
  documentExtractions(
    community: $community
    communities: $communities
    search: $search
    complianceTypes: $complianceTypes
    mode: "INSPECTION"
    orderBy: "-created_at"
    first: $first
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...InspectionExtraction
      }
    }
  }
}
    ${InspectionExtractionFragmentDoc}`;

/**
 * __useInspectionReportsQuery__
 *
 * To run a query within a React component, call `useInspectionReportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionReportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionReportsQuery({
 *   variables: {
 *      community: // value for 'community'
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      complianceTypes: // value for 'complianceTypes'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInspectionReportsQuery(baseOptions?: Apollo.QueryHookOptions<InspectionReportsQuery, InspectionReportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionReportsQuery, InspectionReportsQueryVariables>(InspectionReportsDocument, options);
      }
export function useInspectionReportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionReportsQuery, InspectionReportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionReportsQuery, InspectionReportsQueryVariables>(InspectionReportsDocument, options);
        }
export type InspectionReportsQueryHookResult = ReturnType<typeof useInspectionReportsQuery>;
export type InspectionReportsLazyQueryHookResult = ReturnType<typeof useInspectionReportsLazyQuery>;
export type InspectionReportsQueryResult = Apollo.QueryResult<InspectionReportsQuery, InspectionReportsQueryVariables>;
export const InspectionReportStatusDocument = gql`
    query InspectionReportStatus($id: UUID!) {
  documentExtraction(id: $id) {
    ...InspectionExtractionProgress
  }
}
    ${InspectionExtractionProgressFragmentDoc}`;

/**
 * __useInspectionReportStatusQuery__
 *
 * To run a query within a React component, call `useInspectionReportStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionReportStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionReportStatusQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useInspectionReportStatusQuery(baseOptions: Apollo.QueryHookOptions<InspectionReportStatusQuery, InspectionReportStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionReportStatusQuery, InspectionReportStatusQueryVariables>(InspectionReportStatusDocument, options);
      }
export function useInspectionReportStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionReportStatusQuery, InspectionReportStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionReportStatusQuery, InspectionReportStatusQueryVariables>(InspectionReportStatusDocument, options);
        }
export type InspectionReportStatusQueryHookResult = ReturnType<typeof useInspectionReportStatusQuery>;
export type InspectionReportStatusLazyQueryHookResult = ReturnType<typeof useInspectionReportStatusLazyQuery>;
export type InspectionReportStatusQueryResult = Apollo.QueryResult<InspectionReportStatusQuery, InspectionReportStatusQueryVariables>;
export const RetryInspectionExtractionDocument = gql`
    mutation RetryInspectionExtraction($input: RetryDocumentExtractionInput!) {
  retryDocumentExtraction(input: $input) {
    documentExtraction {
      ...InspectionExtraction
    }
    errors {
      field
      messages
    }
  }
}
    ${InspectionExtractionFragmentDoc}`;
export type RetryInspectionExtractionMutationFn = Apollo.MutationFunction<RetryInspectionExtractionMutation, RetryInspectionExtractionMutationVariables>;

/**
 * __useRetryInspectionExtractionMutation__
 *
 * To run a mutation, you first call `useRetryInspectionExtractionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryInspectionExtractionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryInspectionExtractionMutation, { data, loading, error }] = useRetryInspectionExtractionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRetryInspectionExtractionMutation(baseOptions?: Apollo.MutationHookOptions<RetryInspectionExtractionMutation, RetryInspectionExtractionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryInspectionExtractionMutation, RetryInspectionExtractionMutationVariables>(RetryInspectionExtractionDocument, options);
      }
export type RetryInspectionExtractionMutationHookResult = ReturnType<typeof useRetryInspectionExtractionMutation>;
export type RetryInspectionExtractionMutationResult = Apollo.MutationResult<RetryInspectionExtractionMutation>;
export type RetryInspectionExtractionMutationOptions = Apollo.BaseMutationOptions<RetryInspectionExtractionMutation, RetryInspectionExtractionMutationVariables>;
export const InspectionOverviewDocument = gql`
    query InspectionOverview($taskId: UUID!) {
  task(id: $taskId) {
    id
    checklist {
      id
      sourceExtraction {
        ...InspectionOverviewExtraction
      }
    }
  }
}
    ${InspectionOverviewExtractionFragmentDoc}`;

/**
 * __useInspectionOverviewQuery__
 *
 * To run a query within a React component, call `useInspectionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionOverviewQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *   },
 * });
 */
export function useInspectionOverviewQuery(baseOptions: Apollo.QueryHookOptions<InspectionOverviewQuery, InspectionOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionOverviewQuery, InspectionOverviewQueryVariables>(InspectionOverviewDocument, options);
      }
export function useInspectionOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionOverviewQuery, InspectionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionOverviewQuery, InspectionOverviewQueryVariables>(InspectionOverviewDocument, options);
        }
export type InspectionOverviewQueryHookResult = ReturnType<typeof useInspectionOverviewQuery>;
export type InspectionOverviewLazyQueryHookResult = ReturnType<typeof useInspectionOverviewLazyQuery>;
export type InspectionOverviewQueryResult = Apollo.QueryResult<InspectionOverviewQuery, InspectionOverviewQueryVariables>;
export const InspectionWorkspaceActivityDocument = gql`
    query InspectionWorkspaceActivity($taskId: UUID!, $first: Int = 50, $after: String) {
  task(id: $taskId) {
    id
    updates(first: $first, after: $after) {
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...WorkspaceUpdate
        }
      }
    }
  }
}
    ${WorkspaceUpdateFragmentDoc}`;

/**
 * __useInspectionWorkspaceActivityQuery__
 *
 * To run a query within a React component, call `useInspectionWorkspaceActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useInspectionWorkspaceActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInspectionWorkspaceActivityQuery({
 *   variables: {
 *      taskId: // value for 'taskId'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInspectionWorkspaceActivityQuery(baseOptions: Apollo.QueryHookOptions<InspectionWorkspaceActivityQuery, InspectionWorkspaceActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InspectionWorkspaceActivityQuery, InspectionWorkspaceActivityQueryVariables>(InspectionWorkspaceActivityDocument, options);
      }
export function useInspectionWorkspaceActivityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InspectionWorkspaceActivityQuery, InspectionWorkspaceActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InspectionWorkspaceActivityQuery, InspectionWorkspaceActivityQueryVariables>(InspectionWorkspaceActivityDocument, options);
        }
export type InspectionWorkspaceActivityQueryHookResult = ReturnType<typeof useInspectionWorkspaceActivityQuery>;
export type InspectionWorkspaceActivityLazyQueryHookResult = ReturnType<typeof useInspectionWorkspaceActivityLazyQuery>;
export type InspectionWorkspaceActivityQueryResult = Apollo.QueryResult<InspectionWorkspaceActivityQuery, InspectionWorkspaceActivityQueryVariables>;
export const ManagerDeclarationTargetsDocument = gql`
    query ManagerDeclarationTargets($residencyId: UUID!) {
  residency(id: $residencyId) {
    ...ManagerDeclarationResidency
  }
}
    ${ManagerDeclarationResidencyFragmentDoc}`;

/**
 * __useManagerDeclarationTargetsQuery__
 *
 * To run a query within a React component, call `useManagerDeclarationTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useManagerDeclarationTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useManagerDeclarationTargetsQuery({
 *   variables: {
 *      residencyId: // value for 'residencyId'
 *   },
 * });
 */
export function useManagerDeclarationTargetsQuery(baseOptions: Apollo.QueryHookOptions<ManagerDeclarationTargetsQuery, ManagerDeclarationTargetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ManagerDeclarationTargetsQuery, ManagerDeclarationTargetsQueryVariables>(ManagerDeclarationTargetsDocument, options);
      }
export function useManagerDeclarationTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ManagerDeclarationTargetsQuery, ManagerDeclarationTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ManagerDeclarationTargetsQuery, ManagerDeclarationTargetsQueryVariables>(ManagerDeclarationTargetsDocument, options);
        }
export type ManagerDeclarationTargetsQueryHookResult = ReturnType<typeof useManagerDeclarationTargetsQuery>;
export type ManagerDeclarationTargetsLazyQueryHookResult = ReturnType<typeof useManagerDeclarationTargetsLazyQuery>;
export type ManagerDeclarationTargetsQueryResult = Apollo.QueryResult<ManagerDeclarationTargetsQuery, ManagerDeclarationTargetsQueryVariables>;
export const HomeActiveResidencyForDeclarationDocument = gql`
    query HomeActiveResidencyForDeclaration($homeId: UUID!) {
  home(id: $homeId) {
    id
    activeResidency {
      id
    }
  }
}
    `;

/**
 * __useHomeActiveResidencyForDeclarationQuery__
 *
 * To run a query within a React component, call `useHomeActiveResidencyForDeclarationQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeActiveResidencyForDeclarationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeActiveResidencyForDeclarationQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function useHomeActiveResidencyForDeclarationQuery(baseOptions: Apollo.QueryHookOptions<HomeActiveResidencyForDeclarationQuery, HomeActiveResidencyForDeclarationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomeActiveResidencyForDeclarationQuery, HomeActiveResidencyForDeclarationQueryVariables>(HomeActiveResidencyForDeclarationDocument, options);
      }
export function useHomeActiveResidencyForDeclarationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomeActiveResidencyForDeclarationQuery, HomeActiveResidencyForDeclarationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomeActiveResidencyForDeclarationQuery, HomeActiveResidencyForDeclarationQueryVariables>(HomeActiveResidencyForDeclarationDocument, options);
        }
export type HomeActiveResidencyForDeclarationQueryHookResult = ReturnType<typeof useHomeActiveResidencyForDeclarationQuery>;
export type HomeActiveResidencyForDeclarationLazyQueryHookResult = ReturnType<typeof useHomeActiveResidencyForDeclarationLazyQuery>;
export type HomeActiveResidencyForDeclarationQueryResult = Apollo.QueryResult<HomeActiveResidencyForDeclarationQuery, HomeActiveResidencyForDeclarationQueryVariables>;
export const SafetyRecordsDocument = gql`
    query SafetyRecords($communities: [ID], $isOccupant: Boolean, $hasConsent: Boolean, $hasNeeds: Boolean, $search: String, $pcfraStatus: String, $eesStatus: String, $includeArchived: Boolean, $after: String) {
  residentSafetyRecords(
    communities: $communities
    isOccupant: $isOccupant
    hasConsent: $hasConsent
    hasNeeds: $hasNeeds
    search: $search
    pcfraStatus: $pcfraStatus
    eesStatus: $eesStatus
    includeArchived: $includeArchived
    after: $after
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        ...SafetyListItem
      }
    }
  }
}
    ${SafetyListItemFragmentDoc}`;

/**
 * __useSafetyRecordsQuery__
 *
 * To run a query within a React component, call `useSafetyRecordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyRecordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyRecordsQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      isOccupant: // value for 'isOccupant'
 *      hasConsent: // value for 'hasConsent'
 *      hasNeeds: // value for 'hasNeeds'
 *      search: // value for 'search'
 *      pcfraStatus: // value for 'pcfraStatus'
 *      eesStatus: // value for 'eesStatus'
 *      includeArchived: // value for 'includeArchived'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSafetyRecordsQuery(baseOptions?: Apollo.QueryHookOptions<SafetyRecordsQuery, SafetyRecordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyRecordsQuery, SafetyRecordsQueryVariables>(SafetyRecordsDocument, options);
      }
export function useSafetyRecordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyRecordsQuery, SafetyRecordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyRecordsQuery, SafetyRecordsQueryVariables>(SafetyRecordsDocument, options);
        }
export type SafetyRecordsQueryHookResult = ReturnType<typeof useSafetyRecordsQuery>;
export type SafetyRecordsLazyQueryHookResult = ReturnType<typeof useSafetyRecordsLazyQuery>;
export type SafetyRecordsQueryResult = Apollo.QueryResult<SafetyRecordsQuery, SafetyRecordsQueryVariables>;
export const SafetyRosterDocument = gql`
    query SafetyRoster($communities: [ID], $blocks: [UUID], $cohort: String, $search: String, $pcfraStatuses: [String], $eesStatuses: [String], $issue: String, $limit: Int, $offset: Int) {
  safetyRoster(
    communities: $communities
    blocks: $blocks
    cohort: $cohort
    search: $search
    pcfraStatuses: $pcfraStatuses
    eesStatuses: $eesStatuses
    issue: $issue
    limit: $limit
    offset: $offset
  ) {
    cohort
    totalCount
    hasMore
    counts {
      needsAction
      declaredNeeds
      noNeeds
      notAnswered
      all
    }
    pcfraCounts {
      notOffered
      offered
      declined
    }
    eesCounts {
      notGenerated
      generated
      agreed
    }
    rows {
      ...SafetyRosterRow
    }
  }
}
    ${SafetyRosterRowFragmentDoc}`;

/**
 * __useSafetyRosterQuery__
 *
 * To run a query within a React component, call `useSafetyRosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyRosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyRosterQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      blocks: // value for 'blocks'
 *      cohort: // value for 'cohort'
 *      search: // value for 'search'
 *      pcfraStatuses: // value for 'pcfraStatuses'
 *      eesStatuses: // value for 'eesStatuses'
 *      issue: // value for 'issue'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSafetyRosterQuery(baseOptions?: Apollo.QueryHookOptions<SafetyRosterQuery, SafetyRosterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyRosterQuery, SafetyRosterQueryVariables>(SafetyRosterDocument, options);
      }
export function useSafetyRosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyRosterQuery, SafetyRosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyRosterQuery, SafetyRosterQueryVariables>(SafetyRosterDocument, options);
        }
export type SafetyRosterQueryHookResult = ReturnType<typeof useSafetyRosterQuery>;
export type SafetyRosterLazyQueryHookResult = ReturnType<typeof useSafetyRosterLazyQuery>;
export type SafetyRosterQueryResult = Apollo.QueryResult<SafetyRosterQuery, SafetyRosterQueryVariables>;
export const SafetyPortfolioDocument = gql`
    query SafetyPortfolio($communities: [ID]) {
  safetyPortfolio(communities: $communities) {
    communityId
    communityName
    postcode
    blocks {
      ...SafetyBlockReadiness
    }
  }
}
    ${SafetyBlockReadinessFragmentDoc}`;

/**
 * __useSafetyPortfolioQuery__
 *
 * To run a query within a React component, call `useSafetyPortfolioQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyPortfolioQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyPortfolioQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useSafetyPortfolioQuery(baseOptions?: Apollo.QueryHookOptions<SafetyPortfolioQuery, SafetyPortfolioQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyPortfolioQuery, SafetyPortfolioQueryVariables>(SafetyPortfolioDocument, options);
      }
export function useSafetyPortfolioLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyPortfolioQuery, SafetyPortfolioQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyPortfolioQuery, SafetyPortfolioQueryVariables>(SafetyPortfolioDocument, options);
        }
export type SafetyPortfolioQueryHookResult = ReturnType<typeof useSafetyPortfolioQuery>;
export type SafetyPortfolioLazyQueryHookResult = ReturnType<typeof useSafetyPortfolioLazyQuery>;
export type SafetyPortfolioQueryResult = Apollo.QueryResult<SafetyPortfolioQuery, SafetyPortfolioQueryVariables>;
export const HomesMissingFloorDocument = gql`
    query HomesMissingFloor($block: UUID!, $offset: Int) {
  block(id: $block) {
    id
    totalFloors
  }
  homes(
    block: $block
    missingFloor: true
    first: 10
    offset: $offset
    orderBy: "name"
  ) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        addressLine1
        floorNumber
      }
    }
  }
}
    `;

/**
 * __useHomesMissingFloorQuery__
 *
 * To run a query within a React component, call `useHomesMissingFloorQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomesMissingFloorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomesMissingFloorQuery({
 *   variables: {
 *      block: // value for 'block'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useHomesMissingFloorQuery(baseOptions: Apollo.QueryHookOptions<HomesMissingFloorQuery, HomesMissingFloorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomesMissingFloorQuery, HomesMissingFloorQueryVariables>(HomesMissingFloorDocument, options);
      }
export function useHomesMissingFloorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomesMissingFloorQuery, HomesMissingFloorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomesMissingFloorQuery, HomesMissingFloorQueryVariables>(HomesMissingFloorDocument, options);
        }
export type HomesMissingFloorQueryHookResult = ReturnType<typeof useHomesMissingFloorQuery>;
export type HomesMissingFloorLazyQueryHookResult = ReturnType<typeof useHomesMissingFloorLazyQuery>;
export type HomesMissingFloorQueryResult = Apollo.QueryResult<HomesMissingFloorQuery, HomesMissingFloorQueryVariables>;
export const SafetyReadinessDocument = gql`
    query SafetyReadiness($community: UUID!) {
  safetyReadiness(community: $community) {
    ...SafetyBlockReadiness
    exclusions {
      reason
      label
      count
    }
  }
}
    ${SafetyBlockReadinessFragmentDoc}`;

/**
 * __useSafetyReadinessQuery__
 *
 * To run a query within a React component, call `useSafetyReadinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyReadinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyReadinessQuery({
 *   variables: {
 *      community: // value for 'community'
 *   },
 * });
 */
export function useSafetyReadinessQuery(baseOptions: Apollo.QueryHookOptions<SafetyReadinessQuery, SafetyReadinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyReadinessQuery, SafetyReadinessQueryVariables>(SafetyReadinessDocument, options);
      }
export function useSafetyReadinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyReadinessQuery, SafetyReadinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyReadinessQuery, SafetyReadinessQueryVariables>(SafetyReadinessDocument, options);
        }
export type SafetyReadinessQueryHookResult = ReturnType<typeof useSafetyReadinessQuery>;
export type SafetyReadinessLazyQueryHookResult = ReturnType<typeof useSafetyReadinessLazyQuery>;
export type SafetyReadinessQueryResult = Apollo.QueryResult<SafetyReadinessQuery, SafetyReadinessQueryVariables>;
export const GenerateHomeSafetyFormDocument = gql`
    mutation GenerateHomeSafetyForm($homeId: UUID!, $scope: SafetyPaperFormScope, $recordId: UUID) {
  generateHomeSafetyForm(homeId: $homeId, scope: $scope, recordId: $recordId) {
    pdfBase64
    filename
    residencyId
  }
}
    `;
export type GenerateHomeSafetyFormMutationFn = Apollo.MutationFunction<GenerateHomeSafetyFormMutation, GenerateHomeSafetyFormMutationVariables>;

/**
 * __useGenerateHomeSafetyFormMutation__
 *
 * To run a mutation, you first call `useGenerateHomeSafetyFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateHomeSafetyFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateHomeSafetyFormMutation, { data, loading, error }] = useGenerateHomeSafetyFormMutation({
 *   variables: {
 *      homeId: // value for 'homeId'
 *      scope: // value for 'scope'
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGenerateHomeSafetyFormMutation(baseOptions?: Apollo.MutationHookOptions<GenerateHomeSafetyFormMutation, GenerateHomeSafetyFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateHomeSafetyFormMutation, GenerateHomeSafetyFormMutationVariables>(GenerateHomeSafetyFormDocument, options);
      }
export type GenerateHomeSafetyFormMutationHookResult = ReturnType<typeof useGenerateHomeSafetyFormMutation>;
export type GenerateHomeSafetyFormMutationResult = Apollo.MutationResult<GenerateHomeSafetyFormMutation>;
export type GenerateHomeSafetyFormMutationOptions = Apollo.BaseMutationOptions<GenerateHomeSafetyFormMutation, GenerateHomeSafetyFormMutationVariables>;
export const PaperFormHomeOccupantsDocument = gql`
    query PaperFormHomeOccupants($homeId: UUID!) {
  home(id: $homeId) {
    id
    activeResidency {
      id
      residentSafetyRecords {
        edges {
          node {
            id
            first
            last
            archivedAt
            isAppLinked
          }
        }
      }
    }
  }
}
    `;

/**
 * __usePaperFormHomeOccupantsQuery__
 *
 * To run a query within a React component, call `usePaperFormHomeOccupantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaperFormHomeOccupantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaperFormHomeOccupantsQuery({
 *   variables: {
 *      homeId: // value for 'homeId'
 *   },
 * });
 */
export function usePaperFormHomeOccupantsQuery(baseOptions: Apollo.QueryHookOptions<PaperFormHomeOccupantsQuery, PaperFormHomeOccupantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaperFormHomeOccupantsQuery, PaperFormHomeOccupantsQueryVariables>(PaperFormHomeOccupantsDocument, options);
      }
export function usePaperFormHomeOccupantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaperFormHomeOccupantsQuery, PaperFormHomeOccupantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaperFormHomeOccupantsQuery, PaperFormHomeOccupantsQueryVariables>(PaperFormHomeOccupantsDocument, options);
        }
export type PaperFormHomeOccupantsQueryHookResult = ReturnType<typeof usePaperFormHomeOccupantsQuery>;
export type PaperFormHomeOccupantsLazyQueryHookResult = ReturnType<typeof usePaperFormHomeOccupantsLazyQuery>;
export type PaperFormHomeOccupantsQueryResult = Apollo.QueryResult<PaperFormHomeOccupantsQuery, PaperFormHomeOccupantsQueryVariables>;
export const LegacySafetyPackDocument = gql`
    query LegacySafetyPack($communityId: UUID!) {
  legacySafetyPack(communityId: $communityId) {
    communityId
    communityName
    sibPackUrl
    lastGeneratedAt
    totalHomes
    totalOccupants
    responsiblePerson {
      name
      role
    }
    contacts {
      role
      name
      email
      phone
    }
    blocks {
      name
      shortCode
      totalFloors
      homeCount
      responsiblePerson {
        name
        role
      }
      dutyHolderLabel
      packUrl
      packGeneratedAt
      rows {
        flat
        floor
        assistance
        communication
        eesInPlace
        pcfraInPlace
      }
    }
    documents {
      id
      title
      description
      sibCategory
      sibCategoryLabel
      fileUrl
    }
  }
}
    `;

/**
 * __useLegacySafetyPackQuery__
 *
 * To run a query within a React component, call `useLegacySafetyPackQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacySafetyPackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacySafetyPackQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useLegacySafetyPackQuery(baseOptions: Apollo.QueryHookOptions<LegacySafetyPackQuery, LegacySafetyPackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacySafetyPackQuery, LegacySafetyPackQueryVariables>(LegacySafetyPackDocument, options);
      }
export function useLegacySafetyPackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacySafetyPackQuery, LegacySafetyPackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacySafetyPackQuery, LegacySafetyPackQueryVariables>(LegacySafetyPackDocument, options);
        }
export type LegacySafetyPackQueryHookResult = ReturnType<typeof useLegacySafetyPackQuery>;
export type LegacySafetyPackLazyQueryHookResult = ReturnType<typeof useLegacySafetyPackLazyQuery>;
export type LegacySafetyPackQueryResult = Apollo.QueryResult<LegacySafetyPackQuery, LegacySafetyPackQueryVariables>;
export const LegacySafetyCenterDocumentDocument = gql`
    query LegacySafetyCenterDocument($communityId: UUID!, $id: UUID!) {
  legacySafetyCenterDocument(communityId: $communityId, id: $id) {
    id
    title
    fileUrl
  }
}
    `;

/**
 * __useLegacySafetyCenterDocumentQuery__
 *
 * To run a query within a React component, call `useLegacySafetyCenterDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLegacySafetyCenterDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLegacySafetyCenterDocumentQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLegacySafetyCenterDocumentQuery(baseOptions: Apollo.QueryHookOptions<LegacySafetyCenterDocumentQuery, LegacySafetyCenterDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LegacySafetyCenterDocumentQuery, LegacySafetyCenterDocumentQueryVariables>(LegacySafetyCenterDocumentDocument, options);
      }
export function useLegacySafetyCenterDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LegacySafetyCenterDocumentQuery, LegacySafetyCenterDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LegacySafetyCenterDocumentQuery, LegacySafetyCenterDocumentQueryVariables>(LegacySafetyCenterDocumentDocument, options);
        }
export type LegacySafetyCenterDocumentQueryHookResult = ReturnType<typeof useLegacySafetyCenterDocumentQuery>;
export type LegacySafetyCenterDocumentLazyQueryHookResult = ReturnType<typeof useLegacySafetyCenterDocumentLazyQuery>;
export type LegacySafetyCenterDocumentQueryResult = Apollo.QueryResult<LegacySafetyCenterDocumentQuery, LegacySafetyCenterDocumentQueryVariables>;
export const SafetyRecordAuditLogsDocument = gql`
    query SafetyRecordAuditLogs($id: UUID!) {
  residentSafetyRecord(id: $id) {
    id
    auditLogs(orderBy: "-created_at") {
      edges {
        node {
          id
          eventType
          metadata
          createdAt
          actor {
            id
            name
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSafetyRecordAuditLogsQuery__
 *
 * To run a query within a React component, call `useSafetyRecordAuditLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyRecordAuditLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyRecordAuditLogsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafetyRecordAuditLogsQuery(baseOptions: Apollo.QueryHookOptions<SafetyRecordAuditLogsQuery, SafetyRecordAuditLogsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyRecordAuditLogsQuery, SafetyRecordAuditLogsQueryVariables>(SafetyRecordAuditLogsDocument, options);
      }
export function useSafetyRecordAuditLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyRecordAuditLogsQuery, SafetyRecordAuditLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyRecordAuditLogsQuery, SafetyRecordAuditLogsQueryVariables>(SafetyRecordAuditLogsDocument, options);
        }
export type SafetyRecordAuditLogsQueryHookResult = ReturnType<typeof useSafetyRecordAuditLogsQuery>;
export type SafetyRecordAuditLogsLazyQueryHookResult = ReturnType<typeof useSafetyRecordAuditLogsLazyQuery>;
export type SafetyRecordAuditLogsQueryResult = Apollo.QueryResult<SafetyRecordAuditLogsQuery, SafetyRecordAuditLogsQueryVariables>;
export const SafetyDeclarationHistoryDocument = gql`
    query SafetyDeclarationHistory($recordId: UUID!, $first: Int) {
  residentSafetyRecord(id: $recordId) {
    id
    needsReconciliation
    authoritativeDeclaration {
      id
    }
    declarations(first: $first) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          ...DeclarationHistoryEntry
        }
      }
    }
  }
}
    ${DeclarationHistoryEntryFragmentDoc}`;

/**
 * __useSafetyDeclarationHistoryQuery__
 *
 * To run a query within a React component, call `useSafetyDeclarationHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyDeclarationHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyDeclarationHistoryQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSafetyDeclarationHistoryQuery(baseOptions: Apollo.QueryHookOptions<SafetyDeclarationHistoryQuery, SafetyDeclarationHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyDeclarationHistoryQuery, SafetyDeclarationHistoryQueryVariables>(SafetyDeclarationHistoryDocument, options);
      }
export function useSafetyDeclarationHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyDeclarationHistoryQuery, SafetyDeclarationHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyDeclarationHistoryQuery, SafetyDeclarationHistoryQueryVariables>(SafetyDeclarationHistoryDocument, options);
        }
export type SafetyDeclarationHistoryQueryHookResult = ReturnType<typeof useSafetyDeclarationHistoryQuery>;
export type SafetyDeclarationHistoryLazyQueryHookResult = ReturnType<typeof useSafetyDeclarationHistoryLazyQuery>;
export type SafetyDeclarationHistoryQueryResult = Apollo.QueryResult<SafetyDeclarationHistoryQuery, SafetyDeclarationHistoryQueryVariables>;
export const SafetyCenterRecordDocument = gql`
    query SafetyCenterRecord($id: UUID!) {
  residentSafetyRecord(id: $id) {
    ...SafetyCenterRecordFields
  }
}
    ${SafetyCenterRecordFieldsFragmentDoc}`;

/**
 * __useSafetyCenterRecordQuery__
 *
 * To run a query within a React component, call `useSafetyCenterRecordQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyCenterRecordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyCenterRecordQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSafetyCenterRecordQuery(baseOptions: Apollo.QueryHookOptions<SafetyCenterRecordQuery, SafetyCenterRecordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyCenterRecordQuery, SafetyCenterRecordQueryVariables>(SafetyCenterRecordDocument, options);
      }
export function useSafetyCenterRecordLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyCenterRecordQuery, SafetyCenterRecordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyCenterRecordQuery, SafetyCenterRecordQueryVariables>(SafetyCenterRecordDocument, options);
        }
export type SafetyCenterRecordQueryHookResult = ReturnType<typeof useSafetyCenterRecordQuery>;
export type SafetyCenterRecordLazyQueryHookResult = ReturnType<typeof useSafetyCenterRecordLazyQuery>;
export type SafetyCenterRecordQueryResult = Apollo.QueryResult<SafetyCenterRecordQuery, SafetyCenterRecordQueryVariables>;
export const SafetyReviewRequestsDocument = gql`
    query SafetyReviewRequests($recordId: UUID!) {
  residentSafetyRecord(id: $recordId) {
    id
    isAppLinked
    openReviewRequest {
      ...SafetyReviewRequestDetail
    }
    reviewRequests {
      ...SafetyReviewRequestDetail
    }
  }
}
    ${SafetyReviewRequestDetailFragmentDoc}`;

/**
 * __useSafetyReviewRequestsQuery__
 *
 * To run a query within a React component, call `useSafetyReviewRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafetyReviewRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafetyReviewRequestsQuery({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSafetyReviewRequestsQuery(baseOptions: Apollo.QueryHookOptions<SafetyReviewRequestsQuery, SafetyReviewRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SafetyReviewRequestsQuery, SafetyReviewRequestsQueryVariables>(SafetyReviewRequestsDocument, options);
      }
export function useSafetyReviewRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SafetyReviewRequestsQuery, SafetyReviewRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SafetyReviewRequestsQuery, SafetyReviewRequestsQueryVariables>(SafetyReviewRequestsDocument, options);
        }
export type SafetyReviewRequestsQueryHookResult = ReturnType<typeof useSafetyReviewRequestsQuery>;
export type SafetyReviewRequestsLazyQueryHookResult = ReturnType<typeof useSafetyReviewRequestsLazyQuery>;
export type SafetyReviewRequestsQueryResult = Apollo.QueryResult<SafetyReviewRequestsQuery, SafetyReviewRequestsQueryVariables>;
export const SendSafetyReviewRequestDocument = gql`
    mutation SendSafetyReviewRequest($recordId: UUID!, $channel: SafetyReviewAttemptChannel, $note: String) {
  sendSafetyReviewRequest(recordId: $recordId, channel: $channel, note: $note) {
    reviewRequest {
      ...SafetyReviewRequestDetail
    }
    attempt {
      ...SafetyReviewAttemptEntry
    }
  }
}
    ${SafetyReviewRequestDetailFragmentDoc}
${SafetyReviewAttemptEntryFragmentDoc}`;
export type SendSafetyReviewRequestMutationFn = Apollo.MutationFunction<SendSafetyReviewRequestMutation, SendSafetyReviewRequestMutationVariables>;

/**
 * __useSendSafetyReviewRequestMutation__
 *
 * To run a mutation, you first call `useSendSafetyReviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSafetyReviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSafetyReviewRequestMutation, { data, loading, error }] = useSendSafetyReviewRequestMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *      channel: // value for 'channel'
 *      note: // value for 'note'
 *   },
 * });
 */
export function useSendSafetyReviewRequestMutation(baseOptions?: Apollo.MutationHookOptions<SendSafetyReviewRequestMutation, SendSafetyReviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSafetyReviewRequestMutation, SendSafetyReviewRequestMutationVariables>(SendSafetyReviewRequestDocument, options);
      }
export type SendSafetyReviewRequestMutationHookResult = ReturnType<typeof useSendSafetyReviewRequestMutation>;
export type SendSafetyReviewRequestMutationResult = Apollo.MutationResult<SendSafetyReviewRequestMutation>;
export type SendSafetyReviewRequestMutationOptions = Apollo.BaseMutationOptions<SendSafetyReviewRequestMutation, SendSafetyReviewRequestMutationVariables>;
export const OfferPcfraDocument = gql`
    mutation OfferPcfra($id: UUID!) {
  offerPcfra(id: $id) {
    residentSafetyRecord {
      id
      pcfraOfferedAt
    }
  }
}
    `;
export type OfferPcfraMutationFn = Apollo.MutationFunction<OfferPcfraMutation, OfferPcfraMutationVariables>;

/**
 * __useOfferPcfraMutation__
 *
 * To run a mutation, you first call `useOfferPcfraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferPcfraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerPcfraMutation, { data, loading, error }] = useOfferPcfraMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOfferPcfraMutation(baseOptions?: Apollo.MutationHookOptions<OfferPcfraMutation, OfferPcfraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferPcfraMutation, OfferPcfraMutationVariables>(OfferPcfraDocument, options);
      }
export type OfferPcfraMutationHookResult = ReturnType<typeof useOfferPcfraMutation>;
export type OfferPcfraMutationResult = Apollo.MutationResult<OfferPcfraMutation>;
export type OfferPcfraMutationOptions = Apollo.BaseMutationOptions<OfferPcfraMutation, OfferPcfraMutationVariables>;
export const DeclinePcfraDocument = gql`
    mutation DeclinePcfra($id: UUID!) {
  declinePcfra(id: $id) {
    residentSafetyRecord {
      id
      pcfraDeclinedAt
    }
  }
}
    `;
export type DeclinePcfraMutationFn = Apollo.MutationFunction<DeclinePcfraMutation, DeclinePcfraMutationVariables>;

/**
 * __useDeclinePcfraMutation__
 *
 * To run a mutation, you first call `useDeclinePcfraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclinePcfraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declinePcfraMutation, { data, loading, error }] = useDeclinePcfraMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeclinePcfraMutation(baseOptions?: Apollo.MutationHookOptions<DeclinePcfraMutation, DeclinePcfraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclinePcfraMutation, DeclinePcfraMutationVariables>(DeclinePcfraDocument, options);
      }
export type DeclinePcfraMutationHookResult = ReturnType<typeof useDeclinePcfraMutation>;
export type DeclinePcfraMutationResult = Apollo.MutationResult<DeclinePcfraMutation>;
export type DeclinePcfraMutationOptions = Apollo.BaseMutationOptions<DeclinePcfraMutation, DeclinePcfraMutationVariables>;
export const SendSafetyReminderDocument = gql`
    mutation SendSafetyReminder($recordId: UUID!) {
  sendSafetyReminder(recordId: $recordId) {
    success
  }
}
    `;
export type SendSafetyReminderMutationFn = Apollo.MutationFunction<SendSafetyReminderMutation, SendSafetyReminderMutationVariables>;

/**
 * __useSendSafetyReminderMutation__
 *
 * To run a mutation, you first call `useSendSafetyReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendSafetyReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendSafetyReminderMutation, { data, loading, error }] = useSendSafetyReminderMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useSendSafetyReminderMutation(baseOptions?: Apollo.MutationHookOptions<SendSafetyReminderMutation, SendSafetyReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendSafetyReminderMutation, SendSafetyReminderMutationVariables>(SendSafetyReminderDocument, options);
      }
export type SendSafetyReminderMutationHookResult = ReturnType<typeof useSendSafetyReminderMutation>;
export type SendSafetyReminderMutationResult = Apollo.MutationResult<SendSafetyReminderMutation>;
export type SendSafetyReminderMutationOptions = Apollo.BaseMutationOptions<SendSafetyReminderMutation, SendSafetyReminderMutationVariables>;
export const GenerateEesDocument = gql`
    mutation GenerateEes($id: UUID!) {
  generateEes(id: $id) {
    url
    residentSafetyRecord {
      id
      eesGeneratedAt
      eesAgreedAt
      eesFileUrl
    }
  }
}
    `;
export type GenerateEesMutationFn = Apollo.MutationFunction<GenerateEesMutation, GenerateEesMutationVariables>;

/**
 * __useGenerateEesMutation__
 *
 * To run a mutation, you first call `useGenerateEesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateEesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateEesMutation, { data, loading, error }] = useGenerateEesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateEesMutation(baseOptions?: Apollo.MutationHookOptions<GenerateEesMutation, GenerateEesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateEesMutation, GenerateEesMutationVariables>(GenerateEesDocument, options);
      }
export type GenerateEesMutationHookResult = ReturnType<typeof useGenerateEesMutation>;
export type GenerateEesMutationResult = Apollo.MutationResult<GenerateEesMutation>;
export type GenerateEesMutationOptions = Apollo.BaseMutationOptions<GenerateEesMutation, GenerateEesMutationVariables>;
export const AgreeEesDocument = gql`
    mutation AgreeEes($id: UUID!) {
  agreeEes(id: $id) {
    residentSafetyRecord {
      id
      eesAgreedAt
    }
  }
}
    `;
export type AgreeEesMutationFn = Apollo.MutationFunction<AgreeEesMutation, AgreeEesMutationVariables>;

/**
 * __useAgreeEesMutation__
 *
 * To run a mutation, you first call `useAgreeEesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAgreeEesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [agreeEesMutation, { data, loading, error }] = useAgreeEesMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAgreeEesMutation(baseOptions?: Apollo.MutationHookOptions<AgreeEesMutation, AgreeEesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AgreeEesMutation, AgreeEesMutationVariables>(AgreeEesDocument, options);
      }
export type AgreeEesMutationHookResult = ReturnType<typeof useAgreeEesMutation>;
export type AgreeEesMutationResult = Apollo.MutationResult<AgreeEesMutation>;
export type AgreeEesMutationOptions = Apollo.BaseMutationOptions<AgreeEesMutation, AgreeEesMutationVariables>;
export const GeneratePeepsExportDocument = gql`
    mutation GeneratePeepsExport($blockId: UUID!) {
  generatePeepsExport(blockId: $blockId) {
    url
    qrDataUri
    liveUrl
    occupantCount
  }
}
    `;
export type GeneratePeepsExportMutationFn = Apollo.MutationFunction<GeneratePeepsExportMutation, GeneratePeepsExportMutationVariables>;

/**
 * __useGeneratePeepsExportMutation__
 *
 * To run a mutation, you first call `useGeneratePeepsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePeepsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePeepsExportMutation, { data, loading, error }] = useGeneratePeepsExportMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGeneratePeepsExportMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePeepsExportMutation, GeneratePeepsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePeepsExportMutation, GeneratePeepsExportMutationVariables>(GeneratePeepsExportDocument, options);
      }
export type GeneratePeepsExportMutationHookResult = ReturnType<typeof useGeneratePeepsExportMutation>;
export type GeneratePeepsExportMutationResult = Apollo.MutationResult<GeneratePeepsExportMutation>;
export type GeneratePeepsExportMutationOptions = Apollo.BaseMutationOptions<GeneratePeepsExportMutation, GeneratePeepsExportMutationVariables>;
export const GenerateSibPackDocument = gql`
    mutation GenerateSibPack($blockId: UUID!) {
  generateSibPack(blockId: $blockId) {
    url
    occupantCount
    documentCount
    appendedPdfCount
    pack {
      ...SafetyResponderPackState
    }
    community {
      id
      sibPackUrl
      sibPackStale
      lastSibPackGeneratedAt
      lastSibPackPrintedAt
    }
  }
}
    ${SafetyResponderPackStateFragmentDoc}`;
export type GenerateSibPackMutationFn = Apollo.MutationFunction<GenerateSibPackMutation, GenerateSibPackMutationVariables>;

/**
 * __useGenerateSibPackMutation__
 *
 * To run a mutation, you first call `useGenerateSibPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSibPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSibPackMutation, { data, loading, error }] = useGenerateSibPackMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useGenerateSibPackMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSibPackMutation, GenerateSibPackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSibPackMutation, GenerateSibPackMutationVariables>(GenerateSibPackDocument, options);
      }
export type GenerateSibPackMutationHookResult = ReturnType<typeof useGenerateSibPackMutation>;
export type GenerateSibPackMutationResult = Apollo.MutationResult<GenerateSibPackMutation>;
export type GenerateSibPackMutationOptions = Apollo.BaseMutationOptions<GenerateSibPackMutation, GenerateSibPackMutationVariables>;
export const MarkSibPackPrintedDocument = gql`
    mutation MarkSibPackPrinted($blockId: UUID!) {
  markSibPackPrinted(blockId: $blockId) {
    pack {
      ...SafetyResponderPackState
    }
    community {
      id
      sibPackUrl
      sibPackStale
      lastSibPackGeneratedAt
      lastSibPackPrintedAt
    }
  }
}
    ${SafetyResponderPackStateFragmentDoc}`;
export type MarkSibPackPrintedMutationFn = Apollo.MutationFunction<MarkSibPackPrintedMutation, MarkSibPackPrintedMutationVariables>;

/**
 * __useMarkSibPackPrintedMutation__
 *
 * To run a mutation, you first call `useMarkSibPackPrintedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkSibPackPrintedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markSibPackPrintedMutation, { data, loading, error }] = useMarkSibPackPrintedMutation({
 *   variables: {
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useMarkSibPackPrintedMutation(baseOptions?: Apollo.MutationHookOptions<MarkSibPackPrintedMutation, MarkSibPackPrintedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkSibPackPrintedMutation, MarkSibPackPrintedMutationVariables>(MarkSibPackPrintedDocument, options);
      }
export type MarkSibPackPrintedMutationHookResult = ReturnType<typeof useMarkSibPackPrintedMutation>;
export type MarkSibPackPrintedMutationResult = Apollo.MutationResult<MarkSibPackPrintedMutation>;
export type MarkSibPackPrintedMutationOptions = Apollo.BaseMutationOptions<MarkSibPackPrintedMutation, MarkSibPackPrintedMutationVariables>;
export const GenerateSibPackQrPdfDocument = gql`
    mutation GenerateSibPackQrPdf($communityId: UUID!) {
  generateSibPackQrPdf(communityId: $communityId) {
    pdfBase64
    filename
  }
}
    `;
export type GenerateSibPackQrPdfMutationFn = Apollo.MutationFunction<GenerateSibPackQrPdfMutation, GenerateSibPackQrPdfMutationVariables>;

/**
 * __useGenerateSibPackQrPdfMutation__
 *
 * To run a mutation, you first call `useGenerateSibPackQrPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSibPackQrPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSibPackQrPdfMutation, { data, loading, error }] = useGenerateSibPackQrPdfMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *   },
 * });
 */
export function useGenerateSibPackQrPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSibPackQrPdfMutation, GenerateSibPackQrPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSibPackQrPdfMutation, GenerateSibPackQrPdfMutationVariables>(GenerateSibPackQrPdfDocument, options);
      }
export type GenerateSibPackQrPdfMutationHookResult = ReturnType<typeof useGenerateSibPackQrPdfMutation>;
export type GenerateSibPackQrPdfMutationResult = Apollo.MutationResult<GenerateSibPackQrPdfMutation>;
export type GenerateSibPackQrPdfMutationOptions = Apollo.BaseMutationOptions<GenerateSibPackQrPdfMutation, GenerateSibPackQrPdfMutationVariables>;
export const SetSafetyDocumentInSibPackDocument = gql`
    mutation SetSafetyDocumentInSibPack($id: UUID!, $include: Boolean!) {
  setSafetyDocumentInSibPack(id: $id, include: $include) {
    safetyCenterDocument {
      id
      includeInSibPack
    }
  }
}
    `;
export type SetSafetyDocumentInSibPackMutationFn = Apollo.MutationFunction<SetSafetyDocumentInSibPackMutation, SetSafetyDocumentInSibPackMutationVariables>;

/**
 * __useSetSafetyDocumentInSibPackMutation__
 *
 * To run a mutation, you first call `useSetSafetyDocumentInSibPackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSafetyDocumentInSibPackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSafetyDocumentInSibPackMutation, { data, loading, error }] = useSetSafetyDocumentInSibPackMutation({
 *   variables: {
 *      id: // value for 'id'
 *      include: // value for 'include'
 *   },
 * });
 */
export function useSetSafetyDocumentInSibPackMutation(baseOptions?: Apollo.MutationHookOptions<SetSafetyDocumentInSibPackMutation, SetSafetyDocumentInSibPackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSafetyDocumentInSibPackMutation, SetSafetyDocumentInSibPackMutationVariables>(SetSafetyDocumentInSibPackDocument, options);
      }
export type SetSafetyDocumentInSibPackMutationHookResult = ReturnType<typeof useSetSafetyDocumentInSibPackMutation>;
export type SetSafetyDocumentInSibPackMutationResult = Apollo.MutationResult<SetSafetyDocumentInSibPackMutation>;
export type SetSafetyDocumentInSibPackMutationOptions = Apollo.BaseMutationOptions<SetSafetyDocumentInSibPackMutation, SetSafetyDocumentInSibPackMutationVariables>;
export const SetSafetyDocumentResidentVisibleDocument = gql`
    mutation SetSafetyDocumentResidentVisible($id: UUID!, $visible: Boolean!) {
  setSafetyDocumentResidentVisible(id: $id, visible: $visible) {
    safetyCenterDocument {
      id
      showInSafetyCenter
    }
  }
}
    `;
export type SetSafetyDocumentResidentVisibleMutationFn = Apollo.MutationFunction<SetSafetyDocumentResidentVisibleMutation, SetSafetyDocumentResidentVisibleMutationVariables>;

/**
 * __useSetSafetyDocumentResidentVisibleMutation__
 *
 * To run a mutation, you first call `useSetSafetyDocumentResidentVisibleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSafetyDocumentResidentVisibleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSafetyDocumentResidentVisibleMutation, { data, loading, error }] = useSetSafetyDocumentResidentVisibleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useSetSafetyDocumentResidentVisibleMutation(baseOptions?: Apollo.MutationHookOptions<SetSafetyDocumentResidentVisibleMutation, SetSafetyDocumentResidentVisibleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSafetyDocumentResidentVisibleMutation, SetSafetyDocumentResidentVisibleMutationVariables>(SetSafetyDocumentResidentVisibleDocument, options);
      }
export type SetSafetyDocumentResidentVisibleMutationHookResult = ReturnType<typeof useSetSafetyDocumentResidentVisibleMutation>;
export type SetSafetyDocumentResidentVisibleMutationResult = Apollo.MutationResult<SetSafetyDocumentResidentVisibleMutation>;
export type SetSafetyDocumentResidentVisibleMutationOptions = Apollo.BaseMutationOptions<SetSafetyDocumentResidentVisibleMutation, SetSafetyDocumentResidentVisibleMutationVariables>;
export const GenerateSafetyRecordActivityPdfDocument = gql`
    mutation GenerateSafetyRecordActivityPdf($recordId: UUID!) {
  generateSafetyRecordActivityPdf(recordId: $recordId) {
    pdfBase64
    filename
  }
}
    `;
export type GenerateSafetyRecordActivityPdfMutationFn = Apollo.MutationFunction<GenerateSafetyRecordActivityPdfMutation, GenerateSafetyRecordActivityPdfMutationVariables>;

/**
 * __useGenerateSafetyRecordActivityPdfMutation__
 *
 * To run a mutation, you first call `useGenerateSafetyRecordActivityPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSafetyRecordActivityPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSafetyRecordActivityPdfMutation, { data, loading, error }] = useGenerateSafetyRecordActivityPdfMutation({
 *   variables: {
 *      recordId: // value for 'recordId'
 *   },
 * });
 */
export function useGenerateSafetyRecordActivityPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSafetyRecordActivityPdfMutation, GenerateSafetyRecordActivityPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSafetyRecordActivityPdfMutation, GenerateSafetyRecordActivityPdfMutationVariables>(GenerateSafetyRecordActivityPdfDocument, options);
      }
export type GenerateSafetyRecordActivityPdfMutationHookResult = ReturnType<typeof useGenerateSafetyRecordActivityPdfMutation>;
export type GenerateSafetyRecordActivityPdfMutationResult = Apollo.MutationResult<GenerateSafetyRecordActivityPdfMutation>;
export type GenerateSafetyRecordActivityPdfMutationOptions = Apollo.BaseMutationOptions<GenerateSafetyRecordActivityPdfMutation, GenerateSafetyRecordActivityPdfMutationVariables>;
export const CreateSafetyCenterDocumentDocument = gql`
    mutation CreateSafetyCenterDocument($input: CreateSafetyCenterDocumentInput!) {
  createSafetyCenterDocument(input: $input) {
    safetyCenterDocument {
      id
      title
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSafetyCenterDocumentMutationFn = Apollo.MutationFunction<CreateSafetyCenterDocumentMutation, CreateSafetyCenterDocumentMutationVariables>;

/**
 * __useCreateSafetyCenterDocumentMutation__
 *
 * To run a mutation, you first call `useCreateSafetyCenterDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafetyCenterDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafetyCenterDocumentMutation, { data, loading, error }] = useCreateSafetyCenterDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafetyCenterDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateSafetyCenterDocumentMutation, CreateSafetyCenterDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSafetyCenterDocumentMutation, CreateSafetyCenterDocumentMutationVariables>(CreateSafetyCenterDocumentDocument, options);
      }
export type CreateSafetyCenterDocumentMutationHookResult = ReturnType<typeof useCreateSafetyCenterDocumentMutation>;
export type CreateSafetyCenterDocumentMutationResult = Apollo.MutationResult<CreateSafetyCenterDocumentMutation>;
export type CreateSafetyCenterDocumentMutationOptions = Apollo.BaseMutationOptions<CreateSafetyCenterDocumentMutation, CreateSafetyCenterDocumentMutationVariables>;
export const SetSafetyDocumentBlockDocument = gql`
    mutation SetSafetyDocumentBlock($id: UUID!, $blockId: UUID) {
  setSafetyDocumentBlock(id: $id, blockId: $blockId) {
    safetyCenterDocument {
      id
      block {
        id
        name
      }
    }
  }
}
    `;
export type SetSafetyDocumentBlockMutationFn = Apollo.MutationFunction<SetSafetyDocumentBlockMutation, SetSafetyDocumentBlockMutationVariables>;

/**
 * __useSetSafetyDocumentBlockMutation__
 *
 * To run a mutation, you first call `useSetSafetyDocumentBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSafetyDocumentBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSafetyDocumentBlockMutation, { data, loading, error }] = useSetSafetyDocumentBlockMutation({
 *   variables: {
 *      id: // value for 'id'
 *      blockId: // value for 'blockId'
 *   },
 * });
 */
export function useSetSafetyDocumentBlockMutation(baseOptions?: Apollo.MutationHookOptions<SetSafetyDocumentBlockMutation, SetSafetyDocumentBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSafetyDocumentBlockMutation, SetSafetyDocumentBlockMutationVariables>(SetSafetyDocumentBlockDocument, options);
      }
export type SetSafetyDocumentBlockMutationHookResult = ReturnType<typeof useSetSafetyDocumentBlockMutation>;
export type SetSafetyDocumentBlockMutationResult = Apollo.MutationResult<SetSafetyDocumentBlockMutation>;
export type SetSafetyDocumentBlockMutationOptions = Apollo.BaseMutationOptions<SetSafetyDocumentBlockMutation, SetSafetyDocumentBlockMutationVariables>;
export const ArchiveSafetyCenterDocumentDocument = gql`
    mutation ArchiveSafetyCenterDocument($input: ArchiveSafetyCenterDocumentInput!) {
  archiveSafetyCenterDocument(input: $input) {
    safetyCenterDocument {
      id
      archivedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveSafetyCenterDocumentMutationFn = Apollo.MutationFunction<ArchiveSafetyCenterDocumentMutation, ArchiveSafetyCenterDocumentMutationVariables>;

/**
 * __useArchiveSafetyCenterDocumentMutation__
 *
 * To run a mutation, you first call `useArchiveSafetyCenterDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSafetyCenterDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSafetyCenterDocumentMutation, { data, loading, error }] = useArchiveSafetyCenterDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSafetyCenterDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSafetyCenterDocumentMutation, ArchiveSafetyCenterDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSafetyCenterDocumentMutation, ArchiveSafetyCenterDocumentMutationVariables>(ArchiveSafetyCenterDocumentDocument, options);
      }
export type ArchiveSafetyCenterDocumentMutationHookResult = ReturnType<typeof useArchiveSafetyCenterDocumentMutation>;
export type ArchiveSafetyCenterDocumentMutationResult = Apollo.MutationResult<ArchiveSafetyCenterDocumentMutation>;
export type ArchiveSafetyCenterDocumentMutationOptions = Apollo.BaseMutationOptions<ArchiveSafetyCenterDocumentMutation, ArchiveSafetyCenterDocumentMutationVariables>;
export const GenerateSafetyDocumentQrPdfDocument = gql`
    mutation GenerateSafetyDocumentQrPdf($id: UUID!) {
  generateSafetyDocumentQrPdf(id: $id) {
    pdfBase64
    filename
  }
}
    `;
export type GenerateSafetyDocumentQrPdfMutationFn = Apollo.MutationFunction<GenerateSafetyDocumentQrPdfMutation, GenerateSafetyDocumentQrPdfMutationVariables>;

/**
 * __useGenerateSafetyDocumentQrPdfMutation__
 *
 * To run a mutation, you first call `useGenerateSafetyDocumentQrPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSafetyDocumentQrPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSafetyDocumentQrPdfMutation, { data, loading, error }] = useGenerateSafetyDocumentQrPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateSafetyDocumentQrPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSafetyDocumentQrPdfMutation, GenerateSafetyDocumentQrPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSafetyDocumentQrPdfMutation, GenerateSafetyDocumentQrPdfMutationVariables>(GenerateSafetyDocumentQrPdfDocument, options);
      }
export type GenerateSafetyDocumentQrPdfMutationHookResult = ReturnType<typeof useGenerateSafetyDocumentQrPdfMutation>;
export type GenerateSafetyDocumentQrPdfMutationResult = Apollo.MutationResult<GenerateSafetyDocumentQrPdfMutation>;
export type GenerateSafetyDocumentQrPdfMutationOptions = Apollo.BaseMutationOptions<GenerateSafetyDocumentQrPdfMutation, GenerateSafetyDocumentQrPdfMutationVariables>;
export const UpdateBlockSafetyIdentityDocument = gql`
    mutation UpdateBlockSafetyIdentity($input: UpdateBlockSafetyIdentityInput!) {
  updateBlockSafetyIdentity(input: $input) {
    block {
      id
      responsiblePersonName
      responsiblePersonRole
      hrbReference
      dutyHolderLabel
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateBlockSafetyIdentityMutationFn = Apollo.MutationFunction<UpdateBlockSafetyIdentityMutation, UpdateBlockSafetyIdentityMutationVariables>;

/**
 * __useUpdateBlockSafetyIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateBlockSafetyIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBlockSafetyIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBlockSafetyIdentityMutation, { data, loading, error }] = useUpdateBlockSafetyIdentityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBlockSafetyIdentityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBlockSafetyIdentityMutation, UpdateBlockSafetyIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBlockSafetyIdentityMutation, UpdateBlockSafetyIdentityMutationVariables>(UpdateBlockSafetyIdentityDocument, options);
      }
export type UpdateBlockSafetyIdentityMutationHookResult = ReturnType<typeof useUpdateBlockSafetyIdentityMutation>;
export type UpdateBlockSafetyIdentityMutationResult = Apollo.MutationResult<UpdateBlockSafetyIdentityMutation>;
export type UpdateBlockSafetyIdentityMutationOptions = Apollo.BaseMutationOptions<UpdateBlockSafetyIdentityMutation, UpdateBlockSafetyIdentityMutationVariables>;
export const UpdateCommunitySibPackReviewSettingsDocument = gql`
    mutation UpdateCommunitySibPackReviewSettings($communityId: UUID!, $sibPackReviewRemindersEnabled: Boolean, $sibPackReviewNudgeMonths: Int) {
  updateCommunitySibPackReviewSettings(
    communityId: $communityId
    sibPackReviewRemindersEnabled: $sibPackReviewRemindersEnabled
    sibPackReviewNudgeMonths: $sibPackReviewNudgeMonths
  ) {
    community {
      id
      settings {
        sibPackReviewRemindersEnabled
        sibPackReviewNudgeMonths
      }
    }
  }
}
    `;
export type UpdateCommunitySibPackReviewSettingsMutationFn = Apollo.MutationFunction<UpdateCommunitySibPackReviewSettingsMutation, UpdateCommunitySibPackReviewSettingsMutationVariables>;

/**
 * __useUpdateCommunitySibPackReviewSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateCommunitySibPackReviewSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommunitySibPackReviewSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommunitySibPackReviewSettingsMutation, { data, loading, error }] = useUpdateCommunitySibPackReviewSettingsMutation({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      sibPackReviewRemindersEnabled: // value for 'sibPackReviewRemindersEnabled'
 *      sibPackReviewNudgeMonths: // value for 'sibPackReviewNudgeMonths'
 *   },
 * });
 */
export function useUpdateCommunitySibPackReviewSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommunitySibPackReviewSettingsMutation, UpdateCommunitySibPackReviewSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommunitySibPackReviewSettingsMutation, UpdateCommunitySibPackReviewSettingsMutationVariables>(UpdateCommunitySibPackReviewSettingsDocument, options);
      }
export type UpdateCommunitySibPackReviewSettingsMutationHookResult = ReturnType<typeof useUpdateCommunitySibPackReviewSettingsMutation>;
export type UpdateCommunitySibPackReviewSettingsMutationResult = Apollo.MutationResult<UpdateCommunitySibPackReviewSettingsMutation>;
export type UpdateCommunitySibPackReviewSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateCommunitySibPackReviewSettingsMutation, UpdateCommunitySibPackReviewSettingsMutationVariables>;
export const ArchiveSafetySubjectDocument = gql`
    mutation ArchiveSafetySubject($input: ArchiveSafetySubjectInput!) {
  archiveSafetySubject(input: $input) {
    residentSafetyRecord {
      id
      archivedAt
      lifecycleStatus
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ArchiveSafetySubjectMutationFn = Apollo.MutationFunction<ArchiveSafetySubjectMutation, ArchiveSafetySubjectMutationVariables>;

/**
 * __useArchiveSafetySubjectMutation__
 *
 * To run a mutation, you first call `useArchiveSafetySubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveSafetySubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveSafetySubjectMutation, { data, loading, error }] = useArchiveSafetySubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveSafetySubjectMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveSafetySubjectMutation, ArchiveSafetySubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveSafetySubjectMutation, ArchiveSafetySubjectMutationVariables>(ArchiveSafetySubjectDocument, options);
      }
export type ArchiveSafetySubjectMutationHookResult = ReturnType<typeof useArchiveSafetySubjectMutation>;
export type ArchiveSafetySubjectMutationResult = Apollo.MutationResult<ArchiveSafetySubjectMutation>;
export type ArchiveSafetySubjectMutationOptions = Apollo.BaseMutationOptions<ArchiveSafetySubjectMutation, ArchiveSafetySubjectMutationVariables>;
export const LinkSafetySubjectDocument = gql`
    mutation LinkSafetySubject($input: LinkSafetySubjectInput!) {
  linkSafetySubject(input: $input) {
    residentSafetyRecord {
      id
      first
      last
      isAppLinked
      contactEmail
      linkSuggestions {
        userId
        email
        name
      }
      user {
        id
        firstName
        lastName
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type LinkSafetySubjectMutationFn = Apollo.MutationFunction<LinkSafetySubjectMutation, LinkSafetySubjectMutationVariables>;

/**
 * __useLinkSafetySubjectMutation__
 *
 * To run a mutation, you first call `useLinkSafetySubjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkSafetySubjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkSafetySubjectMutation, { data, loading, error }] = useLinkSafetySubjectMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkSafetySubjectMutation(baseOptions?: Apollo.MutationHookOptions<LinkSafetySubjectMutation, LinkSafetySubjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkSafetySubjectMutation, LinkSafetySubjectMutationVariables>(LinkSafetySubjectDocument, options);
      }
export type LinkSafetySubjectMutationHookResult = ReturnType<typeof useLinkSafetySubjectMutation>;
export type LinkSafetySubjectMutationResult = Apollo.MutationResult<LinkSafetySubjectMutation>;
export type LinkSafetySubjectMutationOptions = Apollo.BaseMutationOptions<LinkSafetySubjectMutation, LinkSafetySubjectMutationVariables>;
export const SetSafetySubjectContactEmailDocument = gql`
    mutation SetSafetySubjectContactEmail($input: SetSafetySubjectContactEmailInput!) {
  setSafetySubjectContactEmail(input: $input) {
    residentSafetyRecord {
      id
      contactEmail
      linkSuggestions {
        userId
        email
        name
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SetSafetySubjectContactEmailMutationFn = Apollo.MutationFunction<SetSafetySubjectContactEmailMutation, SetSafetySubjectContactEmailMutationVariables>;

/**
 * __useSetSafetySubjectContactEmailMutation__
 *
 * To run a mutation, you first call `useSetSafetySubjectContactEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSafetySubjectContactEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSafetySubjectContactEmailMutation, { data, loading, error }] = useSetSafetySubjectContactEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetSafetySubjectContactEmailMutation(baseOptions?: Apollo.MutationHookOptions<SetSafetySubjectContactEmailMutation, SetSafetySubjectContactEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSafetySubjectContactEmailMutation, SetSafetySubjectContactEmailMutationVariables>(SetSafetySubjectContactEmailDocument, options);
      }
export type SetSafetySubjectContactEmailMutationHookResult = ReturnType<typeof useSetSafetySubjectContactEmailMutation>;
export type SetSafetySubjectContactEmailMutationResult = Apollo.MutationResult<SetSafetySubjectContactEmailMutation>;
export type SetSafetySubjectContactEmailMutationOptions = Apollo.BaseMutationOptions<SetSafetySubjectContactEmailMutation, SetSafetySubjectContactEmailMutationVariables>;
export const CreateManagerSafetyDeclarationDocument = gql`
    mutation CreateManagerSafetyDeclaration($input: CreateManagerSafetyDeclarationInput!) {
  createManagerSafetyDeclaration(input: $input) {
    needsReconciliation
    residentSafetyRecord {
      ...SafetyCenterRecordFields
    }
    declaration {
      id
      origin
      declaredAt
    }
  }
}
    ${SafetyCenterRecordFieldsFragmentDoc}`;
export type CreateManagerSafetyDeclarationMutationFn = Apollo.MutationFunction<CreateManagerSafetyDeclarationMutation, CreateManagerSafetyDeclarationMutationVariables>;

/**
 * __useCreateManagerSafetyDeclarationMutation__
 *
 * To run a mutation, you first call `useCreateManagerSafetyDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateManagerSafetyDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createManagerSafetyDeclarationMutation, { data, loading, error }] = useCreateManagerSafetyDeclarationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateManagerSafetyDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<CreateManagerSafetyDeclarationMutation, CreateManagerSafetyDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateManagerSafetyDeclarationMutation, CreateManagerSafetyDeclarationMutationVariables>(CreateManagerSafetyDeclarationDocument, options);
      }
export type CreateManagerSafetyDeclarationMutationHookResult = ReturnType<typeof useCreateManagerSafetyDeclarationMutation>;
export type CreateManagerSafetyDeclarationMutationResult = Apollo.MutationResult<CreateManagerSafetyDeclarationMutation>;
export type CreateManagerSafetyDeclarationMutationOptions = Apollo.BaseMutationOptions<CreateManagerSafetyDeclarationMutation, CreateManagerSafetyDeclarationMutationVariables>;
export const GiveFireServiceConsentDocument = gql`
    mutation GiveFireServiceConsent($id: UUID!, $channel: SafetyComplianceChannel, $authority: SafetyComplianceAuthority, $representativeName: String) {
  giveFireServiceConsent(
    id: $id
    channel: $channel
    authority: $authority
    representativeName: $representativeName
  ) {
    residentSafetyRecord {
      id
      fireServiceConsentGivenAt
      fireServiceConsentWithdrawnAt
      sharesWithFireService
    }
  }
}
    `;
export type GiveFireServiceConsentMutationFn = Apollo.MutationFunction<GiveFireServiceConsentMutation, GiveFireServiceConsentMutationVariables>;

/**
 * __useGiveFireServiceConsentMutation__
 *
 * To run a mutation, you first call `useGiveFireServiceConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGiveFireServiceConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [giveFireServiceConsentMutation, { data, loading, error }] = useGiveFireServiceConsentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      authority: // value for 'authority'
 *      representativeName: // value for 'representativeName'
 *   },
 * });
 */
export function useGiveFireServiceConsentMutation(baseOptions?: Apollo.MutationHookOptions<GiveFireServiceConsentMutation, GiveFireServiceConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GiveFireServiceConsentMutation, GiveFireServiceConsentMutationVariables>(GiveFireServiceConsentDocument, options);
      }
export type GiveFireServiceConsentMutationHookResult = ReturnType<typeof useGiveFireServiceConsentMutation>;
export type GiveFireServiceConsentMutationResult = Apollo.MutationResult<GiveFireServiceConsentMutation>;
export type GiveFireServiceConsentMutationOptions = Apollo.BaseMutationOptions<GiveFireServiceConsentMutation, GiveFireServiceConsentMutationVariables>;
export const WithdrawFireServiceConsentDocument = gql`
    mutation WithdrawFireServiceConsent($id: UUID!, $channel: SafetyComplianceChannel, $reason: String) {
  withdrawFireServiceConsent(id: $id, channel: $channel, reason: $reason) {
    residentSafetyRecord {
      id
      fireServiceConsentGivenAt
      fireServiceConsentWithdrawnAt
      sharesWithFireService
    }
  }
}
    `;
export type WithdrawFireServiceConsentMutationFn = Apollo.MutationFunction<WithdrawFireServiceConsentMutation, WithdrawFireServiceConsentMutationVariables>;

/**
 * __useWithdrawFireServiceConsentMutation__
 *
 * To run a mutation, you first call `useWithdrawFireServiceConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useWithdrawFireServiceConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [withdrawFireServiceConsentMutation, { data, loading, error }] = useWithdrawFireServiceConsentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      channel: // value for 'channel'
 *      reason: // value for 'reason'
 *   },
 * });
 */
export function useWithdrawFireServiceConsentMutation(baseOptions?: Apollo.MutationHookOptions<WithdrawFireServiceConsentMutation, WithdrawFireServiceConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<WithdrawFireServiceConsentMutation, WithdrawFireServiceConsentMutationVariables>(WithdrawFireServiceConsentDocument, options);
      }
export type WithdrawFireServiceConsentMutationHookResult = ReturnType<typeof useWithdrawFireServiceConsentMutation>;
export type WithdrawFireServiceConsentMutationResult = Apollo.MutationResult<WithdrawFireServiceConsentMutation>;
export type WithdrawFireServiceConsentMutationOptions = Apollo.BaseMutationOptions<WithdrawFireServiceConsentMutation, WithdrawFireServiceConsentMutationVariables>;
export const ReconcileSafetyDeclarationDocument = gql`
    mutation ReconcileSafetyDeclaration($id: UUID!) {
  reconcileSafetyDeclaration(id: $id) {
    residentSafetyDeclaration {
      id
      isAuthoritative
    }
    residentSafetyRecord {
      id
      needsReconciliation
      ...SafetyCenterRecordFields
    }
  }
}
    ${SafetyCenterRecordFieldsFragmentDoc}`;
export type ReconcileSafetyDeclarationMutationFn = Apollo.MutationFunction<ReconcileSafetyDeclarationMutation, ReconcileSafetyDeclarationMutationVariables>;

/**
 * __useReconcileSafetyDeclarationMutation__
 *
 * To run a mutation, you first call `useReconcileSafetyDeclarationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileSafetyDeclarationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileSafetyDeclarationMutation, { data, loading, error }] = useReconcileSafetyDeclarationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReconcileSafetyDeclarationMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileSafetyDeclarationMutation, ReconcileSafetyDeclarationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileSafetyDeclarationMutation, ReconcileSafetyDeclarationMutationVariables>(ReconcileSafetyDeclarationDocument, options);
      }
export type ReconcileSafetyDeclarationMutationHookResult = ReturnType<typeof useReconcileSafetyDeclarationMutation>;
export type ReconcileSafetyDeclarationMutationResult = Apollo.MutationResult<ReconcileSafetyDeclarationMutation>;
export type ReconcileSafetyDeclarationMutationOptions = Apollo.BaseMutationOptions<ReconcileSafetyDeclarationMutation, ReconcileSafetyDeclarationMutationVariables>;
export const RespondToPcfraDocument = gql`
    mutation RespondToPcfra($id: UUID!, $accepted: Boolean!, $channel: SafetyComplianceChannel, $authority: SafetyComplianceAuthority) {
  respondToPcfra(
    id: $id
    accepted: $accepted
    channel: $channel
    authority: $authority
  ) {
    residentSafetyRecord {
      id
      pcfraAcceptedAt
      pcfraDeclinedAt
      pcfraParticipation
    }
  }
}
    `;
export type RespondToPcfraMutationFn = Apollo.MutationFunction<RespondToPcfraMutation, RespondToPcfraMutationVariables>;

/**
 * __useRespondToPcfraMutation__
 *
 * To run a mutation, you first call `useRespondToPcfraMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRespondToPcfraMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [respondToPcfraMutation, { data, loading, error }] = useRespondToPcfraMutation({
 *   variables: {
 *      id: // value for 'id'
 *      accepted: // value for 'accepted'
 *      channel: // value for 'channel'
 *      authority: // value for 'authority'
 *   },
 * });
 */
export function useRespondToPcfraMutation(baseOptions?: Apollo.MutationHookOptions<RespondToPcfraMutation, RespondToPcfraMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RespondToPcfraMutation, RespondToPcfraMutationVariables>(RespondToPcfraDocument, options);
      }
export type RespondToPcfraMutationHookResult = ReturnType<typeof useRespondToPcfraMutation>;
export type RespondToPcfraMutationResult = Apollo.MutationResult<RespondToPcfraMutation>;
export type RespondToPcfraMutationOptions = Apollo.BaseMutationOptions<RespondToPcfraMutation, RespondToPcfraMutationVariables>;
export const CloseSurveyDocument = gql`
    mutation CloseSurvey($id: UUID!) {
  closeSurvey(id: $id) {
    survey {
      id
      status
    }
  }
}
    `;
export type CloseSurveyMutationFn = Apollo.MutationFunction<CloseSurveyMutation, CloseSurveyMutationVariables>;

/**
 * __useCloseSurveyMutation__
 *
 * To run a mutation, you first call `useCloseSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeSurveyMutation, { data, loading, error }] = useCloseSurveyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloseSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CloseSurveyMutation, CloseSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseSurveyMutation, CloseSurveyMutationVariables>(CloseSurveyDocument, options);
      }
export type CloseSurveyMutationHookResult = ReturnType<typeof useCloseSurveyMutation>;
export type CloseSurveyMutationResult = Apollo.MutationResult<CloseSurveyMutation>;
export type CloseSurveyMutationOptions = Apollo.BaseMutationOptions<CloseSurveyMutation, CloseSurveyMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
    question
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const FindSurveyDocument = gql`
    query FindSurvey($id: UUID!) {
  survey(id: $id) {
    id
    question
    createdAt
    status
    link
    totalResidents
    options {
      id
      option
      totalResidents
      residents {
        id
        homeName
        user {
          id
          name
          email
        }
      }
    }
    groups {
      edges {
        node {
          id
          name
          community {
            id
            name
          }
        }
      }
    }
    answers {
      id
    }
  }
}
    `;

/**
 * __useFindSurveyQuery__
 *
 * To run a query within a React component, call `useFindSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindSurveyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFindSurveyQuery(baseOptions: Apollo.QueryHookOptions<FindSurveyQuery, FindSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindSurveyQuery, FindSurveyQueryVariables>(FindSurveyDocument, options);
      }
export function useFindSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindSurveyQuery, FindSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindSurveyQuery, FindSurveyQueryVariables>(FindSurveyDocument, options);
        }
export type FindSurveyQueryHookResult = ReturnType<typeof useFindSurveyQuery>;
export type FindSurveyLazyQueryHookResult = ReturnType<typeof useFindSurveyLazyQuery>;
export type FindSurveyQueryResult = Apollo.QueryResult<FindSurveyQuery, FindSurveyQueryVariables>;
export const SurveyResultsCsvDocument = gql`
    query SurveyResultsCsv($id: UUID!) {
  survey(id: $id) {
    rawCsv
  }
}
    `;

/**
 * __useSurveyResultsCsvQuery__
 *
 * To run a query within a React component, call `useSurveyResultsCsvQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyResultsCsvQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyResultsCsvQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyResultsCsvQuery(baseOptions: Apollo.QueryHookOptions<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>(SurveyResultsCsvDocument, options);
      }
export function useSurveyResultsCsvLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>(SurveyResultsCsvDocument, options);
        }
export type SurveyResultsCsvQueryHookResult = ReturnType<typeof useSurveyResultsCsvQuery>;
export type SurveyResultsCsvLazyQueryHookResult = ReturnType<typeof useSurveyResultsCsvLazyQuery>;
export type SurveyResultsCsvQueryResult = Apollo.QueryResult<SurveyResultsCsvQuery, SurveyResultsCsvQueryVariables>;
export const ListResidentSurveyDocument = gql`
    query ListResidentSurvey($communities: [ID], $communityGroups: [ID], $after: String, $orderBy: String, $search: String, $type: [String]) {
  surveys(
    communities: $communities
    communityGroups: $communityGroups
    after: $after
    orderBy: $orderBy
    search: $search
    type: $type
  ) {
    edges {
      node {
        ...SurveyItem
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${SurveyItemFragmentDoc}`;

/**
 * __useListResidentSurveyQuery__
 *
 * To run a query within a React component, call `useListResidentSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useListResidentSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListResidentSurveyQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      communityGroups: // value for 'communityGroups'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useListResidentSurveyQuery(baseOptions?: Apollo.QueryHookOptions<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>(ListResidentSurveyDocument, options);
      }
export function useListResidentSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>(ListResidentSurveyDocument, options);
        }
export type ListResidentSurveyQueryHookResult = ReturnType<typeof useListResidentSurveyQuery>;
export type ListResidentSurveyLazyQueryHookResult = ReturnType<typeof useListResidentSurveyLazyQuery>;
export type ListResidentSurveyQueryResult = Apollo.QueryResult<ListResidentSurveyQuery, ListResidentSurveyQueryVariables>;
export const AssignClientTagToTaskDefinitionDocument = gql`
    mutation AssignClientTagToTaskDefinition($input: AssignClientTagToTaskDefinitionInput!) {
  assignClientTagToTaskDefinition(input: $input) {
    tagAssignment {
      id
      tag {
        id
        name
        color
      }
    }
    taskDefinition {
      id
      tagAssignments {
        edges {
          node {
            id
            tag {
              id
              name
              color
            }
          }
        }
      }
    }
  }
}
    `;
export type AssignClientTagToTaskDefinitionMutationFn = Apollo.MutationFunction<AssignClientTagToTaskDefinitionMutation, AssignClientTagToTaskDefinitionMutationVariables>;

/**
 * __useAssignClientTagToTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useAssignClientTagToTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignClientTagToTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignClientTagToTaskDefinitionMutation, { data, loading, error }] = useAssignClientTagToTaskDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignClientTagToTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<AssignClientTagToTaskDefinitionMutation, AssignClientTagToTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignClientTagToTaskDefinitionMutation, AssignClientTagToTaskDefinitionMutationVariables>(AssignClientTagToTaskDefinitionDocument, options);
      }
export type AssignClientTagToTaskDefinitionMutationHookResult = ReturnType<typeof useAssignClientTagToTaskDefinitionMutation>;
export type AssignClientTagToTaskDefinitionMutationResult = Apollo.MutationResult<AssignClientTagToTaskDefinitionMutation>;
export type AssignClientTagToTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<AssignClientTagToTaskDefinitionMutation, AssignClientTagToTaskDefinitionMutationVariables>;
export const AssignTaskDocument = gql`
    mutation AssignTask($input: AssignTaskInput!) {
  assignTask(input: $input) {
    task {
      id
      assignedUser {
        id
        name
        email
        displayPicture
      }
      updates {
        edges {
          node {
            ...TaskUpdate
          }
        }
      }
    }
  }
}
    ${TaskUpdateFragmentDoc}`;
export type AssignTaskMutationFn = Apollo.MutationFunction<AssignTaskMutation, AssignTaskMutationVariables>;

/**
 * __useAssignTaskMutation__
 *
 * To run a mutation, you first call `useAssignTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignTaskMutation, { data, loading, error }] = useAssignTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignTaskMutation(baseOptions?: Apollo.MutationHookOptions<AssignTaskMutation, AssignTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignTaskMutation, AssignTaskMutationVariables>(AssignTaskDocument, options);
      }
export type AssignTaskMutationHookResult = ReturnType<typeof useAssignTaskMutation>;
export type AssignTaskMutationResult = Apollo.MutationResult<AssignTaskMutation>;
export type AssignTaskMutationOptions = Apollo.BaseMutationOptions<AssignTaskMutation, AssignTaskMutationVariables>;
export const AsanaPendingTasksDocument = gql`
    query AsanaPendingTasks($communityIds: [String!]!) {
  asanaPendingTasks(communityIds: $communityIds) {
    edges {
      node {
        ...AsanaPendingTaskCard
      }
    }
  }
}
    ${AsanaPendingTaskCardFragmentDoc}`;

/**
 * __useAsanaPendingTasksQuery__
 *
 * To run a query within a React component, call `useAsanaPendingTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsanaPendingTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsanaPendingTasksQuery({
 *   variables: {
 *      communityIds: // value for 'communityIds'
 *   },
 * });
 */
export function useAsanaPendingTasksQuery(baseOptions: Apollo.QueryHookOptions<AsanaPendingTasksQuery, AsanaPendingTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsanaPendingTasksQuery, AsanaPendingTasksQueryVariables>(AsanaPendingTasksDocument, options);
      }
export function useAsanaPendingTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsanaPendingTasksQuery, AsanaPendingTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsanaPendingTasksQuery, AsanaPendingTasksQueryVariables>(AsanaPendingTasksDocument, options);
        }
export type AsanaPendingTasksQueryHookResult = ReturnType<typeof useAsanaPendingTasksQuery>;
export type AsanaPendingTasksLazyQueryHookResult = ReturnType<typeof useAsanaPendingTasksLazyQuery>;
export type AsanaPendingTasksQueryResult = Apollo.QueryResult<AsanaPendingTasksQuery, AsanaPendingTasksQueryVariables>;
export const AsanaPendingTasksCountDocument = gql`
    query AsanaPendingTasksCount($communityIds: [String!]!) {
  asanaPendingTasksCount(communityIds: $communityIds)
}
    `;

/**
 * __useAsanaPendingTasksCountQuery__
 *
 * To run a query within a React component, call `useAsanaPendingTasksCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAsanaPendingTasksCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAsanaPendingTasksCountQuery({
 *   variables: {
 *      communityIds: // value for 'communityIds'
 *   },
 * });
 */
export function useAsanaPendingTasksCountQuery(baseOptions: Apollo.QueryHookOptions<AsanaPendingTasksCountQuery, AsanaPendingTasksCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AsanaPendingTasksCountQuery, AsanaPendingTasksCountQueryVariables>(AsanaPendingTasksCountDocument, options);
      }
export function useAsanaPendingTasksCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AsanaPendingTasksCountQuery, AsanaPendingTasksCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AsanaPendingTasksCountQuery, AsanaPendingTasksCountQueryVariables>(AsanaPendingTasksCountDocument, options);
        }
export type AsanaPendingTasksCountQueryHookResult = ReturnType<typeof useAsanaPendingTasksCountQuery>;
export type AsanaPendingTasksCountLazyQueryHookResult = ReturnType<typeof useAsanaPendingTasksCountLazyQuery>;
export type AsanaPendingTasksCountQueryResult = Apollo.QueryResult<AsanaPendingTasksCountQuery, AsanaPendingTasksCountQueryVariables>;
export const AcceptAsanaPendingTaskDocument = gql`
    mutation AcceptAsanaPendingTask($input: AcceptAsanaPendingTaskInput!) {
  acceptAsanaPendingTask(input: $input) {
    task {
      id
    }
    pending {
      id
      status
    }
  }
}
    `;
export type AcceptAsanaPendingTaskMutationFn = Apollo.MutationFunction<AcceptAsanaPendingTaskMutation, AcceptAsanaPendingTaskMutationVariables>;

/**
 * __useAcceptAsanaPendingTaskMutation__
 *
 * To run a mutation, you first call `useAcceptAsanaPendingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAsanaPendingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAsanaPendingTaskMutation, { data, loading, error }] = useAcceptAsanaPendingTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcceptAsanaPendingTaskMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAsanaPendingTaskMutation, AcceptAsanaPendingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAsanaPendingTaskMutation, AcceptAsanaPendingTaskMutationVariables>(AcceptAsanaPendingTaskDocument, options);
      }
export type AcceptAsanaPendingTaskMutationHookResult = ReturnType<typeof useAcceptAsanaPendingTaskMutation>;
export type AcceptAsanaPendingTaskMutationResult = Apollo.MutationResult<AcceptAsanaPendingTaskMutation>;
export type AcceptAsanaPendingTaskMutationOptions = Apollo.BaseMutationOptions<AcceptAsanaPendingTaskMutation, AcceptAsanaPendingTaskMutationVariables>;
export const DismissAsanaPendingTaskDocument = gql`
    mutation DismissAsanaPendingTask($input: DismissAsanaPendingTaskInput!) {
  dismissAsanaPendingTask(input: $input) {
    pending {
      id
      status
    }
  }
}
    `;
export type DismissAsanaPendingTaskMutationFn = Apollo.MutationFunction<DismissAsanaPendingTaskMutation, DismissAsanaPendingTaskMutationVariables>;

/**
 * __useDismissAsanaPendingTaskMutation__
 *
 * To run a mutation, you first call `useDismissAsanaPendingTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissAsanaPendingTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissAsanaPendingTaskMutation, { data, loading, error }] = useDismissAsanaPendingTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDismissAsanaPendingTaskMutation(baseOptions?: Apollo.MutationHookOptions<DismissAsanaPendingTaskMutation, DismissAsanaPendingTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissAsanaPendingTaskMutation, DismissAsanaPendingTaskMutationVariables>(DismissAsanaPendingTaskDocument, options);
      }
export type DismissAsanaPendingTaskMutationHookResult = ReturnType<typeof useDismissAsanaPendingTaskMutation>;
export type DismissAsanaPendingTaskMutationResult = Apollo.MutationResult<DismissAsanaPendingTaskMutation>;
export type DismissAsanaPendingTaskMutationOptions = Apollo.BaseMutationOptions<DismissAsanaPendingTaskMutation, DismissAsanaPendingTaskMutationVariables>;
export const CreateTaskGroupDocument = gql`
    mutation CreateTaskGroup($input: CreateTaskGroupInput!) {
  createTaskGroup(input: $input) {
    taskGroup {
      id
      name
      schedule
      isActive
      taskTemplate {
        id
        name
      }
      tasks(first: 1) {
        edges {
          node {
            id
            taskDefinition {
              id
            }
          }
        }
      }
    }
    tasksCreatedCount
  }
}
    `;
export type CreateTaskGroupMutationFn = Apollo.MutationFunction<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>;

/**
 * __useCreateTaskGroupMutation__
 *
 * To run a mutation, you first call `useCreateTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskGroupMutation, { data, loading, error }] = useCreateTaskGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>(CreateTaskGroupDocument, options);
      }
export type CreateTaskGroupMutationHookResult = ReturnType<typeof useCreateTaskGroupMutation>;
export type CreateTaskGroupMutationResult = Apollo.MutationResult<CreateTaskGroupMutation>;
export type CreateTaskGroupMutationOptions = Apollo.BaseMutationOptions<CreateTaskGroupMutation, CreateTaskGroupMutationVariables>;
export const TaskCategoriesDocument = gql`
    query TaskCategories {
  taskCategories {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useTaskCategoriesQuery__
 *
 * To run a query within a React component, call `useTaskCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTaskCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<TaskCategoriesQuery, TaskCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskCategoriesQuery, TaskCategoriesQueryVariables>(TaskCategoriesDocument, options);
      }
export function useTaskCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskCategoriesQuery, TaskCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskCategoriesQuery, TaskCategoriesQueryVariables>(TaskCategoriesDocument, options);
        }
export type TaskCategoriesQueryHookResult = ReturnType<typeof useTaskCategoriesQuery>;
export type TaskCategoriesLazyQueryHookResult = ReturnType<typeof useTaskCategoriesLazyQuery>;
export type TaskCategoriesQueryResult = Apollo.QueryResult<TaskCategoriesQuery, TaskCategoriesQueryVariables>;
export const CreateTaskDefinitionDocument = gql`
    mutation CreateTaskDefinition($input: CreateTaskDefinitionInput!) {
  createTaskDefinition(input: $input) {
    taskDefinition {
      id
      name
    }
    task {
      ...TaskItem
    }
  }
}
    ${TaskItemFragmentDoc}`;
export type CreateTaskDefinitionMutationFn = Apollo.MutationFunction<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;

/**
 * __useCreateTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskDefinitionMutation, { data, loading, error }] = useCreateTaskDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>(CreateTaskDefinitionDocument, options);
      }
export type CreateTaskDefinitionMutationHookResult = ReturnType<typeof useCreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationResult = Apollo.MutationResult<CreateTaskDefinitionMutation>;
export type CreateTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateTaskDefinitionMutation, CreateTaskDefinitionMutationVariables>;
export const CreateTaskFromConversationDocument = gql`
    mutation CreateTaskFromConversation($input: CreateTaskFromConversationInput!) {
  createTaskFromConversation(input: $input) {
    taskDefinition {
      id
      name
    }
    task {
      ...TaskItem
    }
  }
}
    ${TaskItemFragmentDoc}`;
export type CreateTaskFromConversationMutationFn = Apollo.MutationFunction<CreateTaskFromConversationMutation, CreateTaskFromConversationMutationVariables>;

/**
 * __useCreateTaskFromConversationMutation__
 *
 * To run a mutation, you first call `useCreateTaskFromConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskFromConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskFromConversationMutation, { data, loading, error }] = useCreateTaskFromConversationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskFromConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskFromConversationMutation, CreateTaskFromConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskFromConversationMutation, CreateTaskFromConversationMutationVariables>(CreateTaskFromConversationDocument, options);
      }
export type CreateTaskFromConversationMutationHookResult = ReturnType<typeof useCreateTaskFromConversationMutation>;
export type CreateTaskFromConversationMutationResult = Apollo.MutationResult<CreateTaskFromConversationMutation>;
export type CreateTaskFromConversationMutationOptions = Apollo.BaseMutationOptions<CreateTaskFromConversationMutation, CreateTaskFromConversationMutationVariables>;
export const LinkConversationToTaskDocument = gql`
    mutation LinkConversationToTask($input: LinkConversationToTaskInput!) {
  linkConversationToTask(input: $input) {
    task {
      id
    }
  }
}
    `;
export type LinkConversationToTaskMutationFn = Apollo.MutationFunction<LinkConversationToTaskMutation, LinkConversationToTaskMutationVariables>;

/**
 * __useLinkConversationToTaskMutation__
 *
 * To run a mutation, you first call `useLinkConversationToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkConversationToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkConversationToTaskMutation, { data, loading, error }] = useLinkConversationToTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkConversationToTaskMutation(baseOptions?: Apollo.MutationHookOptions<LinkConversationToTaskMutation, LinkConversationToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkConversationToTaskMutation, LinkConversationToTaskMutationVariables>(LinkConversationToTaskDocument, options);
      }
export type LinkConversationToTaskMutationHookResult = ReturnType<typeof useLinkConversationToTaskMutation>;
export type LinkConversationToTaskMutationResult = Apollo.MutationResult<LinkConversationToTaskMutation>;
export type LinkConversationToTaskMutationOptions = Apollo.BaseMutationOptions<LinkConversationToTaskMutation, LinkConversationToTaskMutationVariables>;
export const LinkTaskSearchDocument = gql`
    query LinkTaskSearch($search: String, $statuses: [String], $communities: [String], $first: Int = 10, $after: String, $orderBy: String = "-created_at") {
  tasks(
    search: $search
    statuses: $statuses
    communities: $communities
    first: $first
    after: $after
    orderBy: $orderBy
  ) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        status
        taskDefinition {
          id
          name
          communityTaskDefinitions(first: 1) {
            edges {
              node {
                community {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useLinkTaskSearchQuery__
 *
 * To run a query within a React component, call `useLinkTaskSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useLinkTaskSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLinkTaskSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *      statuses: // value for 'statuses'
 *      communities: // value for 'communities'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useLinkTaskSearchQuery(baseOptions?: Apollo.QueryHookOptions<LinkTaskSearchQuery, LinkTaskSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LinkTaskSearchQuery, LinkTaskSearchQueryVariables>(LinkTaskSearchDocument, options);
      }
export function useLinkTaskSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LinkTaskSearchQuery, LinkTaskSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LinkTaskSearchQuery, LinkTaskSearchQueryVariables>(LinkTaskSearchDocument, options);
        }
export type LinkTaskSearchQueryHookResult = ReturnType<typeof useLinkTaskSearchQuery>;
export type LinkTaskSearchLazyQueryHookResult = ReturnType<typeof useLinkTaskSearchLazyQuery>;
export type LinkTaskSearchQueryResult = Apollo.QueryResult<LinkTaskSearchQuery, LinkTaskSearchQueryVariables>;
export const TasksDocument = gql`
    query Tasks($after: String, $search: String, $communities: [String], $statuses: [String], $clientTags: [String], $orderBy: String) {
  tasks(
    after: $after
    search: $search
    communities: $communities
    statuses: $statuses
    clientTags: $clientTags
    orderBy: $orderBy
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...TaskItem
      }
    }
  }
}
    ${TaskItemFragmentDoc}`;

/**
 * __useTasksQuery__
 *
 * To run a query within a React component, call `useTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTasksQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      statuses: // value for 'statuses'
 *      clientTags: // value for 'clientTags'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useTasksQuery(baseOptions?: Apollo.QueryHookOptions<TasksQuery, TasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
      }
export function useTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TasksQuery, TasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TasksQuery, TasksQueryVariables>(TasksDocument, options);
        }
export type TasksQueryHookResult = ReturnType<typeof useTasksQuery>;
export type TasksLazyQueryHookResult = ReturnType<typeof useTasksLazyQuery>;
export type TasksQueryResult = Apollo.QueryResult<TasksQuery, TasksQueryVariables>;
export const RenameTaskDocument = gql`
    mutation RenameTask($input: RenameTaskInput!) {
  renameTask(input: $input) {
    task {
      id
      sharesDefinition
      taskDefinition {
        id
        name
      }
    }
  }
}
    `;
export type RenameTaskMutationFn = Apollo.MutationFunction<RenameTaskMutation, RenameTaskMutationVariables>;

/**
 * __useRenameTaskMutation__
 *
 * To run a mutation, you first call `useRenameTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameTaskMutation, { data, loading, error }] = useRenameTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenameTaskMutation(baseOptions?: Apollo.MutationHookOptions<RenameTaskMutation, RenameTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameTaskMutation, RenameTaskMutationVariables>(RenameTaskDocument, options);
      }
export type RenameTaskMutationHookResult = ReturnType<typeof useRenameTaskMutation>;
export type RenameTaskMutationResult = Apollo.MutationResult<RenameTaskMutation>;
export type RenameTaskMutationOptions = Apollo.BaseMutationOptions<RenameTaskMutation, RenameTaskMutationVariables>;
export const TaskGroupDetailDocument = gql`
    query TaskGroupDetail($id: UUID!, $dueDateAfter: Date) {
  taskGroup(id: $id) {
    id
    name
    description
    priority
    schedule
    isActive
    generationHorizon
    createdAt
    taskTemplate {
      id
      name
    }
    tasks(first: 10, orderBy: "due_date", dueDateAfter: $dueDateAfter) {
      edges {
        node {
          ...TaskItem
          scheduledFor
          category {
            id
            name
          }
        }
      }
    }
    documents {
      edges {
        node {
          ...TaskDocument
        }
      }
    }
    templateTask: tasks(first: 1, statuses: ["SCHEDULED"], orderBy: "due_date") {
      edges {
        node {
          id
          assignedUser {
            id
            name
          }
          contractorCompany {
            id
            name
            contractors {
              edges {
                node {
                  id
                  name
                  email
                  jobTitle
                }
              }
            }
          }
          contractorUsers {
            edges {
              node {
                id
                name
                email
                jobTitle
              }
            }
          }
        }
      }
    }
  }
}
    ${TaskItemFragmentDoc}
${TaskDocumentFragmentDoc}`;

/**
 * __useTaskGroupDetailQuery__
 *
 * To run a query within a React component, call `useTaskGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      dueDateAfter: // value for 'dueDateAfter'
 *   },
 * });
 */
export function useTaskGroupDetailQuery(baseOptions: Apollo.QueryHookOptions<TaskGroupDetailQuery, TaskGroupDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskGroupDetailQuery, TaskGroupDetailQueryVariables>(TaskGroupDetailDocument, options);
      }
export function useTaskGroupDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskGroupDetailQuery, TaskGroupDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskGroupDetailQuery, TaskGroupDetailQueryVariables>(TaskGroupDetailDocument, options);
        }
export type TaskGroupDetailQueryHookResult = ReturnType<typeof useTaskGroupDetailQuery>;
export type TaskGroupDetailLazyQueryHookResult = ReturnType<typeof useTaskGroupDetailLazyQuery>;
export type TaskGroupDetailQueryResult = Apollo.QueryResult<TaskGroupDetailQuery, TaskGroupDetailQueryVariables>;
export const TaskGroupPastTasksDocument = gql`
    query TaskGroupPastTasks($id: UUID!, $first: Int, $after: String, $statuses: [String]) {
  taskGroup(id: $id) {
    id
    tasks(first: $first, after: $after, statuses: $statuses, orderBy: "-due_date") {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...TaskItem
          scheduledFor
          category {
            id
            name
          }
        }
      }
    }
  }
}
    ${TaskItemFragmentDoc}`;

/**
 * __useTaskGroupPastTasksQuery__
 *
 * To run a query within a React component, call `useTaskGroupPastTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupPastTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupPastTasksQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      statuses: // value for 'statuses'
 *   },
 * });
 */
export function useTaskGroupPastTasksQuery(baseOptions: Apollo.QueryHookOptions<TaskGroupPastTasksQuery, TaskGroupPastTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskGroupPastTasksQuery, TaskGroupPastTasksQueryVariables>(TaskGroupPastTasksDocument, options);
      }
export function useTaskGroupPastTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskGroupPastTasksQuery, TaskGroupPastTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskGroupPastTasksQuery, TaskGroupPastTasksQueryVariables>(TaskGroupPastTasksDocument, options);
        }
export type TaskGroupPastTasksQueryHookResult = ReturnType<typeof useTaskGroupPastTasksQuery>;
export type TaskGroupPastTasksLazyQueryHookResult = ReturnType<typeof useTaskGroupPastTasksLazyQuery>;
export type TaskGroupPastTasksQueryResult = Apollo.QueryResult<TaskGroupPastTasksQuery, TaskGroupPastTasksQueryVariables>;
export const TaskGroupsDocument = gql`
    query TaskGroups($first: Int, $after: String, $search: String, $communities: [String]) {
  taskGroups(
    first: $first
    after: $after
    search: $search
    communities: $communities
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...TaskGroupItem
      }
    }
  }
}
    ${TaskGroupItemFragmentDoc}`;

/**
 * __useTaskGroupsQuery__
 *
 * To run a query within a React component, call `useTaskGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskGroupsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *   },
 * });
 */
export function useTaskGroupsQuery(baseOptions?: Apollo.QueryHookOptions<TaskGroupsQuery, TaskGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskGroupsQuery, TaskGroupsQueryVariables>(TaskGroupsDocument, options);
      }
export function useTaskGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskGroupsQuery, TaskGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskGroupsQuery, TaskGroupsQueryVariables>(TaskGroupsDocument, options);
        }
export type TaskGroupsQueryHookResult = ReturnType<typeof useTaskGroupsQuery>;
export type TaskGroupsLazyQueryHookResult = ReturnType<typeof useTaskGroupsLazyQuery>;
export type TaskGroupsQueryResult = Apollo.QueryResult<TaskGroupsQuery, TaskGroupsQueryVariables>;
export const ArchiveTaskGroupDocument = gql`
    mutation ArchiveTaskGroup($input: ArchiveTaskGroupInput!) {
  archiveTaskGroup(input: $input) {
    taskGroup {
      id
      archivedAt
      isActive
    }
  }
}
    `;
export type ArchiveTaskGroupMutationFn = Apollo.MutationFunction<ArchiveTaskGroupMutation, ArchiveTaskGroupMutationVariables>;

/**
 * __useArchiveTaskGroupMutation__
 *
 * To run a mutation, you first call `useArchiveTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTaskGroupMutation, { data, loading, error }] = useArchiveTaskGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTaskGroupMutation, ArchiveTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTaskGroupMutation, ArchiveTaskGroupMutationVariables>(ArchiveTaskGroupDocument, options);
      }
export type ArchiveTaskGroupMutationHookResult = ReturnType<typeof useArchiveTaskGroupMutation>;
export type ArchiveTaskGroupMutationResult = Apollo.MutationResult<ArchiveTaskGroupMutation>;
export type ArchiveTaskGroupMutationOptions = Apollo.BaseMutationOptions<ArchiveTaskGroupMutation, ArchiveTaskGroupMutationVariables>;
export const UpdateTaskGroupDocument = gql`
    mutation UpdateTaskGroup($input: UpdateTaskGroupInput!) {
  updateTaskGroup(input: $input) {
    taskGroup {
      id
      name
      description
      priority
      schedule
      isActive
      generationHorizon
      createdAt
      taskTemplate {
        id
        name
      }
      tasks {
        totalCount
      }
    }
  }
}
    `;
export type UpdateTaskGroupMutationFn = Apollo.MutationFunction<UpdateTaskGroupMutation, UpdateTaskGroupMutationVariables>;

/**
 * __useUpdateTaskGroupMutation__
 *
 * To run a mutation, you first call `useUpdateTaskGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskGroupMutation, { data, loading, error }] = useUpdateTaskGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskGroupMutation, UpdateTaskGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskGroupMutation, UpdateTaskGroupMutationVariables>(UpdateTaskGroupDocument, options);
      }
export type UpdateTaskGroupMutationHookResult = ReturnType<typeof useUpdateTaskGroupMutation>;
export type UpdateTaskGroupMutationResult = Apollo.MutationResult<UpdateTaskGroupMutation>;
export type UpdateTaskGroupMutationOptions = Apollo.BaseMutationOptions<UpdateTaskGroupMutation, UpdateTaskGroupMutationVariables>;
export const ArchiveTaskDocument = gql`
    mutation ArchiveTask($input: ArchiveTaskInput!) {
  archiveTask(input: $input) {
    task {
      id
      archivedAt
    }
  }
}
    `;
export type ArchiveTaskMutationFn = Apollo.MutationFunction<ArchiveTaskMutation, ArchiveTaskMutationVariables>;

/**
 * __useArchiveTaskMutation__
 *
 * To run a mutation, you first call `useArchiveTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTaskMutation, { data, loading, error }] = useArchiveTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTaskMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTaskMutation, ArchiveTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTaskMutation, ArchiveTaskMutationVariables>(ArchiveTaskDocument, options);
      }
export type ArchiveTaskMutationHookResult = ReturnType<typeof useArchiveTaskMutation>;
export type ArchiveTaskMutationResult = Apollo.MutationResult<ArchiveTaskMutation>;
export type ArchiveTaskMutationOptions = Apollo.BaseMutationOptions<ArchiveTaskMutation, ArchiveTaskMutationVariables>;
export const AssignContractorToTaskDocument = gql`
    mutation AssignContractorToTask($input: AssignContractorToTaskInput!) {
  assignContractorToTask(input: $input) {
    task {
      id
      contractorCompany {
        id
        name
        contractors {
          edges {
            node {
              id
              name
              email
              jobTitle
            }
          }
        }
      }
      contractorUsers {
        edges {
          node {
            id
            name
            email
            jobTitle
          }
        }
      }
      updates {
        edges {
          node {
            ...TaskUpdate
          }
        }
      }
    }
  }
}
    ${TaskUpdateFragmentDoc}`;
export type AssignContractorToTaskMutationFn = Apollo.MutationFunction<AssignContractorToTaskMutation, AssignContractorToTaskMutationVariables>;

/**
 * __useAssignContractorToTaskMutation__
 *
 * To run a mutation, you first call `useAssignContractorToTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignContractorToTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignContractorToTaskMutation, { data, loading, error }] = useAssignContractorToTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignContractorToTaskMutation(baseOptions?: Apollo.MutationHookOptions<AssignContractorToTaskMutation, AssignContractorToTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignContractorToTaskMutation, AssignContractorToTaskMutationVariables>(AssignContractorToTaskDocument, options);
      }
export type AssignContractorToTaskMutationHookResult = ReturnType<typeof useAssignContractorToTaskMutation>;
export type AssignContractorToTaskMutationResult = Apollo.MutationResult<AssignContractorToTaskMutation>;
export type AssignContractorToTaskMutationOptions = Apollo.BaseMutationOptions<AssignContractorToTaskMutation, AssignContractorToTaskMutationVariables>;
export const ChangeTaskStatusDocument = gql`
    mutation ChangeTaskStatus($input: ChangeTaskStatusInput!) {
  changeTaskStatus(input: $input) {
    errors {
      field
      messages
    }
    task {
      id
      status
      completedAt
      updates {
        edges {
          node {
            ...TaskUpdate
          }
        }
      }
    }
  }
}
    ${TaskUpdateFragmentDoc}`;
export type ChangeTaskStatusMutationFn = Apollo.MutationFunction<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;

/**
 * __useChangeTaskStatusMutation__
 *
 * To run a mutation, you first call `useChangeTaskStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTaskStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTaskStatusMutation, { data, loading, error }] = useChangeTaskStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTaskStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>(ChangeTaskStatusDocument, options);
      }
export type ChangeTaskStatusMutationHookResult = ReturnType<typeof useChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationResult = Apollo.MutationResult<ChangeTaskStatusMutation>;
export type ChangeTaskStatusMutationOptions = Apollo.BaseMutationOptions<ChangeTaskStatusMutation, ChangeTaskStatusMutationVariables>;
export const FlagChecklistItemDocument = gql`
    mutation FlagChecklistItem($input: FlagChecklistItemInput!) {
  flagChecklistItem(input: $input) {
    checklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;
export type FlagChecklistItemMutationFn = Apollo.MutationFunction<FlagChecklistItemMutation, FlagChecklistItemMutationVariables>;

/**
 * __useFlagChecklistItemMutation__
 *
 * To run a mutation, you first call `useFlagChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagChecklistItemMutation, { data, loading, error }] = useFlagChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFlagChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<FlagChecklistItemMutation, FlagChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagChecklistItemMutation, FlagChecklistItemMutationVariables>(FlagChecklistItemDocument, options);
      }
export type FlagChecklistItemMutationHookResult = ReturnType<typeof useFlagChecklistItemMutation>;
export type FlagChecklistItemMutationResult = Apollo.MutationResult<FlagChecklistItemMutation>;
export type FlagChecklistItemMutationOptions = Apollo.BaseMutationOptions<FlagChecklistItemMutation, FlagChecklistItemMutationVariables>;
export const UnflagChecklistItemDocument = gql`
    mutation UnflagChecklistItem($input: UnflagChecklistItemInput!) {
  unflagChecklistItem(input: $input) {
    taskChecklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;
export type UnflagChecklistItemMutationFn = Apollo.MutationFunction<UnflagChecklistItemMutation, UnflagChecklistItemMutationVariables>;

/**
 * __useUnflagChecklistItemMutation__
 *
 * To run a mutation, you first call `useUnflagChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnflagChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unflagChecklistItemMutation, { data, loading, error }] = useUnflagChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnflagChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<UnflagChecklistItemMutation, UnflagChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnflagChecklistItemMutation, UnflagChecklistItemMutationVariables>(UnflagChecklistItemDocument, options);
      }
export type UnflagChecklistItemMutationHookResult = ReturnType<typeof useUnflagChecklistItemMutation>;
export type UnflagChecklistItemMutationResult = Apollo.MutationResult<UnflagChecklistItemMutation>;
export type UnflagChecklistItemMutationOptions = Apollo.BaseMutationOptions<UnflagChecklistItemMutation, UnflagChecklistItemMutationVariables>;
export const CreateFollowUpTaskFromChecklistItemDocument = gql`
    mutation CreateFollowUpTaskFromChecklistItem($input: CreateFollowUpTaskFromChecklistItemInput!) {
  createFollowUpTaskFromChecklistItem(input: $input) {
    task {
      ...ChecklistFollowUpTask
    }
    checklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistFollowUpTaskFragmentDoc}
${ChecklistItemFragmentDoc}`;
export type CreateFollowUpTaskFromChecklistItemMutationFn = Apollo.MutationFunction<CreateFollowUpTaskFromChecklistItemMutation, CreateFollowUpTaskFromChecklistItemMutationVariables>;

/**
 * __useCreateFollowUpTaskFromChecklistItemMutation__
 *
 * To run a mutation, you first call `useCreateFollowUpTaskFromChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFollowUpTaskFromChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFollowUpTaskFromChecklistItemMutation, { data, loading, error }] = useCreateFollowUpTaskFromChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateFollowUpTaskFromChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFollowUpTaskFromChecklistItemMutation, CreateFollowUpTaskFromChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFollowUpTaskFromChecklistItemMutation, CreateFollowUpTaskFromChecklistItemMutationVariables>(CreateFollowUpTaskFromChecklistItemDocument, options);
      }
export type CreateFollowUpTaskFromChecklistItemMutationHookResult = ReturnType<typeof useCreateFollowUpTaskFromChecklistItemMutation>;
export type CreateFollowUpTaskFromChecklistItemMutationResult = Apollo.MutationResult<CreateFollowUpTaskFromChecklistItemMutation>;
export type CreateFollowUpTaskFromChecklistItemMutationOptions = Apollo.BaseMutationOptions<CreateFollowUpTaskFromChecklistItemMutation, CreateFollowUpTaskFromChecklistItemMutationVariables>;
export const AssignChecklistItemDocument = gql`
    mutation AssignChecklistItem($input: AssignChecklistItemInput!) {
  assignChecklistItem(input: $input) {
    checklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;
export type AssignChecklistItemMutationFn = Apollo.MutationFunction<AssignChecklistItemMutation, AssignChecklistItemMutationVariables>;

/**
 * __useAssignChecklistItemMutation__
 *
 * To run a mutation, you first call `useAssignChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignChecklistItemMutation, { data, loading, error }] = useAssignChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<AssignChecklistItemMutation, AssignChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignChecklistItemMutation, AssignChecklistItemMutationVariables>(AssignChecklistItemDocument, options);
      }
export type AssignChecklistItemMutationHookResult = ReturnType<typeof useAssignChecklistItemMutation>;
export type AssignChecklistItemMutationResult = Apollo.MutationResult<AssignChecklistItemMutation>;
export type AssignChecklistItemMutationOptions = Apollo.BaseMutationOptions<AssignChecklistItemMutation, AssignChecklistItemMutationVariables>;
export const AssignChecklistSectionDocument = gql`
    mutation AssignChecklistSection($input: AssignChecklistSectionInput!) {
  assignChecklistSection(input: $input) {
    checklistSection {
      ...ChecklistSection
    }
  }
}
    ${ChecklistSectionFragmentDoc}`;
export type AssignChecklistSectionMutationFn = Apollo.MutationFunction<AssignChecklistSectionMutation, AssignChecklistSectionMutationVariables>;

/**
 * __useAssignChecklistSectionMutation__
 *
 * To run a mutation, you first call `useAssignChecklistSectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignChecklistSectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignChecklistSectionMutation, { data, loading, error }] = useAssignChecklistSectionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignChecklistSectionMutation(baseOptions?: Apollo.MutationHookOptions<AssignChecklistSectionMutation, AssignChecklistSectionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignChecklistSectionMutation, AssignChecklistSectionMutationVariables>(AssignChecklistSectionDocument, options);
      }
export type AssignChecklistSectionMutationHookResult = ReturnType<typeof useAssignChecklistSectionMutation>;
export type AssignChecklistSectionMutationResult = Apollo.MutationResult<AssignChecklistSectionMutation>;
export type AssignChecklistSectionMutationOptions = Apollo.BaseMutationOptions<AssignChecklistSectionMutation, AssignChecklistSectionMutationVariables>;
export const CreateChecklistItemCommentDocument = gql`
    mutation CreateChecklistItemComment($input: CreateChecklistItemCommentInput!) {
  createChecklistItemComment(input: $input) {
    taskChecklistItemComment {
      ...ChecklistItemComment
    }
    errors {
      field
      messages
    }
  }
}
    ${ChecklistItemCommentFragmentDoc}`;
export type CreateChecklistItemCommentMutationFn = Apollo.MutationFunction<CreateChecklistItemCommentMutation, CreateChecklistItemCommentMutationVariables>;

/**
 * __useCreateChecklistItemCommentMutation__
 *
 * To run a mutation, you first call `useCreateChecklistItemCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistItemCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistItemCommentMutation, { data, loading, error }] = useCreateChecklistItemCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistItemCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistItemCommentMutation, CreateChecklistItemCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChecklistItemCommentMutation, CreateChecklistItemCommentMutationVariables>(CreateChecklistItemCommentDocument, options);
      }
export type CreateChecklistItemCommentMutationHookResult = ReturnType<typeof useCreateChecklistItemCommentMutation>;
export type CreateChecklistItemCommentMutationResult = Apollo.MutationResult<CreateChecklistItemCommentMutation>;
export type CreateChecklistItemCommentMutationOptions = Apollo.BaseMutationOptions<CreateChecklistItemCommentMutation, CreateChecklistItemCommentMutationVariables>;
export const CompleteChecklistItemDocument = gql`
    mutation CompleteChecklistItem($input: CompleteChecklistItemInput!) {
  completeChecklistItem(input: $input) {
    taskChecklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;
export type CompleteChecklistItemMutationFn = Apollo.MutationFunction<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;

/**
 * __useCompleteChecklistItemMutation__
 *
 * To run a mutation, you first call `useCompleteChecklistItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteChecklistItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeChecklistItemMutation, { data, loading, error }] = useCompleteChecklistItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCompleteChecklistItemMutation(baseOptions?: Apollo.MutationHookOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>(CompleteChecklistItemDocument, options);
      }
export type CompleteChecklistItemMutationHookResult = ReturnType<typeof useCompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationResult = Apollo.MutationResult<CompleteChecklistItemMutation>;
export type CompleteChecklistItemMutationOptions = Apollo.BaseMutationOptions<CompleteChecklistItemMutation, CompleteChecklistItemMutationVariables>;
export const CreateChecklistItemMediaDocument = gql`
    mutation CreateChecklistItemMedia($input: CreateChecklistItemMediaInput!) {
  createChecklistItemMedia(input: $input) {
    taskChecklistItemMedia {
      id
    }
  }
}
    `;
export type CreateChecklistItemMediaMutationFn = Apollo.MutationFunction<CreateChecklistItemMediaMutation, CreateChecklistItemMediaMutationVariables>;

/**
 * __useCreateChecklistItemMediaMutation__
 *
 * To run a mutation, you first call `useCreateChecklistItemMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistItemMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistItemMediaMutation, { data, loading, error }] = useCreateChecklistItemMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistItemMediaMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistItemMediaMutation, CreateChecklistItemMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChecklistItemMediaMutation, CreateChecklistItemMediaMutationVariables>(CreateChecklistItemMediaDocument, options);
      }
export type CreateChecklistItemMediaMutationHookResult = ReturnType<typeof useCreateChecklistItemMediaMutation>;
export type CreateChecklistItemMediaMutationResult = Apollo.MutationResult<CreateChecklistItemMediaMutation>;
export type CreateChecklistItemMediaMutationOptions = Apollo.BaseMutationOptions<CreateChecklistItemMediaMutation, CreateChecklistItemMediaMutationVariables>;
export const DeleteChecklistItemMediaDocument = gql`
    mutation DeleteChecklistItemMedia($input: DeleteChecklistItemMediaInput!) {
  deleteChecklistItemMedia(input: $input) {
    deletedMediaId
  }
}
    `;
export type DeleteChecklistItemMediaMutationFn = Apollo.MutationFunction<DeleteChecklistItemMediaMutation, DeleteChecklistItemMediaMutationVariables>;

/**
 * __useDeleteChecklistItemMediaMutation__
 *
 * To run a mutation, you first call `useDeleteChecklistItemMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChecklistItemMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChecklistItemMediaMutation, { data, loading, error }] = useDeleteChecklistItemMediaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChecklistItemMediaMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChecklistItemMediaMutation, DeleteChecklistItemMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChecklistItemMediaMutation, DeleteChecklistItemMediaMutationVariables>(DeleteChecklistItemMediaDocument, options);
      }
export type DeleteChecklistItemMediaMutationHookResult = ReturnType<typeof useDeleteChecklistItemMediaMutation>;
export type DeleteChecklistItemMediaMutationResult = Apollo.MutationResult<DeleteChecklistItemMediaMutation>;
export type DeleteChecklistItemMediaMutationOptions = Apollo.BaseMutationOptions<DeleteChecklistItemMediaMutation, DeleteChecklistItemMediaMutationVariables>;
export const SetChecklistItemDueDateDocument = gql`
    mutation SetChecklistItemDueDate($input: SetChecklistItemDueDateInput!) {
  setChecklistItemDueDate(input: $input) {
    checklistItem {
      ...ChecklistItem
    }
  }
}
    ${ChecklistItemFragmentDoc}`;
export type SetChecklistItemDueDateMutationFn = Apollo.MutationFunction<SetChecklistItemDueDateMutation, SetChecklistItemDueDateMutationVariables>;

/**
 * __useSetChecklistItemDueDateMutation__
 *
 * To run a mutation, you first call `useSetChecklistItemDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChecklistItemDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChecklistItemDueDateMutation, { data, loading, error }] = useSetChecklistItemDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChecklistItemDueDateMutation(baseOptions?: Apollo.MutationHookOptions<SetChecklistItemDueDateMutation, SetChecklistItemDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChecklistItemDueDateMutation, SetChecklistItemDueDateMutationVariables>(SetChecklistItemDueDateDocument, options);
      }
export type SetChecklistItemDueDateMutationHookResult = ReturnType<typeof useSetChecklistItemDueDateMutation>;
export type SetChecklistItemDueDateMutationResult = Apollo.MutationResult<SetChecklistItemDueDateMutation>;
export type SetChecklistItemDueDateMutationOptions = Apollo.BaseMutationOptions<SetChecklistItemDueDateMutation, SetChecklistItemDueDateMutationVariables>;
export const SetChecklistSectionDueDateDocument = gql`
    mutation SetChecklistSectionDueDate($input: SetChecklistSectionDueDateInput!) {
  setChecklistSectionDueDate(input: $input) {
    checklistSection {
      ...ChecklistSection
    }
  }
}
    ${ChecklistSectionFragmentDoc}`;
export type SetChecklistSectionDueDateMutationFn = Apollo.MutationFunction<SetChecklistSectionDueDateMutation, SetChecklistSectionDueDateMutationVariables>;

/**
 * __useSetChecklistSectionDueDateMutation__
 *
 * To run a mutation, you first call `useSetChecklistSectionDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetChecklistSectionDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setChecklistSectionDueDateMutation, { data, loading, error }] = useSetChecklistSectionDueDateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetChecklistSectionDueDateMutation(baseOptions?: Apollo.MutationHookOptions<SetChecklistSectionDueDateMutation, SetChecklistSectionDueDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetChecklistSectionDueDateMutation, SetChecklistSectionDueDateMutationVariables>(SetChecklistSectionDueDateDocument, options);
      }
export type SetChecklistSectionDueDateMutationHookResult = ReturnType<typeof useSetChecklistSectionDueDateMutation>;
export type SetChecklistSectionDueDateMutationResult = Apollo.MutationResult<SetChecklistSectionDueDateMutation>;
export type SetChecklistSectionDueDateMutationOptions = Apollo.BaseMutationOptions<SetChecklistSectionDueDateMutation, SetChecklistSectionDueDateMutationVariables>;
export const CreateChecklistDocument = gql`
    mutation CreateChecklist($input: CreateChecklistInput!) {
  createChecklist(input: $input) {
    taskChecklist {
      ...TaskChecklist
    }
  }
}
    ${TaskChecklistFragmentDoc}`;
export type CreateChecklistMutationFn = Apollo.MutationFunction<CreateChecklistMutation, CreateChecklistMutationVariables>;

/**
 * __useCreateChecklistMutation__
 *
 * To run a mutation, you first call `useCreateChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistMutation, { data, loading, error }] = useCreateChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistMutation, CreateChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChecklistMutation, CreateChecklistMutationVariables>(CreateChecklistDocument, options);
      }
export type CreateChecklistMutationHookResult = ReturnType<typeof useCreateChecklistMutation>;
export type CreateChecklistMutationResult = Apollo.MutationResult<CreateChecklistMutation>;
export type CreateChecklistMutationOptions = Apollo.BaseMutationOptions<CreateChecklistMutation, CreateChecklistMutationVariables>;
export const CreateChecklistFromTemplateDocument = gql`
    mutation CreateChecklistFromTemplate($input: CreateChecklistFromTemplateInput!) {
  createChecklistFromTemplate(input: $input) {
    checklist {
      ...TaskChecklist
    }
  }
}
    ${TaskChecklistFragmentDoc}`;
export type CreateChecklistFromTemplateMutationFn = Apollo.MutationFunction<CreateChecklistFromTemplateMutation, CreateChecklistFromTemplateMutationVariables>;

/**
 * __useCreateChecklistFromTemplateMutation__
 *
 * To run a mutation, you first call `useCreateChecklistFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistFromTemplateMutation, { data, loading, error }] = useCreateChecklistFromTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistFromTemplateMutation, CreateChecklistFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChecklistFromTemplateMutation, CreateChecklistFromTemplateMutationVariables>(CreateChecklistFromTemplateDocument, options);
      }
export type CreateChecklistFromTemplateMutationHookResult = ReturnType<typeof useCreateChecklistFromTemplateMutation>;
export type CreateChecklistFromTemplateMutationResult = Apollo.MutationResult<CreateChecklistFromTemplateMutation>;
export type CreateChecklistFromTemplateMutationOptions = Apollo.BaseMutationOptions<CreateChecklistFromTemplateMutation, CreateChecklistFromTemplateMutationVariables>;
export const CreateChecklistWithStructureDocument = gql`
    mutation CreateChecklistWithStructure($input: CreateChecklistWithStructureInput!) {
  createChecklistWithStructure(input: $input) {
    checklist {
      ...TaskChecklist
    }
  }
}
    ${TaskChecklistFragmentDoc}`;
export type CreateChecklistWithStructureMutationFn = Apollo.MutationFunction<CreateChecklistWithStructureMutation, CreateChecklistWithStructureMutationVariables>;

/**
 * __useCreateChecklistWithStructureMutation__
 *
 * To run a mutation, you first call `useCreateChecklistWithStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChecklistWithStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChecklistWithStructureMutation, { data, loading, error }] = useCreateChecklistWithStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChecklistWithStructureMutation(baseOptions?: Apollo.MutationHookOptions<CreateChecklistWithStructureMutation, CreateChecklistWithStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChecklistWithStructureMutation, CreateChecklistWithStructureMutationVariables>(CreateChecklistWithStructureDocument, options);
      }
export type CreateChecklistWithStructureMutationHookResult = ReturnType<typeof useCreateChecklistWithStructureMutation>;
export type CreateChecklistWithStructureMutationResult = Apollo.MutationResult<CreateChecklistWithStructureMutation>;
export type CreateChecklistWithStructureMutationOptions = Apollo.BaseMutationOptions<CreateChecklistWithStructureMutation, CreateChecklistWithStructureMutationVariables>;
export const UpdateChecklistStructureDocument = gql`
    mutation UpdateChecklistStructure($input: UpdateChecklistStructureInput!) {
  updateChecklistStructure(input: $input) {
    checklist {
      ...TaskChecklist
    }
  }
}
    ${TaskChecklistFragmentDoc}`;
export type UpdateChecklistStructureMutationFn = Apollo.MutationFunction<UpdateChecklistStructureMutation, UpdateChecklistStructureMutationVariables>;

/**
 * __useUpdateChecklistStructureMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistStructureMutation, { data, loading, error }] = useUpdateChecklistStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChecklistStructureMutation, UpdateChecklistStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChecklistStructureMutation, UpdateChecklistStructureMutationVariables>(UpdateChecklistStructureDocument, options);
      }
export type UpdateChecklistStructureMutationHookResult = ReturnType<typeof useUpdateChecklistStructureMutation>;
export type UpdateChecklistStructureMutationResult = Apollo.MutationResult<UpdateChecklistStructureMutation>;
export type UpdateChecklistStructureMutationOptions = Apollo.BaseMutationOptions<UpdateChecklistStructureMutation, UpdateChecklistStructureMutationVariables>;
export const DeleteChecklistDocument = gql`
    mutation DeleteChecklist($input: DeleteChecklistInput!) {
  deleteChecklist(input: $input) {
    deletedChecklistId
  }
}
    `;
export type DeleteChecklistMutationFn = Apollo.MutationFunction<DeleteChecklistMutation, DeleteChecklistMutationVariables>;

/**
 * __useDeleteChecklistMutation__
 *
 * To run a mutation, you first call `useDeleteChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChecklistMutation, { data, loading, error }] = useDeleteChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteChecklistMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChecklistMutation, DeleteChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChecklistMutation, DeleteChecklistMutationVariables>(DeleteChecklistDocument, options);
      }
export type DeleteChecklistMutationHookResult = ReturnType<typeof useDeleteChecklistMutation>;
export type DeleteChecklistMutationResult = Apollo.MutationResult<DeleteChecklistMutation>;
export type DeleteChecklistMutationOptions = Apollo.BaseMutationOptions<DeleteChecklistMutation, DeleteChecklistMutationVariables>;
export const UpdateChecklistDocument = gql`
    mutation UpdateChecklist($input: UpdateChecklistInput!) {
  updateChecklist(input: $input) {
    checklist {
      id
      name
      requiresSignOff
    }
  }
}
    `;
export type UpdateChecklistMutationFn = Apollo.MutationFunction<UpdateChecklistMutation, UpdateChecklistMutationVariables>;

/**
 * __useUpdateChecklistMutation__
 *
 * To run a mutation, you first call `useUpdateChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateChecklistMutation, { data, loading, error }] = useUpdateChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateChecklistMutation(baseOptions?: Apollo.MutationHookOptions<UpdateChecklistMutation, UpdateChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateChecklistMutation, UpdateChecklistMutationVariables>(UpdateChecklistDocument, options);
      }
export type UpdateChecklistMutationHookResult = ReturnType<typeof useUpdateChecklistMutation>;
export type UpdateChecklistMutationResult = Apollo.MutationResult<UpdateChecklistMutation>;
export type UpdateChecklistMutationOptions = Apollo.BaseMutationOptions<UpdateChecklistMutation, UpdateChecklistMutationVariables>;
export const SignOffChecklistDocument = gql`
    mutation SignOffChecklist($input: SignOffChecklistInput!) {
  signOffChecklist(input: $input) {
    checklist {
      ...TaskChecklist
    }
  }
}
    ${TaskChecklistFragmentDoc}`;
export type SignOffChecklistMutationFn = Apollo.MutationFunction<SignOffChecklistMutation, SignOffChecklistMutationVariables>;

/**
 * __useSignOffChecklistMutation__
 *
 * To run a mutation, you first call `useSignOffChecklistMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOffChecklistMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOffChecklistMutation, { data, loading, error }] = useSignOffChecklistMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOffChecklistMutation(baseOptions?: Apollo.MutationHookOptions<SignOffChecklistMutation, SignOffChecklistMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOffChecklistMutation, SignOffChecklistMutationVariables>(SignOffChecklistDocument, options);
      }
export type SignOffChecklistMutationHookResult = ReturnType<typeof useSignOffChecklistMutation>;
export type SignOffChecklistMutationResult = Apollo.MutationResult<SignOffChecklistMutation>;
export type SignOffChecklistMutationOptions = Apollo.BaseMutationOptions<SignOffChecklistMutation, SignOffChecklistMutationVariables>;
export const SuggestRemediationStepsDocument = gql`
    mutation SuggestRemediationSteps($input: SuggestRemediationStepsInput!) {
  suggestRemediationSteps(input: $input) {
    steps {
      title
      description
      guidance
    }
  }
}
    `;
export type SuggestRemediationStepsMutationFn = Apollo.MutationFunction<SuggestRemediationStepsMutation, SuggestRemediationStepsMutationVariables>;

/**
 * __useSuggestRemediationStepsMutation__
 *
 * To run a mutation, you first call `useSuggestRemediationStepsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestRemediationStepsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestRemediationStepsMutation, { data, loading, error }] = useSuggestRemediationStepsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuggestRemediationStepsMutation(baseOptions?: Apollo.MutationHookOptions<SuggestRemediationStepsMutation, SuggestRemediationStepsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestRemediationStepsMutation, SuggestRemediationStepsMutationVariables>(SuggestRemediationStepsDocument, options);
      }
export type SuggestRemediationStepsMutationHookResult = ReturnType<typeof useSuggestRemediationStepsMutation>;
export type SuggestRemediationStepsMutationResult = Apollo.MutationResult<SuggestRemediationStepsMutation>;
export type SuggestRemediationStepsMutationOptions = Apollo.BaseMutationOptions<SuggestRemediationStepsMutation, SuggestRemediationStepsMutationVariables>;
export const BatchCreateTaskDocumentsDocument = gql`
    mutation BatchCreateTaskDocuments($input: BatchCreateTaskDocumentsInput!) {
  batchCreateTaskDocuments(input: $input) {
    taskDocuments {
      ...TaskDocument
    }
  }
}
    ${TaskDocumentFragmentDoc}`;
export type BatchCreateTaskDocumentsMutationFn = Apollo.MutationFunction<BatchCreateTaskDocumentsMutation, BatchCreateTaskDocumentsMutationVariables>;

/**
 * __useBatchCreateTaskDocumentsMutation__
 *
 * To run a mutation, you first call `useBatchCreateTaskDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBatchCreateTaskDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [batchCreateTaskDocumentsMutation, { data, loading, error }] = useBatchCreateTaskDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBatchCreateTaskDocumentsMutation(baseOptions?: Apollo.MutationHookOptions<BatchCreateTaskDocumentsMutation, BatchCreateTaskDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BatchCreateTaskDocumentsMutation, BatchCreateTaskDocumentsMutationVariables>(BatchCreateTaskDocumentsDocument, options);
      }
export type BatchCreateTaskDocumentsMutationHookResult = ReturnType<typeof useBatchCreateTaskDocumentsMutation>;
export type BatchCreateTaskDocumentsMutationResult = Apollo.MutationResult<BatchCreateTaskDocumentsMutation>;
export type BatchCreateTaskDocumentsMutationOptions = Apollo.BaseMutationOptions<BatchCreateTaskDocumentsMutation, BatchCreateTaskDocumentsMutationVariables>;
export const CreateTaskDocumentDocument = gql`
    mutation CreateTaskDocument($input: CreateTaskDocumentInput!) {
  createTaskDocument(input: $input) {
    taskDocument {
      ...TaskDocument
    }
  }
}
    ${TaskDocumentFragmentDoc}`;
export type CreateTaskDocumentMutationFn = Apollo.MutationFunction<CreateTaskDocumentMutation, CreateTaskDocumentMutationVariables>;

/**
 * __useCreateTaskDocumentMutation__
 *
 * To run a mutation, you first call `useCreateTaskDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskDocumentMutation, { data, loading, error }] = useCreateTaskDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskDocumentMutation, CreateTaskDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskDocumentMutation, CreateTaskDocumentMutationVariables>(CreateTaskDocumentDocument, options);
      }
export type CreateTaskDocumentMutationHookResult = ReturnType<typeof useCreateTaskDocumentMutation>;
export type CreateTaskDocumentMutationResult = Apollo.MutationResult<CreateTaskDocumentMutation>;
export type CreateTaskDocumentMutationOptions = Apollo.BaseMutationOptions<CreateTaskDocumentMutation, CreateTaskDocumentMutationVariables>;
export const RemoveTaskDocumentDocument = gql`
    mutation RemoveTaskDocument($input: RemoveTaskDocumentInput!) {
  removeTaskDocument(input: $input) {
    taskDocument {
      ...TaskDocument
    }
    errors {
      field
      messages
    }
  }
}
    ${TaskDocumentFragmentDoc}`;
export type RemoveTaskDocumentMutationFn = Apollo.MutationFunction<RemoveTaskDocumentMutation, RemoveTaskDocumentMutationVariables>;

/**
 * __useRemoveTaskDocumentMutation__
 *
 * To run a mutation, you first call `useRemoveTaskDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveTaskDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeTaskDocumentMutation, { data, loading, error }] = useRemoveTaskDocumentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveTaskDocumentMutation(baseOptions?: Apollo.MutationHookOptions<RemoveTaskDocumentMutation, RemoveTaskDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveTaskDocumentMutation, RemoveTaskDocumentMutationVariables>(RemoveTaskDocumentDocument, options);
      }
export type RemoveTaskDocumentMutationHookResult = ReturnType<typeof useRemoveTaskDocumentMutation>;
export type RemoveTaskDocumentMutationResult = Apollo.MutationResult<RemoveTaskDocumentMutation>;
export type RemoveTaskDocumentMutationOptions = Apollo.BaseMutationOptions<RemoveTaskDocumentMutation, RemoveTaskDocumentMutationVariables>;
export const UnassignClientTagFromTaskDefinitionDocument = gql`
    mutation UnassignClientTagFromTaskDefinition($input: UnassignClientTagFromTaskDefinitionInput!) {
  unassignClientTagFromTaskDefinition(input: $input) {
    tagAssignment {
      id
      tag {
        id
      }
    }
    taskDefinition {
      id
      tagAssignments {
        edges {
          node {
            id
            tag {
              id
              name
              color
            }
          }
        }
      }
    }
  }
}
    `;
export type UnassignClientTagFromTaskDefinitionMutationFn = Apollo.MutationFunction<UnassignClientTagFromTaskDefinitionMutation, UnassignClientTagFromTaskDefinitionMutationVariables>;

/**
 * __useUnassignClientTagFromTaskDefinitionMutation__
 *
 * To run a mutation, you first call `useUnassignClientTagFromTaskDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnassignClientTagFromTaskDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unassignClientTagFromTaskDefinitionMutation, { data, loading, error }] = useUnassignClientTagFromTaskDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnassignClientTagFromTaskDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UnassignClientTagFromTaskDefinitionMutation, UnassignClientTagFromTaskDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnassignClientTagFromTaskDefinitionMutation, UnassignClientTagFromTaskDefinitionMutationVariables>(UnassignClientTagFromTaskDefinitionDocument, options);
      }
export type UnassignClientTagFromTaskDefinitionMutationHookResult = ReturnType<typeof useUnassignClientTagFromTaskDefinitionMutation>;
export type UnassignClientTagFromTaskDefinitionMutationResult = Apollo.MutationResult<UnassignClientTagFromTaskDefinitionMutation>;
export type UnassignClientTagFromTaskDefinitionMutationOptions = Apollo.BaseMutationOptions<UnassignClientTagFromTaskDefinitionMutation, UnassignClientTagFromTaskDefinitionMutationVariables>;
export const UpdateTaskDefinitionDescriptionDocument = gql`
    mutation UpdateTaskDefinitionDescription($input: UpdateTaskDefinitionDescriptionInput!) {
  updateTaskDefinitionDescription(input: $input) {
    taskDefinition {
      id
      description
    }
  }
}
    `;
export type UpdateTaskDefinitionDescriptionMutationFn = Apollo.MutationFunction<UpdateTaskDefinitionDescriptionMutation, UpdateTaskDefinitionDescriptionMutationVariables>;

/**
 * __useUpdateTaskDefinitionDescriptionMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDefinitionDescriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDefinitionDescriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDefinitionDescriptionMutation, { data, loading, error }] = useUpdateTaskDefinitionDescriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskDefinitionDescriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDefinitionDescriptionMutation, UpdateTaskDefinitionDescriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDefinitionDescriptionMutation, UpdateTaskDefinitionDescriptionMutationVariables>(UpdateTaskDefinitionDescriptionDocument, options);
      }
export type UpdateTaskDefinitionDescriptionMutationHookResult = ReturnType<typeof useUpdateTaskDefinitionDescriptionMutation>;
export type UpdateTaskDefinitionDescriptionMutationResult = Apollo.MutationResult<UpdateTaskDefinitionDescriptionMutation>;
export type UpdateTaskDefinitionDescriptionMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDefinitionDescriptionMutation, UpdateTaskDefinitionDescriptionMutationVariables>;
export const UpdateTaskDefinitionPriorityDocument = gql`
    mutation UpdateTaskDefinitionPriority($input: UpdateTaskDefinitionPriorityInput!) {
  updateTaskDefinitionPriority(input: $input) {
    taskDefinition {
      id
      priority
    }
  }
}
    `;
export type UpdateTaskDefinitionPriorityMutationFn = Apollo.MutationFunction<UpdateTaskDefinitionPriorityMutation, UpdateTaskDefinitionPriorityMutationVariables>;

/**
 * __useUpdateTaskDefinitionPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDefinitionPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDefinitionPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDefinitionPriorityMutation, { data, loading, error }] = useUpdateTaskDefinitionPriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskDefinitionPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDefinitionPriorityMutation, UpdateTaskDefinitionPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDefinitionPriorityMutation, UpdateTaskDefinitionPriorityMutationVariables>(UpdateTaskDefinitionPriorityDocument, options);
      }
export type UpdateTaskDefinitionPriorityMutationHookResult = ReturnType<typeof useUpdateTaskDefinitionPriorityMutation>;
export type UpdateTaskDefinitionPriorityMutationResult = Apollo.MutationResult<UpdateTaskDefinitionPriorityMutation>;
export type UpdateTaskDefinitionPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDefinitionPriorityMutation, UpdateTaskDefinitionPriorityMutationVariables>;
export const UpdateTaskDefinitionVisibilityDocument = gql`
    mutation UpdateTaskDefinitionVisibility($input: UpdateTaskDefinitionVisibilityInput!) {
  updateTaskDefinitionVisibility(input: $input) {
    taskDefinition {
      ...TaskVisibility
    }
  }
}
    ${TaskVisibilityFragmentDoc}`;
export type UpdateTaskDefinitionVisibilityMutationFn = Apollo.MutationFunction<UpdateTaskDefinitionVisibilityMutation, UpdateTaskDefinitionVisibilityMutationVariables>;

/**
 * __useUpdateTaskDefinitionVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateTaskDefinitionVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskDefinitionVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskDefinitionVisibilityMutation, { data, loading, error }] = useUpdateTaskDefinitionVisibilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskDefinitionVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskDefinitionVisibilityMutation, UpdateTaskDefinitionVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskDefinitionVisibilityMutation, UpdateTaskDefinitionVisibilityMutationVariables>(UpdateTaskDefinitionVisibilityDocument, options);
      }
export type UpdateTaskDefinitionVisibilityMutationHookResult = ReturnType<typeof useUpdateTaskDefinitionVisibilityMutation>;
export type UpdateTaskDefinitionVisibilityMutationResult = Apollo.MutationResult<UpdateTaskDefinitionVisibilityMutation>;
export type UpdateTaskDefinitionVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateTaskDefinitionVisibilityMutation, UpdateTaskDefinitionVisibilityMutationVariables>;
export const UpdateTaskPriorityDocument = gql`
    mutation UpdateTaskPriority($input: UpdateTaskPriorityInput!) {
  updateTaskPriority(input: $input) {
    task {
      id
      priority
    }
  }
}
    `;
export type UpdateTaskPriorityMutationFn = Apollo.MutationFunction<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>;

/**
 * __useUpdateTaskPriorityMutation__
 *
 * To run a mutation, you first call `useUpdateTaskPriorityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskPriorityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskPriorityMutation, { data, loading, error }] = useUpdateTaskPriorityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskPriorityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>(UpdateTaskPriorityDocument, options);
      }
export type UpdateTaskPriorityMutationHookResult = ReturnType<typeof useUpdateTaskPriorityMutation>;
export type UpdateTaskPriorityMutationResult = Apollo.MutationResult<UpdateTaskPriorityMutation>;
export type UpdateTaskPriorityMutationOptions = Apollo.BaseMutationOptions<UpdateTaskPriorityMutation, UpdateTaskPriorityMutationVariables>;
export const TaskDocument = gql`
    query Task($id: UUID!) {
  task(id: $id) {
    ...TaskDetail
  }
}
    ${TaskDetailFragmentDoc}`;

/**
 * __useTaskQuery__
 *
 * To run a query within a React component, call `useTaskQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskQuery(baseOptions: Apollo.QueryHookOptions<TaskQuery, TaskQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
      }
export function useTaskLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskQuery, TaskQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskQuery, TaskQueryVariables>(TaskDocument, options);
        }
export type TaskQueryHookResult = ReturnType<typeof useTaskQuery>;
export type TaskLazyQueryHookResult = ReturnType<typeof useTaskLazyQuery>;
export type TaskQueryResult = Apollo.QueryResult<TaskQuery, TaskQueryVariables>;
export const CreateTaskTemplateDocument = gql`
    mutation CreateTaskTemplate($input: CreateTaskTemplateInput!) {
  createTaskTemplate(input: $input) {
    taskTemplate {
      ...TaskTemplateDetail
    }
  }
}
    ${TaskTemplateDetailFragmentDoc}`;
export type CreateTaskTemplateMutationFn = Apollo.MutationFunction<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>;

/**
 * __useCreateTaskTemplateMutation__
 *
 * To run a mutation, you first call `useCreateTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTaskTemplateMutation, { data, loading, error }] = useCreateTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>(CreateTaskTemplateDocument, options);
      }
export type CreateTaskTemplateMutationHookResult = ReturnType<typeof useCreateTaskTemplateMutation>;
export type CreateTaskTemplateMutationResult = Apollo.MutationResult<CreateTaskTemplateMutation>;
export type CreateTaskTemplateMutationOptions = Apollo.BaseMutationOptions<CreateTaskTemplateMutation, CreateTaskTemplateMutationVariables>;
export const UpdateTaskTemplateDocument = gql`
    mutation UpdateTaskTemplate($input: UpdateTaskTemplateInput!) {
  updateTaskTemplate(input: $input) {
    taskTemplate {
      ...TaskTemplateDetail
    }
  }
}
    ${TaskTemplateDetailFragmentDoc}`;
export type UpdateTaskTemplateMutationFn = Apollo.MutationFunction<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>;

/**
 * __useUpdateTaskTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTemplateMutation, { data, loading, error }] = useUpdateTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>(UpdateTaskTemplateDocument, options);
      }
export type UpdateTaskTemplateMutationHookResult = ReturnType<typeof useUpdateTaskTemplateMutation>;
export type UpdateTaskTemplateMutationResult = Apollo.MutationResult<UpdateTaskTemplateMutation>;
export type UpdateTaskTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTemplateMutation, UpdateTaskTemplateMutationVariables>;
export const UpdateTaskTemplateStructureDocument = gql`
    mutation UpdateTaskTemplateStructure($input: UpdateTaskTemplateStructureInput!) {
  updateTaskTemplateStructure(input: $input) {
    taskTemplate {
      ...TaskTemplateDetail
    }
  }
}
    ${TaskTemplateDetailFragmentDoc}`;
export type UpdateTaskTemplateStructureMutationFn = Apollo.MutationFunction<UpdateTaskTemplateStructureMutation, UpdateTaskTemplateStructureMutationVariables>;

/**
 * __useUpdateTaskTemplateStructureMutation__
 *
 * To run a mutation, you first call `useUpdateTaskTemplateStructureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskTemplateStructureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskTemplateStructureMutation, { data, loading, error }] = useUpdateTaskTemplateStructureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskTemplateStructureMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskTemplateStructureMutation, UpdateTaskTemplateStructureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskTemplateStructureMutation, UpdateTaskTemplateStructureMutationVariables>(UpdateTaskTemplateStructureDocument, options);
      }
export type UpdateTaskTemplateStructureMutationHookResult = ReturnType<typeof useUpdateTaskTemplateStructureMutation>;
export type UpdateTaskTemplateStructureMutationResult = Apollo.MutationResult<UpdateTaskTemplateStructureMutation>;
export type UpdateTaskTemplateStructureMutationOptions = Apollo.BaseMutationOptions<UpdateTaskTemplateStructureMutation, UpdateTaskTemplateStructureMutationVariables>;
export const ArchiveTaskTemplateDocument = gql`
    mutation ArchiveTaskTemplate($input: ArchiveTaskTemplateInput!) {
  archiveTaskTemplate(input: $input) {
    taskTemplate {
      ...TaskTemplateListItem
    }
  }
}
    ${TaskTemplateListItemFragmentDoc}`;
export type ArchiveTaskTemplateMutationFn = Apollo.MutationFunction<ArchiveTaskTemplateMutation, ArchiveTaskTemplateMutationVariables>;

/**
 * __useArchiveTaskTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTaskTemplateMutation, { data, loading, error }] = useArchiveTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useArchiveTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTaskTemplateMutation, ArchiveTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTaskTemplateMutation, ArchiveTaskTemplateMutationVariables>(ArchiveTaskTemplateDocument, options);
      }
export type ArchiveTaskTemplateMutationHookResult = ReturnType<typeof useArchiveTaskTemplateMutation>;
export type ArchiveTaskTemplateMutationResult = Apollo.MutationResult<ArchiveTaskTemplateMutation>;
export type ArchiveTaskTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveTaskTemplateMutation, ArchiveTaskTemplateMutationVariables>;
export const UnarchiveTaskTemplateDocument = gql`
    mutation UnarchiveTaskTemplate($input: UnarchiveTaskTemplateInput!) {
  unarchiveTaskTemplate(input: $input) {
    taskTemplate {
      ...TaskTemplateListItem
    }
  }
}
    ${TaskTemplateListItemFragmentDoc}`;
export type UnarchiveTaskTemplateMutationFn = Apollo.MutationFunction<UnarchiveTaskTemplateMutation, UnarchiveTaskTemplateMutationVariables>;

/**
 * __useUnarchiveTaskTemplateMutation__
 *
 * To run a mutation, you first call `useUnarchiveTaskTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveTaskTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveTaskTemplateMutation, { data, loading, error }] = useUnarchiveTaskTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnarchiveTaskTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveTaskTemplateMutation, UnarchiveTaskTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveTaskTemplateMutation, UnarchiveTaskTemplateMutationVariables>(UnarchiveTaskTemplateDocument, options);
      }
export type UnarchiveTaskTemplateMutationHookResult = ReturnType<typeof useUnarchiveTaskTemplateMutation>;
export type UnarchiveTaskTemplateMutationResult = Apollo.MutationResult<UnarchiveTaskTemplateMutation>;
export type UnarchiveTaskTemplateMutationOptions = Apollo.BaseMutationOptions<UnarchiveTaskTemplateMutation, UnarchiveTaskTemplateMutationVariables>;
export const TaskTemplatesDocument = gql`
    query TaskTemplates($includeArchived: Boolean, $isActive: Boolean, $isDraft: Boolean, $community: UUID, $search: String) {
  taskTemplates(
    includeArchived: $includeArchived
    isActive: $isActive
    isDraft: $isDraft
    community: $community
    search: $search
  ) {
    edges {
      node {
        ...TaskTemplateListItem
      }
    }
  }
}
    ${TaskTemplateListItemFragmentDoc}`;

/**
 * __useTaskTemplatesQuery__
 *
 * To run a query within a React component, call `useTaskTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTemplatesQuery({
 *   variables: {
 *      includeArchived: // value for 'includeArchived'
 *      isActive: // value for 'isActive'
 *      isDraft: // value for 'isDraft'
 *      community: // value for 'community'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTaskTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<TaskTemplatesQuery, TaskTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTemplatesQuery, TaskTemplatesQueryVariables>(TaskTemplatesDocument, options);
      }
export function useTaskTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTemplatesQuery, TaskTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTemplatesQuery, TaskTemplatesQueryVariables>(TaskTemplatesDocument, options);
        }
export type TaskTemplatesQueryHookResult = ReturnType<typeof useTaskTemplatesQuery>;
export type TaskTemplatesLazyQueryHookResult = ReturnType<typeof useTaskTemplatesLazyQuery>;
export type TaskTemplatesQueryResult = Apollo.QueryResult<TaskTemplatesQuery, TaskTemplatesQueryVariables>;
export const TaskTemplateDetailDocument = gql`
    query TaskTemplateDetail($id: UUID!) {
  taskTemplate(id: $id) {
    ...TaskTemplateDetail
  }
}
    ${TaskTemplateDetailFragmentDoc}`;

/**
 * __useTaskTemplateDetailQuery__
 *
 * To run a query within a React component, call `useTaskTemplateDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTaskTemplateDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTaskTemplateDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTaskTemplateDetailQuery(baseOptions: Apollo.QueryHookOptions<TaskTemplateDetailQuery, TaskTemplateDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TaskTemplateDetailQuery, TaskTemplateDetailQueryVariables>(TaskTemplateDetailDocument, options);
      }
export function useTaskTemplateDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TaskTemplateDetailQuery, TaskTemplateDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TaskTemplateDetailQuery, TaskTemplateDetailQueryVariables>(TaskTemplateDetailDocument, options);
        }
export type TaskTemplateDetailQueryHookResult = ReturnType<typeof useTaskTemplateDetailQuery>;
export type TaskTemplateDetailLazyQueryHookResult = ReturnType<typeof useTaskTemplateDetailLazyQuery>;
export type TaskTemplateDetailQueryResult = Apollo.QueryResult<TaskTemplateDetailQuery, TaskTemplateDetailQueryVariables>;
export const UpdateTaskDocument = gql`
    mutation UpdateTask($input: UpdateTaskInput!) {
  updateTask(input: $input) {
    task {
      id
      dueDate
      category {
        id
        name
      }
      updates {
        edges {
          node {
            ...TaskUpdate
          }
        }
      }
    }
  }
}
    ${TaskUpdateFragmentDoc}`;
export type UpdateTaskMutationFn = Apollo.MutationFunction<UpdateTaskMutation, UpdateTaskMutationVariables>;

/**
 * __useUpdateTaskMutation__
 *
 * To run a mutation, you first call `useUpdateTaskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTaskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTaskMutation, { data, loading, error }] = useUpdateTaskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTaskMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTaskMutation, UpdateTaskMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTaskMutation, UpdateTaskMutationVariables>(UpdateTaskDocument, options);
      }
export type UpdateTaskMutationHookResult = ReturnType<typeof useUpdateTaskMutation>;
export type UpdateTaskMutationResult = Apollo.MutationResult<UpdateTaskMutation>;
export type UpdateTaskMutationOptions = Apollo.BaseMutationOptions<UpdateTaskMutation, UpdateTaskMutationVariables>;
export const AddTaskCommentDocument = gql`
    mutation AddTaskComment($input: AddTaskCommentInput!) {
  addTaskComment(input: $input) {
    errors {
      field
      messages
    }
    taskUpdate {
      id
      updateType
      comment
      createdAt
      actor {
        id
        name
        displayPicture
      }
      targetAction {
        id
      }
    }
  }
}
    `;
export type AddTaskCommentMutationFn = Apollo.MutationFunction<AddTaskCommentMutation, AddTaskCommentMutationVariables>;

/**
 * __useAddTaskCommentMutation__
 *
 * To run a mutation, you first call `useAddTaskCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTaskCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTaskCommentMutation, { data, loading, error }] = useAddTaskCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTaskCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTaskCommentMutation, AddTaskCommentMutationVariables>(AddTaskCommentDocument, options);
      }
export type AddTaskCommentMutationHookResult = ReturnType<typeof useAddTaskCommentMutation>;
export type AddTaskCommentMutationResult = Apollo.MutationResult<AddTaskCommentMutation>;
export type AddTaskCommentMutationOptions = Apollo.BaseMutationOptions<AddTaskCommentMutation, AddTaskCommentMutationVariables>;
export const GetFixfloIssueDocument = gql`
    query GetFixfloIssue($communityId: UUID!, $issueRef: String!) {
  getFixfloIssue(communityId: $communityId, issueRef: $issueRef) {
    id
    title
    faultCategory
    status
    faultPriority
    created
    address
  }
}
    `;

/**
 * __useGetFixfloIssueQuery__
 *
 * To run a query within a React component, call `useGetFixfloIssueQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFixfloIssueQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFixfloIssueQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      issueRef: // value for 'issueRef'
 *   },
 * });
 */
export function useGetFixfloIssueQuery(baseOptions: Apollo.QueryHookOptions<GetFixfloIssueQuery, GetFixfloIssueQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFixfloIssueQuery, GetFixfloIssueQueryVariables>(GetFixfloIssueDocument, options);
      }
export function useGetFixfloIssueLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFixfloIssueQuery, GetFixfloIssueQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFixfloIssueQuery, GetFixfloIssueQueryVariables>(GetFixfloIssueDocument, options);
        }
export type GetFixfloIssueQueryHookResult = ReturnType<typeof useGetFixfloIssueQuery>;
export type GetFixfloIssueLazyQueryHookResult = ReturnType<typeof useGetFixfloIssueLazyQuery>;
export type GetFixfloIssueQueryResult = Apollo.QueryResult<GetFixfloIssueQuery, GetFixfloIssueQueryVariables>;
export const LinkTaskToAsanaDocument = gql`
    mutation LinkTaskToAsana($input: LinkTaskToAsanaInput!) {
  linkTaskToAsana(input: $input) {
    task {
      ...TaskDetail
    }
  }
}
    ${TaskDetailFragmentDoc}`;
export type LinkTaskToAsanaMutationFn = Apollo.MutationFunction<LinkTaskToAsanaMutation, LinkTaskToAsanaMutationVariables>;

/**
 * __useLinkTaskToAsanaMutation__
 *
 * To run a mutation, you first call `useLinkTaskToAsanaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTaskToAsanaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTaskToAsanaMutation, { data, loading, error }] = useLinkTaskToAsanaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkTaskToAsanaMutation(baseOptions?: Apollo.MutationHookOptions<LinkTaskToAsanaMutation, LinkTaskToAsanaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkTaskToAsanaMutation, LinkTaskToAsanaMutationVariables>(LinkTaskToAsanaDocument, options);
      }
export type LinkTaskToAsanaMutationHookResult = ReturnType<typeof useLinkTaskToAsanaMutation>;
export type LinkTaskToAsanaMutationResult = Apollo.MutationResult<LinkTaskToAsanaMutation>;
export type LinkTaskToAsanaMutationOptions = Apollo.BaseMutationOptions<LinkTaskToAsanaMutation, LinkTaskToAsanaMutationVariables>;
export const LinkTaskToFixfloDocument = gql`
    mutation LinkTaskToFixflo($input: LinkTaskToFixfloInput!) {
  linkTaskToFixflo(input: $input) {
    task {
      ...TaskDetail
    }
  }
}
    ${TaskDetailFragmentDoc}`;
export type LinkTaskToFixfloMutationFn = Apollo.MutationFunction<LinkTaskToFixfloMutation, LinkTaskToFixfloMutationVariables>;

/**
 * __useLinkTaskToFixfloMutation__
 *
 * To run a mutation, you first call `useLinkTaskToFixfloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkTaskToFixfloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkTaskToFixfloMutation, { data, loading, error }] = useLinkTaskToFixfloMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLinkTaskToFixfloMutation(baseOptions?: Apollo.MutationHookOptions<LinkTaskToFixfloMutation, LinkTaskToFixfloMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkTaskToFixfloMutation, LinkTaskToFixfloMutationVariables>(LinkTaskToFixfloDocument, options);
      }
export type LinkTaskToFixfloMutationHookResult = ReturnType<typeof useLinkTaskToFixfloMutation>;
export type LinkTaskToFixfloMutationResult = Apollo.MutationResult<LinkTaskToFixfloMutation>;
export type LinkTaskToFixfloMutationOptions = Apollo.BaseMutationOptions<LinkTaskToFixfloMutation, LinkTaskToFixfloMutationVariables>;
export const PushTaskToAsanaDocument = gql`
    mutation PushTaskToAsana($input: PushTaskToAsanaInput!) {
  pushTaskToAsana(input: $input) {
    task {
      ...TaskDetail
    }
  }
}
    ${TaskDetailFragmentDoc}`;
export type PushTaskToAsanaMutationFn = Apollo.MutationFunction<PushTaskToAsanaMutation, PushTaskToAsanaMutationVariables>;

/**
 * __usePushTaskToAsanaMutation__
 *
 * To run a mutation, you first call `usePushTaskToAsanaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushTaskToAsanaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushTaskToAsanaMutation, { data, loading, error }] = usePushTaskToAsanaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushTaskToAsanaMutation(baseOptions?: Apollo.MutationHookOptions<PushTaskToAsanaMutation, PushTaskToAsanaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushTaskToAsanaMutation, PushTaskToAsanaMutationVariables>(PushTaskToAsanaDocument, options);
      }
export type PushTaskToAsanaMutationHookResult = ReturnType<typeof usePushTaskToAsanaMutation>;
export type PushTaskToAsanaMutationResult = Apollo.MutationResult<PushTaskToAsanaMutation>;
export type PushTaskToAsanaMutationOptions = Apollo.BaseMutationOptions<PushTaskToAsanaMutation, PushTaskToAsanaMutationVariables>;
export const SearchAsanaTasksDocument = gql`
    query SearchAsanaTasks($communityId: UUID!, $query: String!) {
  searchAsanaTasks(communityId: $communityId, query: $query) {
    gid
    name
    permalinkUrl
  }
}
    `;

/**
 * __useSearchAsanaTasksQuery__
 *
 * To run a query within a React component, call `useSearchAsanaTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAsanaTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAsanaTasksQuery({
 *   variables: {
 *      communityId: // value for 'communityId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchAsanaTasksQuery(baseOptions: Apollo.QueryHookOptions<SearchAsanaTasksQuery, SearchAsanaTasksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAsanaTasksQuery, SearchAsanaTasksQueryVariables>(SearchAsanaTasksDocument, options);
      }
export function useSearchAsanaTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAsanaTasksQuery, SearchAsanaTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAsanaTasksQuery, SearchAsanaTasksQueryVariables>(SearchAsanaTasksDocument, options);
        }
export type SearchAsanaTasksQueryHookResult = ReturnType<typeof useSearchAsanaTasksQuery>;
export type SearchAsanaTasksLazyQueryHookResult = ReturnType<typeof useSearchAsanaTasksLazyQuery>;
export type SearchAsanaTasksQueryResult = Apollo.QueryResult<SearchAsanaTasksQuery, SearchAsanaTasksQueryVariables>;
export const UnlinkTaskFromAsanaDocument = gql`
    mutation UnlinkTaskFromAsana($input: UnlinkTaskFromAsanaInput!) {
  unlinkTaskFromAsana(input: $input) {
    task {
      ...TaskDetail
    }
  }
}
    ${TaskDetailFragmentDoc}`;
export type UnlinkTaskFromAsanaMutationFn = Apollo.MutationFunction<UnlinkTaskFromAsanaMutation, UnlinkTaskFromAsanaMutationVariables>;

/**
 * __useUnlinkTaskFromAsanaMutation__
 *
 * To run a mutation, you first call `useUnlinkTaskFromAsanaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTaskFromAsanaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTaskFromAsanaMutation, { data, loading, error }] = useUnlinkTaskFromAsanaMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkTaskFromAsanaMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTaskFromAsanaMutation, UnlinkTaskFromAsanaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTaskFromAsanaMutation, UnlinkTaskFromAsanaMutationVariables>(UnlinkTaskFromAsanaDocument, options);
      }
export type UnlinkTaskFromAsanaMutationHookResult = ReturnType<typeof useUnlinkTaskFromAsanaMutation>;
export type UnlinkTaskFromAsanaMutationResult = Apollo.MutationResult<UnlinkTaskFromAsanaMutation>;
export type UnlinkTaskFromAsanaMutationOptions = Apollo.BaseMutationOptions<UnlinkTaskFromAsanaMutation, UnlinkTaskFromAsanaMutationVariables>;
export const UnlinkTaskFromFixfloDocument = gql`
    mutation UnlinkTaskFromFixflo($input: UnlinkTaskFromFixfloInput!) {
  unlinkTaskFromFixflo(input: $input) {
    task {
      ...TaskDetail
    }
  }
}
    ${TaskDetailFragmentDoc}`;
export type UnlinkTaskFromFixfloMutationFn = Apollo.MutationFunction<UnlinkTaskFromFixfloMutation, UnlinkTaskFromFixfloMutationVariables>;

/**
 * __useUnlinkTaskFromFixfloMutation__
 *
 * To run a mutation, you first call `useUnlinkTaskFromFixfloMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkTaskFromFixfloMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkTaskFromFixfloMutation, { data, loading, error }] = useUnlinkTaskFromFixfloMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnlinkTaskFromFixfloMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkTaskFromFixfloMutation, UnlinkTaskFromFixfloMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkTaskFromFixfloMutation, UnlinkTaskFromFixfloMutationVariables>(UnlinkTaskFromFixfloDocument, options);
      }
export type UnlinkTaskFromFixfloMutationHookResult = ReturnType<typeof useUnlinkTaskFromFixfloMutation>;
export type UnlinkTaskFromFixfloMutationResult = Apollo.MutationResult<UnlinkTaskFromFixfloMutation>;
export type UnlinkTaskFromFixfloMutationOptions = Apollo.BaseMutationOptions<UnlinkTaskFromFixfloMutation, UnlinkTaskFromFixfloMutationVariables>;
export const ToggleArchivedAtCommunityUpdateDocument = gql`
    mutation ToggleArchivedAtCommunityUpdate($input: ToggleArchivedAtCommunityUpdateInput!) {
  toggleArchivedAtCommunityUpdate(input: $input) {
    communityUpdate {
      id
    }
  }
}
    `;
export type ToggleArchivedAtCommunityUpdateMutationFn = Apollo.MutationFunction<ToggleArchivedAtCommunityUpdateMutation, ToggleArchivedAtCommunityUpdateMutationVariables>;

/**
 * __useToggleArchivedAtCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useToggleArchivedAtCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleArchivedAtCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleArchivedAtCommunityUpdateMutation, { data, loading, error }] = useToggleArchivedAtCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useToggleArchivedAtCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ToggleArchivedAtCommunityUpdateMutation, ToggleArchivedAtCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleArchivedAtCommunityUpdateMutation, ToggleArchivedAtCommunityUpdateMutationVariables>(ToggleArchivedAtCommunityUpdateDocument, options);
      }
export type ToggleArchivedAtCommunityUpdateMutationHookResult = ReturnType<typeof useToggleArchivedAtCommunityUpdateMutation>;
export type ToggleArchivedAtCommunityUpdateMutationResult = Apollo.MutationResult<ToggleArchivedAtCommunityUpdateMutation>;
export type ToggleArchivedAtCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<ToggleArchivedAtCommunityUpdateMutation, ToggleArchivedAtCommunityUpdateMutationVariables>;
export const CommunityUpdateDocument = gql`
    query CommunityUpdate($id: UUID!) {
  communityUpdate(id: $id) {
    id
    title
    body
    summary
    category
    image
    attachment
    attachments {
      ...CommunityUpdateAttachment
    }
    isArk
    publishedAt
    scheduledFor
    imageUrl
    imageSearchTerm
    archivedAt
    groups {
      locales
      edges {
        node {
          id
          name
          community {
            id
            name
            commentsEnabled
          }
        }
      }
    }
    variants {
      edges {
        node {
          id
          locale
        }
      }
    }
    status
    stats {
      totalLikes
      totalReads
      totalComments
    }
    communityDocument {
      id
      title
      file
      document {
        id
      }
    }
  }
}
    ${CommunityUpdateAttachmentFragmentDoc}`;

/**
 * __useCommunityUpdateQuery__
 *
 * To run a query within a React component, call `useCommunityUpdateQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCommunityUpdateQuery(baseOptions: Apollo.QueryHookOptions<CommunityUpdateQuery, CommunityUpdateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdateQuery, CommunityUpdateQueryVariables>(CommunityUpdateDocument, options);
      }
export function useCommunityUpdateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdateQuery, CommunityUpdateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdateQuery, CommunityUpdateQueryVariables>(CommunityUpdateDocument, options);
        }
export type CommunityUpdateQueryHookResult = ReturnType<typeof useCommunityUpdateQuery>;
export type CommunityUpdateLazyQueryHookResult = ReturnType<typeof useCommunityUpdateLazyQuery>;
export type CommunityUpdateQueryResult = Apollo.QueryResult<CommunityUpdateQuery, CommunityUpdateQueryVariables>;
export const DeleteCommunityUpdateDocument = gql`
    mutation DeleteCommunityUpdate($input: DeleteCommunityUpdateInput!) {
  deleteCommunityUpdate(input: $input) {
    id
  }
}
    `;
export type DeleteCommunityUpdateMutationFn = Apollo.MutationFunction<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>;

/**
 * __useDeleteCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityUpdateMutation, { data, loading, error }] = useDeleteCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>(DeleteCommunityUpdateDocument, options);
      }
export type DeleteCommunityUpdateMutationHookResult = ReturnType<typeof useDeleteCommunityUpdateMutation>;
export type DeleteCommunityUpdateMutationResult = Apollo.MutationResult<DeleteCommunityUpdateMutation>;
export type DeleteCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityUpdateMutation, DeleteCommunityUpdateMutationVariables>;
export const SaveCommunityUpdateDocument = gql`
    mutation SaveCommunityUpdate($input: SaveCommunityUpdateInput!) {
  saveCommunityUpdate(input: $input) {
    id
    title
    summary
    body
    category
    errors {
      field
      messages
    }
  }
}
    `;
export type SaveCommunityUpdateMutationFn = Apollo.MutationFunction<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>;

/**
 * __useSaveCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useSaveCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCommunityUpdateMutation, { data, loading, error }] = useSaveCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>(SaveCommunityUpdateDocument, options);
      }
export type SaveCommunityUpdateMutationHookResult = ReturnType<typeof useSaveCommunityUpdateMutation>;
export type SaveCommunityUpdateMutationResult = Apollo.MutationResult<SaveCommunityUpdateMutation>;
export type SaveCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<SaveCommunityUpdateMutation, SaveCommunityUpdateMutationVariables>;
export const SelectDocumentDialogDocument = gql`
    query SelectDocumentDialog($communities: [ID!], $search: String, $after: String) {
  documents(
    communities: $communities
    search: $search
    after: $after
    type: ["COMMUNITY"]
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        contentObject {
          ...CommunityDocumentListItem
        }
      }
    }
  }
}
    ${CommunityDocumentListItemFragmentDoc}`;

/**
 * __useSelectDocumentDialogQuery__
 *
 * To run a query within a React component, call `useSelectDocumentDialogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectDocumentDialogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectDocumentDialogQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSelectDocumentDialogQuery(baseOptions?: Apollo.QueryHookOptions<SelectDocumentDialogQuery, SelectDocumentDialogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectDocumentDialogQuery, SelectDocumentDialogQueryVariables>(SelectDocumentDialogDocument, options);
      }
export function useSelectDocumentDialogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectDocumentDialogQuery, SelectDocumentDialogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectDocumentDialogQuery, SelectDocumentDialogQueryVariables>(SelectDocumentDialogDocument, options);
        }
export type SelectDocumentDialogQueryHookResult = ReturnType<typeof useSelectDocumentDialogQuery>;
export type SelectDocumentDialogLazyQueryHookResult = ReturnType<typeof useSelectDocumentDialogLazyQuery>;
export type SelectDocumentDialogQueryResult = Apollo.QueryResult<SelectDocumentDialogQuery, SelectDocumentDialogQueryVariables>;
export const CancelScheduledPublishCommunityUpdateDocument = gql`
    mutation CancelScheduledPublishCommunityUpdate($input: CancelScheduledPublishCommunityUpdateInput!) {
  cancelScheduledPublishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CancelScheduledPublishCommunityUpdateMutationFn = Apollo.MutationFunction<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>;

/**
 * __useCancelScheduledPublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useCancelScheduledPublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelScheduledPublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelScheduledPublishCommunityUpdateMutation, { data, loading, error }] = useCancelScheduledPublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelScheduledPublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>(CancelScheduledPublishCommunityUpdateDocument, options);
      }
export type CancelScheduledPublishCommunityUpdateMutationHookResult = ReturnType<typeof useCancelScheduledPublishCommunityUpdateMutation>;
export type CancelScheduledPublishCommunityUpdateMutationResult = Apollo.MutationResult<CancelScheduledPublishCommunityUpdateMutation>;
export type CancelScheduledPublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<CancelScheduledPublishCommunityUpdateMutation, CancelScheduledPublishCommunityUpdateMutationVariables>;
export const CommunityUpdateCommentsDocument = gql`
    query CommunityUpdateComments($id: UUID!, $after: String) {
  communityUpdate(id: $id) {
    comments(after: $after) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          comment
          createdAt
          userType
        }
      }
    }
  }
}
    `;

/**
 * __useCommunityUpdateCommentsQuery__
 *
 * To run a query within a React component, call `useCommunityUpdateCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdateCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdateCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCommunityUpdateCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>(CommunityUpdateCommentsDocument, options);
      }
export function useCommunityUpdateCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>(CommunityUpdateCommentsDocument, options);
        }
export type CommunityUpdateCommentsQueryHookResult = ReturnType<typeof useCommunityUpdateCommentsQuery>;
export type CommunityUpdateCommentsLazyQueryHookResult = ReturnType<typeof useCommunityUpdateCommentsLazyQuery>;
export type CommunityUpdateCommentsQueryResult = Apollo.QueryResult<CommunityUpdateCommentsQuery, CommunityUpdateCommentsQueryVariables>;
export const CreateUpdateCommentDocument = gql`
    mutation CreateUpdateComment($input: CreateUpdateCommentInput!) {
  createUpdateComment(input: $input) {
    communityUpdateComment {
      comment
    }
  }
}
    `;
export type CreateUpdateCommentMutationFn = Apollo.MutationFunction<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>;

/**
 * __useCreateUpdateCommentMutation__
 *
 * To run a mutation, you first call `useCreateUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateCommentMutation, { data, loading, error }] = useCreateUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>(CreateUpdateCommentDocument, options);
      }
export type CreateUpdateCommentMutationHookResult = ReturnType<typeof useCreateUpdateCommentMutation>;
export type CreateUpdateCommentMutationResult = Apollo.MutationResult<CreateUpdateCommentMutation>;
export type CreateUpdateCommentMutationOptions = Apollo.BaseMutationOptions<CreateUpdateCommentMutation, CreateUpdateCommentMutationVariables>;
export const DeleteUpdateCommentDocument = gql`
    mutation DeleteUpdateComment($input: DeleteCommunityUpdateCommentInput!) {
  deleteUpdateComment(input: $input) {
    id
  }
}
    `;
export type DeleteUpdateCommentMutationFn = Apollo.MutationFunction<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>;

/**
 * __useDeleteUpdateCommentMutation__
 *
 * To run a mutation, you first call `useDeleteUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUpdateCommentMutation, { data, loading, error }] = useDeleteUpdateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>(DeleteUpdateCommentDocument, options);
      }
export type DeleteUpdateCommentMutationHookResult = ReturnType<typeof useDeleteUpdateCommentMutation>;
export type DeleteUpdateCommentMutationResult = Apollo.MutationResult<DeleteUpdateCommentMutation>;
export type DeleteUpdateCommentMutationOptions = Apollo.BaseMutationOptions<DeleteUpdateCommentMutation, DeleteUpdateCommentMutationVariables>;
export const DeleteCommunityUpdateAttachmentDocument = gql`
    mutation DeleteCommunityUpdateAttachment($input: DeleteCommunityUpdateAttachmentInput!) {
  deleteCommunityUpdateAttachment(input: $input) {
    errors {
      field
      messages
    }
  }
}
    `;
export type DeleteCommunityUpdateAttachmentMutationFn = Apollo.MutationFunction<DeleteCommunityUpdateAttachmentMutation, DeleteCommunityUpdateAttachmentMutationVariables>;

/**
 * __useDeleteCommunityUpdateAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteCommunityUpdateAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommunityUpdateAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommunityUpdateAttachmentMutation, { data, loading, error }] = useDeleteCommunityUpdateAttachmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCommunityUpdateAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommunityUpdateAttachmentMutation, DeleteCommunityUpdateAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommunityUpdateAttachmentMutation, DeleteCommunityUpdateAttachmentMutationVariables>(DeleteCommunityUpdateAttachmentDocument, options);
      }
export type DeleteCommunityUpdateAttachmentMutationHookResult = ReturnType<typeof useDeleteCommunityUpdateAttachmentMutation>;
export type DeleteCommunityUpdateAttachmentMutationResult = Apollo.MutationResult<DeleteCommunityUpdateAttachmentMutation>;
export type DeleteCommunityUpdateAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteCommunityUpdateAttachmentMutation, DeleteCommunityUpdateAttachmentMutationVariables>;
export const LocalesForGroupsDocument = gql`
    query LocalesForGroups($ids: [UUID!]!) {
  communityGroups(ids: $ids) {
    locales
  }
}
    `;

/**
 * __useLocalesForGroupsQuery__
 *
 * To run a query within a React component, call `useLocalesForGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocalesForGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocalesForGroupsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useLocalesForGroupsQuery(baseOptions: Apollo.QueryHookOptions<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>(LocalesForGroupsDocument, options);
      }
export function useLocalesForGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>(LocalesForGroupsDocument, options);
        }
export type LocalesForGroupsQueryHookResult = ReturnType<typeof useLocalesForGroupsQuery>;
export type LocalesForGroupsLazyQueryHookResult = ReturnType<typeof useLocalesForGroupsLazyQuery>;
export type LocalesForGroupsQueryResult = Apollo.QueryResult<LocalesForGroupsQuery, LocalesForGroupsQueryVariables>;
export const PreviewCommunityUpdateVariantsDocument = gql`
    query PreviewCommunityUpdateVariants($id: UUID!) {
  communityUpdate(id: $id) {
    id
    title
    body
    publishedAt
    summary
    category
    image
    attachment
    imageUrl
    stats {
      totalLikes
    }
    variants {
      edges {
        node {
          id
          locale
          title
          summary
          body
          status
        }
      }
    }
  }
}
    `;

/**
 * __usePreviewCommunityUpdateVariantsQuery__
 *
 * To run a query within a React component, call `usePreviewCommunityUpdateVariantsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewCommunityUpdateVariantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewCommunityUpdateVariantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePreviewCommunityUpdateVariantsQuery(baseOptions: Apollo.QueryHookOptions<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>(PreviewCommunityUpdateVariantsDocument, options);
      }
export function usePreviewCommunityUpdateVariantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>(PreviewCommunityUpdateVariantsDocument, options);
        }
export type PreviewCommunityUpdateVariantsQueryHookResult = ReturnType<typeof usePreviewCommunityUpdateVariantsQuery>;
export type PreviewCommunityUpdateVariantsLazyQueryHookResult = ReturnType<typeof usePreviewCommunityUpdateVariantsLazyQuery>;
export type PreviewCommunityUpdateVariantsQueryResult = Apollo.QueryResult<PreviewCommunityUpdateVariantsQuery, PreviewCommunityUpdateVariantsQueryVariables>;
export const PublishCommunityUpdateDocument = gql`
    mutation PublishCommunityUpdate($input: PublishCommunityUpdateInput!) {
  publishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
      publishedAt
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type PublishCommunityUpdateMutationFn = Apollo.MutationFunction<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>;

/**
 * __usePublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `usePublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishCommunityUpdateMutation, { data, loading, error }] = usePublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>(PublishCommunityUpdateDocument, options);
      }
export type PublishCommunityUpdateMutationHookResult = ReturnType<typeof usePublishCommunityUpdateMutation>;
export type PublishCommunityUpdateMutationResult = Apollo.MutationResult<PublishCommunityUpdateMutation>;
export type PublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<PublishCommunityUpdateMutation, PublishCommunityUpdateMutationVariables>;
export const SchedulePublishCommunityUpdateDocument = gql`
    mutation SchedulePublishCommunityUpdate($input: SchedulePublishCommunityUpdateInput!) {
  schedulePublishCommunityUpdate(input: $input) {
    communityUpdate {
      id
      status
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type SchedulePublishCommunityUpdateMutationFn = Apollo.MutationFunction<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>;

/**
 * __useSchedulePublishCommunityUpdateMutation__
 *
 * To run a mutation, you first call `useSchedulePublishCommunityUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSchedulePublishCommunityUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [schedulePublishCommunityUpdateMutation, { data, loading, error }] = useSchedulePublishCommunityUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSchedulePublishCommunityUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>(SchedulePublishCommunityUpdateDocument, options);
      }
export type SchedulePublishCommunityUpdateMutationHookResult = ReturnType<typeof useSchedulePublishCommunityUpdateMutation>;
export type SchedulePublishCommunityUpdateMutationResult = Apollo.MutationResult<SchedulePublishCommunityUpdateMutation>;
export type SchedulePublishCommunityUpdateMutationOptions = Apollo.BaseMutationOptions<SchedulePublishCommunityUpdateMutation, SchedulePublishCommunityUpdateMutationVariables>;
export const CommunityUpdatesDocument = gql`
    query CommunityUpdates($communities: [ID], $communityGroups: [ID], $search: String, $after: String, $status: [String], $category: [String], $orderBy: String) {
  communityUpdates(
    communities: $communities
    communityGroups: $communityGroups
    search: $search
    after: $after
    orderBy: $orderBy
    status: $status
    category: $category
    hasLinkedFeature: false
  ) {
    edges {
      node {
        id
        title
        summary
        image
        imageUrl
        category
        publishedAt
        stats {
          totalLikes
          totalReads
          totalComments
        }
        status
        groups {
          edges {
            node {
              ...CommmunityUpdateGroupItem
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${CommmunityUpdateGroupItemFragmentDoc}`;

/**
 * __useCommunityUpdatesQuery__
 *
 * To run a query within a React component, call `useCommunityUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunityUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunityUpdatesQuery({
 *   variables: {
 *      communities: // value for 'communities'
 *      communityGroups: // value for 'communityGroups'
 *      search: // value for 'search'
 *      after: // value for 'after'
 *      status: // value for 'status'
 *      category: // value for 'category'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useCommunityUpdatesQuery(baseOptions?: Apollo.QueryHookOptions<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>(CommunityUpdatesDocument, options);
      }
export function useCommunityUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>(CommunityUpdatesDocument, options);
        }
export type CommunityUpdatesQueryHookResult = ReturnType<typeof useCommunityUpdatesQuery>;
export type CommunityUpdatesLazyQueryHookResult = ReturnType<typeof useCommunityUpdatesLazyQuery>;
export type CommunityUpdatesQueryResult = Apollo.QueryResult<CommunityUpdatesQuery, CommunityUpdatesQueryVariables>;
export const SignOutCommunityVisitorDocument = gql`
    mutation SignOutCommunityVisitor($input: SignOutCommunityVisitorInput!) {
  signOutCommunityVisitor(input: $input) {
    communityVisitor {
      id
      signedOutAt
    }
  }
}
    `;
export type SignOutCommunityVisitorMutationFn = Apollo.MutationFunction<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>;

/**
 * __useSignOutCommunityVisitorMutation__
 *
 * To run a mutation, you first call `useSignOutCommunityVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutCommunityVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutCommunityVisitorMutation, { data, loading, error }] = useSignOutCommunityVisitorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignOutCommunityVisitorMutation(baseOptions?: Apollo.MutationHookOptions<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>(SignOutCommunityVisitorDocument, options);
      }
export type SignOutCommunityVisitorMutationHookResult = ReturnType<typeof useSignOutCommunityVisitorMutation>;
export type SignOutCommunityVisitorMutationResult = Apollo.MutationResult<SignOutCommunityVisitorMutation>;
export type SignOutCommunityVisitorMutationOptions = Apollo.BaseMutationOptions<SignOutCommunityVisitorMutation, SignOutCommunityVisitorMutationVariables>;
export const VisitorDocument = gql`
    query Visitor($id: UUID!) {
  communityVisitor(id: $id) {
    id
    name
    email
    mobile
    createdAt
    residentName
    reasonForVisit
    signedOutAt
    vehicleRegistration
    company
    community {
      id
      name
    }
    type
  }
}
    `;

/**
 * __useVisitorQuery__
 *
 * To run a query within a React component, call `useVisitorQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVisitorQuery(baseOptions: Apollo.QueryHookOptions<VisitorQuery, VisitorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorQuery, VisitorQueryVariables>(VisitorDocument, options);
      }
export function useVisitorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorQuery, VisitorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorQuery, VisitorQueryVariables>(VisitorDocument, options);
        }
export type VisitorQueryHookResult = ReturnType<typeof useVisitorQuery>;
export type VisitorLazyQueryHookResult = ReturnType<typeof useVisitorLazyQuery>;
export type VisitorQueryResult = Apollo.QueryResult<VisitorQuery, VisitorQueryVariables>;
export const VisitorsDocument = gql`
    query Visitors($after: String, $search: String, $communities: [ID!], $visitorType: String, $orderBy: String, $signedOut: Boolean, $dateFrom: Date, $dateTo: Date, $block: UUID) {
  communityVisitors(
    after: $after
    search: $search
    communities: $communities
    block: $block
    type: $visitorType
    orderBy: $orderBy
    signedOut: $signedOut
    dateFrom: $dateFrom
    dateTo: $dateTo
  ) {
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        ...VisitorItem
      }
    }
  }
}
    ${VisitorItemFragmentDoc}`;

/**
 * __useVisitorsQuery__
 *
 * To run a query within a React component, call `useVisitorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitorsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      communities: // value for 'communities'
 *      visitorType: // value for 'visitorType'
 *      orderBy: // value for 'orderBy'
 *      signedOut: // value for 'signedOut'
 *      dateFrom: // value for 'dateFrom'
 *      dateTo: // value for 'dateTo'
 *      block: // value for 'block'
 *   },
 * });
 */
export function useVisitorsQuery(baseOptions?: Apollo.QueryHookOptions<VisitorsQuery, VisitorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitorsQuery, VisitorsQueryVariables>(VisitorsDocument, options);
      }
export function useVisitorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitorsQuery, VisitorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitorsQuery, VisitorsQueryVariables>(VisitorsDocument, options);
        }
export type VisitorsQueryHookResult = ReturnType<typeof useVisitorsQuery>;
export type VisitorsLazyQueryHookResult = ReturnType<typeof useVisitorsLazyQuery>;
export type VisitorsQueryResult = Apollo.QueryResult<VisitorsQuery, VisitorsQueryVariables>;
export const SendManagerAmplitudeTestDocument = gql`
    mutation sendManagerAmplitudeTest($input: SendManagerAmplitudeTestInput!) {
  sendManagerAmplitudeTest(input: $input) {
    manager {
      id
    }
  }
}
    `;
export type SendManagerAmplitudeTestMutationFn = Apollo.MutationFunction<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>;

/**
 * __useSendManagerAmplitudeTestMutation__
 *
 * To run a mutation, you first call `useSendManagerAmplitudeTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendManagerAmplitudeTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendManagerAmplitudeTestMutation, { data, loading, error }] = useSendManagerAmplitudeTestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendManagerAmplitudeTestMutation(baseOptions?: Apollo.MutationHookOptions<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>(SendManagerAmplitudeTestDocument, options);
      }
export type SendManagerAmplitudeTestMutationHookResult = ReturnType<typeof useSendManagerAmplitudeTestMutation>;
export type SendManagerAmplitudeTestMutationResult = Apollo.MutationResult<SendManagerAmplitudeTestMutation>;
export type SendManagerAmplitudeTestMutationOptions = Apollo.BaseMutationOptions<SendManagerAmplitudeTestMutation, SendManagerAmplitudeTestMutationVariables>;
export const ReferencingEnabledDocument = gql`
    query ReferencingEnabled {
  getUser {
    id
    manager {
      id
      community(referencingEnabled: true) {
        totalCount
      }
    }
  }
}
    `;

/**
 * __useReferencingEnabledQuery__
 *
 * To run a query within a React component, call `useReferencingEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferencingEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferencingEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useReferencingEnabledQuery(baseOptions?: Apollo.QueryHookOptions<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>(ReferencingEnabledDocument, options);
      }
export function useReferencingEnabledLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>(ReferencingEnabledDocument, options);
        }
export type ReferencingEnabledQueryHookResult = ReturnType<typeof useReferencingEnabledQuery>;
export type ReferencingEnabledLazyQueryHookResult = ReturnType<typeof useReferencingEnabledLazyQuery>;
export type ReferencingEnabledQueryResult = Apollo.QueryResult<ReferencingEnabledQuery, ReferencingEnabledQueryVariables>;